export default {
    labels: {
        clear: 'ទទេ',
        refresh: 'ធ្វើ ឲ្យ ស្រស់',
        nextStep: 'ជំហាន បន្ទាប់',
        prevStep: 'ជំហាន មុន',
        closeDriver: 'ចេញ ចាប់ផ្ដើម',
        complete: 'បញ្ចប់',
        viewStatistics: 'មើល ស្ថិតិ',
        colon: '：',
        splitter: '/',
        remark: 'ពាក្យ បញ្ជា',
        correction: 'កែ កំហុស',
        save: 'រក្សាទុក',
        reset: 'កំណត់ ឡើង វិញ',
        increase: 'បន្ថែម@ info: whatsthis',
        preview: 'មើល ជាមុន',
        unit: 'អត្ថបទ',
        cancel: 'បោះបង់',
        all: 'ទាំង អស់',
        searchPlaceHolder: 'បញ្ចូល សំណួរ ពាក្យ គន្លឹះ',
        greaterThan: 'ធំ',
        lessThan: 'តិច',
        second: 'វិនាទី',
        description: 'សេចក្ដី ពិពណ៌នា',
        column: 'ជួរឈរ',
        pleaseChoice: 'សូម ជ្រើស',
        filter: 'តម្រង',
        saveAndSubmit: 'រក្សាទុក និង ដាក់ ស្នើ',
        submit: 'ដាក់ ស្នើ',
        appeal: 'ជម្រះ',
        review: 'ឡើង វិញ',
        choose: 'ជ្រើស',
        manage: 'គ្រប់គ្រងComment',
        delete: 'លុប',
        add: 'ថ្មី',
        create: 'ថ្មី',
        edit: 'កែសម្រួល',
        name: 'ឈ្មោះ:',
        describe: 'សេចក្ដី ពិពណ៌នា',
        next: 'ជំហាន បន្ទាប់',
        percent: '%',
        export: 'នាំចេញ',
        exportAll: 'នាំចេញ ទាំងអស់',
        confirm: 'កំណត់@ info: whatsthis',
        back: 'ត្រឡប់ វិញ',
        versionUpdate: 'ខ្ញុំ មាន សុវត្ថិភាព ដើម្បី ជូន ដំណឹង អ្នក ថា តំបន់ បណ្ដាញ របស់ យើង គ្រាន់ តែ បញ្ចេញ កំណែ ថ្មី មួយ ។ ដើម្បី សារ ហើយ បន្ទាប់ មក ស្រស់ ទំព័រ (ចុច ប៊ូតុង ស្រស់ កម្មវិធី រុករក ឬ ចុច គ្រាប់ចុច F5) ដើម្បី ធ្វើ ឲ្យ កំណែ ថ្មី របស់ យើង មាន ប្រសិទ្ធភាព ។ អំណរ ច្រើន ចំពោះ ភារកិច្ច របស់ អ្នក !',
        more: 'បន្ថែម',
        selected: 'បាន ជ្រើស',
        deduct: 'គំនូស',
        maxScore: 'បំផុត',
        scoreUnit: 'ចំណុច',
        pointUnit: 'មួយ',
        comma: '，',
        view: 'ទិដ្ឋភាព',
        batchingImport: 'នាំចូល',
        deleteContent: 'តើ អ្នក ពិត ជា ចង់ លុប វា ឬ ? អ្នក មិន អាច ស្ដារ វា បាន ទេ បន្ទាប់ ពី លុប',
        import: 'នាំចូល',
        uploadFile: 'ផ្ទុក ឯកសារ',
        downloadFile: 'នាំចេញ ឯកសារ',
        upload: 'ផ្ទុក ឡើង លើ',
        click: 'ចុច ទេ',
        downloadTemplate: 'ទាញយក ពុម្ព',
        fillInTheForm: 'បំពេញ តាម ទ្រង់ទ្រាយ',
        UploadExcelfile: 'ផ្ទុក ឡើង Excel ដើម្បី បញ្ចប់ ការ នាំចូល ថ្មី',
        uploadIdentical: 'ប្រសិន បើ មាន ឈ្មោះ API មាន ទិន្នន័យ ដែល មាន នៅ ក្នុង ប្រព័ន្ធ នឹង ត្រូវ បាន ធ្វើ ឲ្យ ទាន់សម័យ កំឡុង ពេល នាំចូល ។',
        numOne: '1',
        numTwo: '2',
        numThree: '3',
        apply: 'អាច អនុញ្ញាត',
        leftBracket: '(',
        rightBracket: ')',
        question: 'សំណួរ',
        answer: 'ចម្លើយ',
        content: 'មាតិកា',
        search: 'ស្វែងរក',
        query: 'សំណួរ',
        cancelEdit: 'បោះបង់ កែសម្រួល',
        noValue: 'គ្មាន ទិន្នន័យ',
        selectAll: 'ជ្រើស ទាំងអស់',
        changeAGroup: 'ផ្លាស់ប្ដូរ ក្រុម',
        arrow: ' ---> ',
        saveReview: 'ឡើង វិញ',
        saveSpotCheck: 'ការ ត្រួត ពិនិត្យ និង ដាក់ស្នើ',
        rapidSampling: 'ការ គំរូ រហ័ស',
        file: 'ប័ណ្ណសារ',
        download: 'ទាញយក',
        lastPage: 'ទំព័រ មុន',
        nextPage: 'ទំព័រ បន្ទាប់',
        batchActions: 'ប្រតិបត្តិការ ថ្មី',
        cancelDistribution: 'មិន បំពេញ@ info: whatsthis',
        againDistribution: 'ផ្ដល់ ឡើងវិញ',
        deleteRecord: 'លុប ថត',
        oneOptionOpertor: 'អ្នក ត្រួត ពិនិត្យ គុណភាព ជម្រើសName',
        allOptionOpertor: 'អ្នក ត្រួតពិនិត្យ គុណភាព ទាំងអស់',
        distributionInfoFirstOne: 'អះអាង',
        distributionInfoFirstTwo: 'តើ អ្នក ចង់ ផ្ដល់ ថត ឡើងវិញ ឬ ? សូម ជ្រើស គោលដៅ ការ ផ្ដល់ ។',
        distributionInfoSecondOne: 'ត្រឹមត្រូវ បោះបង់',
        distributionInfoSecondTwo: 'តើ ព័ត៌មាន ថត នេះ ជា ? បន្ទាប់ ពី បោះបង់ វា នឹង ស្វែងរក ថត មើល មិន បាន ផ្ដល់ ។',
        distributionInfoSecondThree: 'តើ ព័ត៌មាន ដែល បាន ដោះស្រាយ នៃ ថត នេះ វា នឹង ជា ថត គំរូ ដែល មិន បាន បញ្ជាក់ បន្ទាប់ ពី ការ បោះបង់ ។',
        distributionInfoThirdOne: 'ថត ដែល បាន ជ្រើស',
        distributionInfoThirdTwo: 'ថត ដែល បាន ពិនិត្យ នឹង មិន ត្រូវ បាន ដំណើរការ ទេ ។',
        distributionInfoThirdThree: 'ថត ដែល បាន គំរូ នឹង មិន ត្រូវ បាន ដំណើរការ ទេ ។',
        exportError: 'នាំចេញ បាន បរាជ័យ',
        exportSuccess: 'នាំចេញ បាន ជោគជ័យ',
        deleteRecordInfo: 'តើ អ្នក ពិត ជា ចង់ លុប ថត {0} ? ទិន្នន័យ មិន អាច ត្រូវ បាន យក ឡើង វិញ បន្ទាប់ ពី លុប',
        pleaseSetFilter: 'សូម ជ្រើស លក្ខខណ្ឌ តម្រង',
        noCountAfterFilter: 'គ្មាន ទិន្នន័យ នាំចេញ សូម កំណត់ លក្ខខណ្ឌ តម្រង ឡើង វិញ',
        redo: 'ការ ប្រតិបត្តិ ឡើង វិញ',
        batchMove: 'ផ្លាស់ទី បាច់',
        websiteName: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
        salesEnable: 'ការ សន្យារ',
        systemName: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
        initSystemError: 'បដិសេធ បណ្ដាញ ឬ ការ ចាប់ផ្តើម ទំព័រ សូម ទាក់ទង សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ',
        day: 'ថ្ងៃStencils',
        hour: 'ម៉ោង',
        minute: 'ចំណុច',
        questionMark: '？',
        personalSettings: 'ការ កំណត់ ផ្ទាល់ខ្លួន',
        logout: 'បិទ សរសេរ',
        ok: 'កំណត់@ info: whatsthis',
        saveAs: 'រក្សាទុក',
        pleaseEnter: 'សូម បញ្ចូល',
        executeMessage: {
            executeSuccess: '{0} បាន ប្រតិបត្តិ ដោយ ជោគជ័យ',
            executeError: 'បរាជ័យ ក្នុង ការ ប្រតិបត្តិ {0}',
        },
        field: 'វាល',
        operator: 'កម្មវិធី',
        value: 'តម្លៃ',
        placeholder: 'សូម ជ្រើស',
        pleaseSelect: 'សូម ជ្រើស',
        totalScore: 'ពិន្ទុ សរុប',
        hyphen: '-',
        semicolon: '；',
        wfm: 'ការ កំណត់ ពេល ត្រឹមត្រូវ',
        user: 'អ្នក ប្រើ',
        none: 'គ្មាន ទេ',
        plusSign: '+',
        minusSign: '-',
        saveSuccessAndReload: 'រក្សាទុក ដោយ ជោគជ័យ ! មាន ប្រយោជន៍ បន្ទាប់ ពី ទំព័រ ស្រស់ ស្រស់ ភ្ជាប់',
        saveAsName: '{0} ចម្លង',
        systemInformation: 'មើល ទិន្នន័យ ប្រព័ន្ធ',
        billingCenter: 'ចំណុច ចំណុច',
        financeCenter: 'ការគ្រប់គ្រងហិរញ្ញវត្ថុ',
        warningMessage: 'កូតា ដែល នៅ សល់ មិន គ្រប់គ្រាន់ សូម ធ្វើ ឡើង វិញ',
        fileTypeHolder: 'ទ្រង់ទ្រាយ ឯកសារ មិន ត្រឹមត្រូវ ។ សូម ផ្ទុក ឯកសារ ឡើង នៅ ក្នុង ទ្រង់ទ្រាយ {0} ។',
        dataNo: 'គ្មាន ទិន្នន័យ',
        move: 'ផ្លាស់ទី',
        study: 'អ្នក មាន ចំណុច ត្រួត ពិនិត្យ គុណភាព សិក្សា ផ្ទាល់ ខ្លួន',
        studySuccess: 'ការ ជោគជ័យ',
        studyError: 'បរាជ័យ ក្នុង ការ បរាជ័យ',
        editType: 'កែសម្រួល ស្លាក ប្រភេទ',
        copyed: 'បាន ចម្លង ទៅ ក្ដារ តម្បៀត ខ្ទាស់',
        clickToCopy: 'ចុច ចម្លង',
        addFilterConditions: 'បន្ថែម លក្ខខណ្ឌ តម្រង',
        filterConditions: 'លក្ខខណ្ឌ តម្រង',
        messageTime: 'ពេលវេលា សារ',
        messageType: 'ប្រភេទ សារ',
        pushType: 'ឆានែល សារ',
        messageContent: 'មាតិកា សារ',
        messageName: 'ឈ្មោះ សារ',
        messageStatus: 'ស្ថានភាព សារ',
        configuration: 'ព័ត៌មាន កំណត់ រចនា សម្ព័ន្ធ',
        sendTarget: 'ផ្ញើ ទិសដៅ',
        guideUrl: 'URL Bootstrap',
        noticeDetail: 'សេចក្ដី លម្អិត សារ',
        action: 'ប្រតិបត្តិការ',
        seeDetail: 'មើល សេចក្ដី លម្អិត',
        theDay: 'ថ្ងៃ {0}',
        theLastDayOfMonth: 'ថ្ងៃ ចុង ក្រោយ រាល់ ខែ',
        ignore: 'មិន អើពើ',
        seeNow: 'មើល ឥឡូវ នេះ',
        exportConfirmText: {
            export: 'សរុប {0} នៃ ទិន្នន័យ អះអាង ដើម្បី នាំចេញ ឬ ?',
            exportAll: 'អះអាង ដើម្បី នាំចេញ មាតិកា ទាំងអស់ ឬ ?',
        },
        samrTagAdd: 'បន្ថែម ស្លាក',
        deletePopconfirmContent: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
        TheLastThirtyDays: '៣០ ថ្ងៃ ចុងក្រោយ',
        addNumber: 'ប្លូស',
        subNumber: 'មីន',
        addStrategy: 'បន្ថែម គោលនយោបាយ',
        minutes: 'នាទី',
        status: 'បាន អនុញ្ញាត ស្ថានភាព',
        pushConfig: 'ចុច ការ កំណត់ រចនា សម្ព័ន្ធ',
        category: 'ថត',
        and: 'ជា មួយ',
        interval: 'ចន្លោះ',
        switchOn: 'បើក',
        switchOff: 'បិទ',
        batchDel: 'លុប Batch',
        exportTxt: 'នាំចេញ អត្ថបទ TXT',
        playSpeed: 'ល្បឿន ទ្វេលា',
        messageLogBtn: 'មើល ការ ជូន ដំណឹង/ ជោគជ័យ ដែល កេះ ការ ជូនដំណឹង',
        dataLink: 'តំណ ទិន្នន័យ',
        yes: 'បាន',
        no: 'គ្មាន ទេ',
        sentenceUnit: 'ប្រយោជន៍',
        appealDetail: 'សេចក្ដី លម្អិត សំណុំ តួរ',
        detail: 'សេចក្ដី លម្អិត',
        default: 'លំនាំដើម',
        customer: 'ម៉ាស៊ីន ភ្ញៀវ',
        agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
        sort: 'តម្រង',
        applyNow: 'កម្មវិធី',
        index: 'លេខ សៀរៀល',
        allColumns: 'ជួរ ឈរ ដែល អាច ត្រូវ បាន បន្ថែម@ info: whatsthis',
        selectedColumns: 'បាន បន្ថែម ជួរ ឈរ',
        syn: 'ធ្វើ សមកាលកម្ម',
        saveAndNext: 'រក្សាទុក និង បង្កើត បន្ទាប់',
        viewReference: 'មើល សេចក្ដីយោងComment',
        referenceDetail: 'សេចក្ដី លម្អិត យយក',
        goToQaList: 'ទៅ កាន់ ការ ត្រួត ពិនិត្យ គុណភាព',
        goToCheck: 'ទៅ កាន់ ពិនិត្យ មើល ចំណុច',
        businessCard: 'កាត ពាក្យ',
        weapp: 'កម្មវិធី តូចៗ',
        redpacket: 'ក្រហម',
        externalRedpacket: 'ផ្លាស់ប្ដូរ ពណ៌ ក្រហម',
        sphfeed: 'លេខ វីដេអូ',
        exportTaskCreated: 'នាំចេញ ភារកិច្ច បាន បង្កើត ដោយ ជោគជ័យ',
        plzGoTo: 'សូម លុប',
        importTaskCreated: 'បាន នាំចូល ភារកិច្ច បង្កើត ដោយ ជោគជ័យ',
        taskCreated: 'បាន បង្កើត ភារកិច្ច ដោយ ជោគជ័យ',
        reply: 'ឆ្លើយតប',
        replied: 'ឆ្លើយតប',
        release: 'បោះពុម្ព',
        expandMore: 'ពង្រីក ឆ្លើយតប {0} ផ្សេង ទៀត',
        comment: 'សេចក្តី អធិប្បាយ',
    },
    business: {
        notifyMessage: {
            IsNullErrorFormat: 'សូម មាន យ៉ាង ហោច ណាស់ {0}',
            canNotBeEmptyFormat: '{0} មិន អាច ទទេ',
            repeatErrorTipFormat: '{0} មាន ស្ទួន',
            getInformationFailedFormat: 'បាន បរាជ័យ ក្នុង ការ យក ព័ត៌មាន {0} ។ សូម ពិនិត្យ មើល ការ តភ្ជាប់ បណ្ដាញ របស់ អ្នក ឬ ព្យាយាម ម្ដង ទៀត ម្ដង ទៀត',
            deleteSuccessFormat: '{0} ត្រូវ បាន លុប ដោយ ជោគជ័យ ។',
            deleteFailedFormat: '{0} បាន បរាជ័យ ក្នុង ការ លុប ។ សូម ព្យាយាម ម្ដង ទៀត ក្រោយ ។',
            saveSuccessFormat: '{0} បាន រក្សាទុក ដោយ ជោគជ័យ ។',
            saveFailedFormat: 'បរាជ័យ ក្នុង ការ រក្សាទុក {0} ។ សូម ព្យាយាម ម្ដង ទៀត ក្រោយ ។',
            fileSuccessFormat: 'បាន ប័ណ្ណសារ {0} ដោយ ជោគជ័យ ។',
            fileFailedFormat: 'បរាជ័យ ក្នុង ការ ប័ណ្ណសារ {0} ។ សូម ព្យាយាម ម្ដង ទៀត ក្រោយ ។',
            exportSuccessFormat: '{0} បាន នាំចេញ ជោគជ័យ',
            exportFailedFormat: 'នាំចេញ {0} បាន បរាជ័យ ។ សូម ព្យាយាម ម្ដង ទៀត ក្រោយ ។',
            submitSuccessFormat: '{0} បាន ដាក់ ស្នើ ដោយ ជោគជ័យ ។',
            submitFailedFormat: '{0} បាន បរាជ័យ ក្នុង ការ ដាក់ស្នើ សូម ព្យាយាម ម្ដង ទៀត ។',
            confirmSuccessFormat: 'ការ អះអាង {0} បាន ជោគជ័យ ។',
            confirmFailedFormat: 'ការ អះអាង {0} បាន បរាជ័យ ។ សូម ព្យាយាម ម្ដង ទៀត ក្រោយ ។',
            pleaseUploadFile: 'សូម ផ្ទុក ឯកសារ ឡើង ដំបូង !',
            importFileSuccess: 'នាំចូល ឯកសារ បាន ជោគជ័យ !',
            importFildFailed: 'បាន បរាជ័យ ក្នុង ការ នាំចូល ឯកសារ !',
            deleteSuccess: 'បាន លុប ដោយ ជោគជ័យ !',
            deleteFailed: 'បាន បរាជ័យ លុប សូម ព្យាយាម ម្ដង ទៀត ក្រោយ !',
            illegalTitle: 'សិទ្ធិ មិន គ្រប់គ្រាន់',
            illegalMessage: 'អ្នក មិនមាន សិទ្ធិ មួយ ចំនួន ឬ សិទ្ធិ ទាំងអស់ សម្រាប់ ជំហាន បន្ទាប់ សូម ទាក់ទង អ្នក គ្រប់គ្រង ដើម្បី កំណត់ រចនា សម្ព័ន្ធ ។ ចុច ប៊ូតុង OK នឹង បិទ ចាប់ផ្ដើម',
            illegalMessageCurrent: 'អ្នក មិនមាន សិទ្ធិ មួយ ចំនួន ឬ សិទ្ធិ ទាំងអស់ សម្រាប់ ជំហាន បច្ចុប្បន្ន សូម ទាក់ទង អ្នក គ្រប់គ្រង ដើម្បី កំណត់ រចនា សម្ព័ន្ធ ។ ចុច ប៊ូតុង OK នឹង បិទ ចាប់ផ្ដើម',
            skipMessage: 'ប្រសិន បើ អ្នក ចង់ រំលង ជំហាន នេះ ឥឡូវ នេះ ចុច រំលង',
            errorMsg500: 'ការ សំណើ ម៉ាស៊ីន បម្រើ បាន បរាជ័យ សូម ពិនិត្យ មើល ប្រតិបត្តិការ របស់ អ្នក ឬ ធ្វើ ឲ្យ ស្រស់ ហើយ ព្យាយាម ម្ដង ទៀត',
            errorMsg404: 'Ooops... ទំព័រ ដែល អ្នក កំពុង ស្វែងរក បាន',
            errorMsg400: 'បាន បរាជ័យ សំណើ ម៉ាស៊ីន បម្រើ សូម ពិនិត្យ មើល ទិន្នន័យ របស់ អ្នក ហើយ ព្យាយាម ម្ដង ទៀតName',
            pageOverFlow: 'បច្ចុប្បន្ន មាន តែ របារ ១០០០ អាច ត្រូវ បាន បង្ហាញ ។ សូម កំណត់ លក្ខខណ្ឌ តម្រង ដើម្បី មើល ច្រើន ។',
            isHandAddSmartTag: 'ជា ស្លាក ត្រឹមត្រូវ ដែល បាន បន្ថែម ដោយ ដៃ',
            defaultGradeMustAtLast: 'ការ វាយតម្លៃ លំនាំដើម ត្រូវ តែ ដាក់ នៅ ចុង បញ្ចូល',
            AutomaticAllocationInspectorsIsNull: 'សូម បញ្ចូល ទំព័រ ព័ត៌មាន មូលដ្ឋាន ដើម្បី បន្ថែម អ្នក ត្រួត ពិនិត្យ គុណភាព',
            timePickerTips: 'ដើម្បី មិន ប៉ះពាល់ ការ ប្រើ ធម្មតា របស់ អ្នក គឺ 23: 00 ~ 2 00 គឺ ជា ពេលវេលា ថែទាំ ប្រព័ន្ធ កុំ អនុវត្ត ភារកិច្ច ដែល បាន កំណត់ ពេល ។',
            batchDeleteInfo: 'ធាតុ {0} ត្រូវ បាន លុប ហើយ ធាតុ {1} បាន បរាជ័យ ដោយ ទិន្នន័យ ត្រូវ បាន ប្រើ ។',
            batchDeleteTips: 'ពិនិត្យ មើល ទិន្នន័យ {0} ដោយ អះអាង ដើម្បី លុប ?',
            correctionSuccess: 'កំហុស ជោគជ័យ',
        },
        pages: {
            qualityInspectionForm: {
                list: {
                    IsMaxFormNumberError: 'បន្ថែម ទៅ កាន់ សំណុំ បែបបទ ត្រួតពិនិត្យ គុណភាព ១០',
                },
                specialProject: {
                    sumOfScoresErrorTip: 'ធាតុ មេត្រី',
                    banProjectMaxErrorTip: 'បន្ថែម ទៅកាន់ ធាតុ ដែល បាន បដិសេធ ២០០០',
                    deadlyProjectMaxErrorTip: 'បន្ថែម ធាតុ ធឺណិត ៥០',
                },
            },
        },
        info: {
            creatSuccess: 'បាន បង្កើត ដោយ ជោគជ័យ',
            creatError: 'បាន បរាជ័យ',
            editSuccess: 'ការ កែប្រែ បាន ជោគជ័យ',
            editError: 'ការ កែប្រែ បាន បរាជ័យ',
            deleteSuccess: 'បាន លុប ដោយ ជោគជ័យ',
            addSuccess: 'ជោគជ័យ ថ្មី',
            deleteError: 'បរាជ័យ លុប',
            conditionError: 'កំហុស កន្សោម ឡូក',
            customJudgeLogic: 'កំហុស កន្សោម ឡូក លក្ខខណ្ឌ ផ្ទាល់ខ្លួន',
            exportError: 'នាំចេញ បាន បរាជ័យ',
            searchError: 'តម្រង បាន បរាជ័យ',
            loadError: 'បរាជ័យ ក្នុង ការ ផ្ទុក {0}',
            saveSuccess: 'រក្សាទុក ដោយ ជោគជ័យ',
            saveError: 'បាន បរាជ័យ ក្នុង ការ រក្សាទុក',
            fileSuccess: 'ប័ណ្ណសារ ជោគជ័យ',
            fileError: 'បរាជ័យ ក្នុង ការ ប័ណ្ណសារ',
            cannotBeNull: '{0} មិន អាច ទទេ !',
            pleaseSearchAndSelect: 'សូម បញ្ចូល ការ ស្វែងរក ពាក្យ គន្លឹះ',
            clickAndToggle: 'ចុច ដើម្បី ជ្រើស ប្ដូរ',
            deleteWarning: 'ការ លុប {0} នឹង មិន អាច ឡើងវិញ បានទេ តើ អ្នក ពិត ជា ចង់ បន្ត ឬ ?',
            getOssAuthFailed: 'បាន បរាជ័យ ក្នុង ការ ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ របស់ OSS ។ ពិនិត្យ មើល ការ តភ្ជាប់ បណ្ដាញ ឬ ព្យាយាម ម្ដង ទៀត ។',
            getInsightAuthFailed: 'បាន បរាជ័យ ក្នុង ការ ទទួល ការ អនុញ្ញាត Insight ។ ពិនិត្យ មើល ការ តភ្ជាប់ បណ្ដាញ របស់ អ្នក ឬ ព្យាយាម ម្ដង ទៀត ។',
            pictureUploadFailed: 'បាន បរាជ័យ ក្នុង ការ ផ្ទុក ឡើង រូបភាពName',
            pictureUploadFailedSize: 'ទំហំ រូបភាព មាន ដែន កំណត់ បរាជ័យ ក្នុង ការ ផ្ទុក ឡើង រូបភាព',
            wecomTagsSyncInfo: 'បាន ធ្វើ ឲ្យ ទាន់សម័យ ចុងក្រោយ ៖ កំពុង ធ្វើ សមកាលកម្ម {1}',
            collectSuccess: 'ការ សម្រាំង ជោគជ័យ ។',
        },
    },
    components: {
        common: {
            qcReportEcharts: {
                errorMessage: 'បាន បរាជ័យ ក្នុង ការ យក ទិន្នន័យ របាយការណ៍Name',
            },
            waveAudio: {
                noWaveMessage: 'ដើម្បី ថែទាំ បទ ពិសោធន៍ របស់ អ្នក នឹង មិន ត្រូវ បានបង្ហាញ សម្រាប់ ការ ថត រហូត ឡើង វិញ {0} នាទី ។ អ្នក អាច លេង ពួកវា ដោយ ផ្ទាល់ ។',
            },
            customFilter: {
                del: 'លុប',
                edit: 'កែសម្រួល',
                new: 'តម្រង ផ្ទាល់ខ្លួន',
                apply: 'កម្មវិធី',
                cancel: 'បោះបង់',
                onlyApply: 'បាន តែ អនុវត្ត ប៉ុណ្ណោះ',
                ohterSave: 'រក្សាទុក',
                save: 'រក្សាទុក',
                customFilter: 'តម្រង ធម្មតា',
                reset: 'កំណត់ ឡើង វិញ',
                holderKeyWord: 'សូម បញ្ចូល ពាក្យ គន្លឹះ',
                customFilterRule: 'តម្រង ច្បាប់ តក្ក ៖',
                customFilterName: 'ឈ្មោះ តម្រង ៖',
                holderCustomFilterName: 'សូម បញ្ចូល ឈ្មោះ តម្រង',
                manualConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ ដោយដៃ',
                holderCustomRule: 'សូម បញ្ចូល លក្ខខណ្ឌ ផ្ទាល់ខ្លួន',
                example: 'ឧទាហរណ៍',
                dragConfiguration: 'អូស និង ទម្លាក់ ការ កំណត់ រចនា សម្ព័ន្ធ',
                condition: 'លទ្ធផល',
                operation: 'ប្រតិបត្តិការ',
                infoDel: 'អូស មាតិកា ចេញ ពី ផ្ទៃ ដើម្បី លុប',
                toConfigure: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                holderCustomFilterNameLength: 'ប្រវែង អតិបរមា ឈ្មោះ តម្រង គឺ ១០',
                customFilterNameNone: 'ឈ្មោះ តម្រង មិន អាច ទទេ',
                and: 'និង សិទ្ធិ',
                or: 'ឬ ថត',
                not: 'កុំ',
                delSuccess: 'បាន លុប ដោយ ជោគជ័យ',
                saveSuccess: 'រក្សាទុក ដោយ ជោគជ័យ',
                updateSuccess: 'ការ កែប្រែ បាន ជោគជ័យ',
                customFilterCondition: 'លក្ខខណ្ឌ តម្រង',
                conditionRule: 'ច្បាប់ លក្ខខណ្ឌ',
                none: 'គ្មាន ទេ',
                filterPlaceholder: 'សូម បញ្ចូល ពាក្យ គន្លឹះ',
            },
            labelTabs: {
                addThis: 'បន្ថែម ទៅ នេះ',
                goThis: 'ផ្លាស់ទី ទៅ នេះ',
                saveGo: 'រក្សាទុក និង មរ',
            },
            datePicker: {
                today: 'ថ្ងៃ នេះ@ item: inlistbox',
                yesterday: 'ម្រាមង',
                theDayBeforeYesterday: 'ថ្ងៃ មុន ម្ល',
                thisWeek: 'សប្ដាហ៍ នេះ',
                lastWeek: 'សប្ដាហ៍ មុន',
                thisMonth: 'ខែ នេះ',
                lastMonth: 'ខែ មុន',
                lastSevenDay: '៧ ថ្ងៃ ចុងក្រោយ',
                lastThirtyDay: '៣០ ថ្ងៃ ចុងក្រោយ',
                thisQuarter: 'ចន្លោះ នេះ',
                lastQuarter: 'ចន្លោះ ចុងក្រោយ',
                thisYear: 'ឆ្នាំ នេះ',
                lastYear: 'ឆ្នាំ មុន',
                lastYearFromToday: 'ឆ្នាំ មុន',
            },
            pagination: {
                page: 'ទំព័រ {1} នៃ {0}',
            },
            wechatRecord: {
                loadMoreBtn: {
                    top: 'ផ្ទុក សារ មុន',
                    bottom: 'ផ្ទុក សារ បន្ថែម',
                },
            },
        },
        pages: {
            menuTitleList: {
                tasksManageTitle: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                informationCollectTasksManageTitle: 'ភារកិច្ច សម្រាំង',
                customerServiceCenterTitle: 'មជ្ឈមណ្ឌល សេវា ម៉ាស៊ីន ភ្ញៀវ',
                informationTitle: 'មជ្ឈមណ្ឌល ទិន្នន័យ',
                intelligentAnalysisTitle: 'ការ វិភាគ បដិសេធ',
                semanticIntelligence: 'ជម្រះ សំឡេង',
                trainingCenterTitle: 'មជ្ឈមណ្ឌល បង្ហាញ',
                adminTitle: 'គ្រប់គ្រង ប្រព័ន្ធ',
            },
            qualityCheckingTask: {
                title: 'ការ ត្រួត ពិនិត្យ គុណភាព ហៅ',
                index: {
                    tipOne: 'ការ ត្រួត ពិនិត្យ គុណភាព ហៅ ត្រូវ បាន ប្រើ ដើម្បី តម្លៃ គុណភាព នៃ ការងារ កណ្ដាល ហៅ របស់ អ្នក ។ អ្នក អាច រៀបចំ សំណុំ បែបបទ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ ដោយ មូលដ្ឋាន លើ ដំណើរការ របស់ អ្នក ។',
                    tipTwo: 'ក្ដារ ដែល ត្រឹមត្រូវ អាច ត្រូវ បាន កំណត់ សម្រាប់ ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព ដែល រួម បញ្ចូល ត្រង និង គំរូ ។ បន្ទាប់ ពី ពិន្ទុ បញ្ជា',
                    addTaskTitle: 'បន្ថែម ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                    deleteTipTitle: 'លុប ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                    deleteTipContent: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព មិន អាច ត្រូវ បាន ស្ដារ ឡើង វិញ បន្ទាប់ ពី លុប ។ តើ អ្នក ពិត ជា ចង់ លុប ពួកវា ឬ ?',
                    checkingTask: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                    checkingTaskList: 'បញ្ជី ភារកិច្ច ត្រួតពិនិត្យ គុណភាព',
                    formList: 'បញ្ជី សំណួរ',
                    viewHelpDocuments: 'មើល ឯកសារ ជំនួយ',
                },
                manage: {
                    taskSetting: {
                        title: 'ការ កំណត់ ភារកិច្ច',
                        form: 'ទ្រង់ទ្រាយ',
                        basicInfo: 'ព័ត៌មាន មូលដ្ឋាន',
                        visibleRange: 'ជួរ ដែល អាច មើល ឃើញ',
                        visibleRangeTip: 'សេវា របស់ អ្នក ដែល បាន ជ្រើស និង ក្រុម សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ អាច មើល ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ។ បន្ថែម ចំពោះ ក្រុម សេវា របស់ ភ្ញៀវ សេវា សេវា និង អ្នក ត្រួត ពិនិត្យ គុណភាព អាច ត្រូវ បាន ភ្ជាប់ ជាមួយ ការ កំណត់ សិទ្ធិ សម្រាប់ ភារកិច្ច នេះ ។',
                        automaticSampling: 'គំរូ ដោយ ស្វ័យ ប្រវត្តិ',
                        automaticSamplingTip: 'អ្នក អាច កំណត់ ច្បាប់ គំរូ ដោយ ស្វ័យ ប្រវត្តិ ដូច្នេះ ប្រព័ន្ធ នឹង បន្ថែម ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ខ្ពស់ តាម ច្បាប់ ដែល អ្នក កំណត់ ។ ដូចជា ចេញ ៥% នៃ ហៅ របស់ សប្ដាហ៍ ចុងក្រោយ រាល់ ថ្ងៃ ។',
                        samplingRate: 'ប្រេកង់ គំរូ',
                        samplingTime: 'ពេលវេលា គំនូស់',
                        samplingRange: 'ជួរ ការ គំរូ',
                        samplingRule: 'ច្បាប់ គំរូ',
                        fillterCondition: 'លក្ខខណ្ឌ តម្រង',
                        workflow: 'ទំហំ ការងារ ត្រួត ពិនិត្យ គុណភាព',
                        appealsTime: 'អនុញ្ញាត ពេលវេលា សំណួរ',
                        appealsTimeTipOne: 'បន្ទាប់ ពី ការ ដាក់ស្នើ ពិន្ទុ',
                        appealsTimeTipTwo: 'នៅ ក្នុង ថ្ងៃweather condition',
                        appealsTimeTipThree: 'ប្រសិនបើ ពេលវេលា អះអាង គឺ លើស ស្ថានភាព ត្រួត ពិនិត្យ គុណភាព ថត នឹង ត្រូវ បាន ផ្លាស់ប្ដូរ ដោយ ស្វ័យ ប្រវត្តិ ទៅ កាន់ អះអាង "',
                        auditTime: 'ពេលវេលា ដំណើរការ ត្រួត ពិន្ទុ',
                        auditTimeTipOne: 'បន្ទាប់ ពី ការ ដាក់ ស្ថិត មួយ',
                        auditTimeTipTwo: 'នៅ ក្នុង ថ្ងៃweather condition',
                        auditTimeTipThree: 'បន្ទាប់ ពី ពេលវេលា ដំណើរការ ការ អនុញ្ញាត ត្រូវ បាន បន្ថែម ថត ថត រក្សា ពិន្ទុ ដើម ។ និង ស្ថានភាព ត្រួត ពិនិត្យ គុណភាព ត្រូវ បាន ផ្លាស់ប្ដូរ ដោយ ស្វ័យ ប្រវត្តិ ទៅ ជា អះអាង "',
                        noAppealsMode: 'គ្មាន របៀប ភ្ជាប់',
                        appealsMode: 'អនុញ្ញាត របៀប អាក់',
                        noAppealsModeImage: 'no-appeal.png',
                        appealsModeImage: 'appeal.png',
                        customerServices: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                        customerServicesGroup: 'ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
                        surveyList: 'បញ្ជី តម្លៃ',
                        customFields: 'វាល ផ្ទាល់ខ្លួន',
                        fieldConfig: 'ការ កំណត់ រចនាសម្ព័ន្ធ វាល',
                        from: 'ពីរ',
                        owner: 'ផ្នែក ត្រួត ព្រួញ',
                        inspectorAndReviewerAuthority: 'ការ ពិនិត្យ មើល គុណភាព មួយ',
                        inspector: 'កម្មវិធី ត្រួតពិនិត្យ គុណភាព',
                        reviewer: 'កម្មវិធី បន្ត',
                        inspectorTip: 'អ្នក ត្រួតពិនិត្យ អាច ចំណុច ភារកិច្ច',
                        reviewerTip: 'កម្មវិធី មើល អាច វាយ តម្លៃ ភារកិច្ច',
                        dataStatisticsAuthority: 'សិទ្ធិ ស្ថិតិ ទិន្នន័យ',
                    },
                    samplingRecords: {
                        title: 'ការ ថត គំរូ',
                        manualSampling: {
                            title: 'ការ គំរូ',
                            fillterCondition: 'លក្ខខណ្ឌ តម្រង',
                            samplingRule: 'ច្បាប់ គំរូ',
                            agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                            type: 'ប្រភេទ@ info: whatsthis',
                            result: 'លទ្ធផល',
                            evaluate: 'ការ តម្លៃ',
                            relayNumber: 'លេខ ឡើង វិញ',
                            source: 'ប្រភព',
                            task: 'ភារកិច្ច',
                            queueState: 'ស្ថានភាព ជួរ',
                            callHanger: 'ភ្ញៀវ ហៅ ដោយ',
                            queueTime: 'ការ ដាក់ ជួរ ពេលវេលាComment',
                            talkTime: 'ថិរវេលា ហៅ',
                            bellTime: 'ថិរវេលា បង្ហាញ',
                            recordCountTipOne: 'សរុប',
                            recordCountTipTwo: 'ថត',
                            customerServices: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                            customerServicesGroup: 'ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
                            surveyList: 'បញ្ជី តម្លៃ',
                            customFields: 'វាល ផ្ទាល់ខ្លួន',
                            fieldConfig: 'ការ កំណត់ រចនាសម្ព័ន្ធ វាល',
                            defaultFields: 'វាល លំនាំដើម',
                        },
                    },
                    taskList: {
                        title: 'បញ្ជី ភារកិច្ច',
                        index: {
                            batchDelete: 'លុប Batch',
                            batchSubmit: 'ដាក់ ស្នើ  ব্যাត់',
                            batchConfirm: 'អះអាង Bath',
                            itemFields: 'វាល ធាតុ បញ្ឈរ',
                            categoryFields: 'វាល ក្លែង ធ្វើ រង',
                            forbidsAndDeadlies: 'ធាតុ ដែល បាន បង្ហាញ និង ធ្វើ',
                            scoreFieldList: 'បញ្ជី វាល ធាតុ',
                            customerName: 'ឈ្មោះ ម៉ាស៊ីន ភ្ញៀវ',
                            cellphone: 'ទូរស័ព្ទ',
                            email: 'អ៊ីមែល',
                            organization: 'ក្រុមហ៊ុន',
                            description: 'សេចក្ដី ពិពណ៌នា',
                            tags: 'ស្លាក',
                            taskUserRole: 'អ្នក ប្រើ ភារកិច្ច បច្ចុប្បន្ន',
                        },
                        workBench: {
                            title: 'សេចក្ដី លម្អិត ថត',
                            checkForm: 'ទ្រង់ទ្រាយ ត្រួត ពិនិត្យ គុណភាព',
                            waitEvaluate: 'ត្រូវ បាន ប្រយោជន៍',
                            alreadyEvaluate: 'បាន តម្លៃ',
                            waitSubmit: 'ត្រូវ បាន ដាក់ស្នើ',
                            alreadySubmit: 'បាន ដាក់ ស្នើ',
                            waitConfirm: 'ត្រូវ អះអាង',
                            alreadyConfirm: 'បាន អះអាង',
                            waitReview: 'ត្រូវ បាន ពិនិត្យ មួយ',
                            alreadyReview: 'បាន ឡើង វិញ',
                            alreadyDone: 'បាន បញ្ចប់',
                            comment: 'ការ វាយ តម្លៃ',
                            totalScore: 'ពិន្ទុ សរុប',
                            score: 'ចំណុច',
                            remark: 'ពាក្យ បញ្ជា',
                            changeRecords: 'ផ្លាស់ប្ដូរ ថត',
                            subject: 'ស្បែក',
                            secondLevelScore: 'ពិន្ទុ ថ្នាក់ ២',
                            deadlyList: 'ធាតុ ធ្ងន់ធ្ងរ',
                            forbidList: 'ធាតុ ដែល បាន បង្ហាញ',
                            addToCheckTask: 'បន្ថែម ទៅ ភារកិច្ច គុណភាព',
                            submitCheckRemark: 'បាន ដាក់ស្នើ ការ វាយតម្លៃ ត្រួតពិនិត្យ គុណភាព',
                            changeCheckRemark: 'ការ ត្រួតពិនិត្យ គុណភាព ត្រូវ បាន កែប្រែ@ info: whatsthis',
                            doneCheckRemark: 'បាន បញ្ចប់ ការ វាយតម្លៃ ត្រួតពិនិត្យ គុណភាព',
                            submitCheckReview: 'បាន ដាក់ ស្នើ សម្រាប់ ការ ត្រួត ពិនិត្យ គុណភាព',
                            submitCheckAppeal: 'បាន ដាក់ ស្នើ ការ ត្រួត ពិនិត្យ គុណភាព',
                            saveFlowSuccess: 'តម្រូវ ការ ជោគជ័យ ។',
                            saveFlowFailed: 'បាន បរាជ័យ ក្នុង ការ វាយតម្លៃ សូម ព្យាយាម ម្ដង ទៀត ។',
                            FormDetail: 'សេចក្ដី លម្អិត សំណួរ',
                            callDetail: 'សេចក្ដី លម្អិត កំណត់ ហេតុ ហៅ',
                            sampleCalllogDetail: 'សេចក្ដី លម្អិត ថត',
                            appealReasonTip: 'សូម បញ្ចូល មូលហេតុ សម្រាប់ ការ តភ្ជាប់ (ទាមទារ)',
                            appeal: 'ជម្រះ',
                            appealReason: 'មូលដ្ឋាន សំខាន់ៗ',
                        },
                    },
                },
            },
            qualityInspectionForm: {
                formformat: 'ទ្រង់ទ្រាយ ការ ត្រួត ពិនិត្យ គុណភាព {0}',
                basicInformationTitle: 'ព័ត៌មាន មូលដ្ឋាន',
                indicatorsProjectTitle: 'ធាតុ បញ្ចូល',
                specialProjectTitle: 'ធាតុ ពិសេស',
                totalScore: 'ពិន្ទុ សរុប',
                indicatorsName: 'ឈ្មោះ កម្មវិធី បង្ហាញ',
                score: 'ប្រទេស',
                singleScore: 'ពិន្ទុ ធាតុ មួយ',
                weight: 'កម្ពស់',
                maxDeductScore: 'ការ បម្លែង ចំណុច អតិបរមា',
                add: 'បង្កើន',
                detail: 'សេចក្ដី លម្អិត សំណួរ',
                list: {
                    title: 'ទ្រង់ទ្រាយ ត្រួត ពិនិត្យ គុណភាព',
                    tipOne: 'ការ កំណត់ រចនា សម្ព័ន្ធ សំណុំ ការ ត្រួត ពិនិត្យ គុណភាព គឺ ជា ជំហាន ដំបូង ក្នុង ការ ត្រួត ពិនិត្យ គុណភាព ។ អ្នក អាច កំណត់ រចនា សម្ព័ន្ធ សំណុំ បែបបទ ត្រួត ពិនិត្យ គុណភាព សមរម្យ បំផុត ដែល មាន មូលដ្ឋាន លើ បណ្ដាញ របស់ អ្នក ។',
                    tipTwo: 'យើង គាំទ្រ សំណុំ បែបបទ ផ្សេងៗ ដូចជា ការ ពិន្ទុ កម្រិត ពិន្ទុ និង ប្រព័ន្ធ ការ ដោះស្រាយ ចំណុច ។ វា ត្រូវ បាន ផ្ដល់ អនុសាសន៍ ថា អ្នក រៀបចំ ច្បាប់ មុន ពេល បន្ថែម ពួកវា ទៅ ប្រព័ន្ធ ។',
                },
                basicInformation: {
                    formTemplate: 'ពុម្ព ទ្រង់ទ្រាយ',
                    directScore: 'ការ វាយតម្លៃ ផ្ទាល់',
                    weightedScore: 'ពិន្ទុ ទំហំ',
                    deductScore: 'ដក',
                    directScoreSecondLevel: 'ការ វាយតម្លៃ កម្រិត ២',
                    weightedScoreSecondLevel: 'ពិន្ទុ កម្រិត ២',
                    deductScoreSecondLevel: 'ចំណុច ដោះស្រាយ កម្រិត ២',
                    deductScoreImageFileName: 'deduct-score.png',
                    weightedScoreImageFileName: 'weighted-score.png',
                    directScoreImageFileName: 'direct-score.png',
                    deductScoreSecondLevelImageFileName: 'deduct-score-second-level.png',
                    weightedScoreSecondLevelImageFileName: 'weighted-score-second-level.png',
                    directScoreSecondLevelImageFileName: 'direct-score-second-level.png',
                },
                specialProject: {
                    banProject: 'ធាតុ ដែល បាន បង្ហាញ',
                    banProjectTip: 'វា អាច ត្រូវ បាន ប្រើ ដើម្បី ធីក កំឡុង ពេល ពិនិត្យ មើល គុណភាព ។ វា អាច ទាក់ទង ជា ការ បំបាត់ ឬ ការ បន្ថយ សេចក្តី អធិប្បាយ ដោយ មិន ប៉ះពាល់ ការ ពិន្ទុ ពិត ។',
                    deadlyProject: 'ធាតុ ធ្ងន់ធ្ងរ',
                    deadlyProjectTip: 'ធាតុ ធ្ងន់ធ្ងរ អាច ត្រូវ បាន ប្រើ ដើម្បី ពិនិត្យ មើល គុណភាព ។ ប្រសិន បើ ធីក ធាតុ ធ្ងន់ធ្ងរ ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព ត្រូវ បាន ពិនិត្យ ដោយ ផ្ទាល់ ០ ចំណុច ។',
                },
            },
            qualityInspectionStatisticalReports: {
                reports: {
                    title: 'ការ ត្រួត ពិនិត្យ គុណភាព ហៅ',
                    entiretyReportTitle: 'របាយការណ៍ ទាំងអស់',
                    serviceGroupReportTitle: 'របាយការណ៍ ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    serviceReportTitle: 'របាយការណ៍ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    entiretyReport: {
                        pandect: 'មើល មើល',
                        contrast: 'កម្រិត ពណ៌',
                        trend: 'មធ្យម',
                        analyze: 'វិភាគ រយ',
                        totalScore: 'ពិន្ទុ សរុប',
                        banProject: 'ធាតុ ដែល បាន បង្ហាញ',
                        deadlyProject: 'ធាតុ ធ្ងន់ធ្ងរ',
                    },
                },
            },
            appealChekingTask: {
                list: {
                    title: 'បញ្ជី លទ្ធផល ត្រួតពិនិត្យ គុណភាព',
                    taskSelectPlaceholder: 'ជ្រើស ភារកិច្ច គុណភាព',
                    agentSelectPlaceholder: 'ជ្រើស សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ',
                    refresh: 'ធ្វើ ឲ្យ ស្រស់',
                    all: 'ទាំង អស់',
                    unread: 'មិនទាន់ អាន',
                    inComplaint: 'នៅ ក្នុង សត្វ',
                    reviewed: 'បាន ឡើង វិញ',
                    totalScore: 'សេចក្ដី អធិប្បាយ ទូទៅ',
                    detail: 'សេចក្ដី លម្អិត ការ ត្រួត ពិនិត្យ គុណភាព',
                    audioText: 'អត្ថបទ ដែល បាន ថត',
                    callInfo: 'ព័ត៌មាន ហៅ',
                    ticketInfo: 'ព័ត៌មាន លំដាប់ ការងារ',
                    wechatInfo: 'ព័ត៌មាន សម័យ',
                    dialogText: 'ប្រអប់ អត្ថបទName',
                    dialogInfo: 'ព័ត៌មាន សកម្ម',
                    customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                    agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    none: 'គ្មាន ទិន្នន័យ ត្រួត ពិនិត្យ គុណភាព',
                    appealSuccess: 'ការ តភ្ជាប់ បាន ជោគជ័យ !',
                    appealFailed: 'បាន បរាជ័យ ក្នុង ការ តភ្ជាប់ សូម ព្យាយាម ម្ដង ទៀត ។',
                    pointListIsNull: 'ចំណុច ការ ត្រួត ពិនិត្យ គុណភាព ស្លាប់ មិន អាច ទទេ !',
                    pleaseSelectPoint: 'សូម ជ្រើស ចំណុច ត្រួត ពិនិត្យ គុណភាព !',
                    unsupportedFormat: 'ទ្រង់ទ្រាយ នេះ មិន ត្រូវ បាន គាំទ្រ ។',
                    shardingInformation: 'ចែករំលែក ដូច ខាងក្រោម {0}',
                    smartTags: 'ស្លាក ឆ្លាត',
                    businessRecords: 'ថត ពាក្យ',
                    selectedPointsWarning: 'សូម ពិនិត្យ មើល ធាតុ ការ ត្រួត ពិនិត្យ គុណភាព ដើម្បី សិទ្ធិ បញ្ជាក់ ការ ធនធាន ដែល ទាក់ទង សម្រាប់ ធាតុ សំណួរ ហើយ បន្ទាប់ មក ចុច ដាក់ ស្នើ ។',
                    applyReason: 'ផែនទី ការ អាប់ភ្លេត ( ពាក្យ អតិបរមា ៥០)',
                    chatMessageTypes: {
                        all: 'ទាំង អស់',
                        text: 'អត្ថបទ',
                        image: 'រូបភាព',
                        agree: 'មាតិកា សម័យ',
                        video: 'វីដេអូ',
                        voice: 'សំឡេង',
                        file: 'ឯកសារ',
                        emotion: 'កន្សា',
                        link: 'តំណ',
                        chatrecord: 'ថត ជជែក កំសាន្ត',
                        mixed: 'សារ ដែល បាន លាយ',
                        default: 'មិន គាំទ្រ សារ',
                        deleteFriend: 'លុប មិត្តភក្ដិ',
                        redpacket: 'ក្រហម',
                        card: 'កាត ពាក្យ',
                        disAgree: 'មិន ទាក់ទង ជាមួយ មាតិកា សួរ',
                        weapp: 'កម្មវិធី តូចៗ',
                        externalRedpacket: 'ផ្លាស់ប្ដូរ ពណ៌ ក្រហម',
                        meetingVoicevCall: 'សារ ហៅ',
                        uRL: 'ទំព័រ បណ្ដាញ',
                        replyTimeout: 'អស់ពេល ឆ្លើយតប',
                        sphfeed: 'លេខ វីដេអូ',
                        chatRecordTitle: 'ថត ជជែក កំសាន្ត',
                    },
                },
                components: {
                    qualityCheckScore: {
                        totalScore: 'ពិន្ទុ សរុប',
                        actualScore: 'ការ វាយតម្លៃ',
                        actualGrade: 'ការ វាយតម្លៃ',
                        appeal: 'ជម្រះ',
                        remark: 'ការ ព្យាយាម ដោយដៃ',
                        none: 'គ្មាន ទិន្នន័យ លម្អិត សម្រាប់ ការ ត្រួត ពិនិត្យ គុណភាព',
                        pointEdit: 'ថ្នាក់ កែសម្រួល ចំណុច ត្រួត ពិនិត្យ គុណភាព',
                    },
                    changeList: {
                        title: 'ផ្លាស់ប្ដូរ ថត',
                        user: 'អ្នក ប្រើ',
                        point: 'ចំណុច ត្រួត ពិនិត្យ គុណភាព',
                    },
                    relatedRecord: {
                        title: 'ថត ដែល ទាក់ទង',
                        qualityList: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                        none: 'គ្មាន ទេ',
                        check: 'ទិដ្ឋភាព',
                        loadMore: 'ផ្ទុក បន្ថែម',
                    },
                },
            },
            grade: {
                title: 'ការ ត្រួត ពិនិត្យ គុណភាព',
                subTitle: 'អត្រា ការ ត្រួត ពិនិត្យ គុណភាព ត្រូវ បាន ប្រើ ដើម្បី បញ្ចប់ វត្ថុ ត្រួតពិនិត្យ គុណភាព ថ្នាក់ បន្ទាប់ ពី ការ ពិនិត្យ មើល គុណភាព ត្រូវ បាន បញ្ចប់ ។ ឧទាហរណ៍ វា អាច ត្រូវ បាន កំណត់ រចនា សម្ព័ន្ធ ជា មិន ត្រឹមត្រូវ ប្រសិន បើ វា ទាប ៦០ ។ និង ល្អ បំផុត ប្រសិនបើ វា ខ្ពស់ ជាង ៨០ ។',
                list: {
                    up: 'ផ្លាស់ទី ឡើង លើ',
                    down: 'ផ្លាស់ទី ចុះក្រោម',
                    del: 'លុប',
                    case: 'ចូលរួម បណ្ណាល័យ ដោយ ស្វ័យ ប្រវត្តិ',
                    orderCase: 'បណ្ណាល័យ អក្សរ លំនាំដើម',
                    info: 'ការ វាយតម្លៃ លំនាំដើម មិនមាន លក្ខខណ្ឌ ផ្គូផ្គង ហើយ មិន អាច លុប ។ ប្រសិន បើ ការ វាយតម្លៃ ខាង លើ មិន ត្រូវ បាន ធ្វើ ឲ្យ វាយតម្លៃ លំនាំដើម នឹង ត្រូវ បាន ទទួល ។',
                    add: 'បន្ថែម ការ វាយតម្លៃ',
                    save: 'រក្សាទុក',
                    close: 'បោះបង់',
                    max: 'ការ ត្រួត ពិនិត្យ គុណភាព អាច ត្រូវ បាន កំណត់ រចនា សម្ព័ន្ធ ដល់ ២០',
                    name: 'គ្មាន ឈ្មោះ',
                    success: 'រក្សាទុក ដោយ ជោគជ័យ',
                },
            },
            qualityInspectionList: {
                title: 'បញ្ជី ត្រួតពិនិត្យ គុណភាព',
                fastFilter: 'ការ ត្រួត ពិនិត្យ គុណភាព',
                fastFilterTip: 'គំនូរ នៅ លើ ប្រព័ន្ធ ចំណុច មុខ',
                titleWechat: 'បញ្ជី វិភាគName',
                titleCollect: 'បញ្ជី សំឡេង',
                status: 'ស្ថានភាព វិភាគComment',
                reQualityInspectionConfig: 'ជម្រើស ភារកិច្ច ត្រឹមត្រូវ',
                pleaseSelectRecheckPoints: 'សូម ជ្រើស ចំណុច ត្រួត ពិនិត្យ គុណភាព ដែល ត្រូវ បាន គណនា ឡើង វិញ',
                beginReQualityInspection: 'ចាប់ផ្ដើម ប្រតិបត្តិ',
                cancelReQualityInspection: 'បោះបង់ ភារកិច្ច',
                reQualityInspection: 'ឡើង វិញ',
                reQualityInspectionWechat: 'វិភាគ ឡើង វិញ',
                reQualityInspectionUnderWay: 'ភារកិច្ច បញ្ជា',
                reQualityInspectionUnderWayTip: 'ការ ទុក ទំព័រ បន្ទាប់ ពី បិទ បង្អួច មិន ប៉ះពាល់ ដល់ ភារកិច្ច',
                reQualityInspectionDone: 'បាន បញ្ចប់ ឡើង វិញ',
                reQualityInspectionDoneTip: 'ការ ណែនាំ ឡើងវិញ ត្រូវ បាន បញ្ចប់ ដោយ ជោគជ័យ សូម ចុច ប៊ូតុង ការ អះអាង ។',
                endReQualityInspection: 'បញ្ចប់ ភារកិច្ច',
                alreadyDoneTip: '{0} បាន បញ្ចប់',
                totalTip: '{0} សរុប',
                endReInspectionSuccess: 'បាន បញ្ចប់ ភារកិច្ច គុណភាព ឡើង វិញ',
                closeWindow: 'បិទ បង្អួច',
                endReInspectionFailed: 'បាន បរាជ័យ ភារកិច្ច គុណភាព ឡើង វិញ សូម ព្យាយាម ម្ដង ទៀត ។',
                detail: {
                    title: 'សេចក្ដី លម្អិត ការ ត្រួត ពិនិត្យ គុណភាព',
                    wechatTitle: 'សេចក្ដី លម្អិត ការ វិភាគName',
                    titleCollect: 'សេចក្ដី លម្អិត សម្រាំង',
                    callIndex: 'ហៅ ដែល ទាក់ទង',
                    textIndex: 'ការ និយាយ ដែល ទាក់ទង',
                    fileConfirm: 'អះអាង ការ បង្ហាញ ឬ ?',
                    fileConfirmDesc: 'បន្ទាប់ ពី ប័ណ្ណសារ ពិន្ទុ ត្រួត ពិនិត្យ គុណភាព មិន អាច ត្រូវ បាន កែសម្រួល ។ សូម អះអាង ថា តើ ត្រូវ ប័ណ្ណសារ ឬ ទេ ។',
                },
                sysCloumnsContal: 'គ្រប់គ្រង វាល ជួរឈរ ប្រព័ន្ធ',
                personCloumnsContal: 'គ្រប់គ្រង វាល ជួរឈរ ផ្ទាល់ខ្លួន',
            },
            spotCheckList: {
                title: 'បញ្ជី គំរូ',
                onlyMyTip: 'មើល តែ គំរូ របស់ ខ្ញុំ',
                plInspector: 'សូម ជ្រើស ភារកិច្ច គំរូ',
                allInspector: 'មើល ទាំងអស់',
                seInspector: 'មើល បញ្ជា',
                myInspector: 'មើល តែ ម៉ាស៊ីន ភ្ញៀវ',
                noInspector: 'ពិនិត្យ មើល សំណុំ គំរូ ដែល មិន បាន គាំទ្រName',
                detail: {
                    title: 'សេចក្ដី លម្អិត គំរូ',
                },
            },
            reviewList: {
                title: 'បញ្ជី ឡើង វិញ',
                onlyMyTip: 'មើល តែ ការ ត្រួត ពិនិត្យ របស់ ខ្ញុំ',
                plInspector: 'សូម ជ្រើស កម្មវិធី ពិនិត្យ មួយ',
                allInspector: 'មើល ទាំងអស់',
                seInspector: 'មើល កម្មវិធី ពិនិត្យ មើល ដែល បាន កំណត់',
                myInspector: 'មើល តែ ម៉ាស៊ីន ភ្ញៀវ',
                noInspector: 'មើល កម្មវិធី មើល មិន បាន ផ្នែក ទេ',
                detail: {
                    title: 'សេចក្ដី លម្អិត ឡើង វិញ',
                },
            },
            caseBaseList: {
                title: 'បណ្ណាល័យ អក្សរ',
                del: 'លុប',
                delTitle: 'មាតិកា ទាំងអស់ នឹង មិន ត្រូវ បាន រក្សាទុក បន្ទាប់ ពី លុប',
                cancel: 'បោះបង់',
                actions: 'ប្រតិបត្តិការ',
                seeCaseBase: 'មើល អក្សរ',
                seeDetail: 'មើល សេចក្ដី លម្អិត',
                edit: 'កែសម្រួល',
                save: 'រក្សាទុក',
                addCaseBase: 'បណ្ណាល័យ ករណី ថ្មី',
                export: 'នាំចេញ',
                ok: 'កំណត់@ info: whatsthis',
                tip: 'ទិន្នន័យ ហៅ និង ព័ត៌មាន ធម្មតា នៅ ក្នុង បញ្ជី ត្រួត ពិនិត្យ គុណភាព អាច ត្រូវ បាន រក្សាទុក ទៅ បណ្ណាល័យ ករណី សម្រាប់ ការ សិក្សា និង ការ ចែករំលែក ងាយស្រួល ។',
                detail: {
                    choiceCaseBase: 'សូម ជ្រើស តួអក្សរ',
                    delCaseBase: 'លុប អក្សរ',
                    addCaseBase: 'បន្ថែម អក្សរ',
                    successed: 'រក្សាទុក ដោយ ជោគជ័យ',
                    info: 'សូម រក្សាទុក ឬ បោះបង់ មាតិកា ដែល អ្នក កំពុង កែសម្រួល',
                    caseType: 'សូម ជ្រើស បណ្ណាល័យ ករណី ដើម្បី ចូលរួម@ info: whatsthis',
                },
            },
            testSetList: {
                title: 'ការ សាកល្បង ការ ត្រួត ពិនិត្យ គុណភាព',
                tip: 'ទិន្នន័យ ដែល បាន គំរូ ដោយ អ្នក ត្រួត ពិនិត្យ គុណភាព នឹង ត្រូវ បាន រក្សាទុក នៅ ក្នុង សំណុំ ការ ពិនិត្យ គុណភាព ។ ដែល មាន ងាយស្រួល ដើម្បី ធ្វើ ឲ្យ ការ កំណត់ រចនា សម្ព័ន្ធ នៃ លក្ខខណ្ឌ ត្រួត ពិនិត្យ គុណភាព និង ច្បាប់ សម្រាប់ ធាតុ កំហុស ត្រួត ពិនិត្យ ម៉ាស៊ីន មួយ ចំនួន បាន ប្រៀបធៀប បន្ទាប់ ពី ត្រួតពិនិត្យ គំរូ ។',
                refresh: 'ធ្វើ ឲ្យ ស្រស់',
                reQualityInspectionUnderWay: 'តម្រូវការ ភារកិច្ច ឡើង វិញ...',
                reQualityInspectionUnderWayTip: 'ការ ទុក ទំព័រ បន្ទាប់ ពី បិទ បង្អួច មិន ប៉ះពាល់ ដល់ ភារកិច្ច',
                reQualityInspectionDone: 'បាន បញ្ចប់ ការ កំណត់ ឡើង វិញ',
                reQualityInspectionDoneTip: 'ការ ត្រួតពិនិត្យ ឡើង វិញ បាន បញ្ចប់ ដោយ ជោគជ័យ សូម ចុច ប៊ូតុង អះអាង',
                endReQualityInspection: 'បញ្ចប់ ភារកិច្ច',
                alreadyDoneTip: '{0} បាន បញ្ចប់',
                totalTip: '{0} សរុប',
                endReInspectionSuccess: 'បាន បញ្ចប់ ភារកិច្ច ការ កំណត់ ឡើង វិញ',
                closeWindow: 'បិទ បង្អួច',
                endReInspectionFailed: 'បាន បរាជ័យ ភារកិច្ច ការ តម្លៃ ឡើង វិញ សូម ព្យាយាម ម្ដង ទៀត ។',
                recheckPoint: 'គណនា ពិន្ទុ ចំណុច ត្រឹមត្រូវ',
                recheckPointTitle: 'ជម្រើស តម្លៃ ឡើង វិញ',
                delete: {
                    reQualityInspectionUnderWay: 'លុប ភារកិច្ច ...',
                    reQualityInspectionUnderWayTip: 'ការ ទុក ទំព័រ បន្ទាប់ ពី បិទ បង្អួច មិន ប៉ះពាល់ ដល់ ភារកិច្ច',
                    reQualityInspectionDone: 'លុប Batch ភារកិច្ច បាន បញ្ចប់',
                    reQualityInspectionDoneTip: 'ការ លុប ទម្រិត ត្រូវ បាន បញ្ចប់ ដោយ ជោគជ័យ សូម ចុច ប៊ូតុង អះអាង',
                    endReQualityInspection: 'បញ្ចប់ ភារកិច្ច',
                    alreadyDoneTip: '{0} បាន បញ្ចប់',
                    totalTip: '{0} សរុប',
                    endReInspectionSuccess: 'លុប ភារកិច្ច ថ្មី',
                    closeWindow: 'បិទ បង្អួច',
                    endReInspectionFailed: 'បាន បរាជ័យ ក្នុង ការ លុប ថត សូម ព្យាយាម ម្ដង ទៀត ។',
                },
                reultList: {
                    assessmentTime: 'ពេលវេលា វាយតម្លៃ ចុងក្រោយ',
                    assessmentAll: 'ការ ត្រួតពិនិត្យ សរុប',
                    strip: 'អត្ថបទ',
                    spot: 'ចំណុច',
                    deviation: 'ការ បិទ',
                    accuracyRate: 'ភាព ត្រឹមត្រូវ',
                    info: 'គ្មាន លទ្ធផល តម្លៃ សូម វាយតម្លៃ',
                    onlyDeviationInfo: 'មើល តែ ថត ការ ដោះស្រាយ ប៉ុណ្ណោះ',
                    againAssessment: 'ការ តម្លៃ ឡើងវិញ',
                    screen: 'តម្រង',
                    batchDelete: 'ចេញ',
                    matching: 'ផ្គូផ្គង',
                    ok: 'បាន',
                    noCancel: 'គ្មាន ទេ',
                },
            },
            smartWordsLibrary: {
                title: 'កម្រិត សំឡេង',
                tip1: 'សញ្ញា synonyms ៖ ប្រើ ដើម្បី បន្ថយ ចំនួន ការ បង្ហាត់ នៃ ស្លាក semantic ពាក្យ ស្រដៀង គ្នា ជា និច្ច',
                tip2: 'ចំណុច ប្រទាក់ មុន ឈ្មោះ លទ្ធផល និង ពាក្យ ចល័ត ដែល មិន ត្រូវ បាន ទទួល ស្គាល់ ដោយ ត្រឹមត្រូវ ដើម្បី បង្កើន ភាព ត្រឹមត្រូវ នៃ ការ ទទួល ស្គាល់ និង ភាព ត្រឹមត្រូវ ។',
                tip3: 'ផ្ដោត លើ ពាក្យ ៖ ផ្ដោត អារម្មណ៍ លើ ពាក្យ ដែល អ្នក ចង់ ផ្ដោត លើ ក្នុង ការ វិភាគ ពណ៌ ពពក ដើម្បី ជួយ AI ការ វិភាគ រយ hotspos',
                tip4: 'ទប់ស្កាត់ ពាក្យ ៖ ទប់ស្កាត់ ពាក្យ ដែល អ្នក មិន ចង់ ផ្ដល់ នូវ ការ វិភាគ ពណ៌ ព័ត៌មាន ដើម្បី ជួយ AI ឲ្យ វិភាគ រយ ក្នុង បន្ទាត់ ជាមួយ បច្ចុប្បន្ន ដំណើរការ ។',
                tip5: 'ពាក្យ ៖ ប្រើ ដើម្បី កែ និង ធ្វើ ឲ្យ ប្រសើរ ឡើង វិញ នៃ ស្លាក សំឡេង ។ ដោយ កែប្រែ ភាព ខ្ពស់ របស់ ពាក្យ នៅ ក្នុង ប្រយោជន៍ បែបផែន ការ ទទួល ស្គាល់ សញ្ញា ជា វិធី ដែល ជាក់លាក់ អាច ត្រូវ បាន ធ្វើ ឲ្យ ប្រសើរ ឡើង ។',
                tip6: 'ទិន្នន័យ Corpus ៖ បញ្ចូល ឧទាហរណ៍ អត្ថបទ ធំ សម្រាប់ វិធីសាស្ត្រ បច្ចុប្បន្ន',
                upload: {
                    uploadSynonymWords: 'នាំចូល synonyms',
                    uploadProfessionalWords: 'នាំចូល ពាក្យ វិនិច្ឆ័យ មួយ',
                    uploadAttentionWords: 'នាំចូល ពាក្យ សន្យារ',
                    uploadIgnoreWords: 'នាំចូល មិន អើពើ ពាក្យ',
                    uploadWordsWeight: 'នាំចូល ពាក្យ សម្ងាត់',
                    uploadTypo: 'នាំចូល ពាក្យ សំណុំ តួ អក្សរ',
                    uploadCorpusData: 'នាំចូល ទិន្នន័យ corpusName',
                    uploadCorpusContent: 'នាំចូល មាតិកា ទិន្នន័យ corpus',
                    firstUploadStep: '១ ទាញ យក ពុម្ព ហើយ បំពេញ វា តាម រយៈ ទ្រង់ទ្រាយ ពុម្ព',
                    downloadTemplateMessage: 'ទាញយក ពុម្ព ៖',
                    firstUploadJSONButton: 'JSON',
                    firstUploadExcelButton: 'EXCEl',
                    firstUploadTxtButton: 'TXT',
                    secondUploadStep: '2. ចុច ប៊ូតុង នាំចូល ដើម្បី ផ្ទុក ឡើង ឯកសារ EXCEl រចនា សម្ព័ន្ធ ទៅ ទ្រង់ទ្រាយ ពុម្ព',
                    secondUploadCorpusDataStep: '2. ចុច ប៊ូតុង នាំចូល ដើម្បី ផ្ទុក ឡើង ឯកសារ TXT ដែល ឆប តាម ទ្រង់ទ្រាយ ពុម្ព ។',
                    postUploadDataFail: 'បរាជ័យ ក្នុង ការ ដាក់ ស្នើ និង ផ្ទុក ទិន្នន័យ ឡើង ។',
                    pleaseUploadTemplate: 'សូម ផ្ទុក ឡើង ឯកសារ EXCEl/JSON/TXT',
                    templateNeedJSONOrXLSX: 'ពុម្ព ឯកសារ អាច មាន តែ ក្នុង ទ្រង់ទ្រាយ JSON ឬ xlsx',
                    templateNeedTxt: 'ពុម្ព ឯកសារ ទិន្នន័យ corpus អាច មាន តែ ឯកសារ TXT',
                    uploadSuccess: 'នាំចូល បាន ជោគជ័យ',
                    uploadFailed: 'នាំចូល បាន បរាជ័យ',
                    downloadError: 'ការ ទាញយក បាន បរាជ័យ',
                    downLoadTxtTitle: 'អ៊ីស្រាអែល ។ Txt',
                },
                navTabNames: {
                    synonymWords: 'Synonyms',
                    professionalWords: 'បណ្ដាញ',
                    attentionWords: 'ពាក្យ ដែល មាន ប្រយោជន៍',
                    ignoreWords: 'មិន អើពើ ពាក្យ',
                    wordsWeight: 'ពាក្យ',
                    corpusData: 'ទិន្នន័យ corpusName',
                    typoLibrary: 'កំណត់ ពាក្យ typo',
                },
                synonymWords: {
                    createSynonymWords: 'សញ្ញា ថ្មី',
                    editSynonymWords: 'កែសម្រួល វាក្យសម្ព័ន្ធ',
                    addSynonymWords: 'បន្ថែម សញ្ញា',
                    pleaseEnterStandardWords: 'សូម បញ្ចូល ពាក្យ ស្តង់ដារ',
                    synonymWordsExists: 'មាន សញ្ញា synonym រួច ហើយ មិន អាច ត្រូវ បាន បន្ថែម ទេ',
                    synonymWordsCanNotNull: 'បាន បន្ថែម វាក្យសម្ពន្ធ មិន អាច ទទេ',
                    pleaseAddSynonymWords: 'សូម បន្ថែម សញ្ញា សំណួរ',
                    addSuccess: 'ជោគជ័យ ថ្មី',
                    editSuccess: 'ការ កែប្រែ បាន ជោគជ័យ',
                    deleteSuccess: 'បាន លុប ដោយ ជោគជ័យ',
                    deleteError: 'បរាជ័យ លុប',
                    required: '*',
                },
                professionalWords: {
                    create: 'ពាក្យ ប្រភេទ ថ្មី',
                    edit: 'កម្មវិធី កែសម្រួល កម្រិត ពិសេស',
                    addTargetWords: 'បន្ថែម ពាក្យ ជំនួយ',
                    targetWordsExists: 'ពាក្យ ជំនួស មាន រួច ហើយ មិន អាច ត្រូវ បាន បន្ថែម ទេ',
                    targetWordsCanNotNull: 'ពាក្យ ជំនួស ដែល បាន បន្ថែម មិន អាច ទទេ',
                    pleaseAddTargetWords: 'សូម បន្ថែម ពាក្យ ជំនួស មួយ',
                    pleaseEnter: 'សូម បញ្ចូល ពាក្យ ប្រភេទ មួយ',
                    wordsExists: 'ពាក្យ មាន រួច ហើយ ។',
                    createSuccess: 'បាន បន្ថែម ដោយ ជោគជ័យ',
                    editSuccess: 'ការ កែប្រែ បាន ជោគជ័យ',
                    deleteSuccess: 'បាន លុប ដោយ ជោគជ័យ',
                    deleteError: 'បរាជ័យ លុប',
                    saveError: 'បាន បរាជ័យ ក្នុង ការ រក្សាទុក',
                    addTargetWordsMaxNumberError: 'អ្នក អាច បន្ថែម ពាក្យ ជំនួស ១០',
                    addHomophonyWordsMaxNumberError: 'អ្នក អាច បន្ថែម ពាក្យ របាំង ១០',
                },
                attentionWords: {
                    create: 'ពាក្យ ថ្មី',
                    edit: 'កម្មវិធី កែសម្រួល ពាក្យ ដែល មាន កិរិយាសព្ទ',
                    pleaseEnter: 'សូម បញ្ចូល ពាក្យ សន្យារ',
                    wordsExists: 'មាន ពាក្យ ទំនាក់ទំនង រួច ហើយ ។',
                    createSuccess: 'បាន បន្ថែម ដោយ ជោគជ័យ',
                    editSuccess: 'ការ កែប្រែ បាន ជោគជ័យ',
                    deleteSuccess: 'បាន លុប ដោយ ជោគជ័យ',
                    deleteError: 'បរាជ័យ លុប',
                },
                ignoreWords: {
                    create: 'មិន អើពើ ពាក្យ ថ្មី',
                    edit: 'មិន អើពើ ការ កែសម្រួល ពាក្យ',
                    pleaseEnter: 'សូម បញ្ចូល មិន អើពើ ពាក្យ',
                    wordsExists: 'មិន អើពើ ពាក្យ មាន រួចហើយ',
                    createSuccess: 'បាន បន្ថែម ដោយ ជោគជ័យ',
                    editSuccess: 'ការ កែប្រែ បាន ជោគជ័យ',
                    deleteSuccess: 'បាន លុប ដោយ ជោគជ័យ',
                    deleteError: 'បរាជ័យ លុប',
                },
                wordsWeight: {
                    createWordsWeight: 'ពាក្យ កម្លាំង ថ្មី',
                    editWordsWeight: 'កែសម្រួល ពាក្យ កម្ពស់',
                    addWordsWeight: 'បន្ថែម ពាក្យ កម្ពស់',
                    pleaseEnterWeightWords: 'សូម បញ្ចូល ពាក្យ វត្ថិភាព',
                    pleaseEnterWeight: 'សូម បញ្ចូល ពន្លឺ',
                    weightNeedInZeroToHundred: 'កម្ពស់ ត្រូវ តែ រវាង ០ និង ១០',
                    synonymWordsExists: 'ពាក្យ វង់ មាន រួចហើយ',
                    weightNeedNumber: 'សំឡេង ត្រូវការ ទ្រង់ទ្រាយ គំរូ',
                    standardWeightInformation: 'កម្រិត ពណ៌ សំណួរ គឺ ៥០ ហើយ កម្រិត ធំ ច្រើន ជាង ការ វិភាគ ច្រើន ។',
                    createSuccess: 'បាន បន្ថែម ដោយ ជោគជ័យ',
                    editSuccess: 'ការ កែប្រែ បាន ជោគជ័យ',
                    deleteSuccess: 'បាន លុប ដោយ ជោគជ័យ',
                    deleteError: 'បរាជ័យ លុប',
                },
                corpusData: {
                    createCorpusData: 'ទិន្នន័យ Corpus ថ្មី',
                    editCorpusData: 'កែសម្រួល ទិន្នន័យ Corpus',
                    addCorpusData: 'បន្ថែម ទិន្នន័យ Corpus',
                    pleaseEnterCorpusDescription: 'សូម បញ្ចូល សេចក្ដី ពិពណ៌នា corpus',
                    pleaseEnterCorpusContent: 'សូម បញ្ចូល មាតិកា របស់ corpusName',
                    synonymWordsExists: 'ទិន្នន័យ corpus នេះ មាន រួចហើយ',
                    CorpusContentWordsOverSetting: 'ចំនួន ពាក្យ នៅ ក្នុង មាតិកា លើស ពាក្យ ២០០០ ។',
                    download: 'ទាញយក',
                    upload: 'ផ្ទុក ឡើង លើ',
                    see: 'ទិដ្ឋភាព',
                    canNotSave: 'សូម ប្រើ អនុគមន៍ នាំចូល មិន ដូច្នេះ វា មិន អាច ត្រូវ បាន រក្សាទុក',
                    createSuccess: 'បាន បន្ថែម ដោយ ជោគជ័យ',
                    editSuccess: 'ការ កែប្រែ បាន ជោគជ័យ',
                    deleteSuccess: 'បាន លុប ដោយ ជោគជ័យ',
                    deleteError: 'បរាជ័យ លុប',
                    required: '*',
                },
                typoLibrary: {
                    fields: {
                        rightWord: 'ពាក្យ ត្រឹមត្រូវ',
                        wrongWord: 'ពាក្យ ខុស',
                        wrongWordCount: 'ចំនួន ពាក្យ ខុស',
                        wrongWordTip: 'ចុច បញ្ចូល ដើម្បី បន្ថែម@ info: whatsthis',
                        status: 'ភាព បែបផែន',
                    },
                    create: 'ការ កំណត់ ពាក្យ ប្រភេទ ថ្មី',
                    edit: 'កែសម្រួល វាយ ប្រព័ន្ធ',
                    tip: 'សំណុំ ពាក្យ typos ត្រូវ បាន ប្រើ ដើម្បី ធ្វើ ឲ្យ បែបផែន នៃ " ការ រក ឃើញ ប្រភេទ" ។ ឧទាហរណ៍ ប្រសិន បើ "refund" ត្រូវ បាន ផ្ញើ ដោយ មិន ត្រឹមត្រូវ ជា "ទឹង ដោះស្រាយ", typos ធម្មតា និង ពាក្យ ត្រឹមត្រូវ អាច កំណត់ តាម រយៈ អនុគមន៍ នេះ ។ ហើយ វា នឹង មាន ប្រសិទ្ធភាព ថ្ងៃ បន្ទាប់ ពី ការ រក្សាទុក ។',
                    onlyChinese: 'គាំទ្រ តែ ពាក្យ បញ្ចូល ចិន ប៉ុណ្ណោះ',
                    wrongWordLengthErr: 'ប្រវែង ពាក្យ ខុស នីមួយៗ គួរ តែ ជា 2 ~ 10 ពាក្យ',
                },
            },
            semanticTags: {
                title: 'ស្លាក semantic',
                current: 'ស្លាក សញ្ញា បច្ចុប្បន្ន',
                reference1: 'ភារកិច្ច ត្រួតពិនិត្យ គុណភាព ៖ {0} - {1}',
                reference2: 'ស្លាក ឆ្លាត ៖ {0}',
                reference3: 'ការ ដំណើរការ ទិន្នន័យ មុន ៖ {0}',
                reference4: 'មូលដ្ឋាន ស្គាល់ ៖ {0}',
                index: {
                    import: 'នាំចូល ស្លាក សំឡេង',
                },
                detail: {
                    new: 'ស្លាក ថ្មី',
                    edit: 'កែសម្រួល ស្លាក សញ្ញា',
                    name: 'ឈ្មោះ:',
                    standardSentences: 'ពាក្យ ស្តង់ដារ',
                    effectiveness: 'ភាព បែបផែន',
                    similarSentences: 'ប្រយោជន៍ ស្រដប់',
                    tip: 'ការ គាំទ្រ ដោយ ប្រើ# # ដើម្បី ហៅ API ឧទាហរណ៍ ៖ តើ លេខ ទូរស័ព្ទ ចល័ត របស់ អ្នក # sys_ ទូរស័ព្ទ ចល័ត ឬ ?',
                    excludeSimilarSentences: 'មិន រួម បញ្ចូល ពាក្យ ស្រដៀង គ្នាName',
                    intelligentRecommend: 'ផ្ដល់ អនុសាសន៍ មាតិកា ស្រដៀង គ្នាName',
                    fastTraining: 'ការ បង្ហាត់ រហ័ស ៖',
                    qualify: 'ធម្មតា',
                    recallKeyWord: 'ចងចាំ ពាក្យ គន្លឹះ',
                    excludeKeywords: 'បញ្ចូល ពាក្យ គន្លឹះ',
                    excludeKeywordsInfo1: 'មិន រួម បញ្ចូល ពាក្យ គន្លឹះ និង កន្សោម ធម្មតា ដែល មាន មុន លើ តក្កវិធី ទាំងអស់ ។ ប្រសិន បើ ពួក វា ត្រូវ បាន បដិសេធ ស្លាក semantic នឹង មិន ត្រូវ បាន ចុះ ទេ ។',
                    keyWordInfo1: 'ពាក្យ គន្លឹះ បញ្ចូល ច្រើន អាច ត្រូវ បាន បំពេញ ក្នុង បន្ទាត់ នីមួយៗ ដែល បំបែក ដោយ សញ្ញា អង់គ្លេស ។ នៅពេល ដែល ពាក្យ គន្លឹះ ហៅ ច្រើន ត្រូវ បាន បំពេញ តក្កវិធី គឺ ជា ការ ងារ ទាំងអស់ ត្រូវ បាន បាញ់ ។',
                    keyWordInfo2: 'ចងចាំ ពាក្យ គន្លឹះ អាច ត្រូវ បាន បំពេញ ក្នុង បន្ទាត់ ច្រើន ។ នៅ ពេល បន្ទាត់ ច្រើន ត្រូវ បាន បំពេញ តក្ក តក្ក ។',
                    recallRegular: 'ចងចាំ ធម្មតា',
                    excludeRegular: 'បដិសេធ ធម្មតា',
                    similaSentences: 'មិន រួម បញ្ចូល ពាក្យ ស្រដៀង គ្នាName',
                    simim: 'ស្រដៀង គ្នាName',
                    keyWordInfo3: 'ការ ដោះស្រាយ ពាក្យ ស្រដៀង នឹង មាន មុន លើ តក្ក ទាំងអស់ ។ ប្រសិនបើ ពាក្យ ស្រដៀង នឹង ត្រូវ បាន បាញ់ ស្លាក semantic នឹង មិន ត្រូវ បាន ចុះ ទេ ។ ភាព ស្រដៀង លំនាំដើម គឺ ៨០% និង ភាព ស្រដៀង គ្នា ច្រើន ជាង វា ស្រដៀង គ្នា ច្រើន ។',
                    keyWordInfo4: 'ច្បាប់ ស្រដៀង នឹង ធម្មតា ដែល មាន ចាប់ផ្ដើម និង បញ្ចប់ លំនាំដើម ។ មិន ចាំបាច់ ប្រើ ជាមួយ តួច ឧ. [មិនមែន XXXX]',
                    keyWordInfo5: 'អនុគមន៍ នៅ ក្នុង ម៉ូឌុល កម្រិត ខ្ពស់ ជា ធម្មតា មុខងារ ពិសេស សម្រាប់ អ្នក ភ្ញៀវ ដែល សម្គាល់ ប្រតិបត្តិការ ។ ប្រសិន បើ អ្នក មិន ប្រាកដ ថា តើ ប្រតិបត្តិការ ត្រូវ បាន ផ្ដល់ អនុសាសន៍ ថា អ្នក មិន ផ្លាស់ប្ដូរ ផ្នែក នេះ ទេ ។',
                    keyWordInfo6: 'លក្ខណៈ ពិសេស ការ រក ឃើញ ពាក្យ បញ្ជា ផ្ដល់ ឲ្យ ស្លាក semantic ដែល អាច រក ឃើញ ប្រយោជន៍ ។',
                    keyWordInfo7: 'នៅ ក្នុង តួនាទី ដូច គ្នា ជា ច្រើន បំផុត',
                    keyWordInfo8: 'មិនអើពើ អស់ ប្រវែង សំណួរ ផ្សេង គ្នា មិន ធំ ទេ',
                    keyWordInfo9: 'ប្រយោជន៍ នៃ ពាក្យ សម្រាប់ ការ រក ឃើញ សំណួរ',
                    keyWordInfo10: 'ប្រវែង កម្រិត ពាក្យ បញ្ជា',
                    keyWordInfo11: 'យក ភាគរយ ស្រដៀង គ្នា ចេញ',
                    keyWordInfo12: 'ភាព ស្រដៀង គ្នា មិន ទាប',
                    keyWordInfo13: '% នៃ ពាក្យ ស្រដៀង នឹង ត្រូវ បាន ផ្គូផ្គង ដូចគ្នា (ភាព ស្រដៀង លំនាំដើម ៨០%)',
                    keyWordInfo14: 'បំបែក ដូចគ្នា ផ្គូផ្គង ពាក្យ ដែល មាន មូលដ្ឋាន លើ ភាព ស្រដៀងគ្នា របស់ ពួក វា ។ វា ត្រូវ បាន ផ្ដល់ អនុសាសន៍ ដើម្បី យក ប្រយោជន៍ ដែល ស្រដៀង នឹង បង្កើន ភាព ល្អ បំផុត ។',
                    keyWord: 'ពាក្យ សោ',
                    entity: 'ធនធាតុ',
                    ruleField: 'ពាក្យ ទំនាក់ទំនង',
                    customRule: 'រចនា សម្ព័ន្ធ',
                    fanhua: 'សំណួរ ស្រដៀង គ្នាName',
                    test: 'សាកល្បង',
                    testOk: 'ការ សាកល្បង ចេញ',
                    senior: 'ការ កំណត់ កម្រិត ខ្ពស់',
                    seniorList: 'ការ រក ឃើញ សំណួរ',
                    up: 'អនុញ្ញាត',
                    down: 'បិទ',
                    ju: 'ប្រយោជន៍',
                    oneWord: 'ពាក្យ',
                    simimNo: 'ស្រដៀង គ្នា នឹង យក ពន្លឺ ចេញ',
                    seniorField: 'កម្រិត ពន្លឺ ស្រដៀង គ្នាName',
                    save: 'រក្សាទុក',
                    cancel: 'បោះបង់',
                    specialElements: 'ធាតុ ពិសេស',
                    logicRule: 'ច្បាប់ តក្ក',
                    every: 'ផ្គូផ្គង ច្រើន',
                    recallOk: 'ចុះ ពាក្យ ចង ៖',
                    recallNo: 'បាត់ ពាក្យ',
                    ruleOk: 'ហៅ ធម្មតា',
                    ruleNo: 'បាត់ ធម្មតា',
                    rularOk: 'គូរ បន្ទាត់',
                    rularNo: 'ច្បាប់ ដែល បាន បាត់Comment',
                    infoOk: 'ពាក្យ ស្តង់ដារ ឬ ប្រយោជន៍ ស្រដៀង គ្នា ៖',
                    infoNo: 'បាត់ ពង្រីក ស្តង់ដារ ឬ ពាក្យ ស្រដៀង គ្នាName',
                    fieldOk: 'គំនូរ ដើម្បី បិទ ពាក្យ ស្រដៀង គ្នា ៖',
                    fieldNo: 'បាន បាត់ ឲ្យ បដិសេធ ពាក្យ ស្រដៀង គ្នាName',
                    excludeRuleNo: 'អ៊ីនធាតុ',
                    excludeRuleOk: 'បាន ដោះស្រាយ ធម្មតា',
                    excludeKeywordNo: 'បាត់បង់ ពាក្យ គន្លឹះ',
                    excludeKeywordOk: 'ចេះ ពាក្យ គន្លឹះ',
                    update: 'ធ្វើ ឲ្យ ទាន់សម័យ បាន ជោគជ័យ',
                    fanhuaList: 'បាន ដាក់ ស្នើ ទៅ ផ្ទាំង ទូទៅ បញ្ជី ប្រយោជន៍ ស្រដៀង គ្នាName',
                    wordList: 'បញ្ជី បង្ហាត់ គឺ ទទេ ហើយ មិន អាច ត្រូវ បាន ដាក់ស្នើ ទៅ បញ្ជី ទូទៅ',
                    start: 'ចាប់ផ្ដើម',
                    end: 'បញ្ចប់',
                    keyWordInfo15: 'វាល ស្រដៀង គ្នា មាន នៅ ក្នុង បញ្ជី ទូទៅ ( ការ កំណត់ រចនា សម្ព័ន្ធ កម្រិត កម្រិត ខ្ពស់ នៃ កម្រិត បំបែក ស្រដៀង គ្នា)',
                    saveSuccess: 'រក្សាទុក ដោយ ជោគជ័យ',
                    errInfo: 'វាល មួយ ចំនួន មិន ត្រូវ បាន បំពេញ ឬ បំពេញ មិន ត្រឹមត្រូវ',
                },
                table: {
                    deepTraining: 'ការ បង្ហាត់ ជម្រៅ {0}',
                    fastTraining: 'ការ បង្ហាត់ រហ័ស',
                },
            },
            intelligentCollection: {
                title: 'ការ ទទួល ប្រយោជន៍',
                classification: 'បញ្ជី ក្រុម',
                new: 'សម្រាំង ថ្មី',
                table: {
                    name: 'ឈ្មោះ វាល',
                    props: 'គុណលក្ខណៈ របស់ ម៉ាស៊ីន ភ្ញៀវ',
                    type: 'ប្រភេទ វាល',
                    desc: 'សេចក្ដី ពិពណ៌នា វាល',
                },
                detail: {
                    isCustomerProps: 'រក្សាទុក ទៅ កាន់ គុណលក្ខណៈ របស់ ម៉ាស៊ីន ភ្ញៀវ',
                    customerPropsHelper: 'បន្ទាប់ ពី រក្សាទុក ព័ត៌មាន ដែល បាន ប្រមូល នឹង ត្រូវ បាន ធ្វើ ឲ្យ ទាន់ សម័យ ទៅកាន់ ព័ត៌មាន របស់ ម៉ាស៊ីន ភ្ញៀវ ។ ប្រសិន បើ អ្នក មិន រក្សាទុក វា នឹង មិន ធ្វើ ឲ្យ ទាន់សម័យ ទៅ ព័ត៌មាន របស់ ភ្ញៀវ',
                    name: 'ឈ្មោះ វាល',
                    type: 'ប្រភេទ វាល',
                    text: 'អត្ថបទ',
                    desc: 'សេចក្ដី ពិពណ៌នា វាល',
                    descPlaceHolder: 'ពិពណ៌នា ប្រើ របស់ វាល នេះ ដើម្បី ប្រមូល ព័ត៌មាន',
                    condition: 'លទ្ធផល',
                    logic: 'បន្ទាត់',
                    method: 'របៀប បង្កើន',
                    message: 'មាតិកា ព័ត៌មាន',
                    range: 'ជួរ ស្រង់ចេញ',
                    entity: 'ស្រង់ ធាតុ ចេញ',
                    base: 'ព័ត៌មាន មូលដ្ឋាន',
                    collect: 'ប្រមូល ព័ត៌មាន',
                },
            },
            intelligentTags: {
                title: 'ស្លាក ឆ្លាត',
                sessionLabelTitle: 'សម័យ',
                keyEventsTitle: 'ព្រឹត្តិការណ៍ សោ',
                customerLabelTitle: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
                addClassification: 'បង្កើត ថ្នាក់ ស្លាក ថ្មី',
                defaultCategoryName: 'ថ្នាក់ លំនាំដើម',
                index: {
                    createTag: 'ស្លាក ថ្មី',
                    createEvent: 'ព្រឹត្តិការណ៍ ថ្មី',
                    editTagClassification: 'កែសម្រួល ថ្នាក់ ស្លាក',
                    selectTagClassification: 'ជ្រើស ថ្នាក់ ស្លាក',
                    editTagGrounp: 'កែសម្រួល ការ ដាក់ ក្រុមComment',
                    callTimeError: 'ជួរ ពេលវេលា ចាប់ផ្ដើម ហៅ/ ការ និយាយ ដែល បាន ជ្រើស ជួរ ពេលវេលា ចាប់ផ្ដើម មិន អាច មាន ខែ មួយ (៣១ ថ្ងៃ)',
                    callRecordCountError: 'ចំនួន ថត គឺ ០ សូម ជ្រើស ពេលវេលា ហៅ/ វែកញែក ឡើង វិញ',
                    selectItmeCountError: 'សូម ជ្រើស ស្លាក ឆ្លាត ដែល អ្នក ចង់ អនុវត្ត ប្រតិបត្តិការ ត្រូ វ',
                    redoSuccess: 'ការ ប្រតិបត្តិ ឡើង វិញ គឺ ជោគជ័យ សូម ចូល ទៅ កាន់ មជ្ឈមណ្ឌល ភារកិច្ច ដើម្បី មើលName',
                    redoError: 'បាន បរាជ័យ ក្នុង ការ ប្រតិបត្តិ ឡើង វិញ សូម ព្យាយាម ម្ដង ទៀត ក្រោយ ឡើយ',
                    timeError: 'ពេលវេលា សំណួរ មិន អាច មាន ខែ មួយ (៣១ ថ្ងៃ)',
                    categoryName: 'ឈ្មោះ ប្រភេទ',
                    categoryColor: 'ពណ៌ កំណត់',
                    newTagClassification: 'ថ្នាក់ ស្លាក ថ្មី',
                    newEventClassification: 'ប្រភេទ ថ្មី',
                    tagClassification: 'ស្លាក ថ្នាក់Name',
                    eventClassification: 'កា រកំណត់ ព្រឹត្តិការណ៍',
                },
                detail: {
                    new: 'ស្លាក ថ្មី',
                    edit: 'កែសម្រួល ស្លាក ឆ្លាត',
                    tagName: 'ឈ្មោះ:',
                    tagDesc: 'សេចក្ដី ពិពណ៌នា',
                    category: 'ថត',
                    tagStatus: 'ភាព បែបផែន',
                    operator: 'កម្មវិធី',
                    rule: 'បន្ទាត់',
                    labelClassAtion: 'ប្រភេទ ស្លាក',
                    labelClassAtionTip1: 'ស្លាក បញ្ចូល ៖ labeling based on rules.',
                    labelClassAtionTip2: 'ថ្នាក់ ថ្នាក់ ៖',
                    group: 'ក្រុម',
                    checkLabel: 'ជ្រើស ប្រភេទ',
                    warn: 'ព្រមានComment',
                    warnTips: 'បន្ទាប់ ពី ការ ព្រមាន ត្រូវ បាន បើក នៅពេល សម័យ ជួប នឹង ច្បាប់ ព្រឹត្តិការណ៍ នេះ ។ មនុស្ស ដែល បាន រៀបចំ នឹង ត្រូវ បាន សួរ ហើយ អាច ទទួល កម្មវិធី រំលឹក នៅ បញ្ជី ការងារ ត្រូវ ធ្វើ ។',
                    warnError: 'សូម ជ្រើស ភារកិច្ច ដែល បាន បញ្ជាក់@ info: whatsthis',
                },
                subTitle: {
                    common: 'ស្លាក សម័យ ឆ្លាត',
                    wecom: 'ស្លាក មីក្រូ សិទ្ធិ',
                },
            },
            customerPortrait: {
                title: 'ច្រក ក្បៀស',
                index: {
                    import: 'នាំចូល ពាក្យ បញ្ជា',
                },
                searchPlaceHolder: 'លេខ សម្គាល់ អ្នក ប្ដូរ ឈ្មោះ ឬ ទូរស័ព្ទ',
                callCount: 'ចំនួន ព័ត៌មាន ៖',
                callDuration: 'ថិរវេលា ហៅ សរុប ៖',
                dialogCount: 'ចំនួន សរុប របស់ សរុប ៖',
                keyWordsStatistics: 'ស្ថិតិ ពាក្យ គន្លឹះ',
                keyWordsCount: '({0})',
                businessTag: 'ស្លាក ព័ត៌មាន',
                keyWordsCloudImg: 'ពាក្យ គន្លឹះ គំរូ ពពក',
                customerEmotionTrend: 'វិធីសាស្ត្រ របស់ អ្នក ភ្ជាប់',
                notFoundCustomer: 'មិន បាន ទៅ យក អ្នក ភ្ញៀវ ដែល ទាក់ទង',
                noKeyWords: 'រក មិន ឃើញ ពាក្យ គន្លឹះ ដែល ទាក់ទង',
                noBusinessTags: 'រក មិន ឃើញ ស្លាក បណ្ដាញ ដែល ទាក់ទង',
                getKeyWordsStatisticsDataError: 'បាន បរាជ័យ ក្នុង ការ សំណួរ ពាក្យ គន្លឹះ',
                getBusinessTagsStatisticsDataError: 'បាន បរាជ័យ ក្នុងកា រ ស្លាក បច្ចុប្បន្ន',
                personCustome: 'ព័ត៌មាន របស់ ម៉ាស៊ីន ភ្ញៀវ មិន បាន សួរ',
                notimeInfo: 'រក មិន ឃើញ ព័ត៌មាន សកម្មភាព ។',
                timeList: 'ជួរ កាលបរិច្ឆេទ',
                operator: 'ស្លាក ឆ្លាត',
                placeHolder: 'សូម ជ្រើស',
                placeOperator: 'សូម ជ្រើស ស្លាក ជម្រះ',
                search: 'សំណួរ',
                reset: 'កំណត់ ឡើង វិញ',
                searchHolder: 'ស្វែងរក',
                call: 'ហៅ',
                text: 'ប្រអប់Comment',
            },
            sentimentAnalysis: {
                title: 'ការ រក មើល សាធារណៈ',
            },
            saleSentimentAnalysis: {
                title: 'ការ វិភាគ កម្រិត សាធារណៈ',
            },
            dataPreprocess: {
                title: 'ដំណើរការ ទិន្នន័យ',
                index: {
                    createData: 'ទិន្នន័យ ថ្មី',
                    selectDataSource: 'ជ្រើស ប្រភព ទិន្នន័យ',
                    selectStatus: 'ជ្រើស ភាព បែបផែន',
                    callTimeError: 'ជួរ ពេលវេលា ចាប់ផ្ដើម ហៅ/ ការ និយាយ ដែល បាន ជ្រើស ជួរ ពេលវេលា ចាប់ផ្ដើម មិន អាច មាន ខែ មួយ (៣១ ថ្ងៃ)',
                    callRecordCountError: 'ចំនួន ថត គឺ ០ សូម ជ្រើស ពេលវេលា ហៅ/ វែកញែក ឡើង វិញ',
                    selectItmeCountError: 'សូម ជ្រើស ទិន្នន័យ ដើម្បី អនុវត្ត ប្រតិបត្តិការ ខ្សើរ',
                    redoSuccess: 'ការ ប្រតិបត្តិ ឡើង វិញ គឺ ជោគជ័យ សូម ចូល ទៅ កាន់ មជ្ឈមណ្ឌល ភារកិច្ច ដើម្បី មើលName',
                    redoError: 'បាន បរាជ័យ ក្នុង ការ ប្រតិបត្តិ ឡើង វិញ សូម ព្យាយាម ម្ដង ទៀត ក្រោយ ឡើយ',
                },
                detail: {
                    new: 'ទិន្នន័យ ថ្មី',
                    edit: 'កែសម្រួល ទិន្នន័យ',
                    name: 'ឈ្មោះ:',
                    desc: 'សេចក្ដី ពិពណ៌នា',
                    dataSource: 'ប្រភព ទិន្នន័យ',
                    status: 'ភាព បែបផែន',
                    entity: 'ស្រង់ ធាតុ ចេញ',
                    operator: 'កម្មវិធី',
                    rule: 'បន្ទាត់',
                },
            },
            connectedByConversation: {
                title: 'ទំនាក់ទំនង ទំនាក់ទំនង',
                list: {
                    title: 'អនុគមន៍ ទំនាក់ទំនង ប្រអប់ ទំនាក់ទំនង',
                    info: 'មុខងារ ទំនាក់ ទំនង ព័ត៌មាន អាច ភ្ជាប់ ការ ហៅ និង ពង្រីក ខុសគ្នា ដោយ យោង តាម ច្បាប់ ដែល បាន កំណត់ ។',
                    rule: 'ច្បាប់ ទំនាក់ទំនង ទំនាក់ទំនង',
                    source: 'សូម ជ្រើស ប្រភព ទិន្នន័យ',
                    classification: 'សូម ជ្រើស ប្រភេទ មួយ',
                    choose: 'សូម ជ្រើស',
                    input: 'សូម បញ្ចូល',
                    save: 'រក្សាទុក',
                    cancel: 'បោះបង់',
                    fieldwei: 'ប៊ីត',
                    fieldNot: 'មាន វាល ដែល មិន បាន បំពេញName',
                    fiedldlengthNo: 'ប្រវែង វាល លើក ដែន មុន',
                },
            },
            components: {
                operatorListGather: {
                    conditionTitle: 'CK',
                    keywordTip: 'ពាក្យ គន្លឹះ ច្រើន អាច ត្រូវ បាន បំបែក ដោយ សញ្ញា សម្ងាត់',
                    applyRole: 'រកឃើញ រលា',
                    preOperator: 'មុន កម្មវិធី អនុវត្តComment',
                    applyOperatorScope: 'ជួរ រកឃើញ@ info: whatsthis',
                    addOperator: 'បន្ថែម ប្រតិទិន',
                    noPreOperator: 'គ្មាន ទេ',
                    from: 'ភាគComment',
                    to: 'ប្រយោជន៍ ទៅ លេខ.',
                    end: 'ប្រយោជន៍',
                    testRegular: 'សាកល្បង កន្សោម ធម្មតា',
                    test: 'សាកល្បង',
                    matchSuccess: 'ផ្គូផ្គង ដោយ ជោគជ័យ',
                    matchError: 'ការ ផ្គូផ្គង បាន បរាជ័យ',
                    querySementicTags: 'ជ្រើស ស្លាក សំឡេង',
                    reQuerySementicTags: 'ជ្រើស ស្លាក semantic',
                    sementicTag: 'ស្លាក semantic',
                    standardSentence: 'ពាក្យ ស្តង់ដារ',
                    similarity: 'ស្រដៀង គ្នាName',
                    actions: 'ប្រតិបត្តិការ',
                    noFitTag: 'មិន បាន រក ស្លាក ត្រឹមត្រូវ ឡើយ ។',
                    addSemanticTag: 'បន្ថែម ស្លាក semantic ថ្មី',
                    pleaseEnterRegular: 'សូម បញ្ចូល កន្សោម ធម្មតា',
                    pleaseEnterRegularText: 'សូម បញ្ចូល មាតិកា ដែល ត្រូវ ផ្ទៀងផ្ទាត់',
                    newAssociateComponentTip: 'ប្រសិន បើ តម្លៃ ជា ប្រភេទ លេខ ប្រើ លក្ខណៈ ពិសេស ចាស់ៗ',
                },
                filterManage: {
                    noValueTip: 'គ្មាន ទិន្នន័យ',
                    allCall: 'ការ ហៅ ទាំងអស់',
                    allDialogue: 'ប្រអប់ ទាំងអស់',
                    allWechat: 'សម័យ ទាំងអស់',
                    getFiltersListFailed: 'បាន បរាជ័យ ក្នុង ការ យក បញ្ជី តម្រង សូម ព្យាយាម ម្ដង ទៀត ។',
                    getFilterDetailFailed: 'បាន បរាជ័យ ក្នុង ការ យក សេចក្ដី លម្អិត តម្រង សូម ព្យាយាម ម្ដង ទៀត ។',
                    getAllCountFailed: 'បាន បរាជ័យ ក្នុង ការ ទទួល ចំនួន ហៅ/ វែកញែក សរុប សូម ព្យាយាម ម្ដង ទៀត ពេល ក្រោយ !',
                },
                listManage: {
                    searchPlaceHolder: 'សូម បញ្ចូល ការ ស្វែងរក ពាក្យ គន្លឹះ',
                    filterConditions: 'លក្ខខណ្ឌ តម្រង',
                    records: 'ថត',
                    getRecordsFailed: 'បាន បរាជ័យ ក្នុង ការ យក ថត សូម ព្យាយាម ម្ដង ទៀត ។',
                },
                miniListManage: {
                    getRecordsFailed: 'បាន បរាជ័យ ក្នុង ការ យក ថត សូម ព្យាយាម ម្ដង ទៀត ។',
                },
                applyTemplates: {
                    title: 'ពុម្ព ត្រួត ពិនិត្យ គុណភាព ខ្ពស់',
                    collectionTitle: 'ពុម្ព ការ ទទួល យក ដែល អាច អនុវត្ត បានName',
                },
                recordDetail: {
                    showWaveAudio: 'បង្ហាញ ថត',
                    getDetailFailed: 'បាន បរាជ័យ ក្នុង ការ ទទួល លម្អិត សូម ព្យាយាម ម្ដង ទៀត ។',
                    getSmartTagsFailed: 'បាន បរាជ័យ ក្នុង ការ យក ស្លាក ជោគជ័យ សូម ព្យាយាម ម្ដង ទៀត ។',
                    getTemplatesFailed: 'បាន បរាជ័យ ក្នុង ការ យក ពុម្ព អនុវត្ត សូម ព្យាយាម ម្ដង ទៀត ។',
                },
                changeList: {
                    sampleStatus: 'ស្ថានភាព គំរូ',
                    sampleAssignInspector: 'ផ្ដល់ អ្នក ត្រួតពិនិត្យ គំរូ',
                    reviewAssignInspector: 'ផ្ដល់ កម្មវិធី ត្រួត ពិនិត្យComment',
                    read: 'អាន',
                    distributivePerson: 'អ្នក ដែល បាន បិទ',
                    totalScore: 'ពិន្ទុ សរុប',
                },
                qualityCheckScore: {
                    totalScore: 'ពិន្ទុ សរុប',
                    actualScore: 'ពិន្ទុ',
                    actualGrade: 'ការ វាយតម្លៃ',
                    appeal: 'ជម្រះ',
                    remark: 'ពាក្យ បញ្ជា',
                    manualRemark: 'ការ ព្យាយាម ដោយដៃ',
                    none: 'គ្មាន ទិន្នន័យ លម្អិត សម្រាប់ ការ ត្រួត ពិនិត្យ គុណភាព',
                    interactiveTip: 'ប្រើ ការ ទទួល ស្គាល់ អន្តរកម្ម ដើម្បី រក ឃើញ ការ ប្រើប្រាស់ របស់ FAQ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    interactiveIsEmptyTip: 'មិន បាន រក ឃើញ មាតិកា ការ ស្គាល់ អន្តរសកម្ម',
                },
                semanticMark: {
                    semanticContent: 'ការ សម្គាល់ ពាក្យ សម្ងាត់',
                    markedSimilarTitel: 'ស្លាក សញ្ញា ស្រដៀង គ្នាName',
                    markedExcludeTitle: 'បាន សម្គាល់ ដើម្បី បិទ ស្លាក សញ្ញា ស្រដៀង គ្នាName',
                    taskTagTitle: 'ស្លាក ដែល ទាក់ទង នឹង ភារកិច្ច',
                    similarTagTitle: 'បញ្ជាក់ ស្លាក semantic ស្រដៀង គ្នា (គំរូ> ៤០ កំពូល ២០)',
                    delete: 'លុប',
                    markSimilar: 'សម្គាល់ ស្រដប់',
                    markExclude: 'មិន រួម បញ្ចូល ស្រដៀង គ្នាName',
                    none: 'គ្មាន ទេ',
                },
                selectCallTime: {
                    callTime: 'ពេលវេលា ចាប់ផ្ដើម និយាយ/ ពេលវេលា សម័យ',
                    callTimeRemind: 'អ្នក អាច ជ្រើស ជា មួយ ខែ ៣១ ថ្ងៃ ) នៃ ការ ថត សួរ ខ្លួន ក្នុង ឆ្នាំ ចុង ក្រោយ ។',
                    callRecordCount: 'អ្នក បាន ជ្រើស សរុប នៃ ថត ហៅ/ វែកញែក សរុប {0}',
                    getCallRecordError: 'បាន បរាជ័យ ក្នុង ការ យក ថត សូម ព្យាយាម ម្ដង ទៀត ក្រោយ@ info: whatsthis',
                },
            },
            informationEntities: {
                title: 'ធាតុ ព័ត៌មាន',
                index: {
                    import: 'នាំចូល ធាតុ ព័ត៌មាន',
                },
                detail: {
                    new: 'ធាតុ ព័ត៌មាន ថ្មី',
                    edit: 'កែសម្រួល ធាតុ ព័ត៌មាន',
                    name: 'ឈ្មោះ:',
                    apiName: 'ឈ្មោះ API',
                    activeFlag: 'ភាព បែបផែន',
                    remark: 'សេចក្ដី ពិពណ៌នា',
                    logicExp: 'ធនធាន ធម្មតា',
                    sentenceList: 'មាតិកា ទំនាក់ទំនង',
                    tip: 'មាតិកា ធាតុ គាំទ្រ ធាតុ ច្រើន ដែល បាន បំបែក ដោយ ចន្លោះ ដែល ជា និច្ច នៃ ធាតុ ដូចគ្នា ។',
                    remarkLengthError: 'ប្រវែង សេចក្ដី ពិពណ៌នា មិន អាច លើក ភាព 255 បាន ឡើយ',
                    nameLengthError: 'ប្រវែង ឈ្មោះ មិន អាច លើក ៤០ ទេ',
                    entityDuplicateError: 'ស្ទេ',
                },
            },
            interactiveRecognition: {
                title: 'ការ ទទួល ស្គាល់ អន្តរសកម្ម',
                classify: 'ថត',
                addClassify: 'បន្ថែម ប្រភេទ',
                editClassify: 'កែសម្រួល ប្រភេទ',
                index: {
                    import: 'នាំចូល ការ ទទួល យក ទំនាក់ទំនង',
                },
                detail: {
                    new: 'អន្តរកម្ម ថ្មី',
                    edit: 'កែសម្រួល អន្តរកម្ម ឆ្លាត',
                    type: 'ប្រភេទ@ info: whatsthis',
                    standardQuestion: 'បញ្ហា ស្តង់ដារ',
                    similarQList: 'បញ្ហា ស្រដប់',
                    exceptSimilarQList: 'បញ្ហា បញ្ហា ស្រដៀង គ្នាName',
                    category: 'ថត',
                    targetType: 'គោលដៅ រក បញ្ហា',
                    status: 'ភាព បែបផែន',
                    standardAnswer: 'ចម្លើយ ស្តង់ដារ',
                    similarAList: 'ចម្លើយ ស្រដៀង គ្នាName',
                    wrongAList: 'ចម្លើយ ខុស',
                },
            },
            businessAnalysis: {
                title: 'ការ វិភាគ បិទ',
                tip1: 'ការ វិភាគ វិភាគ បណ្ដាញ ៖ កូអរដោនេ បញ្ឈរ គឺ ជា ចំនួន ការ និយាយ I ។ E. ចំនួន សរុប នៃ ការងារ ដែល ទាក់ទង នឹង លក្ខខណ្ឌ និង កូអរដោនេ ផ្ដេក គឺ ជា ពេលវេលា ។',
                tip2: 'ការ វិភាគ កម្រិត ៖ វិភាគ ការ តភ្ជាប់ របស់ ហត្ថលេខា ច្រើន ទិន្នន័យ ការ ផ្អាក កណ្ដុរ កម្រិត កម្រិត ទិន្នន័យ ទាក់ទង អត្រា ការ ធ្វើ ឡើងវិញ',
                tip3: 'ការ វិភាគ បម្លែង ៖ ការ វិភាគ នៃ អ្នក ចង្អុល ច្រើន អាច បង្កើត ទំនាក់ទំនង បម្លែង គ្នា លក្ខខណ្ឌ ការ បម្លែង សម្រាប់ ការ ហៅ/ ជុំ គ្នា ដូចគ្នា ។ ប្រសិនបើ អ្នក អាច បញ្ចូល ទ្រនិច ផ្សេង ពីរ អ្នក អាច គិត ថា អ្នក បង្ហាញ ពីរ មាន ទំនាក់ទំនង បម្លែង ។',
            },
            knowledgeBase: {
                title: 'មូលដ្ឋាន សិទ្ធិ',
                list: {
                    add: 'បន្ថែម ប្រភេទ រង',
                    delete: 'លុប កំណត់',
                    categoryName: 'ឈ្មោះ ប្រភេទ',
                    createSuccess: 'បាន បង្កើត ប្រភេទ រង ដោយ ជោគជ័យ',
                    keyWord: 'ពាក្យ សោ',
                },
                detail: {
                    type: 'ប្រភេទ@ info: whatsthis',
                    status: 'ស្ថានភាព',
                    classification: 'ថត',
                    standardQuestion: 'បញ្ហា ស្តង់ដារ',
                    answerDetectionRange: 'ជួរ ការ រកឃើញ ចម្លើយ',
                    standardAnswer: 'ចម្លើយ ស្តង់ដារ',
                },
            },
            callManage: {
                title: 'តម្រង ថត ហៅ',
                listTitle: 'គ្រប់គ្រង ហៅ',
                detailTitle: 'សេចក្ដី លម្អិត',
            },
            dialogueManage: {
                title: 'តម្រង អត្ថបទ',
                listTitle: 'ប្រអប់ គ្រប់គ្រងComment',
                detailTitle: 'ប្រអប់ លម្អិត',
            },
            weChatManage: {
                title: 'តម្រង សម័យ Enterprise WeChat',
                listTitle: 'គ្រប់គ្រង សម័យ Enterprise WeChat',
                detailTitle: 'សេចក្ដី លម្អិត សម័យ បណ្ដាញ',
            },
            speechRecognition: {
                title: 'ការ ទទួល ស្គាល់ និយាយComment',
                asr: 'ការ ទទួល ស្គាល់ និយាយComment',
                asrRemind: 'បិទ ប្ដូរ នេះ នឹង ធ្វើ ឲ្យ មុខងារ សំឡេង ទៅ អត្ថបទ និង មុខងារ ត្រួត ពិនិត្យ គុណភាព ម៉ាស៊ីន ត្រូវ បាន បិទ ។',
                asrConfig: 'ត្រង ASR',
                imAsrConfig: 'IMASR',
                imAsrConfigRemind: 'នៅពេល បាន អនុញ្ញាត ASR ការ បម្លែង របស់ IM ត្រូវ បាន អនុវត្តName',
                asrConfigRemind: 'នៅពេល បាន អនុញ្ញាត តែ ការ ហៅ អាច ប្រតិបត្តិ មាតិកា ASR',
                correction: 'កែ កំហុស ដែល ត្រឹមត្រូវName',
                correctionRemind: 'នៅពេល បាន អនុញ្ញាត មាតិកា ក្នុង "<a href = \'/site/semantic-intelligence/smart-words-library/professional-words គោលដៅ = \'_blank\'> Thesaurus-Professional Nouns </a>" នឹង ត្រូវ បាន ប្រើ ដើម្បី បង្ខំ ការ កែ កំហុស',
                correctionConfig: 'តម្រង កែ កំហុស',
                advancedSettings: 'ការ កំណត់ កម្រិត ខ្ពស់',
                advancedSettingsTip: 'ជ្រើស ម៉ូដែល ASR ដែល បាន បញ្ជាក់ សម្រាប់ ទិន្នន័យ ដែល បាន បញ្ជាក់ ។',
                mandarinASRModel: 'ម៉ង់ដាំ ASR',
                cantoneseASRModel: 'ម៉ូឌុល ASR',
                englishASRModel: 'ម៉ូដែល ASR អង់គ្លេស',
                correctionConfigRemind: 'នៅពេល ដែល បាន អនុញ្ញាត តែ ការ ហៅ ដែល ធ្វើ ឲ្យ លក្ខខណ្ឌ ខាងក្រោម នឹង ត្រូវ បាន កែសម្រួល',
                customJudgeLogicIsNull: 'មិន អាច ទទេ',
                redoCorrection: 'កែប្រែ កំហុស ឡើង វិញ',
                callTime: 'ជ្រើស ពេលវេលា និយាយComment',
                callTimeRemind: 'អ្នក អាច ជ្រើស ថត ហៅ ហៅ រហូត ដល់ មួយ ខែ ៣១ ថ្ងៃ ) ក្នុង ឆ្នាំ ចុងក្រោយ ។',
                callRecordCount: 'អ្នក បាន ជ្រើស សរុប នៃ ការ ហៅ {0}',
                redoCorrectionSubmit: 'ដាក់ ស្នើ សម្រាប់ ប្រតិបត្តិ',
                callTimeError: 'ជួរ ពេលវេលា ហៅ ដែល បាន ជ្រើស មិន អាច លើស មួយ ខែ (៣១ ថ្ងៃ)',
                callRecordCountError: 'ចំនួន ថត ហៅ គឺ ០ សូម ជ្រើស ពេលវេលា ហៅ ឡើង វិញ',
                redoCorrectionSuccess: 'ការ កែ កំហុស ឡើង វិញ ត្រូវ បាន ជោគជ័យ សូម ទៅ កាន់ មជ្ឈមណ្ឌល ភារកិច្ច ដើម្បី មើលName',
                redoCorrectionError: 'កំហុស ឡើងវិញ បាន បរាជ័យ សូម ព្យាយាម ម្ដង ទៀត ពេល ក្រោយ@ info: whatsthis',
            },
            role: {
                title: 'គ្រប់គ្រង រលូន',
                create: 'ភាព ថ្មី',
                detail: {
                    title: 'រលូន',
                    new: 'ភាព ថ្មី',
                    view: 'មើល ជួរ',
                    edit: 'កែសម្រួល រលា',
                    navTabNames: {
                        basicInfo: 'សិទ្ធិ ម៉ឺនុយ',
                        taskPermissions: 'សិទ្ធិ ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព',
                        dataPermissions: 'សិទ្ធិ ទិន្នន័យ',
                    },
                    basicInfo: {
                        roleName: 'ឈ្មោះ:',
                        permissions: 'សិទ្ធិ',
                    },
                    taskPermissions: {
                        allTask: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ទាំងអស់',
                        myCreatedTask: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ដែល ខ្ញុំ បាន បង្កើតName',
                    },
                    dataPermissions: {
                        dataPermissionsConfig: 'ការ កំណត់ រចនាសម្ព័ន្ធ សិទ្ធិ ទិន្នន័យ',
                        tips: 'តួនាទី នេះ អាច មើល ទិន្នន័យ ក្រោម កា រកំណត់ ដែល បាន ជ្រើស',
                        select: 'ជ្រើស ប្រភេទ',
                        selectPlaceholder: 'សូម ជ្រើស ទិន្នន័យ ដែល ត្រូវការ សិទ្ធិ ភាព មើល ឃើញ ទិន្នន័យ',
                    },
                },
            },
            dataMigration: {
                title: 'ការ ប្ដូរ ទិន្នន័យ',
                dataUpload: 'ការ ប្ដូរ ទិន្នន័យ',
                dataDowload: 'ការ ប្ដូរ ទិន្នន័យ',
                error: 'សូម ជ្រើស ភារកិច្ច គុណភាព ដែល ត្រូវ នាំចេញ',
                list: {
                    info: 'សូម ជ្រើស ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព ដែល ត្រូវ ផ្លាស់ទី ចេញName',
                    listInfo: 'សូម ជ្រើស ថាតើ ត្រូវ ផ្លាស់ប្ដូរ ទិន្នន័យ ដែល ទាក់ទង នឹង ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ( ដូចជា thesaurus ដែល មាន ប្រយោជន៍ ស្លាក semantic ធាតុ ព័ត៌មាន អភិវឌ្ឍន៍ ខ្លាំង ។)',
                    noInfo: 'សូម ជ្រើស ថា តើ ត្រូវ ផ្លាស់ទី ចេញ ទិន្នន័យ មិនមែន ជា QC ផ្សេងទៀត',
                    ownInfo: 'ផ្លាស់ទី តែ ភារកិច្ច',
                    everyInfo: 'ផ្លាស់ទី ភារកិច្ច ដែល ទាក់ទង',
                    allInfo: 'ផ្លាស់ទី ចេញ ទាំងអស់',
                    callFilter: 'តម្រង ហៅ',
                    talkFilter: 'ប្រអប់ តម្រង',
                    smartTag: 'ស្លាក ឆ្លាត',
                },
                upload: {
                    info: '១ ចុច ប៊ូតុង ផ្ទុក ឡើង ដើម្បី ផ្ទុក ឯកសារ JSON ឡើង ដែល ឆប តាម ទ្រង់ទ្រាយ ។',
                    uploadSuccess: 'ផ្ទុក ឡើង ជោគជ័យ',
                    uploadError: 'បាន បរាជ័យ ក្នុងកា រផ្ទុក ឡើយ',
                },
            },
            dataAnalysis: {
                businessStatistics: 'ស្ថិតិ បណ្ដាញ',
                qualityEffect: 'ការ ត្រួត ពិនិត្យ គុណភាព',
                qualityAnalysis: 'ការ វិភាគ ត្រួត ពិនិត្យ គុណភាព',
                generalInspecitionReport: 'របាយការណ៍ ទូទៅ',
                fullAmountWork: 'ការងារ របស់ អ្នក ត្រួត ពិនិត្យ គុណភាពName',
                intelligentTagsAnalysis: 'វិភាគ ស្លាក',
                saleIntelligentTagsAnalysis: 'ការ វិភាគ ស្លាក ឆ្លាត',
                generalInspecitionReportTip: 'ទិន្នន័យ សរុប ៖ ចំនួន សរុប របស់ ហៅ និង ទិន្នន័យ សរុប ក្នុង ដែន កំណត់ ពេលវេលា និង ជួរ ភារកិច្ច បច្ចុប្បន្ន ។ រួម បញ្ចូល ចំនួន ភាគរយ នៃ ទិន្នន័យ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ ចំនួន ភាគរយ នៃ ទិន្នន័យ គំរូ ដោយ ដៃ ចំនួន ការ សិទ្ធិ អត្រា គំរូ និង គំនូសតាង ពេលវេលា ។',
                groupTest: 'សាកល្បង ក្រុម',
            },
            uploadDownloadList: {
                title: 'មជ្ឈមណ្ឌល ភារកិច្ច',
                tabs: {
                    upload: 'ផ្ទុក នាំចូល',
                    download: 'ទាញយក នាំចេញ',
                    taskCenter: 'ការ ប្រតិបត្តិ ភារកិច្ច',
                },
            },
            uploadDownloadModel: {
                title: 'ផ្ទុក ឡើង និង ទាញយក',
                list: {
                    clear: 'ទទេ',
                    success: 'ជោគជ័យ',
                    fail: 'បាន បរាជ័យ',
                    hand: 'កំពុង វឌ្ឍន៍',
                    noInfo: 'គ្មាន ទិន្នន័យ',
                },
            },
            financeCenter: {
                title: 'ការគ្រប់គ្រងហិរញ្ញវត្ថុ',
                unavailable: 'ប្រព័ន្ធវិក្កយបត្រមិនត្រូវបានកំណត់នៅក្នុងបរិស្ថានបច្ចុប្បន្នទេ',
                loadError: 'ការផ្ទុកប្រព័ន្ធវិក្កយបត្របានបរាជ័យ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។',
            },
            billingCenter: {
                title: 'ចំណុច ចំណុច',
                export: 'នាំចេញ',
                limit: 'ដែន កំណត់ កម្មវិធី រំលឹក',
                tips: 'លទ្ធផល ប៊ូតុង នឹង ត្រូវ បាន ដោះស្រាយ ដោយ សារ កម្រិត សម្រាប់ តែ យោង ប៉ុណ្ណោះ',
                dashboard: {
                    remainingQuota: 'កូតា បច្ចុប្បន្ន',
                    usedQuota: 'កូតា ដែល បានប្រើ',
                    voiceQuality: 'ការ ត្រួត ពិនិត្យ គុណភាព សំឡេង ៖',
                    voice: 'សំឡេង ៖',
                    textQuality: 'ការ ត្រួតពិនិត្យ គុណភាព អត្ថបទ ៖',
                    text: 'អត្ថបទ ៖',
                    hour: 'ម៉ោង',
                    tenThousandHour: 'ម៉ោង ។',
                    day: 'ថ្ងៃStencils',
                    cutoff: 'គូប',
                    warning: '(កូតា ដែល នៅ សល់ មិន គ្រប់គ្រាន់ សូម ធ្វើ ឡើង វិញ រហ័ស ដែល អាច ធ្វើ បាន)',
                    isClosed: '( ស្ថានភាព បិទ)',
                },
                table: {
                    quotaRecord: 'កម្រិត សំឡេង',
                    timeFilter: 'ជ្រើស កាលបរិច្ឆេទ ៖',
                    search: 'សំណួរ',
                    reset: 'កំណត់ ឡើង វិញ',
                    id: 'លេខ សៀរៀល',
                    type: 'ប្រភេទ@ info: whatsthis',
                    qualityType: 'ប្រភេទ ត្រួត ពិនិត្យ គុណភាព',
                    quotaChange: 'ផ្លាស់ប្ដូរ',
                    surplus: 'តុល្យា',
                    changeTime: 'ពេលវេលា',
                    voiceQuality: 'ការ ត្រួត ពិនិត្យ គុណភាព សំឡេង',
                    textQuality: 'ការ ត្រួត ពិនិត្យ គុណភាព អត្ថបទ',
                    sizeChangeText: 'បង្ហាញ ក្នុង ទំព័រ',
                    used: 'ប្រើ@ info: whatsthis',
                    give: 'ពាក្យ បញ្ជា',
                    deduction: 'ដាច់',
                    callTime: 'ពេលវេលា និយាយComment',
                    count: 'កំពុង ដំណើរការ កម្រិត សំឡេង ទិន្នន័យ',
                    page: 'ទំព័រ {1} នៃ {0}',
                },
                limitModal: {
                    call: 'ការ ត្រួត ពិនិត្យ គុណភាព សំឡេង គឺ ទាប',
                    callFix: 'ម៉ោង ត្រូវ រំលឹក',
                    dialogue: 'ពេលវេលា ដែល នៅ សល់ នៃ ការ ត្រួត ពិនិត្យ គុណភាព អត្ថបទ គឺ តិច',
                    dialogueFix: 'ថ្ងៃ ត្រូវ រំលឹក',
                },
            },
            messageCenter: {
                replyTitle: 'ឆ្លើយតប ទៅ ខ្លួន',
                answerTitle: '@ Name',
                shareTitle: 'ចែករំលែក សំណូ ។',
            },
            columnsManage: {
                title: 'គ្រប់គ្រង វាល ត្រួត ពិនិត្យ គុណភាព',
            },
            recordUpload: {
                list: {
                    task: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                    user: 'កម្មវិធី',
                    uploadTime: 'ពេលវេលា ផ្ទុក ឡើង',
                    endTime: 'ពេលវេលា បញ្ចប់',
                    total: 'ផ្ទុក ឡើង សរុប',
                    success: 'ការ ត្រួត ពិនិត្យ គុណភាព ជោគជ័យ',
                    failed: 'បាន បរាជ័យ ក្នុង ការ ត្រួត ពិនិត្យ គុណភាព',
                    progress: 'វឌ្ឍនភាព ត្រួតពិនិត្យ គុណភាព',
                    inProgress: 'កំពុង វឌ្ឍន៍',
                    finished: 'បាន បញ្ចប់',
                },
                steps: {
                    uploading: 'ផ្ទុក ឯកសារ ថត ឡើង លើ',
                    baseInfo: 'បំពេញ ព័ត៌មាន មូលដ្ឋាន',
                    start: 'ចាប់ផ្ដើម ការ ត្រួត ពិនិត្យ គុណភាព',
                },
                uploadComponent: {
                    dragger: 'អូស និង ទម្លាក់ ដើម្បី បន្ថែម ឯកសារ',
                    or: 'ឬ ថត',
                    selectFile: 'ជ្រើស ឯកសារ',
                    des: 'គាំទ្រ wav, ទ្រង់ទ្រាយ mp3, អត្រា គំរូ របស់ ឯកសារ 8000 Hz, 16. ប៊ីត',
                    limit1: 'ផ្ទុក ឡើង វិញ',
                    limit2: 'ឯកសារ ទំហំ ឯកសារ នីមួយៗ មិន លើក',
                    uploading: 'កំពុង ផ្ទុក ឡើង លើ',
                    finished: 'ផ្ទុក ឡើង បញ្ចប់@ info: whatsthis',
                    success: 'ជោគជ័យ',
                    failure: 'បាន បរាជ័យ',
                },
                baseInfo: {
                    task: 'ជ្រើស ភារកិច្ច គុណភាព',
                    type: 'ជ្រើស សំណុំ ថត',
                    agentSide: 'ឆានែល ដែល មាន សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    excel: 'ផ្ទុក ទិន្នន័យ ឡើង',
                    checkFileInfo: 'ផ្ទៀងផ្ទាត់ ព័ត៌មាន ឯកសារ',
                    excelFileError: 'សូម ផ្ទុក ទិន្នន័យ ឡើង វិញ',
                    checking: 'ការ ក្រិត ខាង ក្នុង ... @ info: whatsthis',
                    reCheck: 'ការ មាត្រដ្ឋាន ឡើង វិញ',
                    success: 'ជោគជ័យ ផ្ទៀងផ្ទាត់',
                    excelUoloadFail: 'បាន បរាជ័យ ក្នុង ការ ផ្ទុក ទិន្នន័យ ឡើង តាម ផ្លូវ ។',
                    tips: {
                        tip1: '1. ឈ្មោះ របស់ ឯកសារ ថត ក្នុង ecxel ត្រូវ តែ ដូច ឈ្មោះ របស់ ការ ថត ដែល បាន ផ្ទុក ឡើង ហើយ មិន អាច ជា ឈ្មោះ ដូចគ្នា ។',
                        tip2: '2. ប្រព័ន្ធ ពិនិត្យ មើល ជាមួយ ឈ្មោះ ឯកសារ ថត និង លេខ សម្គាល់ ។ ទិន្នន័យ ដែល បាន ធ្វើ ឡើងវិញ នឹង នាំ ឲ្យ បរាជ័យ ក្នុង ការ ត្រួត ពិនិត្យ គុណភាព ។',
                        tip3: '៣ ចំពោះ ពុម្ព ថត ដែល បាន ទាញ យក ពណ៌ ពុម្ព អក្សរ ក្រហម ដែល ជា វាល ដែល ទាមទារ ។',
                        tip4: '៤ វាល ទ្រង់ទ្រាយ នៃ ប្រភេទ ពេលវេលា គឺ ៖ yyyy- mm- dd hhh: mmm: ss 2021- 04- ២០៧: 36: ៣0',
                    },
                },
                title: 'ផ្ទុក ថត មូលដ្ឋាន',
                checkTitle: 'ការ ត្រួត ពិនិត្យ គុណភាព ថត',
                start: 'ចាប់ផ្ដើម ការ ត្រួត ពិនិត្យ គុណភាព',
                disabledTips: 'សូម ផ្ទៀងផ្ទាត់ ឯកសារ ថត មុន ពេល ត្រួតពិនិត្យ គុណភាពName',
                tips: 'ឯកសារ ថត ដែល មាន ឈ្មោះ ដូចគ្នា សរសេរ ជាន់ លើ លទ្ធផល ត្រួតពិនិត្យ គុណភាព និង ព័ត៌មាន មូលដ្ឋាន ។',
                tips1: 'អូស និង ទម្លាក់ ឯកសារ នៅ ទីនេះ ឬ ចុច ផ្ទុក ឡើង',
                tips2: 'គាំទ្រ',
                tips3: 'ទ្រង់ទ្រាយ',
                type: 'wav、mp3',
                tips4: 'ផ្ទុក ឡើង វិញ',
                tips5: 'ឯកសារ ទំហំ ឯកសារ នីមួយៗ មិន លើក',
                tipsOverSize: 'ជួរ បច្ចុប្បន្ន ពេញ សូម យក ឯកសារ នៅ ក្នុង ជួរ មុន ពេល ផ្ទុក ឡើង ។',
                size: '500M',
                count: '20',
                uploaded: 'បាន ផ្ទុក ឯកសារ ថត',
                uploading: '({0}%)',
                uploadFinished: '(បាន បញ្ចប់)',
                bottomTitle: 'សម្រាំង ព័ត៌មាន ថត ៖',
                recordType: 'ជ្រើស សំណុំ ថត ៖',
                double: 'ថត ការ ហៅ ឆានែល ពីរ',
                single: 'ការ ថត ហៅ ឆានែល តែ មួយName',
                recordBaseInfo: 'ផ្ទុក ព័ត៌មាន មូលដ្ឋាន ថត ឡើង ៖',
                addBtn: 'បន្ថែម ឯកសារ',
                downloadTemplate: 'ទាញយក ពុម្ព',
                checkRecord: 'ផ្ទៀងផ្ទាត់ ព័ត៌មាន ថត',
                checking: 'ការ ក្រិត ខាង ក្នុង ... @ info: whatsthis',
                reCheck: 'ការ មាត្រដ្ឋាន ឡើង វិញ',
                checkAll: 'ជ្រើស ទាំងអស់',
                cancelCheckAll: 'បោះបង់ ជ្រើស ទាំងអស់',
                delete: 'លុប',
                deleteLotSize: 'លុប Batch',
                agentChannel: 'ឆានែល សេវា ម៉ាស៊ីន បម្រើ ៖',
                left: 'ឆានែល ឆ្វេង',
                right: 'ឆានែល ស្ដាំ',
                donotKonw: 'ខ្ញុំ មិន ដឹង ឡើយ',
                mission: 'ជ្រើស ភារកិច្ច គុណភាព ៖',
                uploadFail: 'បាន បរាជ័យ ក្នុងកា រផ្ទុក ឡើយ',
                repeat: 'ស្ទួន ឯកសារ',
                overCount: 'ចំនួន ឯកសារ បន្ថែម ដែន ទេ',
                overSize: 'ទំហំ ឯកសារ លើក ដែន ទេ',
                uoloadFail: 'បាន បរាជ័យ ក្នុង ការ ផ្ទុក ឡើង ទៅ ពពក',
                formatError: 'កំហុស ទ្រង់ទ្រាយ',
                seccess: 'ជោគជ័យ ផ្ទៀងផ្ទាត់',
                fail: 'បាន បរាជ័យ ក្នុង ការ ផ្ទៀងផ្ទាត់',
                recordChecking: 'ថត ក្នុង ការ ត្រួត ពិនិត្យ គុណភាព សូម ក្រោយ ...',
                recordCheckSuccess: 'បាន បញ្ចប់ ការ ត្រួតពិនិត្យ គុណភាព ថត',
                recordCheckFail: 'បាន បរាជ័យ ក្នុង ការ ត្រួតពិនិត្យ គុណភាព ថត សូម ពិនិត្យ ថាតើ ថត គឺ ជា ស្ទួន ឬ មិន ត្រឹមត្រូវ',
                backToIndex: 'ត្រឡប់ ទៅ បញ្ជី ផ្ទុក ឡើង',
                recordCheckIsStarted: 'ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព បច្ចុប្បន្ន កំពុង ត្រូវ បាន ប្រតិបត្តិ ។ សូម ចាប់ផ្ដើម ភារកិច្ច ថ្មី បន្ទាប់ ពី ភារកិច្ច បច្ចុប្បន្ន បាន បញ្ចប់ ។',
            },
            customerServicePortrait: {
                title: 'ច្រក សេវា ម៉ាស៊ីន ភ្ញៀវ',
                tip1: 'ច្បាប់ ចែកចាយ នៃ ប្រវែង ប្រយោជន៍ ៖ ការ ចែកចាយ ប្រវែង ប្រយោជន៍ ត្រូវ បាន រាប់ ក្នុង ចម្រៀក តាម ចំនួន ពាក្យ ក្នុង ប្រវែង ប្រយោជន៍ និង តែ សេវា របស់ ភ្ញៀវ',
                tip2: 'ច្បាប់ ចែកចាយ ល្បឿន ៖ ការ ចែកចាយ នៃ ល្បឿន យោង តាម ល្បឿន គណនា តែ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                tip3: 'ច្បាប់ ចែកចាយ ពេលវេលា ឆ្លើយតប ៖ ការ ចែកចាយ នៃ ពេលវេលា ឆ្លើយតប តែ ស្ថានភាព ឆ្លើយតប សេវា ដែល ត្រូវ បាន គណនា ។',
                tip4: 'ការ ត្រួត ពិនិត្យ គុណភាព ៖ អត្រា តាម បំណង នៃ ចំណុច ត្រួត ពិនិត្យ គុណភាព',
                tip5: 'ពិន្ទុ ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព មធ្យម ៖ មធ្យោបាយ ការ ត្រួត ពិនិត្យ quality',
                contol: {
                    date: 'ជ្រើស កាលបរិច្ឆេទ ៖',
                    today: 'ថ្ងៃ នេះ@ item: inlistbox',
                    thisMonth: 'ខែ នេះ',
                    lastMonth: 'ខែ មុន',
                    thisQuarter: 'ចន្លោះ នេះ',
                    lastQuarter: 'ចន្លោះ ចុងក្រោយ',
                    thisYear: 'ឆ្នាំ នេះ',
                    lastYear: 'ឆ្នាំ មុន',
                    customer: 'សេវា ម៉ាស៊ីន ភ្ញៀវ ៖',
                    search: 'សំណួរ',
                    reset: 'កំណត់ ឡើង វិញ',
                    export: 'នាំចេញ',
                    indicator: 'គ្រប់គ្រង ការ បង្ហាញ',
                    selectPlaceholder: 'សូម ជ្រើស សេវា ម៉ាស៊ីន ភ្ញៀវ ដែល ត្រូវការ ប្រៀបធៀប',
                    warning: 'ជ្រើស ៥ ភ្នាក់ងារ សម្រាប់ ប្រៀបធៀប',
                    warning2: 'សូម ជ្រើស ភ្នាក់ងារ យ៉ាង ហោច ណាស់ ១ ដើម្បី សួរ',
                    dataWarning: 'បាន តែ ទិន្នន័យ រង ៣៦ ថ្ងៃ បន្ទាប់ ពី កាលបរិច្ឆេទ ចាប់ផ្ដើម អាច សួរ ។',
                    seccuss: 'ថត នាំចេញ បាន ជោគជ័យ',
                },
                echarts: {
                    distributionLaw: 'ច្បាប់ ចែកចាយ',
                    count: 'ចំនួន ពេលវេលា',
                    bout: 'ពេលវេលាName',
                },
                portrait: {
                    ability: 'វិមាត្រ សមត្ថភាព សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    option: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                    abilityOption: 'កំណត់ រចនា សម្ព័ន្ធ វិធី សមត្ថភាព',
                    placeholder: 'ស្វែងរក ពាក្យ គន្លឹះ នៃ សមត្ថភាព បញ្ចូល',
                    save: 'រក្សាទុក',
                    warning: 'សូម ជ្រើស ទ្រនិច បី យ៉ាង ហោច ណាស់ ដើម្បី កំណត់ រចនា សម្ព័ន្ធ ហើយ អ្នក អាច ជ្រើស ទ្រនិច បង្ហាញ ១០',
                },
                label: {
                    title: 'ស្លាក សេវា ម៉ាស៊ីន ភ្ញៀវ',
                },
            },
            customerServiceRankList: {
                routerTitle: 'RankList',
                title: 'តម្រូវ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                select: {
                    date: 'ជ្រើស កាលបរិច្ឆេទ ៖',
                    today: 'ថ្ងៃ នេះ@ item: inlistbox',
                    thisMonth: 'ខែ នេះ',
                    lastMonth: 'ខែ មុន',
                    thisQuarter: 'ចន្លោះ នេះ',
                    lastQuarter: 'ចន្លោះ ចុងក្រោយ',
                    thisYear: 'ឆ្នាំ នេះ',
                    lastYear: 'ឆ្នាំ មុន',
                    group: 'ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ ៖',
                    groupPlaceholder: 'សូម ជ្រើស ក្រុម ភ្ញៀវ',
                    customer: 'សេវា ម៉ាស៊ីន ភ្ញៀវ ៖',
                    customerPlaceholder: 'សូម ជ្រើស សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    search: 'សំណួរ',
                    reset: 'កំណត់ ឡើង វិញ',
                    compared: 'កម្រិត ពណ៌',
                    export: 'នាំចេញ',
                    column: 'ជួរឈរ',
                    warning: 'ជ្រើស ៥ ភ្នាក់ងារ សម្រាប់ ប្រៀបធៀប',
                    warning2: 'សូម ជ្រើស ភ្នាក់ងារ យ៉ាងហោច ណាស់ មួយ',
                    dataWarning: 'បាន តែ ទិន្នន័យ រង ៣៦ ថ្ងៃ បន្ទាប់ ពី កាលបរិច្ឆេទ ចាប់ផ្ដើម អាច សួរ ។',
                    selected: 'ភ្នាក់ងារ ដែល បាន ជ្រើស ៖',
                    seccuss: 'ថត នាំចេញ បាន ជោគជ័យ',
                },
                compared: {
                    title: 'ជ្រើស សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ',
                    return: 'បោះបង់',
                    compared: 'កម្រិត ពណ៌',
                    tips: 'សូម ជ្រើស ភ្នាក់ងារ ២-៥ សម្រាប់ ប្រៀបធៀប',
                    warning: 'បាន គាំទ្រ តែ ភ្នាក់ងារ 2-5 សម្រាប់ ប្រៀបធៀប',
                },
                transfer: {
                    leftTitle: 'ធាតុ រាយ',
                    rightTitle: 'បង្ហាញ ធាតុ',
                },
                table: {
                    page: 'ទំព័រ {1} នៃ {0}',
                    actionTitle: 'ប្រតិបត្តិការ',
                    action: 'ទិដ្ឋភាព',
                },
            },
            conceptWord: {
                title: 'ពាក្យ ទំនាក់ទំនង',
                new: 'ពាក្យ ទំនាក់ទំនង ថ្មី',
                control: {
                    search: 'ស្វែងរក ៖',
                    searchPlaceholder: 'ឈ្មោះ ឬ ស្វែងរក ពាក្យ គន្លឹះ',
                    commit: 'សំណួរ',
                    reset: 'កំណត់ ឡើង វិញ',
                    import: 'នាំចូល',
                    export: 'នាំចេញ',
                    seccuss: 'ថត នាំចេញ បាន ជោគជ័យ',
                },
                modal: {
                    title: 'នាំចូល ពាក្យ រូបភាព',
                },
                table: {
                    sizeChangeText: 'បង្ហាញ ក្នុង ទំព័រ',
                    page: 'ទំព័រ {1} នៃ {0}',
                    edit: 'កែសម្រួល',
                    delete: 'លុប',
                    request: 'បន្ទាប់ ពី លុប វា មិន អាច ត្រូវ បាន ទទួល បាន ទេ ។ តើ អ្នក ពិត ជា ចង់ លុប វា ឬ ?',
                    cancel: 'បោះបង់',
                    title: {
                        conceptWord: 'ពាក្យ ទំនាក់ទំនង',
                        describeWordsNum: 'ចំនួន ពាក្យ ពិពណ៌នា',
                        updateTime: 'ពេលវេលា ទាន់ សម័យ',
                        status: 'ភាព បែបផែន',
                        effective: 'មាន ប្រសិទ្ធភាព',
                        invalid: 'មិន ត្រឹមត្រូវ',
                        action: 'ប្រតិបត្តិការ',
                    },
                },
                detail: {
                    title: {
                        new: 'ពាក្យ ទំនាក់ទំនង ថ្មី',
                        edit: 'កែសម្រួល ពាក្យ ទំនាក់ទំនង',
                    },
                    name: 'ឈ្មោះ ពាក្យ ទំនាក់ទំនង',
                    namePlaceholder: 'សូម បញ្ចូល ឈ្មោះ ពាក្យ សម្ងាត់ មួយ',
                    effectiveness: 'ភាព បែបផែន',
                    effective: 'មាន ប្រសិទ្ធភាព',
                    invalid: 'មិន ត្រឹមត្រូវ',
                    description: 'ការ ពិពណ៌នា ៖',
                    descriptionPlaceholder: 'សូម បញ្ចូល កម្មវិធី ពិពណ៌នា',
                    add: 'បន្ថែម@ info: whatsthis',
                    repeat: 'មាតិកា ស្ទេ',
                    empty: 'អ្នក ពិពណ៌នា មិន អាច ទទេ',
                    recommendEmpty: 'គ្មាន ពាក្យ សេចក្ដី ពិពណ៌នា ទៀត ទៀត សូម បញ្ចូល ហើយ បន្ថែម ពួកវា ដោយ ដៃ ។',
                    recommend: 'ពាក្យ ពិពណ៌នា ឆ្លាត',
                    cancel: 'បោះបង់',
                    change: 'ផ្លាស់ប្ដូរ ក្រុម',
                    descriptionSelected: 'បាន បន្ថែម អ្នក ពិពណ៌នា ៖',
                    save: 'រក្សាទុក',
                    success: 'បាន រក្សាទុក ពាក្យ ទំនាក់ទំនង ដោយ ជោគជ័យ',
                    warning: 'ឈ្មោះ ពាក្យ ទំនាក់ទំនង មិន អាច ទទេ',
                    warning2: 'សូម បន្ថែម អ្នក ពិពណ៌នា យ៉ាង ហោច ណាស់ ១',
                    submitBtnHandle: {
                        title: 'កម្មវិធី ពិពណ៌នា ដែល បាន ជ្រើស មិន ត្រូវ បាន បន្ថែម ទេ ។ ការ រក្សាទុក នឹង បោះបង់ កម្មវិធី ពិពណ៌នា ដែល មិន បាន ។',
                        content: 'ចុច ត្រឹមត្រូវ ដើម្បី ត្រឡប់ ទៅ ទំព័រ ផ្ទះ ពាក្យ សម្ងាត់ សូម អះអាង ដើម្បី បន្ត ឬ ?',
                    },
                },
            },
            smartTools: {
                btn: 'ឧបករណ៍ ឆ្លាត',
                title: {
                    similarWords: 'រកឃើញ ពាក្យ ដែល ទាក់ទង',
                    search: 'តាម ពាក្យ',
                    semanticTags: 'ស្លាក semantic',
                },
                sentenceSearch: {
                    placeholder: 'សូម បញ្ចូល ការ ស្វែងរក ពាក្យ គាំទ្រ ពាក្យ គន្លឹះ ច្រើន',
                    more: 'មើល អត្ថបទ ពេញ',
                    pageUp: 'ទំព័រ មុន',
                    pageDown: 'ទំព័រ បន្ទាប់',
                    total: 'ថត {0} សរុប',
                },
                similarDiscover: {
                    placeholder: 'សូម បញ្ចូល ពាក្យ គន្លឹះ',
                    copyed: 'បាន ចម្លង',
                    none: 'គ្មាន ពាក្យ ដែល ទាក់ទង សូម ព្យាយាម ពាក្យ គន្លឹះ ផ្សេង ទៀត',
                },
                smartTags: {
                    searchPlaceHolder: 'សូម បញ្ចូល ពាក្យ គន្លឹះ ឬ ប្រយោជន៍',
                    createSmartTag: 'ថ្មី',
                    createClusteringSmartTag: 'បង្កើត ថ្មី ជាមួយ ទិន្នន័យ {0}',
                    addFromKeyword: 'បន្ថែម មាតិកា ស្វែងរក ទៅ ពាក្យ ស្រដៀង គ្នាName',
                    hit: 'បិទ',
                    similar: 'ស្រដល់',
                    name: 'ឈ្មោះ ស្លាក សំឡេង',
                    namePlaceHolder: 'សូម បញ្ចូល ឈ្មោះ ស្លាក semantic',
                    recallWords: 'ចងចាំ ពាក្យ',
                    recallWordsPlaceHolder: 'សូម បញ្ចូល ពាក្យ គន្លឹះ ហាយ',
                    recallRegular: 'ចងចាំ ធម្មតា',
                    recallRegularPlaceHolder: 'សូម បញ្ចូល ធម្មតា',
                    rules: 'បន្ទាត់',
                    standardSentences: 'ពាក្យ ស្តង់ដារ',
                    standardSentencesPlaceHolder: 'សូម បញ្ចូល ពាក្យ ស្តង់ដារ',
                    similaSentences: 'ប្រយោជន៍ ស្រដប់',
                    similaSentencesPlaceHolder: 'សូម បញ្ចូល ពាក្យ ស្រដៀង គ្នាName',
                    notSaveError: 'សូម រក្សាទុក ស្លាក semantic មុន ពេល ស្វែងរក',
                    add: 'បន្ថែម@ info: whatsthis',
                    newPage: 'បើក ក្នុង ទំព័រ ថ្មី',
                    querryError: 'វាល ស្រដៀង គ្នា មាន នៅ ក្នុង បញ្ជី ទូទៅ ( ការ កំណត់ រចនា សម្ព័ន្ធ កម្រិត កម្រិត ខ្ពស់ នៃ កម្រិត បំបែក ស្រដៀង គ្នា)',
                    detailTitle: 'សេចក្ដី លម្អិត ស្លាក សញ្ញា',
                },
            },
            trainingCenter: {
                title: 'មជ្ឈមណ្ឌល បង្ហាញ',
                edit: 'កែសម្រួល',
                delete: 'លុប',
                seleteAll: 'ជ្រើស ទាំងអស់',
                cancelCheckAll: 'បោះបង់ ជ្រើស ទាំងអស់',
                add: 'បន្ថែម@ info: whatsthis',
                remove: 'យក ចេញ',
                save: 'រក្សាទុក',
                cancel: 'បោះបង់',
                fastTraining: {
                    title: 'ការ បង្ហាត់ រហ័ស',
                    titleDes: 'ការ បង្ហាត់ រហ័ស ត្រូវ បាន រចនា សម្ព័ន្ធ ដើម្បី ជួយ ស្លាក សំឡេង រហ័ស ឲ្យ លឿន ទៅ កាន់ ២០ កម្រិត ស្រដៀង គ្នាName',
                    semanticTags: 'ស្លាក semantic',
                    semanticTagsPlaceholder: 'សូម បញ្ចូល ការ ស្វែងរក ពាក្យ គន្លឹះ',
                    standardSentence: 'ពាក្យ ស្តង់ដារ ៖ {0}',
                    similarSentencesPlaceholder: 'បញ្ចូល ពាក្យ ស្រដៀង គ្នា ដើម្បី បន្ថែម ឬ ស្វែងរក',
                    similarSentencesAdd: 'បន្ថែម@ info: whatsthis',
                    similarSentencesSearch: 'ស្វែងរក',
                    similarSentences: 'បាន បន្ថែម ពាក្យ ដូច គ្នា',
                    trainingCount: 'ចំនួន បង្ហាត់ ៖ {0}',
                    similarSentencesRecommend: 'អនុសាសន៍ ពាក្យ ស្រដៀង គ្នាName',
                    noResp: 'គ្មាន ស្លាក សញ្ញា ដែល ទាក់ទង សូម ផ្លាស់ប្ដូរ ពាក្យ គន្លឹះ',
                    similarSentencesModalTitle: 'ស្វែងរក ប្រយោជន៍ ស្រដៀង គ្នាName',
                    moreInfo: 'មើល បរិបទComment',
                    moreInfoBtn: 'បរិបទ',
                    modalSearchType: {
                        all: 'ទាំង អស់',
                        customer: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                        client: 'ម៉ាស៊ីន ភ្ញៀវ',
                    },
                    repetWarning: 'មាន ប្រយោជន៍ ដូចគ្នា រួច ហើយ សូម កុំ បន្ថែម វា ម្ដងទៀត ។',
                    repetRemoveTip: 'មាន មាតិកា ស្ទួន នៅ ក្នុង ប្រយោជន៍ ស្រដៀង គ្នា ដែល បាន រក្សាទុក ដែល បាន បដិសេធ ដោយ ស្វ័យ ប្រវត្តិ ។',
                },
                trainingHistory: {
                    title: 'ប្រវត្តិ បង្ហាញ',
                    select: {
                        date: 'ជ្រើស ពេលវេលា ៖',
                        today: 'ថ្ងៃ នេះ@ item: inlistbox',
                        thisMonth: 'ខែ នេះ',
                        lastMonth: 'ខែ មុន',
                        thisQuarter: 'ចន្លោះ នេះ',
                        lastQuarter: 'ចន្លោះ ចុងក្រោយ',
                        thisYear: 'ឆ្នាំ នេះ',
                        lastYear: 'ឆ្នាំ មុន',
                        search: 'សំណួរ',
                        reset: 'កំណត់ ឡើង វិញ',
                    },
                    table: {
                        time: 'ពេលវេលា',
                        user: 'កម្មវិធី',
                        tag: 'ស្លាក semantic',
                        similarCount: 'ចំនួន ពាក្យ ស្រដៀង គ្នាName',
                        deleteCount: 'ចំនួន ពាក្យ ដែល បាន យក ចេញ',
                        page: 'ទំព័រ {1} នៃ {0}',
                    },
                },
                classifiedTraining: {
                    title: 'ការ បង្ហាត់ ថ្នាក់',
                    tagsGrounp: 'ស្លាក',
                    placeHolder: 'សូម ជ្រើស',
                    cellTime: 'ជ្រើស ពេលវេលា',
                    search: 'សំណួរ',
                    reset: 'កំណត់ ឡើង វិញ',
                    classifiedFlag: 'ការ បង្ហាញ',
                    num: 'លេខName',
                    gas: 'ភាគរយ',
                    noData: 'បង្ហាត់ ដែល មិន បាន ថ្នាក់',
                    noDataHeight: 'ទិន្នន័យ ដែល មិន បាន ថ្នាក់ គឺ ខ្ពស់ និង ការ បង្ហាត់ ត្រូវការ យ៉ាង ត្រឹមត្រូវ ។',
                    noDataSmall: 'គណនី ទិន្នន័យ ដែល មិន បាន ថ្នាក់ សម្រាប់ សមាមាត្រ ខ្ពស់ និង ការ បង្ហាត់ ត្រូវ បាន ផ្ដល់ អនុសាសន៍ ។',
                    noDataDays: '{0} ថ្ងៃ មុន ពេល ប្រតិបត្តិ ចុងក្រោយ',
                    training: 'បង្ហាញ',
                    start: 'ចាប់ផ្ដើម',
                    addClass: 'បន្ថែម ថ្នាក់Comment',
                    custom: 'តម្រង កម្រិត ខ្ពស់',
                    marked: 'Errata ទិន្នន័យ ស្លាកName',
                    markedHeight: 'Errata មិន ត្រូវ បាន អនុវត្ត សម្រាប់ {0} ថ្ងៃ ហើយ វា ត្រូវ បាន ផ្ដល់ អនុសាសន៍ ឲ្យ ធ្វើ ដូច្នេះ ។',
                    markedSmall: 'Errata មិន ត្រូវ បាន អនុវត្ត សម្រាប់ {0} ថ្ងៃ ឡើយ ។ Errata ត្រូវការ ត្រឹមត្រូវComment',
                    mark: 'អារ៉ាត',
                    dataCheck: 'ការ ផ្ទៀងផ្ទាត់ ទិន្នន័យ',
                    dataCheckSmall: 'វិភាគ K- L គឺ ខ្ពស់ ជាង ៥០, វា ត្រូវ បាន ផ្ដល់ អនុសាសន៍ ដើម្បី បង្ហាត់ ។',
                    dataCheckHeight: 'ការ ដោះស្រាយ K- L គឺ ខ្ពស់ ជាង ០. ៨ និង ការ បង្ហាត់ ត្រូវការ យ៉ាង ត្រឹមត្រូវ ។',
                    check: 'ក្រាហ្វិក',
                    history: 'ប្រវត្តិ ការ ហៅ',
                    historyTime: 'ចំណារ ពន្យល់ និង កែប្រែ រាល់ ថ្ងៃ នឹង អនុវត្ត ការ បង្ហាត់ ម៉ូដែល ដោយ ស្វ័យ ប្រវត្តិ នៅ ២: 00 នាទី ។',
                    today: 'បាន ស្លាក ថ្ងៃ នេះ@ info: whatsthis',
                    article: 'អត្ថបទ',
                    none: 'គ្មាន ទេ',
                    historyCheck: 'ការ ហៅ ប្រវត្តិ សរុប',
                    look: 'មើល ថត',
                    historyluate: 'ទិន្នន័យ ប្រវត្តិ ឡើង វិញ',
                    startluate: 'គណនា គ្នា',
                    classData: 'ទិន្នន័យ ដែល បាន កម្រិតComment',
                    classStatus: 'វឌ្ឍនភាព បង្ហាញ',
                    next: 'អត្ថបទ បន្ទាប់',
                    prev: 'អត្ថបទ មុន',
                    finish: 'ការ បង្ហាត់ បញ្ចប់',
                    stop: 'ចុង បង្ហាត់ បង្ហាញ',
                    classDetail: 'សេចក្ដី លម្អិត ការ បង្ហាញ',
                    trainingNone: 'គ្មាន ការ បង្ហាត់ សម្រាប់ ស្លាក ឆ្លាត',
                },
                classifiedTrainingHistory: {
                    title: 'ប្រវត្តិ បង្ហាញ',
                    time: 'ជ្រើស ពេលវេលា ៖',
                    tag: 'ប្រភេទ ស្លាក ៖',
                    user: 'ប្រតិបត្តិការ ៖',
                    data: 'ជ្រើស ប្រភព ទិន្នន័យ ៖',
                    search: 'សំណួរ',
                    searchBar: 'ស្វែងរក ៖',
                    searchBarPlaceholder: 'សូម បញ្ចូល ការ ស្វែងរក លេខ សម្គាល់/ជា',
                    reset: 'កំណត់ ឡើង វិញ',
                    export: 'នាំចេញ',
                    all: 'ទាំង អស់',
                    select: {
                        today: 'ថ្ងៃ នេះ@ item: inlistbox',
                        thisMonth: 'ខែ នេះ',
                        lastMonth: 'ខែ មុន',
                        thisQuarter: 'ចន្លោះ នេះ',
                        lastQuarter: 'ចន្លោះ ចុងក្រោយ',
                        thisYear: 'ឆ្នាំ នេះ',
                        lastYear: 'ឆ្នាំ មុន',
                        search: 'សំណួរ',
                        reset: 'កំណត់ ឡើង វិញ',
                    },
                    table: {
                        user: 'កម្មវិធី',
                        date: 'ពេលវេលា ប្រតិបត្តិការ',
                        data: 'ប្រភព ទិន្នន័យ',
                        id: 'លេខ សម្គាល់ ហៅ/ សាកល្បង',
                        tagType: 'ក្រុម ស្លាក ឆ្លាត',
                        tagName: 'ឈ្មោះ ស្លាក',
                        state: 'ស្ថានភាព',
                        sizeChangeText: 'បង្ហាញ ក្នុង ទំព័រ',
                        page: 'ទំព័រ {1} នៃ {0}',
                        call: 'ហៅ',
                        dialogue: 'ប្រអប់Comment',
                    },
                },
                clusteringAnnotation: {
                    title: 'ចំណារ ព័ត៌មាន ក្បៀន',
                    left: {
                        title: 'លទ្ធផល ក្បៀន',
                    },
                    right: {
                        title: 'ប្រយោជន៍',
                        checkAll: 'ជ្រើស ទំព័រ ទាំងអស់ នេះ',
                        tagging: 'ការ ហៅ',
                        detail: 'ទិដ្ឋភាព',
                        meaningless: 'មិន អើពើ',
                        meaninglessTips: 'លទ្ធផល ដែល មិន អើពើ នឹង មិន ត្រូវ បាន បង្ហាញ ក្នុង អនាគត ។ តើ អ្នក ពិត ជា ចង់ មិន អើពើ ពួកវា ឬ ?',
                        cancel: 'បោះបង់',
                    },
                },
            },
            clientCenter: {
                clientManage: {
                    title: 'គ្រប់គ្រង ម៉ាស៊ីន ភ្ញៀវ',
                    tabTitle: 'ម៉ាស៊ីន ភ្ញៀវ',
                },
                wechatClientManage: {
                    title: 'ម៉ាស៊ីន ភ្ញៀវ',
                    table: {
                        id: 'លេខ សម្គាល់ ម៉ាស៊ីន ភ្ញៀវ',
                        name: 'ឈ្មោះ អ្នក ភ្ជាប់',
                        tag: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
                    },
                },
            },
            collectionRule: {
                title: 'ច្បាប់ សម្រាំង',
                form: {
                    info: 'សម្រាំង ព័ត៌មាន ចំណាំ',
                    infoPlaceholder: 'សូម ជ្រើស ប្រភេទ មួយ',
                },
                table: {
                    name: 'ឈ្មោះ វាល',
                    props: 'គុណលក្ខណៈ របស់ ម៉ាស៊ីន ភ្ញៀវ',
                    type: 'ប្រភេទ វាល',
                    desc: 'សេចក្ដី ពិពណ៌នា វាល',
                },
            },
            dataAdd: {
                title: 'បន្ថែម ទិន្នន័យ',
                types: {
                    auto: 'បន្ថែម ដោយ ស្វ័យ ប្រវត្តិ',
                    manual: 'បន្ថែម ដោយ ដៃ',
                },
            },
            wechatStaff: {
                table: {
                    name: 'ឈ្មោះ:',
                    part: 'ហត្ថលេខា',
                    phone: 'លេខ ទូរស័ព្ទ ចល័ត',
                    email: 'អ៊ីមែល',
                    wechartId: 'លេខ សម្គាល់ WeChat Enterprise',
                    status: 'ស្ថានភាព លើ ដំណើរការ',
                },
                info: 'សូម ជ្រើស ចំណុច ដែល ត្រូវការ ធ្វើ សមកាលកម្ម ទិន្នន័យ ដំបូងName',
                synSuccess: 'ការ ធ្វើ សមកាលកម្ម បាន ជោគជ័យ',
                init: 'ការ ចាប់ផ្ដើម',
                syn: 'ធ្វើ សមកាលកម្ម',
            },
            appealHistory: {
                appealTime: 'ពេលវេលា សំណួរ',
                cancelTime: 'ពេលវេលា បដិសេធ',
                reviewTime: 'ពេលវេលា ឡើង វិញ',
                inspector: 'កម្មវិធី ត្រួតពិនិត្យ គុណភាព',
                result: 'លទ្ធផល នៃ សំខាន់',
                complainResult: 'ធាតុ ការ ត្រួត ពិនិត្យ គុណភាព {0} ត្រូវ បាន អភិវឌ្ឍន៍ សរុប {1} ត្រូវ បាន បដិសេធ ដោយ ជោគជ័យ ហើយ {2} ត្រូវ បាន បដិសេធ',
                reason: 'មូលហេតុ សម្រាប់ សាកល្បង',
                rejection: 'មូលហេតុ សម្រាប់ ការ បដិសេធ',
                cancel: 'បាន ដក',
                tip: 'ការ អះអាង ដើម្បី យក ការ ភ្ញាក់ ?',
            },
            appealSdk: {
                time: 'ពេលវេលា ប្រអប់Name',
                externalIdCall: 'លេខ សម្គាល់ កំណត់ហេតុ ហៅ',
                externalIdText: 'លេខ សម្គាល់ សំណួរ',
                callCenterCallID: 'លេខសម្គាល់ការហៅទូរស័ព្ទរបស់មជ្ឈមណ្ឌលហៅទូរសព្ទ',
                imDialogRecordID: 'លេខសម្គាល់កំណត់ត្រាការសន្ទនា IM',
                customerNickName: 'ឈ្មោះ អ្នក ភ្ជាប់',
                readStatus: 'ស្ថានភាព ឡើង វិញ',
                status: 'ស្ថានភាព សាកល្បង',
                isManual: 'ការ ត្រួត ពិនិត្យ គុណភាព ដោយ ដៃ',
                complainButtonInfo: '{0} ត្រូវ អនុញ្ញាត ឲ្យ {1} បិទ រួច ហើយ, {2} បិទ នៅ សល់ ។ {3} អាច តភ្ជាប់ មុន@ info: whatsthis',
                submit: 'ដាក់ ស្នើ សំឡេង',
                complain: 'ជម្រះ',
                allComplain: 'សញ្ញា ទាំងអស់',
                pendingSubmit: 'ត្រូវ បាន ដាក់ស្នើ',
                taskIds: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                graded: 'ការ វាយតម្លៃ',
                complainSuccess: 'បាន ដាក់ស្នើ ដោយ ជោគជ័យ',
                appealSdkIndex: {
                    title: 'លទ្ធផល ត្រួតពិនិត្យ គុណភាព ត្រឹមត្រូវ',
                },
            },
        },
        lookupRecords: {
            getFiltersListError: 'បាន បរាជ័យ ក្នុង ការ ទទួល ព័ត៌មាន បញ្ជី តម្រង សូម ពិនិត្យ មើល ការ តភ្ជាប់ បណ្ដាញ ឬ ព្យាយាម ម្ដង ទៀត ។',
            columns: 'ជួរឈរ',
            filter: 'តម្រង',
            noSearchResult: 'រក មិនឃើញ ថត',
            pleaseSearch: 'សូម ជ្រើស តម្រង ហើយ ព្យាយាម ស្វែងរក',
            sift: 'តម្រង',
            create: 'ថ្មី',
            search: 'ស្វែងរក',
            createTaskTitle: 'ភារកិច្ច ថ្មី',
            title: 'ចំណង ជើង',
            deadline: 'កាលបរិច្ឆេទ',
            principal: 'ផ្នែក ត្រួត ព្រួញ',
            enqueueTime: 'ពេលវេលា បញ្ចូល',
            computeError: 'ការ គណនា បាន បរាជ័យ សូម រង់ចាំ !',
            sum: 'គំរូ',
            max: 'អតិបរមា',
            min: 'អប្បបរមា',
            avg: 'មធ្យម',
            count: 'គណនា',
            maxDate: 'អតិបរមា (ចុងក្រោយ)',
            minDate: 'អប្បបរមា (ចាស់ បំផុត)',
        },
        mainMenu: {
            insight: {
                name: 'Insight',
                getInsightUrlError: 'បាន បរាជ័យ ក្នុង ការ ទទួល អាសយដ្ឋាន តំណ Insight សូម ព្យាយាម ម្ដង ទៀត ។',
            },
            template: {
                learningReminder: 'កម្មវិធី រំលឹក',
                subscriptionDynamics: 'ថាមវន្ត',
            },
        },
        tasks: {
            subMenu: {
                manageHome: {
                    text: 'គ្រប់គ្រង ភារកិច្ច',
                    chaneg: 'ប្ដូរ',
                },
                qualityCheckTemplate: {
                    text: 'ពុម្ព ត្រួត ពិនិត្យ គុណភាព',
                    collectText: 'ពុម្ព បង្កើន',
                    condition: {
                        text: 'លក្ខខណ្ឌ ត្រួត ពិនិត្យ គុណភាព',
                    },
                    checkPoint: {
                        text: 'ការ កំណត់ រចនាសម្ព័ន្ធ បន្ទាត់',
                    },
                    automaticAdd: {
                        text: 'ដំណើរការ ដោយ ស្វ័យ ប្រវត្តិ',
                    },
                    manualAdd: {
                        text: 'បន្ថែម ដោយ ដៃ',
                    },
                    roleConfig: {
                        text: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                    },
                    basicInfo: {
                        text: 'ព័ត៌មាន មូលដ្ឋាន',
                    },
                    smartWordsLibrary: {
                        text: 'កម្រិត សំឡេង',
                    },
                    grade: {
                        text: 'ការ ត្រួត ពិនិត្យ គុណភាព',
                    },
                    collectionRule: {
                        text: 'ច្បាប់ សម្រាំង',
                    },
                    addData: {
                        text: 'បន្ថែម ទិន្នន័យ',
                    },
                    collectionList: {
                        text: 'បញ្ជី សំឡេង',
                    },
                },
                qualityCheckWorkbench: {
                    text: 'ការងារ ត្រួត ពិនិត្យ គុណភាព',
                    wechatText: 'វិភាគ WorkbenchName',
                    informationCollectText: 'ការងារ បង្ហាញ',
                    qualityInspectionList: {
                        text: 'បញ្ជី ត្រួតពិនិត្យ គុណភាព',
                        wechatText: 'បញ្ជី វិភាគName',
                        informationCollectText: 'បញ្ជី សំឡេង',
                    },
                    condition: {
                        text: 'បញ្ជី ការ ត្រួត ពិនិត្យ គុណភាព (অុសប្រាស់)',
                    },
                    reviewList: {
                        text: 'បញ្ជី ឡើង វិញ',
                    },
                    spotCheckList: {
                        text: 'បញ្ជី គំរូ',
                    },
                    caseBaseList: {
                        text: 'បណ្ណាល័យ អក្សរ',
                    },
                    testSetList: {
                        text: 'ការ សាកល្បង ការ ត្រួត ពិនិត្យ គុណភាព',
                    },
                },
                statisticsAndReports: {
                    text: 'ស្ថិតិ និង របាយការណ៍Name',
                    wholeReport: {
                        text: 'របាយការណ៍ ទាំងអស់',
                    },
                    groupReport: {
                        text: 'របាយការណ៍ ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    },
                    agentReport: {
                        text: 'របាយការណ៍ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    },
                    customerServiceExecution: {
                        text: 'ការ វិភាគ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    },
                    analysisOverview: {
                        text: 'ទិដ្ឋភាព ទូទៅ',
                    },
                    inspectionItemsAnalysis: {
                        text: 'ការ វិភាគ ធាតុ ត្រួត ពិនិត្យ គុណភាព',
                    },
                },
                wechatQa: {
                    text: 'ការ ត្រួត ពិនិត្យ គុណភាព WeChat Enterprise',
                    task: {
                        text: 'ភារកិច្ច វិភាគរក',
                    },
                    baseInfo: {
                        text: 'ព័ត៌មាន មូលដ្ឋាន',
                    },
                    checkPoint: {
                        text: 'ការ កំណត់ រចនា សម្ព័ន្ធ ម៉ូឌុល',
                    },
                    setting: {
                        text: 'ការ កំណត់ រចនា សម្ព័ន្ធ ការ វិភាគ WeChat Enterprise',
                    },
                    automaticAdd: {
                        text: 'ដំណើរការ ដោយ ស្វ័យ ប្រវត្តិ',
                    },
                    manualAdd: {
                        text: 'បន្ថែម ដោយ ដៃ',
                    },
                },
                clientCenter: {
                    text: 'មជ្ឈមណ្ឌល សេវា ម៉ាស៊ីន ភ្ញៀវ',
                },
            },
            conditionDictionaries: {
                title: 'លក្ខខណ្ឌ ទាំងអស់',
                searchDefaultText: 'សូម បញ្ចូល លេខ សម្គាល់ ឬ ឈ្មោះ',
                id: 'ID',
                name: 'ឈ្មោះ:',
                conditionDetailedShow: 'ពង្រីក',
                conditionDetailedHide: 'ស្មើ',
                remark: 'សេចក្ដី ពិពណ៌នា ៖',
                checkRole: 'ទីតាំង ៖',
                operator: 'ប្រតិបត្តិការ ៖',
                operatorLogic: 'តក្កវិធី ៖',
            },
            audioTextView: {
                customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                unsupportedFormat: 'ទ្រង់ទ្រាយ នេះ មិន ត្រូវ បាន គាំទ្រ ។',
            },
            checkPointClassifications: {
                add: 'បន្ថែម ប្រភេទ',
                name: 'ឈ្មោះ:',
                enterToSave: 'ចុច បញ្ចូល ដើម្បី រក្សាទុក',
                highestScore: 'ចំណុច ពិន្ទុ អតិបរមា',
                minimumScore: 'ដែន កំណត់ ពិន្ទុ អប្បបរមា',
                defaultMinScore: 'លំនាំដើម គឺ ០ ចំណុច',
                minimumScoreTitle: 'ដែន កំណត់ ពិន្ទុ ទាប',
                beginScore: 'តម្លៃ ពិន្ទុ ចាប់ផ្ដើម ទាំងអស់',
                beginScoreTitle: 'ចាប់ផ្ដើម តម្លៃ ពិន្ទុ',
                scoreSetTip: 'ពិន្ទុ អតិបរមា គឺ តិច ជាង ពិន្ទុ ទាំងអស់ ។ អ្នក អាច ជ្រើស ៖',
                ignoreExcessSpillover: 'មិន អើពើ ទំហំ ច្រើន ទំហំ',
                automaticWeightCalculation: 'គណនី ភាព ស្វ័យ ប្រវត្តិ',
            },
        },
        fieldSelect: {
            field: 'វាល',
        },
        checkRange: {
            numberTipOne: 'ភាគComment',
            numberTipTwo: 'ប្រយោជន៍',
            numberTipThree: 'ប្រយោជន៍ ទៅ លេខ.',
            conditionLimit: 'ការ កំណត់ លក្ខខណ្ឌ',
            roleLimit: 'ការ បង្ហាញ',
            contextLimit: 'ការ ដែន ប្រយោជន៍',
            notZero: 'បញ្ចូល 0 មិន ត្រូវ បាន គាំទ្រ សម្រាប់ ការ កម្រិត ប្រយោជន៍ ទេ',
            startMustLessThanEnd: 'ទីតាំង ពាក្យ ចាប់ផ្ដើម ត្រូវ តែ តិច ជាង ទីតាំង បញ្ចប់ ប្រយោជន៍',
        },
        waveAudio: {
            play: 'ចាក់',
            pause: 'ផ្អាក',
            rateOne: '0.5',
            rateTwo: '1.0',
            rateThree: '1.5',
            rateFour: '2.0',
            rateFive: '1.2',
        },
        operatorListGather: {
            pleaseEnter: 'សូម បញ្ចូល',
            pleaseEnterRegular: 'សូម បញ្ចូល កន្សោម ធម្មតា',
            pleaseEnterGrammar: 'សូម បញ្ចូល ច្បាប់ ក្រាប',
            pleaseEnterTestText: 'សូម បញ្ចូល មាតិកា ដែល ត្រូវ ផ្ទៀងផ្ទាត់',
            pleaseEnterLoudness: 'សូម បញ្ចូល lodness decibelName',
            pleaseEnterRangeAbility: 'សូម បញ្ចូល ជួរ ផ្លាស់ប្ដូរ',
            afterHit: 'ពិនិត្យ មើល បន្ទាប់ ពី ការ បាន',
            pleaseEnterContext: 'សូម បញ្ចូល សេចក្ដី យោង នេះ',
            wordNumber: 'ចន្លោះ ពាក្យ',
            intervalSecond: 'ចន្លោះពេល ធំៗ',
            minute: 'រាល់ នាទី ។',
            wordUnit: 'ពាក្យ',
            test: 'សាកល្បង',
            testRegular: 'សាកល្បង កន្សោម ធម្មតា',
            testGrammar: 'សាកល្បង ក្រាប',
            testGrammarError: 'ការ សាកល្បង ក្រាប បាន បរាជ័យ',
            regularError: 'កំហុស កន្សោម ធម្មតា សូម បញ្ចូល ឡើង វិញ',
            pleaseEnterSemanticSentence: 'សូម បញ្ចូល ពាក្យ ដែល ទាមទារ ការ រក ឃើញ semantic',
            pleaseEnterAssociate: 'យោង ទៅ លើ សេចក្ដី ណែនាំ ទៅ ខាង ស្ដាំ ដើម្បី បង្កើត កន្សោម ទិន្នន័យ',
            querySemanticTags: 'ជ្រើស ស្លាក សំឡេង',
            reQuerySemanticTags: 'ជ្រើស ស្លាក semantic',
            semanticTags: 'ស្លាក semantic',
            standardSentence: 'ពាក្យ ស្តង់ដារ',
            semanticName: 'ស្លាក semantic',
            sentence: 'ពាក្យ ស្តង់ដារ',
            similarity: 'ស្រដៀង គ្នាName',
            actions: 'ប្រតិបត្តិការ',
            tipOne: 'មិន បាន រក ស្លាក ត្រឹមត្រូវ ឡើយ ។',
            tipTwo: 'បន្ថែម ស្លាក semantic ថ្មី',
            notLessThan: 'មិន តិច',
            notGreaterThan: 'មិន ធំ ទេ',
            ignoreLessThan: 'មិន អើពើ',
            wordUnitSet: 'ពាក្យ ពាក្យ',
            speedWordNotNull: 'ចំនួន ពាក្យ អប្បបរមា និង ចំនួន ពាក្យ អតិបរមា ក្នុង ការ រកឃើញ ល្បឿន និយាយ មិន អាច ទទេ ទាំង ពីរ ។',
            speedWordMinValueLessThanMaxValue: 'ចំនួន ពាក្យ អប្បបរមា ក្នុង ការ រកឃើញ ល្បឿន និយាយ មិន អាច ធំ ជាង ចំនួន ពាក្យ អតិបរមា ។',
            speechGrabbingIntervalTip: 'ចន្លោះពេល> =',
            speechLengthTip: 'ប្រយោជន៍ វែង> =',
            msUnit: 'ms',
            sUnit: 'វិនាទី',
            grabIntervalNotNull: 'ចន្លោះ ពេល ចាប់ យក មិន អាច ទទេ',
            grabLengthNotNull: 'ប្រយោជន៍ មិន អាច ទទេ ។',
            pleaseSelectEntity: 'សូម ជ្រើស ធាតុ ព័ត៌មាន',
            pleaseSelectOperator: 'សូម ជ្រើស សកម្មភាព មួយ',
            pleaseSelectBasicInfo: 'សូម ជ្រើស ព័ត៌មាន មូលដ្ឋាន',
            pleaseEnterFixedValue: 'សូម បញ្ចូល តម្លៃ ថេរ',
            loudnessUnit: 'db',
            percent: '%',
            matchSuccess: 'ផ្គូផ្គង ដោយ ជោគជ័យ',
            matchError: 'ការ ផ្គូផ្គង បាន បរាជ័យ',
            mindetectionStatement: 'ការ រក ឃើញ អប្បបរមា',
            conceptWordholder: 'សូម ជ្រើស ពាក្យ បង្ហាញ',
            elementHolder: 'សូម បញ្ចូល ធាតុ មួយ',
            associateMedol: {
                tabs: {
                    data: 'ទិន្នន័យ',
                    operator: 'កម្មវិធី',
                },
            },
            repet: 'ធ្វើ ឡើងវិញ',
            bout: 'ពេលវេលាName',
            ignore: 'មិន អើពើ',
            ignoreAffix: 'ពាក្យ ពាក្យ',
            associateData: 'ទិន្នន័យ តាម ផ្លូវComment',
            pretreatmentData: 'កំពុង ដំណើរការ ទិន្នន័យ',
            reviewTaskData: 'មើល ទិន្នន័យ ភារកិច្ច',
            taskData: 'ទិន្នន័យ ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព',
            businessData: 'ថត ពាក្យ',
            functionOperator: 'ប្រតិបត្តិការ របស់ អនុគមន៍',
            operation: 'ប្រតិបត្តិការ',
            notAnyMatch: 'នៅ ពេល បញ្ហា ណា មួយ មិន ត្រូវ បាន បាត់ ៖',
            times: 'ចំនួន កើតឡើង ដើម',
            newAssociateDataTip: 'ប្រសិន បើ តម្លៃ ជា ប្រភេទ លេខ ប្រើ លក្ខណៈ ពិសេស ចាស់ៗ',
        },
        conditionGather: {
            cycle: 'រង្វង់Comment',
            rlue: 'បន្ទាត់',
            delete: 'យក ចេញ',
            sampling: 'ស្រង់ចេញ',
            item: 'អត្ថបទ',
            percent: '%',
            samplingSame: 'ចំនួន ស្រង់ ចេញ ក្នុង មួយ ភ្នាក់ងា',
            samplingRecheck: 'អនុញ្ញាត ឲ្យ ស្រង់ចេញ ធាតុ ដែល បាន គំរូ',
            dateUnit: 'គ្មាន ។',
            samplingTip: 'ក្បួន ផ្សេង គ្នា បង្កើន ការ ហៅ ដូចគ្នា នឹង មិន ត្រូវ បាន ស្រង់ ឡើង វិញ ទេ ។ និង ថត ដែល បាន ស្រង់ចេញ ប៉ុន្តែ មិន បាន ធីក នឹង មិន ត្រូវ បាន ស្រង់ ឡើង វិញ ទេ ។',
            add: 'ច្បាប់ ថ្មី',
        },
        ruleGather: {
            title: 'បន្ទាត់',
            screeningCondition: 'លក្ខខណ្ឌ តម្រង',
            addRule: 'ច្បាប់ ថ្មី',
            inspector: 'កម្មវិធី ត្រួតពិនិត្យ គុណភាព',
            ruleTip: 'របៀប បម្រុង ទុក ច្បាប់ ដំបូង ពី កំពូល ទៅ បាត មិន ធ្វើ ការ បម្លែង ឡើង វិញ ។ នៅ ក្នុង ច្បាប់ ឬ មិន ផ្គូផ្គង ធាតុ ច្បាប់ ណាមួយ នឹង ត្រូវ បាន បម្លែង ដោយ ចៃដន្យ ។',
            moveUp: 'ផ្លាស់ទី ឡើង លើ',
            moveDown: 'ផ្លាស់ទី ចុះក្រោម',
            top: 'កំពូលName',
        },
        pushRulesGather: {
            title: 'បន្ទាត់',
            delete: 'យក ចេញ',
            newPush: 'ចុច ថ្មី',
            newRule: 'ច្បាប់ ថ្មី',
            sampling: 'ស្រង់ចេញ',
            item: 'អត្ថបទ',
            percent: '%',
            samplingSame: 'ចំនួន ស្រង់ ចេញ ក្នុង មួយ ភ្នាក់ងា',
            dateUnit: 'គ្មាន ។',
            screeningCondition: 'លក្ខខណ្ឌ តម្រង',
            email: 'អ៊ីមែល',
            emailPlaceholder: 'បញ្ចូល ប្រអប់ សំបុត្រ ដែល បាន បំបែក ដោយ សមត្ថិភាព',
            updateType: 'ប្រភេទ ធ្វើ ឲ្យ ទាន់ សម័យ',
            pushDetail: 'ចុច សេចក្ដី លម្អិត',
            pushUrl: 'ចុច URL',
            pushWay: 'ចុច ប្រភេទ@ info: whatsthis',
            pushMethod: 'ចុច របៀបComment',
            pushContentType: 'ទ្រង់ទ្រាយ ទិន្នន័យ',
            pushData: 'ចុច ទិន្នន័យ',
            additionalData: 'ទិន្នន័យ បន្ថែម',
            inspectionType: 'ប្រភេទ ត្រួត ពិនិត្យ គុណភាព',
            all: 'ទាំង អស់',
        },
        taskAdditionalData: {
            newData: 'ទិន្នន័យ ថ្មី',
            delete: 'យក ចេញ',
            placeholder: 'សូម បញ្ចូល ឈ្មោះ មួយ',
            dataPlaceholder: 'សូម បញ្ចូល មាតិកា',
        },
        UdeskQaReact: {
            loadSdkError: 'បាន បរាជ័យ ក្នុង ការ ផ្ទុក SDK សូម ព្យាយាម ម្ដង ទៀត ។',
        },
        gearOptionList: {
            evaluation: 'ការ តម្លៃ',
        },
        tableComponentTransfer: {
            leftTitle: 'ធាតុ រាយ',
            rightTitle: 'បង្ហាញ ធាតុ',
        },
        kmTinymce: {
            link: 'បញ្ចូល/កែសម្រួល តំណ',
            modalTitle: 'បញ្ចូល តំណ',
            href: 'អាសយដ្ឋាន',
            text: 'បង្ហាញ អត្ថបទ',
            title: 'ចំណង ជើង',
            target: 'របៀប បើក',
            none: 'គ្មាន ទេ',
            newWindow: 'បើក ក្នុង បង្អួច ថ្មី',
            buttonStyle: 'រចនាប័ទ្ម ប៊ូតុង',
            close: 'បិទ',
            open: 'បើក',
            answerMessage: 'លោត/ផ្ញើ សារ',
            answerMessageTitle: 'ផ្ញើ ប៊ូតុង សារ',
            answerMessageText: 'បង្ហាញ អត្ថបទ',
            answerMessageContent: 'មាតិកា សារ',
            answerMessageButtonStyle: 'រចនាប័ទ្ម ប៊ូតុង',
            answerMessageTips: 'ចំណាំ ៖ ប៊ូតុង ផ្ញើ សារ គាំទ្រ តែ ឆានែល បណ្ដាញ សូម កំណត់ រចនា សម្ព័ន្ធ វា ដោយ ត្រឹមត្រូវ ។',
            answerSwitchStaff: 'លោត / បិទ ដោយ ដៃ',
            answerSwitchStaffTitle: 'បើក ប៊ូតុង ដៃ',
            answerSwitchStaffText: 'បង្ហាញ អត្ថបទ',
            answerSwitchStaffRule: 'ច្បាប់ ប៊ូតុង',
            answerSwitchStaffButtonStyle: 'រចនាប័ទ្ម ប៊ូតុង',
            answerSwitchStaffTips: 'ចំណាំ ៖ ប៊ូតុង ប្ដូរ ដោយ ដៃ គាំទ្រ តែ ឆានែល បណ្ដាញ សូម កំណត់ រចនា សម្ព័ន្ធ វា ដោយ ត្រឹមត្រូវ ។',
            textButton: 'ប៊ូតុង អត្ថបទ',
            borderButton: 'ប៊ូតុង ស៊ុម',
            message: 'ផ្ញើ សារ',
            switchStaff: 'បិទ ដៃ',
            messageError: 'មាតិកា ប៊ូតុង មិន អាច លើស ពី ១០ ពាក្យ បាន ឡើយ',
            messageIsEmptyError: 'មាតិកា ប៊ូតុង មិន អាច ទទេ',
            okText: 'កំណត់@ info: whatsthis',
            cancelText: 'បោះបង់',
            video: 'វីដេអូ',
            uploadVideo: 'ផ្ទុក វីដេអូ ឡើង លើ',
            uploadText: 'គាំទ្រ តែ ទ្រង់ទ្រាយ MP4 ប៉ុណ្ណោះ ទំហំ ទំហំ ច្រើន ជាង ២០M',
            videoEmptyOrUploading: 'វីដេអូ ទទេ ឬ ផ្ទុក ឡើង',
            customEmoji: 'កន្សា',
        },
        massageConfiguration: {
            pushTarget: 'គោលដៅ ជូន ដំណឹង',
            customizePushTarget: 'ចុច ទិសដៅ ផ្ទាល់ខ្លួន',
            sysUser: 'អ្នក ប្រើ ប្រព័ន្ធ បច្ចុប្បន្ន',
            sysRole: 'ភាព ប្រព័ន្ធ បច្ចុប្បន្ន',
            emailPushTarget: 'ផ្ញើ ទិសដៅ',
            targetEmailsPlaceholder: 'សូម បញ្ចូល ប្រអប់ សំបុត្រ ដែល បាន បំបែក ដោយ សមត្ថិភាព',
            subject: 'ឈ្មោះ សារ',
            SDKID: 'លេខ សម្គាល់ SDK',
            content: 'មាតិកា ការ ជូន ដំណឹង',
            sdkPushType: 'ចុច គ្រោង',
            sdkPushURL: 'ចុច URL',
            pushData: 'ចុច ទិន្នន័យ',
            sdkPushWay: 'ចុច របៀបComment',
            dataType: 'ទ្រង់ទ្រាយ ទិន្នន័យ',
            additionalData: 'ទិន្នន័យ បន្ថែម',
            name: 'ឈ្មោះ សារ',
            filter: 'លក្ខខណ្ឌ តម្រង',
            triggerType: 'គ្នា',
            pushCycle: 'ការ កំណត់ ពេលវេលា ប្រេកង់ ថេរ',
            pushContent: 'មាតិកា រាយការណ៍',
            qualityList: 'បញ្ជី លទ្ធផល ត្រួតពិនិត្យ គុណភាព',
            designated: 'ម៉ាស៊ីន ភ្ញៀវ ដែល បាន ជ្រើស',
            messageType: 'ប្រភេទ សារ',
        },
        taskCard: {
            template: {
                flyingBookGroupChat: 'ជជែក ក្រុម សៀវភៅ',
                questionnaire: 'កម្រិត សំណួរ',
                ecommerceSession: 'សម័យ E- Comment',
                eCommerceReview: 'E- Comment',
                socialMediaComments: 'សេចក្តី អធិប្បាយ មេឌៀ',
                mixing: 'លាយ',
                video: 'វីដេអូ',
                cancelCollection: 'បោះបង់ សំណព្វ',
                collection: 'សម្រាំង',
            },
        },
        semanticTagsSelect: {
            index: {
                delete: 'លុប',
                standardSentence: 'ពាក្យ ស្តង់ដារ ៖',
            },
        },
        gong: {
            filesOpen: {
                folderItem: {
                    collection: 'សម្រាំង',
                    calls: 'ហៅ',
                    createdBy: 'បាន បង្កើត ៖',
                    createdOn: 'ពេលវេលា បង្កើត ៖',
                },
                fileItem: {
                    uIProvidesIcon: 'ផ្ដល់ រូប តំណាងName',
                    minute: 'នាទី',
                    callClip: 'ភាគរយ ហៅ',
                    start: 'ចាប់ផ្ដើម',
                    End: 'បញ្ចប់',
                    employees: 'ម៉ាស៊ីន ភ្ញៀវ ៖',
                    Customer: 'ម៉ាស៊ីន ភ្ញៀវ ៖',
                    sessionTime: 'ពេលវេលា សម័យ ៖',
                    reasonForRecommendation: 'មូលហេតុ សម្រាប់ ផ្ដល់ អនុសាសន៍ ៖',
                    addedBy: 'បាន បន្ថែម ៖',
                    addTime: 'បន្ថែម ពេលវេលា ៖',
                },
                modalAddFile: {
                    caseTitle: 'ចំណង ជើង អក្សរ',
                    addSomeClipsToTheCaseLibrary: 'បន្ថែម snippet ភាគ ច្រើន ទៅ បណ្ណាល័យ ប្រភេទ@ info: whatsthis',
                    addToCaseBase: 'បន្ថែម ទៅ បណ្ណាល័យ អក្សរ',
                    storedIn: 'បាន ទុក ក្នុង@ info: whatsthis',
                    pleaseSelect: 'សូម ជ្រើស',
                    reasonsForRecommendation: 'មូលហេតុ សម្រាប់ អនុញ្ញាត',
                    pleaseEnter: 'សូម បញ្ចូល',
                },
            },
            shareModal: {
                index: {
                    customer: 'ម៉ាស៊ីន ភ្ញៀវ ៖',
                    employees: 'ម៉ាស៊ីន ភ្ញៀវ ៖',
                    timeliness: 'បន្ទាត់ ពេលវេលា ៖',
                    recordingLinkValidWithinDays: 'ការ ថត តំណ គឺ ត្រឹមត្រូវ ក្នុង ថ្ងៃ',
                    sharingInstructions: 'ការ ពិពណ៌នា ៖',
                    shareSuccess: 'ការ ចែករំលែក ជោគជ័យ !',
                    cancel: 'បោះបង់',
                    share: 'ចែក រំលែក',
                    copySucceeded: 'ចម្លង បាន ជោគជ័យ !',
                    copyShareLink: 'ចម្លង តំណ ចែក រំលែក',
                    shareWithColleagues: 'ចែករំលែក ជាមួយ អ្នក ភ្ញៀវ',
                    shareWithCustomers: 'ចែករំលែក ជាមួយ ម៉ាស៊ីន ភ្ញៀវ',
                    staff: 'ការងារ',
                    selectColleagues: 'ជ្រើស អ្នក ភ្ញៀវ',
                    pleaseSelectColleaguesToShare: 'សូម ជ្រើស អ្នក ភ្ញៀវ ដើម្បី ចែក រំលែក',
                    pleaseEnterTheSharingDescription: 'សូម បញ្ចូល សេចក្ដី ណែនាំ ចែក រំលែក',
                    taskName: 'ភារកិច្ច ៖',
                    recordingShareValidWithinDays: 'ការ ចែក រំលែក តំណ ត្រឹមត្រូវ ក្នុង ថ្នាក់',
                },
            },
            waveAudio: {
                index: {
                    theFileCannotBeFound: 'មិន អាច រក ឃើញ ឯកសារ !',
                    sale: 'ចម្លង ៖',
                    customer: 'ម៉ាស៊ីន ភ្ញៀវ ៖',
                    topicDetection: 'ការ រក ឃើញ បទ ៖',
                    keyEvents: 'ព្រឹត្តិការណ៍ សោ ៖',
                },
            },
            helpCommentModal: {
                index: {
                    selectColleagues: 'ជ្រើស អ្នក ភ្ញៀវ',
                    helpContent: 'មាតិកា ជំនួយ',
                    visibleRange: 'ជួរ ដែល អាច មើល ឃើញ',
                    seekCounseling: 'ស្វែងរក ការ ជំនួយ',
                },
            },
            commentDispalyItem: {
                index: {
                    seekAdvice: 'ស្វែងរក សំណួរ',
                    concatText: 'ទៅ',
                },
            },
            customerInsight: {
                index: {
                    customerInformation: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
                    customerInsight: 'សមត្ថភាព របស់ អ្នក ភ្ជាប់',
                    customerLabel: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
                },
            },
            intelligentRecommend: {
                index: {
                    scriptRecommendation: 'ការ និយាយ ផ្ដល់ អនុសារ',
                    objectionHandlingScripts: 'ការ ដោះស្រាយ ទិន្នន័យ',
                    productSellingPointScripts: 'ចំណុច ចែក លទ្ធផលName',
                    knowledgePointRecommendation: 'ការ ផ្ដល់ អនុសាសន៍ ចំណុច ចំណុច',
                    relatedKnowledgePoints: 'ចំណុច សៀវភៅ ដែល ទាក់ទង',
                    recommendedCases: 'អនុសាសន៍ តួអក្សរ',
                },
            },
            supervision: {
                index: {
                    scriptRecommendation: 'ការ និយាយ ផ្ដល់ អនុសារ',
                    caseRecommendation: 'អនុសាសន៍ តួអក្សរ',
                    hit: 'បិទ',
                    miss: 'បាត់Comment',
                    supervisionItem: 'ធាតុ មួយ',
                    implementation: 'ស្ថានភាព អនុញ្ញាត',
                    reInspection: 'ឡើង វិញ',
                    supervisionItemSettings: 'ការ កំណត់ ធាតុ មួយ',
                },
            },
            supervisionClassificationModal: {
                index: {
                    telephoneCall: 'ហៅ ទូរស័ព្ទ',
                    enterpriseWeChatCall: 'សៀវភៅ មីក្រូ',
                    enterpriseMicroConversation: 'សម័យ micro-section Enterprise',
                    open: 'បើក',
                    close: 'បិទ',
                    conversationScenario: 'សម័យ',
                    monitorConversationChannels: 'ត្រួតពិនិត្យ ឆានែល ស្វែងរក',
                    permanentlyValid: 'មាន ប្រយោជន៍ ធម្មតា',
                    permanentlyInvalid: 'មិន ត្រឹមត្រូវ',
                    customValidity: 'រយៈពេល មាន សុពលភាព ផ្ទាល់ខ្លួន',
                    termOfValidity: 'រយៈពេល មាន សុពលភាព',
                    newRating: 'ការ វាយតម្លៃ ថ្មី',
                    whenConversation: 'ពេល សម័យ',
                    hit: 'បិទ',
                    miss: 'បាត់Comment',
                    time: 'នៅ ពេល បញ្ចូល',
                    rated: 'ការ វាយតម្លៃ',
                    qualified: 'បាន បញ្ចប់',
                    unqualified: 'មិន បាន ត្រឹមត្រូវ',
                    modifiedSuccessfully: 'ការ កែប្រែ បាន ជោគជ័យ',
                    classificationName: 'ឈ្មោះ ប្រភេទ',
                    supervisionObject: 'វត្ថុ របស់ មួយ',
                    entryintoforceTime: 'ពេលវេលា មាន ប្រយោជន៍',
                    supervisionItemRating: 'ការ វាយតម្លៃ របស់ ធាតុ ត្រួត ពិន្ទុ',
                    pleaseCheckWhetherTheRatingOfSupervisionItemIsCorrect: 'សូម ពិនិត្យ មើល ថាតើ ការ ត្រួត ពិនិត្យ ត្រឹមត្រូវ',
                    ratingRules: 'ច្បាប់ ការ វាយតម្លៃ',
                    settingOfRatingRulesForSupervisionItems: 'ការ កំណត់ ការ វាយតម្លៃ ធាតុ',
                },
            },
            reInspect: {
                index: {
                    keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                    supervisionItem: 'ធាតុ មួយ',
                    conversationScenario: 'សម័យ',
                    customerLabel: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
                    reDetectionRules: 'ប្ដូរ ទិន្នន័យ',
                },
            },
            audioPlayerBar: {
                index: {
                    downloadRecording: 'ទាញយក ថត',
                    downloadText: 'ទាញយក អត្ថបទName',
                },
            },
        },
        imgUpload: {
            index: {
                uploadPictures: 'ផ្ទុក រូបភាព ឡើង',
                pleaseSelectAPictureWithASizeOfNoMoreThankb: 'សូម ជ្រើស រូបភាព ដែល មាន ទំហំ ដែល មិន មែន ជា 2048 kb',
            },
        },
        chatRecord: {
            chatRecordItem: {
                components: {
                    debugInfo: {
                        or: 'ឬ ថត',
                        and: 'និង សិទ្ធិ',
                        wrong: 'កុំ',
                        matchTo: 'ផ្គូផ្គង',
                        rule: 'បន្ទាត់',
                        satisfactionOperator: 'ប្រសើរ',
                        customerLabel: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
                        keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                        knowledgePoints: 'ចំណុច ស្គាល់ ចំណុច',
                        sessionLabel: 'ស្លាក សម័យ',
                        supervisionItem: 'ធាតុ មួយ',
                    },
                    linkExplorer: {
                        linkInTheText: 'តំណ ក្នុង អត្ថបទ ៖',
                    },
                    index: {
                        unsupportedMessageType: 'ប្រភេទ សារ ដែល មិន បាន គាំទ្រ',
                        locationInformation: 'ព័ត៌មាន ទីតាំង',
                        businessCard: 'កាត ពាក្យ',
                        smallProgram: 'កម្មវិធី តូចៗ',
                        videoNumber: 'លេខ វីដេអូ',
                    },
                    translate: {
                        index: {
                            translation: 'ការ បក ប្រែ',
                        },
                    },
                    imageRecognition: {
                        index: {
                            imageRecognitionSuccessful: 'ការ ស្គាល់ រូបភាព បាន ជោគជ័យ',
                            imageRecognitionFailed: 'បាន បរាជ័យ ក្នុង ការ ស្គាល់ រូបភាពName',
                        },
                    },
                },
                index: {
                    system: 'ប្រព័ន្ធ',
                    customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    robot: 'Robot',
                    customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                    silence: 'ស្គាល់',
                    theFollowingIsTheBotServiceMessage: 'ខាងក្រោម គឺ ជា សារ សេវា របស់ BotName',
                    theFollowingIsTheHumanServiceMessage: 'ដូច ខាង ក្រោម គឺ សារ សេវា ជា មនុស្សName',
                },
            },
        },
        createForm: {
            field: {
                customComponentNotFound: 'រក មិន ឃើញ សមាសភាគ ផ្ទាល់ខ្លួន ៖',
            },
        },
        sdkLoaderBase: {
            component: {
                custom: 'ផ្ទាល់ខ្លួន',
            },
            dropdownMonit: {
                updateSucceeded: 'ធ្វើ ឲ្យ ទាន់សម័យ បាន ជោគជ័យ',
                areYouSureToDelete: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                custom: 'ផ្ទាល់ខ្លួន',
            },
            modalMonit: {
                saveCurrentReportConfigurationForm: 'រក្សាទុក ការ កំណត់ រចនា សម្ព័ន្ធ របាយការណ៍ បច្ចុប្បន្ន = === សំណុំ បែបបទ@ info: whatsthis',
                saveCurrentReportConfiguration: 'រក្សាទុក ការ កំណត់ រចនាសម្ព័ន្ធ របាយការណ៍ បច្ចុប្បន្ន',
                pleaseEnterTheNameOfCommonSettingsTheMaximumLengthIs: 'សូម បញ្ចូល ឈ្មោះ ការកំណត់ ធម្មតា ប្រវែង អតិបរមា គឺ ២០ !',
                preservation: 'រក្សាទុក',
            },
            template: {
                saveCurrentReportConfiguration: 'រក្សាទុក ការ កំណត់ រចនាសម្ព័ន្ធ របាយការណ៍ បច្ចុប្បន្ន',
                updateCurrentReportConfiguration: 'ធ្វើ ឲ្យ ការ កំណត់ រចនាសម្ព័ន្ធ របាយការណ៍ បច្ចុប្បន្ន',
            },
        },
        audioCallBasicInfoV2: {
            template: {
                processingTime: 'ពេលវេលា ដំណើរការ',
                customFields: 'វាល ផ្ទាល់ខ្លួន',
                customerInformation: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
                associatedWorkOrder: 'លំដាប់ ការងារ',
                workOrderInformation: 'ព័ត៌មាន លំដាប់ ការងារ',
                workOrder: 'លំដាប់ ការងារ',
                triggerScenario: 'ចំណុច ប្រសើរ',
                associatedCallConversation: 'ទាក់ទង/ ការ ហៅ/ ចង្អុល',
            },
        },
        audioCallContentInfoV2: {
            components: {
                testBtn: {
                    testWithCurrentCommunicationDialogueText: 'សាកល្បង ជាមួយ អត្ថបទ សម្ងាត់/ ប្រអប់ បច្ចុប្បន្ន',
                },
            },
            index: {
                originalSentence: 'ពាក្យ ដើម',
                clause: 'ក្រោយ',
            },
        },
        checkPointOperatorListGather: {
            template: {
                whetherOverlappingStatementsAreIgnored: 'ថាតើ មិន អើពើ សេចក្ដី ពណ៌នា ដែល ពង្រីក ត្រូវ បានអើពើ',
                overlappingSpeechResponse: 'ឆ្លើយតប និយាយ ដក',
                section: 'ភាគComment',
                day: 'ថ្ងៃStencils',
            },
            businessSummary: {
                normal: {
                    equalTo: 'ស្មើ',
                    notEqualTo: 'មិន ស្មើ',
                    contain: 'មាន ថ្មី',
                    excluding: 'មិនមាន ទេ',
                },
            },
            externalInterfaceCheck: {
                normal: {
                    equalTo: 'ស្មើ',
                    contain: 'មាន ថ្មី',
                    informationEntity: 'ធាតុ ព័ត៌មាន',
                    followthepathField: 'វាល ផ្លូវ តាម បន្ទាត់',
                    fixedValue: 'តម្លៃ ថេរ',
                    pleaseSelectAnOperator: 'សូម ជ្រើស ប្រហែល',
                    pleaseSelectADataType: 'សូម ជ្រើស ប្រភេទ ទិន្នន័យ',
                    pleaseSelect: 'សូម ជ្រើស',
                    whenNoResultIsReturned: 'នៅពេល គ្មាន លទ្ធផល ត្រូវ បាន ត្រឡប់@ info: whatsthis',
                    theResultIsYes: 'លទ្ធផល គឺ "បាទ"',
                    resultIsNo: 'លទ្ធផល គឺ "គ្មាន"',
                },
            },
            associate: {
                advanced: {
                    valueTemplate: 'ពុម្ព តម្លៃ',
                },
                normal: {
                    processingTime: 'ពេលវេលា ដំណើរការ',
                    customFields: 'វាល ផ្ទាល់ខ្លួន',
                    customerInformation: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
                    workOrderInformation: 'ព័ត៌មាន លំដាប់ ការងារ',
                    anyWorkOrder: 'លំដាប់ ការងារ',
                    allWorkOrders: 'លំដាប់ ការងារ ទាំងអស់',
                },
                index: {
                    operatorHitResultWhenTheDataSourceIsNot: 'ប្រតិបត្តិការ លទ្ធផល នៅពេល ប្រភព ទិន្នន័យ',
                    yes: 'បាន',
                    no: 'គ្មាន ទេ',
                },
            },
            semanticMatching: {
                index: {
                    pleaseEnterALargeModelPrompt: 'សូម បញ្ចូល ម៉ូដែល សួរ ខ្ពស់',
                },
            },
            multiModal: {
                normal: {
                    pleaseEnterALargeModelPrompt: 'សូម បញ្ចូល ម៉ូដែល សួរ ខ្ពស់',
                    whenThereIsNoSuchData: 'នៅពេល ដែល គ្មាន ទិន្នន័យ ដូច នេះ',
                },
            },
        },
        massagePushConfiguration: {
            component: {
                iAmMeItsADifferentFireworksxxxx8827: 'ខ្ញុំ ជា អ្វី ដែល ខ្ញុំ ជា ភ្លើង ផ្សេង ទៀត @ 156xxxx8827Name',
                hiThisIsTheNotificationOfRobotQualityInspectionWarningMessageSinceItWasAddedToTheGroupOnOctober: 'ជំនួស ខ្ញុំ ជា ការ ជូន ដំណឹង នៃ សារ ការ ព្រមាន ការ ត្រួត ពិនិត្យ គុណភាព រ៉ូប៊ី ដែល ត្រូវ បាន បន្ថែម ទៅ ក្រុម នៅ ទី ១៧ ខែ ចុច',
            },
            interfacePush: {
                component: {
                    iAmMeItsADifferentFireworksxxxx8827: 'ខ្ញុំ ជា អ្វី ដែល ខ្ញុំ ជា ភ្លើង ផ្សេង ទៀត @ 156xxxx8827Name',
                    hiThisIsTheNotificationOfRobotQualityInspectionWarningMessageSinceItWasAddedToTheGroupOnOctober: 'ជំនួស ខ្ញុំ ជា ការ ជូន ដំណឹង នៃ សារ ការ ព្រមាន ការ ត្រួត ពិនិត្យ គុណភាព រ៉ូប៊ី ដែល ត្រូវ បាន បន្ថែម ទៅ ក្រុម នៅ ទី ១៧ ខែ ចុច',
                },
            },
            associateSelect: {
                const: {
                    communicationTheme: 'ស្បែក ទំនាក់ទំនង',
                    conversationSummary: 'សង្ខេប សម័យ',
                    serviceSuggestions: 'ការ អនុសាសន៍ សេវាName',
                },
                template: {
                    associatedWorkOrder: 'លំដាប់ ការងារ',
                    smartTags: 'ស្លាក ឆ្លាត',
                },
            },
            otherPush: {
                template: {
                    customPushDestination: 'ចុច ទិសដៅ ផ្ទាល់ខ្លួន',
                },
                components: {
                    ticketConfig: {
                        index: {
                            pleaseEnterTheAcceptanceCustomerServiceEmailOnlyOneIsSupported: 'សូម បញ្ចូល អ៊ីមែល សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ ដែល ត្រូវ បាន គាំទ្រ តែ មួយ ប៉ុណ្ណោះ ។',
                            acceptCustomerService: 'ទទួល យក សេវា ម៉ាស៊ីន ភ្ញៀវ',
                            customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                            dontSetUpAcceptCustomerService: 'កុំ រៀបចំ ទទួល សេវា របស់ ភ្ញៀវ',
                            specifyMailbox: 'បញ្ជាក់ ប្រអប់ សំបុត្រ',
                            workOrderTitle: 'ចំណង ជើង លំដាប់ ការងារ',
                        },
                    },
                    callingRobotConfig: {
                        index: {
                            workingTimeID: 'លេខ សម្គាល់ ពេលវេលា ការងារ',
                            taskName: 'ឈ្មោះ ភារកិច្ច',
                            pleaseEnter: 'សូម បញ្ចូល',
                            outcallTemplateID: 'លេខ សម្គាល់ ពុម្ព ក្រៅ',
                            pleaseEnterIntOnly: 'សូម បញ្ចូល តែ អ៊ីមែល ប៉ុណ្ណោះ',
                            outcallRobotDefinitionID: 'លេខ សម្គាល់ ការ កំណត់ រចនា សម្ព័ន្ធ',
                            callingNumberType: 'ប្រភេទ លេខ ហៅ',
                            relayNumber: 'លេខ ឡើង វិញ',
                            numberPool: 'ចំណុច លេខName',
                            pleaseSelect: 'សូម ជ្រើស',
                            callingNumberValue: 'តម្លៃ ហៅ លេខComment',
                            contactListID: 'លេខ សម្គាល់ បញ្ជី ទំនាក់ទំនង',
                            workEventID: 'លេខ សម្គាល់ ព្រឹត្តិការណ៍ ការងារ',
                        },
                    },
                },
            },
        },
        productMatrix: {
            index: {
                clickToLearnMore: 'ចុច ដើម្បី សិក្សា ផ្សេងទៀត',
            },
            schema: {
                textRobot: 'រ៉ូប៊ុម អត្ថបទ',
                trainerEscortDocumentQATaskDialogueTableQAAtlasQA: 'កម្មវិធី បង្ហាញ សំណួរ និង ឆ្លើយតប ឯកសារ ប្រអប់ មូលដ្ឋាន លើ ភារកិច្ច សំណួរ និង ឆ្លើយតប តារាង ក្រាហ្វ និង ចម្លើយ ។',
                capitalRetentionRobot: 'រ៉ូប៊ុម',
                richInquiryAndRetentionStrategiesHighPersonificationCommunicationEnsuringHighRetentionRateAndEfficientAutomaticConversionOfClues: 'វិធីសាស្ត្រ ការ ថែទាំ ទាក់ទង នឹង ការ ទំនាក់ទំនង កម្រិត ខ្ពស់ ដើម្បី ប្រាកដ អត្រា ការ ថែទាំ ខ្ពស់ ចំណាំ ការ បម្លែង ដោយ ស្វ័យ ប្រវត្តិ ។',
                outboundRobot: 'រ៉ូប៊ុម',
                workOrderCompletionReturnVisitServiceSatisfactionSurveyOperationAndMaintenanceFaultWarningPromptOrderDeliveryReminderEcommerceActivityNoticeCandidateAppointmentAndHelpBusinessAutomationAndBusinessEfficiencyImprovement: 'ការ បញ្ចប់ លំដាប់ ការងារ ការងារ បញ្ចប់ ការ ទស្សនា ការ ស្វែងរក ការ សម្រាក របស់ សេវា ប្រតិបត្តិការ និង ការ ព្រមាន បរាជ័យ ក្នុង ការ ថែទាំ, ការ រំលឹក បញ្ជូន លំដាប់ ។ ការ ជូន ដំណឹង សកម្មភាព អ៊ីស្រាអែល, ការ កំណត់ រចនា សម្ព័ន្ធ អ្នក ឯកសារ',
                incomingRobot: 'រ៉ូប៊ុម ចូលName',
                flexiblyIntegrateWorkOrdersOrdersAndOtherBusinessSystemsToRealizeProcessAutomationCustomizedRecognitionOfSpeechSemanticModelAndTheBusinessEffectIsImmediateEntitymobilePhoneNumberOrderAmountOrderTimeAddressIdentificationToQuicklySupportComplexBusiness: 'ការ រួមបញ្ចូល លំដាប់ ការងារ លំដាប់ លំដាប់ និង ប្រព័ន្ធ បណ្ដាញ ផ្សេង ទៀត ដើម្បី ធ្វើ ឲ្យ ដំណើរការ ដោយ ស្វ័យ ប្រវត្តិ សំឡេង ម៉ូឌុល សំឡេង ដែល បាន ទទួល ស្គាល់ តាម បំណង លទ្ធផល រហ័ស ភ្លាមៗ ។ Entity (លេខ ទូរស័ព្ទ ទូរស័ព្ទ ចំនួន លំដាប់ ពេលវេលា លំដាប់ អាសយដ្ឋាន...) ការ គាំទ្រ លឿន',
                intelligentQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
                fullQualityInspectionTimelyAndEfficientWithAnAccuracyRateOf: 'ការ ត្រួត ពិនិត្យ គុណភាព ពេញលេញ ពេលវេលា និង មាន ប្រយោជន៍ ដែល មាន អត្រា ភាព ត្រឹមត្រូវ',
                intelligentSessionAnalysis: 'ការ វិភាគ សម័យ ជម្រះ',
                insightIntoBusinessWeaknessesListenToTheVoiceOfCustomersAndImproveMarketingTransformation: 'សមត្ថភាព ក្នុង ក្ដារ ដំណើរការ ខ្លី សូម ស្ដាប់ សំឡេង របស់ អ្នក ភ្ញៀវ បង្កើន ការ បម្រុង ទៀត',
                enterpriseWechatConversationAnalysis: 'ការ វិភាគ សម័យ WeChat Enterprise',
                effectivelyIdentifyPotentialBusinessOpportunitiesAndRisksAndIncreaseTheMarketingConversionRateBy: 'ការ កំណត់ អត្តសញ្ញាណ មាន ប្រយោជន៍ នៃ ដំណោះស្រាយ រហ័ស គ្រោះថ្នាក់ អត្រា បម្លែង ប្រតិបត្តិការ បង្កើន កម្លាំង តាម 20%Name',
                assistant: 'អ្នក ជំនួយ',
                theAgentAssistantCanGuaranteeTheNoviceCustomerServiceToCompleteTheServiceAndImproveTheCallQualityOfTheSkilledCustomerServiceLetEverySeatBeYourTrumpCard: 'អ្នក ជំនួយការ អាច ប្រាកដ សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ ថ្មី និង ធ្វើ ឲ្យ ប្រសើរ គុណភាព ហៅ របស់ សេវា របស់ ភ្ញៀវ ដែល មាន សិទ្ធិ ។ អនុញ្ញាត ឲ្យ មាន ចំណុច រាល់ គ្នា ជា កាត កណ្ដាល របស់ អ្នក',
                digitalPeople: 'មនុស្ស ឌីជីថល',
                FaceToFaceAnthropomorphicCommunicationSupportVoiceTextVideoTouchMultimodalInteractionAchieveImmersiveCommunicationExperienceAndImproveBrandImageAndUserServiceExperience: 'ការ ទំនាក់ទំនង anthropomorphic "Face-to-face" គាំទ្រ សំឡេង អត្ថបទ វីដេអូ តភ្ជាប់ ច្រើន-ម៉ូឌុល ដើម្បី ទទួល យក មេរៀន ទំនាក់ទំនង បង្កើន រូបភាព កម្រិត និង សេវា អ្នកប្រើ',
                aIKnowledgeZhongtaiEnterpriseSearch: 'ស្វែងរក មធ្យោបាយ ការ ស្វែងរក មធ្យម',
                knowledgeSearchKnowledgeSharingDocumentSearchDatabaseDockingSearch: 'ស្វែងរក ស្វែងរក ការ ចែករំលែក សាធារណៈ ការ ស្វែងរក ឯកសារ មូលដ្ឋាន ទិន្នន័យ',
                aIKnowledgeCenterKCsKnowledgeBase: 'AI knowledge Dek កណ្ដាល · KCS KnowledgeName',
                provideFullLifecycleManagementOfKnowledgeUnifiedMaintenanceOfRobotAndImKnowledgeBaseSupportDockingWithThirdpartyKnowledgeBaseKnowledgeTemplateAtomicKnowledgeAndOtherPowerfulFunctionsToBringMoreConvenientKnowledgeManagementExperience: 'ផ្ដល់ ការ គ្រប់គ្រង រង្វង់ ជីវិត ពេញលេញ នៃ ស្គាល់, ថែទាំ រ៉ូប៊ី និង មូលដ្ឋាន សាធារណៈ IM គាំទ្រ ការ ចត ជាមួយ មូលដ្ឋាន សម្គាល់ ភាគ ទីបី ពុម្ព សាធារណៈ ស្គាល់ អាតូម និង មុខងារ ដែល មាន ឥទ្ធិពល ផ្សេង ទៀត ដើម្បី នាំ ឲ្យ មាន ភាព ត្រឹមត្រូវ ។',
                aIKnowledgeCenterKnowledgeMap: 'ផែនទី សម្គាល់ វេទិកា AI',
                oneStopMapConstructionIntegratesEnterpriseKnowledgeLargescaleMapShowsKnowledgeDetailsDockingAbilityAndCustomizedExperience: 'ការ បង្កើត ផែនទី មួយ បញ្ឈប់ ការ សម្ងាត់ រួម បញ្ចូល សញ្ញា បញ្ចូល រូបភាព ធំ បង្ហាញ សេចក្ដី លម្អិត សម្គាល់ ។ និង សមត្ថភាព ចត ដើម្បី បង្កើត បទ ពិសោធ ដែល បាន ផ្ទាល់ ខ្លួន ។',
                modularDevelopmentPlatformOriginalEngineASR: 'ម៉ូឌុល វេទិកា អភិវឌ្ឍន៍ ម៉ូឌុល',
                theEndtoendAlgorithmIsAdoptedToRealizeTheEffectExperienceOfBusinessCustomizationTheNaturalSceneRecognitionRateExceedsAndThePersonalizedVocabularyRecognitionRateExceeds97: 'ចាប់ផ្តើម អាល់ប៊ុម បញ្ចប់ បញ្ចប់ ដើម្បី ដឹង ភាព បែបផែន សេវា ដែល បាន ផ្ទាល់ ខ្លួន ។ ជាមួយ អត្រា ការ ទទួល ស្គាល់ ផែនទី ធម្មតា លើក ០០០ និង ការ ទទួល ស្គាល់ វាក្យសព្ទ ផ្ទាល់ ខ្លួន ជាង ៧៩%',
                modularDevelopmentPlatformIntelligentMarketing: 'វេទិកា អភិវឌ្ឍន៍ ម៉ូឌុល',
                makeUseOfDeepLearningAlgorithmsAndUserPortraitsToAchieveAccurateRecommendationOfGoodsAndImproveSalesConversion: 'ប្រើ អាល់ប៊ុម សិក្សា កម្រិត ដែល បាន រួមបញ្ចូល ជាមួយ រូបថត អ្នក ប្រើ ។ ដើម្បី ទទួល យក ការ ផ្ដល់ អនុសាសន៍ ត្រឹមត្រូវ នៃ វត្ថុ និង បង្កើន ការ បម្លែង ចេញ ។',
                modularDevelopmentPlatformUserPortrait: 'វេទិកា អភិវឌ្ឍន៍ ម៉ូឌុល · ច្រក អ្នកប្រើ',
                accuratelyBuildUserPortraitsBasedOnUserDataAndConversationDataToFullyDescribeCustomerCharacteristics: 'ស្ថាបនា ទម្រង់ អ្នក ប្រើ ដោយ ត្រឹមត្រូវ ដែល មាន មូលដ្ឋាន លើ ទិន្នន័យ អ្នក ប្រើ និង ប្រអប់ ការ ពិពណ៌នា លក្ខណៈ សម្បត្តិ របស់ ម៉ាស៊ីន ភ្ញៀវ ពេញលេញ',
                modularDevelopmentPlatformIntelligentRecommendation: 'វេទិកា អភិវឌ្ឍន៍ ម៉ូឌុល',
                automaticallyRecommendProductsThatUsersMayBeInterestedInAccordingToUserPortraitsAndProductPortraitsAndRealizePersonalizedRecommendationForThousandsOfPeople: 'ផ្ដល់ អនុសាសន៍ ដោយ ស្វ័យ ប្រវត្តិ ដោយ ស្វ័យ ប្រវត្តិ ដែល អាច មាន ទំនាក់ទំនង សម្រាប់ អ្នក ប្រើ ដែល មាន មូលដ្ឋាន លើ រូបថត អ្នក ប្រើ និង រូបរាង ការ អនុញ្ញាត ឲ្យ ផ្ទាល់ខ្លួន ផ្ទាល់ ខ្លួន សម្រាប់ មនុស្ស ។',
                modularDevelopmentPlatformNLPPAAS: 'វេទិកា អភិវឌ្ឍន៍ ម៉ូឌុល · NLP PaaS',
                provideNLPBasicCapabilitiesWithHighAccuracyCoveringTheUnderlyingCapabilitiesOfDifferentGranularitySuchAsWordsSentencesAndArticles: 'ផ្ដល់ សមត្ថភាព NLP មូលដ្ឋាន ដែល មាន ភាព ត្រឹមត្រូវ ខ្ពស់ បង្កើន សមត្ថភាព កម្រិត ទាប នៃ ភាព ផ្សេងៗ ដូចជា ពាក្យ ប្រយោជន៍ និង អត្ថបទ ។',
            },
        },
        qualityScore: {
            index: {
                show: 'បង្ហាញ ៖',
                displayBySecondaryClassification: 'បង្ហាញ តាម ទិន្នន័យ ទីពីរName',
                showByRule: 'បង្ហាញ តាម បន្ទាត់',
                pleaseEnterClassificationruleName: 'សូម បញ្ចូល ឈ្មោះ ត្រួត ពិន្ទុ',
                clickCopy: 'ចុច ចម្លង',
                hitDetailsOfOperatorsInRules: 'ប្រតិបត្តិការ លម្អិត ក្នុង ច្បាប់ ៖',
                hit: 'បិទ',
                miss: 'បាត់Comment',
                filter: 'តម្រង ៖',
                clickToViewDetails: 'ចុច ដើម្បី មើល សេចក្ដី លម្អិត',
            },
            components: {
                flowNodeList: {
                    branch: 'ចំណុច',
                    pleaseSelect: 'សូម ជ្រើស',
                    viewTheCompleteProcess: 'មើល ដំណើរការ ពេញលេញ',
                    thereIsCurrentlyNoProcessAvailable: 'គ្មាន ដំណើរការ',
                },
                pointItem: {
                    xiangHit: 'ធាតុ បាញ់',
                },
                flowNodeListModal: {
                    index: {
                        completeProcess: 'ដំណើរការ បញ្ចប់',
                    },
                },
                reviewComponent: {
                    theProcessQualityInspectionTaskHasChangedPleaseAppealAgain: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ដំណើរការ បាន ផ្លាស់ប្ដូរ សូម អភិវឌ្ឍន៍ ម្ដង ទៀត ។',
                    components: {
                        reviewDetail: {
                            index: {
                                reasonsForAdoption: 'មូលហេតុ សម្រាប់ ការ តភ្ជាប់ ៖',
                                reasonForRejection: 'មូលហេតុ សម្រាប់ ការ បដិសេធ ៖',
                                secondaryReview: 'មើល រង',
                                firstlevelReview: 'មើល កម្រិត ទី មុន',
                            },
                        },
                    },
                    index: {
                        pleaseEnterAReason: 'សូម បញ្ចូល មូលដ្ឋាន',
                        reasonsForAdoption: 'មូលហេតុ សម្រាប់ ការ តភ្ជាប់ ៖',
                        reasonForRejection: 'មូលហេតុ សម្រាប់ ការ បដិសេធ ៖',
                        attachments: 'ឯកសារ ភ្ជាប់ ៖',
                    },
                },
                annotation: {
                    index: {
                        annotation: 'ចំណារ ព័ត៌មាន',
                        ruleAnnotation: 'ចំណារ បន្ទាត់',
                        areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                        preserve: 'រក្សាទុក',
                        cancel: 'បោះបង់',
                        callout: 'ការ ហៅ',
                    },
                },
                uplaod: {
                    index: {
                        uploadFile: 'ផ្ទុក ឯកសារ',
                    },
                },
            },
        },
        recordDetail: {
            template: {
                processingTime: 'ពេលវេលា ដំណើរការ',
                communicationDialogueInformation: 'ព័ត៌មាន ប្រអប់ ទំនាក់ទំនង',
                problemExtraction: 'ស្រង់ បញ្ហា',
                customFields: 'វាល ផ្ទាល់ខ្លួន',
                customerInformation: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
                information: 'ព័ត៌មាន',
                associatedWorkOrder: 'លំដាប់ ការងារ',
                commentInformation: 'ព័ត៌មាន សេចក្ដី អធិប្បាយ',
                theDataHasBeenClearedPeriodically: 'ទិន្នន័យ នេះ ត្រូវ បាន ជម្រះ តាម រយៈពេល',
                subject: 'ប្រធាន បទ ៖',
                description: 'សេចក្ដី ពិពណ៌នា ៖',
            },
            components: {
                addToTask: {
                    index: {
                        addToQualityInspectionTask: 'បន្ថែម ទៅ ភារកិច្ច គុណភាព',
                    },
                },
            },
        },
        relatedDetail: {
            index: {
                associatedCallConversation: 'ទាក់ទង/ ការ ហៅ/ ចង្អុល',
            },
        },
        samplingTarget: {
            index: {
                time: 'នៅ ពេល បញ្ចូល',
                samplingQuantityIsLessThan: 'ចំនួន គំរូ ដែល ទាប',
                alertWhen: 'ការ ព្រមាន មុន',
                everyday: 'ថ្ងៃថែម',
                weekly: 'សប្ដាហ៍',
                monthly: 'រាល់ ខែ',
                samplingInspectionTargetSavedSuccessfully: 'គោលដៅ ត្រួតពិនិត្យ គំរូ បាន រក្សាទុក ដោយ ជោគជ័យ',
                personnel: 'ភ្ញៀវ',
                eachCustomerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ នីមួយៗ',
                cycle: 'រង្វង់Comment',
                samplingInspectionTarget: 'គោលដៅ ត្រួតពិនិត្យ គំរូ',
                strip: 'អត្ថបទ',
                alertSettings: 'ការ កំណត់ ព្រមានComment',
            },
        },
        samplingTargetBanner: {
            index: {
                customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                complete: 'បញ្ចប់',
                Objective: 'បណ្ដាញ',
                everyday: 'ថ្ងៃថែម',
                weekly: 'សប្ដាហ៍',
                monthly: 'រាល់ ខែ',
            },
        },
        sessionInsights: {
            components: {
                groupChatInteractionRate: 'អត្រា អន្តរកម្ម ជជែក ក្រុម',
                maximumResponseIntervalTime: 'ចន្លោះពេល អតិបរមា រវាង ឆ្លើយតប',
                numberOfPreemptiveCalls: 'ចំនួន ការ បិទ',
                numberOfMessages: 'ចំនួន សារ',
                strip: 'អត្ថបទ',
                proportionOfMessages: 'ភាគរយ នៃ ចំនួន សារ',
                speechPercentage: 'ការ និយាយ សមាមាត្រ',
                longestCustomerTalk: 'និយាយ អ្នក ភ្ញៀវ វែង',
                numberOfIndepthDiscussions: 'ចំនួន ការ ពិពណ៌នា ជម្រៅ',
                second: 'ពេលវេលាName',
                maximumDurationOfContinuousSpeech: 'ថិរវេលា ដែល និយាយ បន្ត អតិបរមា',
                questionFrequency: 'ប្រេកង់ សំណួរ',
                customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                keyEvents: 'ព្រឹត្តិការណ៍ សោ ៖',
                opportunity: {
                    index: {
                        generationFailed: 'បរាជ័យ ក្នុងកា រ ស្ថាបត្រ',
                        generateOpportunityPoints: 'បង្កើត ចំណុច ជំនួយ',
                    },
                },
                sessionSummary: {
                    index: {
                        generationFailed: 'បរាជ័យ ក្នុងកា រ ស្ថាបត្រ',
                        generateSummary: 'បង្កើត សង្ខេប',
                    },
                },
            },
            index: {
                areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                add: 'បន្ថែម@ info: whatsthis',
                opportunityPoints: 'ចំណុច ជំនួយ',
                conversationSummary: 'សង្ខេប សម័យ',
                cancel: 'បោះបង់',
                determine: 'កំណត់@ info: whatsthis',
                edit: 'កែសម្រួល',
                establish: 'បង្កើត@ info: whatsthis',
                conversationalInsights: 'សម័យ សម័យ',
                keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                numKeyEvents: 'ព្រឹត្តិការណ៍ សោ',
                questionAnalysis: 'ការ វិភាគ នៃ សំណួរ',
                find: 'រក ឃើញ@ info: whatsthis',
                questions: 'សំណួរ ទីពីរ',
                conversationAction: 'សកម្មភាព សម័យ',
                customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                sale: 'ល្អ',
                sessionLabel: 'សម័យ',
                employeeQuestions: 'សួរ សំណួរ',
                customerQuestions: 'សំណួរ ម៉ាស៊ីន ភ្ញៀវ',
            },
        },
        ticketTextInfo: {
            index: {
                customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                replyTo: 'ឆ្លើយតប',
                addressee: 'ទៅ ៖',
            },
            components: {
                call: {
                    index: {
                        initiateOutcall: 'ចាប់ផ្ដើម រុករក ក្រៅ',
                        callInformation: 'ព័ត៌មាន ហៅ ៖',
                        assignedNumber: 'លេខ ដែល បាន ផ្ដល់ ៖',
                        assignAgent: 'ផ្ដល់ ភ្នាក់ងារ ៖',
                        answerDelay: 'ការ ពន្យារ ចម្លើយ ៖',
                        answerNumber: 'លេខ ចម្លើយ ៖',
                        callMode: 'របៀប ហៅ ៖',
                        status: 'ស្ថានភាព ៖',
                        callDuration: 'ថិរវេលា ហៅ ៖',
                        yourBrowserDoesNotSupportTheAudioElement: 'កម្មវិធី រុករក របស់ អ្នក មិន គាំទ្រ ធាតុ អូឌីយ៉ូ ទេ ។',
                    },
                },
                remark: {
                    index: {
                        notesAdded: 'បាន បន្ថែម ចំណាំName',
                        recipient: 'អ្នក ទទួល',
                    },
                },
                textMessage: {
                    index: {
                        sendSMS: 'ផ្ញើ SMS',
                        basicInformation: 'ព័ត៌មាន មូលដ្ឋាន ៖',
                        mobilePhoneNumber: 'លេខ ទូរស័ព្ទ ចល័ត ៖',
                        sendObject: 'ផ្ញើ វត្ថុ ៖',
                        sMSTemplate: 'ពុម្ព SMS ៖',
                        sendResults: 'ផ្ញើ លទ្ធផល ៖',
                        sMSContent: 'មាតិកា SMS ៖',
                    },
                },
                changeRecord: {
                    index: {
                        workOrderCreated: 'បាន បង្កើត លំដាប់ ការងារ',
                        triggeredTheFollowingActions: 'បាន កេះ សកម្មភាព ខាង ក្រោមName',
                    },
                },
            },
        },
        listManage: {
            template: {
                reerrorCorrection: 'កែ កំហុស ឡើង វិញ',
                areYouSureYouWantToRecorrectTheError: 'តើ អ្នក ពិត ជា ចង់ កែ កំហុស ឡើង វិញ ឬ ?',
                retranslation: 'បកប្រែ ឡើង វិញ',
                areYouSureYouWantToRetranslate: 'តើ អ្នក ពិត ជា ចង់ ធ្វើ ឡើងវិញ ឬ ?',
                sort: 'តម្រង',
                theSelectedDataLanguageIsInconsistentAndCannotBeAddedToTheQualityInspectionTask: 'ភាសា ទិន្នន័យ ដែល បាន ជ្រើស មិន ត្រឹមត្រូវ ហើយ មិន អាច ត្រូវ បាន បន្ថែម ទៅ កាន់ ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ។',
                reIdentification: 'ការ កំណត់ អត្តសញ្ញាណ ឡើង វិញ',
                rerecognitionWillConsumeTranscriptionTimePleaseOperateWithCaution: 'ការ កំណត់ អត្តសញ្ញាណ ឡើង វិញ នឹង បណ្ដោះ អាសន្ន ពេលវេលា ផ្ទេរ សូម ប្រតិបត្តិការ ដោយ សុវត្ថិភាព ។',
                determine: 'កំណត់@ info: whatsthis',
                executionSuccessful: 'ការ ប្រតិបត្តិ ដោយ ជោគជ័យ',
                addToQualityInspectionTask: 'បន្ថែម ទៅ ភារកិច្ច គុណភាព',
                batchOperation: 'ប្រតិបត្តិការ ថ្មី',
            },
        },
        addToTaskModal: {
            index: {
                successfullyAdded: 'បាន បន្ថែម ដោយ ជោគជ័យ',
                addToQualityInspectionTask: 'បន្ថែម ទៅ ភារកិច្ច គុណភាព',
                qualityInspectionTask: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
            },
        },
        customFilterModal: {
            component: {
                saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                detectRoles: 'រកឃើញ រលា',
                detectionRange: 'ជួរ រកឃើញ@ info: whatsthis',
                sentence: 'ប្រយោជន៍',
            },
            template: {
                cancelDefault: 'បោះបង់ លំនាំដើម',
                setAsDefault: 'កំណត់ ជា លំនាំដើម',
                default: 'លំនាំដើម',
            },
        },
        inspectionDetail: {
            template: {
                theDataHasBeenClearedPeriodically: 'ទិន្នន័យ នេះ ត្រូវ បាន ជម្រះ តាម រយៈពេល',
            },
        },
        backToSubSystem: {
            index: {
                returnToBusinessSystem: 'ត្រឡប់ ទៅ ប្រព័ន្ធ ពាក្យ',
            },
        },
        qualityCheckScoreTalk: {
            template: {
                overallMood: 'ស្មើ',
                problemExtraction: 'ស្រង់ បញ្ហា',
                businessSummary: 'សង្ខេប ពាក្យ',
                keyWord: 'ពាក្យ សោ',
            },
            components: {
                problemExtraction: {
                    personalityIssues: 'បញ្ហា ផ្ទាល់ខ្លួន',
                    generalQuestions: 'សំណួរ ទូទៅ',
                    positiveEmotions: 'សកម្មភាព វិសេស',
                    negativeEmotion: 'សកម្មភាព អុហ្វសិត',
                    neutralEmotion: 'សកម្មភាព អ៊ីមែល',
                    no: 'គ្មាន ទេ',
                    customerServiceDidNotAnswer: 'សេវា ម៉ាស៊ីន ភ្ញៀវ មិន បាន ឆ្លើយតប',
                    customerServiceHasAnswered: 'សេវា ម៉ាស៊ីន ភ្ញៀវ បាន ឆ្លើយតប',
                    problemUnresolved: 'មិន បាន ដោះស្រាយ បញ្ហា',
                    theProblemHasBeenResolved: 'បាន ដោះស្រាយ បញ្ហា',
                    customerIssue: 'បញ្ហា របស់ អ្នក ក្មេង ៖',
                    customerServiceAnswer: 'ចម្លើយ សេវា ម៉ាស៊ីន ភ្ញៀវ ៖',
                    reExtractQuestions: 'បញ្ហា ស្រង់ ឡើង វិញ',
                    clickToExtractQuestions: 'ចុច ដើម្បី ស្រង់ សំណួរ',
                },
            },
        },
        coach: {
            customerPortrait: {
                detail: {
                    index: {
                        portraitName: 'ឈ្មោះ ច្រក',
                        backgroundDescription: 'សេចក្ដី ពិពណ៌នា ផ្ទៃ ខាង ក្រោយ',
                        customerLabel: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
                        labelManagement: 'គ្រប់គ្រង ស្លាក',
                    },
                },
                list: {
                    components: {
                        addCustomerPortraitItemBtn: {
                            index: {
                                newlyBuild: 'ថ្មី',
                            },
                        },
                    },
                },
            },
            detailedInquiryConfig: {
                components: {
                    detailedInquiryConfigTitle: {
                        index: {
                            questioningSettings: 'ការ កំណត់ សំណួរ',
                        },
                    },
                    detailedInquiryList: {
                        index: {
                            increaseQuestioning: 'បង្កើន ការ សួរ',
                            remove: 'យក ចេញ',
                            addQuestioning: 'បន្ថែម សំណួរ',
                            section: 'ភាគComment',
                            secondInquiry: 'សំណួរ ទីពីរ',
                            questioningScore: 'ពិន្ទុ សំណួរ',
                        },
                    },
                },
                index: {
                    accordingToRules: 'តាម បន្ទាត់',
                    byScore: 'តាម ពិន្ទុ',
                    whenMissRule: 'នៅពេល ដែល បាន បាត់ ច្បាប់Name',
                    whenConductingQuestioning: 'នៅពេល សួរ សំណួរ',
                    pleaseSelectARule: 'សូម ជ្រើស ច្បាប់ នេះ',
                    ruleCannotBeEmpty: 'ច្បាប់ មិន អាច ទទេ',
                    currentScriptScore: 'ពេល ពិន្ទុ និយាយ ≤',
                    pleaseEnterTheScore: 'សូម បញ្ចូល ពិន្ទុ',
                    scoreCannotBeEmpty: 'ពិន្ទុ មិន អាច ទទេ',
                },
            },
            dialogue: {
                components: {
                    narrator: {
                        narrator: 'អ្នក និពន្ធ ៖',
                    },
                    pPT: {
                        slide: 'ស្លាយ',
                    },
                    realTimeAnalyzer: {
                        index: {
                            scriptReview: 'សេចក្តី អធិប្បាយ',
                            script: 'ពាក្យ',
                            semantics: 'Semantic',
                            violatingWords: 'ការ បំបាត់ ពាក្យ',
                            speechSpeed: 'ល្បឿន និយាយComment',
                            emotion: 'សមាសភាព',
                        },
                    },
                    scoreDetail: {
                        index: {
                            scriptReview: 'សេចក្តី អធិប្បាយ',
                            regenerate: 'បង្កើត ឡើង វិញ',
                            generate: 'បង្កើត@ info: whatsthis',
                            hitSituation: 'តួ អក្សរ',
                            noSemanticTagsMatched: 'មិន ផ្គូផ្គង នឹង ស្លាក សញ្ញា',
                            matchToSemanticTags: 'ផ្គូផ្គង ទៅ ស្លាក សំឡេង',
                            appealToBeSubmitted: 'សាកល្បង ត្រូវ បាន ដាក់ស្នើ',
                            ratingHasBeenReviewed: 'បាន ឡើង វិញ',
                            ratingAppealInProgress: 'ការ ពិន្ទុ',
                            expressionScore: 'ពិន្ទុ កន្សា',
                            moodParticlesTimes: 'ពាក្យ តូន',
                            changeTheModalParticlesTo: 'សម្រាប់ ពាក្យ modal',
                            second: 'ពេលវេលាName',
                            interrogation: 'ការ សួរ',
                            questioningWithoutScoring: 'សួរ ដោយ គ្មាន ពិន្ទុ',
                            branch: 'ចំណុច',
                            matchingRate: 'អត្រា ដែល ផ្គូផ្គង',
                            ratingAppeal: 'ការ ភ្ញៀវ អត្រា',
                            changeTo: 'ផ្លាស់ប្ដូរ',
                            wordPerMinute: 'ពាក្យ ក្នុង នាទី',
                            completeScript: 'និយាយ ពេញលេញ',
                            incompleteScript: 'និយាយ មិន បញ្ចប់',
                            semanticHit: 'សំឡេង',
                            semanticMisses: 'សញ្ញា សម្រាក',
                            scriptViolation: 'ការ បំបាត់ និយាយComment',
                            modified: 'បាន កែប្រែ',
                            notChanged: 'មិន បាន កែប្រែ',
                            keyWord: 'ពាក្យ សោ',
                            semanticLabels: 'ស្លាក semantic',
                            semanticMatchingRate: 'អត្រា ការ ផ្គូផ្គង  semantic',
                            violatingWords: 'ការ បំបាត់ ពាក្យ "',
                            delete: 'លុប',
                            unmatched: 'មិន ផ្គូផ្គង',
                            matching: 'ផ្គូផ្គង',
                            matchTo: 'ផ្គូផ្គង',
                            notMatchedTo: 'មិន ផ្គូផ្គង',
                            scriptScore: 'ពិន្ទុ និយាយComment',
                            standardScript: 'និយាយ ស្តង់ដារ',
                            emotionalScore: 'ពិន្ទុ អាក្រក់',
                            speechSpeedScore: 'ពិន្ទុ ល្បឿន',
                            viewResolution: 'គុណភាព បង្ហាញ ទិដ្ឋភាព',
                            nodeConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ ថ្នាយ',
                        },
                    },
                    userNode: {
                        theAnswerTimeForThisQuestionHasExceededAndTheAnswerContentWillBeAutomaticallySubmitted: 'ពេល វេលា ចម្លើយ របស់ សំណួរ នេះ គឺ ជា ពេលវេលា ច្រើន ហើយ មាតិកា ចម្លើយ ត្រូវ បាន ដាក់ស្នើ ដោយ ស្វ័យ ប្រវត្តិ ។',
                    },
                    knowledgeNode: {
                        theAnswerTimeForThisQuestionHasExceededAndTheAnswerContentWillBeAutomaticallySubmitted: 'ពេល វេលា ចម្លើយ របស់ សំណួរ នេះ គឺ ជា ពេលវេលា ច្រើន ហើយ មាតិកា ចម្លើយ ត្រូវ បាន ដាក់ស្នើ ដោយ ស្វ័យ ប្រវត្តិ ។',
                    },
                    correctBtn: {
                        saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                        errorCorrection: 'កែ កំហុស',
                        cancel: 'បោះបង់',
                        preserve: 'រក្សាទុក',
                    },
                },
            },
            scoringRules: {
                components: {
                    drawerTitle: {
                        scoringRules: 'ក្ដារ ពិន្ទុ',
                        cancel: 'បោះបង់',
                        determine: 'កំណត់@ info: whatsthis',
                    },
                    scoringRuleItem: {
                        whole: 'ទាំង អស់',
                        arbitrarily: 'ជម្រះ',
                        pleaseEnterARuleName: 'សូម បញ្ចូល ឈ្មោះ បន្ទាត់',
                        standardScript: 'និយាយ ស្តង់ដារ',
                        if: 'ប្រសិនបើ',
                        and: 'និង សិទ្ធិ',
                        or: 'ឬ ថត',
                        thenScore: 'បន្ទាប់ ពិន្ទុ',
                        pleaseEnterAScore: 'សូម បញ្ចូល ពិន្ទុ',
                        bonusPoints: 'ចំណុច ចំណុច',
                        minusPoints: 'ចំណុច មីន',
                        hit: 'បិទ',
                        misses: 'បាត់Comment',
                        keyWord: 'ពាក្យ សោ',
                        semantics: 'Semantic',
                    },
                    title: {
                        ruleValidation: 'ការ ផ្ទៀងផ្ទាត់ បន្ទាត់',
                        scoringRulestheTotalScoreOfTheCurrentScriptIs: 'ច្បាប់ ពិន្ទុ ( ពិន្ទុ សរុប របស់ និយាយ បច្ចុប្បន្ន',
                        points: 'ចំណុច)',
                        editRules: 'កែសម្រួល បន្ទាត់',
                    },
                },
            },
            userTagsSelect: {
                index: {
                    noLabelsCurrentlyAvailable: 'គ្មាន ស្លាក',
                },
            },
            aiGenDialogFrame: {
                components: {
                    description: {
                        index: {
                            communicationObjectives: 'គោលដៅ ទំនាក់ទំនង',
                            scoringCriteria: 'លក្ខខណ្ឌ ពិន្ទុ',
                        },
                    },
                },
                index: {
                    generating: 'កំពុង បង្កើត@ info: whatsthis',
                    generateDialogueFramework: 'បង្កើត គ្រោងការណ៍ ប្រអប់ មួយ',
                    theme: 'ស្បែក',
                },
            },
            aiGenPrompt: {
                components: {
                    title: {
                        hintLanguage: 'សួរ',
                        generatePromptLanguage: 'បាន បង្កើត សំណួរ',
                    },
                },
            },
            aiGenScore: {
                index: {
                    communicationStage: 'រូបរាង ទំនាក់ទំនង',
                    communicationObjectives: 'គោលដៅ ទំនាក់ទំនង',
                    scoringCriteria: 'លក្ខខណ្ឌ ពិន្ទុ',
                    suggestionsForImprovement: 'ការ បង្កើន ការ បង្កើន',
                },
            },
            score: {
                overview: {
                    index: {
                        processScore: 'ពិន្ទុ ដំណើរការ',
                        contentIntegrity: 'ភាព ត្រឹមត្រូវ មាតិកា ៖',
                        NumberOfCompletedProcesses: '%, ចំនួន ដំណើរការ ដែល បាន បញ្ចប់',
                        keyHitPointsTotal: 'គ្រាប់ ចុច ៖ សរុប',
                        notReached: 'មិន បាន ទទួល បាន ទេ',
                        accurateFollowupAccumulationOfStandardScripts: 'ថត ក្រោយ ត្រឹមត្រូវ ៖ ការ បង្កើត និយាយ ស្តង់ដារ',
                        theTotalNumberOfWordsHitByTheStudentAfterReading: 'ពាក្យ មួយ ចំនួន ពាក្យ គត់ ដោយ សិទ្ធិ',
                        aWord: 'ពាក្យ',
                        languageNormsYes: 'ការ បញ្ជាក់ ភាសា ៖ បាន',
                        emotionsAppearing: 'សកម្មភាព ៖',
                        speechSpeedSpeakingTooFast: 'SPEED ៖ SPEED រហ័ស',
                        modalParticlesExcessiveOccurrenceOfModalParticles: 'បំណែក ម៉ូឌុល ៖ ការ កើតឡើង ដដែលៗ ពង្រីក ភាគ ម៉ូឌុល',
                    },
                },
            },
            randomBranchConfig: {
                index: {
                    nextNodeRandomTrigger: 'កេះ ថ្នាំង ចៃដន្យ',
                    ifTheUserPortraitIsEnabledTheNodePathWillBeBasedOnTheUserPortraitAndDefaultSpeechAndTheRandomFunctionWillNotTakeEffect: 'បើ អ្នក ប្រើ ត្រូវ បាន អនុញ្ញាត ផ្លូវ ថ្នាំង នឹង មាន មូលដ្ឋាន លើ អ្នក ប្រើ និង និយាយ លំនាំដើម ។ និង អនុគមន៍ ចៃដន្យ នឹង មិន មាន ប្រសិទ្ធភាព ។',
                    pleaseSelectRandomMode: 'សូម ជ្រើស របៀប ចៃដន្យ',
                    completelyRandom: 'ចៃដន្យ',
                    pathCoverageRandom: 'ផ្លូវ ចៃដន្យ',
                },
            },
        },
        smartTags: {
            template: {
                addToIgnoreTags: 'បន្ថែម ទៅ មិន អើពើ ស្លាក',
                areYouSureYouWantToReExecuteTheSmartLabel: 'តើ អ្នក ពិត ជា ចង់ ប្រតិបត្តិ ស្លាក  smart ឡើង វិញ ឬ ?',
                reExecute: 'ការ ប្រតិបត្តិ ឡើង វិញ',
            },
            component: {
                successfullyAdded: 'បាន បន្ថែម ដោយ ជោគជ័យ',
            },
        },
        reInspectionResultModal: {
            index: {
                turnOffAllNotifications: 'បិទ ការ ជូនដំណឹង ទាំងអស់',
                reQualityInspectionTask: 'ឡើង វិញ',
                requalityInspection: 'ឡើង វិញ',
                waiting: 'រង់ចាំ',
                viewDetails: 'មើល សេចក្ដី លម្អិត',
            },
        },
        checkPointConditionListGather: {
            checkPointCondition: {
                components: {
                    applyTimeType: {
                        index: {
                            detectionTime: 'ពេលវេលា រកឃើញ ៖',
                        },
                    },
                    problemDetectionMode: {
                        index: {
                            singleSentenceDetection: 'ការ រក ឃើញ ពាក្យ មួយ',
                            multisentenceDetection: 'ការ រក ឃើញ គោលការណ៍ ច្រើន',
                            crosssentenceDetection: 'ការ រក ឃើញ សំណួរ',
                            problemDetectionMethod: 'វិធីសាស្ត្រ រក បញ្ហា ៖',
                            mostAcross: 'ភាគច្រើន ។',
                            sentence: 'ប្រយោជន៍',
                            ignoreNotGreater: 'មិន អើពើ មិន ធំ ទេ',
                            theSentenceOfTheWord: 'ពាក្យ ពាក្យ',
                            theCrosssentenceLimitIsNotGreater: 'ដែន កំណត់ ពាក្យ បញ្ជា',
                            word: 'ពាក្យ',
                        },
                    },
                    info: {
                        index: {
                            useLargeModelsForSemanticMatching: 'ប្រើ ម៉ូដែល ធំ សម្រាប់ ការ ផ្គូផ្គង សញ្ញា ។',
                            keywordsUseStrictMatchingOneLineCanEnterMultipleKeywordsKeywordsAreSeparatedByCommas: 'ពាក្យ គន្លឹះ ប្រើ ការ ផ្គូផ្គង បន្ទាត់ មួយ អាច បញ្ចូល ពាក្យ គន្លឹះ ច្រើន ពាក្យ គន្លឹះ ត្រូវ បាន បំបែក ដោយ សមត្ថភាព ។',
                            semanticTagsSupportBothStrictMatchingAndSemanticMatchingWhereSemanticTagsNeedToBeConfiguredInTheSidebarOfSmartToolsOrSemanticIntelligencesemanticTags: 'ស្លាក សំឡេង គាំទ្រ ទាំង ការ ផ្គូផ្គង និង ការ ផ្គូផ្គង សញ្ញា នៅ ទីតាំង ស្លាក semantic ត្រូវ តែ កំណត់ រចនា សម្ព័ន្ធ នៅ ក្នុង របារ ចំហៀង របស់ ឧបករណ៍ ឆ្លាត ឬ ស្លាក សញ្ញា សម្រាក ។',
                            conceptWordsAresemanticLabelsDesignedForWordsWhichCanMatchWordsStrictlyOrSemanticallyWhereConceptWordsAreConfiguredInSemanticIntelligenceconceptWords: 'ពាក្យ ទំនាក់ទំនង គឺ ជា " ស្លាក semantic" ដែល បាន រចនា សម្រាប់ ពាក្យ ដែល អាច ផ្គូផ្គង ពាក្យ បញ្ជា ឬ ជា សញ្ញា កន្លែង ដែល ពាក្យ ចំណង ជើង ត្រូវ បាន កំណត់ រចនា សម្ព័ន្ធ នៅ ក្នុង ពាក្យ ទំនាក់ទំនង ។',
                            checkWhetherTheCustomerServiceResponseTimedOutWhetherTheCustomerRespondedTimedOutAndWhetherTheCustomerDidNotRespondTheResponseStartSentenceRefersToWhetherTheResponseOfRoleAIsDetectedFromTheFirstSentenceOrTheLastSentenceOfMultipleMessagesSentContinuouslyWhenRoleAContinuouslySendsMessagesAndDetectsTheResponseOfRoleBResponseTimeoutIsAnUpgradedVersionOfSilentDetection: 'ពិនិត្យ មើល ថា តើ ការ ឆ្លើយតប សេវា ម៉ាស៊ីន ភ្ញៀវ បាន អស់ ពេល ដែល អ្នក ភ្ញៀវ បាន ឆ្លើយ តប ឬ អត់ ។ និង ថាតើ អ្នក ភ្ញៀវ មិន ឆ្លើយតប ទេ ។ ប្រយោជន៍ ចាប់ផ្ដើម ឆ្លើយតប យោង ទៅ ថា តើ ការ ឆ្លើយតប របស់ តួអក្សរ A ត្រូវ បាន រក ឃើញ ពី ប្រយោជន៍ ដំបូង ឬ ប្រយោជន៍ ចុងក្រោយ នៃ សារ ច្រើន ដែល បាន ផ្ញើ បន្ត មួយ ពេល តួនាទី A ផ្ញើ សារ បន្ត និង រកឃើញ ការ ឆ្លើយតប របស់ តួនាទី B ។ ពេលវេលា ឆ្លើយតប គឺ ជា កំណែ ដែល បាន ធ្វើ ឲ្យ ប្រសើរ នៃ ការ រក ឃើញ ស្ងាត់ ។',
                            theSilenceDurationOfEachCharacterIsDetectedByDefaultTheLastSentenceIsDetected: 'ថិរវេលា ស្ងាត់ នៃ តួអក្សរ នីមួយៗ ត្រូវ បាន រក ឃើញ ។ តាម លំនាំ ដើម រកឃើញ ពាក្យ ចុងក្រោយ ។',
                            inTheDialogueBetweenTwoDifferentRolesTheEndTimeOfThePreviousSentencetheStartTimeOfTheCurrentSentenceTheSnatchingIntervalAndTheEndTimeOfTheCurrentSentencetheStartTimeOfTheCurrentSentenceTheLengthOfTheSnatchingSentenceIfItIsSatisfiedAtTheSameTimeItWillBeJudgedAsSnatchingWords: 'នៅ ក្នុង ប្រអប់ រវាង តួនាទី ផ្សេង ពីរ ពេលវេលា បញ្ចប់ នៃ ប្រយោជន៍ មុន - ពេលវេលា ចាប់ផ្ដើម នៃ ប្រយោជន៍ បច្ចុប្បន្ន > = ចន្លោះពេល ចាប់ផ្ដើម ។ និង ពេលវេលា បញ្ចប់ នៃ ប្រយោជន៍ បច្ចុប្បន្ន - ពេលវេលា ចាប់ផ្ដើម នៃ ប្រយោជន៍ បច្ចុប្បន្ន > ប្រវែង នៃ ប្រយោជន៍ បច្ចុប្បន្ន ប្រសិនបើ វា ត្រូវ បាន ជម្រះ នៅពេល តែ មួយ ។ ។',
                            itIsSuitableForBusinessKnowledgeAnswerDetectionOfOneQuestionAndOneAnswerTypeTheOperatorPreferentiallyDetectsProblemsFromTheCustomersMessagesIfTheProblemIsNotDetectedFollowTheConfigurationOfTheConfigurationItemWhenTheProblemIsNotDetectedIfAProblemIsDetectedTheAnswerIsDetectedFromTheCustomerServiceMessageWhenAnAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsCorrectIfNoAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsWrongThisOperatorIsTheOldVersionOfTheKnowledgeSolutionAndTheCorrespondingOptionsAreConfiguredInSemanticIntelligenceInteractiveRecognition: 'វា ត្រូវ បាន សមរម្យ សម្រាប់ ការ រកឃើញ ចម្លើយ សំណួរ មួយ និង ប្រភេទ ចម្លើយ មួយ ។ រកឃើញ បញ្ហា ពី សារ របស់ ម៉ាស៊ីន ភ្ញៀវ ។ ប្រសិនបើ បញ្ហា មិន បាន រក ឃើញ សូម តាម ការ កំណត់ រចនា សម្ព័ន្ធ ធាតុ " នៅ ពេល បញ្ហា មិន ត្រូវ បាន រក ឃើញ បញ្ហា ។ ប្រសិន បើ បាន រក ឃើញ បញ្ហា ចម្លើយ ត្រូវ បាន រកឃើញ ពី សារ សេវា ម៉ាស៊ីន ភ្ញៀវ ។ នៅពេល រកឃើញ ចម្លើយ វា ត្រូវ បាន កំណត់ ថា ដំណោះស្រាយ សេវា របស់ ភ្ញៀវ គឺ ត្រឹមត្រូវ ប្រសិន បើ គ្មាន ចម្លើយ ។ វា ត្រូវ បាន កំណត់ ថា ដំណោះស្រាយ សេវា របស់ ភ្ញៀវ គឺ ខុស ។ ប្រតិបត្តិការ នេះ គឺ ជា កំណែ ចាស់ នៃ ដំណោះស្រាយ ស្គាល់ ។ និង ជម្រើស ដែល ទាក់ទង ត្រូវ បាន កំណត់ រចនា សម្ព័ន្ធ នៅ ក្នុង ការ ទទួល យក អន្តរសកម្ម សំឡេង ។',
                            detectingWhetherThereAreDuplicateMessagesInASessionSupportsBothStrictAndSemanticDuplication: 'ការ រកឃើញ ថា តើ មាន សារ ស្ទួន នៅ ក្នុង សម័យ មួយ គាំទ្រ ការ ស្ទួន ពាក្យ និង សំឡេង ។',
                            itSupportsTheDetectionOfTheIntervalBetweenTwoSemanticsInWhichSemanticLabelsCanBeSetInTheSidebarOfIntelligentToolsOrSemanticIntelligencesemanticLabels: 'វា គាំទ្រ ការ រក ឃើញ ចន្លោះពេល រវាង semantics ពីរ នៅ ក្នុង ការ ស្លាក semantic អាច ត្រូវ បាន កំណត់ នៅ ក្នុង របារ ចំហៀង របស់ ឧបករណ៍ ដែល មាន ប្រយោជន៍ ឬ ស្លាក សញ្ញា សញ្ញា សម្រាក ។',
                            itIsSuitableForBusinessKnowledgeAnswerDetectionOfOneQuestionAndOneAnswerTypeTheOperatorPreferentiallyDetectsProblemsFromTheCustomersMessagesIfTheProblemIsNotDetectedFollowTheConfigurationOfTheConfigurationItemWhenTheProblemIsNotDetectedIfAProblemIsDetectedTheAnswerIsDetectedFromTheCustomerServiceMessageWhenAnAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsCorrectIfNoAnswerIsDetectedItIsDeterminedThatTheCustomerServiceKnowledgeSolutionIsWrongThisOperatorIsANewVersionOfTheKnowledgeSolutionAndTheCorrespondingOptionsAreConfiguredInTheSemanticIntelligenceknowledgeBase: 'វា ត្រូវ បាន សមរម្យ សម្រាប់ ការ រកឃើញ ចម្លើយ សំណួរ មួយ និង ប្រភេទ ចម្លើយ មួយ ។ រកឃើញ បញ្ហា ពី សារ របស់ ម៉ាស៊ីន ភ្ញៀវ ។ ប្រសិនបើ បញ្ហា មិន បាន រក ឃើញ សូម តាម ការ កំណត់ រចនា សម្ព័ន្ធ ធាតុ " នៅ ពេល បញ្ហា មិន ត្រូវ បាន រក ឃើញ បញ្ហា ។ ប្រសិន បើ បាន រក ឃើញ បញ្ហា ចម្លើយ ត្រូវ បាន រកឃើញ ពី សារ សេវា ម៉ាស៊ីន ភ្ញៀវ ។ នៅពេល រកឃើញ ចម្លើយ វា ត្រូវ បាន កំណត់ ថា ដំណោះស្រាយ សេវា របស់ ភ្ញៀវ គឺ ត្រឹមត្រូវ ប្រសិន បើ គ្មាន ចម្លើយ ។ វា ត្រូវ បាន កំណត់ ថា ដំណោះស្រាយ សេវា របស់ ភ្ញៀវ គឺ ខុស ។ ប្រតិបត្តិការ នេះ គឺ ជា កំណែ ថ្មី នៃ ដំណោះស្រាយ ស្គាល់ ។ និង ជម្រើស ដែល ទាក់ទង ត្រូវ បាន កំណត់ រចនា សម្ព័ន្ធ នៅ ក្នុង មូលដ្ឋាន សញ្ញា សម្គាល់ សញ្ញា ។',
                            checkWhetherTheCustomerServiceSentenceIsTooShortOrTooLong: 'ពិនិត្យ មើល ថាតើ ប្រយោជន៍ សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ គឺ ខ្លី ពេក ឬ វែង ។',
                            detectTheEmotionsOfAgentsOrCustomers: 'រកឃើញ សកម្មភាព របស់ ភ្នាក់ងារ ឬ ភ្ញៀវ ។',
                            onlyApplicableToTextConversationQualityInspectionToDetectWhetherTheSentMessageContainsTyposTheTyposCanBeEnrichedInTheSemanticIntelligenceintelligentThesaurustyposToOptimizeTheDetectionOfTypos: 'អាច អនុវត្ត តែ ទៅ កាន់ ការ ត្រួត ពិនិត្យ គុណភាព ព័ត៌មាន អត្ថបទ ដើម្បី រក ឃើញ ថាតើ សារ ផ្ញើ មាន ប្រភេទ ។ Typos អាច ត្រូវ បាន ធ្វើ ឲ្យ សម្រាំង នៅ ក្នុង សញ្ញា សម្រាំង បណ្ដាញ សញ្ញា ប្រតិបត្តិ ការ រក ឃើញ typos ។',
                            itIsOnlyApplicableToVoiceCallQualityInspectionWhichDetectsWhetherInterrogativeSentencesAppearInTheSession: 'វា អាច អនុវត្ត តែ ដើម្បី ត្រួត ពិនិត្យ គុណភាព ហៅ សំឡេង ដែល រកឃើញ ថាតើ ប្រយោជន៍ សួរ អនុញ្ញាត នៅ ក្នុង សម័យ ។',
                            itIsOnlyApplicableToVoiceCallQualityInspectionWhichDetectsWhetherTheVolumeOfTheCustomerServiceOrCustomerIsTooHighOrTooLowAndWhetherTheVolumeChangesSuddenly: 'វា អាច អនុវត្ត តែ ដើម្បី ត្រួតពិនិត្យ គុណភាព ហៅ សំឡេង ដែល រកឃើញ ថា កម្រិត សំឡេង របស់ សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ គឺ ខ្ពស់ ឬ ទាប ពេក និង ថាតើ កម្រិត សំឡេង ផ្លាស់ប្ដូរ ភ្លាមៗ ។',
                            itIsOnlyApplicableToVoiceCallQualityInspectionAndDetectsTheSpeechSpeedOfCustomerServiceOrCustomers: 'វា អាច អនុវត្ត តែ ដើម្បី ត្រួត ពិនិត្យ គុណភាព ហៅ សំឡេង និង រកឃើញ ល្បឿន និយាយ របស់ សេវា ឬ ភ្ញៀវ ។',
                            checkWhetherTheInformationEntityMentionedInTheSessionIsCorrectThatIsJudgeWhetherTheInformationEntityValueIsEqualToACertainPathassociatedDataOrFixedValueTheInformationEntityCanBeConfiguredInTheSemanticIntelligenceinformationEntity: 'ពិនិត្យ មើល ថាតើ ធាតុ ព័ត៌មាន ដែល បាន បញ្ជាក់ នៅ ក្នុង សម័យ គឺ ត្រឹមត្រូវ ឬ , ប្រយ័ត្ន ថាតើ តម្លៃ ធាតុ ព័ត៌មាន គឺ ស្មើ នឹង ទិន្នន័យ ដែល ទាក់ទង នឹង ផ្លូវ ជាក់លាក់ ឬ តម្លៃ ថេរ ។ ធាតុ ព័ត៌មាន អាច ត្រូវ បាន កំណត់ រចនា សម្ព័ន្ធ នៅ ក្នុង ធាតុ ព័ត៌មាន បណ្ដាញ សញ្ញា ។',
                            theNewVersionOfTheAccompanyingFieldDetectsWhetherTheAccompanyingDataIsEqualToAFixedValueOldVersionOfDataWithTheRouteCanDetectWhetherTheDataWithTheRouteMeetsTheRelationshipExpressionWhereTheRelationshipExpressionSupportsUserdefinedYouCanSetTheAdditionSubtractionMultiplicationAndDivisionOperationWhetherToMatchTheSemanticLabelWhetherToContainKeywordsIFJudgmentEtc: 'កំណែ ថ្មី នៃ វាល ដែល ចូលរួម ៖ រក ឃើញ ថាតើ ទិន្នន័យ ដែល ចូលរួម គឺ ស្មើ នឹង តម្លៃ ថេរ ។ កំណែ ទិន្នន័យ ចាស់ ជាមួយ ផ្លូវ ៖ អាច រក ឃើញ ថា តើ ទិន្នន័យ ជាមួយ ផ្លូវ ទាក់ទង កន្សោម ទំនាក់ទំនង ។ នៅ ទីតាំង កន្សោម ទំនាក់ទំនង គាំទ្រ ដែល បាន កំណត់ អ្នក ប្រើ អ្នក អាច កំណត់ បន្ថែម ការ ដកស្រង់ ច្រើន និង ប្រតិបត្តិការ បំបែក ។ ថាតើ ត្រូវ ផ្គូផ្គង ស្លាក សញ្ញា ថាតើ ត្រូវ មាន ពាក្យ គន្លឹះ IF ចង្អុល ។ ។',
                            determineWhetherTheSummaryContentOfTheSessionIsEqualToOrContainsAFixedValueTheSummaryIsSetInProcessAutomationBusinessSummary: 'កំណត់ ថាតើ មាតិកា សង្ខេប របស់ សម័យ គឺ ស្មើ នឹង ឬ មាន តម្លៃ ថេរ ។ សង្ខេប ត្រូវ បាន កំណត់ នៅ ក្នុង សេចក្ដី សង្ខេប ដំណើរការ ដោយ ស្វ័យ ប្រវត្តិ ។',
                        },
                    },
                },
                template: {
                    IgnoreLess: ', មិន អើពើ តិច',
                    theSentenceOfTheWord: 'ពាក្យ ពាក្យ',
                    secondsToNo: 'វិនាទី ទៅ លេខ ។',
                    seconds: 'វិនាទី',
                    responseOpeningSentence: 'ពាក្យ ចាប់ផ្ដើម ឆ្លើយតប',
                },
            },
            template: {
                multimodal: 'ច្រើន ម៉ូឌុល',
                model: 'ម៉ូល',
            },
            component: {
                largeModel: 'ម៉ូដែល ធំ',
            },
        },
        businessSummary: {
            components: {
                fieldItem: {
                    index: {
                        generationFailed: 'បរាជ័យ ក្នុងកា រ ស្ថាបត្រ',
                        generate: 'បង្កើត@ info: whatsthis',
                    },
                },
                empty: {
                    index: {
                        thereIsCurrentlyNoDataAvailable: 'គ្មាន ទិន្នន័យ',
                    },
                },
            },
            index: {
                regenerate: 'បង្កើត ឡើង វិញ',
            },
        },
        applyTemplates: {
            component: {
                areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                operationSuccessful: 'ប្រតិបត្តិការ បាន ជោគជ័យ',
            },
            template: {
                delete: 'លុប',
            },
        },
        similarQuestionRecommend: {
            index: {
                pleaseSelectAQuestion: 'សូម ជ្រើស សំណួរ !',
                similarQuestionRecommendation: 'សួរ ការ ផ្ដល់ អនុសាសន៍ ដូច គ្នា',
                selectAllOnPage: 'ពេល ជ្រើស ទំព័រ ទាំងអស់',
                cancel: 'បោះបង់',
                preserve: 'រក្សាទុក',
                changeBatch: 'ផ្លាស់ប្ដូរ ថត',
            },
        },
        listControl: {
            index: {
                columnControl: 'ត្រួតពិនិត្យ ជួរឈរ',
            },
        },
        loginUserAvatar: {
            index: {
                switch: 'ប្ដូរ',
            },
        },
        autoAddComponent: {
            index: {
                whenAddingDataInRealTimeTheQualityInspectionTaskStillTakesTimeToExecuteTheSpecificTimeDependsOnTheSizeOfTheQualityInspectionDataRangingFromAFewMinutesToHours: 'នៅពេល បន្ថែម ទិន្នន័យ ក្នុង ពេលវេលា ពិត ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព នៅ តែ ត្រូវការ ពេលវេលា ដើម្បី ប្រតិបត្តិ ។ ពេលវេលា ជាក់លាក់ អាស្រ័យ លើ ទំហំ ទិន្នន័យ ត្រួត ពិនិត្យ គុណភាព ដែល មាន ពី នាទី ទៅ ២ ម៉ោង ។',
            },
        },
        bEditor: {
            index: {
                delete: 'លុប',
                cancel: 'បោះបង់',
                confirm: 'កំណត់@ info: whatsthis',
                insert: 'បញ្ចប់',
                width: 'ទទឹង',
                height: 'កម្ពស់',
                clearContent: 'ជម្រះ មាតិកា',
                revoked: 'បាន ដក',
                redo: 'ធ្វើ វិញ',
                fontSize: 'ទំហំ ពុម្ព អក្សរ',
                rowHeight: 'កម្ពស់ ជួរដេក',
                wordSpacing: 'ចន្លោះ ពាក្យ',
                paragraphIndent: 'បន្ទាត់ បន្ទាត់',
                increaseIndent: 'បង្កើន ការ ចូល បន្ទាត់',
                decreaseIndent: 'បន្ថយ ការ ចូល បន្ទាត់',
                border: 'ស៊ុម',
                color: 'ពណ៌',
                textColor: 'ពណ៌ អត្ថបទ',
                backgroundColor: 'ពណ៌ ផ្ទៃ ខាង ក្រោយ',
                temporaryColor: 'ពណ៌ បណ្ដោះ អាសន្ន',
                bold: 'ដង',
                italic: 'អ៊ីនធាតុ',
                underline: 'បន្ទាត់',
                strikethrough: 'បន្ទាត់ បន្ទាត់',
                font: 'ពុម្ព អក្សរ',
                textAlignment: 'តម្រឹម អត្ថបទ',
                left: 'ឆ្វេង',
                centered: 'កណ្ដាញ',
                right: 'ស្ដាំ',
                bothEnds: 'ចុង ទាំង ពីរ',
                leftFloat: 'ទសភាគ ឆ្វេង',
                rightFloat: 'ទសភាគ ស្ដាំ',
                subrupt: 'Superfcript',
                subscript: 'ស្គ្រីប រង',
                clearStyle: 'ជម្រះ រចនាប័ទ្រ',
                title: 'ចំណង ជើង',
                regular: 'ធម្មតា',
                orderedList: 'បញ្ជី ដែល បាន លំដាប់',
                unorderedList: 'បញ្ជី ដែល មិន បាន ឡើយ',
                reference: 'យោងName',
                code: 'កូដ',
                link: 'តំណ',
                clearLink: 'ជម្រះ តំណ',
                horizontalLine: 'បន្ទាត់ ផ្ដេក',
                media: 'មេឌៀ',
                mediaLibrary: 'បណ្ណាល័យ មេឌៀ',
                smallExpression: 'កន្សោម តូចៗ',
                fullScreen: 'ពេញ អេក្រង់',
                exitFullScreen: 'ចេញ ពី អេក្រង់ ពេញ',
                enterLinkText: 'បញ្ចូល អត្ថបទ តំណ',
                enterLinkAddress: 'បញ្ចូល អាសយដ្ឋាន តំណ',
                enterTheLinkAddressAndPressEnter: 'បញ្ចូល អាសយដ្ឋាន តំណ និង បញ្ចូល',
                openInNewWindow: 'បើក ក្នុង បង្អួច ថ្មី',
                removeLink: 'យក តំណ ចេញ',
                playingAudioFiles: 'កំពុង ចាក់ ឯកសារ អូឌីយ៉ូ',
                playVideoFiles: 'ចាក់ ឯកសារ វីដេអូ',
                embeddedMedia: 'មេឌៀ ដែល បាន បង្កប់',
                image: 'រូបភាព',
                video: 'វីដេអូ',
                audio: 'អូឌីយ៉ូ',
            },
        },
        verifyModal: {
            components: {
                verifyCodeInput: {
                    index: {
                        sentSuccessfully: 'ផ្ញើ ដោយ ជោគជ័យ',
                        resend: 'ផ្ញើ ឡើង វិញ (',
                        sendVerificationCode: 'ផ្ញើ កូដ ផ្ទៀងផ្ទាត់',
                    },
                },
            },
            index: {
                cAPTCHA: 'កាបៃ',
                confirm: 'កំណត់@ info: whatsthis',
                pleaseEnterTheVerificationCode: 'សូម បញ្ចូល កូដ ផ្ទៀងផ្ទាត់',
            },
        },
        languageSelect: {
            const: {
                urdu: 'អ៊ុរូដូ',
                kazakh: 'ភាសាកាហ្សាក់',
                americanEnglish: 'អាមេរិក អង់គ្លេស',
                canadianEnglish: 'កាណាដា អង់គ្លេស',
                africanEnglish: 'អង់គ្លេស អាហ្វ្រិកName',
                french: 'បារាំង',
                spanish: 'អេស្ប៉ាញ',
                russian: 'រុស្ស៊ីName',
                arabic: 'អារ៉ាប់Name',
                turkish: 'ទ័រគីName',
                vietnamese: 'វីដេអេអ៊ីName',
                portuguese: 'ព័រទុយហ្គាល់Name',
                german: 'អាល្លឺម៉ង់Name',
                italian: 'អ៊ីតាលី',
                polish: 'ប៉ូឡូសName',
                finnish: 'ហ្វីនសName',
                dutch: 'ហ៊ុង',
                czech: 'ចេស',
                bengali: 'ប៊ីងហ្គា',
                greek: 'ក្រិកName',
                hindi: 'ហ៊ីង',
                chineseTaiwan: 'ចិន តាន់វ៉ាន',
                cambodian: 'កាបូដូសName',
                allLanguages: 'ភាសា ទាំងអស់',
                chinese: 'ចិនStencils',
                english: 'អង់គ្លេស',
                cantonese: 'កានតានីសName',
                thai: 'ថាName',
                malay: 'ម៉ាឡាយ',
                indonesian: 'ហូនេស៊ីName',
                korean: 'កូរ៉េName',
                filipino: 'ហ្វីលីនូName',
                japanese: 'ជប៉ុន',
            },
            index: {
                pleaseSelectLanguage: 'សូម ជ្រើស ភាសា មួយ',
            },
        },
        languageSetting: {
            index: {
                aSRModel: 'ម៉ូដែល ASR',
                languageAdaptive: 'កែប្រែ ភាសា',
                mainLanguage: 'ភាសា មេ',
                paraLanguage: 'ភាសា Para',
                rules: 'បន្ទាត់',
                languageType: 'ប្រភេទ ភាសា ៖',
                preserve: 'រក្សាទុក',
                remove: 'យក ចេញ',
                new: 'ថ្មី',
            },
        },
        smartToolBar: {
            smartTags: {
                template: {
                    language: 'ភាសាComment',
                },
            },
            aiReport: {
                component: {
                    submittedSuccessfully: 'បាន ដាក់ ស្នើ ដោយ ជោគជ័យ',
                },
                template: {
                    selectQualityTask: 'ជ្រើស ភារកិច្ច គុណភាព',
                    enterReportGenerationRequirements: 'បញ្ចូល ការ ទាមទារ ការ បង្កើត របាយការណ៍Name',
                    generateReport: 'បង្កើត របាយការណ៍@ info: whatsthis',
                    historicalReport: 'របាយការណ៍ ប្រវត្តិ',
                    toBeGenerated: 'ត្រូវ បង្កើតComment',
                    exporting: 'នាំចេញ',
                    failedToGenerate: 'ការ បង្កើត បាន បរាជ័យ',
                    complete: 'បញ្ចប់',
                },
            },
            component: {
                largeModelReport: 'របាយការណ៍ ម៉ូឌុល ធំ',
            },
        },
        audioCallContentInfo: {
            components: {
                commentView: {
                    index: {
                        viewDetails: 'មើល សេចក្ដី លម្អិត',
                    },
                },
            },
            template: {
                all: 'ទាំង អស់',
                theFollowingIsTheBotServiceMessage: 'ខាងក្រោម គឺ ជា សារ សេវា របស់ BotName',
                theFollowingIsTheHumanServiceMessage: 'ដូច ខាង ក្រោម គឺ សារ សេវា ជា មនុស្សName',
            },
        },
        asrStatusModal: {
            index: {
                aSRTrainingStatus: 'ស្ថានភាព បង្ហាត់ ASR',
                chineseASR: 'ចិន ASRName',
                aSRModelUpdateTimegeneric: 'ពេលវេលា ទាន់ សម័យ ម៉ូដែល ASR (យោង ៖',
                aSRModelUpdateTimeexclusive: 'ពេលវេលា ទាន់ សម័យ ម៉ូដែល ASR (មិន លុប ៖',
                numberOfErrorCorrectionsTrained: 'ចំនួន កែ កំហុស ដែល បាន បង្ហាត់ ៖',
                trainedErrorCorrectionDuration: 'ថិរវេលា កែ កំហុស ដែល បាន បង្ហាត់ ៖',
                minutes: 'នាទី',
                numberOfUntrainedErrors: 'ចំនួន កំហុស ដែល មិន បាន បង្រៀន ៖',
                untrainedErrorCorrectionDuration: 'ថិរវេលា កែ កំហុស ដែល មិន បាន បង្ហាត់ ៖',
            },
        },
        survey: {
            components: {
                question: {
                    index: {
                        singleTopic: 'ប្រធានបទ មួយ',
                        multipleChoiceQuestions: 'សំណួរ ជ្រើស ច្រើន',
                        questionAndAnswer: 'សំណួរ និង ចម្លើយ',
                    },
                },
            },
        },
        soundtrackListManage: {
            component: {
                keyWords: 'ពាក្យ សោ',
            },
        },
        audioStickersTalkV2: {
            index: {
                customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                topic: 'ប្រធាន បទ',
            },
        },
        infoEntitySelect: {
            index: {
                pleaseSelectAnInformationEntity: 'សូម ជ្រើស ធាតុ ព័ត៌មាន',
            },
        },
        outerApiConfigsResponseSelect: {
            index: {
                pleaseSelectAReturnParameter: 'សូម ជ្រើស ប៉ារ៉ាម៉ែត្រ ត្រឡប់ វិញ',
            },
        },
        outerApiConfigsSelect: {
            index: {
                pleaseSelectExternalInterface: 'សូម ជ្រើស ចំណុច ប្រទាក់ ខាងក្រៅ',
            },
        },
        randomFieldSelect: {
            index: {
                pleaseSelect: 'សូម ជ្រើស',
            },
            utils: {
                customerInformation: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
                followtheroadData: 'ទិន្នន័យ តាម ផ្លូវComment',
                preprocessingData: 'កំពុង ដំណើរការ ទិន្នន័យ',
                businessRecords: 'ថត ពាក្យ',
                workOrderInformation: 'ព័ត៌មាន លំដាប់ ការងារ',
            },
        },
        frequency: {
            index: {
                pleaseSelect: 'សូម ជ្រើស',
                no: 'គ្មាន ។',
            },
        },
        roleSelect: {
            index: {
                pleaseSelect: 'សូម ជ្រើស',
            },
        },
        userSelect: {
            index: {
                pleaseSelect: 'សូម ជ្រើស',
            },
        },
        massageConfigurationV2: {
            index: {
                messageName: 'ឈ្មោះ សារ',
                dataType: 'ប្រភេទ ទិន្នន័យ',
                filterCondition: 'លក្ខខណ្ឌ តម្រង',
                triggerMechanism: 'គ្នា',
                afterDataAcquisition: 'បន្ទាប់ ពី ការ ទទួល ទិន្នន័យ',
                afterDataAnalysis: 'បន្ទាប់ ពី ការ វិភាគ ទិន្នន័យ',
                pushMode: 'ចុច របៀបComment',
            },
        },
        evaluateDrawer: {
            index: {
                courseQuality: 'គុណភាព ដក',
                higherValuesIndicateBetterCourseQuality: 'តម្លៃ ខ្ពស់ បង្ហាញ គុណភាព បង្ហាញ',
                learningEffect: 'បែបផែន បង្រៀនName',
                theHigherTheValueTheBetterTheLearningEffect: '[ កំណត់ សម្គាល',
                interactiveExperience: 'អន្តរសកម្ម',
                theHigherTheValueTheBetterTheInteractiveExperienceOfTheCourse: 'តម្លៃ ខ្ពស់ ជាង ច្រើន ភាព ត្រឹមត្រូវ របស់ អន្តរសកម្ម ល្អ បំផុត ។',
                suggestedFeedback: 'ការ ឆ្លើយតប ដែល បាន ស្នើ',
                pleaseEnterAnEvaluationProposalForThisCourse: 'សូម បញ្ចូល សំណុំ ការ វាយតម្លៃ សម្រាប់ វត្ថុ',
                cancel: 'បោះបង់',
                submission: 'ដាក់ ស្នើ',
            },
        },
        filterManage: {
            template: {
                default: 'លំនាំដើម',
            },
        },
        associatedTicket: {
            index: {
                associatedWorkOrder: 'លំដាប់ ការងារ',
            },
        },
        appealHistory: {
            index: {
                reasonsForPassing: 'មូលហេតុ សម្រាប់ បញ្ចូល',
                reasonForRejection: 'មូលហេតុ សម្រាប់ ការ បដិសេធ',
                secondaryReview: 'មើល រង',
                firstlevelReview: 'មើល កម្រិត ទី មុន',
            },
        },
        customSortModal: {
            component: {
                sorterNameCannotBeEmpty: 'ឈ្មោះ កម្មវិធី តម្រង មិន អាច ទទេ',
                ascending: 'កំពុង រត់',
                descending: 'កំពុង បន្ទាត់',
            },
            customFilters: {
                ascending: 'កំពុង រត់',
                descending: 'កំពុង បន្ទាត់',
            },
            template: {
                sorterName: 'ឈ្មោះ កម្មវិធី តម្រង ៖',
                pleaseEnterASorterName: 'សូម បញ្ចូល ឈ្មោះ កម្មវិធី តម្រង',
                customSort: 'តម្រៀប ផ្ទាល់ខ្លួន',
                commonSort: 'តម្រៀប ទូទៅ',
            },
        },
        waveAudioTalkV2: {
            template: {
                confirmRetranslation: 'អះអាង ការ បកប្រែ ឡើងវិញ ?',
                retranslation: 'បកប្រែ ឡើង វិញ',
            },
        },
        waveAudioTalk: {
            template: {
                confirmRetranslation: 'អះអាង ការ បកប្រែ ឡើងវិញ ?',
                retranslation: 'បកប្រែ ឡើង វិញ',
            },
        },
        variableFieldSelect: {
            const: {
                languageField: 'វាល ភាសា',
                businessRecords: 'ថត ពាក្យ',
                smartLabel: 'ស្លាក ឆ្លាត',
                pretreatment: 'ការ ត្រួត ពិន្ទុ',
                workOrderFields: 'វាល លំដាប់ ការងារ',
                customerInformation: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
                associatedWorkOrder: 'លំដាប់ ការងារ',
            },
            index: {
                pleaseEnterAKeywordQuery: 'សូម បញ្ចូល សំណួរ ពាក្យ គន្លឹះ',
            },
        },
        customModelsQaMethod: {
            index: {
                qualityInspectionMethod: 'វិធីសាស្ត្រ ត្រួតពិនិត្យ គុណភាព',
                setTheLargeModelQualityInspectionMethodOfTheCurrentQualityInspectionRule: 'កំណត់ វិធីសាស្ត្រ ត្រួត ពិនិត្យ លក្ខណៈ សម្បត្តិ ម៉ូសេ ធំ នៃ ច្បាប់ ត្រួត ពិនិត្យ គុណភាព បច្ចុប្បន្ន ។',
                batchQualityInspectionAfterTheCurrentRuleIsMergedWithOtherBatchQualityInspectionRulesUnderTheSameTaskTheLargeModelIsCalledToOutputTheQualityInspectionResultsOfMultipleRulesAtOneTimeThisIsApplicableToSimpleRules: 'ការ ត្រួត ពិនិត្យ គុណភាព Batch ៖ បន្ទាប់ ពី ច្បាប់ បច្ចុប្បន្ន ត្រូវ បាន បញ្ចូល គ្នា ជាមួយ ច្បាប់ ត្រួត ពិនិត្យ គុណភាព បណ្ដាញ ផ្សេង ទៀត ក្រោម ភារកិច្ច ដូចគ្នា ។ ម៉ូដែល ធំ ត្រូវ បាន ហៅ ដើម្បី លទ្ធផល លទ្ធផល ត្រួត ពិនិត្យ គុណភាព នៃ ច្បាប់ ច្រើន នៅ ពេល មួយ ។ នេះ ត្រូវ បាន អនុវត្ត ទៅកាន់ ច្បាប់ ធម្មតា ។',
                separateQualityInspectionIndicatesThatTheCurrentRuleIsNotMergedWithOtherRulesAndQualityInspectionIsPerformedSeparatelyThisIsApplicableToComplexRules: 'ការ ត្រួត ពិនិត្យ គុណភាព បំបែក ៖ បង្ហាញ ថា ច្បាប់ បច្ចុប្បន្ន មិន ត្រូវ បាន បញ្ចូល ជាមួយ ច្បាប់ ផ្សេង ទៀត ទេ ។ និង ការ ត្រួត ពិនិត្យ គុណភាព ត្រូវ បាន ធ្វើ ដោយ ផ្សេង គ្នា ។ វា ត្រូវ បាន អនុវត្ត ទៅកាន់ ក្បួន ត្រឹមត្រូវ ។',
                noteThatTheConsumptionOfIndividualQualityInspectionTokenIsHigherThanThatOfBatchQualityInspection: 'ចំណាំ ថា ការ រុករក នៃ តូចតាង ត្រួត ពិនិត្យ គុណភាព នីមួយៗ គឺ ខ្ពស់ ជាង ការ ត្រួត ពិនិត្យ គុណភាព កម្លាំង ។',
                batchQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ថត',
                separateQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព បំបែក',
            },
        },
        dialogInformation: {
            index: {
                call: 'ហៅ',
                dialogue: 'ប្រអប់Comment',
            },
        },
        ticketRelateQa: {
            index: {
                detectionDataCannotBeEmpty: 'ការ រក ឃើញ ទិន្នន័យ មិន អាច ទទេ !',
                workOrder: 'លំដាប់ ការងារ',
                dialogue: 'ប្រអប់Comment',
                detectionData: 'រកឃើញ ទិន្នន័យ',
            },
        },
        customerServiceGrounp: {
            component: {
                maximumNameLengthIs: 'ប្រវែង ឈ្មោះ អតិបរមា គឺ ២០',
            },
        },
        agentGroupSelect: {
            index: {
                pleaseSelectAnAgentGroup: 'សូម ជ្រើស ក្រុម ភ្ញៀវ',
            },
        },
        agentSelect: {
            index: {
                pleaseSelectCustomerService: 'សូម ជ្រើស សេវា ម៉ាស៊ីន ភ្ញៀវ',
            },
        },
        ticketTypeSelect: {
            index: {
                customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                internalRemarks: 'សម្គាល់ ខាង ក្នុង@ info: whatsthis',
                sMS: 'SMS',
                call: 'ហៅ',
                mail: 'សំបុត្រ',
                changeRecord: 'ផ្លាស់ប្ដូរ ថត',
            },
        },
        agentDepartmentSelect: {
            index: {
                pleaseSelectDepartment: 'សូម ជ្រើស ចំណុច',
            },
        },
        aSRModelSelect: {
            index: {
                pleaseSelect: 'សូម ជ្រើស',
            },
        },
        exportButton: {
            index: {
                exportTaskCreatedSuccessfully: 'នាំចេញ ភារកិច្ច បាន បង្កើត ដោយ ជោគជ័យ',
                taskCreatedSuccessfully: 'បាន បង្កើត ភារកិច្ច ដោយ ជោគជ័យ',
                downloadCenter: 'ទាញយក មជ្ឈមណ្ឌល',
                taskCenter: 'មជ្ឈមណ្ឌល ភារកិច្ច',
            },
        },
    },
    fields: {
        qualityInspectionForm: {
            list: {
                name: 'ឈ្មោះ:',
                description: 'សេចក្ដី ពិពណ៌នា',
                type: 'ប្រភេទ@ info: whatsthis',
                status: 'ស្ថានភាព',
                actions: 'ប្រតិបត្តិការ',
            },
        },
        qualityCheckingTask: {
            index: {
                name: 'ឈ្មោះ ភារកិច្ច',
                description: 'សេចក្ដី ពិពណ៌នា',
                form: 'ទ្រង់ទ្រាយ ត្រួត ពិនិត្យ គុណភាព',
                actions: 'ប្រតិបត្តិការ',
                createUser: 'អ្នក បង្កើតComment',
            },
            samplingRecords: {
                createTime: 'ពេលវេលា',
                type: 'ប្រភេទ@ info: whatsthis',
                operateUser: 'កម្មវិធី',
                number: 'បន្ថែម មាតិកា',
                filterConditionList: 'លក្ខខណ្ឌ តម្រង',
                sampleRuleStr: 'លក្ខខណ្ឌ គំរូ',
                timeGreaterThan: 'ពេលវេលា ធំៗ',
                timeLessThan: 'ពេលវេលា តិច',
            },
        },
        customFilters: {
            createdAt: 'ពេលវេលា និយាយComment',
            customerId: 'ម៉ាស៊ីន ភ្ញៀវ',
            agentId: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            userGroupId: 'ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
            state: 'ស្ថានភាព',
            lastEvaluateUserId: 'អត្រា ចុង ក្រោយ',
            submitTime: 'ពេលវេលា ដាក់ ស្នើ ចុងក្រោយ',
            totalScore: 'ពិន្ទុ សរុប',
            formItemForbidIdList: 'ធាតុ ដែល បាន បង្ហាញ',
            formItemDeadlyIdList: 'ធាតុ ធ្ងន់ធ្ងរ',
        },
        samplingInspection: {
            callTime: 'ពេលវេលា និយាយComment',
            dialogTime: 'ពេលវេលា ប្រអប់Name',
            originator: 'អ្នក ដែល បាន បិទ',
            createTime: 'ពេលវេលា បង្កើតComment',
            updateTime: 'ពេលវេលា ទាន់ សម័យ',
            status: 'ស្ថានភាព ដំណើរការ',
            score: 'ប្រទេស',
            actions: 'ប្រតិបត្តិការ',
            reviewer: 'កម្មវិធី បន្ត',
            samplingOfficer: 'កម្មវិធី ត្រួតពិនិត្យ គំរូ',
            id: 'លេខ សម្គាល់ កំណត់ហេតុ ហៅ',
            time: 'ពេលវេលា និយាយComment',
            phone: 'ទូរស័ព្ទ ម៉ាស៊ីន ភ្ញៀវ',
            staff: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            inspectionStatus: 'ស្ថានភាព ត្រួតពិនិត្យ គុណភាព',
            samplingStatus: 'ស្ថានភាព គំរូ',
            inspectionGrade: 'ការ វាយតម្លៃ',
        },
        smartWordsLibrary: {
            synonymWords: {
                standardWords: 'ពាក្យ ស្តង់ដារ',
                synonymWords: 'Synonyms',
                synonymWordsNumber: 'ចំនួន សញ្ញា',
                useFrequency: 'ប្រេកង់ ប្រើ',
                effectiveness: 'ភាព បែបផែន',
                operation: 'ប្រតិបត្តិការ',
            },
            common: {
                useFrequency: 'ប្រេកង់ ប្រើ',
                effectiveness: 'ភាព បែបផែន',
                operation: 'ប្រតិបត្តិការ',
            },
            professionalWords: {
                professionalWords: 'បណ្ដាញ',
                useFrequency: 'ប្រើ ស្ថិតិ',
                homophonic: 'ពាក្យ ព្រិល (ការ ជំនួស មូហ្វូន)',
                target: 'ការ ជំនួស ឈ្មោះName',
                targetWords: 'ជំនួស ពាក្យ',
                homophonyWords: 'ពាក្យ បង្កើត',
                operation: 'ប្រតិបត្តិការ',
            },
            attentionWords: 'ពាក្យ ដែល មាន ប្រយោជន៍',
            ignoreWords: 'មិន អើពើ ពាក្យ',
            wordsWeight: {
                selfDefineWeightWords: 'ពាក្យ បង្កើន ផ្ទាល់ខ្លួន',
                weightWords: 'ពាក្យ កម្ពស់',
                weight: 'កម្ពស់',
                useFrequency: 'ប្រេកង់ ប្រើ',
                effectiveness: 'ភាព បែបផែន',
                operation: 'ប្រតិបត្តិការ',
            },
            corpusData: {
                corpusDescription: 'សេចក្ដី ពិពណ៌នា corpus',
                updateTime: 'ពេលវេលា ទាន់ សម័យ',
                wordsCount: 'ចំនួន ពាក្យ',
                effectiveness: 'ភាព បែបផែន',
                operation: 'ប្រតិបត្តិការ',
                corpusContent: 'មាតិកា',
            },
        },
        semanticTags: {
            title: 'ស្លាក semantic',
            tags: 'ពាក្យ ស្តង់ដារ',
            orgName: 'រៀបចំComment',
            tagCount: 'ចំនួន បង្ហាញ',
            usingCount: 'ចំនួន យោងName',
            activeFlag: 'ភាព បែបផែន',
            suggestion: 'ការ អនុសាសន៍ បង្ហាញ',
            actions: 'ប្រតិបត្តិការ',
        },
        intelligentTags: {
            tagName: 'ឈ្មោះ:',
            tagDesc: 'សេចក្ដី ពិពណ៌នា',
            tagRefCnt: 'ចំនួន សញ្ញា',
            categoryName: 'ស្លាក ថ្នាក់Name',
            eventName: 'កា រកំណត់ ព្រឹត្តិការណ៍',
            tagStatus: 'ភាព បែបផែន',
            actions: 'ប្រតិបត្តិការ',
            tagType: 'ប្រភេទ ស្លាក',
        },
        dataPreprocess: {
            name: 'ឈ្មោះ:',
            desc: 'សេចក្ដី ពិពណ៌នា',
            dataSource: 'ដែន កំណត់ ប្រភព ទិន្នន័យ',
            type: 'ប្រភេទ@ info: whatsthis',
            status: 'ភាព បែបផែន',
            actions: 'ប្រតិបត្តិការ',
        },
        informationEntities: {
            name: 'ឈ្មោះ:',
            apiName: 'ឈ្មោះ API',
            type: 'ប្រភេទ@ info: whatsthis',
            remark: 'សេចក្ដី ពិពណ៌នា',
            activeFlag: 'ភាព បែបផែន',
            actions: 'ប្រតិបត្តិការ',
        },
        interactiveRecognition: {
            questionAndAnswer: 'សំណួរ និង ចម្លើយ',
            type: 'ប្រភេទ@ info: whatsthis',
            status: 'ស្ថានភាព',
            actions: 'ប្រតិបត្តិការ',
            question: 'សំណួរ',
        },
        role: {
            id: 'ID',
            name: 'ឈ្មោះ:',
            actions: 'ប្រតិបត្តិការ',
        },
        uploadDownload: {
            taskName: 'ឈ្មោះ ឯកសារ',
            createTime: 'កាលបរិច្ឆេទ',
            size: 'ទំហំ',
            createUserName: 'កម្មវិធី',
            status: 'ស្ថានភាព',
            result: 'លទ្ធផល',
            actions: 'ប្រតិបត្តិការ',
        },
        taskCenterList: {
            name: 'មាតិកា ភារកិច្ច',
            createTime: 'ពេលវេលា ដាក់ ស្នើ',
            startTime: 'ពេលវេលា ចាប់ផ្ដើម',
            endTime: 'ពេលវេលា បញ្ចប់',
            createUserName: 'កម្មវិធី',
            status: 'ស្ថានភាព',
            result: 'លទ្ធផល',
            actions: 'ប្រតិបត្តិការ',
        },
        customerInformation: {
            title: 'ព័ត៌មាន សេវា ម៉ាស៊ីន ភ្ញៀវ',
            data: 'មើល តែ ទិន្នន័យ ស្រប់',
            list: {
                agentNo: 'លេខ សម្គាល់ សេវា លេខ ការងារ',
                agentName: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                agentTel: 'ទូរស័ព្ទ',
                agentEmail: 'អ៊ីមែល',
                updateTime: 'ពេលវេលា ទាន់ សម័យ',
                actions: 'ប្រតិបត្តិការ',
            },
            upload: {
                second: '2. ចុច ប៊ូតុង នាំចូល ដើម្បី ផ្ទុក ឡើង ឯកសារ EXCEl រចនា សម្ព័ន្ធ ទៅ ទ្រង់ទ្រាយ ពុម្ព',
            },
        },
        IndexManagement: {
            title: 'គ្រប់គ្រង ការ បង្ហាញ',
            list: {
                indicatorName: 'ឈ្មោះ:',
                indicatorDesc: 'សេចក្ដី ពិពណ៌នា',
                activity: 'ភាព បែបផែន',
                inspectDataSource: 'ប្រភព ទិន្នន័យ',
                sysType: 'ប្រភេទ@ info: whatsthis',
                agentGroups: 'ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
                actions: 'ប្រតិបត្តិការ',
            },
            detail: {
                nameEmpty: 'ឈ្មោះ មិន អាច ទទេ',
                descript: 'សេចក្ដី ពិពណ៌នា',
                descriptEmpty: 'សេចក្ដី ពិពណ៌នា មិន អាច ទទេ',
                active: 'ភាព បែបផែន',
                activeEmpty: 'សុពលភាព មិន អាច ទទេ',
                dataSource: 'ប្រភព ទិន្នន័យ',
                dataSourceEmpty: 'ប្រភព ទិន្នន័យ មិន អាច ទទេ',
                grounp: 'ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
                grounpEmpty: 'ក្រុម ភ្នាក់ងារ មិន អាច ទទេ',
                grounpHolder: 'សូម ជ្រើស ក្រុម ភ្ញៀវ',
                type: 'វិធីសាស្ត្រ ពិន្ទុ',
                typeNone: 'វិធីសាស្ត្រ ពិន្ទុ មិន អាច ទទេ',
                base: 'ចំណុច មូលដ្ឋាន',
                baseNone: 'ពិន្ទុ មូលដ្ឋាន មិន អាច ទទេ',
                positive: 'កត្តា វិជ្ជមាន',
                positiveNone: 'កត្តា វិជ្ជមាន មិន អាច ទទេ',
                customAdd: 'បន្ថែម តម្រង',
                negative: 'កម្លាំង អវិជ្ជមាន',
                negativeNone: 'កត្តា មិន អាច ទទេ',
                customOK: 'យោង តម្រង ៖',
                judgeStrategy: 'ច្បាប់ លក្ខខណ្ឌ ៖',
                other: 'កត្តា ផ្សេងទៀត',
                otherAdd: 'បន្ថែម កត្តា',
                agent: 'ទិន្នន័យ',
                section: 'ចំនួន ចន្លោះពេល',
                sectionNone: 'ចំនួន ចន្លោះពេល មិន អាច ទទេ',
                step: 'ចន្លោះ ជំហានComment',
                stepNone: 'ចន្លោះ ជំហានComment',
                save: 'រក្សាទុក',
                cancel: 'បោះបង់',
            },
        },
    },
    enums: {
        gongRolesTypes: {
            all: 'ទាំង អស់',
            staff: 'មាន តែ ខ្លួន មុន',
            department: 'ភាគ និង ខាង ក្រោមName',
        },
        gongStatisticsDate: {
            week: 'សប្ដាហ៍',
            month: 'ខែ',
            season: 'រយៈពេល',
        },
        gongCoachTaskStatus: {
            wait: 'ដើម្បី បង្ហាញ',
            already: 'បង្ហាញ',
            ignore: 'មិន អើពើ',
        },
        callRangeStatus: {
            all: 'ការ ហៅ ទាំងអស់',
            sale: 'បាន ចាប់ផ្ដើម ភ្ជាប់',
            customer: 'បាន ចាប់ផ្តើម ម៉ាស៊ីន ភ្ញៀវ',
        },
        todoListType: {
            later: 'ស្ដាប់ បន្ទាប់',
            help: 'ការ ទទួល ជំនួយ',
            contact: 'ទំនាក់ទំនង ក្រោយ@ info: whatsthis',
            send: 'ផ្ញើ ទិន្នន័យ',
            warn: 'ការ ព្រមាន រហ័ស',
        },
        frequencyTypes: {
            everyDay: 'ថ្ងៃថែម',
            everyWeek: 'សប្ដាហ៍',
            everyMonth: 'រាល់ ខែ',
        },
        classifiedTraing: {
            trainTypeList: {
                noneDataTrain: 'ការ បង្ហាត់ ទិន្នន័យ ដែល មិន បាន ថ្នាក់',
                markedDataCorrigenda: 'Errata ទិន្នន័យ ស្លាកName',
                classifiedDataCheck: 'ការ ផ្ទៀងផ្ទាត់ ទិន្នន័យ',
                markedHistoryRecord: 'ប្រវត្តិ ការ ហៅ',
                historyDataRecalculate: 'ទិន្នន័យ ប្រវត្តិ ឡើង វិញ',
            },
            dataExtractMode: {
                random: 'ចៃដន្យ',
                intelligentRecommend: 'អនុសាសន៍ ជម្រះ',
                custom: 'ផ្ទាល់ខ្លួន',
                specifiedClass: 'បញ្ជាក់ ចេញ',
            },
            smartRatesList: {
                markRate: 'អត្រា ការ សម្គាល់@ info: whatsthis',
                corrigendaRate: 'អត្រា errata',
                kl: 'ដោះស្រាយ K- LName',
                signalNoiseRate: 'សមាមាត្រ សញ្ញា',
            },
        },
        visibleRangeTypes: {
            all: 'ទាំង អស់',
            customerGroup: 'ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
            userDefined: 'ផ្ទាល់ខ្លួន',
        },
        samplingRateTypes: {
            everyDay: 'គូរ រាល់ ថែម',
            everyWeek: 'គូរ សប្ដាហ៍',
        },
        taskRemindTypes: {
            confirm: 'ផ្ញើ កម្មវិធី រំលឹក នៅពេល ដែល ថត ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព ត្រូវការ ត្រូវ បាន អះអាង ។',
            appeal: 'នៅ ពេល ថត ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ចាប់ផ្តើម ស្លាប់ សូម ផ្ញើ កម្មវិធី រំលឹក ។',
        },
        weekDays: {
            monday: 'ថ្ងៃ ចុងក្រោយ',
            tuesday: 'ថ្ងៃ ខ្លាំង',
            wednesday: 'ថ្ងៃ ខ្លាំង',
            thursday: 'ថ្ងៃ ជម្រះ',
            friday: 'ថ្ងៃ ខែ',
            saturday: 'ថ្ងៃ ស្លាក',
            sunday: 'ថ្ងៃ ខ្លាំង',
        },
        reportDateTypes: {
            dailyReport: 'របាយការណ៍ រាល់ ថ្ងៃ@ info: whatsthis',
            weeklyReport: 'របាយការណ៍ សប្ដាហ៍',
        },
        samplingRangeDayTypes: {
            today: 'ថ្ងៃ នេះ@ item: inlistbox',
            yesterday: 'ម្រាមង',
        },
        samplingRangeWeekTypes: {
            thisWeek: 'សប្ដាហ៍ នេះ',
            lastWeek: 'សប្ដាហ៍ មុន',
        },
        samplingRuleTypes: {
            proportion: 'គំរូ សមាមាត្រ',
            random: 'គំរូ ចៃដន្យ',
        },
        taskStatusTypes: {
            waitEvaluate: 'ត្រូវ បាន ប្រយោជន៍',
            waitSubmit: 'ត្រូវ បាន ដាក់ស្នើ',
            waitConfirm: 'ត្រូវ អះអាង',
            waitReview: 'ត្រូវ បាន ពិនិត្យ មួយ',
            completed: 'បាន បញ្ចប់',
            all: 'ទាំង អស់',
        },
        qualityInspectionForm: {
            formTemplateTypes: {
                directScore: 'ការ វាយតម្លៃ ផ្ទាល់',
                weightedScore: 'ពិន្ទុ ទំហំ',
                deductScore: 'ដក',
                directScoreSecondLevel: 'ការ វាយតម្លៃ កម្រិត ២',
                weightedScoreSecondLevel: 'ពិន្ទុ កម្រិត ២',
                deductScoreSecondLevel: 'ចំណុច ដោះស្រាយ កម្រិត ២',
            },
        },
        fieldOperators: {
            is: 'ស្មើ',
            not: 'មិន ស្មើ',
            contains: 'មាន ថ្មី',
            notContains: 'មិនមាន ទេ',
            not_contains: 'មិនមាន ទេ',
            containsAny: 'មាន ថ្មី',
            contains_any: 'មាន ថ្មី',
            is_any: 'មាន ថ្មី',
            not_any: 'មិន មាន ទេ',
            notContainsAny: 'មិន មាន ទេ',
            not_contains_any: 'មិន មាន ទេ',
            containsAll: 'មាន ទាំងអស់',
            contains_all: 'មាន ទាំងអស់',
            notContainsAll: 'មិន មាន ទាំងអស់',
            nont_contains_all: 'មិន មាន ទាំងអស់',
            isNull: 'ទទេ',
            is_null: 'ទទេ',
            isNotNull: 'មិន ទទេ',
            is_not_null: 'មិន ទទេ',
            greaterThan: 'ធំ',
            greater_than: 'ធំ',
            greaterThanEq: 'ធំ ជាង ឬ ស្មើ',
            greater_than_eq: 'ធំ ជាង ឬ ស្មើ',
            lessThan: 'តិច',
            less_than: 'តិច',
            lessThanEq: 'តូច ជាង ឬ ស្មើ',
            less_than_eq: 'តូច ជាង ឬ ស្មើ',
            between: 'រវាង',
            notBetween: 'កុំ',
            not_between: 'កុំ',
            relative: 'ស្មើ',
            set: 'កំណត់Comment',
            belongs: 'ចូល រួម@ info: whatsthis',
            notBelongs: 'មិនមែន ជា ដក',
            not_belongs: 'មិន ស្មើ',
            today: 'ថ្ងៃ នេះ@ item: inlistbox',
            yesterday: 'ម្រាមង',
            the_day_before_yesterday: 'ថ្ងៃ មុន ម្ល',
            tomorrow: 'ថ្ងៃ ។',
            next_seven_day: '៧ ថ្ងៃ បន្ទាប់',
            last_seven_day: '៧ ថ្ងៃ ចុងក្រោយ',
            this_week: 'សប្ដាហ៍ នេះ',
            next_week: 'សប្ដាហ៍ បន្ទាប់',
            last_week: 'សប្ដាហ៍ មុន',
            this_month: 'ខែ នេះ',
            next_month: 'ខែ បន្ទាប់',
            last_month: 'ខែ មុន',
            this_year: 'ឆ្នាំ នេះ',
            next_year: 'ឆ្នាំ បន្ទាប់',
            last_year: 'ឆ្នាំ មុន',
            exact_match: 'ផ្គូផ្គង ពាក្យ',
            add_value: 'បាន បន្ថែម តម្លៃ ថ្មី',
            remove_value: 'លុប តម្លៃ',
            set_null: 'ទទេ',
            isAny: 'ស្មើ',
            notAny: 'មិន ស្មើ',
            belongTo: 'ចូល រួម@ info: whatsthis',
            notBelongTo: 'មិនមែន ជា ដក',
            hasAny: 'មាន ថ្មី',
            notHasAny: 'មិន មាន ទេ',
            prefixContains: 'ចាប់ផ្ដើម ស្មើ',
            prefixNotContains: 'ការ ចាប់ផ្ដើម មិន ស្មើ',
            suffixContains: 'ចុង ស្មើ',
            suffixNotContains: 'បញ្ចប់ មិន ស្មើ',
            nextSevenDay: '៧ ថ្ងៃ បន្ទាប់',
            lastSevenDay: '៧ ថ្ងៃ ចុងក្រោយ',
            thisWeek: 'សប្ដាហ៍ នេះ',
            nextWeek: 'សប្ដាហ៍ បន្ទាប់',
            lastWeek: 'សប្ដាហ៍ មុន',
            thisMonth: 'ខែ នេះ',
            nextMonth: 'ខែ បន្ទាប់',
            lastMonth: 'ខែ មុន',
            thisYear: 'ឆ្នាំ នេះ',
            nextYear: 'ឆ្នាំ បន្ទាប់',
            lastYear: 'ឆ្នាំ មុន',
            after: 'បន្ទាប់ ពី (រួម បញ្ចូល ថ្ងៃ បច្ចុប្បន្ន)',
            before: 'មុន ជាង (រួម បញ្ចូល ថ្ងៃ បច្ចុប្បន្ន)',
            allMatching: 'ផ្គូផ្គង ទាំងអស់',
            allNotMatching: 'ទាំងអស់ មិន ផ្គូផ្គង',
            hit: 'បិទ',
            not_hit: 'បាត់Comment',
        },
        fieldsOperators: {
            is: 'ស្មើ',
            is_null: 'ទទេ',
            head_equal: 'ចាប់ផ្ដើម ស្មើ',
            tail_equal: 'ចុង ស្មើ',
            is_not_null: 'មិន ទទេ',
            not: 'មិន ស្មើ',
            diff_equal: 'ដោះស្រាយ ស្មើ',
            diff_greater_than: 'ដោះស្រាយ ធំ ជាង',
            diff_greater_than_eq: 'បំបែក ធំ ជាង ឬ ស្មើ',
            diff_less_than: 'ដោះស្រាយ គឺ តិច',
            diff_less_than_eq: 'បំបែក តិច ឬ ស្មើ',
            hour_equal: 'ម៉ោង ដូចគ្នា ។',
            day_equal: 'ថ្ងៃ មេ',
            week_equal: 'សប្ដាហ៍ មេ',
            month_equal: 'ខែ គេ',
            year_equal: 'ឆ្នាំ មួយ',
            day: 'ថ្ងៃStencils',
            minute: 'នាទី',
            hour: 'ម៉ោង',
            part_equal: 'ស្មើ',
        },
        samplingColumnCaptions: {
            created_at: 'ពេលវេលា និយាយComment',
            agent_id: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            get_direction: 'ប្រភេទ ហៅ',
            call_result: 'លទ្ធផល ហៅ',
            survey: 'ការ តម្លៃ',
            derived_from_id: 'ប្រភព',
            quit_queue_why: 'ស្ថានភាព ជួរ',
            queuing_duration: 'ការ ដាក់ ជួរ ពេលវេលាComment',
            talking_seconds: 'ថិរវេលា ហៅ',
            ringing_seconds: 'ពេលវេលា បង្ហាញ',
            hangup_by: 'ភ្ញៀវ ហៅ ដោយ',
        },
        callTypes: {
            callIn: 'ហៅ ចូលName',
            callOut: 'ប្រសើរ',
            threeParty: '(ចែក ត្រី )',
            consultation: '(ការ សួរ)',
            insert: '(បញ្ចូល ពិសេស)',
            monitor: '(កំពុង ស្ដាប់)',
            transfer: '(ផ្ទេរ)',
            intercept: '(ប្រជុំ)',
            transferOutside: '( ផ្ទេរ បន្ទាត់ ខាង ក្រៅ)',
            threePartyOutside: '(បន្ទាត់ ខាង ក្រៅ ត្រីកោណ)',
            consultingOutside: '(ការ បញ្ជា ខាងក្រៅ)',
        },
        callResults: {
            staffAnswer: 'ចម្លើយ សេវា ម៉ាស៊ីន ភ្ញៀវ',
            staffNotAnswer: 'បាត់ សេវា ម៉ាស៊ីន ភ្ញៀវ',
            customerAnswer: 'ឆ្លើយតប របស់ អ្នក ជំនួយ',
            customerNotAnswer: 'បាន បាត់ កម្មវិធី',
            phoneBusy: 'រវល់ ទូរស័ព្ទ',
            phoneOffline: 'ទូរស័ព្ទ ក្រៅ បណ្ដាញ',
            customerSpeedHangUp: 'រហូត របស់ អ្នក ប្ដូរ រហ័ស',
            customerHangUp: 'ម៉ាស៊ីន ភ្ញៀវ ដោយ',
            queueTimeout: 'អស់ ពេលវេលា ជួរ',
            queueGiveUp: 'ការ បោះបង់ ជួរ',
            outlineAnswer: 'ចម្លើយ ខាងក្រៅ',
            outlineNotAnswer: 'មិន បាន តភ្ជាប់ បន្ទាត់ ខាងក្រៅ',
            noChooseQueue: 'មិន បាន ជ្រើស ជួរ',
        },
        defaultSurveys: {
            noEvaluation: 'មិន បាន វាយតម្លៃ',
            noNeedToEvaluate: 'គ្មាន ការ វាយតម្លៃ',
        },
        queueStates: {
            queueSuccess: 'ជោគជ័យ ជួរ',
            queueTimeout: 'អស់ ពេលវេលា ជួរ',
            queueGiveUp: 'ការ បោះបង់ ជួរ',
            noStaffOnline: 'គ្មាន សេវា ម៉ាស៊ីន ភ្ញៀវ នៅ លើ បណ្ដាញ',
        },
        callHangers: {
            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
            staff: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            outline: 'ខាង ក្រៅ',
        },
        workFlowTypes: {
            noAppealsMode: 'គ្មាន របៀប ភ្ជាប់',
            appealsMode: 'អនុញ្ញាត របៀប អាក់',
        },
        fieldCategories: {
            standardCondition: 'យោង តម្រង ស្តង់ដារ',
            customerCondition: 'លក្ខខណ្ឌ តម្រង ដែល បាន កំណត់ របស់ អ្នក ប្រើ',
        },
        sampleTypes: {
            automatic: 'គំរូ ដោយ ស្វ័យ ប្រវត្តិ',
            manual: 'ការ គំរូ ដោយ ដៃ',
        },
        defaultFields: {
            createdAt: 'ពេលវេលា និយាយComment',
            agentId: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            getDirection: 'ប្រភេទ ហៅ',
            callResult: 'លទ្ធផល ហៅ',
            survey: 'ការ តម្លៃ',
            derivedFrom: 'ប្រភព',
            quitQueueWhy: 'ស្ថានភាព ជួរ',
            queuingDuration: 'ការ ដាក់ ជួរ ពេលវេលាComment',
            talkingSeconds: 'ថិរវេលា ហៅ',
            ringingSeconds: 'ពេលវេលា បង្ហាញ',
            hangupBy: 'ភ្ញៀវ ហៅ ដោយ',
        },
        conditionFieldCategories: {
            fixedField: 'វាល ថេរ',
            customField: 'វាល ផ្ទាល់ខ្លួន',
            secondLevelScore: 'ចល័ត រង',
            formItemScore: 'ធាតុ ពិន្ទុ',
            forbids: 'ធាតុ ដែល បាន បង្ហាញ',
            deadlies: 'ធាតុ ធ្ងន់ធ្ងរ',
        },
        columnFieldCategories: {
            agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            callLog: 'ការ ថត ហៅ',
            businessFields: 'ព័ត៌មាន បណ្ដាញ',
            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
            customerCustomFields: 'ផ្ទាល់ខ្លួន',
            source: 'ប្រភព',
            queue: 'ជួរ',
            fixed: 'ថេរ',
            secondLevelScore: 'ចល័ត រង',
            formItemScore: 'ធាតុ ពិន្ទុ',
            forbids: 'ធាតុ ដែល បាន បង្ហាញ',
            deadlies: 'ធាតុ ធ្ងន់ធ្ងរ',
        },
        taskListDefaultFields: {
            startTime: 'ពេលវេលា និយាយComment',
            name: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            state: 'ស្ថានភាព',
            totalScore: 'ពិន្ទុ សរុប',
            formItemForbidList: 'ធាតុ ដែល បាន បង្ហាញ',
            formItemDeadlyList: 'ធាតុ ធ្ងន់ធ្ងរ',
            comment: 'ការ វាយ តម្លៃ',
            inspector: 'ការ វាយតម្លៃ',
            review: 'កម្មវិធី បន្ត',
        },
        evaluationStates: {
            initial: 'ការ ចាប់ផ្ដើម',
            waitEvaluate: 'ត្រូវ បាន ប្រយោជន៍',
            evaluated: 'ត្រូវ បាន ដាក់ស្នើ',
            waitConfirm: 'ត្រូវ អះអាង',
            waitCheck: 'ត្រូវ បាន ពិនិត្យ មួយ',
            complete: 'បាន បញ្ចប់',
        },
        workBenchInfoTypes: {
            callInfo: 'ព័ត៌មាន ហៅ',
            businessInfo: 'ព័ត៌មាន បណ្ដាញ',
            customerInfo: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
        },
        evaluationEventStates: {
            create: 'បង្កើត@ info: whatsthis',
            valuate: 'ការ តម្លៃ',
            edit: 'កែសម្រួល',
            submit: 'ដាក់ ស្នើ',
            confirm: 'អះអាង',
            appeal: 'ជម្រះ',
            checkConfirm: 'ការ អះអាង',
            check: 'ឡើង វិញ',
        },
        formItemTypes: {
            direct: 'ការ វាយតម្លៃ ផ្ទាល់',
            weight: 'កម្ពស់',
            deduct: 'ដក',
            forbid: 'ធាតុ ដែល បាន បង្ហាញ',
            deadly: 'ធាតុ ធ្ងន់ធ្ងរ',
        },
        appealCheckCallTypes: {
            callIn: 'ហៅ ចូលName',
            callBack: 'ការ ហៅ ថយក្រោយ ពីរ',
            callOut: 'ហត្ថលេខា ផ្ទាល់ ខាងក្រៅ',
            autoCall: 'ការ ហៅ ចេញ ដោយ ស្វ័យ ប្រវត្តិ',
        },
        appealCheckCallStatus: {
            waitReview: 'ត្រូវ បាន ពិនិត្យ មួយ',
            reviewed: 'បាន ឡើង វិញ',
            filed: 'បាន ប័ណ្ណសារ',
        },
        samplingStatus: {
            all: 'ទាំង អស់',
            unchecked: 'មិន បាន ពិនិត្យ មើល ការ ស្រង់ចេញ',
            checked: 'ការ គំរូ',
        },
        inspectionStatus: {
            all: 'ទាំង អស់',
            unread: 'មិនទាន់ អាន',
            readed: 'អាន',
            appeal: 'ជម្រះ',
            review: 'ឡើង វិញ',
            filed: 'បាន ប័ណ្ណសារ',
        },
        gradeChooseHits: {
            yes: 'បាន',
            no: 'គ្មាន ទេ',
        },
        appealCheckStatus: {
            all: 'ស្ថានភាព ទាំងអស់',
            unread: 'មិនទាន់ អាន',
            inComplaint: 'នៅ ក្នុង សត្វ',
            reviewed: 'បាន ឡើង វិញ',
            readed: 'អាន',
            filed: 'បាន ប័ណ្ណសារ',
            spotchecked: 'ការ គំរូ',
        },
        flowStatus: {
            unread: 'មិនទាន់ អាន',
            alreadyRead: 'អាន',
            complaining: 'នៅ ក្នុង សត្វ',
            reviewed: 'បាន ឡើង វិញ',
            sampling: 'មិន បាន ពិនិត្យ មើល ការ ស្រង់ចេញ',
            samplingCompleted: 'ការ គំរូ',
            complainCancel: 'បាន ដក',
        },
        complainStatus: {
            success: 'ជោគជ័យ',
            fail: 'បាន បរាជ័យ',
            default: 'នៅ ក្នុង សត្វ',
            canceled: 'បាន ដក',
        },
        reviewInspectionStatus: {
            inComplaint: 'នៅ ក្នុង សត្វ',
            reviewed: 'បាន ឡើង វិញ',
        },
        gradeChangeTypes: {
            edit: 'កែសម្រួល',
            check: 'ឡើង វិញ',
            file: 'ប័ណ្ណសារ',
            remark: 'ពាក្យ បញ្ជា',
            complain: 'ជម្រះ',
            review: 'ឡើង វិញ',
            reviewEvaluation: 'ការ វាយតម្លៃ',
            sample: 'ការ ត្រួត ពិនិត្យ ចៃដន្យ',
            sampleEvaluation: 'ការ ត្រួត ពិនិត្យ និង វាយតម្លៃ គំរូ',
            sampleSubmit: 'ការ ត្រួត ពិនិត្យ និង ដាក់ស្នើ',
            sampleAssign: 'ការ បម្លែង គំរូ',
            reviewAssign: 'កា រចនា សម្ព័ន្ធ',
            read: 'អាន',
            reviewConfirm: 'ការ អះអាង',
            sampleConfirm: 'អះអាង ការ ត្រួត ពិនិត្យ គំរូ',
            caseBase: 'បន្ថែម ទៅ ក្រុម',
            sampleCancel: 'បោះបង់ ការ ផ្ដល់ គំរូ',
            reviewCancel: 'បោះបង់',
            sampleAgain: 'ការ គំរូ ចង្អុល',
            reviewAgain: 'ការ កំណត់ ឡើង វិញ',
            btachDelete: 'លុប ការ ត្រួត ពិនិត្យ ចៃដន្យ',
            rapidSampling: 'ការ គំរូ រហ័ស',
            reInspection: 'ឡើង វិញ',
            smartTagsChange: 'ការ ផ្លាស់ប្ដូរ ស្លាក ឆ្លាត',
            cancelAppeal: 'បោះបង់ ការ ភ្ញៀវ',
        },
        appealTypes: {
            transliterationError: 'កំហុស បម្រុង',
            discriminationError: 'កំហុស បញ្ហា',
            otherError: 'កំហុស ផ្សេងៗ',
        },
        inspectDataSources: {
            voiceCall: 'ហៅ សំឡេង',
            textDialogue: 'ប្រអប់ អត្ថបទ',
            realTimeVoiceCall: 'ហៅ សំឡេង ពេលវេលា ពិត',
            realTimeTextDialogue: 'ពាក្យ សម្រាក អត្ថបទ ពេលវេលា ពិត',
            wechatDialogue: 'សម័យ micro-section Enterprise',
            taobao: 'ប្រអប់ អត្ថបទ អ៊ីមែល',
            ticket: 'លំដាប់ ការងារ',
            wechatRadio: 'សំឡេង',
        },
        inspectTaskType: {
            all: 'ទាំង អស់',
            common: 'ការ ត្រួត ពិនិត្យ គុណភាព ធម្មតា',
            relate: 'ការ ត្រួត ពិនិត្យ គុណភាព ដែល បាន ទាក់ទង',
        },
        inspectApproveType: {
            all: 'ទាំង អស់',
            resolve: 'បាន អនុញ្ញាត',
            resolving: 'ឡើង វិញ',
            reject: 'មិន បាន បញ្ជូន ត្រួត ពិន្ទុ',
        },
        dataSourceFlags: {
            all: 'គ្មាន ការ ដែន ឡើយ',
            voiceCall: 'ហៅ',
            textDialogue: 'ប្រអប់Comment',
        },
        smartWordsLibrary: {
            hotWords: 'ពាក្យ រង',
            effective: 'មាន ប្រសិទ្ធភាព',
            invalid: 'មិន ត្រឹមត្រូវ',
        },
        activeFlags: {
            effiective: 'មាន ប្រសិទ្ធភាព',
            invalid: 'មិន ត្រឹមត្រូវ',
        },
        labelTypes: {
            dimensionLabel: 'ស្លាក ហៅ',
            classificationLabel: 'ស្លាក ប្រភេទ',
        },
        pointTypes: {
            automatic: 'តម្លៃ ស្វ័យ ប្រវត្តិ',
            manual: 'ការ វាយតម្លៃ ដោយដៃ',
            interactiveDetection: 'រក ឃើញ អន្តរសភាព',
            smartRules: 'ច្បាប់ ឆ្លាត',
            machineLearning: 'របៀប សិក្សា ផ្ទាល់ខ្លួន',
            intelligentModel: 'ម៉ូឌុល ខ្លាំង',
        },
        pointGradeTypes: {
            radio: 'ជម្រើស មួយ',
            input: 'បញ្ចូល',
            select: 'ជ្រើស',
            all: 'សម័យ ទាំងអស់',
            any: 'ជួប ប្រទះ',
            customize: 'ផ្ទាល់ខ្លួន',
        },
        pointNaChecked: {
            check: 'N/A',
        },
        operatorTypes: {
            keyword: 'ការ ផ្គូផ្គង ពាក្យ គន្លឹះ',
            question: 'ប្រយោជន៍ សួរ',
            regular: 'កន្សោម ធម្មតា',
            context: 'ការ ស្ទួន បរិបទ',
            semantics: 'ការ ផ្គូផ្គង semantic',
            word: 'ពាក្យ ស្រដប់',
            dialogue: 'ចន្លោះ',
            speed: 'ការ រក ឃើញ ល្បឿន និយាយComment',
            grabDetection: 'ការ រក ឃើញ ថត',
            semanticTags: 'ស្លាក semantic',
        },
        applyRoles: {
            all: 'ទាំង អស់',
            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
            agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            robot: 'Robot',
        },
        saleApplyRoles: {
            all: 'ទាំង អស់',
            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
            agent: 'ការងារ',
        },
        applyOperatorScopes: {
            all: 'អត្ថបទ ពេញ',
            preCondition: 'លក្ខខណ្ឌ មុន',
            scope: 'ជួរ ដែល បាន បញ្ជាក់@ info: whatsthis',
        },
        keywordScopes: {
            all: 'រកឃើញ ពាក្យ គន្លឹះ ទាំងអស់ ។',
            any: 'រកឃើញ ពាក្យ គន្លឹះ',
        },
        preOperatorHitTypes: {
            first: 'ផ្គូផ្គង ដំបូង',
            every: 'រាល់ ការ ផ្គូផ្គង',
            last: 'ផ្គូផ្គង ចុងក្រោយ',
            any: 'ផ្គូផ្គង',
            none: 'មិន ផ្គូផ្គង',
        },
        operatorRuleTypes: {
            all: 'សម័យ ទាំងអស់',
            any: 'ជួប ប្រទះ',
            custom: 'តួអក្សរ ផ្ទាល់ខ្លួន',
        },
        informationEntityTypes: {
            system: 'ប្រព័ន្ធ',
            custom: 'ផ្ទាល់ខ្លួន',
            moduleCompany: 'ម៉ូឌុល',
        },
        organizationTypes: {
            null: 'គ្មាន ទេ',
            moduleCompany: 'ម៉ូឌុល',
        },
        customType: {
            smartTag: 'ស្រង់ ធាតុ ចេញ',
            scriptTimes: 'ការ រាប់ និយាយComment',
            dataCategory: 'ទិន្នន័យ',
        },
        interactiveQuestionTypes: {
            standard: 'Q & A ស្តង់ដារ',
            multiElement: 'សំណួរ និង ឆ្លើយតប និង ធាតុ ច្រើន',
            guideMultiRound: 'អភិវឌ្ឍន៍ ពហុ រល់',
        },
        targetTypes: {
            all: 'ទាំង អស់',
            customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
        },
        interactiveTypes: {
            similarQList: 'បញ្ហា ស្រដប់',
            exceptSimilarQList: 'បញ្ហា បញ្ហា ស្រដៀង គ្នាName',
            similarAList: 'ចម្លើយ ស្រដៀង គ្នាName',
            wrongAList: 'ចម្លើយ ខុស',
        },
        filterTypes: {
            call: 'ការ ថត ហៅ',
            dialogue: 'ប្រអប់ អត្ថបទName',
            wechat: 'បណ្ដាញ ជម្រះ',
            wechatAll: 'ប្រអប់ ប្ដូរ ជម្រើស ទាំងអស់',
            ticket: 'សម័យ លំដាប់ ការងារ',
            taobao: 'សម័យ E- Comment',
            wechatRadio: 'សំឡេង',
        },
        fieldTypes: {
            keyword: 'ពាក្យ សោ',
            agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            agentGroup: 'ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
            sigleListbox: 'ជម្រើស មួយ',
            multiListbox: 'ជម្រើស ច្រើន',
            text: 'បន្ទាត់ អត្ថបទ',
            textArea: 'បន្ទាត់ ច្រើន',
            dateTime: 'ពេលវេលា',
            number: 'លេខComment',
            voice: '',
            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
            fieldWithLink: 'វាល ជាមួយ តំណ',
            percentage: 'ភាគរយ',
            intelligentClassification: 'ថ្នាក់ ចំណុច',
            testSetList: 'កំណត់ វាល ថាមវន្ត',
            inspector: 'កម្មវិធី ត្រួតពិនិត្យ គុណភាព',
        },
        saveTypes: {
            save: 'រក្សាទុក',
        },
        knowledgeType: {
            oneToOne: 'សំណួរ មួយ និង ចម្លើយ មួយ',
        },
        updateTypes: {
            update: 'ធ្វើ ឲ្យ ទាន់ សម័យ',
            saveAs: 'រក្សាទុក',
        },
        recommendItemActionTypes: {
            similar: 'ស្រដល់',
            exclude: 'មិន រួម បញ្ចូល',
            ignore: 'មិន អើពើ',
        },
        gradeStatus: {
            unread: 'មិនទាន់ អាន',
            alreadyReview: 'បាន ឡើង វិញ',
            alreadyFiled: 'បាន ប័ណ្ណសារ',
            waitReview: 'ត្រូវ បាន ពិនិត្យ មួយ',
            alreadyRead: 'អាន',
        },
        qualityCheckDetailTypes: {
            review: 'ឡើង វិញ',
            spotCheck: 'ការ ត្រួត ពិនិត្យ ចៃដន្យ',
        },
        sampleAndReviewStatus: {
            init: 'មិន បាន ស្រង់ចេញ',
            unread: 'មិនទាន់ អាន',
            alreadyRead: 'អាន',
            complaining: 'នៅ ក្នុង សត្វ',
            reviewed: 'បាន ឡើង វិញ',
            sampling: 'មិន បាន ពិនិត្យ មើល ការ ស្រង់ចេញ',
            samplingCompleted: 'ការ គំរូ',
        },
        interactiveAnswerTypes: {
            noAnswer: 'មិន បាន រកឃើញ ចម្លើយ',
            answer: 'បាន រកឃើញ ចម្លើយ',
            wrongAnswer: 'បាន រកឃើញ ចម្លើយ មិន ត្រឹមត្រូវ',
        },
        interactiveMatchedQuestionTypes: {
            noQuestion: 'រក មិនឃើញ បញ្ហា',
            question: 'បាន រកឃើញ បញ្ហា',
            eliminateQuestion: 'បាន រកឃើញ បញ្ហា ការ ដោះស្រាយ បញ្ហា',
        },
        isManual: {
            yes: 'ការ ត្រួត ពិនិត្យ គុណភាព ដោយ ដៃ',
            no: 'គ្មាន ការ ត្រួត ពិនិត្យ គុណភាព ដៃ ឡើយ',
        },
        readStatus: {
            yes: 'អាន',
            no: 'មិនទាន់ អាន',
        },
        reInspectionType: {
            recalcScore: 'គណនា តែ ពិន្ទុ',
            recheckPoint: 'គណនា ចំណុច និង ពិន្ទុ ត្រួត ពិន្ទុ ឡើង វិញ',
        },
        common: {
            processingTime: 'ពេលវេលា ដំណើរការ',
            noResponseFromCustomerService: 'គ្មាន ការ ឆ្លើយតប ពី សេវា ម៉ាស៊ីន ភ្ញៀវ',
            businessRecords: 'ថត ពាក្យ',
            customFields: 'វាល ផ្ទាល់ខ្លួន',
            flyingBookGroupChat: 'ជជែក ក្រុម សៀវភៅ',
            associatedWorkOrder: 'លំដាប់ ការងារ',
            dataSourceManagement: 'ការ គ្រប់គ្រង ប្រភព ទិន្នន័យ',
            qualityInspectionList: 'បញ្ជី ត្រួតពិនិត្យ គុណភាព',
            reviewList: 'បញ្ជី ឡើង វិញ',
            samplingList: 'បញ្ជី គំរូ',
            theRobotAnswers: 'រ៉ូប៊ី ចម្លើយ ។',
            voiceOfCustomer: 'សំឡេង របស់ ម៉ាស៊ីន ភ្ញៀវ',
            questionnaire: 'កម្រិត សំណួរ',
            originalSoundManagement: 'គ្រប់គ្រង សំឡេង ដើម',
            eCommerceReview: 'E- Comment',
            socialMediaComments: 'សេចក្តី អធិប្បាយ មេឌៀ',
            mixedQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព លាយ',
            videoCall: 'ហៅ វីដេអូ',
            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
            customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            robot: 'Robot',
            customerInformation: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
            workOrderFields: 'វាល លំដាប់ ការងារ',
            intelligentConversationAnalysis: 'ការ វិភាគ សម័យ ជម្រះ',
            insightIntoBusinessWeaknessesListenToCustomerVoicesAndEnhanceMarketingTransformation: 'សមត្ថភាព ក្នុង ក្ដារ ដំណើរការ ខ្លី សូម ស្ដាប់ សំឡេង របស់ អ្នក ភ្ញៀវ បង្កើន ការ បម្រុង ទៀត',
            intelligentAccompanyingPractice: 'ឆ្លាត',
            createImmersiveAIAccompanimentExercisesThatSimulateRealBusinessScenariosEnablingAllEmployeesToMasterGoldMedalScriptsAndQuicklyImproveDialogueSkills: 'បង្កើត AI sparring ដ្បិត ដែល ក្លែង ធ្វើ ការ សម្រាក ពិត ដើម្បី ទទួល ប្រយោជន៍ ពេញលេញ នៃ សមត្ថភាព និយាយ មាស មាស និង ការ ធ្វើ ឲ្យ ប្រសើរ រហ័ស សមត្ថភាព ។',
            intelligentQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
            fullQualityInspectionTimelyAndEfficientWithAccuracyRateAbove: 'ការ ត្រួត ពិនិត្យ គុណភាព ពេញលេញ ពេលវេលា និង មាន ប្រយោជន៍ ដែល មាន អត្រា ភាព ត្រឹមត្រូវ ច្រើន ជាង 85%',
            salesEmpowerment: 'ការ សន្យារ',
            aIReshapesSalesManagementRealizesDigitalAndVisualCommunicationProcessTransparentlyManagesEveryLinkOfSalesIntelligentlyInsightIntoEveryStepOfCommunicationFinelyDiagnosesBusinessProblemsAndPerfectlyReplicatesSalesExperience: 'AI ប្ដូរ ការ គ្រប់គ្រង ការ លុប ប្ដូរ ឡើង វិញ មាន ប្រយោជន៍ គិត ថា ជំហាន នៃ ការ ទំនាក់ទំនង រាល់ គ្នា មាន ប្រយោជន៍ បញ្ហា បណ្ដាញ និង បញ្ហា ពិត ជា ពិត ឡើង វិញ ។',
            algorithmPlatform: 'អាល់ប៊ុម',
            basedOnSelfdevelopedOriginalHeartEngineVoiceSemanticsASRAndNLPModelCustomizationGetThroughBusinessScenarioDataRealizeSystemSelflearningAndAchieveTheGoalOfMoreIntelligentAndMoreAccurateWhenUsed: 'មាន មូលដ្ឋាន លើ សញ្ញា និយាយ នៃ ម៉ាស៊ីន សម្រាក ដើម ដែល បាន អភិវឌ្ឍន៍ ដោយ ខ្លួន ។ ម៉ូដែល ASR និង NLP ត្រូវ បាន ប្ដូរ តាម បំណង ដើម្បី ទទួល តាម ទិន្នន័យ វិធីសាស្ត្រ និង ស្វែងរក ប្រព័ន្ធ សិក្សា ផ្ទាល់ ខ្លួន ។ ដូច្នេះ ដើម្បី ទទួល ប្រយោជន៍ គោល បំណង នៃ ការ ប្រើ ត្រឹមត្រូវ ច្រើន ជាង និង ត្រឹមត្រូវ ។',
            generalSettings: 'ការ កំណត់ ទូទៅ',
            unifiedSettingAndManagementOfDataPermissionsAndEmployeeRoles: 'កំណត់ និង គ្រប់គ្រង សិទ្ធិ ទិន្នន័យ និង តួនាទី របស់ អ្នក ក្នុង វិធី ដែល បាន ឯកសារ',
            callLog: 'ការ ថត ហៅ',
            intelligentRules: 'ច្បាប់ ឆ្លាត',
            customFilter: {
                call: 'ហៅ សំឡេង',
                text: 'ប្រអប់ អត្ថបទ',
                smartTags: 'ស្លាក ឆ្លាត',
                pretreatment: 'ការ ត្រួត ពិន្ទុ',
                smartTagGroup: 'ក្រុម ស្លាក ឆ្លាត',
                currency: 'ទិន្នន័យ ទូទៅ',
                wechat: 'បណ្ដាញ ជម្រះ',
                spotCheck: 'ការ ត្រួត ពិនិត្យ ចៃដន្យ',
                personaField: 'បញ្ជី ម៉ាស៊ីន ភ្ញៀវ',
                ticket: 'សម័យ លំដាប់ ការងារ',
                taobao: 'សម័យ E- Comment',
                wechatRadio: 'សំឡេង',
                reviewList: 'ឡើង វិញ',
            },
            talkerRecognitionType: {
                API: 'អត្តសញ្ញាណ ផ្លូវ បទ API',
                text: 'ការ ស្គាល់ អត្ថបទ',
            },
            operatorTypes: {
                keyword: 'ការ ផ្គូផ្គង ពាក្យ គន្លឹះ',
                question: 'ប្រយោជន៍ សួរ',
                regular: 'កន្សោម ធម្មតា',
                context: 'ការ ស្ទួន បរិបទ',
                semantics: 'ការ ផ្គូផ្គង semantic',
                word: 'ពាក្យ ស្រដប់',
                dialogue: 'ចន្លោះ',
                speed: 'ការ រក ឃើញ ល្បឿន និយាយComment',
                grabDetection: 'ការ រក ឃើញ ថត',
                semanticTags: 'ស្លាក semantic',
                keywordStrict: 'ការ ផ្គូផ្គង ពាក្យ គន្លឹះ',
                link: 'វាល តំណ',
                entityInfoDetection: 'រក ឃើញ ធាតុ ព័ត៌មាន',
                basicInfoDetection: 'រក ឃើញ ព័ត៌មាន មូលដ្ឋាន',
                volume: 'រក ឃើញ កម្រិត សំឡេង',
                emotion: 'ការ វិភាគ សំណួរ',
                grammar: 'ក្ដារ ក្រាប',
                sentenceLength: 'រកឃើញ ប្រវែង ប្រយោជន៍',
                conceptWord: 'ពាក្យ ទំនាក់ទំនង',
                questionsAndAnswers: 'ដំណោះស្រាយ មូលដ្ឋាន សញ្ញា (ចាស់)',
                element: 'សំណួរ និង ចម្លើយ ចំពោះ សំណួរ',
                silent: 'ពេលវេលា អស់ ការ ឆ្លើយតប',
                associate: 'ទិន្នន័យ តាម ផ្លូវComment',
                repeat: 'ធ្វើ ឡើង វិញ',
                timeInterval: 'ថិរវេលា ចន្លោះ',
                typoDetection: 'រក ឃើញ typo',
                silentOld: 'ស្គាល់',
                knowledge: 'ដំណោះស្រាយ សៀវភៅ',
                wecomRemark: 'សម្គាល់ មីក្រូ មធ្យម',
                customerAddTime: 'បន្ថែម ពេលវេលា របស់ ម៉ាស៊ីន ភ្ញៀវ',
            },
            keywordOperators: {
                all: 'ផ្គូផ្គង ទាំងអស់',
                allNot: 'ទាំងអស់ មិន ផ្គូផ្គង',
                any: 'ផ្គូផ្គង',
            },
            applyRoles: {
                all: 'ទាំង អស់',
                customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            },
            sentenceLength: {
                less: 'តិច',
                greater: 'ធំ',
                equal: 'ស្មើ',
                greater_or_equal: 'ធំ ជាង ឬ ស្មើ',
                less_or_equal: 'តូច ជាង ឬ ស្មើ',
            },
            dialogueApplyScopes: {
                differentRoles: 'រវាង តំណ ផ្សេង',
                agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                agentResponse: 'ឆ្លើយតប របស់ អ្នក ភ្ជាប់',
                customerResponse: 'ឆ្លើយតប របស់ អ្នក ភ្ជាប់',
                customerNoResponse: 'ម៉ាស៊ីន ភ្ញៀវ មិន ឆ្លើយតប',
            },
            applyConditionHitTypes: {
                first: 'ចាប់ផ្ដើម ដំបូង ។',
                every: 'រាល់ ទាំង អស់ ។',
                last: 'ចុងក្រោយ',
            },
            applyConditionScopes: {
                current: 'បច្ចុប្បន្ន',
                before: 'មុន',
                after: 'បន្ទាត់',
                beforeAll: 'ទាំងអស់ មុន',
                afterAll: 'បន្ទាប់ ពី ទាំងអស់',
                around: 'ខាង ជា',
            },
            voiceDemoTypes: {
                singleChannel: 'ការ ថត ហៅ ឆានែល តែ មួយName',
                dualChannel: 'ថត ការ ហៅ ឆានែល ពីរ',
            },
            sendStatus: {
                sending: 'កំពុង ផ្ញើ',
                arrive: 'បាន បញ្ចូល',
                fail: 'បាន បរាជ័យ ក្នុង ការ ផ្ញើ',
                off_sending: 'ក្រៅ បណ្ដាញ ផ្ញើ មិនទាន់ អាន',
                off_arrive: 'អាន',
                rollback: 'បាន បដិសេធ',
            },
            collectionMethod: {
                assignment: 'ការ ផ្ដល់ ផ្ទាល់',
                entity: 'ស្រង់ ធាតុ ចេញ',
            },
            systemTypes: {
                qa: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
                wfm: 'ការ កំណត់ ពេល ត្រឹមត្រូវ',
            },
            entityOperators: {
                equals: 'ព័ត៌មាន ស្មើ',
                notEquals: 'មិន ស្មើ នឹង ព័ត៌មាន',
                contains: 'មាន ព័ត៌មាន ៖',
                notContains: 'មិនមាន ព័ត៌មាន ឡើយ',
                equalsFix: 'ស្មើ នឹង តម្លៃ ថេរ',
                notEqualsFix: 'មិន ស្មើ នឹង តម្លៃ ថេរ',
                containsFix: 'មាន តម្លៃ ថេរ',
                notContainsFix: 'មិន មាន តម្លៃ ថេរ ឡើយ',
            },
            basicInfoOperators: {
                equals: 'ស្មើ',
                notEquals: 'មិន ស្មើ',
                contains: 'មាន ថ្មី',
                notContains: 'មិនមាន ទេ',
                isNull: 'ទទេ',
                isNotNull: 'មិន ទទេ',
            },
            volumeDetectionWays: {
                loudness: 'កម្រិត សំឡេង',
                rangeAbilitySelf: 'ជួរ ការ ផ្លាស់ប្ដូរ (ទាក់ទង នឹង ខ្ញុំ បាន ធ្វើ ក្នុង ប្រយោជន៍ មុន)',
                rangeAbilityOth: 'ជួរ ការ ផ្លាស់ប្ដូរ ( ប្រៀបធៀប នឹង ពាក្យ ខាង លើ)',
                rangeAbility3: 'ជួរ ការ ផ្លាស់ប្ដូរ (ទាក់ទង នឹង ខ្ញុំ នៅ ក្នុង ប្រយោជន៍ នេះ)',
            },
            volumeDetectionOperators: {
                is: 'ស្មើ',
                not: 'មិន ស្មើ',
                greaterThan: 'ធំ',
                greaterThanEq: 'ធំ ជាង ឬ ស្មើ',
                lessThan: 'តិច',
                lessThanEq: 'តូច ជាង ឬ ស្មើ',
            },
            sentimentTypes: {
                positive: 'សកម្មភាព វិសេស',
                negative: 'សកម្មភាព អុហ្វសិត',
                neutral: 'សកម្មភាព អ៊ីមែល',
                thankful: 'សរសើរ',
                happy: 'សុវត្ថិភាព',
                complaining: 'ជម្រះ',
                angry: 'កម្លាំង',
                post: 'ផ្នែក ខាងមុខName',
                negat: 'ហុច',
                neut: 'អ៊ីមែល',
            },
            emotionOperators: {
                is: 'ការ តភ្ជាប់Name',
                not: 'មិន ត្រឹមត្រូវ',
            },
            propTypes: {
                system: 'ប្រព័ន្ធ',
                user: 'ផ្ទាល់ខ្លួន',
            },
            valueTypes: {
                text: 'អត្ថបទ',
                number: 'លេខComment',
            },
        },
        tasks: {
            agent: 'ភាគ',
            assignToDesignatedPersons: 'ការ ផ្ដល់ ឲ្យ មនុស្ស ដែល បាន រៀប ចំ',
            bigModelRules: 'ច្បាប់ ម៉ូឌុល ធំ',
            topicAnalysis: 'ការ វិភាគ បណ្ដាញ',
            customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            addAutomatically: 'បន្ថែម ដោយ ស្វ័យ ប្រវត្តិ',
            createAQualitySparringTask: 'បង្កើត ភារកិច្ច sparring គុណភាព',
            forcedCustomerServiceOffline: 'សេវា ម៉ាស៊ីន ភ្ញៀវ ដែល បាន បង្ខំ បណ្ដាញ',
            allowCustomGrievance: 'អនុញ្ញាត ឲ្យ ភ្ញៀវ ផ្ទាល់ខ្លួន',
            businessSummary: 'សង្ខេប ពាក្យ',
            theDayBeforeYesterday: 'ថ្ងៃ មុន ម្ល',
            assessActionTypes: {
                reassess: 'ការ តម្លៃ ឡើងវិញ',
            },
            scoreType: {
                aiScore: 'ការ វាយតម្លៃ មធ្យម',
                manualScore: 'ការ វាយតម្លៃ ដោយដៃ',
                interactiveDetection: 'រក ឃើញ អន្តរសភាព',
                smartRules: 'ច្បាប់ ឆ្លាត',
                machineLearning: 'របៀប សិក្សា ផ្ទាល់ខ្លួន',
            },
            inspectType: {
                inspectTrue: 'ពិនិត្យ មួយ',
                inspectFalse: 'មិន បាន ធីក',
            },
            operatorType: {
                keyword: 'ការ ផ្គូផ្គង ពាក្យ គន្លឹះ',
                notKeyword: 'ពាក្យ គន្លឹះ មិន ត្រឹមត្រូវ',
            },
            applyRole: {
                all: 'ទាំង អស់',
                customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            },
            applyScope: {
                all: 'ទាំង អស់',
                specific: 'ពាក្យ ដែល បាន បញ្ជាក់@ info: whatsthis',
                scope: 'ជួរ ដែល បាន បញ្ជាក់@ info: whatsthis',
            },
            judgeStrategy: {
                all: 'ធ្វើ ឲ្យ លក្ខខណ្ឌ ទាំងអស់',
                arbitrarily: 'ការ ផ្គូផ្គង',
                custom: 'តួអក្សរ ផ្ទាល់ខ្លួន',
            },
            checkPointStatus: {
                waitFor: 'រង់ចាំ ការ ត្រួត ពិនិត្យComment',
                notDeductScore: 'គ្មាន ការ ដោះស្រាយ',
                deductScore: 'ដក',
            },
            applyOptions: {
                hit: 'លក្ខខណ្ឌ បាន បាញ់',
                notHit: 'គ្មាន លក្ខខណ្ឌ បាន បញ្ជាក់ ទេ',
            },
            gradeTypes: {
                yesOrNo: 'ការ តភ្ជាប់Name',
                input: 'បញ្ចូល ដោយ ដៃ',
                level: 'ការ វាយតម្លៃ ថ្នាយ',
                multipleFactors: 'ធាតុ ច្រើន',
            },
            gradeChooseHits: {
                yes: 'បាន',
                no: 'គ្មាន ទេ',
            },
            gradeChangeTypes: {
                edit: 'កែសម្រួល',
                check: 'ឡើង វិញ',
                file: 'ប័ណ្ណសារ',
                remark: 'ពាក្យ បញ្ជា',
                complain: 'ជម្រះ',
                review: 'ឡើង វិញ',
                reviewEvaluation: 'ការ វាយតម្លៃ',
                sample: 'ការ ត្រួត ពិនិត្យ ចៃដន្យ',
                sampleEvaluation: 'ការ ត្រួត ពិនិត្យ និង វាយតម្លៃ គំរូ',
                sampleSubmit: 'ការ ត្រួត ពិនិត្យ និង ដាក់ស្នើ',
                sampleAssign: 'ការ បម្លែង គំរូ',
                reviewAssign: 'កា រចនា សម្ព័ន្ធ',
                read: 'អាន',
                reviewConfirm: 'ការ អះអាង',
                sampleConfirm: 'អះអាង ការ ត្រួត ពិនិត្យ គំរូ',
            },
            gradeStatus: {
                unread: 'មិនទាន់ អាន',
                alreadyReview: 'បាន ឡើង វិញ',
                alreadyFild: 'បាន ប័ណ្ណសារ',
                waitReview: 'ត្រូវ បាន ពិនិត្យ មួយ',
                alreadyRead: 'អាន',
            },
            samplingFrequencyTypes: {
                everyDay: 'ថ្ងៃថែម',
                everyWeek: 'សប្ដាហ៍',
                everyMonth: 'រាល់ ខែ',
            },
            samplingEveryDayTimeTypes: {
                yesterday: 'ម្រាមង',
                today: 'ថ្ងៃ នេះ@ item: inlistbox',
            },
            samplingEveryWeekTimeTypes: {
                thisWeek: 'សប្ដាហ៍ នេះ',
                lastWeek: 'សប្ដាហ៍ មុន',
            },
            samplingEveryMonthTimeTypes: {
                thisMonth: 'ខែ នេះ',
                lastMonth: 'ខែ មុន',
            },
            samplingTypes: {
                random: 'គំរូ ចៃដន្យ',
                proportional: 'គំរូ សមាមាត្រ',
            },
            weekdays: {
                Monday: 'ថ្ងៃ ចុងក្រោយ',
                Tuesday: 'ថ្ងៃ ខ្លាំង',
                Wednesday: 'ថ្ងៃ ខ្លាំង',
                Thursday: 'ថ្ងៃ ជម្រះ',
                Friday: 'ថ្ងៃ ខែ',
                Saturday: 'ថ្ងៃ ស្លាក',
                Sunday: 'ថ្ងៃ ខ្លាំង',
            },
            distributeTypes: {
                rule: 'ការ បម្រុង អាទិភាព បន្ទាត',
                average: 'ការ ចែកចាយ មធ្យម',
            },
            notMatchAnyRuleTypes: {
                random: 'ការ ចែកចាយ មធ្យម',
                assign: 'ការ ផ្ដល់ ឲ្យ មនុស្ស ដែល បាន ដឹក នាំ់',
                ignore: 'មិន បាន ផ្ដល់ ទេ',
            },
            inspectorTypes: {
                all: 'អ្នក ត្រួតពិនិត្យ គុណភាព ទាំងអស់',
                some: 'អ្នក ត្រួតពិនិត្យ គុណភាព ដែល បាន ជ្រើស',
            },
            pushFrequencyTypes: {
                everyDay: 'ថ្ងៃថែម',
                everyWeek: 'សប្ដាហ៍',
                everyMonth: 'រាល់ ខែ',
                inspectionUpdate: 'ការ ត្រួត ពិនិត្យ ភាព ទាន់ សម័យ',
                timelyInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ពេលវេលា ពិត',
            },
            pushObjectTypes: {
                email: 'បញ្ជាក់ ប្រអប់ សំបុត្រ',
                staff: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            },
            reviewOptions: {
                reviewResult: 'បង្ហាញ លទ្ធផល ត្រួតពិនិត្យ គុណភាព កំឡុង ពេល ពិនិត្យ មួយ',
                reviewRecord: 'បង្ហាញ ថត ដែល ទាក់ទង កំឡុង ពេល ពិនិត្យ មួយ',
                reviewAgentHidden: 'លាក់ ព័ត៌មាន ភ្នាក់ងារ កំឡុង ពេល ពិនិត្យ មួយ',
                samplingResult: 'បង្ហាញ លទ្ធផល ត្រួតពិនិត្យ គុណភាព កំឡុង ពេល ត្រួត ពិនិត្យ ចៃដន្យ',
                samplingRecord: 'បង្ហាញ ការ ត្រួត ពិនិត្យ ចៃដន្យ',
                sampleAgentHidden: 'លាក់ ព័ត៌មាន សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ កំឡុង ពេល ត្រួត ពិនិត្យ ចៃដន្យ',
                checkExportAddCallInfoIphone: 'ភ្ជាប់ កំណត់ ហៅ ពេល នាំចេញ បញ្ជី មួយ',
                sampleExportAddCallInfoIphone: 'ភ្ជាប់ កំណត់ ហៅ ពេល នាំចេញ បញ្ជី មួយ',
                checkExportAddCallInfoText: 'ភ្ជាប់ កំណត់ សម្គាល់ សម្ងាត់ នៅពេល នាំចេញ បញ្ជា',
                sampleExportAddCallInfoText: 'ភ្ជាប់ កំណត់ សម្គាល់ សម្ងាត់ នៅពេល នាំចេញ បញ្ជា',
                inspectionExportAddCallInfoIphone: 'ភ្ជាប់ ថត ការ ហៅ នៅពេល នាំចេញ បញ្ជី (ឡើង ទៅ កាន់ 10000 អាច ត្រូវ បាន នាំចេញ នៅ ពេល មួយ)',
                inspectionExportAddCallInfoText: 'ភ្ជាប់ ការ ថត ព័ត៌មាន ពេល នាំចេញ បញ្ជី (ឡើង ទៅ កាន់ 10000 អាច ត្រូវ បាន នាំចេញ នៅ ពេល មួយ)',
            },
            fastSampleInDetailList: {
                fastSampleInInspectDetail: 'អនុញ្ញាត ឲ្យ ពិនិត្យ មើល ចំណុច រហ័ស ក្នុង សេចក្ដី លម្អិត គុណភាព',
                fastSampleInSampleDetail: 'អនុញ្ញាត ឲ្យ ប្រតិបត្តិ រហ័ស នៃ ការ ត្រួត ពិនិត្យ ចៃដន្យ',
                fastSampleInReviewDetail: 'អនុញ្ញាត ឲ្យ ប្រតិបត្តិ ការ ពិនិត្យ មើល រហ័ស នៅ ក្នុង សេចក្ដី លម្អិត មួយ',
            },
            permitCustomReasonList: {
                permitCustomReason: 'អនុញ្ញាត មូលដ្ឋាន ផ្ទាល់ ខ្លួន សម្រាប់ បិទ',
            },
            autoMateTasks: {
                autoLoad: 'បន្ថែម ដោយ ស្វ័យ ប្រវត្តិ',
                sample: 'ត្រួតពិនិត្យ គំរូ ដោយ ស្វ័យ ប្រវត្តិ',
                assign: 'បម្រុង ទុក ដោយ ស្វ័យ ប្រវត្តិ',
                pushes: 'ចុច ស្វ័យ ប្រវត្តិ',
                assess: 'ការ ប្រាកដ ដោយ ស្វ័យ ប្រវត្តិ',
                check: 'ការ ពិនិត្យ មើល គំរូ',
                case: 'ការ ធ្វើ សមកាលកម្ម បណ្ណាល័យ រូបភាព',
            },
            qualityCheckDetailTypes: {
                review: 'ឡើង វិញ',
                spotCheck: 'ការ ត្រួត ពិនិត្យ ចៃដន្យ',
            },
            appealTypes: {
                transliterationError: 'កំហុស បម្រុង',
                discriminationError: 'កំហុស បញ្ហា',
                otherError: 'កំហុស ផ្សេងៗ',
            },
            inspectDataSources: {
                voiceCall: 'ហៅ សំឡេង',
                textDialogue: 'ប្រអប់ អត្ថបទ',
                realTimeVoiceCall: 'ហៅ សំឡេង ពេលវេលា ពិត',
                realTimeTextDialogue: 'ពាក្យ សម្រាក អត្ថបទ ពេលវេលា ពិត',
            },
            pointTypes: {
                automatic: 'តម្លៃ ស្វ័យ ប្រវត្តិ',
                manual: 'ការ វាយតម្លៃ ដោយដៃ',
                interactiveDetection: 'រក ឃើញ អន្តរសភាព',
            },
            pointGradeTypes: {
                radio: 'ជម្រើស មួយ',
                input: 'បញ្ចូល',
                select: 'ជ្រើស',
            },
            sampleAndReviewStatus: {
                init: 'មិន បាន ស្រង់ចេញ',
                unread: 'មិនទាន់ អាន',
                alreadyRead: 'អាន',
                complaining: 'នៅ ក្នុង សត្វ',
                reviewed: 'បាន ឡើង វិញ',
                sampling: 'មិន បាន ពិនិត្យ មើល ការ ស្រង់ចេញ',
                samplingCompleted: 'ការ គំរូ',
            },
            wayOverUpperLimits: {
                ignoreExcessSpillover: 'មិន អើពើ ទំហំ ច្រើន ទំហំ',
                automaticWeightCalculation: 'គណនី ភាព ស្វ័យ ប្រវត្តិ',
            },
            calculateScoreTypes: {
                add: 'ចំណុច ចំណុច',
                sub: 'ចំណុច មីន',
            },
            naChecked: {
                check: 'ធាតុ នេះ មិន រួម បញ្ចូល ក្នុង ការ រក ឃើញ អនុញ្ញាត',
            },
            pointNaChecked: {
                check: 'N/A',
            },
            interactiveRules: {
                proportional: 'ចំណុច ភាគរយ',
                allRight: 'ចំណុច ត្រឹមត្រូវ ទាំងអស់',
                anyRight: 'ពិន្ទុ ត្រឹមត្រូវ',
            },
            noHitQuestionResults: {
                true: 'លទ្ធផល គឺ "បាទ"',
                false: 'លទ្ធផល គឺ "គ្មាន"',
            },
            repetRules: {
                same: 'មាតិកា ដូចគ្នា ជា គ្នា',
                similar: 'ភាព ស្រដៀង គ្នា ជា semantic',
            },
            relateConditions: {
                highlightQuestion: 'បន្លិច បញ្ហា',
                highlightAnswer: 'ចម្លើយ បន្លិច',
                hightlightFoctors: 'បន្លិច ធាតុComment',
            },
            interactiveQuestionTypes: {
                question: 'បាន រកឃើញ បញ្ហា',
                eliminateQuestion: 'បាន រកឃើញ បញ្ហា ការ ដោះស្រាយ បញ្ហា',
            },
            interactiveAnswerTypes: {
                noAnswer: 'មិន បាន រកឃើញ ចម្លើយ',
                answer: 'បាន រកឃើញ ចម្លើយ',
                wrongAnswer: 'បាន រកឃើញ ចម្លើយ មិន ត្រឹមត្រូវ',
            },
            inspectionUpdateTypes: {
                autoInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ស្វ័យ ប្រវត្តិ',
                autoInspectionWechat: 'ការ វិភាគ ស្វ័យ ប្រវត្តិ',
                artificialSampling: 'ការ គំរូ ដោយ ដៃ',
                artificialReview: 'មើល ដៃ',
                manualModification: 'ការ គំរូ រហ័ស',
                timelyInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ពេលវេលា ពិត',
                samplingAssign: 'ការ បម្លែង គំរូ',
                artificialComplain: 'ការ ដាក់ស្នើ',
                fastSampling: 'ការ ត្រួត ពិនិត្យ គំរូ រហ័ស និង ការ ដាក់ស្នើ',
                recheckInspection: 'ឡើង វិញ',
                recheckInspectionWechat: 'វិភាគ ឡើង វិញ',
            },
            timelyInspectionTypes: {
                timelyInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ពេលវេលា ពិត',
            },
            pushActionTypes: {
                email: 'សំបុត្រ',
                interfacePush: 'ចុច ចំណុច ប្រទាក់',
            },
            pushDetailWays: {
                riskAlert: 'ការ ព្រមាន ការ លទ្ធផល',
                subscribe: 'ជាវ ជាវ សារ',
            },
            riskAlertPushDataTypes: {
                dialogueMessage: 'សារ',
                inspectionResults: 'លទ្ធផល ត្រួត ពិនិត្យ គុណភាព',
            },
            subscribePushDataTypes: {
                dialogueMessage: 'សារ',
                textContent: 'មាតិកា អត្ថបទ នៃ ការ ហៅ/ វណ្ណៈ',
                inspectionResults: 'លទ្ធផល ត្រួត ពិនិត្យ គុណភាព',
            },
            pushRequestMethods: {
                post: 'POST',
            },
            pushContentTypes: {
                json: 'JSON',
            },
            notMatchPreRule: {
                average: 'ពិន្ទុ មធ្យម',
                addOrSubtract: 'ចំណុច ផ្ទាល់ និង ចំណុច',
                noChange: 'គ្មាន ចំណុច បន្ថែម',
            },
            defaultScore: {
                empty: 'ទទេ',
                add: 'ចំណុច ចំណុច',
                notAdd: 'គ្មាន ចំណុច បន្ថែម ទេ',
                sub: 'ចំណុច មីន',
                notSub: 'គ្មាន ចំណុច បាន បន្ថយ',
                na: 'N/A',
                input: 'បញ្ចូល ដោយ ដៃ',
                choose: 'ជ្រើស',
            },
            strategyTypes: {
                hitAdd: 'គ្រាប់ប់',
                hitNotAdd: 'គ្មាន ចំណុច សម្រាប់ តូច',
                hitSub: 'ចំណុច គូរ',
                hitNotSub: 'គូរ មិន បន្ថយ ចំណុច',
            },
        },
        download: {
            exportStatus: {
                prepare: 'ក្នុង ការ រៀបចំ',
                process: 'កំពុង វឌ្ឍន៍',
                faild: 'នាំចេញ បាន បរាជ័យ',
                success: 'ជោគជ័យ',
            },
        },
        messageType: {
            all: 'ទាំង អស់',
            monitor: 'ការ ត្រួតពិនិត្យ ភ្លាមៗ',
            trigger: 'ការ បិទ ការ ជូន ដំណឹង',
            timing: 'របាយការណ៍ ពេលវេលា',
        },
        messagePushType: {
            all: 'ទាំង អស់',
            system: 'សារ ប្រព័ន្ធ',
            sdk: 'SDK សារ',
            push: 'ចុច ចំណុច ប្រទាក់',
            email: 'សំបុត្រ',
            udesk: 'ការ ជូនដំណឹង udesk',
            udeskWhite: 'ការ ជូនដំណឹង ប្រព័ន្ធ សេវា ម៉ាស៊ីន ភ្ញៀវ',
            weChat: 'មីក្រូ សារ សំណួរ',
        },
        autoAddPushTarget: {
            sampleAssignInspector: 'ផ្ដល់ អ្នក ត្រួតពិនិត្យ គំរូ',
            sampleInspector: 'កម្មវិធី ត្រួតពិនិត្យ គំរូ',
            assignReviewer: 'ផ្ដល់ កម្មវិធី ត្រួត ពិនិត្យComment',
            reviewer: 'កម្មវិធី បន្ត',
            taskInspector: 'កម្មវិធី ត្រួតពិនិត្យ ភារកិច្ច',
        },
        sdkPushType: {
            webHook: 'បណ្ដាញ ស្តង់ដារ',
            dingDing: 'រ៉ូប៊ីន ឌីងTalk',
            weChat: 'រចនា សម្ព័ន្ធ WeChat',
            customer: 'មាតិកា Json ផ្ទាល់ខ្លួន',
        },
        inspectionRemarksType: {
            inspection: 'ការ ត្រួត ពិនិត្យ គុណភាព',
            check: 'ការ ត្រួត ពិនិត្យ ចៃដន្យ',
            review: 'ឡើង វិញ',
        },
        segmentationStrategyType: {
            count: 'ចំនួន សារ',
            spacing: 'ចន្លោះពេល សារ',
        },
        segmentationStrategy: {
            byTime: 'ចម្រៀក ពេលវេលា',
            customize: 'គ្រាប់ រំកម្ម',
        },
        inspectType: {
            commonInspect: 'ការ ត្រួត ពិនិត្យ គុណភាព ធម្មតា',
            associateInspect: 'ការ ត្រួត ពិនិត្យ គុណភាព ដែល បាន ទាក់ទង',
        },
        typoDetectionOperators: {
            less: 'តិច',
            greater: 'ធំ',
        },
        autoAddTypes: {
            realTimeAdd: 'បន្ថែម ពេលវេលា ពិល',
            timingAdd: 'បន្ថែម ពេលវេលា',
        },
        messageTypes: {
            text: 'សារ អត្ថបទ',
            markdown: 'សារ',
        },
        inServiceStatus: {
            activated: 'បាន ធ្វើ សកម្ម',
            disabled: 'បាន បិទ',
            inactivated: 'មិន បាន ធ្វើ សកម្ម',
            resigned: 'ចេញ ពី ការ បង្ហាញ',
        },
        roles: {
            agent: 'ការងារ',
            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
        },
        commentVisibleAuthority: {
            all: 'មើល ឃើញ សម្រាប់ មនុស្ស ទាំង អស់',
            self: 'មាន តែ មើល ឃើញ សម្រាប់ ផ្ទាល់ ខ្លួន ប៉ុណ្ណោះ',
            designation: 'មនុស្ស ដែល បាន ដែន មើល ឃើញName',
        },
        appealCheckingTask: {
            agent: 'ភាគ',
            flyingBookGroupChat: 'ជជែក ក្រុម សៀវភៅ',
            finalAppeal: 'សិទ្ធិ ចុងក្រោយ',
            largeModel: 'ម៉ូដែល ធំ',
            overdueReview: 'ទិដ្ឋភាព ធ្នូ',
            questionnaire: 'កម្រិត សំណួរ',
            eCommerceReview: 'E- Comment',
            socialMediaComments: 'សេចក្តី អធិប្បាយ មេឌៀ',
            mixedType: 'ប្រភេទ លាយ',
            videoCall: 'ហៅ វីដេអូ',
            customModel: 'ម៉ូដែល ផ្ទាល់ខ្លួន',
            universalModel: 'ម៉ូដែល ទូទៅ',
            enterpriseWeChatText: 'អត្ថបទ ក្រហម',
            generalQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ទូទៅ',
            processQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ដំណើរការ',
            voiceCopy: 'ថាស សំឡេង ទេ',
            beEqualTo: 'ស្មើ',
            notEqualTo: 'មិន ស្មើ',
            canAppeal: 'អាច សិទ្ធិ',
            noAppeal: 'មិន ត្រឹមត្រូវ',
        },
        wechat: {
            redEnvelopes: 'ក្រហម',
            text: 'អត្ថបទ',
            picture: 'រូបភាព',
            voice: 'សំឡេង',
            voiceCall: 'ហៅ សំឡេង',
            video: 'វីដេអូ',
            businessCard: 'កាត ពាក្យ',
            position: 'ទីតាំង',
            expression: 'កន្សា',
            link: 'តំណ',
            applet: 'កម្មវិធី តូចៗ',
            chatRecord: 'ថត ជជែក កំសាន្ត',
            mixedMessage: 'សារ ដែល បាន លាយ',
            file: 'ឯកសារ',
        },
        gong: {
            sessionActivity: 'សកម្មភាព សម័យ',
            conversationAction: 'សកម្មភាព សម័យ',
            riskSemantics: 'គ្រោះថ្នាក់',
            daysNotFollowedUp: 'ថ្ងៃ មិន បាន បន្ទាត់',
            waysideData: 'ទិន្នន័យ តាម ផ្លូវComment',
            notStarted: 'មិន បាន ចាប់ផ្ដើម',
            completed: 'បាន បញ្ចប់',
            haveInHand: 'កំពុង វឌ្ឍន៍',
            unpublished: 'មិន បាន បោះពុម្ព',
            published: 'បាន បោះពុម្ព',
            knowledgePoints: 'ចំណុច ស្គាល់ ចំណុច',
            technologicalProcess: 'ដំណើរការ',
            notMarked: 'មិន បាន ស្លាក',
            inAnnotation: 'ក្នុង ការ ហៅ',
            annotated: 'ស្លាក',
        },
        qualityChecingTask: {
            appealCanceled: 'បាន បោះបង់ ការ សិទ្ធិ',
            complaintExpired: 'ផុត កំណត់',
            incomingCall: 'ហៅ ចូលName',
            exhale: 'ប្រសើរ',
            incomingCallthirdParty: 'ការ ហៅ ចូល (វិធី បី)',
            incomingCallconsultation: 'ហៅ ចូល (កា រកំណួរ)',
            incomingCallforcedInsertion: 'ការ ហៅ ចូល (កម្លាំង)',
            incomingCallmonitoring: 'ការ ហៅ ចូល (កំពុង ស្ដាប់)',
            incomingCalltransfer: 'ហៅ ចូល (ផ្ទេរ)',
            incomingCallinterception: 'ការ ហៅ ចូល (ចំណុច ប្រទាក់)',
            incomingCalltransferToExternalLine: 'ការ ហៅ ចូល (ផ្ទេរ ខាងក្រៅ បន្ទាត់)',
            incomingCallthirdPartyExternalLine: 'ការ ហៅ ចូល (បី ផ្លូវ ខាងក្រៅ បន្ទាត់)',
            incomingCallexternalLine: 'ហៅ ចូល (ការ ជូន ដំណឹង ខាងក្រៅ បន្ទាត់)',
            outgoingCallthirdParty: 'លទ្ធផល (បី ផ្លូវ)',
            outgoingCalltransfer: 'ចេញ (ផ្ទេរ)',
            outgoingCallforcedInsertion: 'លទ្ធផល (កម្លាំង)',
            outgoingCallmonitoring: 'ចេញ (ការ ស្ដាប់)',
            outgoingCallinterception: 'ការ ហៅ ចេញ ( ប្រតិបត្តិ)',
            outgoingCalltransferToExternalLine: 'ចេញ (ផ្ទេរ ខាងក្រៅ បន្ទាត់)',
            outgoingCallthreePartyExternalLine: 'ការ ហៅ ចេញ (បី ផ្លូវ ខាងក្រៅ បន្ទាត់)',
            customerServiceAnswer: 'ចម្លើយ សេវា ម៉ាស៊ីន ភ្ញៀវ',
            customerServiceMissed: 'បាត់ សេវា ម៉ាស៊ីន ភ្ញៀវ',
            customerAnswer: 'ឆ្លើយតប របស់ អ្នក ជំនួយ',
            customerMissed: 'បាន បាត់ កម្មវិធី',
            theTelephoneIsBusy: 'រវល់ ទូរស័ព្ទ',
            phoneOffline: 'ទូរស័ព្ទ ក្រៅ បណ្ដាញ',
            customerQuickHanging: 'រហូត របស់ អ្នក ប្ដូរ រហ័ស',
            clientHangsUp: 'ម៉ាស៊ីន ភ្ញៀវ ដោយ',
            queueTimeout: 'អស់ ពេលវេលា ជួរ',
            giveUpQueuing: 'ការ បោះបង់ ជួរ',
            outsideLineAnswering: 'ចម្លើយ ខាងក្រៅ',
            externalLineIsNotConnected: 'មិន បាន តភ្ជាប់ បន្ទាត់ ខាងក្រៅ',
            noQueueSelected: 'មិន បាន ជ្រើស ជួរ',
            notEvaluated: 'មិន បាន វាយតម្លៃ',
            noEvaluationRequired: 'គ្មាន ការ វាយតម្លៃ',
            queuingSucceeded: 'ជោគជ័យ ជួរ',
            noCustomerServiceOnline: 'គ្មាន សេវា ម៉ាស៊ីន ភ្ញៀវ នៅ លើ បណ្ដាញ',
            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
            customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
            outsideLines: 'ខាង ក្រៅ',
        },
        sessionActivity: {
            single: 'មធ្យម',
            all: 'ហៅ សរុប',
            allTime: 'ថិរវេលា ហៅ សរុប',
        },
        sessionAction: {
            salesProportion: 'សមាមាត្រ ចម្លង',
            salesLongest: 'មធ្យម',
            customerLongest: 'និយាយ អ្នក ភ្ញៀវ វែង បំផុត មធ្យម',
            discussNumber: 'ចំនួន ការ ពិពណ៌នា ជម្រៅ',
            frequency: 'ប្រេកង់ សំណួរ',
        },
        monitorCriteria: {
            all: 'មុន និង បន្ទាប់',
            before: 'មុន',
            after: 'បន្ទាត់',
        },
        monitorTimeCycle: {
            day: 'ថ្ងៃStencils',
            week: 'សប្ដាហ៍',
            month: 'ខែ',
        },
        monitorGroupTestType: {
            ab: 'ប្រៀបធៀប នៃ ក្រុម ពីរ',
            a: 'ក្រុម A',
            b: 'ក្រុម B',
        },
        fields: {
            customerServiceDepartment: 'វឌ្ឍនភាព សេវា ម៉ាស៊ីន ភ្ញៀវ',
            belongToDepartment: 'ចូល ទៅ កាន់ វឌ្ឍន៍',
            doesNotBelongToTheDepartment: 'មិនមែន ជា ភាគ ទៀត',
            department: 'ហត្ថលេខា',
            customerTags: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
            member: 'សមាជ្ញ',
            time: 'ពេលវេលា',
            cascade: 'កាសកូដ',
            anyMatch: 'ផ្គូផ្គង',
            keyWord: 'ពាក្យ សោ',
            keyEvents: 'ព្រឹត្តិការណ៍ សោ',
        },
        semanticIntelligence: {
            staff: 'ការងារ',
            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
            employeesAndCustomers: 'កិច្ចការ និង អ្នក ភ្ញៀវ',
            notStarted: 'មិន បាន ចាប់ផ្ដើម',
            haveInHand: 'កំពុង វឌ្ឍន៍',
            completed: 'បាន បញ្ចប់',
            callRecording: 'ការ ថត ហៅ',
            enterpriseWeChatCall: 'សៀវភៅ មីក្រូ',
            enterpriseWeChatText: 'អត្ថបទ ក្រហម',
            discourseMiningForObjectionHandling: 'ការ ដោះស្រាយ សំឡេង',
            productSellingPointScriptsMining: 'ការ ដោះស្រាយ ចំណុច សម្រាំង',
            conversationScenario: 'សម័យ',
            topicOfConversation: 'ប្រធាន បទ',
            keyEvents: 'ព្រឹត្តិការណ៍ សោ',
            customerLabel: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
            includeAny: 'មាន ថ្មី',
            includeAll: 'មាន ទាំងអស់',
            and: 'និង សិទ្ធិ',
            or: 'ឬ ថត',
            question: 'ប្រយោជន៍ សួរ',
            nonInterrogativeSentence: 'ប្រយោជន៍ មិន សួរ សួរ',
        },
        coach: {
            comprehensiveScore: 'ពិន្ទុ ពិន្ទុ',
            comprehensiveScoreCourseQuality05LearningEffect02InteractiveExperience: 'ពិន្ទុ ពិនិត្យ = ០. ៣ * គុណភាព ខ្ពស់ ៥.៥ * បែបផែន សិក្សា 0. 2 * អន្តរសកម្ម',
            courseQuality: 'គុណភាព ដក',
            learningEffect: 'បែបផែន បង្រៀនName',
            interactiveExperience: 'អន្តរសកម្ម',
            greaterThanOrEqual: 'ធំ ជាង ឬ ស្មើ',
            lessThanOrEqual: 'តូច ជាង ឬ ស្មើ',
            equal: 'ស្មើ',
            smartSparring: 'ឆ្លាត',
            intelligentQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
            notPassed: 'មិន មែនទេ',
            analogTelephone: 'ទូរស័ព្ទ អាណាឡូក',
            enterScenarioInformation: 'បញ្ចូល ព័ត៌មាន វិធីសាស្ត្រ',
            generateDialogueFramework: 'បង្កើត គ្រោងការណ៍ ប្រអប់ មួយ',
            generatePromptLanguage: 'បាន បង្កើត សំណួរ',
            aIGeneratedDialogue: 'ប្រអប់ ដែល បាន បង្កើត AI',
            system: 'ប្រព័ន្ធ',
            custom: 'ផ្ទាល់ខ្លួន',
            flow: 'ដំណើរការ',
            script: 'ពាក្យ',
            express: 'កន្សា',
            emotion: 'សមាសភាព',
            rateAccordingToCourseConfiguration: 'ពិន្ទុ តាម ការ កំណត់ រចនា សម្ព័ន្ធ',
            intelligentModelRating: 'ពិន្ទុ ម៉ូដែល ឆ្លាត',
            allData: 'ទិន្នន័យ ទាំងអស់',
            dataFromThisDepartment: 'ទិន្នន័យ នៃ ហត្ថលេខា',
            multidepartmentalData: 'ទិន្នន័យ ភាគ ច្រើន',
            underReview: 'ឡើង វិញ',
            no: 'គ្មាន ទេ',
            yes: 'បាន',
            automaticRating: 'ពិន្ទុ ស្វ័យ ប្រវត្តិ',
            auditRating: 'ពិន្ទុ ត្រួត ពិន្ទុ',
            reRating: 'ការ ពិន្ទុ ឡើង វិញ',
            inAppeal: 'នៅ ក្នុង សត្វ',
            reviewed: 'បាន ឡើង វិញ',
            notViewed: 'មិន បាន មើល ទេ',
            viewed: 'បាន មើលComment',
            uncorrected: 'មិន បាន កែ ឡើយ',
            corrected: 'បាន ត្រូវ',
            practice: 'ដំណើរការ',
            examination: 'ការ ព្រួញ',
            other: 'ផ្សេងទៀត',
            notMeetingStandards: 'មិន មែន ជា ស្តង់ដារ',
            meetingStandards: 'ស្តង់ដារ',
            excellent: 'ល្អ ប្រសើរ',
            invalid: 'បរាជ័យ',
            notStarted: 'មិន បាន ចាប់ផ្ដើម',
            haveInHand: 'កំពុង វឌ្ឍន៍',
            ended: 'បាន បញ្ចប់',
            completed: 'បាន បញ្ចប់',
            hangInTheAir: 'មិន បាន បញ្ចប់',
            passed: 'បាន ជម្រះ',
            voiceConversation: 'ប្រអប់ សំឡេង',
            textDialogue: 'ប្រអប់ អត្ថបទ',
            slidePresentation: 'ការ បង្ហាញ ស្លាយ',
            unpublished: 'មិន បាន បោះពុម្ព',
            published: 'បាន បោះពុម្ព',
            narration: 'កម្មវិធី និពន្ធComment',
            studentSpeaking: 'ការ និយាយ កាត់',
            robotTalk: 'រ៉ូបេស និយាយ ។',
            knowledgeBaseQA: 'ស្គាល់ Q & A',
            slide: 'ស្លាយ',
            negativeEmotions: 'សកម្មភាព អុហ្វសិត',
            emotionallyNormal: 'ធម្មតា',
            incompleteScript: 'និយាយ មិន បញ្ចប់',
            completeScript: 'និយាយ ពេញលេញ',
            normalSpeechSpeed: 'បាន បញ្ចប់',
            speakTooFast: 'និយាយ លឿន ពេញ',
            speakTooSlowly: 'និយាយ យឺត ពេកComment',
            whole: 'ទាំង អស់',
            singlePage: 'ទំព័រ មួយ',
            qA: 'សំណួរ មួយ និង ចម្លើយ មួយ',
            situationalDialogue: 'ប្រអប់ ទំនាក់ទំនង',
            misses: 'បាត់Comment',
            hit: 'បិទ',
            sequentialQA: 'Q & A',
            randomQA: 'សំណួរ ចៃដន្យ',
            mastered: 'ការ ចាប់ផ្តើម',
            notMastered: 'មិន បាន មេ ទេ',
        },
        algorithm: {
            salesEmpowerment: 'ការ សន្យារ',
            enterpriseWeChatVoice: 'សំឡេង WeChat Enterprise',
            enterpriseWeChatText: 'អត្ថបទ ជម្រើស',
            waiting: 'រង់ចាំ',
            extracting: 'កំពុង ស្រង់ចេញ',
            success: 'ជោគជ័យ',
            fail: 'បាន បរាជ័យ',
            intelligentQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
            textDialogue: 'ប្រអប់ អត្ថបទ',
            voiceCall: 'ហៅ សំឡេង',
            smartTags: 'ស្លាក ឆ្លាត',
            satisfactionEvaluation: 'ការ វាយតម្លៃ សម្អាត',
            score: 'ការ វាយតម្លៃ',
            grade: 'ការ វាយតម្លៃ',
            customerServiceTeam: 'ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
            conversationAnalysis: 'ការ វិភាគ សកម្ម',
        },
        operatorListGather: {
            falseClosing: 'បិទ មិន ត្រឹមត្រូវ',
            largeModelSemanticMatching: 'ការ ផ្គូផ្គង ម៉ូដែល ធំ',
            system: 'ប្រព័ន្ធ',
            customerInformation: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
            audio: 'អូឌីយ៉ូ',
            videoSound: 'សំឡេង វីដេអូ',
            videoScreen: 'អេក្រង់ វីដេអូ',
            videoFile: 'ឯកសារ វីដេអូ',
            voiceMessage: 'សារ សំឡេង',
            picture: 'រូបភាព',
            documentation: 'ឯកសារ',
            workOrderInformation: 'ព័ត៌មាន លំដាប់ ការងារ',
            semanticMatching: 'ការ ផ្គូផ្គង semantic',
            specifiedTime: 'ពេលវេលា ដែល បាន បញ្ជាក់@ info: whatsthis',
            externalInterfaceDetection: 'ការ រក ឃើញ ចំណុច ប្រទាក់ ខាងក្រៅ',
            robot: 'Robot',
            intelligentModel: 'ម៉ូឌុល ខ្លាំង',
            businessSummary: 'សង្ខេប ពាក្យ',
            firstSentence: 'ពាក្យ ដំបូង',
            lastSentence: 'ពាក្យ ចុងក្រោយ',
            allTime: 'ពេលវេលា ទាំងអស់',
            nonBusinessWorkingHours: 'ម៉ោង មិនមែន ជា ដំណើរការ',
            businessWorkingHours: 'ម៉ោង ការងារ រហ័ស',
        },
        callDialogueManage: {
            flyingBookGroupChat: 'ជជែក ក្រុម សៀវភៅ',
            videoCall: 'ហៅ វីដេអូ',
            questionnaire: 'កម្រិត សំណួរ',
            originalSoundManagement: 'គ្រប់គ្រង សំឡេង ដើម',
            eCommerceReview: 'E- Comment',
            socialMediaComments: 'សេចក្តី អធិប្បាយ មេឌៀ',
        },
        user: {
            voiceRobotOutcall: 'រុករក ក្រៅ រ៉ូប៊ី សំឡេង',
            workOrder: 'លំដាប់ ការងារ',
        },
        dataPreprocess: {
            ecommerceSessionQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព សម័យ E-commerce',
        },
        connectedByConversation: {
            workOrder: 'លំដាប់ ការងារ',
        },
    },
    pages: {
        auth: {
            welcome: '',
            copyRight: '',
            login: {
                name: 'ចូលComment',
                email: 'អ៊ីមែល',
                password: 'ពាក្យ សម្ងាត់',
                forgetPwd: 'បំពេញ ពាក្យ សម្ងាត់',
                emailCannotBeEmpty: 'ប្រអប់ សំបុត្រ មិន ត្រូវ តែ ទទេ ។',
                passwordCannotByEmpty: 'ពាក្យ សម្ងាត់ មិន ត្រូវ តែ ទទេ ។',
                mustChangeLogin: 'សូម ទោស ពាក្យ សម្ងាត់ របស់ អ្នក ត្រូវ តែ កំណត់ ឡើង វិញ សូម ទាក់ទង អ្នក គ្រប់គ្រង របស់ អ្នក ដើម្បី កំណត់ ពាក្យ សម្ងាត់ របស់ អ្នក ឡើង វិញ ។',
                dismissionLogin: 'សូម ទោស អ្នក បាន ទុក ការងារ របស់ អ្នក ។',
                forbiddenLogin: 'សូម ទោស គណនី របស់ អ្នក ត្រូវ បាន បិទ ។',
                loginError: 'បាន បរាជ័យ ក្នុង ការ ចូល ប្រអប់ សំបុត្រ ឬ ពាក្យ សម្ងាត់ មិន ត្រឹមត្រូវ ។',
                loginPrompt: 'ចូល ទៅ ប្រព័ន្ធ',
                rememberMe: 'ចងចាំ ខ្ញុំ@ info: whatsthis',
            },
            logout: {
                logoutError: 'បរាជ័យ ក្នុង ការ ចូល ។ ពិនិត្យ មើល ការ តភ្ជាប់ បណ្ដាញ របស់ អ្នក ឬ ព្យាយាម ម្ដង ទៀត ។',
            },
            resetPassword: {
                forgetPwd: 'បំពេញ ពាក្យ សម្ងាត់',
                inputEmailPrompt: 'បញ្ចូល អ៊ីមែល គណនី របស់ អ្នក ខាងក្រោម ហើយ យើង នឹង ផ្ញើ អ្នក អ៊ីមែល និង ណែនាំ ដើម្បី កំណត់ ពាក្យ សម្ងាត់ របស់ អ្នក ឡើង វិញ ។',
                sendEmailSuccess: 'អក្សរ អះអាង ការ កែប្រែ ពាក្យ សម្ងាត់ ត្រូវ បាន ផ្ញើ ដោយ ជោគជ័យ ទៅកាន់ អ៊ីមែល ដែល អ្នក បាន បំពេញ សូម ពិនិត្យ វា ក្នុង ពេលវេលា ។',
                sendEmailFailed: 'ប្រអប់ សំបុត្រ បាន បរាជ័យ ក្នុងការ ផ្ញើ ។ ពិនិត្យ មើល ការ តភ្ជាប់ បណ្ដាញ របស់ អ្នក ឬ ព្យាយាម ម្ដង ទៀត ។',
                setNewPassword: 'កំណត់ ពាក្យ សម្ងាត់ ថ្មី របស់ អ្នក',
                passwordCannotEmpty: 'ពាក្យ សម្ងាត់ មិន ត្រូវ តែ ទទេ',
                passwordFormWrong: 'ទ្រង់ទ្រាយ ពាក្យ សម្ងាត់ មិន ត្រឹមត្រូវ',
                confirmPasswordWrong: 'ពាក្យ សម្ងាត់ ពីរ ដែល បាន បញ្ចូល មិន ស្មើ ទេ ។',
                passwordResetSuccess: 'បាន កំណត់ ពាក្យ សម្ងាត់ ឡើងវិញ ។',
                passwordResetFailed: 'ការ កំណត់ ពាក្យ សម្ងាត់ ឡើងវិញ បាន បរាជ័យ ។ ពិនិត្យ មើល ការ តភ្ជាប់ បណ្ដាញ របស់ អ្នក ឬ ព្យាយាម ម្ដង ទៀត ។',
                linkTimeover: 'កំណត់ តំណ ពាក្យ សម្ងាត់ ឡើង វិញ',
            },
            form: {
                title: 'ការ បង្ហាញ ទ្រង់ទ្រាយ CASE',
            },
        },
        public: {
            auth: {
                forgotPassword: {
                    email: 'អ៊ីមែល',
                    emailFormatError: 'កំហុស ទ្រង់ទ្រាយ ប្រអប់ សំបុត្រ សូម បញ្ចូល ឡើងវិញ !',
                    forgotPassword: 'បំពេញ ពាក្យ សម្ងាត់ របស់ អ្នក ?',
                    describe: 'បញ្ចូល អ៊ីមែល គណនី របស់ អ្នក ខាងក្រោម ហើយ យើង នឹង ផ្ញើ អ្នក អ៊ីមែល និង ណែនាំ ដើម្បី កំណត់ ពាក្យ សម្ងាត់ របស់ អ្នក ឡើង វិញ ។',
                    send: 'ផ្ញើ',
                    emailCannotBeEmpty: 'ប្រអប់ សំបុត្រ មិន អាច ទទេ',
                    resetPasswordExpire: 'កំណត់ តំណ ពាក្យ សម្ងាត់ ឡើង វិញ',
                },
                resetPassword: {
                    setPassword: 'កំណត់ ពាក្យ សម្ងាត់ ថ្មី របស់ អ្នក',
                    newPassword: 'ពាក្យ សម្ងាត់ ថ្មី',
                    repeatPassword: 'ពាក្យ សម្ងាត់',
                    resetPassword: 'កំណត់ ពាក្យ សម្ងាត់ ឡើង វិញ',
                    passwordCannotBeEmpty: 'ពាក្យ សម្ងាត់ ថ្មី មិន អាច ទទេ ។',
                    confirmPasswordCannotBeEmpty: 'ពាក្យ សម្ងាត់ ស្ទួន មិន អាច ទទេ ។',
                    passwordsNotMatch: 'ពាក្យ សម្ងាត់ ពីរ មិន ត្រឹមត្រូវ !',
                    passwordFormWrong: 'ពាក្យ សម្ងាត់ មិន អាច មាន ក្នុង ចិន ហើយ ចំនួន គឺ 6-14 !',
                    linkExpiration: 'កំណត់ តំណ ពាក្យ សម្ងាត់ ឡើង វិញ',
                },
            },
            errors: {
                haveNoPermissionWarningText: 'អ្នក មិនមាន សិទ្ធិ ដើម្បី មើល ទំព័រ នេះ',
            },
        },
        downloadCenter: {
            name: 'ទាញយក មជ្ឈមណ្ឌល',
            saveTime: '(៣០ ថ្ងៃ តាម លំនាំដើម)',
            headerTitle: 'ទាញយក ឯកសារ',
            download: 'ទាញយក',
            downloadPromp: 'ភារកិច្ច ទាញ យក ត្រូវ បាន ដាក់ ស្នើ សូម ទៅ លើ',
            viewProgress: 'មើល វឌ្ឍន៍',
        },
        uploadCenter: {
            name: 'ផ្ទុក កណ្ដាល',
        },
        tasks: {
            index: {
                name: 'ឈ្មោះ:',
                remark: 'សេចក្ដី ពិពណ៌នា',
                qualityCheckTasksTitle: 'ពង្រីក',
                informationCollection: 'ភារកិច្ច សម្រាំង',
                qualityCheckTasks: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                wechatQaTasks: 'ភារកិច្ច វិភាគរក',
                moduleName: 'ប្រើ ពុម្ព ថ្មី',
                creatNewQualityCheckTask: 'ភារកិច្ច ថ្មី',
                generalInspectionList: 'របាយការណ៍ ត្រួតពិនិត្យ គុណភាព ទូទៅ',
                editQualityCheckTask: 'កែសម្រួល ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                creatNewQualityCheckTaskError: 'បាន បរាជ័យ ក្នុង ការ បង្កើត ភារកិច្ច ត្រួតពិនិត្យ គុណភាព ថ្មី ។',
                editQualityCheckTaskError: 'បរាជ័យ ក្នុង ការ កែសម្រួល ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព ។',
                type: 'ប្រភេទ ប្រព័ន្ធ',
                singleScore: 'ពិន្ទុ មួយ',
                singleScoreNullError: 'ពិន្ទុ តែ មិន អាច ទទេ',
                inspector: 'កម្មវិធី ត្រួតពិនិត្យ គុណភាព',
                inspectDataSource: 'ប្រភព ទិន្នន័យ',
                taskName: 'ឈ្មោះ ភារកិច្ច',
                inspectionType: 'ប្រភេទ ត្រួត ពិនិត្យ គុណភាព',
            },
            manage: {
                screeningCondition: 'លក្ខខណ្ឌ តម្រង',
                template: {
                    condition: {
                        index: {
                            name: 'លទ្ធផល',
                            existingConditions: 'លក្ខខណ្ឌ មាន ស្រាប់',
                        },
                        detail: {
                            id: 'ID',
                            name: 'ឈ្មោះ លទ្ធផល',
                            remark: 'សេចក្ដី ពិពណ៌នា',
                            checkRange: 'ជួរ រកឃើញ@ info: whatsthis',
                            operator: 'កម្មវិធី',
                            operatorLogic: 'តក្កវិជ្ជា',
                        },
                    },
                    checkPointTest: {
                        title: 'ការ សាកល្បង បន្ទាត់',
                        running: 'ច្បាប់ ក្នុង សាកល្បង សូម ក្រោយ ....',
                        clearSuccess: 'ប្រអប់ ដែល បាន ក្លែង ធ្វើ បាន ទទេ ដោយ ជោគជ័យ',
                        mock: 'ប្រអប់ ដែល បាន ក្លែង លេង',
                        save: 'រក្សាទុក ប្រអប់ ដែល បាន ជ្រើស',
                        saveAll: 'រក្សាទុក ការ សម្រាក ទាំងអស់',
                        saveSuccess: 'បាន រក្សាទុក ការ សម្រាក ដោយ ជោគជ័យ',
                        close: 'ចេញ',
                        delete: 'លុប ដែល បាន ជ្រើស',
                        clear: 'ទទេ',
                        customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                        agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                        test: 'សាកល្បង',
                        request: 'បន្ទាប់ ពី ជម្រះ ប្រអប់ ក្លែង ធ្វើ វា មិន អាច ត្រូវ បាន ទទួល បាន ទេ ។ អះអាង ដើម្បី ជម្រះ វា ឬ ?',
                        deletePopconfirmContent: 'តើ អ្នក ពិត ជា ចង់ លុប ប្រអប់ ដែល បាន ជ្រើស ឬ ?',
                    },
                    checkPoint: {
                        index: {
                            name: 'ការ កំណត់ រចនាសម្ព័ន្ធ បន្ទាត់',
                            wechatTitle: 'ការ កំណត់ រចនា សម្ព័ន្ធ ម៉ូឌុល',
                            existingCheckPoints: 'ច្បាប់ ត្រួតពិនិត្យ គុណភាព ដែល មាន ស្រាប់',
                            currentCheckPointScore: 'ពិន្ទុ ច្បាប់ ត្រួត ពិនិត្យ គុណភាព បច្ចុប្បន្ន បច្ចុប្បន្ន',
                            currentCheckPointScoreWechat: 'ពិន្ទុ ម៉ូដែល វិភាគ បច្ចុប្បន្ន',
                            currentCheckPointWeight: 'កម្រិត សរុប នៃ ច្បាប់ ត្រួត ពិនិត្យ គុណភាព បច្ចុប្បន្ន គឺ ជា មុន',
                            weightTotalScoreAndItemScore: 'ពិន្ទុ សរុប ៖ 100 ពិន្ទុ តែ មួយ ៖',
                            template: 'ពុម្ព បន្ទាត់ ត្រួត ពិនិត្យ គុណភាព',
                            import: 'នាំចូល ពុម្ព បន្ទាត់ ត្រួត ពិនិត្យ គុណភាព',
                            getTemplateError: 'បាន បរាជ័យ ក្នុង ការ យក ពុម្ព ច្បាប់ ត្រួត ពិនិត្យ គុណភាព ។',
                            tabs: {
                                template: 'ពុម្ព',
                                demo: 'គំរូ',
                            },
                            customize: 'ពុម្ព ទទេ',
                            move: 'អូស និង ទម្លាក់ ដើម្បី លៃតម្លៃ តម្លៃ និង តម្រង',
                            classification: 'ការ ត្រួត ពិនិត្យ គុណភាព',
                            classificationWeChat: 'ថ្នាក់ ម៉ូឌុល',
                            first: 'ការ កំណត់ កម្រិត ១',
                            second: 'ចល័ត រង',
                            new: 'ច្បាប់ ត្រួតពិនិត្យ គុណភាព ថ្មី',
                            weChatNew: 'បន្ថែម ម៉ូដែល វិភាគ រយ',
                            createWeChat: 'ម៉ូដែល វិភាគ ថ្មី',
                            empty: 'គ្មាន ច្បាប់ ត្រួត ពិនិត្យ គុណភាព សម្រាប់ ពេលវេលា ឡើយ ។',
                            wechatEmpty: 'គ្មាន ម៉ូដែល វិភាគ ឡើយ',
                            newSecond: 'ថ្នាក់ ថ្មី',
                            newFirst: 'ការ កំណត់ កម្រិត ទីមួយ ថ្មី',
                            checkPoint: 'ច្បាប់ ត្រួត ពិនិត្យ គុណភាព',
                            checkPointWeChat: 'ម៉ូដែល វិភាគ រក',
                        },
                        detail: {
                            name: 'ឈ្មោះ:',
                            remark: 'សេចក្ដី ពិពណ៌នា',
                            type: 'ប្រភេទ@ info: whatsthis',
                            deduction: 'ដក',
                            rule: 'បន្ទាត់',
                            highlighted: 'បន្លិច',
                            gradeType: 'វិធីសាស្ត្រ ពិន្ទុ',
                            interactiveCategory: 'ចំណុច ប្រទាក់ អំពើ',
                            predeterminedScore: 'ពិន្ទុ',
                            weight: 'កម្ពស់',
                            na: 'N/A',
                            default: 'ពិន្ទុ លំនាំដើម',
                            preRule: 'ច្បាប់ ភាព ជាមុន',
                            analysisHighlighted: 'កំពុង ញែក ច្បាប់Comment',
                            categorySelectPrompt: 'សូម ជ្រើស ប្រភេទ មួយ',
                            checkHighlightArrayError: 'ច្បាប់ មិន ផ្គូផ្គង នឹង បន្លិច សូម ចុច ប៊ូតុង ច្បាប់ ញែក ម្ដង ទៀត ។',
                            foctorsHolder: 'សូម ជ្រើស ធាតុ មួយ',
                            foctorsErrorNone: 'ច្បាប់ ធាតុ ច្រើន គឺ ទទេ សូម បន្ថែម ប្រភេទ ធាតុ ច្រើន ។',
                            naError: 'មិន អាច បិទ ធាតុ នៅពេល ពិន្ទុ លំនាំដើម គឺ N/A',
                            templateNew: {
                                theLargeModelRulesHaveBeenIntegratedIntoTheIntelligentRulesAndTheSubsequentIterationWillNotBeContinuedForBetterExperienceItIsRecommendedToSwitchToTheIntelligentRules: 'ក្ដារ ម៉ូដែល ធំ ត្រូវ បាន បញ្ចូល ទៅ ក្នុង ក្បួន មធ្យោបាយ និង ការ ដោះស្រាយ បន្ទាប់ នឹង មិន ត្រូវ បាន បន្ត ទេ ។ [ រូបភាព នៅ ទំព័រ ៣១]',
                                agent: 'ភាគ',
                                convertToLargeModelRules: 'បម្លែង ទៅ ច្បាប់ ម៉ូឌុល ធំ',
                                bigModelRules: 'ច្បាប់ ម៉ូឌុល ធំ',
                                language: 'ភាសាComment',
                                nAIsTheNotApplicableWhichSetsPreconditionsForTheQualityInspectionRuleIfTheConditionIsMetTheRuleIsNotApplicableIfTheConditionIsNotMetTheRuleIsNotDetectedDescriptionOfPreconditionsMeansandMeansorIndicatesNOTFillInTheExampleRR2R3: 'N/A គឺ មិន អាច អនុវត្ត បាន ទេ ដែល កំណត់ ភាព ត្រឹមត្រូវ សម្រាប់ ច្បាប់ ត្រួត ពិនិត្យ គុណភាព ។ ប្រសិនបើ លក្ខខណ្ឌ បាន ធ្វើ ឲ្យ ច្បាប់ មិន អាច អនុវត្ត បាន ។ ប្រសិន បើ មិន បាន ធ្វើ លក្ខខណ្ឌ មិន ត្រូវ បាន រក ឃើញ ច្បាប់ ឡើយ ។\nសេចក្ដី ពិពណ៌នា កម្រិត មុន ៖ "&&" មាន ន័យ ថា " និង "| |" មាន ន័យ " ឬ", "! បង្ហាញ "NOT", បំពេញ ឧទាហរណ៍ "(R1 | | R2) & R3"',
                                applicationMessageType: 'ប្រភេទ សារ កម្មវិធី',
                                selectAll: 'ជ្រើស ទាំងអស់',
                                highlightTags: 'ស្លាក បន្លិច ៖',
                                ruleType: 'ប្រភេទ បន្ទាត់',
                                dataSource: 'ប្រភព ទិន្នន័យ',
                                whole: 'ទាំង អស់',
                                enterpriseMicroConversation: 'សម័យ micro-section Enterprise',
                                enterpriseAndMicroCommunication: 'សៀវភៅ មីក្រូ',
                            },
                            components: {
                                flow: {
                                    flow: {
                                        determineNodes: 'ថ្នាក់ បញ្ឈរ',
                                        dialogueNode: 'ថ្នាក់ ប្រអប់Name',
                                        editNodes: 'កែសម្រួល ថ្នាំង',
                                    },
                                    nodeConfig: {
                                        smartRules: 'ច្បាប់ ឆ្លាត',
                                        bigModelRules: 'ច្បាប់ ម៉ូឌុល ធំ',
                                        nodeName: 'ឈ្មោះ ថ្នាំងComment',
                                        nodeRules: 'ច្បាប់ ថ្នាក់',
                                        scoringLogic: 'ពិន្ទុ',
                                        score: 'ពិន្ទុ ៖',
                                        rule: 'បន្ទាត់',
                                        multiBranchLogic: 'តក្ក ច្រើន',
                                        highlight: 'បន្លិច',
                                        submit: 'ដាក់ ស្នើ',
                                    },
                                    ruleList: {
                                        manualConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ ដោយដៃ',
                                        dragAndDropConfiguration: 'អូស និង ទម្លាក់ ការ កំណត់ រចនា សម្ព័ន្ធ',
                                        branch: 'គ្រប់',
                                        branchName: 'ឈ្មោះ គ្រោង ៖',
                                        addRules: 'បន្ថែម បន្ទាត់',
                                    },
                                    sidebar: {
                                        node: 'ថ្នាំង',
                                    },
                                    hooks: {
                                        useControlButtons: {
                                            automaticOrganization: 'បញ្ចប់ ដោយ ស្វ័យ ប្រវត្តិ',
                                            canvasAdaptation: 'ផ្ទៃ ខ្លួន រចនាសម្ព័ន្ធ',
                                            copy: 'ចម្លង',
                                            delete: 'លុប',
                                        },
                                        useFlow: {
                                            determineThatTheChildNodesOfANodeCannotBeUsedAsConnectionTargets: 'ថ្នាក់ កូន របស់ ថ្នាំង ចង្អុល មិន អាច ត្រូវ បាន ប្រើ ជា គោលដៅ តភ្ជាប់ ។',
                                            theStartingNodeCannotBeUsedAsAConnectionTarget: 'ថ្នាក់ ចាប់ផ្ដើម មិន អាច ជា គោលដៅ តភ្ជាប់ បាន ឡើយ',
                                            startingNodeCannotConnectMultipleNodes: 'ថ្នាក់ ចាប់ផ្ដើម មិន អាច តភ្ជាប់ ថ្នាំង ច្រើន',
                                            nodeCannotBeConnectedToItself: 'ថ្នាំង មិន អាច តភ្ជាប់ ទៅកាន់ ខ្លួន វា បាន ទេ',
                                            startNode: 'ចាប់ផ្ដើម ថ្នាំង',
                                        },
                                    },
                                },
                                msgTypesSelect: {
                                    index: {
                                        cancelSelectAll: 'បោះបង់ ជ្រើស ទាំងអស់',
                                        selectAll: 'ជ្រើស ទាំងអស់',
                                    },
                                },
                                customModelsSelect: {
                                    index: {
                                        whetherItMeetsTheRequirements: 'ការ តភ្ជាប់Name',
                                        gradedEvaluation: 'ការ វាយតម្លៃ ថ្នាយ',
                                    },
                                },
                            },
                        },
                        configuration: {
                            title: 'ច្បាប់ ត្រួត ពិនិត្យ គុណភាព',
                            wechatTitle: 'ម៉ូដែល វិភាគ រក',
                            neme: 'ឈ្មោះ:',
                            errorMessage: 'បាន បរាជ័យ ក្នុងការ លុប ដោយ យ៉ាង ហោច ណាស់ លក្ខខណ្ឌ មួយ',
                            desc: 'សេចក្ដី ពិពណ៌នា',
                            status: 'ស្ថានភាព',
                            yes: 'មាន ប្រសិទ្ធភាព',
                            no: 'មិន ត្រឹមត្រូវ',
                            namePlaceHolder: 'សូម បញ្ចូល ឈ្មោះ ស្លាក',
                            desPlaceHolder: 'សូម បញ្ចូល សេចក្ដី ពិពណ៌នា',
                            nameEmpty: 'ឈ្មោះ មិន អាច ទទេ',
                            desEmpty: 'សេចក្ដី ពិពណ៌នា មិន អាច ទទេ',
                            type: 'ប្រភេទ@ info: whatsthis',
                            ruler: 'ច្បាប់ ឆ្លាត',
                            machineLearning: 'របៀប សិក្សា ផ្ទាល់ខ្លួន',
                            autoScore: 'ពិន្ទុ ឆ្លាត (ចាស់)',
                            manualScore: 'ពិន្ទុ ដៃ',
                            interaction: 'រក ឃើញ អន្តរ សកម្មភាព (ចាស់)',
                            typeTips: {
                                model: 'ម៉ូដែល ត្រួត ពិនិត្យ ៖ ដែល អាច ពិនិត្យ មើល បញ្ហា ដែល មាន នៅ ក្នុង សេវា ដោយ គ្មាន ការ កំណត់ រចនា សម្ព័ន្ធ និង ថែទាំ ។ ម៉ូឌុល នេះ ជា ទូទៅ ច្រើន ជាង ប្រសិនបើ អ្នក មិន ធ្វើ ឲ្យ ការ ទាមទារ កម្មវិធី',
                                rule: 'ក្បួន ត្រួត ពិន្ទុ ស្វ័យ ប្រវត្តិ ដែល មាន មូលដ្ឋាន លើ ច្បាប់ AI',
                                manual: 'ការ ពិនិត្យ ដោយ ដៃ ៖ ការ ពិនិត្យ មើល ដៃ ដៃ ដោយ ដៃ',
                            },
                            model: 'ម៉ូដែល ៖',
                            ruleType: {
                                words: 'ពាក្យ',
                                interaction: 'អន្តរសកម្ម',
                                feature: 'លក្ខណៈ ពិសេស',
                                information: 'ព័ត៌មាន',
                            },
                            testingMode: {
                                all: 'រកឃើញ ពាក្យ គន្លឹះ ទាំងអស់ ។',
                                any: 'រកឃើញ ពាក្យ គន្លឹះ',
                            },
                            operatorTypesOfInteraction: {
                                question: 'សំណួរ មួយ និង ចម្លើយ មួយ',
                                element: 'ចម្លើយ ធាតុComment',
                                repet: 'ការ ស្ទួន បរិបទ',
                                snatch: 'កម្រិត ពាក្យ',
                                silent: 'ស្គាល់',
                            },
                            role: 'តំណ រកឃើញ ៖',
                            preposition: 'កម្មវិធី អនុវត្ត មុន ៖',
                            range: 'ជួរ រកឃើញ ៖',
                            from: 'ភាគComment',
                            to: 'ប្រយោជន៍ ទៅ លេខ.',
                            end: 'ប្រយោជន៍',
                            hasOldSilentTip: 'Hello ដើម្បី ធ្វើ ឲ្យ ភាព ត្រឹមត្រូវ បង្កើន "តួអក្សរ អក្សរ ត្រឹមត្រូវ" ត្រូវ បាន ធ្វើ ឲ្យ ប្រសើរ ឡើង វិញ វា ត្រូវ បាន ផ្ដល់ អនុសាសន៍ ដើម្បី ធ្វើ ឲ្យ ច្បាប់ ការប្រើ ទាន់សម័យ !',
                            changeToOld: 'ប្ដូរ ទៅ កាន់ សិទ្ធិ',
                            changeToNew: 'ប្ដូរ ទៅ កំណែ ថ្មី',
                            logic: {
                                logic: 'ពិន្ទុ',
                                naTip: 'N/A គឺ មិន អាច អនុវត្ត បាន ទេ ដែល កំណត់ ភាព ត្រឹមត្រូវ សម្រាប់ ច្បាប់ ត្រួត ពិនិត្យ គុណភាព ។ ប្រសិន បើ លក្ខខណ្ឌ ត្រូវ បាន ធ្វើ ឲ្យ ច្បាប់ មិន អាច អនុវត្ត បាន ។ ប្រសិន បើ មិន បាន ធ្វើ លក្ខខណ្ឌ មិន ត្រូវ បាន រក ឃើញ ច្បាប់ ឡើយ ។',
                                score: 'ពិន្ទុ ៖',
                                na: 'N/A：',
                                naDes: 'ធាតុ នេះ មិន រួម បញ្ចូល ក្នុង ការ រក ឃើញ អនុញ្ញាត',
                                preRule: 'ច្បាប់ ជាមុន រូបរាង ៖',
                                notCatchPreRule: 'នៅពេល ដែល មិន ត្រឹមត្រូវ ៖',
                                naChecked: 'នៅ លើ N/A ៖',
                                preRuleEmpty: 'ច្បាប់ មុខ',
                                operatorEmpty: 'លក្ខខណ្ឌ ចាំបាច់ មិន អាច ទទេ នៅ ក្នុង សកម្មភាព ទេ',
                                multipleEmpty: 'លក្ខខណ្ឌ ចាំបាច់ មិន អាច ទទេ នៅ ក្នុង ពិន្ទុ ឡូក ច្រើន',
                                average: 'ពិន្ទុ មធ្យម',
                                addOrSubtract: 'ចំណុច ផ្ទាល់ និង ចំណុច',
                                noChange: 'គ្មាន ចំណុច បន្ថែម',
                                rule: 'ច្បាប់ ៖',
                                all: 'ធ្វើ ឲ្យ សកម្មភាព ទាំង អស់',
                                any: 'ធ្វើ ឲ្យ ប្រតិបត្តិការ រហ័ស',
                                customize: 'តក្កវិធី ផ្ទាល់ខ្លួន',
                                multiple: 'ពិន្ទុ តក្ក ច្រើន',
                                heightLight: 'បន្លិច ៖',
                                machineLearningTip: 'បច្ចុប្បន្ន របៀប សិក្សា ចំពោះ ការ និយាយ គ្រីស្ទាន សូម ប្រើ ច្បាប់ ដែល មាន ប្រយោជន៍ ។',
                                strategy: 'យុទ្ធសាស្ត្រ ៖',
                            },
                        },
                        component: {
                            approvalSubmittedSuccessfully: 'បាន ដាក់ស្នើ ដោយ ជោគជ័យ',
                        },
                        components: {
                            pageHeaderExtra: {
                                test: 'សាកល្បង',
                                formal: 'សមរម្យ',
                                submit: 'ដាក់ ស្នើ',
                            },
                            createModal: {
                                index: {
                                    pleaseEnterARuleDescription: 'សូម បញ្ចូល សេចក្ដី ពិពណ៌នា ច្បាប់ មួយ',
                                    ruleGeneratedSuccessfully: 'បាន បង្កើត ច្បាប់ ដោយ ជោគជ័យ',
                                    failedToGenerateRule: 'បាន បរាជ័យ ក្នុង ការ បង្កើត ច្បាប់ ៖',
                                    aIGeneration: 'បង្កើត AI',
                                    pleaseEnterTheRuleDescriptionTheContentIsGeneratedByAIForReferenceOnly: 'សូម បញ្ចូល សេចក្ដី ពិពណ៌នា ច្បាប់ ។ មាតិកា ត្រូវ បាន បង្កើត ដោយ AI សម្រាប់ តែ យោង ។',
                                    generateRules: 'បង្កើត បន្ទាត់',
                                    myRules: 'ច្បាប់ របស់ ខ្ញុំ',
                                },
                            },
                        },
                    },
                    automaticAdd: {
                        index: {
                            name: 'ដំណើរការ ដោយ ស្វ័យ ប្រវត្តិ',
                            screeningCondition: 'លក្ខខណ្ឌ តម្រង',
                            aiScreeningCondition: 'លក្ខខណ្ឌ តម្រង ឆ្លាត',
                            rule: 'បន្ទាត់',
                            automaticAddition: 'បន្ថែម ដោយ ស្វ័យ ប្រវត្តិ',
                            automaticAdditionTip: 'បន្ថែម ទិន្នន័យ ទៅ ភារកិច្ច ដោយ ស្វ័យ ប្រវត្តិ ក្នុង ពេលវេលា ពិត ឬ នៅ ចន្លោះពេល ធម្មតា សម្រាប់ ការ ត្រួតពិនិត្យ គុណភាព AI',
                            autoAdd: {
                                autoAddType: 'វិធីសាស្ត្រ បន្ថែម ស្វ័យ ប្រវត្តិ',
                                addFrequency: 'បន្ថែម ប្រេកង់',
                                add: 'បន្ថែម@ info: whatsthis',
                            },
                            automaticSamplingInspection: 'ត្រួតពិនិត្យ គំរូ ដោយ ស្វ័យ ប្រវត្តិ',
                            automaticSamplingInspectionTip: 'ចេញ ទិន្នន័យ ដោយ ស្វ័យ ប្រវត្តិ ដែល ទាមទារ ការ ត្រួតពិនិត្យ គុណភាព ដៃ ដៃ ឧទាហរណ៍ ។ ចេញ ពី 10% នៃ ទិន្នន័យ ចៃដន្យ',
                            everyAgentCheckLimit: 'គូរ អតិបរមា ក្នុង មួយ ភ្នាក់ងារ',
                            automaticAllocation: 'បម្រុង ទុក ដោយ ស្វ័យ ប្រវត្តិ',
                            automaticAllocationTip: 'ការ បិទ ការ ត្រួត ពិនិត្យ គំរូ ៖ ទិន្នន័យ ដែល បាន ស្រង់ បាន ត្រូវ បាន បម្លែង ដោយ ស្វ័យ ប្រវត្តិ ទៅ អ្នក ត្រួត ពិនិត្យ គុណភាព ។ ឧទាហរណ៍ 10% នៃ ទិន្នន័យ ចៃដន្យ និង អ្នក ត្រួត ពិនិត្យ គុណភាព ២ ត្រូវ បាន ចៃដន្យ ទៅ ភារកិច្ច នេះ មធ្យម ។',
                            automaticAllocationTip2: 'កា រកំណត់ មើល ៖ ទិន្នន័យ អាប់ភ្លេត ត្រូវ បាន បម្លែង ដោយ ស្វ័យ ប្រវត្តិ ទៅ កម្មវិធី ត្រួត ពិនិត្យ គុណភាព ឧទាហរណ៍ ។ ទិន្នន័យ អភិវឌ្ឍន៍ រាល់ ថ្ងៃ ត្រូវ បាន បម្រុង ទុក ដោយ ចៃដន្យ ទៅ កាន់ អ្នក ត្រួត ពិនិត្យ គុណភាព ២ នៃ ភារកិច្ច នេះ សម្រាប់ ការ ពិនិត្យ ។',
                            automaticPush: 'ចុច ស្វ័យ ប្រវត្តិ',
                            automaticPushTip: 'ការ ជូន ដំណឹង ៖ ការ ជូនដំណឹង/ ការជូនដំណឹង កំឡុង ពេល ត្រួត ពិនិត្យ គុណភាព ឧទាហរណ៍ នៅពេល កំហុស ធ្ងន់ធ្ងរ នៅ ក្នុង សេវា ម៉ាស៊ីន ភ្ញៀវ សារ ជូន ដំណឹង ត្រូវ បាន ផ្ញើ ទៅ កាន់ ក្រុម មធ្យម ។',
                            automaticPushTip2: 'របាយការណ៍ ដែល បាន កំណត់ ពេល ៖ ផ្ញើ លទ្ធផល ត្រួត ពិនិត្យ គុណភាព ឧទាហរណ៍ សំបុត្រ ។ ផ្ញើ លទ្ធផល ត្រួត ពិនិត្យ គុណភាព នៃ ការ គំរូ ដៃ របស់ ថ្ងៃ ម្ដង ទៅ កាន់ ប្រអប់ សំបុត្រ របស់ អ្នក គ្រប់គ្រង សេវា នៅ ថ្ងៃ 9: 00 រាល់ ថ្ងៃ ។',
                            automaticAssess: 'ការ ប្រាកដ ដោយ ស្វ័យ ប្រវត្តិ',
                            automaticAssessTip: 'លទ្ធផល គំរូ ដោយ ដៃ ត្រូវ បាន ប្រៀបធៀប ជាមួយ នឹង លទ្ធផល ត្រួត ពិនិត្យ គុណភាព AI សម្រាប់ ការ វាយតម្លៃ ត្រឹមត្រូវ ។ ឧទាហរណ៍ អត្រា ភាព ត្រឹមត្រូវ នៃ ទិន្នន័យ គំរូ របស់ ថ្ងៃ ម្ដង ទៀត ត្រូវ បាន វាយ តម្លៃ នៅ ៨ ថ្ងៃ រាល់ ថ្ងៃ ។',
                            reexaminationComplaint: 'ការ ពិនិត្យ មើល គំរូ',
                            spoktReviewDetail: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                            spoktReviewDetailTip: 'កំណត់ រចនា សម្ព័ន្ធ មុខងារ ដូចជា បញ្ជី ត្រួត ពិនិត្យ គុណភាព, បញ្ជី ការ ត្រួត ពិនិត្យ ចៃដន្យ',
                            qaDetailAction: 'ការ កំណត់ រចនា សម្ព័ន្ធ ត្រួតពិនិត្យ គុណភាព',
                            spoktDetailAction: 'ការ កំណត់ រចនា សម្ព័ន្ធ គំរូ',
                            reviewDetailAction: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                            appealAction: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                            remarkTemplate: 'ពុម្ព ចំណាំ',
                            automaticArchiving: 'ការ ប័ណ្ណសារ ដោយ ស្វ័យ ប្រវត្តិ',
                            conditionalRules: 'ច្បាប់ លក្ខខណ្ឌ',
                            qualityInspectionConditions: 'លក្ខខណ្ឌ ត្រួត ពិនិត្យ គុណភាព',
                            unopened: 'មិន បើក ឡើយ ទេ ។',
                            sampleInspectionDistributionModel: 'ការ បម្លែង គំរូ',
                            reviewAllocationModel: 'កា រចនា សម្ព័ន្ធ',
                            distributionModelTitle: 'គោលការណ៍ បិទ ៖',
                            pushRules: 'ចុច បន្ទាត់',
                            push: 'ចុច កណ្ដុរ',
                            assessRules: 'ច្បាប់ តម្លៃ',
                            on: 'on',
                            off: 'off',
                            updateStatusSuccess: 'ការ ផ្លាស់ប្ដូរ ស្ថានភាព បាន ជោគជ័យ !',
                            updateStatusFailed: 'បាន បរាជ័យ ក្នុង ការ ផ្លាស់ប្ដូរ ស្ថានភាព សូម ព្យាយាម ម្ដង ទៀត ។',
                            sampleNumberOrPercent: 'លេខ គំរូ ឬ សមាមាត្រ',
                            inspectorList: 'អ្នក ត្រួតពិនិត្យ គុណភាព ដែល បាន ជ្រើស',
                            numberOfSubmission: 'ចំនួន រូបតំណាង ដែល អនុញ្ញាត ឲ្យ ដាក់ស្នើ',
                            rewivewDays: 'ថ្ងៃStencils',
                            TimeOfSubmission: 'ភាព ត្រឹមត្រូវ នៃ ការ ដាក់ស្នើ នៃ រូបតំណាងName',
                            rewivewSecond: 'ពេលវេលាName',
                            switchOn: 'បើក',
                            switchOff: 'បិទ',
                            notMatchAnyRule: 'នៅពេល ដែល គ្មាន ច្បាប់ ត្រូវ ផ្គូផ្គង ៖',
                            appealOptionsList: {
                                hiddenInspector: 'ព័ត៌មាន បញ្ជា',
                                hiddenHit: 'ទំព័រ អាប់ភ្លេត គាំទ្រ ការ បន្លិច និង ទីតាំង ។',
                            },
                            caseLibrary: 'ការ ធ្វើ សមកាលកម្ម បណ្ណាល័យ រូបភាព',
                            caseLibrarySyncTip: 'ធ្វើ សមកាលកម្ម ករណី ដែល បាន បន្ថែម ដោយ ប្រព័ន្ធ QA ទៅ ប្រព័ន្ធ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                            addCase: 'បង្កើន ការ ធ្វើ សមកាលកម្ម',
                            caseLibraryId: 'បណ្ណាល័យ អក្សរ',
                            caseLibraryIdTip: 'ក្រុម មូលដ្ឋាន ប្រព័ន្ធ QA',
                            udeskCaseLibraryIdTip: 'ការ ដាក់ ក្រុម ប្រព័ន្ធ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                            syncHis: 'ករណី ប្រវត្តិ សមកាលកម្មName',
                            otherSettings: 'ការ កំណត់ ផ្សេងទៀត',
                            udeskCaseLibraryId: 'ចុច ក្រុម',
                            url: 'ចុច URL',
                            urlTip: 'សូម បញ្ចូល អាសយដ្ឋាន ចំណុច ប្រទាក់ ដែល ចាប់ផ្ដើម ដោយ http:// ឬ http:// s',
                        },
                        templateNew: {
                            resultsView: 'មើល ថ្នាក់',
                            afterTheStartOfTheSupportConfigurationResultsAreAvailableAndTheTimingCanBeViewedInRealTimeOrAccordingToTheRegularRules: 'បន្ទាប់ ពី បើក អ្នក អាច កំណត់ រចនា សម្ព័ន្ធ ពេលវេលា នៃ ការ ប្រកាស ប្រតិបត្តិការ និង ការ មើល ដែល អាច ត្រូវ បាន មើល ក្នុង ពេលវេលា ពិត ឬ ដោយ ច្បាប់ ពេលវេលា ។',
                            topicAnalysis: 'ការ វិភាគ បណ្ដាញ',
                            identifyTheTopicInTheConversationAndCustomizeTheTopicDimensionAccordingToTheBusinessSituation: 'បញ្ជាក់ ប្រធាន បទ ក្នុង ការ និយាយ និង វិធីសាស្ត្រ ផ្ទាល់ ខ្លួន តាម បំណង',
                            detailDisplayConfiguration: 'ការ កំណត់ រចនាសម្ព័ន្ធ ការ បង្ហាញ លម្អិត ៖',
                            silenceOver: 'ស្គាល់',
                            displayAtSeconds: 'បង្ហាញ នៅ វិនាទី',
                            secondaryReview: 'មើល រង',
                            numberOfAppealsAllowedToBeSubmitted: 'ចំនួន អនុញ្ញាត ឲ្យ ដាក់ ស្នើ',
                            validityOfSubmissionOfAppeal: 'ភាព ត្រឹមត្រូវ នៃ ការ ដាក់ស្នើ របស់ អាជ្ញាប់',
                            validityOfAppealReview: 'ភាព ត្រឹមត្រូវ នៃ ការ ត្រួត ពិនិត្យ អាប់ភ្លេត',
                            hours: 'ម៉ោង',
                            businessSummary: 'សង្ខេប ពាក្យ',
                            eachCustomerServiceRepresentativeCanSelectALowerLimit: 'ដែន កំណត់ ទាប នៃ ស្រង់ចេញ ក្នុង មួយ ភ្នាក់ង',
                            automaticallyGenerateBusinessSummariesFromLargeModelsAndCustomizeDimensionsBasedOnBusinessSituations: 'ការ សង្ខេប បណ្ដាញ ត្រូវ បាន បង្កើត ដោយ ស្វ័យ ប្រវត្តិ ដោយ ម៉ូឌុល ធំ ហើយ ទំហំ អាច ត្រូវ បាន ប្ដូរ តាម បំណង ដោយ ស្វ័យ ប្រវត្តិ ។',
                            onlyTheFirstLevelReviewerAllocationStrategy: 'អ្នក ពិនិត្យ មើល កម្រិត ១',
                            secondaryCompounding: 'សមត្ថភាព រង ៖',
                            secondLevelReviewersOnlySupportAverageDistribution: 'អ្នក ត្រួត ពិនិត្យ រង ក្រោយ គាំទ្រ តែ ការ ចែកចាយ ស្មើ',
                            secondLevelReviewer: 'កម្មវិធី មើល កម្រិត ទីពីរ ៖',
                            samplingInspectionTarget: 'គោលដៅ ត្រួតពិនិត្យ គំរូ',
                            setTheTargetToBeCompletedByManualSamplingInspectionWhenTheTargetIsNotReachedOrExceededAPromptWillBeGivenForExampleEveryCustomerServiceShouldCompleteSamplingInspectionsEveryMonthWhenTheNumberIsLessThan80APromptWillBeGivenOnTheQualityInspectionAndSamplingInspectionPage: 'កំណត់ គោលដៅ ដែល ត្រូវ បាន បញ្ចប់ ដោយ ការ ត្រួត ពិនិត្យ គំរូ ដោយ ដៃ ហើយ ផ្តល់ ឲ្យ សួរ ពេល គោលដៅ មិន ត្រូវ បាន ដល់ ឬ បើក ។ ឧទាហរណ៍ សេវា អ្នក ភ្ជាប់ ការ ត្រួត ពិនិត្យ គុណភាព និង ទំព័រ ត្រួត ពិនិត្យ គំរូ នឹង ផ្តល់ ឲ្យ សំឡេង ។',
                        },
                        component: {
                            pleaseImproveTheSamplingDeadlineConfiguration: 'សូម ធ្វើ ឲ្យ ការ កំណត់ រចនា សម្ព័ន្ធ កំណត់ រចនាសម្ព័ន្ធ គំរូ !',
                            pleaseImproveTheAppealConfiguration: 'សូម ធ្វើ ឲ្យ ការ កំណត់ រចនា សម្ព័ន្ធ សម្ព័ន្ធ ។',
                            displaySilentDuration: 'បង្ហាញ ថិរវេលា ស្ងាត់',
                            playbarDisplayMood: 'ការ បង្ហាញ របារ ចាក់',
                            playbarDisplaySmartLabel: 'របារ ចាក់ បង្ហាញ ស្លាក ឆ្លាត',
                            playbarDisplayHitRule: 'បង្ហាញ បន្ទាត់ របារ ចាក់',
                            verificationFailed: 'បាន បរាជ័យ ក្នុង ការ ផ្ទៀងផ្ទាត់',
                            pleaseAddASecondLevelQualityInspector: 'សូម បន្ថែម បញ្ជា',
                        },
                        businessSummary: {
                            components: {
                                field: {
                                    index: {
                                        hintLanguage: 'សួរ',
                                        fieldName: 'ឈ្មោះ វាល',
                                        fieldDescription: 'សេចក្ដី ពិពណ៌នា វាល',
                                        generateContent: 'បង្កើត មាតិកា',
                                        enabled: 'បាន អនុញ្ញាត',
                                        generationMethod: 'វិធីសាស្ត្រ បង្កើតComment',
                                        automaticGeneration: 'បាន បង្កើត ដោយ ស្វ័យ ប្រវត្តិ',
                                        manualTrigger: 'បិទ ដោយ ដៃ',
                                        filterCondition: 'លក្ខខណ្ឌ តម្រង',
                                        return: 'ត្រឡប់ វិញ',
                                        preserve: 'រក្សាទុក',
                                    },
                                    components: {
                                        training: {
                                            index: {
                                                generateResults: 'បង្កើត លទ្ធផល',
                                            },
                                        },
                                    },
                                },
                                contentScope: {
                                    index: {
                                        notQualified: 'មិន បាន ត្រឹមត្រូវ',
                                        limitedScope: 'កម្រិត សំឡេង',
                                        add: 'បន្ថែម@ info: whatsthis',
                                        thereIsCurrentlyNoDataAvailable: 'គ្មាន ទិន្នន័យ',
                                    },
                                },
                            },
                            index: {
                                fieldName: 'ឈ្មោះ វាល',
                                fieldDescription: 'សេចក្ដី ពិពណ៌នា វាល',
                                nothing: 'គ្មាន ទេ',
                                generationMethod: 'វិធីសាស្ត្រ បង្កើតComment',
                                generateManually: 'បង្កើត ដោយ ដៃ',
                                automaticGeneration: 'បាន បង្កើត ដោយ ស្វ័យ ប្រវត្តិ',
                                generateContent: 'បង្កើត មាតិកា',
                                notQualified: 'មិន បាន ត្រឹមត្រូវ',
                                filterCondition: 'លក្ខខណ្ឌ តម្រង',
                                enabled: 'បាន អនុញ្ញាត',
                                type: 'ប្រភេទ@ info: whatsthis',
                                system: 'ប្រព័ន្ធ',
                                custom: 'ផ្ទាល់ខ្លួន',
                                operation: 'ប្រតិបត្តិការ',
                                edit: 'កែសម្រួល',
                                areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                                delete: 'លុប',
                                addField: 'បន្ថែម វាល',
                            },
                        },
                        autoAdd: {
                            index: {
                                addQuestionnaireDataAutomatically: 'បន្ថែម ទិន្នន័យ សំណួរ ដោយ ស្វ័យ ប្រវត្តិ',
                                addVideoDataAutomatically: 'បន្ថែម ទិន្នន័យ វីដេអូ ដោយ ស្វ័យ ប្រវត្តិ',
                                automaticallyAddTextData: 'បន្ថែម ទិន្នន័យ អត្ថបទ ដោយ ស្វ័យ ប្រវត្តិ',
                                addVoiceDataAutomatically: 'បន្ថែម ទិន្នន័យ សំឡេង ដោយ ស្វ័យ ប្រវត្តិ',
                                automaticallyAddWorkOrderData: 'បន្ថែម ទិន្នន័យ លំដាប់ ការងារ ដោយ ស្វ័យ ប្រវត្តិ',
                            },
                        },
                        topicAnalysis: {
                            components: {
                                field: {
                                    index: {
                                        topicName: 'ឈ្មោះ ប្រតិទិន',
                                        topicDescription: 'សេចក្ដី ពិពណ៌នា សំណួរ',
                                        topicTag: 'ស្លាក ប្រតិទិន',
                                    },
                                },
                            },
                            index: {
                                addTopic: 'បន្ថែម ប្រធាន បទ',
                                topicName: 'ឈ្មោះ ប្រតិទិន',
                                topicDescription: 'សេចក្ដី ពិពណ៌នា សំណួរ',
                                topicTag: 'ស្លាក ប្រតិទិន',
                                pleaseEnterATopicName: 'សូម បញ្ចូល ឈ្មោះ ប្រកួត',
                            },
                        },
                        components: {
                            businessConfig: {
                                index: {
                                    moreThanTheValidityPeriodIsNotChecked: 'មិន ត្រូវ បាន ធីក ច្រើន ជាង រយៈពេល សុពលភាព ទេ',
                                    dontSetValidityPeriod: 'កុំ កំណត់ រយៈពេល សុពលភាព',
                                    setTheValidityPeriodOfRandomInspection: 'កំណត់ រយៈពេល សុពលភាព នៃ ការ ត្រួត ពិនិត្យ ចៃដន្យ',
                                    setTheDeadlineForRandomInspection: 'កំណត់ កាលបរិច្ឆេទ សម្រាប់ ការ ត្រួត ពិនិត្យ ចៃដន្យ',
                                    validityPeriodOfSamplingInspection: 'រយៈពេល សុពលភាព នៃ ការ ត្រួត ពិនិត្យ គំរូ',
                                    day: 'ថ្ងៃStencils',
                                    samplingDeadline: 'បញ្ចប់ បន្ទាត់ គំរូ',
                                    caseLibraryConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ បណ្ណាល័យ អក្សរ ៖',
                                    allowViewingTheCaseLibraryInTheAppealsSDK: 'អនុញ្ញាត ឲ្យ មើល បណ្ណាល័យ ករណី ក្នុង SDK',
                                    finalConfiguration: 'ការ កំណត់ រចនាសម្ព័ន្ធ ចុងក្រោយ ៖',
                                    allowFinalReviewInQualityDetails: 'អនុញ្ញាត ឲ្យ មើល ចុងក្រោយ ក្នុង សេចក្ដី លម្អិត គុណភាព',
                                    aIQualityInspectionResultsCanBeAppealed: 'លទ្ធផល ត្រួត ពិនិត្យ គុណភាព AI អាច ត្រូវ បាន កើង',
                                    theResultsOfManualSamplingCanBeAppealed: 'លទ្ធផល នៃ ការ គំរូ ដោយ ដៃ អាច ត្រូវ បាន ជូន ដំណឹង ។',
                                    setAppealDeadline: 'កំណត់ កាលបរិច្ឆេទ ការ អាប់ភ្លេត',
                                    complaintDeadline: 'កាលបរិច្ឆេទ កំណត់',
                                    reviewDeadline: 'មើល កាលបរិច្ឆេទ',
                                    setAppealValidityPeriod: 'កំណត់ រយៈពេល សុពលភាព អាជ្ញាប់',
                                    refreshTheAppealValidityPeriodDuringRandomInspectionOrReinspection: 'ស្រស់ រយៈពេល សុពលភាព ការ បកប្រែ កំឡុង ពេល ត្រួត ពិនិត្យ ចៃដន្យ ឬ បញ្ជា ឡើង វិញ ។',
                                    numberOfAppealsAllowedToBeSubmitted: 'ចំនួន អនុញ្ញាត ឲ្យ ដាក់ ស្នើ',
                                    second: 'ពេលវេលាName',
                                },
                            },
                            autoAssign: {
                                index: {
                                    whenTheSecondlevelReviewAssignerIsEqualToTheFirstlevelReviewSubmiterTheSecondlevelReviewIsAutomaticallyCompleted: 'នៅ ពេល អ្នក ផ្ដល់ ការ មើល កម្រិត ទីពីរ គឺ ស្មើ នឹង អ្នក ដាក់ស្នើ កម្រិត ដំបូង ។ ការ មើល កម្រិត ទីពីរ ត្រូវ បាន បញ្ចប់ ដោយ ស្វ័យ ប្រវត្តិ ។',
                                    firstlevelReview: 'មើល កម្រិត ទី មុន',
                                    triggerPolicy: 'គោលការណ៍ កេះ ៖',
                                    secondaryReviewOnlyWhenPassing: 'ការ ត្រួត ពិនិត្យ ឡើង វិញ តែ នៅ ពេល បញ្ចូល',
                                    secondaryReviewOfAllResults: 'ការ ត្រួត ពិនិត្យ រង នៃ លទ្ធផល ទាំងអស់',
                                },
                            },
                            viewGrade: {
                                index: {
                                    number: 'គ្មាន ។',
                                    pushTiming: 'ចុច ពេលវេលាComment',
                                    realtimeViewing: 'ការ មើល ពេលវេលា ពិតComment',
                                    timingView: 'ទិដ្ឋភាព ពេលវេលា',
                                    addFrequency: 'បន្ថែម ប្រេកង់',
                                    timeRange: 'ជួរ ពេលវេលា',
                                    pleaseSelect: 'សូម ជ្រើស',
                                    filterCriteria: 'យោង តម្រង ៖',
                                },
                            },
                        },
                    },
                    roleConfig: {
                        index: {
                            name: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                            roleConfigTip: 'បាន ប្រើ ដើម្បី កំណត់ រចនា សម្ព័ន្ធ ច្បាប់ ការ ទទួល ស្គាល់ សម្រាប់ ដំណើរការ បំបែក អ្នក និយាយ នៅពេល ទិន្នន័យ ហៅ ដែល បាន នាំចូល គឺ ម៉ូូ ។ បង្ហាញ ជាមួយ ច្បាប់ សម្រាប់ តំណ ភ្នាក់ងារ',
                            operator: 'កម្មវិធី',
                            operatorLogic: 'តក្កវិជ្ជា',
                        },
                    },
                    manualAdd: {
                        index: {
                            name: 'បន្ថែម ដោយ ដៃ',
                            tip: 'បាន ប្រើ ដើម្បី តម្រង ទិន្នន័យ មើល ជា មុន ដោយ ការ កំណត់ រចនា សម្ព័ន្ធ ដោយ ដៃ និង បន្ថែម វា រហ័ស ទៅ ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                            screeningCondition: 'បន្ថែម តាម ទិដ្ឋភាព តម្រង',
                            aiScreeningCondition: 'លក្ខខណ្ឌ តម្រង ឆ្លាត',
                            rule: 'បន្ទាត់',
                            createTime: 'បន្ថែម ពេលវេលា',
                            filterTitle: 'មាតិកា តម្រង',
                            filterRule: 'លក្ខខណ្ឌ តម្រង',
                            startTime: 'ពេលវេលា ចាប់ផ្ដើម',
                            endTime: 'ពេលវេលា បញ្ចប់',
                            records: 'នាំចូល ថត',
                            createUserName: 'កម្មវិធី',
                            successCount: 'បាន បន្ថែម ដោយ ជោគជ័យ',
                            conditionRule: 'ច្បាប់ លក្ខខណ្ឌ ៖',
                            preview: 'មើល ជាមុន',
                            previewData: 'បច្ចុប្បន្ន មាន {0} ដែល ផ្គូផ្គង លក្ខខណ្ឌ តម្រង {1} ភារកិច្ច ត្រូវ បាន បន្ថែម {2} និង {3} ភារកិច្ច មិន អាច ត្រូវ បាន បន្ថែម ។',
                            failCount: 'បាន បរាជ័យ',
                        },
                    },
                    basicInfo: {
                        index: {
                            title: 'ព័ត៌មាន មូលដ្ឋាន',
                            name: 'ឈ្មោះ:',
                            taskName: 'ឈ្មោះ ភារកិច្ច',
                            taskNamePlaceholder: 'សូម បញ្ចូល ឈ្មោះ ភារកិច្ច',
                            requiredName: 'ឈ្មោះ ភារកិច្ច មិន អាច ទទេ',
                            taskRemarkPlaceholder: 'សូម បញ្ចូល សេចក្ដី ពិពណ៌នា ភារកិច្ច',
                            requiredRemark: 'សេចក្ដី ពិពណ៌នា ភារកិច្ច មិន អាច ទទេ',
                            remark: 'សេចក្ដី ពិពណ៌នា',
                            taskRemark: 'សេចក្ដី ពិពណ៌នា ភារកិច្ច',
                            source: 'ប្រភព ទិន្នន័យ',
                            benchmarkScore: 'ពិន្ទុ ចំណុច',
                            benchmarkScorePlaceholder: 'សូម បញ្ចូល ពិន្ទុ ពិន្ទុ',
                            scoreLowerLimit: 'ដែន កំណត់ ពិន្ទុ អប្បបរមា',
                            scoreUpperLimit: 'ចំណុច ពិន្ទុ អតិបរមា',
                            inspectType: 'ប្រភេទ ត្រួត ពិនិត្យ គុណភាព',
                            nlpModel: 'ម៉ូដែល NLP',
                            commonInspect: 'ការ ត្រួត ពិនិត្យ គុណភាព ធម្មតា',
                            associateInspect: 'ការ ត្រួត ពិនិត្យ គុណភាព ដែល បាន ទាក់ទង',
                            associateCycle: 'រយៈពេល បញ្ឈរ',
                            associateRegulation: 'ច្បាប់ ទំនាក់ទំនង',
                            judgeStrategy: 'តក្ក ប្រតិបត្តិ@ info: whatsthis',
                            rule: 'បន្ទាត់',
                            commonTip: 'ការ ត្រួត ពិនិត្យ គុណភាព ធម្មតា ៖ អនុវត្ត ទៅកាន់ ទំនាក់ទំនង តែ មួយ និង ប្រអប់ ។ ការ ត្រួត ពិនិត្យ គុណភាព ត្រូវ បាន អនុវត្ត លើ មាតិកា នៃ ទំនាក់ទំនង តែ មួយ ។',
                            associateTip: 'ការ ត្រួត ពិនិត្យ គុណភាព ដែល បាន ទាក់ទង ៖ អាច អនុវត្ត ទៅកាន់ ការ ទំនាក់ទំនង ច្រើន និង ពាក្យ សម្រាក តភ្ជាប់ មាតិកា នៃ ទំនាក់ទំនង ច្រើន សម្រាប់ ការ ត្រួត ពិនិត្យ គុណភាព ។',
                            cycleTip: 'ប្រសិន បើ មាន ប្រអប់ ទំនាក់ទំនង ច្រើន និង ប្រអប់ ដែល ទាក់ទង នឹង ទិន្នន័យ នៅ ក្នុង រយៈពេល ដែល បាន ភ្ជាប់ នឹង បញ្ចូល ភារកិច្ច សម្រាប់ ការ ត្រួត ពិនិត្យ គុណភាព ។',
                            scoreLowerLimitPlaceholder: 'សូម បញ្ចូល ដែន កំណត់ ពិន្ទុ អប្បបរមា',
                            scoreUpperLimitPlaceholder: 'សូម បញ្ចូល ពិន្ទុ អតិបរមា',
                            call: 'ហៅ សំឡេង',
                            dialogue: 'ប្រអប់ អត្ថបទ',
                            user: 'កម្មវិធី ត្រួតពិនិត្យ គុណភាព',
                            wechatUser: 'កម្មវិធី',
                            noDesignated: 'មិន បញ្ជាក់ ទេ',
                            type: 'ប្រភេទ ប្រព័ន្ធ',
                            singleScore: 'ពិន្ទុ មួយ',
                            conduct: 'សូម បញ្ចប់ ព័ត៌មាន ខាងក្រោម ដំបូង បន្ទាប់ ចុច បន្ទាប់',
                            conduct2: 'សូម បញ្ចប់ ការ កំណត់ រចនា សម្ព័ន្ធ ច្បាប់ ត្រួត ពិនិត្យ គុណភាព និង ចំណុច ត្រួត ពិនិត្យ គុណភាព ។ ប្រសិន បើ អ្នក បាន បញ្ចប់ ការ កំណត់ រចនា សម្ព័ន្ធ អ្នក អាច ចុច បន្ទាប់',
                            conduct3: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រូវ បាន កំណត់ រចនា សម្ព័ន្ធ តាម រយៈ ចំណុច ត្រួត ពិនិត្យ គុណភាព និង អត្រា របស់ វា ។ អ្នក អាច កំណត់ កម្រិត លទ្ធផល ត្រួត ពិនិត្យ គុណភាព ខុស គ្នា ។ ប្រសិន បើ អ្នក មិន ត្រូវការ វាល អ្នក អាច រំលង ជំហាន នេះ ។ ប្រសិន បើ អ្នក បាន បញ្ចប់ ការ កំណត់ រចនា សម្ព័ន្ធ អ្នក អាច ចុច បន្ទាប់ ឬ ចេញ ពី មុន',
                            conduct4: 'អ្នក អាច កំណត់ រចនា សម្ព័ន្ធ លក្ខណៈ សម្បត្តិ ទិន្នន័យ ដែល នឹង ត្រូវ បាន បន្ថែម ទៅ ភារកិច្ច ដោយ ស្វ័យ ប្រវត្តិ តាម ទិន្នន័យ ដែល ភារកិច្ច គួរ តែ ពិនិត្យ ក្នុង ស្វ័យ ប្រវត្តិ ទីតាំង បន្ថែម ។ ប្រសិន បើ អ្នក មិន ត្រូវ បន្ថែម ទិន្នន័យ ដោយ ស្វ័យ ប្រវត្តិ សម្រាប់ ពេលវេលា អ្នក អាច ចុច រំលង ។ ប្រសិន បើ អ្នក បាន បញ្ចប់ ការ កំណត់ រចនា សម្ព័ន្ធ អ្នក អាច ចុច បន្ទាប់ ។',
                            conduct5: 'ប្រសិន បើ អ្នក កំពុង ប្រើ ការ ថត  mono សូម ប្រាកដ ថា កំណត់ រចនា សម្ព័ន្ធ ធាតុ នេះ ហើយ ចុច បន្ទាប់ ។ សូម ប្រើ តែ សំឡេង របស់ សេវា របស់ ភ្ញៀវ ដើម្បី ជួយ ប្រព័ន្ធ ដើម្បី កំណត់ អត្តសញ្ញាណ បទ ផ្សេង គ្នា រវាង សេវា របស់ ភ្ញៀវ និង ភ្ញៀវ ។ ប្រសិន បើ អ្នក ប្រើ ការ ថត ឆានែល ពីរ ឬ បាន បញ្ចប់ ការ កំណត់ រចនា សម្ព័ន្ធ អ្នក អាច ចុច រំលង',
                            conduct6: 'អ្នក អាច ប្រើ មុខងារ បន្ថែម ដៃ ដើម្បី បញ្ចូល ទិន្នន័យ ទំនាក់ទំនង ដែល មាន ស្រាប់ ក្នុង ប្រព័ន្ធ សម្រាប់ ការ ត្រួត ពិនិត្យ គុណភាព ។ ឬ អ្នក បាន ដាក់ ស្នើ ភារកិច្ច បន្ថែម ដោយ ដៃ សូម ចុច បញ្ចប់ ដោយ ផ្ទាល់',
                            helper: 'មើល ឯកសារ ជំនួយ',
                            quit: 'ចេញ ចាប់ផ្ដើម',
                            next: 'ជំហាន បន្ទាប់',
                            complete: 'បញ្ចប់',
                            skip: 'រំលង',
                            cancel: 'បោះបង់',
                            delete: 'លុប',
                            save: 'រក្សាទុក',
                        },
                        template: {
                            language: 'ភាសាComment',
                            samplingInspector: 'កម្មវិធី ត្រួតពិនិត្យ គំរូ',
                            sessionType: 'ប្រភេទ សម័យ',
                        },
                    },
                },
                workbench: {
                    qualityCheckList: {
                        index: {
                            name: 'ការងារ ត្រួត ពិនិត្យ គុណភាព',
                            search: 'តម្រង',
                            export: 'នាំចេញ',
                            condition: 'លទ្ធផល',
                            logic: 'តក្ក',
                            reQualityInspection: 'ឡើង វិញ',
                            reQualityInspectionUnderWay: 'ភារកិច្ច បញ្ជា',
                            reQualityInspectionUnderWayTip: 'ការ ទុក ទំព័រ បន្ទាប់ ពី បិទ បង្អួច មិន ប៉ះពាល់ ដល់ ភារកិច្ច',
                            reQualityInspectionDone: 'បាន បញ្ចប់ ឡើង វិញ',
                            reQualityInspectionDoneTip: 'ការ ណែនាំ ឡើងវិញ ត្រូវ បាន បញ្ចប់ ដោយ ជោគជ័យ សូម ចុច ប៊ូតុង ការ អះអាង ។',
                            endReQualityInspection: 'បញ្ចប់ ភារកិច្ច',
                            alreadyDoneTip: 'បាន បញ្ចប់',
                            totalTip: 'សរុប',
                            unit: 'អត្ថបទ',
                            endReInspectionSuccess: 'បាន បញ្ចប់ ភារកិច្ច គុណភាព ឡើង វិញ',
                            closeWindow: 'បិទ បង្អួច',
                            endReInspectionFailed: 'បាន បរាជ័យ ភារកិច្ច គុណភាព ឡើង វិញ សូម ព្យាយាម ម្ដង ទៀត ។',
                        },
                        detail: {
                            name: 'សេចក្ដី លម្អិត ការ ត្រួត ពិនិត្យ គុណភាព',
                            reviewName: 'សេចក្ដី លម្អិត ឡើង វិញ',
                            spotCheckName: 'សេចក្ដី លម្អិត គំរូ',
                            audioText: 'អត្ថបទ ដែល បាន ថត',
                            callInfo: 'ព័ត៌មាន ហៅ',
                            satisfactionEvaluation: 'ការ វាយតម្លៃ ភាព ត្រឹមត្រូវ ៖',
                            queueTime: 'ពេលវេលា ដែល បាន បង្កើន ជួរ ៖',
                            ringingTime: 'ពេលវេលា បង្ហាត់ ៖',
                            callTime: 'ព្រឹត្តិការណ៍ ហៅ ៖',
                            hangUpIdentity: 'ភ្ញៀវ ដែល ហៅ ៖',
                            location: 'ផ្ទះ ៖',
                            source: 'ប្រភព ៖',
                            agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ ៖',
                            deviceType: 'ប្រភេទ ឧបករណ៍ ៖',
                            callType: 'ប្រភេទ ហៅ ៖',
                            phoneNumber: 'លេខ ឡើង វិញ ៖',
                            task: 'ភារកិច្ច ៖',
                            commentsTip: 'សូម បញ្ចូល សេចក្ដី អធិប្បាយ ការ ត្រួត ពិនិត្យ គុណភាព',
                            lastPage: 'ទំព័រ មុន',
                            nextPage: 'ទំព័រ បន្ទាប់',
                            score: 'ពិន្ទុ ត្រួត ពិនិត្យ គុណភាព',
                            review: 'ឡើង វិញ',
                            file: 'ប័ណ្ណសារ',
                            changeList: 'ផ្លាស់ប្ដូរ ថត',
                            fullMarks: 'សម្គាល់ ពេញ',
                            most: 'បំផុត',
                            saveReview: 'ឡើង វិញ',
                            saveSpotCheck: 'ការ ត្រួត ពិនិត្យ និង ដាក់ស្នើ',
                            point: 'ចំណុច ត្រួត ពិនិត្យ គុណភាព',
                            sampleAssignInspector: 'ផ្ដល់ អ្នក ត្រួតពិនិត្យ គំរូ',
                            reviewAssignInspector: 'ផ្ដល់ កម្មវិធី ត្រួត ពិនិត្យComment',
                            sampleStatus: 'ស្ថានភាព គំរូ',
                            read: 'អាន',
                            user: 'អ្នក ប្រើ',
                            confirmer: 'មនុស្ស ដែល បាន អះអាង',
                            voiceDownloadError: 'បាន បរាជ័យ ក្នុង ការ ទាញយក សំឡេង សូម ព្យាយាម ម្ដង ទៀត ។',
                            smartTags: 'ស្លាក ឆ្លាត',
                            interactiveTip: 'ប្រើ ការ ទទួល ស្គាល់ អន្តរកម្ម ដើម្បី រក ឃើញ ការ ប្រើប្រាស់ របស់ FAQ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                            interactiveIsEmptyTip: 'មិន បាន រក ឃើញ មាតិកា ការ ស្គាល់ អន្តរសកម្ម',
                            businessRecords: 'ថត ពាក្យ',
                        },
                    },
                },
                reports: {
                    groupChatAnalysis: {
                        index: {
                            analysisOfEnterpriseWeChatGroupChat: 'វិភាគ នៃ ជជែក ក្រុម WeChat Enterprise',
                        },
                    },
                },
            },
            cards: {
                health: 'ការ ត្រួត ពិនិត្យ គុណភាព',
                accuracy: 'អត្រា ការ អនុញ្ញាត រក អត្ថបទ',
                sessionsTotal: 'សម័យ សរុប',
                enable: 'អនុញ្ញាត',
                disable: 'បិទ',
                none: 'គ្មាន ទេ',
                call: 'ហៅ',
                dialogue: 'ប្រអប់Comment',
                taobao: 'អ៊ីមែល',
                wecom: 'សម័យ',
                ticket: 'លំដាប់ ការងារ',
            },
            component: {
                language: 'ភាសាComment',
                backup: '(បម្រុង ទុក)',
                taskSaveAsSucceeded: 'បាន រក្សាទុក ភារកិច្ច ជា ជោគជ័យ',
                copyContent: 'ចម្លង មាតិកា',
                essentialInformation: 'ព័ត៌មាន មូលដ្ឋាន',
                ruleConfiguration: 'ការ កំណត់ រចនាសម្ព័ន្ធ បន្ទាត់',
                basicInformationQualityInspector: 'ព័ត៌មាន មូលដ្ឋាន',
                qualityInspectionRating: 'ការ ត្រួត ពិនិត្យ គុណភាព',
                roleConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                autoAddConfiguration: 'បន្ថែម ការ កំណត់ រចនា សម្ព័ន្ធ ដោយ ស្វ័យ ប្រវត្តិ',
                autoPushConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ ចុច ស្វ័យ ប្រវត្តិ',
                automaticSamplingConfiguration: 'ការ កំណត់ រចនាសម្ព័ន្ធ គំរូ ដោយ ស្វ័យ ប្រវត្តិ',
                automaticAllocationConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ កំណត់ រចនាសម្ព័ន្ធ ដោយ ស្វ័យ ប្រវត្តិ',
                businessConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                caseBaseConfiguration: 'បណ្ណាល័យ អក្សរ',
            },
            template: {
                cancel: 'បោះបង់',
                complete: 'បញ្ចប់',
                sort: 'តម្រង',
                ruleApproval: 'បន្ទាត់',
                enterpriseMicroConversationAnalysisTask: 'ភារកិច្ច ការ វិភាគ micro-sesion Enterprise',
                enterpriseAndMicroVoiceAnalysisTask: 'ភារកិច្ច ការ វិភាគ សំឡេង របស់ Micro Enterprise',
                saveTaskAs: 'រក្សាទុក ភារកិច្ច',
            },
            approve: {
                checkPoint: {
                    index: {
                        ruleDetails: 'សេចក្ដី លម្អិត',
                    },
                },
                components: {
                    autoApproveSwitch: {
                        modificationSucceeded: 'ការ កែប្រែ បាន ជោគជ័យ',
                        automaticApproval: 'អនុញ្ញាត ស្វ័យ ប្រវត្តិ',
                    },
                    pageHeaderExtra: {
                        modificationSucceeded: 'ការ កែប្រែ បាន ជោគជ័យ',
                        test: 'សាកល្បង',
                        formal: 'សមរម្យ',
                        adopt: 'តាម គ',
                    },
                    rejectButton: {
                        index: {
                            areYouSureToReject: 'តើ អ្នក ពិត ជា បដិសេធ',
                            pleaseEnterTheRejectionReason: 'សូម បញ្ចូល មូលហេតុ សម្រាប់ ការ បដិសេធ',
                            reject: 'បាន បដិសេធ',
                        },
                    },
                    table: {
                        index: {
                            modificationSucceeded: 'ការ កែប្រែ បាន ជោគជ័យ',
                            taskName: 'ឈ្មោះ ភារកិច្ច',
                            dataSource: 'ប្រភព ទិន្នន័យ',
                            qualityInspectionType: 'ប្រភេទ ត្រួត ពិនិត្យ គុណភាព',
                            state: 'ស្ថានភាព',
                            updateTime: 'ពេលវេលា ទាន់ សម័យ',
                            updatedBy: 'ធ្វើ ឲ្យ អ្នក ទាន់ សម័យ',
                            approver: 'អ្នក អនុញ្ញាត',
                            reasonForRejection: 'មូលហេតុ សម្រាប់ ការ បដិសេធ',
                            operation: 'ប្រតិបត្តិការ',
                            details: 'សេចក្ដី លម្អិត',
                            adopt: 'តាម គ',
                            whole: 'ទាំង អស់',
                            approvalStatus: 'ស្ថានភាព អនុញ្ញាត',
                        },
                    },
                },
            },
        },
        dashboard: {
            title: 'មើល មើល',
            hi: 'ហាំ,',
            standardEdition: 'កែសម្រួល ស្តង់ដារ',
            call: 'តុល្យភាព ត្រួតពិនិត្យ គុណភាព សំឡេង',
            text: 'រយៈពេល សុពលភាព នៃ ការ ត្រួត ពិនិត្យ គុណភាព អត្ថបទ',
            collectionTasks: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ដែល បាន ប្រមូលName',
            noCollection: 'គ្មាន សម្រាំង នៃ ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ។',
            goToCollecte: 'ទៅ សម្រាំង',
            yesterdayOverView: 'ស្ថិតិ បច្ចុប្បន្ន',
            yesterdayAgent: 'បញ្ជី សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ ម្ដង',
            yesterdayInspWork: 'ស្ថានភាព ការងារ របស់ ថ្ងៃ ម្ដងៗ របស់ អ្នក ត្រួត ពិនិត្យ គុណភាពName',
            operationalStatistics: {
                title: 'ស្ថិតិ បណ្ដាញ',
                qualityTesting: 'ការ ត្រួត ពិនិត្យ គុណភាព',
                spotCheck: 'ការ ត្រួត ពិនិត្យ ចៃដន្យ',
                appeal: 'ជម្រះ',
                chartTitles: {
                    qualityTestingTrend: 'កម្រិត សំឡេង ត្រួត ពិនិត្យ គុណភាព',
                    qualityTestingAnalysis: 'ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព',
                    spotCheckTrend: 'លំដាប់ គំរូ',
                    spotCheckAnalysis: 'ស្ថានភាព ភារកិច្ច គំរូ',
                    appealTrend: 'បង្ហាត់ បង្ហាញ',
                    appealAnalysis: 'ស្ថានភាព លទ្ធផល នៃ ការ ភ្ជាប់',
                },
                titles: {
                    qualityDataTend: 'ចែកចាយ ទិន្នន័យ ត្រួត ពិនិត្យ គុណភាព',
                    qualityCover: 'ការ បកប្រែ ការ ត្រួត ពិនិត្យ គុណភាព',
                    qualityAverageTime: 'ពេលវេលា រង់ចាំ ការ ត្រួតពិនិត្យ គុណភាព មធ្យម',
                    qualityCoverTend: 'កម្រិត ពិនិត្យ មើល គុណភាព',
                    handCover: 'ការ គ្រប់គ្រង ដោយ ដៃ',
                    checkCover: 'បង្កើន គំរូ',
                    resAverageTime: 'ពេលវេលា ដំណើរការ មធ្យម',
                    handTend: 'ការ ដំណើរការ ដោយ ដៃ',
                    dataTend: 'ចែកចាយ ភារកិច្ច ទិន្នន័យ',
                },
                qualityAverage: 'ពិន្ទុ មើល គុណភាព មធ្យម',
                scoreTrend: 'ការ ពិនិត្យ មើល គុណភាព មួយ',
                qualityAverageTime: 'ពេលវេលា រង់ចាំ ការ ត្រួតពិនិត្យ គុណភាព មធ្យម',
                callCoverage: 'ការ ពិនិត្យ មើល គុណភាព សំឡេង',
                textCoverage: 'ការ ពិនិត្យ មើល គុណភាព អត្ថបទ',
                checkCount: 'កម្រិត សំឡេង ទិន្នន័យ គំរូ',
                siphonCount: 'ស្រង់ កម្រិត សំឡេង ទិន្នន័យ',
                reviewCount: 'មើល កម្រិត សំឡេង ទិន្នន័យ',
                appealCount: 'កម្រិត សំឡេង ទិន្នន័យ',
                checkRate: 'ភាគរយ នៃ ការ ត្រួត ពិនិត្យ ចៃដន្យ',
                reviewRate: 'ភាគរយ នៃ ការ ពិនិត្យ មើល ភ្ជាប់',
                PieTitle: {
                    totalCount: 'ចំនួន សរុប',
                    totalCall: 'ចំនួន ហៅ សំឡេង',
                    totalIm: 'ចំនួន ព័ត៌មាន អត្ថបទ',
                    inspectionCall: 'ចំនួន ត្រួតពិនិត្យ គុណភាព សំឡេង',
                    inspectionIm: 'ចំនួន ត្រួតពិនិត្យ គុណភាព អត្ថបទ',
                    checkCall: 'ចំនួន គំរូ សំឡេង',
                    unCheckCall: 'សំឡេង មិន បាន គំរូ',
                    checkIm: 'ចំនួន គំរូ អត្ថបទ',
                    unCheckIm: 'សមាសភាគ អត្ថបទ',
                    reviewCall: 'កម្រិត សំឡេង',
                    reviewIm: 'ចំនួន មើល អត្ថបទ',
                    unReviewCall: 'សំឡេង ដែល មិន បាន ឡើង វិញ',
                    unReviewIm: 'ចំនួន អត្ថបទ មិន បាន ពិនិត្យ មើល ទេ',
                    unInspectionCall: 'មិន បាន ពិនិត្យ ភាព សំឡេង',
                    unInspectionIm: 'ចំនួន អត្ថបទ ដែល មិន បាន ធីក',
                },
                check_rate: 'បង្កើន គំរូ',
                voice_check_rate: 'គ្រប គំរូ សំឡេង',
                text_check_rate: 'បង្កប់ គំរូ អត្ថបទ',
                sample_execute_time: 'ពេលវេលា ដំណើរការ គំរូ មធ្យម',
                review_execute_time: 'ពេលវេលា ដំណើរការ ភ្ញៀវ មធ្យម',
            },
            analysisOverview: {
                tableTitle: {
                    conditions: 'ច្បាប់ ត្រួត ពិនិត្យ គុណភាព របស់ Kanban',
                    agent: 'គំរូ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                },
                tableTips: {
                    conditions: '<Div> តម្រៀប ចំនួន សរុប របស់ សរុប ដែល បំបាត់ និង ធ្វើ តាម ច្បាប់ ត្រួត ពិនិត្យ គុណភាព ។ <Br />\nធាតុ ត្រួត ពិនិត្យ គុណភាព ៖ ឈ្មោះ ចំណុច ត្រួត ពិនិត្យ គុណភាព <br />\nចំនួន សរុប នៃ ព័ត៌មាន មិន ត្រឹមត្រូវ ៖ ចំនួន សរុប នៃ ការ និយាយ មិន ត្រឹមត្រូវ នៅ លើ ធាតុ ត្រួត ពិនិត្យ គុណភាព <br />\nភាគរយ នៃ ការ បំបាត់ ៖ ភាគរយ នៃ ការ បំបាត់ = ចំនួន គំរូ សរុប/ ចំនួន គំរូ សរុប នៃ ការ បំបាត់ </div>',
                    agent: '<Div> តម្រៀប អត្រា មធ្យម របស់ ភ្នាក់ងារ <br />\nឈ្មោះ សេវា ម៉ាស៊ីន ភ្ញៀវ ៖ the name of the customer service <br />\nក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ ៖ ក្រុម សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ ដែល មាន សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ ( ព័ត៌មាន ដំណឹង ក្នុង ព័ត៌មាន សេវា) <br />\nចំនួន សរុប របស់ សរុប នៃ ការ ពិនិត្យ ៖ ចំនួន សរុប នៃ ការ ពិនិត្យ គុណភាព របស់ សេវា របស់ ម៉ាស៊ីន ភ្ញៀវ <br />\nពិន្ទុ ត្រួត ពិនិត្យ គុណភាព មធ្យម ៖ ពិន្ទុ ត្រួត ពិនិត្យ ភាព មធ្យម នៃ ភ្នាក់ងារ ( ពិន្ទុ សរុប/ ចំនួន សរុប នៃ ព័ត៌មាន) </div>',
                },
                tips: {
                    total: 'ចំនួន សរុប នៃ បញ្ហា/ ចង្អុល ដែល បាន បញ្ចូល ទៅ ក្នុង ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                    agentTotal: 'ចំនួន ភ្នាក់ងារ ត្រួត ពិនិត្យ គុណភាព សរុប ដែល បាន បញ្ចូល ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                    avg: 'ពិន្ទុ មធ្យម នៃ ពិន្ទុ មើល គុណភាពName',
                    violation: 'ចំនួន ពេលវេលា នៃ ការ ត្រួត ពិនិត្យ គុណភាព ពង្រីក ប្រអប់ ទាំងអស់ បញ្ចូល ការ បំបាត់ ធាតុ ត្រួត ពិនិត្យ គុណភាព',
                    compliance: 'ចំនួន ពេលវេលា ដែល ធាតុ ការ ត្រួត ពិនិត្យ គុណភាព ត្រូវ បាន សាកល្បង កំឡុង ពេល ដំណើរការ ត្រួត ពិនិត្យ គុណភាព តាមរយៈ ប្រអប់Name',
                    check: 'ចំនួន គំរូ ដៃ សរុប',
                    appeal: 'ចំនួន សរុប របស់ សរុប ដែល បាន ដាក់ស្នើ ក្នុង ចំនួន សរុប',
                    review: 'ចំនួន ត្រួត ពិនិត្យ ដែល បាន ដាក់ស្នើ សរុប ក្នុង ចំនួន សរុប នៃ ការ ទំនាក់ទំនង',
                },
                subTips: {
                    violation: 'អត្រា ការ បំបាត់ ៖ សរុប នៃ ការ បំបាត់/ ចំនួន សរុប នៃ ធាតុ ត្រួត ពិនិត្យ គុណភាព * 100%',
                    compliance: 'អត្រា រៀបចំ ៖ ចំនួន សរុប នៃ ការ ធ្វើ តាម បំណង/ ចំនួន សរុប នៃ ធាតុ ត្រួត ពិនិត្យ គុណភាព * 100%',
                    check: 'បង្កើន គំរូ ៖ សរុប គំរូ / ត្រួតពិនិត្យ quality inspection ៖',
                    appeal: 'អត្រា សំណួរ ៖ ចំនួន សរុប នៃ ការ ត្រួត ពិនិត្យ គុណភាព * 100%',
                    review: 'អត្រា ពិនិត្យ ៖ ចំនួន សរុប នៃ ការ ពិនិត្យ/ ចំនួន សរុប នៃ ការ ត្រួត ពិនិត្យ គុណភាព * 100%',
                },
            },
            components: {
                companyBackground: {
                    index: {
                        cancel: 'បោះបង់',
                        pleaseEnterTheCompanyBusinessDescriptionUsedToImproveTheAccuracyOfLargeModelQualityInspectionItIsRecommendedToKeepWithinWords: 'សូម បញ្ចូល សេចក្ដី ពិពណ៌នា របស់ គម្រោង ដែល ត្រូវ បាន ប្រើ ដើម្បី បង្កើន ភាព ត្រឹមត្រូវ នៃ ការ ត្រួត ពិនិត្យ មើល គុណភាព ម៉ូសេ ធំ ។ វា ត្រូវ បាន ផ្ដល់ អនុសាសន៍ ឲ្យ ទុក ក្នុង 200 ពាក្យ ។',
                        save: 'រក្សាទុក',
                    },
                },
            },
        },
        admin: {
            system: {
                index: {
                    name: 'ការ កំណត់ ប្រព័ន្ធ',
                    systemName: 'ឈ្មោះ ប្រព័ន្ធ',
                    speakerRecognize: 'អត្តសញ្ញាណ កម្មវិធី និយាយComment',
                    massage: 'ការ ជូនដំណឹង សារ',
                    evaluate: 'ការ វាយតម្លៃ កម្លាំង សិទ្ធិ',
                    evaluateTip: 'បន្ទាប់ ពី បើក ជ្រើស ការ ពិនិត្យ មើល ចំណុច រហ័ស ក្នុង សេចក្ដី លម្អិត ការ ត្រួត ពិនិត្យ គុណភាព និង ការ វាយតម្លៃ ដោយ ដៃ',
                    speakerRecognizeTip: 'ដើម្បី ចូល ដំណើរការ ការ ថត ហៅ ភាគ ទីបី តាម API ។ វា ត្រូវ ការ កំណត់ ថាតើ ឆានែល ខាង ឆ្វេង ជា សេវា របស់ ភ្ញៀវ ឬ អ្នក ភ្ញៀវ ។',
                    speakerRecognizeTip2: 'ការ ថត ឆានែល តែ មួយ កំណត់ តួនាទី របស់ ភ្នាក់ងារ តាមរយៈ ការ ស្គាល់ អត្ថបទ និង ការ កំណត់ រចនា សម្ព័ន្ធ តួអក្សរ ។',
                    enabledImSendStatusFilter: 'តម្រង សារ ត្រួត ពិនិត្យ គុណភាព អត្ថបទ',
                    enabledImSendStatusFilterTips: 'ការ រក ឃើញ មាតិកា នៃ ការ និយាយ របស់ សកម្មភាព ក្នុង ការ ត្រួត ពិនិត្យ គុណភាព មិន រួម បញ្ចូល សារ នៅ ក្នុង ស្ថានភាព [Withdrawn], [Failed to ផ្ញើ d និង [មិនទាន់ អាន សារ ក្រោយ',
                    lang: 'ការ កំណត់ ភាសា ប្រព័ន្ធ',
                    zh: 'ចិន ធម្មតា',
                    en: 'English',
                    tw: 'ចិន បុរាណ',
                },
                template: {
                    maskChangeRecord: 'ថត ផ្លាស់ប្ដូរ របាំងComment',
                    singleMailQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព សំបុត្រ តែ មួយName',
                    blockSMS: 'ទប់ស្កាត់ SMS',
                    maskInternalRemarks: 'របាំង សម្គាល់ ខាង ក្នុង@ info: whatsthis',
                    workOrderQualityInspectionMessageFiltering: 'តម្រង សារ ត្រួត ពិនិត្យ គុណភាព លំដាប់ ការងារ',
                    theMaskedDataIsOnlyDisplayedButDoesNotParticipateInIntelligentQualityInspection: 'ទិន្នន័យ ដែល បាន របាំង ត្រូវ បាន បង្ហាញ តែ ប៉ុន្តែ មិន ចូលរួម ក្នុង ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ ។',
                    multimodalQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ម៉ូឌុល ច្រើន',
                    useALargeMultimodalModelToCheckThePicturesAudioAndVideoInTheSession: 'ប្រើ ម៉ូឌុល ច្រើន ដើម្បី ពិនិត្យ មើល រូបភាព អូឌីយ៉ូ និង វីដេអូ នៅ ក្នុង សម័យ ។',
                    pictureRecognition: 'ការ ទទួល ស្គាល់ រូបភាព',
                    largeModelLabelSaveFlowMode: 'របៀប រក្សា ទុក',
                    whenEnabledLargeModelMarkingIsPerformedOnlyForSmartTagsRelatedToSessionContent: 'នៅពេល ដែល បាន បើក ការ សម្គាល់ ម៉ូដែល ធំ ត្រូវ បាន អនុវត្ត តែ សម្រាប់ ស្លាក ឆ្លាត ដែល ទាក់ទង នឹង មាតិកា សម័យ',
                    largeModelQualityInspectionProvincialFlowMode: 'របៀប ត្រួត ពិនិត្យ គុណភាព គំរូ ម៉ូដែល ធំ',
                    afterEnabledLargeModelQualityInspectionIsPerformedOnlyForIntelligentModelRulesRelatedToSessionContent: 'បន្ទាប់ ពី បាន អនុញ្ញាត ការ ត្រួត ពិនិត្យ គុណភាព ម៉ូដែល ធំ ត្រូវ បាន អនុញ្ញាត តែ សម្រាប់ ក្ដារ ម៉ូដែល ទាក់ទង នឹង មាតិកា សម័យ ។',
                    cambodian: 'កាបូដូសName',
                    cantonese: 'កានតានីសName',
                    korean: 'កូរ៉េName',
                    filipino: 'ហ្វីលីនូName',
                    largeModelSettings: 'ការ កំណត់ ម៉ូដែល ធំ',
                    forcedCustomerServiceOffline: 'សេវា ម៉ាស៊ីន ភ្ញៀវ ដែល បាន បង្ខំ បណ្ដាញ',
                    afterOpeningWhenTheCustomerFailsToCompleteTheQualityTrainingTaskAccordingToTheTimeRequirementTheCustomerServiceWillBeForcedToGoOffline: 'បន្ទាប់ ពី បើក ពេល អ្នក ភ្ញៀវ បរាជ័យ ក្នុង ការ បញ្ចប់ ភារកិច្ច បង្ហាត់ គុណភាព ដោយ យោង តាម ការ ទាមទារ ពេលវេលា ។ សេវា ម៉ាស៊ីន ភ្ញៀវ នឹង ត្រូវ បាន បង្ខំ ទៅ ក្រៅ បណ្ដាញ ។',
                    indonesian: 'ហូនេស៊ីName',
                    vietnamese: 'វីដេអេអ៊ីName',
                    portuguese: 'ព័រទុយហ្គាល់Name',
                    malay: 'ម៉ាឡាយ',
                    french: 'បារាំង',
                    spanish: 'អេស្ប៉ាញ',
                    japanese: 'ជប៉ុន',
                    thai: 'ថាName',
                    blockSystemSendingMessages: 'របាំង ផ្ញើ សារ ប្រព័ន្ធ',
                    textDataDesensitization: 'ការ ធ្វើ ឲ្យ ទិន្នន័យ អត្ថបទ',
                    whenTheSwitchIsTurnedOnTheDesensitizationFieldDropdownListWillBeDisplayedmultipleChoicesAreSupportedTheDesensitizationFieldsPersonNameMobileNumberAddress: 'នៅពេល ប្ដូរ ត្រូវ បាន បើក បញ្ជី ទម្លាក់ ចុះ ក្រោម វាល បង្ហាញ (ការ ជ្រើស ច្រើន ត្រូវ បាន គាំទ្រ) ។ វាល desensitization រួមមាន ឈ្មោះ របស់ មនុស្ស លេខ ទូរស័ព្ទ ចល័ត និង អាសយដ្ឋាន ។',
                    desensitizingField: 'វាល ដែល បាន desensitized',
                    name: 'ឈ្មោះ របស់ មនុស្ស មុន',
                    cellphoneNumber: 'លេខ ទូរស័ព្ទ ចល័ត',
                    address: 'អាសយដ្ឋាន',
                    dataCleaning: 'ការ សម្អាត ទិន្នន័យ',
                    afterSettingTheConversationDataOfQCAndWeChatWillBeCleanedRegularlyAndCannotBeRecoveredPleaseBeCareful: 'បន្ទាប់ ពី ការ កំណត់ ៖ ទិន្នន័យ សម័យ ត្រួត ពិនិត្យ លក្ខណៈ សម្បត្តិ និង បញ្ហា ទិន្នន័យ សម័យ WeChat នឹង ត្រូវ បាន ជម្រះ ធម្មតា ហើយ មិន អាច ទទួល បាន ឡើង វិញ ។ សូម ប្រតិបត្តិការ ។',
                    newCleaningRules: 'ច្បាប់ សម្អាត ថ្មី',
                    qualityInspectionRuleApproval: 'ការ អនុញ្ញាត ច្បាប់ ត្រួត ពិនិត្យ គុណភាព',
                    afterOpeningTheModificationOfQualityInspectionRulesCanTakeEffectOnlyAfterBeingApproved: 'បន្ទាប់ ពី បើក ការ កែប្រែ ច្បាប់ ត្រួត ពិនិត្យ គុណភាព ត្រូវ តែ ត្រូវ បាន អនុញ្ញាត មុន ពេល វា ទទួល ប្រយោជន៍ ។',
                    maskOfflineMessageUnread: 'របាំង សារ ក្រៅ បណ្ដាញ មិនទាន់ អាន',
                    privacyNumberProtection: 'ការពារ លេខ ឯកជន',
                    afterOpeningDesensitizeThecustomerPhoneFieldInTheCallWhichIsDisplayedAs1881: 'បន្ទាប់ ពី បើក ធ្វើ ឲ្យ វាល "ទូរស័ព្ទ កម្មវិធី" កំឡុង ពេល ហៅ និង បង្ហាញ វា ជា 1881 * * * * * * * * * *',
                    shieldingWithdrawn: 'របាំង ត្រូវ បាន បដិសេធ',
                    maskSendingFailed: 'ការ ផ្ញើ របាំង បាន បរាជ័យ',
                },
                component: {
                    conversation: 'ហៅ',
                    dialogue: 'ប្រអប់Comment',
                    weCom: 'បណ្ដាញ ជម្រះ',
                    day: 'ថ្ងៃStencils',
                    week: 'សប្ដាហ៍',
                    month: 'ខែ',
                    year: 'ឆ្នាំComment',
                },
                components: {
                    dataDeleteConfigItem: {
                        scopeOfCleaning: 'កម្រិត សម្អាត',
                        dataCleaningTimeSetting: 'ការ កំណត់ ពេលវេលា ជម្រះ ទិន្នន័យ',
                        afterCleanUpTheData: 'បន្ទាប់ ពី ជម្រះ ទិន្នន័យ',
                        dataAfterComplaintCompletion: 'ទិន្នន័យ បន្ទាប់',
                    },
                },
                coachSpeechRecognition: {
                    executionSuccessful: 'ការ ប្រតិបត្តិ ដោយ ជោគជ័យ',
                    saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                    speechRecognition: 'ការ ទទួល ស្គាល់ និយាយComment',
                    reExecuteErrorCorrection: 'កែប្រែ កំហុស ឡើង វិញ',
                    confirmExecution: 'អះអាង ការ ប្រតិបត្តិ',
                    voiceDetection: 'រកឃើញ សំឡេង',
                    noiseDetectionPowerLevel: 'ការ រក ឃើញ ថាមពល រន្ធLevel ≤',
                    pleaseEnterTheThreshold: 'សូម បញ្ចូល កម្រិត ពន្លឺ',
                    volumeDetectionPowerLevel: 'ការ រក ឃើញ ថាមពល កម្រិត សំឡេងLevel ≥',
                    reset: 'កំណត់ ឡើង វិញ',
                    preserve: 'រក្សាទុក',
                },
                coachTemplate: {
                    french: 'បារាំង',
                    spanish: 'អេស្ប៉ាញ',
                    japanese: 'ជប៉ុន',
                    thai: 'ថាName',
                    loginPopupWindow: 'បង្អួច លេចឡើង ចូលName',
                    afterActivationAPopupPromptWillAppearWhenEnteringTheIntelligentAccompanimentSystem: 'បន្ទាប់ ពី បើក បង្អួច លេច ឡើង នឹង ត្រូវ បាន សួរ នៅពេល បញ្ចូល ប្រព័ន្ធ សរសេរ ។',
                    title: 'ចំណង ជើង',
                    text: 'អត្ថបទ',
                    checkBoxContent: 'មាតិកា ប្រអប់ ធីក',
                    informedConsentForm: 'សំណុំ បែបបទ ដែល មាន សុវត្ថិភាព',
                    toHelpYouImproveYourCommunicationAndCommunicationSkillsAsWellAsTheApplicationOfProfessionalKnowledgeAllowingYouToPracticeAnytimeAnywhereAndReceiveRealtimeFeedbackWeWillCollectTheFollowingInformationFromYouThroughThisPlatform: 'ដើម្បី ជួយ អ្នក ឲ្យ បង្កើន ការ ទំនាក់ទំនង និង សមត្ថភាព និយាយ របស់ អ្នក និង អនុវត្ត នៃ ចំណង មិត្តភិវឌ្ឍន៍ ។ ដោយ អនុញ្ញាត ឲ្យ អ្នក អនុវត្ត ពេលវេលា ណាមួយ និង កន្លែង ណាមួយ ហើយ ទទួល កម្រិត ព័ត៌មាន អំពី ពេលវេលា ពិត យើង នឹង ប្រមូល ព័ត៌មាន ខាងក្រោម ពី អ្នក តាម រយៈ វេទិកា នេះ ៖',
                    iHaveFullyReadAndFullyUnderstoodThisInformedConsentFormAndSolemnlyDeclareThatIAgreeToProcessMySensitivePersonalInformationInAccordanceWithThePurposesAndMethodsStatedInThisInformedConsentForm: 'ខ្ញុំ បាន អាន និង យល់ ពាក្យ សំណួរ នេះ ពេញលេញលេញ និង សមត្ថភាព វិនិច្ឆ័យ ឲ្យ ដោះស្រាយ ព័ត៌មាន ផ្ទាល់ ខ្លួន របស់ ខ្ញុំ ដោយ យោង តាម វិនិច្ឆ័យ ។ គោល បំណង និង វិធី ដែល បាន ផ្ដល់ នៅ ក្នុង សំណុំ បែបបទ នេះ',
                },
                webPlugin: {
                    webPlugin: 'កម្មវិធី ជំនួយ បណ្ដាញ',
                    generateLink: 'បង្កើត តំណ',
                    link: 'តំណ',
                    pleaseEnterALink: 'សូម បញ្ចូល តំណ',
                },
            },
            systemIntegration: {
                title: 'ការ កំណត់ ប្រព័ន្ធ',
                ccIntegrationTips: 'ឯកសារ សេចក្ដី ពិពណ៌នា មជ្ឈមណ្ឌល ភាព ត្រួត ពិន្ទុ',
                unauthorized: 'មិន បាន អនុញ្ញាត',
                authorized: 'បាន អនុញ្ញាត',
                udeskDomain: 'ឈ្មោះ ដែន ប្រព័ន្ធ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                udeskToken: 'គ្រាប់ ចុច ប្រព័ន្ធ ភ្នែកComment',
                udeskAdminEmail: 'គណនី កម្មវិធី គ្រប់គ្រង ប្រព័ន្ធ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                password: 'ពាក្យ សម្ងាត់ គណនី របស់ អ្នក គ្រប់គ្រងComment',
                applyAuth: 'ការ អនុញ្ញាត',
                cancelAuth: 'បោះបង់ ការ អនុញ្ញាត',
                reApplyAuth: 'ការ អនុញ្ញាត ឡើង វិញ',
                keyTips: 'គ្រប់គ្រង ផ្ទៃ ខាងក្រោយ របស់ ប្រព័ន្ធ សេវា ម៉ាស៊ីន ភ្ញៀវ - API ក្នុង សញ្ញា តែ មួយName',
            },
            customerField: {
                title: 'វាល ម៉ាស៊ីន ភ្ញៀវ',
                table: {
                    propName: 'ឈ្មោះ វាល',
                    propDesc: 'សេចក្ដី ពិពណ៌នា វាល',
                    valueType: 'ប្រភេទ វាល',
                    propType: 'វិធីសាស្ត្រ បង្កើតComment',
                    createTime: 'ពេលវេលា បង្កើតComment',
                    canNotEdit: 'វាល ប្រព័ន្ធ មិន គាំទ្រ ការ កែសម្រួល',
                },
                edit: 'កែសម្រួល វាល',
                new: 'វាល ថ្មី',
            },
            wechatDocking: {
                title: 'ការ ហោច មីក្រូ សិទ្ធិ',
                formLabels: {
                    companyId: 'លេខ សម្គាល់ សំណួរ',
                    communicationKey: 'គ្រាប់ ចុច ទំនាក់ទំនង',
                    token: 'Token',
                    encodingAESKey: 'EncodingAESKey',
                    url: 'URL ហៅ ថយក្រោយ ព្រឹត្តិការណ៍Name',
                    applicationName: 'ឈ្មោះ កម្មវិធី',
                    applicationId: 'លេខ សម្គាល់ កម្មវិធី បណ្ដាញ',
                    applicationSecret: 'កម្មវិធី សម្ងាត់',
                },
                formTitle: {
                    initialForm: 'ការ រៀបចំ ចាប់ផ្ដើម',
                    synchronizeForm: 'ការ ធ្វើ សមកាលកម្ម សៀវភៅ អាសយដ្ឋាន',
                    settingForm: 'ការ កំណត់ កម្មវិធី',
                },
                qrCodeUrlTip: 'សូម សួរ អ្នក គ្រប់គ្រង ដើម្បី វិភាគ កូដ ទំហំ ពីរ ខាងក្រោម ដើម្បី ចង កម្មវិធី អភិវឌ្ឍន៍ ។',
            },
            taobao: {
                formLabels: {
                    name: 'ទុក ឈ្មោះ@ info: whatsthis',
                    account: 'លេខ គណនី',
                    password: 'ពាក្យ សម្ងាត់',
                    confirm: 'អះអាង ពាក្យ សម្ងាត់',
                    authorization: 'ការ អនុញ្ញាត',
                    switchOn: 'បើក',
                    switchOff: 'បិទ',
                },
                tableLabels: {
                    name: 'ទុក ឈ្មោះ@ info: whatsthis',
                    account: 'លេខ គណនី',
                    authorization: 'ការ អនុញ្ញាត',
                    updateUser: 'អ្នក ដែល បាន ធ្វើ ឲ្យ ទាន់សម័យ ថ្មីៗ',
                    updateTime: 'ពេលវេលា ធ្វើ ឲ្យ ទាន់សម័យ ចុងក្រោយ',
                },
            },
            weifengDocking: {
                formLabels: {
                    secondaryDomain: 'ឈ្មោះ ដែន ទីពីរ របស់ Weifeng',
                    secretKeyTip: 'កូនសោ សម្ងាត់ ត្រូវ បាន ទទួល នៅ ទីតាំង ចត នៃ ប្រព័ន្ធ ផ្ទៃ ខាងក្រោយ របស់ Weifeng ។',
                },
            },
            user: {
                index: {
                    name: 'គ្រប់គ្រង ភ្ញៀវ',
                    existingUsers: 'មាន ភារកិច្ច រួច ហើយ ។',
                    deleteSuccess: 'បាន លុប ដោយ ជោគជ័យ',
                    deleteFailed: 'បរាជ័យ លុប',
                },
                detail: {
                    accountPrompt: 'សូម បញ្ចូល អ៊ីមែល',
                    resetPassword: 'កំណត់ ពាក្យ សម្ងាត់ ឡើង វិញ',
                    passwordPrompt: 'ពាក្យ សម្ងាត់ (6-14 បន្សំ តួអក្សរ និង លេខ)',
                    originPasswordPrompt: 'សូម បញ្ចូល ពាក្យ សម្ងាត់ ចាប់ផ្ដើម',
                    resumePasswordPrompt: 'សូម បញ្ចូល ពាក្យ សម្ងាត់ របស់ អ្នក',
                    passwordFormWrong: 'សូម បញ្ចូល បន្សំ តួអក្សរ និង លេខ ៦- ១៤ !',
                    resumePasswordWrong: 'ពាក្យ សម្ងាត់ ពីរ មិន ត្រឹមត្រូវ !',
                    suppertImageType: 'គាំទ្រ jpg, gif, png អតិបរមា 500Kb',
                    namePrompt: 'សូម បញ្ចូល ឈ្មោះ មួយ',
                    nickNamePrompt: 'សូម បញ្ចូល សម្ងាត់ ឈ្មោះ ។',
                    telephonePrompt: 'សូម បញ្ចូល លេខ ទូរស័ព្ទ',
                    roleSelectedPrompt: 'សូម ជ្រើស តំណ',
                    agentIdPrompt: 'សូម បញ្ចូល លេខ ការងារ',
                    disabled: 'បិទ',
                    enabled: 'អនុញ្ញាត',
                    reloadBowerInfo: 'ផ្លាស់ប្ដូរ ព័ត៌មាន អ្នក ប្រើ ត្រូវ ធ្វើ ឲ្យ កម្មវិធី រុករក ស្រស់ ?',
                    saveUserError: 'បាន បរាជ័យ ក្នុង ការ រក្សាទុក ព័ត៌មាន អ្នក ប្រើ សូម ព្យាយាម ម្ដង ទៀត ក្រោយ ឡើយ',
                    resetPasswordSuccess: 'កំណត់ ពាក្យ សម្ងាត់ ឡើង វិញ ដែល បាន ជោគជ័យ',
                    resetPasswordFailed: 'បាន បរាជ័យ ក្នុង ការ កំណត់ ពាក្យ សម្ងាត់ ឡើងវិញ សូម ព្យាយាម ម្ដង ទៀត ពេល ក្រោយ',
                },
            },
            userGroups: {
                index: {
                    name: 'ការ គ្រប់គ្រង ក្រុម អ្នកប្រើ',
                    existingUserGroups: 'ក្រុម អ្នក ប្រើ ដែល មាន ស្រាប់',
                },
            },
            role: {
                index: {
                    name: 'គ្រប់គ្រង រលូន',
                    existingRoles: 'មូលដ្ឋាន ដែល មាន ស្រាប់',
                },
                edit: {
                    editRole: 'កែសម្រួល រលា',
                    createRole: 'បង្កើត រលក',
                    basicInfo: 'ព័ត៌មាន មូលដ្ឋាន',
                    taskPermissions: 'សិទ្ធិ ភារកិច្ច',
                    existingTasks: 'ភារកិច្ច រួច ហើយ',
                },
            },
            anomalousData: {
                title: 'ទិន្នន័យ',
                list: {
                    selectHolder: 'សូម ជ្រើស ប្រភព ទិន្នន័យ',
                    businessTime: 'ពេលវេលា បណ្ដាញ',
                    businessId: 'លេខ សម្គាល់ ពាក្យ',
                    export: 'នាំចេញ',
                },
            },
            templateComponent: {
                list: {
                    title: 'សៀវភៅ ពុម្ព',
                    name: 'ឈ្មោះ ពុម្ព',
                    searchHolder: 'សូម បញ្ចូល មាតិកា ដើម្បី សួរ',
                    update: 'ធ្វើ ឲ្យ ទាន់ សម័យ',
                    sort: 'តម្រង',
                    moduleType: 'ប្រភេទ ពុម្ព',
                    moduleSourceType: 'ប្រភេទ ដែល អាច លុប',
                    fetchNum: 'ចំនួន ពេលវេលា ដែល បាន ទទួល',
                    newest: 'បាន ធ្វើ ឲ្យ ទាន់សម័យ ថ្មីៗ',
                    usedMost: 'យក ច្រើន ជាង',
                    call: 'ហៅ',
                    dialogue: 'ប្រអប់Comment',
                    waiting: 'ត្រូវ បាន ពិនិត្យ មួយ',
                    cancel: 'មិន បោះពុម្ព',
                    success: 'បាន អនុញ្ញាត និង បាន បោះពុម្ព',
                    failed: 'ការ បដិសេធ ត្រួត ពិន្ទុ',
                    no: 'មិន អាច ធ្វើ ឲ្យ ប្រសើរ បាន ឡើយ',
                    ok: 'ប្រសើរ ប្រសើរ',
                    all: 'ទាំង អស់',
                    delete: 'បាន លុប ដោយ ជោគជ័យ',
                    downOk: 'បាន យក ចេញ ដោយ ជោគជ័យ',
                    withdraw: 'ការ បោះបង់ បាន ជោគជ័យ',
                    updateOk: 'ធ្វើ ឲ្យ ប្រសើរ ជោគជ័យ',
                    get: 'យក@ info: whatsthis',
                    width: 'បោះបង់',
                    getOk: 'ជោគជ័យ',
                    orgName: 'រៀបចំComment',
                    nowVersion: 'កំណែ បច្ចុប្បន្ន',
                    lastedVersion: 'កំណែ ចុងក្រោយ',
                    appStatus: 'ស្ថានភាព កម្មវិធី',
                    actions: 'ប្រតិបត្តិការ',
                    down: 'ក្រៅ សែល',
                    updateTop: 'ធ្វើ ឲ្យ ប្រសើរ',
                    check: 'ទិដ្ឋភាព',
                    deleteWhen: 'អះអាង ការ លុប ?',
                    yes: 'បាន',
                    noo: 'គ្មាន ទេ',
                    deleteOk: 'លុប',
                    permissible: 'បាន អនុញ្ញាត',
                    noPermissible: 'មិន អនុញ្ញាត',
                    openUp: 'បើក',
                    openDown: 'មិន បើក',
                    task: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
                    point: 'ចំណុច ត្រួត ពិនិត្យ គុណភាព',
                    tag: 'ស្លាក semantic',
                    muti: 'ធាតុ ច្រើន',
                    inter: 'សំណួរ មួយ និង ចម្លើយ មួយ',
                    info: 'ធាតុ ព័ត៌មាន',
                    concept: 'ពាក្យ ទំនាក់ទំនង',
                    detail: 'សេចក្ដី លម្អិត ម៉ូឌុល',
                    infomation: 'ព័ត៌មាន មូលដ្ឋាន',
                    detailConfig: 'ការ កំណត់ រចនាសម្ព័ន្ធ លម្អិត',
                    twoEdit: 'កែសម្រួល រង',
                    mustUpdate: 'ធ្វើ ឲ្យ ប្រសើរ',
                    descition: 'សេចក្ដី ពិពណ៌នា ពុម្ព',
                    descitionSize: 'ពិពណ៌នា ពុម្ព មិន អាច លើក ឡើង លើ ២០០ ពាក្យ',
                    stencilsDetail: 'សេចក្ដី លម្អិត ពុម្ព',
                    updatedRecords: 'ធ្វើ ឲ្យ ថត ទាន់ សម័យ',
                    version: 'លេខ កំណែ',
                    updateDescription: 'ការ ពិពណ៌នា ធ្វើ ឲ្យ ទាន់ សម័យ',
                    myModule: 'ពុម្ព របស់ ខ្ញុំ',
                    addModule: 'ម៉ូឌុល ថ្មី',
                    publishVersion: 'បញ្ចេញ កំណែ',
                    earliestVersion: 'កំណែ មុន',
                    edit: 'កែសម្រួល',
                    add: 'ថ្មី',
                    configNo: 'សេចក្ដី លម្អិត ការ កំណត់ រចនា សម្ព័ន្ធ ម៉ូឌុល មិន អាច ទទេ',
                    updateNo: 'ការ ពិពណ៌នា ទាន់សម័យ មិន អាច ទទេ',
                    editSuccess: 'ការ កែប្រែ បាន ជោគជ័យ',
                    saveSuccess: 'រក្សាទុក ដោយ ជោគជ័យ',
                    newer: 'ធ្វើ ឲ្យ ទាន់ សម័យ',
                    sumbit: 'ដាក់ ស្នើ',
                    cancelName: 'បោះបង់',
                    nameRequired: 'ឈ្មោះ ម៉ូឌុល គឺ ជា វាល ដែល ទាមទារ',
                    nameSize: 'ឈ្មោះ ម៉ូឌុល មិនអាច លើស ពី ១៦ តួអក្សរ បានទេ',
                    publishStatus: 'ស្ថានភាព បោះពុម្ព',
                    submitUpdate: 'ដាក់ ទាន់ សម័យ',
                    updateVersion: 'ធ្វើ ឲ្យ កំណែ ទាន់ សម័យ',
                    updateExplain: 'ការ ពិពណ៌នា ធ្វើ ឲ្យ ទាន់ សម័យ',
                },
            },
            customDataSource: {
                amazonEcommerce: 'អ៊ីមែល អ៊ីមែល',
                youtubeVideo: 'វីដេអូធូប',
                amazon: {
                    component: {
                        queuing: 'ក្នុង បន្ទាត់',
                        notStarted: 'មិន បាន ចាប់ផ្ដើម',
                        inProgress: 'កំពុង វឌ្ឍន៍',
                        success: 'ជោគជ័យ',
                        failed: 'បាន បរាជ័យ',
                        successfullyCreated: 'បាន បង្កើត ដោយ ជោគជ័យ',
                        editedSuccessfully: 'បាន កែសម្រួល ដោយ ជោគជ័យ',
                        operationSucceeded: 'ប្រតិបត្តិការ បាន ជោគជ័យ',
                        deletedSuccessfully: 'បាន លុប ដោយ ជោគជ័យ',
                        link: 'តំណ',
                        grabState: 'ចាប់ផ្តើម ស្ថានភាព',
                        updateTime: 'ពេលវេលា ទាន់ សម័យ',
                        grab: 'ចាប់ផ្តើម',
                        edit: 'កែសម្រួល',
                    },
                    template: {
                        amazonEcommerce: 'អ៊ីមែល អ៊ីមែល',
                        thisProduct: 'ផលិត នេះ',
                        competition: 'ការ បញ្ហា',
                        new: 'ថ្មី',
                        edit: 'កែសម្រួល',
                        link: 'តំណ',
                    },
                },
                youtube: {
                    template: {
                        youtubeVideo: 'វីដេអូធូប',
                        thisProduct: 'ផលិត នេះ',
                        competition: 'ការ បញ្ហា',
                        new: 'ថ្មី',
                        edit: 'កែសម្រួល',
                        link: 'តំណ',
                    },
                    component: {
                        queuing: 'ក្នុង បន្ទាត់',
                        notStarted: 'មិន បាន ចាប់ផ្ដើម',
                        inProgress: 'កំពុង វឌ្ឍន៍',
                        success: 'ជោគជ័យ',
                        failed: 'បាន បរាជ័យ',
                        successfullyCreated: 'បាន បង្កើត ដោយ ជោគជ័យ',
                        editedSuccessfully: 'បាន កែសម្រួល ដោយ ជោគជ័យ',
                        operationSucceeded: 'ប្រតិបត្តិការ បាន ជោគជ័យ',
                        deletedSuccessfully: 'បាន លុប ដោយ ជោគជ័យ',
                        youTubeVideoLink: 'តំណ YouTube',
                        grabState: 'ចាប់ផ្តើម ស្ថានភាព',
                        updateTime: 'ពេលវេលា ទាន់ សម័យ',
                        grab: 'ចាប់ផ្តើម',
                        edit: 'កែសម្រួល',
                    },
                },
            },
        },
        demo: {
            title: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
            template: 'ជ្រើស ពុម្ព ត្រួត ពិនិត្យ គុណភាព',
            radio: 'ជ្រើស សំណុំ ថត',
            uploadAudio: 'ផ្ទុក ថត',
            uploadAudioTip: 'ការ ថត ដែល បាន ផ្ទុក ឡើង គាំទ្រ តែ ទ្រង់ទ្រាយ wav និង mp3 ហើយ ទំហំ មិន លើក ឡើង ១G',
            uploadText: 'ផ្ទុក អត្ថបទ ឡើង លើ',
            uploadTextTip: 'អត្ថបទ ដែល បាន ផ្ទុក ឡើង គាំទ្រ តែ ទ្រង់ទ្រាយ srt និង txt ហើយ ទំហំ មិន មែន ជា ១០M ។ បន្ទាប់ ពី ផ្ទុក ឡើង អត្ថបទ ASR នឹង មិន ត្រូវ បាន ប្រើ ទៀត ដើម្បី ញែក ឯកសារ ថត ។',
            uploadSuccess: 'បាន ផ្ទុក ឯកសារ ថត ឡើង ដោយ ជោគជ័យ',
            uploadFailed: 'បាន បរាជ័យ ក្នុង ការ ផ្ទុក ឯកសារ ថត',
            startQualityInspection: 'ចាប់ផ្ដើម ការ ត្រួត ពិនិត្យ គុណភាព',
            qualityInspectionStarted: 'ការ ត្រួត ពិនិត្យ គុណភាព កំពុង ដំណើរការ',
            downloadText: 'ទាញយក អត្ថបទ',
            checking: 'វឌ្ឍនភាព ត្រួតពិនិត្យ គុណភាព',
            checkingTip: 'បាន រំពឹង ទុក ឲ្យ រត់ នាទី មួយ ចំនួន សូម ជោគជ័យ ។',
            noCheckContent: 'លទ្ធផល ត្រួត ពិនិត្យ គុណភាព ឡើយ',
            noTextDownload: 'គ្មាន អត្ថបទ ត្រួតពិនិត្យ គុណភាព មិន អាច ត្រូវ បាន ទាញ យក ។',
            pleaseCheckParams: 'សូម ពិនិត្យ មើល ថាតើ ត្រូវ ជ្រើស ពុម្ព ប្រភេទ សំឡេង និង ផ្ទុក ឡើង ឯកសារ ថត',
            inspectionFailed: 'បាន បរាជ័យ ក្នុង ការ ត្រួត ពិនិត្យ គុណភាព សូម ព្យាយាម ម្ដង ទៀត ។',
        },
        wechatQa: {
            baseInfo: {
                title: 'ព័ត៌មាន មូលដ្ឋាន',
            },
            conversationSetting: {
                title: 'ការ កំណត់ សម័យ',
                segmentationStrategy: 'យុទ្ធសាស្ត្រ',
                rule: 'យុទ្ធសាស្ត្រ',
                time: 'ពេលវេលា កាត់',
                daily: 'រាល់ ថ្ងៃ@ info: whatsthis',
                passScore: 'ពិន្ទុ សម័យ',
                ruleLogic: 'តក្ក ប្រតិបត្តិ@ info: whatsthis',
            },
            message: {
                title: 'ចុច ព្រឹត្តិការណ៍',
                table: {
                    index: 'លេខ សៀរៀល',
                    name: 'ឈ្មោះ:',
                    type: 'ចុច របៀបComment',
                    desc: 'សេចក្ដី ពិពណ៌នា',
                    status: 'ស្ថានភាព',
                },
                subTitle: 'បញ្ជី ព្រឹត្តិការណ៍',
            },
            checkPoint: {
                title: 'ម៉ូដែល វិភាគ រក',
                groups: 'ក្រុម ម៉ូឌុល',
                newClassification: 'ក្រុម ថ្មី',
                editClassification: 'កែសម្រួល ការ ដាក់ ក្រុមComment',
                benchmarkScore: 'ពិន្ទុ ចំណុច',
                pointCount: 'ម៉ូដែល វិភាគ ទូទៅ នៅ ក្រោម ទិដ្ឋភាព បច្ចុប្បន្ន',
                openPointCount: 'ចំនួន អនុញ្ញាត',
                closedPointCount: 'ចំនួន ដែល បាន អសកម្ម គឺ ជា សំណើ',
                scoreLowerLimit: 'ដែន កំណត់ ពិន្ទុ អប្បបរមា',
                scoreUpperLimit: 'ចំណុច ពិន្ទុ អតិបរមា',
                classificationName: 'ឈ្មោះ ក្រុម',
                classificationNamePlaceHolder: 'សូម បញ្ចូល ឈ្មោះ ក្រុម',
                classificationRemark: 'សេចក្ដី ពិពណ៌នា ក្រុម',
                classificationRemarkPlaceHolder: 'សូម បញ្ចូល សេចក្ដី ពិពណ៌នា ក្រុម',
            },
            chartRecord: {
                title: 'សម័យ WeChat Enterprise',
                table: {
                    id: 'លេខ សម្គាល់ សម័យ',
                    type: 'ប្រភេទ សម័យ',
                    startTime: 'ពេលវេលា ចាប់ផ្ដើម សម័យ',
                    endTime: 'សម័យ ពេលវេលា បញ្ចប់ ចុងក្រោយ',
                    groupId: 'លេខ សម្គាល់ ក្រុម',
                    client: 'ម៉ាស៊ីន ភ្ញៀវ',
                    customer: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    averageScore: 'ពិន្ទុ មើល គុណភាព មធ្យម',
                },
                detail: {
                    title: 'សេចក្ដី លម្អិត សម័យ បណ្ដាញ',
                    inspectionInfo: 'ព័ត៌មាន វិភាគរក',
                    chartInfo: 'ព័ត៌មាន សម័យ',
                    tasks: 'ភារកិច្ច វិភាគរក',
                    avgScore: 'ពិន្ទុ វិភាគ មធ្យម',
                    qualified: 'បាន បញ្ចប់',
                    unqualified: 'មិន បាន ត្រឹមត្រូវ',
                    taskTitle: 'ពុម្ព វិភាគ ដែល អាច អនុវត្ត បានName',
                    info: 'ការ វិភាគ ពេលវេលា ពិត នៃ ព័ត៌មាន',
                    today: 'ព័ត៌មាន របស់ ថ្ងៃ នេះName',
                    history: 'សារ ប្រវត្តិ',
                    components: {
                        filter: {
                            index: {
                                pleaseEnterACommentNickname: 'សូម បញ្ចូល មតិយោបល់/ឈ្មោះ សំឡេង',
                                pleaseEnterTheGroupChatName: 'សូម បញ្ចូល ឈ្មោះ ជជែក ក្រុម',
                            },
                        },
                    },
                    template: {
                        whole: 'ទាំង អស់',
                    },
                },
            },
            realTimeAnalysis: {
                title: 'ការ វិភាគ ពេលវេលា ពិសេស',
                table: {
                    name: 'ឈ្មោះ រូបភាព',
                    count: 'ចំនួន ម៉ូដែល វិភាគ រយ',
                    baseScore: 'ពិន្ទុ ចំណុច',
                    passScore: 'ពិន្ទុ ដែល បាន បញ្ចប់',
                    maxScore: 'ចំណុច ពិន្ទុ អតិបរមា',
                    minScore: 'ដែន កំណត់ ពិន្ទុ អប្បបរមា',
                    status: 'ស្ថានភាព',
                    actions: 'ប្រតិបត្តិការ',
                },
                detail: {
                    title: 'ការ វិភាគ ពេលវេលា ពិត នៃ វិធីសាស្ត្រ',
                    form: {
                        name: 'ឈ្មោះ រូបភាព',
                        prevCondition: 'លក្ខខណ្ឌ បិទ វិសារ',
                        prevConditionToolTip: 'ប្រសិន បើ លក្ខខណ្ឌ ទទេ វិភាគ រក តាម លំនាំដើម',
                        prevConditionError: 'លក្ខខណ្ឌ កេះ វិភាគរយ មិន អាច ផ្គូផ្គង ជាមួយ ម៉ូដែល វិភាគ បាន ឡើយ',
                        scoreInputPlaceholder: 'បញ្ចូល ពិន្ទុ',
                        baseScore: 'ពិន្ទុ ចំណុច',
                        status: 'ស្ថានភាព',
                        passScore: 'ពិន្ទុ ដែល បាន បញ្ចប់',
                        maxScore: 'ដែន កំណត់ ពិន្ទុ អតិបរមា',
                        minScore: 'ដែន កំណត់ ពិន្ទុ អប្បបរមា',
                        analysisModel: 'ម៉ូដែល វិភាគ រក',
                        message: 'ការ បិទ ការ ជូន ដំណឹង',
                        pushType: 'ចុច របៀបComment',
                        createAnalysisModel: 'បន្ថែម ម៉ូឌុល',
                        scoreUpperLimitError: 'ដែន កំណត់ ទាប នៃ ពិន្ទុ អប្បបរមា មិន អាច ធំ ជាង ដែន កំណត់ ខាង លើ នៃ ពិន្ទុ អតិបរមា ។',
                        table: {
                            name: 'ឈ្មោះ ម៉ូល',
                            rule: 'បន្ទាត់',
                            score: 'ពិន្ទុ',
                        },
                        pushConfigSwitchTip1: 'នៅពេល បង្ហាញ រូបភាព',
                        pushConfigSwitchTip2: 'ពេលវេលា និង ខាង លើ ចុច ការ ជូនដំណឹង',
                    },
                },
            },
            smartCustomerTag: {
                title: 'ប្លង់ ចិត្ត',
                table: {
                    name: 'ឈ្មោះ បន្ទាត់',
                    tags: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
                    status: 'បាន អនុញ្ញាត ស្ថានភាព',
                    createUser: 'អ្នក បង្កើតComment',
                    createTime: 'ពេលវេលា បង្កើតComment',
                },
                detail: {
                    name: 'ឈ្មោះ បន្ទាត់',
                    condition: 'កំណត់ ក្បៀន',
                    logic: 'តក្ក',
                    status: 'បាន អនុញ្ញាត ស្ថានភាព',
                    tags: 'ជ្រើស ស្លាក',
                },
            },
            setting: {
                wechatQaCustomerLabel: {
                    template: {
                        numberOfCustomerTags: 'ចំនួន ដែល បាន សម្គាល់ ម៉ាស៊ីន ភ្ញៀវ',
                    },
                },
                messageFiltering: {
                    template: {
                        edit: 'កែសម្រួល',
                        messageContent: 'មាតិកា សារ',
                        messageTypeID: 'លេខ សម្គាល់ ប្រភេទ សារ',
                        messageTypeDescription: 'សេចក្ដី ពិពណ៌នា ប្រភេទ សារ',
                        messageFiltering: 'តម្រង សារ',
                        suitableForFilteringDataWithoutQualityInspection: 'មាន សមរម្យ សម្រាប់ ត្រង ទិន្នន័យ ដោយ មិន ត្រួត ពិនិត្យ គុណភាព',
                        create: 'បង្កើត@ info: whatsthis',
                        messageDescription: 'សេចក្ដី ពិពណ៌នា សារ',
                    },
                },
            },
            chartAudioRecord: {
                index: {
                    talkTime: 'ពេលវេលា និយាយComment',
                    sessionType: 'ប្រភេទ សម័យ',
                    whole: 'ទាំង អស់',
                    staff: 'ការងារ',
                    customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                    callKeywords: 'គ្រាប់ ចុច ហៅ ពាក្យ',
                },
                detail: {
                    template: {
                        enterpriseMicroVoiceCallDetails: 'សេចក្ដី លម្អិត ហៅ ការ ហៅ កម្រិត សំឡេង',
                    },
                },
            },
            wechatQaChartRecordEntry: {
                sessionArchiving: 'ប័ណ្ណសារ សម័យ',
                voiceCall: 'ហៅ សំឡេង',
                noMoreVoiceCalls: 'គ្មាន ការ ហៅ សំឡេង ទៀត ទេ',
                enterpriseWechatVoiceCall: 'ការ ហៅ សំឡេង WeChat',
                enterpriseWechatConversationDetails: 'សេចក្ដី លម្អិត សម័យ បណ្ដាញ',
                previous: 'អត្ថបទ មុន',
                next: 'អត្ថបទ បន្ទាប់',
            },
            dashboard: {
                template: {
                    enterpriseMicroConversationAnalysisTask: 'ភារកិច្ច ការ វិភាគ micro-sesion Enterprise',
                    enterpriseAndMicroVoiceAnalysisTask: 'ភារកិច្ច ការ វិភាគ សំឡេង របស់ Micro Enterprise',
                },
            },
            wechatQaTaskManagerEntry: {
                analysisOfEnterpriseWeChatGroupChat: 'វិភាគ នៃ ជជែក ក្រុម WeChat Enterprise',
            },
            wechatQaSettingEntry: {
                messageFiltering: 'តម្រង សារ',
            },
        },
        businessAnalysis: {
            keyword: 'ឈ្មោះ របាយការណ៍Name',
            createUser: 'អ្នក បង្កើតComment',
            createTime: 'ពេលវេលា បង្កើតComment',
            updateTime: 'ពេលវេលា ទាន់ សម័យ',
        },
        semanticIntelligence: {
            agent: 'ភាគ',
            externalInterface: {
                detail: {
                    components: {
                        interfaceTest: {
                            index: {
                                testInterface: 'សាកល្បង ចំណុច ប្រទាក់',
                                testPassed: 'បាន សាកល្បង',
                                testNotPassed: 'ការ សាកល្បង មិន ត្រឹមត្រូវ',
                                request: 'សំណើ',
                                resultReturnedAfterParsing: 'លទ្ធផល បាន ត្រឡប់ បន្ទាប់ ពី ញែក',
                                collapseAPIInteraction: 'វេញ អភិវឌ្ឍន៍ API',
                                viewAPIInteractions: 'មើល អភិវឌ្ឍន៍ API',
                            },
                        },
                        paramsList: {
                            components: {
                                valuePlain: {
                                    index: {
                                        pleaseEnterAPathExpression: 'សូម បញ្ចូល កន្សោម ផ្លូវ មួយ',
                                    },
                                },
                                valueSpecial1: {
                                    components: {
                                        randomFieldSelectList: {
                                            index: {
                                                pleaseSelect: 'សូម ជ្រើស',
                                                followthepathField: 'វាល ផ្លូវ តាម បន្ទាត់',
                                            },
                                        },
                                    },
                                    index: {
                                        informationEntity: 'ធាតុ ព័ត៌មាន',
                                        followthepathField: 'វាល ផ្លូវ តាម បន្ទាត់',
                                    },
                                },
                            },
                            index: {
                                pleaseEnterAParameterName: 'សូម បញ្ចូល ឈ្មោះ ប៉ារ៉ាម៉ែត្រ មួយ',
                                addInterfaceParameters: 'បន្ថែម ប៉ារ៉ាម៉ែត្រ ចំណុច ប្រទាក់',
                            },
                        },
                    },
                    index: {
                        testNotPassed: 'ការ សាកល្បង មិន ត្រឹមត្រូវ',
                        saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                        interfaceName: 'ឈ្មោះ ចំណុច ប្រទាក់',
                        pleaseEnterInterfaceName: 'សូម បញ្ចូល ឈ្មោះ ចំណុច ប្រទាក់',
                        interfaceDescription: 'សេចក្ដី ពិពណ៌នា ចំណុច ប្រទាក់',
                        pleaseEnterInterfaceDescription: 'សូម បញ្ចូល សេចក្ដី ពិពណ៌នា ចំណុច ប្រទាក់',
                        validity: 'ភាព បែបផែន',
                        pleaseSelectEffectivity: 'សូម ជ្រើស ភាព បែបផែនភាព',
                        effective: 'មាន ប្រសិទ្ធភាព',
                        invalid: 'មិន ត្រឹមត្រូវ',
                        dataSource: 'ប្រភព ទិន្នន័យ',
                        pleaseSelectADataSource: 'សូម ជ្រើស ប្រភព ទិន្នន័យ',
                        requestMethod: 'វិធីសាស្ត្រ ស្នើ',
                        pleaseSelectARequestMethod: 'សូម ជ្រើស វិធីសាស្ត្រ សំណើ',
                        requestAddress: 'អាសយដ្ឋាន សំណើ',
                        pleaseEnterTheRequestAddress: 'សូម បញ្ចូល អាសយដ្ឋាន សំណើ',
                        requestParameters: 'ប៉ារ៉ាម៉ែត្រ ស្នើ',
                        pleaseAddRequestParameters: 'សូម បន្ថែម ប៉ារ៉ាម៉ែត្រ សំណើ',
                        returnParameter: 'ត្រឡប់ ប៉ារ៉ាម៉ែត្រ',
                        pleaseAddAReturnParameter: 'សូម បន្ថែម ប៉ារ៉ាម៉ែត្រ ត្រឡប់ វិញ',
                        editExternalInterface: 'កែសម្រួល ចំណុច ប្រទាក់ ខាងក្រៅ',
                        newExternalInterface: 'ចំណុច ប្រទាក់ ខាងក្រៅ ថ្មី',
                    },
                },
                index: {
                    operationSuccessful: 'ប្រតិបត្តិការ បាន ជោគជ័យ',
                    name: 'ឈ្មោះ:',
                    interfaceDescription: 'សេចក្ដី ពិពណ៌នា ចំណុច ប្រទាក់',
                    dataSource: 'ប្រភព ទិន្នន័យ',
                    requestMethod: 'វិធីសាស្ត្រ ស្នើ',
                    requestAddress: 'អាសយដ្ឋាន សំណើ',
                    creationTime: 'ពេលវេលា បង្កើតComment',
                    validity: 'ភាព បែបផែន',
                    externalInterface: 'ចំណុច ប្រទាក់ ខាងក្រៅ',
                    pleaseEnterAKeyword: 'សូម បញ្ចូល ពាក្យ គន្លឹះ',
                },
            },
            applicationMessageType: 'ប្រភេទ សារ កម្មវិធី',
            intelligentModel: {
                components: {
                    promptArea: {
                        index: {
                            qualityInspectionRequirements: 'ទាមទារ ការ ត្រួត ពិនិត្យ គុណភាព',
                            outputSpecification: 'ការ បញ្ជាក់ លទ្ធផល',
                            pleaseImproveTheConfiguration: 'សូម កំណត់ រចនា សម្ព័ន្ធ',
                            generatePromptLanguage: 'បាន បង្កើត សំណួរ',
                        },
                        components: {
                            optimization: {
                                index: {
                                    failedToOptimizePrompt: 'បាន បរាជ័យ ក្នុង ការ សួរ សំឡេង បង្កើន',
                                    pleaseEnterACommand: 'សូម បញ្ចូល ពាក្យ បញ្ជា',
                                    pleaseBecomeAPromptWord: 'សូម ស្វែងរក ពាក្យ សួរ',
                                    optimizationPrompt: 'ការ ធ្វើ ឲ្យ ប្រយោជន៍',
                                    ifThePromptContainsVariablesTheVariablesNeedToBeReinsertedAfterThePromptIsOptimized: 'ប្រសិន បើ សំឡេង មាន អថេរ អថេរ គឺ ត្រូវ តែ បញ្ចូល ឡើង វិញ បន្ទាប់ ពី សំឡេង ត្រូវ បាន ធ្វើ ឲ្យ ប្រសើរ ឡើង វិញ ។',
                                    cancel: 'បោះបង់',
                                    application: 'កម្មវិធី',
                                    instruction: 'បង្ហាញ',
                                    generate: 'បង្កើត@ info: whatsthis',
                                    promptWordGenerated: 'បាន បង្កើត ពាក្យ សួរ',
                                },
                            },
                        },
                    },
                    typeSelect: {
                        index: {
                            whetherItMeetsTheRequirements: 'ការ តភ្ជាប់Name',
                            gradedEvaluation: 'ការ វាយតម្លៃ ថ្នាយ',
                        },
                    },
                    training: {
                        index: {
                            pleaseEnter: 'សូម បញ្ចូល',
                            pleaseGeneratePrompt: 'សូម បង្កើត សួរ',
                            pleaseSelectADialogue: 'សូម ជ្រើស ស្វែងរក',
                            training: 'បង្ហាញ',
                            dataType: 'ប្រភេទ ទិន្នន័យ ៖',
                            voiceCall: 'ហៅ សំឡេង',
                            textDialogue: 'ប្រអប់ អត្ថបទ',
                            generate: 'បង្កើត@ info: whatsthis',
                            qualityInspectionResults: 'លទ្ធផល ត្រួតពិនិត្យ គុណភាព ៖',
                            hit: 'បិទ ៖',
                        },
                    },
                },
                detail: {
                    index: {
                        modelName: 'ឈ្មោះ ម៉ូល',
                        pleaseEnterTheModelNameForExampleIsThereASituationWhereCustomerServiceIsInactive: 'សូម បញ្ចូល ឈ្មោះ ម៉ូដែល ឧទាហរណ៍ ថា តើ ភ្នាក់ងារ មិន មាន សកម្មភាព ឡើយ ។',
                        modelDescription: 'សេចក្ដី ពិពណ៌នា ម៉ូឌុល',
                        canYouProvideADetailedDescriptionOfTheContentYouNeedToTestForTheModelsUnderstandingSuchAsWhetherThereIsASituationWhereCustomerServiceIsInactiveThatIsCustomerServiceHasRespondedToCustomerInquiriesButTheCustomersQuestionsHaveNotBeenAddressedThroughoutOrTheResponseContentIsUnrelatedToTheCustomersResponse: 'អ្នក អាច ពិពណ៌នា ជា លម្អិត អ្វី ដែល អ្នក ត្រូវការ សាកល្បង ដែល ងាយស្រួល សម្រាប់ ម៉ូដែល យល់ ។ ឧទាហរណ៍ ថា តើ សេវា របស់ ភ្ញៀវ មិន ធ្វើ អ្វី ទេ គឺជា សេវា របស់ អ្នក ភ្ញៀវ បាន ឆ្លើយតប ចំពោះ សំណួរ របស់ អ្នក ភ្ញៀវ ប៉ុន្តែ សំណួរ របស់ ម៉ាស៊ីន ភ្ញៀវ មិន ត្រូវ បាន ដោះស្រាយ ឬ មាតិកា របស់ ឆ្លើយតប មិន មាន អ្វី ដែល ទាក់ទង នឹង ឆ្លើយតប របស់ អ្នក ក្មេង ។',
                        validity: 'ភាព បែបផែន',
                        effective: 'មាន ប្រសិទ្ធភាព',
                        invalid: 'មិន ត្រឹមត្រូវ',
                        type: 'ប្រភេទ@ info: whatsthis',
                        hintLanguage: 'សួរ',
                        editIntelligentModel: 'កែសម្រួល ម៉ូដែល ឆ្លាត',
                        createANewIntelligentModel: 'ម៉ូដែល ថ្មី',
                    },
                },
                index: {
                    updateTime: 'ពេលវេលា ទាន់ សម័យ',
                    modelName: 'ឈ្មោះ ម៉ូល',
                    modelDescription: 'សេចក្ដី ពិពណ៌នា ម៉ូឌុល',
                    type: 'ប្រភេទ@ info: whatsthis',
                    whetherItMeetsTheRequirements: 'ការ តភ្ជាប់Name',
                    gradedEvaluation: 'ការ វាយតម្លៃ ថ្នាយ',
                    validity: 'ភាព បែបផែន',
                    intelligentModel: 'ម៉ូឌុល ខ្លាំង',
                    applicableToSubjectiveQualityInspectionsuchAsWhetherTheQualityInspectionServiceAttitudeIsEnthusiasticWhetherTheServiceIsPatientEtc: 'អនុវត្ត ទៅកាន់ ការ ត្រួត ពិនិត្យ គុណភាព ជានិច្ច សេវា គឺ ជា អ្នក ភ្ញៀវ)',
                },
            },
            clusterAnalysis: 'ការ វិភាគ គំរូ',
            speechMining: 'ការ បង្រួម ពាក្យ',
            informationEntities: {
                detail: {
                    batchImportOfInformationEntitiesThroughTheAPIInterfaceIsSupportedEditingIsNotSupportedAfterSavingTheAPIName: 'អ្នក អាច នាំចូល ធាតុ ព័ត៌មាន ក្នុង ថ្ម តាម ចំណុច ប្រទាក់ API ។ បន្ទាប់ ពី រក្សាទុក ឈ្មោះ API វា មិន អាច ត្រូវ បាន កែសម្រួល ។',
                    template: {
                        language: 'ភាសាComment',
                    },
                },
                component: {
                    language: 'ភាសាComment',
                    nothing: 'គ្មាន ទេ',
                },
                template: {
                    language: 'ភាសាComment',
                },
            },
            knowledgeBase: {
                index: {
                    language: 'ភាសាComment',
                    classification: 'ថត',
                    import: 'នាំចូល',
                    importKnowledgeBase: 'នាំចូល មូលដ្ឋាន សាធារណៈ',
                    moveKnowledgePointsInBatch: 'ផ្លាស់ទី ចំណុច សាធារណៈ',
                    moveTo: 'ផ្លាស់ទី ៖',
                    pleaseSelectTheKnowledgePointsToBeMovedInBatch: 'សូម ជ្រើស ចំណុច ស្គាល់ ដែល ត្រូវ ផ្លាស់ទី នៅ ក្នុង ថត',
                },
                detail: {
                    index: {
                        language: 'ភាសាComment',
                        intrasentence: 'ខាង ក្នុង ពាក្យ',
                        afterProblem: 'បន្ទាប់ ពី បញ្ហា',
                    },
                },
            },
            semanticTags: {
                component: {
                    numberOfReferences: 'ចំនួន យោងName',
                    language: 'ភាសាComment',
                    nothing: 'គ្មាន ទេ',
                },
                detail: {
                    template: {
                        largeModelAutomaticallyExpandsSimilarSentences: 'ម៉ូដែល ធំ ពង្រីក ពង្រីក ពាក្យ ស្រដៀង គ្នា ដោយ ស្វ័យ ប្រវត្តិ ។',
                        nLPAutoextendedSimilarSentences: 'ពាក្យ ស្រដៀង នឹង NLP ដោយ ស្វ័យ ប្រវត្តិ',
                        automaticExpansionOfSimilarSentences: 'ពង្រីក ពង្រីក ស្វ័យ ប្រវត្តិ',
                        nLPExtendedSimilarSentences: 'បាន ពង្រីក ប្រយោជន៍ ស្រដៀង គ្នា របស់ NLPName',
                        largeModelExtendedSimilarSentences: 'ម៉ូឌុល ធំ បាន ពង្រីក ពង្រីក ពាក្យ ស្រដៀង គ្នាName',
                        oneclickOptimization: 'កា រកំណត់ កម្សារ',
                        excludeRegularExpressionsSupportFillingInMultipleLinesWhenFillingInMultipleLinesTheLogicIsThatAnyHitCanBeEstablished: 'មិន រួម បញ្ចូល កន្សោម ធម្មតា ការ គាំទ្រ ការ បំពេញ បន្ទាត់ ច្រើន ។ នៅពេល បំពេញ បន្ទាត់ ច្រើន តក្ក គឺ ជា ត្បូង ណាមួយ ដែល អាច ត្រូវ បាន បង្កើត ។',
                        recallRegularTip: 'ចងចាំ ការ គាំទ្រ ធម្មតា ដើម្បី បំពេញ បន្ទាត់ ច្រើន បំពេញ បន្ទាត់ តក្ក ច្រើន អាច ត្រូវ បាន បង្កើត ។',
                        language: 'ភាសាComment',
                    },
                    component: {
                        pleaseEnterAStandardSentence: 'សូម បញ្ចូល ពាក្យ ស្តង់ដារ',
                    },
                },
                template: {
                    effectiveness: 'ភាព បែបផែន ៖',
                    pleaseSelectEffectivity: 'សូម ជ្រើស ភាព បែបផែនភាព',
                    effective: 'មាន ប្រសិទ្ធភាព',
                    invalid: 'មិន ត្រឹមត្រូវ',
                    language: 'ភាសាComment',
                },
            },
            smartWordsLibrary: {
                template: {
                    ignoreWordsBlockWordsThatYouDontWantToPayAttentionToInWordCloudAnalysisToHelpAIThatAnalysisHotspotsAreInLineWithCurrentBusiness: 'មិន អើពើ ពាក្យ ៖ ទប់ស្កាត់ ពាក្យ ដែល អ្នក មិន ចង់ ផ្ដល់ នូវ ការ វិភាគ ពណ៌ ព័ត៌មាន ដើម្បី ជួយ AI ដែល ការ វិភាគ កណ្ដាល នៅ ក្នុង បន្ទាត់ ជាមួយ ដំណើរការ បច្ចុប្បន្ន ។',
                    typosWordSetUsedToOptimizeTheEffectOftyposDetectionForExampleIfrefundIsMistakenlySentAsrefundWidthCommonTyposAndCorrectWordsCanBeSetThroughThisFunctionAndItWillTakeEffectTheNextDayAfterSaving: 'សំណុំ ពាក្យ typos ៖ ប្រើ ដើម្បី ធ្វើ ឲ្យ បែបផែន នៃ " ការ រក ឃើញ ប្រភេទ" ។ ឧទាហរណ៍ ប្រសិន បើ "refund" ត្រូវ បាន ផ្ញើ ដោយ មិន ត្រឹមត្រូវ ជា "ទទឹង ដោះស្រាយ", typos ធម្មតា និង ពាក្យ ត្រឹមត្រូវ អាច កំណត់ តាម រយៈ អនុគមន៍ នេះ ។ ហើយ វា នឹង មាន ប្រសិទ្ធភាព ថ្ងៃ បន្ទាប់ ពី ការ រក្សាទុក ។',
                    translationTerminologyUsedToOptimizeTheEffectOfTranslationWhenATermInTheIndustrySuchAsProductNameParameterNameEtcIsNotTranslatedCorrectlyTheTermAndItsCorrectTranslationCanBeAddedAsATranslationTerm: 'បកប្រែ បកប្រែ ៖ ប្រើ ដើម្បី បង្កើន បែបផែន នៃ ការ បកប្រែ ។ នៅពេល ដែល មាន ពាក្យ នៅ ក្នុង បណ្ដាញ ដូចជា ឈ្មោះ ផលិត ឈ្មោះ ប៉ារ៉ាម៉ែត្រ ។ល។ មិន ត្រូវ បាន បកប្រែ ដោយ ត្រឹមត្រូវ ទេ ពាក្យ និង ការ បកប្រែ ត្រឹមត្រូវ របស់ វា អាច ត្រូវ បាន បន្ថែម ជា ពាក្យ បកប្រែ ។',
                    translationOfTerms: 'ការ បកប្រែ ពាក្យ',
                    hotWords: 'ពាក្យ រង',
                    hotWordsUsedToImproveASRTranscriptionAccuracy: 'ពាក្យ រង ៖ ប្រើ ដើម្បី បង្កើន ភាព ត្រឹមត្រូវ ការ បម្លែង ASR',
                    sensitiveWords: 'ពាក្យ តូចៗ',
                    sensitiveWordsSensitiveWordsCanBeConfiguredWithBusinessFocusWordsForPublicOpinionToDiscoverSensitiveWordClouds: 'ពាក្យ តូចៗ ៖ ពាក្យ  Sentive អាច ត្រូវ បាន កំណត់ រចនា សម្ព័ន្ធ ជាមួយ ពាក្យ បញ្ហា ពាក្យ បញ្ហា ដែល ត្រូវ បាន ប្រើ សម្រាប់ ការ រក មើល ព័ត៌មាន សាធារណៈ',
                },
                sensitiveWords: {
                    component: {
                        language: 'ភាសាComment',
                        newSensitiveWord: 'ពាក្យ តូច ថ្មី',
                        editSensitiveWords: 'កែសម្រួល ពាក្យ តូចៗ',
                        sensitiveWords: 'ពាក្យ តូចៗ',
                    },
                    template: {
                        language: 'ភាសាComment',
                        sensitiveWords: 'ពាក្យ តូចៗ',
                        sensitiveWordsCannotBeEmpty: 'ពាក្យ សំខាន់ មិន អាច ទទេ',
                        pleaseEnterSensitiveWordsSeparatedBy: 'សូម បញ្ចូល ពាក្យ តូចៗ ដោយ បំបែក ពាក្យ តូច ច្រើន \'\'',
                    },
                },
                hotWords: {
                    index: {
                        hotWordModel: 'ម៉ូដែល ពាក្យ រង',
                        aSRProject: 'គម្រោង ASR',
                        updateTime: 'ពេលវេលា ទាន់ សម័យ',
                        operation: 'ប្រតិបត្តិការ',
                        editBasicInformation: 'កែសម្រួល ព័ត៌មាន មូលដ្ឋាន',
                        managementHotWords: 'ពាក្យ រង គ្រប់គ្រងComment',
                        delete: 'លុប',
                        saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                        newHotWordModel: 'ម៉ូដែល ពាក្យ ថ្មី',
                        editHotWordModel: 'កែសម្រួល ម៉ូដែល ពាក្យ រង់',
                        hotWordModelName: 'ឈ្មោះ ម៉ូដែល ពាក្យ រង',
                        pleaseEnterHotwordModelName: 'សូម បញ្ចូល ឈ្មោះ ម៉ូដែល ពាក្យ ក្រោយ',
                        pleaseSelectAnASRProject: 'សូម ជ្រើស គម្រោង ASR',
                        areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                        deleteSuccessful: 'បាន លុប ដោយ ជោគជ័យ',
                        currentHotWords: 'ពាក្យ រង បច្ចុប្បន្ន',
                        one: 'មួយ',
                        pleaseEnterAHotWordMultipleHotWordsAreSeparatedByCommasInChineseOrEnglishTheMaximumLengthIsCharacters: 'សូម បញ្ចូល ពាក្យ រង ។ ពាក្យ រង ពហុ ច្រើន ត្រូវ បាន បំបែក ដោយ សម័យ ក្នុង ចិន ឬ អង់គ្លេស ។ ប្រវែង អតិបរមា គឺ ១២ តួអក្សរ ។',
                        submission: 'ដាក់ ស្នើ',
                    },
                },
                corpusData: {
                    component: {
                        language: 'ភាសាComment',
                    },
                    template: {
                        language: 'ភាសាComment',
                    },
                },
                professionalWords: {
                    component: {
                        language: 'ភាសាComment',
                    },
                    template: {
                        language: 'ភាសាComment',
                    },
                },
                smartWordsLibraryCommon: {
                    component: {
                        language: 'ភាសាComment',
                    },
                },
                smartWordsLibraryCommonList: {
                    template: {
                        aSRTrainingStatus: 'ស្ថានភាព បង្ហាត់ ASR',
                    },
                },
                translationTerminology: {
                    components: {
                        list: {
                            index: {
                                pleaseEnterATermNameForTheLanguage: 'សូម បញ្ចូល ឈ្មោះ ពាក្យ សម្រាប់ ភាសា',
                                addAdditionalLanguages: 'បន្ថែម ភាសា បន្ថែម',
                            },
                        },
                    },
                    index: {
                        translationOfTerms: 'ការ បកប្រែ ពាក្យ',
                        language: 'ភាសាComment',
                        effectiveness: 'ភាព បែបផែន',
                        yes: 'បាន',
                        no: 'គ្មាន ទេ',
                        edit: 'កែសម្រួល',
                        new: 'ថ្មី',
                        editTranslationTerms: 'កែសម្រួល ពាក្យ បក ប្រែ',
                        newTranslationTerm: 'ពាក្យ បកប្រែ ថ្មី',
                        pleaseAddTermsInAtLeastTwoLanguages: 'សូម បន្ថែម ពាក្យ ក្នុង ភាសា យ៉ាង ហោច ណាស់ ពីរ',
                    },
                },
            },
            clusteringAnalysis: {
                add: {
                    index: {
                        pleaseSelectAnApplicationScenario: 'សូម ជ្រើស វិធីសាស្ត្រ កម្មវិធី',
                        keyWord: 'ពាក្យ សោ',
                        pleaseEnterKeywords: 'សូម បញ្ចូល ពាក្យ គន្លឹះ',
                        keywordLengthWithinCharacters: 'ប្រវែង ពាក្យ គន្លឹះ ក្នុង តួអក្សរ ៤០',
                        dataSources: 'ប្រភព ទិន្នន័យ',
                        pleaseSelectADataSource: 'សូម ជ្រើស ប្រភព ទិន្នន័យ',
                        theCurrentClusteringHasBeenCompletedReEditingWillGenerateANewClusteringDataAndWillNotOverwriteTheCompletedClusteringDataPleaseConfirm: 'ការ ក្លែង ធ្វើ បច្ចុប្បន្ន ត្រូវ បាន បញ្ចប់ ។ ការ កែសម្រួល ឡើង វិញ នឹង បង្កើត ភាគ ថ្មី នៃ ទិន្នន័យ ព័ត៌មាន និង នឹង មិន សរសេរ ជាន់ លើ ទិន្នន័យ ដែល បាន បញ្ចប់ ។ សូម អះអាង',
                        savingSucceeded: 'រក្សាទុក ដោយ ជោគជ័យ',
                        clusteringStart: 'ចាប់ផ្ដើម',
                        clustering: 'គ្រាប់ប់',
                        edit: 'កែសម្រួល',
                        newlyBuild: 'ថ្មី',
                        clusterName: 'ឈ្មោះ ក្រហម',
                        pleaseEnterAName: 'សូម បញ្ចូល ឈ្មោះ មួយ',
                        withinCharactersOfTheName: 'ប្រវែង ឈ្មោះ ក្នុង ៤០ តួ អក្សរ',
                        speaker: 'អ្នក និយាយComment',
                        pleaseSelectASpeaker: 'សូម ជ្រើស អ្នក និពន្ធName',
                        sessionDate: 'កាលបរិច្ឆេទ សម័យ',
                        pleaseEnterTheSessionDate: 'សូម បញ្ចូល កាលបរិច្ឆេទ សម័យ',
                        selectUpToMonthOfHistoricalSessionData: 'ជ្រើស ទិន្នន័យ សម័យ ប្រវត្តិ អតិបរមា ១ ខែ',
                        automaticallyClusterDailyNewData: 'ស្លាក ស្វ័យ ប្រវត្តិ នៃ ទិន្នន័យ ថ្មី',
                        conversationChannel: 'ឆានែល ទំនាក់ទំនង',
                        pleaseSelectAConversationChannel: 'សូម ជ្រើស ឆានែល សម័យ',
                        applicationScenario: 'និមិត្ត សញ្ញា កម្មវិធី',
                        clusteringRules: 'ក្បៀស',
                        incompleteClusteringRuleSettings: 'ការ កំណត់ ច្បាប់ ក្បៀស មិន បញ្ចប់',
                        startClustering: 'ចាប់ផ្តើម គំរូ',
                    },
                    components: {
                        conditionItem: {
                            pleaseSelectAQualityInspectionTask: 'សូម ជ្រើស ភារកិច្ច គុណភាព',
                            beEqualTo: 'ស្មើ',
                        },
                    },
                },
                detail: {
                    index: {
                        theme: 'ស្បែក',
                        numberOfCorpora: 'ចំនួន corpusName',
                        corpusCoverage: 'គម្រប',
                        clusterDetails: 'សេចក្ដី លម្អិត ក្បឿង',
                    },
                    ranking: {
                        hotWords: 'ពាក្យ រង',
                        numberOfCorpora: 'ចំនួន corpusName',
                        speaker: 'អ្នក និយាយComment',
                        sit: 'រាល់ ។',
                        passenger: 'ភ្ញៀវ',
                        hotSentence: 'ប្រយោជន៍',
                        corpusDetails: 'សេចក្ដី លម្អិត របស់ Corpus',
                    },
                },
                index: {
                    delete: 'លុប',
                    deletionSucceeded: 'បាន លុប ដោយ ជោគជ័យ',
                    clusterName: 'ឈ្មោះ ក្រហម',
                    speaker: 'អ្នក និយាយComment',
                    creationTime: 'ពេលវេលា បង្កើតComment',
                    state: 'ស្ថានភាព',
                    operation: 'ប្រតិបត្តិការ',
                    see: 'ទិដ្ឋភាព',
                    edit: 'កែសម្រួល',
                    clusterAnalysis: 'ការ វិភាគ គំរូ',
                    newCluster: 'ក្រឡា ថ្មី',
                    clusteringStatus: 'ស្ថានភាព បង្កើន',
                },
            },
            wordsMining: {
                dissent: {
                    components: {
                        pageLeftTable: {
                            enterKeywordsToSearchForObjections: 'បញ្ចូល ពាក្យ គន្លឹះ ដើម្បី ស្វែងរក ការងារ',
                        },
                        pageRightTable: {
                            columnHeader: {
                                scriptLibrary: 'បណ្ណាល័យ និយាយComment',
                                recommendedScripts: 'ផ្ដល់ អនុសាសន៍ និយាយComment',
                                common: 'សរុប',
                                strip: 'អត្ថបទ',
                                scriptFavorites: 'ពាក្យ សំណព្វ',
                            },
                            conditionPostfix: {
                                detectRoles: 'រកឃើញ រលា',
                                detectionRange: 'ជួរ រកឃើញ@ info: whatsthis',
                                sentence: 'ប្រយោជន៍',
                            },
                            customerFilter: {
                                scriptFiltering: 'ការ ត្រង និយាយComment',
                                cancel: 'បោះបង់',
                            },
                            index: {
                                viewDetails: 'មើល សេចក្ដី លម្អិត',
                                areYouSureYouWantToDiscardYouCannotRestoreAfterDiscarding: 'តើ អ្នក ពិត ជា ចង់ បោះបង់ វា ឬ ? អ្នក មិន អាច ស្ដារ វា បាន ទេ បន្ទាប់ ពី បោះបង់ វា ។',
                                abandonment: 'បោះបង់',
                                deletionSucceeded: 'បាន លុប ដោយ ជោគជ័យ',
                                passenger: 'ភ្ញៀវ',
                                sit: 'រាល់ ។',
                                adopted: 'បាន ថត',
                                determine: 'កំណត់@ info: whatsthis',
                                cancel: 'បោះបង់',
                                adopt: 'ថត',
                            },
                            pageRightFrom: {
                                savingSucceeded: 'រក្សាទុក ដោយ ជោគជ័យ',
                                pleaseEnterTheScriptContent: 'សូម បញ្ចូល មាតិកា និយាយComment',
                                pleaseSelectAFavoriteGroup: 'សូម ជ្រើស ការ ដាក់ ជា ក្រុម ដែល ចូលចិត្តName',
                            },
                        },
                    },
                    favorite: {
                        components: {
                            pageLeftTable: {
                                objectionHandlingScriptLibrary: 'ការ ដោះស្រាយ បណ្ណាល័យ សំណួរ',
                            },
                            pageRightTable: {
                                index: {
                                    pleaseChooseToAdoptScript: 'សូម ជ្រើស និយាយ ថ្មី',
                                },
                            },
                        },
                    },
                },
                favoriteView: {
                    components: {
                        pageLeftTable: {
                            objectionHandlingScriptFavorites: 'ការ ដោះស្រាយ ពាក្យ សម្អាត',
                        },
                        pageRightTable: {
                            likeCancel: 'ដូច ដែល បាន បោះបង់',
                            likeSuccessfully: 'ខ្ញុំចង់ ជោគជ័យ ។',
                            adoptScripts: 'ថត និយាយComment',
                            operation: 'ប្រតិបត្តិការ',
                            viewConversationDetails: 'មើល សេចក្ដី លម្អិត ព័ត៌មាន',
                        },
                    },
                    sellingPoint: {
                        components: {
                            pageLeftTable: {
                                productSellingPointScriptLibrary: 'បណ្ណាល័យ ចំណុច ពិន្ទុ ចង្អុល',
                            },
                            pageRightTable: {
                                keyPointsOfScript: 'ចំណុច គ្រាប់ ចុច របស់ សនិក',
                            },
                        },
                    },
                },
                favorite: {
                    components: {
                        pageLeftTable: {
                            objectionHandlingScriptFavorites: 'ការ ដោះស្រាយ ពាក្យ សម្អាត',
                            newGroup: 'ក្រុម ថ្មី',
                            editGroup: 'កែសម្រួល ការ ដាក់ ក្រុមComment',
                            addGroup: 'បន្ថែម ក្រុម',
                            savingSucceeded: 'រក្សាទុក ដោយ ជោគជ័យ',
                            groupName: 'ឈ្មោះ ក្រុម',
                            pleaseEnterTheGroupName: 'សូម បញ្ចូល ឈ្មោះ ក្រុម',
                            groupNameWithinCharacters: 'ប្រវែង ឈ្មោះ ក្រុម ក្នុង តួអក្សរ ២០',
                            deletionSucceeded: 'បាន លុប ដោយ ជោគជ័យ',
                        },
                        pageRightTable: {
                            configDrawer: {
                                index: {
                                    scriptRecommendationSettings: 'និយាយ ផ្ដល់ អនុសាសន៍ ការ កំណត់Comment',
                                },
                                rightForm: {
                                    savingSucceeded: 'រក្សាទុក ដោយ ជោគជ័យ',
                                    intelligentRecommendation: 'អនុសាសន៍ ជម្រះ',
                                    theAdoptedExcellentScriptsWillBeAutomaticallyDisplayedInTheConversationSidebarOfSimilarObjectionsAndEmployeesCanDirectlyViewTheRecommendedScriptsForLearningOnTheDetailedPageOfConversationReview: 'សមត្ថភាព និយាយ ល្អ ដែល បាន ចាប់ផ្តើម នឹង ត្រូវ បាន បង្ហាញ ដោយ ស្វ័យ ប្រវត្តិ នៅ ក្នុង របារ ចំហៀង នៃ ការ និយាយ ជា មួយ ការ បដិសេធ ស្រដៀង គ្នា ។ និង អ្នក ភ្ញៀវ អាច មើល សមត្ថភាព និយាយ ដោយ ផ្ទាល់ ខ្លួន ដើម្បី សិក្សា លើ សម័យ បន្ត ទំព័រ លម្អិត សម័យ ។',
                                    objectionsIncludedByDefault: 'ការ ស្វែងរក រួមបញ្ចូល តាម លំនាំដើម',
                                    addRecommendationTriggerSemantics: 'បន្ថែម ការ បិទ semantics',
                                    remindEmployeesToView: 'រំលឹក អ្នក ភ្ជាប់',
                                    shareWithMoreEmployees: 'ចែករំលែក ជាមួយ អ្នក កាន់ តែ ច្រើន ។',
                                    allHands: 'ភារកិច្ច ទាំងអស់',
                                },
                                smartToolbar: {
                                    selectSemanticTag: 'ជ្រើស ស្លាក សំឡេង',
                                },
                            },
                            index: {
                                doYouWantToExportAllDataRecordsUnderTheCurrentGroup: 'នាំចេញ ថត ទិន្នន័យ ទាំងអស់ ក្រោម ការ ដាក់ ក្រុម បច្ចុប្បន្ន ?',
                                newScript: 'និយាយ ថ្មី',
                                editingScript: 'កែសម្រួល និយាយComment',
                                savingSucceeded: 'រក្សាទុក ដោយ ជោគជ័យ',
                                objection: 'ការពារ',
                                pleaseEnterAScriptObjection: 'សូម បញ្ចូល ទិន្នន័យ និយាយName',
                                speechTechnique: 'ពាក្យ',
                                pleaseEnterTheScriptContent: 'សូម បញ្ចូល មាតិកា និយាយComment',
                                grouping: 'ក្រុម',
                                pleaseSelectAFavoriteGroup: 'សូម ជ្រើស ការ ដាក់ ជា ក្រុម ដែល ចូលចិត្តName',
                                adoptScripts: 'ថត និយាយComment',
                                passenger: 'ភ្ញៀវ',
                                sit: 'រាល់ ។',
                                numberOfViews: 'ចំនួន ទិដ្ឋភាព',
                                useful: 'មាន ប្រយោជន៍',
                                operation: 'ប្រតិបត្តិការ',
                                edit: 'កែសម្រួល',
                                delete: 'លុប',
                                deletionSucceeded: 'បាន លុប ដោយ ជោគជ័យ',
                                scriptRecommendationSettings: 'និយាយ ផ្ដល់ អនុសាសន៍ ការ កំណត់Comment',
                            },
                        },
                    },
                },
                index: {
                    scriptLibrary: 'បណ្ណាល័យ និយាយComment',
                    scriptMining: 'ការ បង្រួម ពាក្យ',
                    objectionHandlingScripts: 'ការ ដោះស្រាយ ទិន្នន័យ',
                    productSellingPointScripts: 'ចំណុច ចែក លទ្ធផលName',
                },
                sellingPoint: {
                    index: {
                        newCluster: 'ក្រឡា ថ្មី',
                    },
                    components: {
                        callDetailModal: {
                            sessionDetails: 'សេចក្ដី លម្អិត សម័យ',
                            cancel: 'បោះបង់',
                            determine: 'កំណត់@ info: whatsthis',
                            choice: 'ជ្រើស',
                        },
                        pageCenterTable: {
                            scriptOverview: 'ទិដ្ឋភាព ទូទៅ និយាយComment',
                        },
                        pageLeftTable: {
                            enterSearchKeywords: 'បញ្ចូល ពាក្យ គន្លឹះ ស្វែងរក',
                            keyWord: 'ពាក្យ សោ',
                        },
                        pageRightTable: {
                            index: {
                                viewDetails: 'មើល សេចក្ដី លម្អិត',
                                scriptLibrary: 'បណ្ណាល័យ និយាយComment',
                                scriptRefinement: 'ការ លុប សម្អាត',
                                adoptScript: 'ថត និយាយComment',
                            },
                            tagsEdit: {
                                keyPointsOfScript: 'ចំណុច គ្រាប់ ចុច របស់ សនិក',
                            },
                        },
                    },
                    favorite: {
                        components: {
                            pageLeftTable: {
                                productSellingPointScriptLibrary: 'បណ្ណាល័យ ចំណុច ពិន្ទុ ចង្អុល',
                            },
                            pageRightTable: {
                                configDrawer: {
                                    rightForm: {
                                        defaultIncludedSellingPoints: 'ចំណុច ចែក ដោយ លំនាំដើម',
                                    },
                                },
                                index: {
                                    keyWord: 'ពាក្យ សោ',
                                    pleaseSelectAKeyword: 'សូម ជ្រើស ពាក្យ គន្លឹះ',
                                    keyPointsOfScript: 'ចំណុច គ្រាប់ ចុច របស់ សនិក',
                                    pleaseInputTheKeyPointsOfTheScript: 'សូម បញ្ចូល ចំណុច កូនសោ របស់ និយម',
                                    viewDetails: 'មើល សេចក្ដី លម្អិត',
                                    pleaseChooseToAdoptScript: 'សូម ជ្រើស និយាយ ថ្មី',
                                },
                            },
                        },
                    },
                },
            },
            conceptWord: {
                detail: {
                    template: {
                        language: 'ភាសាComment',
                        matchingLogic: 'ការ ផ្គូផ្គង',
                        nLPMatching: 'ផ្គូផ្គង NLPName',
                        strictlyMatchByWord: 'ផ្គូផ្គង ខ្លាំង តាម ពាក្យ',
                    },
                },
                component: {
                    language: 'ភាសាComment',
                },
                template: {
                    language: 'ភាសាComment',
                },
            },
            applicationMessage: {
                index: {
                    messageTypeName: 'ឈ្មោះ ប្រភេទ សារ',
                    messageTypeID: 'លេខ សម្គាល់ ប្រភេទ សារ',
                    messageTypeDescription: 'សេចក្ដី ពិពណ៌នា ប្រភេទ សារ',
                    applicationMessageType: 'ប្រភេទ សារ កម្មវិធី',
                    itIsApplicableToAccessDataFromDifferentChannelsForQualityInspectionWhichShouldBeClassifiedAccordingToChannelIdentification: 'វា អាច អនុវត្ត ដើម្បី ចូល ដំណើរការ ទិន្នន័យ ពី ឆានែល ផ្សេង សម្រាប់ ការ ត្រួត ពិនិត្យ គុណភាព ដែល គួរ តែ ត្រូវ បាន ថ្នាក់ តាម រយៈ ការ កំណត់ អត្តសញ្ញាណ ឆានែល ។',
                },
                detail: {
                    index: {
                        messageTypeName: 'ឈ្មោះ ប្រភេទ សារ',
                        pleaseEnterAMessageTypeName: 'សូម បញ្ចូល ប្រភេទ សារ',
                        messageTypeDescription: 'សេចក្ដី ពិពណ៌នា ប្រភេទ សារ',
                        describeYourMessageTypeInDetail: 'ពិពណ៌នា ប្រភេទ សារ របស់ អ្នក',
                        editMessageType: 'កែសម្រួល ប្រភេទ សារ',
                        newMessageType: 'ប្រភេទ សារ ថ្មី',
                    },
                },
            },
            aiAgent: {
                detail: {
                    components: {
                        paramsList: {
                            components: {
                                value: {
                                    components: {
                                        randomFieldSelectList: {
                                            index: {
                                                preprocessedField: 'វាល ដែល បាន ដំណើរការ មុន',
                                            },
                                        },
                                    },
                                    index: {
                                        preprocessedField: 'វាល ដែល បាន ដំណើរការ មុន',
                                        fixedValue: 'តម្លៃ ថេរ',
                                        pleaseEnterTheField: 'សូម បញ្ចូល វាល',
                                    },
                                },
                            },
                            index: {
                                pleaseEnterKey: 'សូម បញ្ចូល កូនសោ',
                            },
                        },
                    },
                    index: {
                        pleasePerfectTheVariable: 'សូម បំផុត',
                        editAgent: 'កែសម្រួល ភ្នាក់ងារ',
                        newAgent: 'ភ្នាក់ងារ ថ្មី',
                        agentName: 'ឈ្មោះ ភ្នាក់ងា',
                        pleaseEnter: 'សូម បញ្ចូល',
                        agentDescription: 'សេចក្ដី ពិពណ៌នា ភ្នាក់ងារ',
                        effectiveness: 'ភាព បែបផែន',
                        source: 'ប្រភព',
                        space: 'ទំហំ',
                        agent: 'ភាគ',
                        aPIAddress: 'អាសយដ្ឋាន API',
                        userID: 'លេខ សម្គាល់ អ្នក ប្រើ',
                        type: 'ប្រភេទ@ info: whatsthis',
                        conversationMessages: 'សារ សារ',
                        variable: 'អថេរ',
                    },
                },
                index: {
                    name: 'ឈ្មោះ:',
                    description: 'សេចក្ដី ពិពណ៌នា',
                    source: 'ប្រភព',
                    statusUpdateSuccessful: 'ធ្វើ ឲ្យ ស្ថានភាព ទាន់ សម័យ មាន ជោគជ័យ',
                    agent: 'ភាគ',
                    pleaseEnterAKeyword: 'សូម បញ្ចូល ពាក្យ គន្លឹះ',
                },
            },
        },
        gong: {
            common: {
                pleaseSelectATemMember: 'សូម ជ្រើស ក្រុម មួយ',
                existingFilter: 'មាន តម្រង រួច ហើយ ។',
                pleaseSelect: 'សូម ជ្រើស',
                filterCondition: 'លក្ខខណ្ឌ ត្រង',
                areYouSureToDeleteTheCurrentFilter: 'តើ អ្នក ពិត ជា ចង់ លុប តម្រង បច្ចុប្បន្ន ឬ ?',
                sessionDate: 'កាលបរិច្ឆេទ សម័យ',
                staff: 'ការងារ',
                customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                pleaseEnterCustomerName: 'សូម បញ្ចូល ឈ្មោះ ម៉ាស៊ីន ភ្ញៀវ',
                keyWord: 'ពាក្យ សោ',
                whole: 'ទាំង អស់',
                pleaseEnterSessionKeywords: 'សូម បញ្ចូល ពាក្យ គន្លឹះ សម័យ',
                sessionDuration: 'ថិរវេលា សម័យ',
                sessionLabel: 'សម័យ',
                pleaseSelectASessionLabel: 'សូម ជ្រើស វិធីសាស្ត្រ សម័យName',
                commentTopic: 'សេចក្ដី អធិប្បាយ',
                pleaseSelectACommentTopic: 'សូម ជ្រើស ប្រធាន បទ មតិយោបល់',
                areYouSureYouWantToOverwriteTheCurrentFilter: 'តើ អ្នក ពិត ជា ចង់ សរសេរ ជាន់ លើ តម្រង បច្ចុប្បន្ន ឬ ?',
                overlayFilter: 'តម្រង គម្រប',
                NewFilter: 'តម្រង ថ្មី',
                newFilter: 'តម្រង ថ្មី',
                filterName: 'ឈ្មោះ តម្រង',
                pleaseEnter: 'សូម បញ្ចូល',
                allCall: 'ការ ហៅ ទាំងអស់',
                percentage: 'ភាគរយ',
                filterScreen: {
                    supportSearchingForMultipleKeywordsWithCommasinBothChineseAndEnglishSeparatingTheORRelationshipAndADashSeparatingTheAndRelationshipSuchAs: 'អ្នក អាច ស្វែងរក ពាក្យ គន្លឹះ ច្រើន ។ ប្រើ កម្លាំង (គិត ជា ភាសា អង់គ្លេស និង ចិន) ដើម្បី បំបែក អ្នក នៅ ក្នុង ទំនាក់ទំនង " ឬ" និង ប្រើ កម្លាំង ដើម្បី បំបែក ក្នុង ទំនាក់ទំនង " និង" ដូចគ្នា ៖',
                    callRecordID: 'លេខ សម្គាល់ កំណត់ហេតុ ហៅ',
                    pleaseFillInTheCallRecordID: 'សូម បំពេញ លេខ សម្គាល់ ហៅ',
                    minute: 'នាទី',
                    second: 'វិនាទី',
                    whole: 'ទាំង អស់',
                    callRecording: 'ការ ថត ហៅ',
                    enterpriseWechat: 'បណ្ដាញ ជម្រះ',
                    conversationChannel: 'ឆានែល ទំនាក់ទំនង',
                    pleaseSelectASessionChannel: 'សូម ជ្រើស ឆានែល សម័យ',
                    learningStatus: 'ស្ថានភាព បង្ហាញ',
                    pleaseSelectLearningStatus: 'សូម ជ្រើស ស្ថានភាព សិក្សា',
                    notLearned: 'មិន បាន រៀន ទេ',
                    learned: 'បាន លុប',
                    Minutes: 'នាទី',
                    theFilterConditionIsEmptyNewFilterIsNotSupported: 'លក្ខខណ្ឌ តម្រង គឺ ទទេ តម្រង មិន ត្រូវ បានគាំទ្រ !',
                    filterAddedSuccessfully: 'បាន បន្ថែម តម្រង ដោយ ជោគជ័យ !',
                    failedToAddFilter: 'បាន បរាជ័យ ក្នុង ការ បន្ថែម តម្រង !',
                    filterDeletedSuccessfully: 'តម្រង បាន លុប ដោយ ជោគជ័យ !',
                    filterDeletionFailed: 'បាន បរាជ័យ លុប តម្រង!',
                    filterOverwriteSucceeded: 'តម្រង បដិសេធ ដោយ ជោគជ័យ !',
                    filterOverwriteFailed: 'បាន បរាជ័យ ក្នុង ការ បដិសេធ តម្រង!',
                    theme: 'ស្បែក',
                    pleaseSelectATheme: 'សូម ជ្រើស ស្បែក មួយ',
                    keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                    pleaseSelectAKeyEvent: 'សូម ជ្រើស ព្រឹត្តិការណ៍ សោ',
                },
                filterItem: {
                    startRetesting: 'ចាប់ផ្ដើម ការ រក ឡើង វិញ',
                    time: 'ពេលវេលា',
                    talkTime: 'ថិរវេលា ហៅ',
                    keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                    totalImplementationRateOfSupervisionItems: 'អត្រា ការ អនុញ្ញាត ជាទូទៅ នៃ ធាតុ ភ្ជាប់',
                    sort: 'តម្រៀប ៖',
                    seeMore: 'មើល ទៀត',
                },
                filterStatistics: {
                    conversation: 'ហៅ',
                    weChat: 'បណ្ដាញ',
                    quantity: 'មាត្រ ដ្ឋាន',
                },
            },
            caseBase: {
                index: {
                    copyTo: 'ចម្លង',
                    pleaseSelectTheLocationToMove: 'សូម ជ្រើស ទីតាំង ដើម្បី ផ្លាស់ទី !',
                    folderCopiedSuccessfully: 'ចម្លង ថត បាន ជោគជ័យ !',
                    cancelCollectionSuccessfully: 'បោះបង់ សម្រាំង ដោយ ជោគជ័យ !',
                    collectionSucceeded: 'ការ សម្រាំង ជោគជ័យ !',
                    starCaseBase: 'បណ្ណាល័យ ប្រមាណ រូបភាព',
                    move: 'ផ្លាស់ទី',
                    rename: 'ប្ដូរ ឈ្មោះ',
                    delete: 'លុប',
                    folderMovedSuccessfully: 'បាន ផ្លាស់ទី ថត ដោយ ជោគជ័យ !',
                    fileMovedSuccessfully: 'ឯកសារ បាន ផ្លាស់ទី ដោយ ជោគជ័យ !',
                    fileMoveFailed: 'បាន បរាជ័យ ក្នុង ការ ផ្លាស់ទី ឯកសារ !',
                    folderAddedSuccessfully: 'បន្ថែម ថត ដោយ ជោគជ័យ !',
                    folderRenameSucceeded: 'បាន ប្ដូរ ឈ្មោះ ថត ដោយ ជោគជ័យ !',
                    fileRenameSucceeded: 'បាន ប្ដូរ ឈ្មោះ ឯកសារ ដោយ ជោគជ័យ !',
                    theFolderCannotBeRetrievedAfterDeletionAreYouSureToDeleteIt: 'បន្ទាប់ ពី លុប ថត អ្នក នឹង មិន អាច ទៅ យក វា បាន ទេ ។ តើ អ្នក ពិត ជា លុប វា ឬ ?',
                    deleteSucceeded: 'បាន លុប ដោយ ជោគជ័យ !',
                    theFileCannotBeRetrievedAfterDeletionAreYouSureToDeleteIt: 'បន្ទាប់ ពី លុប ឯកសារ អ្នក នឹង មិន អាច ទៅ យក វា ។ តើ អ្នក ពិត ជា លុប វា ឬ ?',
                    share: 'សរុប',
                    folders: 'ថត',
                    calls: 'ហៅ',
                    newFolder: 'ថត ថ្មី',
                    modifyFolder: 'កែប្រែ ថត',
                    title: 'ចំណង ជើង',
                    pleaseEnter: 'សូម បញ្ចូល',
                    selectMoveLocation: 'ជ្រើស ទីតាំង ផ្លាស់ទី',
                },
            },
            msgCenter: {
                index: {
                    learningReminder: 'កម្មវិធី រំលឹក',
                    subscriptionDynamics: 'ថាមវន្ត',
                },
                subscription: {
                    index: {
                        theSessionYouSubscribedToID: 'សម័យ ដែល អ្នក បាន ជាវ ទៅ (ID)',
                        thereAreDynamicUpdates: 'មាន ភាព ទាន់ សម័យ ថាមវន្ត',
                        newCommentsReplies: 'បន្ថែម សេចក្ដី អធិប្បាយ/ចេញ',
                        strip: 'អត្ថបទ',
                        newHelp: 'បន្ថែម ជំនួយ',
                        goAndWatch: 'ទៅ អ្នក មើល@ info: whatsthis',
                    },
                },
                reply: {
                    index: {
                        respondedToMyComments: 'ឆ្លើយតប ទៅ សេចក្ដី អធិប្បាយ របស់ ខ្ញុំ',
                        replySucceeded: 'បាន ជោគជ័យ !',
                    },
                },
                answer: {
                    index: {
                        youMeInTheComments: '@ I នៅ ក្នុង សេចក្ដី អធិប្បាយ ។',
                        replySucceeded: 'បាន ជោគជ័យ !',
                    },
                },
                share: {
                    index: {
                        shareCallsForYou: 'ហៅ សម្រាប់ អ្នក ត្រូវ ចែក រំលែក',
                        shareCasesForYou: 'ចែករំលែក ករណី សម្រាប់ អ្នក ។',
                    },
                },
                study: {
                    index: {
                        learned: 'បាន លុប',
                        ignored: 'មិន អើពើ',
                        study: 'ការ សិក្សា',
                        ignore: 'មិន អើពើ',
                    },
                },
            },
            userManage: {
                list: {
                    importSuccessful: 'នាំចូល បាន ជោគជ័យ',
                    account: 'លេខ គណនី',
                    password: 'ពាក្យ សម្ងាត់',
                    cover: 'គម្រប',
                    skip: 'រំលង',
                    import: 'នាំចូល',
                    importEmployees: 'នាំចូល ការងារ',
                    importPrompt: 'នាំចូល ព័ត៌មាន',
                    confirm: 'កំណត់@ info: whatsthis',
                    theDataContainsDuplicateAccountsOrNames: 'គណនី ឬ ឈ្មោះ ស្ទួន មាន នៅ ក្នុង ធាតុ ទិន្នន័យ នេះ',
                    allCoverage: 'គម្រប ទាំងអស់',
                    skipAll: 'រំលង ទាំងអស់',
                    headPortrait: 'អាវតារ',
                    fullName: 'ឈ្មោះ:',
                    nickname: 'ឈ្មោះ សំឡេង',
                    excellentStaff: 'ភ្ញៀវ ខ្ពស់',
                    yes: 'បាន',
                    no: 'គ្មាន ទេ',
                    department: 'ហត្ថលេខា',
                    accountNumberemail: 'លេខ គណនី ( អ៊ីមែល)',
                    telephone: 'ទូរស័ព្ទ',
                    jobNumber: 'ការងារ លេខ ។',
                    role: 'រលូន',
                    pleaseEnterANameOrPhoneSearch: 'សូម បញ្ចូល អ៊ីមែល ឈ្មោះ ឬ ស្វែងរក ទូរស័ព្ទ',
                    person: 'មនុស្ស)',
                    AddEmployee: 'បន្ថែម ម៉ាស៊ីន ភ្ញៀវ',
                },
                edit: {
                    jobNo: 'ការងារ លេខ ។',
                    udeskCustomerServiceSystemIdentity: 'អត្តសញ្ញាណ ប្រព័ន្ធ សេវា របស់ Udesk',
                    enterpriseWechatIdentity: 'អត្តសញ្ញាណ WeChat Enterprise',
                    inputID: 'លេខ សម្គាល់ បញ្ចូល',
                    newIdentityBinding: 'ការ ចង អត្តសញ្ញាណ ថ្មី',
                    identityBinding: 'ការ ចង អត្តសញ្ញាណ',
                    avatarGreaterThan500kb: 'Avatar ធំ ជាង 500Kb',
                    uploadSuccessful: 'ផ្ទុក ឡើង ជោគជ័យ',
                    upload: 'ផ្ទុក ឡើង លើ',
                    supportJPGGIFAndPNGUpTo500kb: 'គាំទ្រ jpg, gif, png អតិបរមា 500Kb',
                    yes: 'បាន',
                    no: 'គ្មាន ទេ',
                    accountNumber: 'លេខ គណនី',
                    pleaseEnterTheAccountNumber: 'សូម បញ្ចូល លេខ គណនី',
                    initialPassword: 'ពាក្យ សម្ងាត់ ដើម',
                    pleaseInputAPassword: 'សូម បញ្ចូល ពាក្យ សម្ងាត់',
                    confirmPassword: 'អះអាង ពាក្យ សម្ងាត់',
                    thePasswordsEnteredTwiceAreDifferent: 'ពាក្យ សម្ងាត់ ដែល បាន បញ្ចូល ពីរ ដង មិន ដូចគ្នា ទេ !',
                    headPortrait: 'អាវតារ',
                    fullName: 'ឈ្មោះ:',
                    pleaseEnterYourName: 'សូម បញ្ចូល ឈ្មោះ មួយ',
                    nickname: 'ឈ្មោះ សំឡេង',
                    department: 'ហត្ថលេខា',
                    excellentStaff: 'ភ្ញៀវ ខ្ពស់',
                    sessionIdentity: 'អត្តសញ្ញាណ សម័យ',
                    markTheSessionRecordAsBelongingToTheEmployee: 'ថត សម័យ ស្លាក របស់ ស្លាក គឺ ជា អ្នក ភ្ជាប់',
                    telephone: 'ទូរស័ព្ទ',
                    jobNumber: 'ការងារ លេខ ។',
                    role: 'រលូន',
                    pleaseSelectARole: 'សូម ជ្រើស តំណ',
                    preservation: 'រក្សាទុក',
                    cancel: 'បោះបង់',
                    addedSuccessfully: 'បាន បន្ថែម ដោយ ជោគជ័យ !',
                    modificationSucceeded: 'បាន កែប្រែ ដោយ ជោគជ័យ !',
                    newEmployees: 'ម៉ាស៊ីន ភ្ញៀវ ថ្មី',
                    editEmployee: 'កែសម្រួល ការងារ',
                },
                detail: {
                    viewDetails: 'មើល សេចក្ដី លម្អិត',
                    accountNumber: 'លេខ គណនី',
                    headPortrait: 'អាវតារ',
                    fullName: 'ឈ្មោះ:',
                    nickname: 'ឈ្មោះ សំឡេង',
                    department: 'ហត្ថលេខា',
                    excellentStaff: 'ភ្ញៀវ ខ្ពស់',
                    yes: 'បាន',
                    no: 'គ្មាន ទេ',
                    sessionIdentity: 'អត្តសញ្ញាណ សម័យ',
                    markTheSessionRecordAsBelongingToTheEmployee: 'ថត សម័យ ស្លាក របស់ ស្លាក គឺ ជា អ្នក ភ្ជាប់',
                    telephone: 'ទូរស័ព្ទ',
                    jobNumber: 'ការងារ លេខ ។',
                    role: 'រលូន',
                },
            },
            roleManage: {
                list: {
                    menu: 'ម៉ឺនុយ',
                    functionalCategory: 'ប្រភេទ មុខងារ',
                    functionalSubclass: 'ថ្នាក់ រង អនុគមន៍',
                    deletedSuccessfully: 'បាន លុប ដោយ ជោគជ័យ',
                    NewRole: 'ភាព ថ្មី',
                    role: 'រលូន',
                    dataPermissions: 'សិទ្ធិ ទិន្នន័យ ៖',
                    edit: 'កែសម្រួល',
                    areYouSureYouWantToDeleteTheRole: 'ល្អ ដើម្បី លុប តំណ',
                    determine: 'កំណត់@ info: whatsthis',
                    cancel: 'បោះបង់',
                    delete: 'លុប',
                    applicationPermission: 'អនុវត្ត សិទ្ធិ',
                },
                edit: {
                    youCanOnlySeeYourOwnSessionData: 'អ្នក អាច មើល តែ ទិន្នន័យ សម័យ ផ្ទាល់ របស់ អ្នក',
                    youCanViewTheSessionDataOfYourDepartmentAndSubordinateDepartments: 'អ្នក អាច មើល ទិន្នន័យ សម័យ របស់ ភាគ និង ចំណុច ខ្ពស់',
                    menu: 'ម៉ឺនុយ',
                    functionalCategory: 'ប្រភេទ មុខងារ',
                    functionalSubclass: 'ថ្នាក់ រង អនុគមន៍',
                    successfullyAdded: 'ជោគជ័យ ថ្មី',
                    modifiedSuccessfully: 'ការ កែប្រែ បាន ជោគជ័យ',
                    edit: 'កែសម្រួល',
                    cancel: 'បោះបង់',
                    confirm: 'អះអាង',
                    roleName: 'ឈ្មោះ រាង',
                    pleaseEnterTheRoleName: 'សូម បញ្ចូល ឈ្មោះ role',
                    dataAuthority: 'សិទ្ធិ ទិន្នន័យ',
                    youCanViewCompanyWideSessionData: 'អាច មើល ទិន្នន័យ សម័យ ទូរស័ព្ទ',
                    applicationPermission: 'អនុវត្ត សិទ្ធិ',
                },
            },
            callDetail: {
                index: {
                    conversationProcess: 'ដំណើរការ សម័យ',
                    generateProcess: 'ដំណើរការ បង្កើតComment',
                    addProcess: 'បន្ថែម ដំណើរការ',
                    cancel: 'បោះបង់',
                    complete: 'បញ្ចប់',
                    edit: 'កែសម្រួល',
                    theSettingWillBeSuccessfulLater: 'កំណត់ ដើម្បី មើល ជោគជ័យ ក្រោយ !',
                    previous: 'អត្ថបទ មុន',
                    next: 'អត្ថបទ បន្ទាប់',
                    debuggingMode: 'របៀប បំបាត់ កំហុស',
                    afterActivationIfTheMessageMatchesTheRulesOfKeyEventsSupervisionItemsCustomerLabelsOrKnowledgePointRulesTheRuleNameThatTheMessageMatchesAndTheKnowledgePointNameOfTheKnowledgeBaseWillBeDisplayed: 'បន្ទាប់ ពី សារ ត្រូវ បាន ធ្វើ សកម្ម ប្រសិន បើ វា ផ្គូផ្គង ច្បាប់ ព្រឹត្តិការណ៍ គ្រាប់ ចុច ការ ត្រួតពិនិត្យ ធាតុ ស្លាក របស់ អ្នក ភ្ញៀវ ឬ ចំណុច ពាក្យ សម្គាល់ ឈ្មោះ នៃ ច្បាប់ ដែល ផ្គូផ្គង សារ និង ឈ្មោះ ចំណុច ចំណុច ស្គាល់ នៃ មូលដ្ឋាន ស្គាល់ ត្រូវ បាន បង្ហាញ ។',
                    seeLater: 'មើល បន្ទាប់',
                    determine: 'កំណត់@ info: whatsthis',
                    conversationalInsights: 'សម័យ សម័យ',
                    customerInsight: 'សមត្ថភាព របស់ អ្នក ភ្ជាប់',
                    knowledgePointRecommendation: 'ការ ផ្ដល់ អនុសាសន៍ ចំណុច ចំណុច',
                    comment: 'សេចក្តី អធិប្បាយ',
                    sessionQuality: 'គុណភាព សម័យ',
                    setToListenLaterSuccessfully: 'កំណត់ ដើម្បី ស្ដាប់ ជោគជ័យ ក្រោយ !',
                    listenLater: 'ស្ដាប់ បន្ទាប់',
                    seekCounselingSuccess: 'ស្វែងរក ជោគជ័យ !',
                    altogether: 'សរុប',
                    appearsAt: 'បង្ហាញ \'',
                    commentsPublishedSuccessfully: 'បាន បញ្ចូល សេចក្ដី អធិប្បាយ ដោយ ជោគជ័យ',
                    callRecording: 'ការ ថត ហៅ',
                    addedSuccessfully: 'បាន បន្ថែម ដោយ ជោគជ័យ',
                    shareWithColleagues: 'ចែករំលែក ជាមួយ អ្នក ភ្ញៀវ',
                    shareWithCustomers: 'ចែករំលែក ជាមួយ ម៉ាស៊ីន ភ្ញៀវ',
                    resumptionDetails: 'សេចក្ដី លម្អិត នៃ ការ បើក ឡើង វិញ',
                    addToCaseBase: 'បន្ថែម ទៅ បណ្ណាល័យ អក្សរ',
                    shareCases: 'ការ ចែក រំលែក',
                    seekCounseling: 'ស្វែងរក ការ ជំនួយ',
                    sessionRecord: 'ថត សម័យ',
                    businessRecord: 'ថត ពាក្យ',
                    keywordSearch: 'ស្វែងរក ពាក្យ គន្លឹះ',
                    whole: 'ទាំង អស់',
                    pleaseEnterACommentEnterToNotifyOthersAndEnterToAddATopic: 'សូម បញ្ចូល សេចក្ដី អធិប្បាយ បញ្ចូល @ ដើម្បី ជូនដំណឹង ផ្សេង ទៀត បញ្ចូល # ដើម្បី បន្ថែម ខ្សែស្រឡាយ',
                    subscriptionSession: 'ជាវ ជាវ ទៅ សម័យ',
                    afterSubscribingYouWillBeNotifiedWhenThereAreNewHelpCommentsAndReplies: 'បន្ទាប់ ពី ការ ជាវ នៅពេល មាន ជំនួយ សេចក្តី អធិប្បាយ និង ឆ្លើយតប អ្នក នឹង ទទួល ការ ជូនដំណឹង និង កម្មវិធី រំលឹក ។',
                },
            },
            coachTask: {
                index: {
                    employeeName: 'ឈ្មោះ ម៉ាស៊ីន ភ្ញៀវ',
                    customerName: 'ឈ្មោះ ម៉ាស៊ីន ភ្ញៀវ',
                    source: 'ប្រភព',
                    viewSessionRecords: 'មើល កំណត់ សម័យ',
                    coachingStatus: 'ស្ថានភាព បង្ហាញ',
                    helpTime: 'ពេលវេលា សម្រាប់ ជំនួយ',
                    counselingTime: 'ពេល វេលា សំណួរ',
                    helpContent: 'មាតិកា ជំនួយ',
                    coachingOperation: 'ប្រតិបត្តិការ បង្ហាញ',
                    areYouSureYouWantToIgnoreIt: 'តើ អ្នក ពិត ជា ចង់ មិន អើពើ វា ឬ ?',
                    determine: 'កំណត់@ info: whatsthis',
                    cancel: 'បោះបង់',
                    ignoreHelp: 'មិន អើពើ ជំនួយ',
                    coaching: 'បង្ហាត់ បង្ហាញ',
                    viewCoaching: 'មើល ការ បង្ហាញ',
                    areYouSureToReturnToCounseling: 'តើ អ្នក ពិត ជា ត្រឡប់ ទៅ ការ ភ្ញៀវ ។',
                    returnToPendingCoaching: 'បន្ត ទៅ កាន់ ការ ជំនួយ',
                    tutor: 'អ្នក ទទួល ប្រយោជន៍',
                    helpSeekingStatus: 'ស្ថានភាព ជំនួយ',
                    recentCoachingTime: 'ពេលវេលា សំណួរ ថ្មីៗ',
                    operation: 'ប្រតិបត្តិការ',
                    ignoreSuccess: 'មិន អើពើ ការ ជោគជ័យ !',
                    recoverySucceeded: 'បាន ជោគជ័យ !',
                    successfulCoaching: 'ការ បង្ហាញ ជោគជ័យ !',
                    myMission: 'ភារកិច្ច របស់ ខ្ញុំ',
                    selectCoachingStatus: 'ជ្រើស ស្ថានភាព បង្ហាញ',
                    whole: 'ទាំង អស់',
                    iAskedForHelp: 'ខ្ញុំ សួរ ជំនួយ ។',
                    signOut: 'ចេញ',
                    submit: 'ដាក់ ស្នើ',
                    helpPerson: 'សួរ ជំនួយ',
                    customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                    toBeCoached: 'ដើម្បី បង្ហាញ',
                    counselingSuggestions: 'សំណួរ សំណួរ',
                    pleaseEnterCoachingSuggestions: 'សូម បញ្ចូល ការ ស្នើ បង្ហាញ',
                },
            },
            coachTaskCenter: {
                title: 'មជ្ឈមណ្ឌល ភារកិច្ច',
                list: {
                    taskName: 'ឈ្មោះ ភារកិច្ច',
                    lessonGroup: 'ថ្នាក់ វត្ថុ',
                    lessonName: 'សំឡេង',
                    taskType: 'ប្រភេទ ភារកិច្ច',
                    taskStatus: 'ស្ថានភាព ភារកិច្ច',
                    taskExecutionInfo: 'ស្ថានភាព អនុញ្ញាត',
                    totalCount: 'ចំនួន មនុស្ស ដែល ត្រូវ ប្រតិបត្តិ',
                    executeCount: 'ចំនួន ដែល បាន ប្រតិបត្តិ',
                    executeRate: 'អត្រា ការ អនុញ្ញាត',
                    completeCount: 'ចំនួន បាន បញ្ចប់',
                    completeRate: 'អត្រា បំពេញComment',
                    commitCount: 'ចំនួន ការ ផ្ទៀងផ្ទាត់',
                    commitRate: 'អត្រា បន្ទាប់',
                    excellentRate: 'អត្រា ខ្ពស់',
                    taskTime: 'ពេលវេលា ភារកិច្ច',
                    option: 'ប្រតិបត្តិការ',
                    edit: 'កែសម្រួល',
                    taskDetail: 'ទិន្នន័យ ភារកិច្ច',
                    delete: 'លុប',
                    new: 'សៀវភៅ ថ្មី',
                    taskTypeAll: 'ទាំង អស់',
                    taskTypePractice: 'ដំណើរការ',
                    taskTypeTest: 'ការ ព្រួញ',
                    taskStatusNotStarted: 'មិន បាន ចាប់ផ្ដើម',
                    taskStatusRunning: 'កំពុង វឌ្ឍន៍',
                    taskStatusEnd: 'បាន បញ្ចប់',
                    taskStatusInvalid: 'គ្មាន សិទ្ធិ',
                    unlimitedTime: 'ពេលវេលា គ្មាន កំណត់',
                    to: 'ទៅ',
                    deleteConfirm: 'បន្ទាប់ ពី លុប ថត សិក្សា ទាំងអស់ នៅ ក្រោម ភារកិច្ច នេះ នឹង ត្រូវ បាន ជម្រះ ។ តើ អ្នក ពិត ជា លុប ពួកវា ឬ ?',
                    deleteSuccess: 'បាន លុប ភារកិច្ច ដោយ ជោគជ័យ',
                },
                edit: {
                    addTask: 'បោះពុម្ព ផ្សាយ ភារកិច្ច ថ្មី',
                    editTask: 'កែសម្រួល បោះពុម្ព ភារកិច្ច',
                    publishSuccess: 'បាន បោះពុម្ព ដោយ ជោគជ័យ',
                    publishFailed: 'បាន បរាជ័យ',
                    updateSuccess: 'ធ្វើ ឲ្យ ទាន់សម័យ បាន ជោគជ័យ',
                    updateFailed: 'បាន បរាជ័យ ក្នុង ការ ធ្វើ ឲ្យ ទាន់ សម័យ',
                    cannotBeNull: 'មិន អាច ទទេ',
                    explain: 'សេចក្ដី ពិពណ៌នា',
                    taskDescExtra: '( វា នឹង ត្រូវ បាន បង្ហាញ នៅ ចូល {0})',
                    taskTargetObj: 'ការ បោះពុម្ព ផ្សាយ វត្ថុComment',
                    isEnable: 'ស្ថានភាព បែបផែន',
                    dialogueMode: 'របៀប ប្រអប់Name',
                    voice: 'សំឡេង',
                    text: 'អត្ថបទ',
                    userPortrait: 'ច្រក អ្នកប្រើ',
                    difficultyLevel: 'ពិបាក',
                    limitDuration: 'ដែន កំណត់ កាលបរិច្ឆេទ',
                    tipLabel: 'ព័ត៌មាន',
                    tipTooltip: 'អនុញ្ញាត ឲ្យ អ្នក ភារកិច្ច មើល សេចក្ដី យោងName',
                    limitTimes: 'ចំនួន សិទ្ធិ',
                    time: 'ពេលវេលា',
                    gradingStandart: 'លក្ខខណ្ឌ ពិន្ទុ',
                    gradingStandartDescAffix: '(កម្មវិធី ទំនាក់ទំនង បច្ចុប្បន្ន',
                    gradingStandartDescSuffix: 'ចំណុច សិទ្ធិ និយាយ {0} ចំណុច ខ្លាំង {1} ចំណុច ល្បឿន {2} ចំណុច)',
                    completeStandart: 'ការ បញ្ចប់ ភារកិច្ច',
                    byTimes: 'តាម ចំនួន ពេលវេលា',
                    byScore: 'តាម ពិន្ទុ',
                    completeByTimes: 'ចំនួន សកម្មភាព',
                    times: 'ពេលវេលាName',
                    score: 'ចំណុច',
                    anyTimes: 'មួយ',
                    getScore: 'ពិន្ទុ',
                    offLimitDuration: 'ថិរវេលា គ្មាន កំណត់',
                    onLimitDuration: 'ប្រវែង ពេលវេលា',
                    commitScore: 'ស្តង់ដារ ពិន្ទុ',
                    excellentScore: 'ស្តង់ដារ ខ្ពស់ ពិន្ទុ',
                    offLimitTime: 'ពេលវេលា គ្មាន កំណត់',
                    onLimitTime: 'ពេលវេលា កំណត់',
                },
            },
            homePage: {
                common: {
                    useMessage: {
                        hi: 'ហាំ,',
                    },
                    callDynamic: {
                        today: 'ថ្ងៃ នេះ@ item: inlistbox',
                        yesterday: 'ម្រាម ថ្ងៃ ។',
                        sessions: 'សម័យ',
                    },
                    todoList: {
                        strip: 'អត្ថបទ',
                        theSessionIsAddedTolistenLater: 'សម័យ ត្រូវ បាន ចូល រួម " ស្ដាប់ ក្រោយ"',
                        askYouForHelp: 'សួរ អ្នក ជំនួយ',
                        iHopeToContactYouLater: 'រំពឹង ទុក ទំនាក់ទំនង',
                        lookingForwardToSendingTheInformationLater: 'រំពឹង ទុក ឲ្យ ផ្ញើ ឧបករណ៍ បន្ទាប់',
                        dialogueRisk: 'ការ និយាយ មាន ចំណុច ជម្រើស',
                        tutored: 'បង្ហាញ',
                        goToCounseling: 'ទៅ កាន់ ការ ជំនួយ',
                        contacted: 'ទំនាក់ទំនង',
                        hasBeenSent: 'ផ្ញើ',
                        areYouSureYouWantToIgnoreIt: 'តើ អ្នក ពិត ជា ចង់ មិន អើពើ វា ឬ ?',
                        determine: 'កំណត់@ info: whatsthis',
                        cancel: 'បោះបង់',
                        ignore: 'មិន អើពើ',
                        checked: 'បាន មើលComment',
                    },
                    callListItem: {
                        strip: 'អត្ថបទ',
                        learned: 'បាន លុប',
                        keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                        totalImplementationRateOfSupervisionItems: 'អត្រា ការ អនុញ្ញាត ជាទូទៅ នៃ ធាតុ ភ្ជាប់',
                    },
                },
                index: {
                    operationSucceeded: 'ប្រតិបត្តិការ បាន ជោគជ័យ !',
                    sessionDynamics: 'ថាមវន្ត សម័យ',
                    my: 'មុន',
                    department: 'ហត្ថលេខា',
                    company: 'ក្រុមហ៊ុន',
                    toDoList: 'ការងារ ត្រូវ ធ្វើ',
                },
            },
            teamAnalysis: {
                index: {
                    effectiveCallVolumenumber: 'កម្រិត សំឡេង ហៅ បែបផែន (ឯកតា)',
                    bestPractices: 'សកម្មភាព ល្អ បំផុតName',
                    averageDurationOfASingleCallminutes: 'ថិរវេលា ហៅ តែ មួយ មធ្យម (នាទី)',
                    totalCallVolumePCs: 'ហៅ សរុប (ឯកតា)',
                    totalTalkTimehours: 'ថិរវេលា សរុប',
                    speakingPercentagepercentage: 'ភាគរយ និយាយ (ភាគរយ)',
                    maximumContinuousSpeakingTimeminutes: 'ពេលវេលា និយាយ បន្ត អតិបរមា (នាទី)',
                    numberOfIndepthDiscussionsPCs: 'ចំនួន ការ ពិពណ៌នា កម្រិត (ឯកតា)',
                    maximumCustomerTalkminutes: 'និយាយ អតិបរមា (នាទី)',
                    questionFrequencyPCs: 'ប្រេកង់ សំណួរ (ឯកតា)',
                    averageValue: 'មធ្យម',
                    selectDate: 'ជ្រើស កាលបរិច្ឆេទ',
                    personnel: 'ភ្ញៀវ',
                    pleaseSelect: 'សូម ជ្រើស',
                    callRange: 'ជួរ ហៅ',
                    conversationActivity: 'សកម្មភាព សម័យ',
                    conversationAction: 'សកម្មភាព សម័យ',
                    keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                    callRecord: 'ការ ថត ហៅ',
                    filter: 'តម្រង ៖',
                    conversation: 'ហៅ',
                    minute: 'នាទី',
                    sale: 'ការងារ',
                },
            },
            saleClientCenter: {
                detail: {
                    index: {
                        january: 'ខាង ចុងក្រោយ',
                        numberOfCalls: 'ចំនួន ហៅ',
                        accountInformation: 'ព័ត៌មាន គណនី',
                        month: 'ខែ',
                        today: 'ថ្ងៃ នេះ@ item: inlistbox',
                        customerDetails: 'សេចក្ដី លម្អិត របស់ ម៉ាស៊ីន ភ្ញៀវ',
                        searchKeywordsInCommunicationContent: 'ស្វែងរក ពាក្យ គន្លឹះ ក្នុង មាតិកា ទំនាក់ទំនង',
                        allMembers: 'សមាជិក ទាំងអស់',
                        reset: 'កំណត់ ឡើង វិញ',
                        query: 'សំណួរ',
                        allTrip: 'បង្ហាញ ថ្ងៃ ពេញលេញ',
                        contactOverview: 'ទិដ្ឋភាព ទូទៅ ទំនាក់ទំនង',
                        lastContact: 'ទំនាក់ទំនង ចុងក្រោយ',
                        nextContact: 'ទំនាក់ទំនង បន្ទាប់',
                        previous: 'អត្ថបទ មុន',
                        next: 'អត្ថបទ បន្ទាប់',
                        viewDetails: 'មើល សេចក្ដី លម្អិត',
                        contactDynamics: 'ទំនាក់ទំនង',
                        lastYear: 'ឆ្នាំ មុន',
                        lastCall: 'ហៅ ចុងក្រោយ',
                        hotTopicsForDiscussion: 'ប្រធាន បទ ពិសោធ',
                        totalInTheLastYear: 'នៅ ឆ្នាំ ចុងក្រោយ ។',
                        callTimes: 'ហៅ រង',
                    },
                },
                list: {
                    index: {
                        risk: 'លទ្ធផល',
                        have: 'បាន',
                        nothing: 'គ្មាន ទេ',
                        channel: 'ឆានែល',
                        callRecording: 'ការ ថត ហៅ',
                        enterpriseWeChatConversation: 'សម័យ micro-section Enterprise',
                        enterpriseWeChatCall: 'សៀវភៅ មីក្រូ',
                        followUpSuggestions: 'ការ អនុសាសន៍ តាម ក្រោយ',
                        customer: 'មជ្ឈមណ្ឌល ម៉ាស៊ីន ភ្ញៀវ',
                        followUp: 'ធ្វើ តាម តំណ',
                        personInCharge: 'ផ្នែក ត្រួត ព្រួញ',
                        recentFollowup: 'បាន ធ្វើ តាម ថ្មីៗ ។',
                        lastContactTime: 'ពេលវេលា ទំនាក់ទំនង ចុងក្រោយ',
                        operation: 'ប្រតិបត្តិការ',
                        see: 'ទិដ្ឋភាព',
                        exceed: 'បន្ថែម',
                        noActivityForMoreThanDays: 'ថ្ងៃ ដោយ គ្មាន សកម្មភាព',
                        lately: 'ថ្មីៗ',
                        risksOccurredInTheLastDays: 'រហូត សំណុំ បែបផែន កើត ឡើង ក្នុង ថ្ងៃ មើល',
                        savedSuccessfully: 'រក្សាទុក ដោយ ជោគជ័យ',
                        today: 'ថ្ងៃ នេះ@ item: inlistbox',
                        allDepartments: 'ភាគ ទាំងអស់',
                        allMembers: 'សមាជិក ទាំងអស់',
                        customerName: 'ឈ្មោះ ម៉ាស៊ីន ភ្ញៀវ',
                        reset: 'កំណត់ ឡើង វិញ',
                        query: 'សំណួរ',
                        customers: 'ម៉ាស៊ីន ភ្ញៀវ',
                        showTheContactInformationBetweenEmployeesAndCustomersInWhichPinkBubblesAreCustomerMessagesAndBlueOnesAreEmployeeMessagesTheLargerTheProportionOfSpeechesTheLargerTheBubbles: 'បង្ហាញ ទំនាក់ទំនង រវាង ការងារ និង ភ្ញៀវ ដែល ខ្ពស់ ជា សារ ភ្ញៀវ និង ព័ត៌មាន ខៀវ គឺ សារ របស់ អ្នក ។ ធំ ជាង សមាមាត្រ នៃ និយាយ ធំ ច្រើន ។',
                        riskAllocation: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                        preservation: 'រក្សាទុក',
                        pleaseEnter: 'សូម បញ្ចូល',
                        noActivityForDays: 'ថ្ងៃ ដោយ គ្មាន សកម្មភាព',
                        riskSemanticsWithinDays: 'រហូត សំណុំ បែបផែន កើត ឡើង ក្នុង ថ្ងៃ មើល',
                        addRiskSemantics: 'បន្ថែម គ្រោងការណ៍',
                        semanticTags: 'ស្លាក សញ្ញា ៖',
                        standardSentence: 'ពាក្យ ស្តង់ដារ ៖',
                    },
                    components: {
                        advancedFilter: {
                            components: {
                                list: {
                                    index: {
                                        addNewConditions: 'បន្ថែម លក្ខខណ្ឌ ថ្មី',
                                    },
                                },
                            },
                            index: {
                                meetAllOfTheFollowingConditions: 'កំណត់ លក្ខខណ្ឌ ទាំងអស់ ដូច ខាង ក្រោម ទាំងអស់',
                            },
                        },
                        advancedFilterButton: {
                            index: {
                                screen: 'តម្រង',
                                pleaseSelectFilteringCriteria: 'សូម ជ្រើស លក្ខខណ្ឌ តម្រង',
                            },
                        },
                    },
                },
                components: {
                    businessStage: {
                        index: {
                            changeOpportunityStage: 'ផ្លាស់ប្ដូរ វិធីសាស្ត្រ',
                            theCurrentStageIs: 'រូបរាង បច្ចុប្បន្ន គឺ ជា ម',
                            ConfirmToChangeItTo: '], អះអាង ដើម្បី ផ្លាស់ប្ដូរ វា',
                            IsIt: ']?',
                            StageCoStay: '] ស្ថានភាព សរុប',
                            day: 'ថ្ងៃStencils',
                            start: 'ចាប់ផ្ដើម',
                            end: 'បញ្ចប់',
                            orderInput: 'កា រកំណត់ លំដាប់',
                            restart: 'ចាប់ផ្ដើម ឡើង វិញ',
                            pleaseConfigureTheSalesStageInformation: 'សូម កំណត់ រចនា សម្ព័ន្ធ ព័ត៌មាន វិសាលគមន៍',
                            reasonForDocumentInput: 'មូលហេតុ សម្រាប់ បាត់បង់ លំដាប់ ៖',
                            completeOrderInput: 'ចេញ',
                            pleaseSelectTheReason: 'សូម ជ្រើស មូលដ្ឋាន',
                        },
                        modal: {
                            customerDynamics: {
                                theManagerSuggests: 'ការ គ្រប់គ្រង ផ្ដល់ អនុសាសន៍ ៖',
                            },
                            index: {
                                sessionDetails: 'សេចក្ដី លម្អិត សម័យ',
                                customerDynamics: 'Dynamics របស់ ម៉ាស៊ីន ភ្ញៀវ',
                                riskPoint: 'ចំណុច ជម្រើស',
                                followUpSuggestions: 'ការ អនុសាសន៍ តាម ក្រោយ',
                            },
                            sessionDetails: {
                                common: 'សរុប',
                                currentlyViewingThe: 'មើល បច្ចុប្បន្ន លេខ ។',
                                sessions: 'សម័យ',
                            },
                        },
                    },
                    businessTitle: {
                        index: {
                            theCurrentStageHasStayed: 'ថេប បច្ចុប្បន្ន បាន បញ្ឈប់',
                            day: 'ថ្ងៃStencils',
                        },
                    },
                    business: {
                        index: {
                            reEnableOpportunity: 'អាច បើក ឡើង វិញ',
                        },
                    },
                    customerTag: {
                        index: {
                            label: 'ស្លាក',
                        },
                    },
                    moreCustomer: {
                        index: {
                            essentialInformation: 'ព័ត៌មាន មូលដ្ឋាន',
                            cancel: 'បោះបង់',
                            confirm: 'អះអាង',
                            customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                            currentFollowupStage: 'ថិរវេលា បន្ទាត់ បច្ចុប្បន្ន',
                            telephone: 'ទូរស័ព្ទ',
                            followUpDays: 'ថ្ងៃ តាម បន្ទាត់',
                            day: 'ថ្ងៃStencils',
                            remarks: 'ពាក្យ បញ្ជា',
                            channelPreference: 'ចំណូលចិត្ត ឆានែល',
                            hello: 'Hello ។',
                            customFields: 'វាល ផ្ទាល់ខ្លួន',
                            opportunityAmount: 'មាត្រ វិមាត្រ វិមាត្រ',
                            focus: 'ពិបាក',
                            customerInformation: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
                            viewMoreCustomerInformation: 'មើល ព័ត៌មាន របស់ ម៉ាស៊ីន ភ្ញៀវ ផ្សេងទៀត',
                        },
                    },
                    table: {
                        components: {
                            row: {
                                row0: {
                                    keyEvents: 'ព្រឹត្តិការណ៍ សោ ៖',
                                },
                                row1: {
                                    customerDynamics: 'Dynamics របស់ ម៉ាស៊ីន ភ្ញៀវ',
                                    common: 'សរុប',
                                    barDynamic: 'ថាមវន្ត',
                                },
                                row2: {
                                    riskPoint: 'ចំណុច ជម្រើស',
                                    common: 'សរុប',
                                    risks: 'អត្ថបទ',
                                },
                                row3: {
                                    followUpSuggestions: 'ការ អនុសាសន៍ តាម ក្រោយ',
                                    intelligentRecommendation: 'អនុសាសន៍ ជម្រះ',
                                    strip: 'អត្ថបទ',
                                    managersSuggestATotalOf: 'កម្មវិធី គ្រប់គ្រង ផ្ដល់ អនុសាសន៍ សរុប',
                                    recommendedByManagers: 'ផ្ដល់ អនុសាសន៍ របស់ កម្មវិធី គ្រប់គ្រងComment',
                                    creationTime: 'ពេលវេលា បង្កើតComment',
                                    administratorSuggestions: 'ព័ត៌មាន ជំនួយ របស់ អ្នក គ្រប់គ្រងComment',
                                    suggestionsForNewManagers: 'ព័ត៌មាន អំពី កម្មវិធី គ្រប់គ្រង ថ្មី',
                                },
                            },
                        },
                        index: {
                            typeTime: 'ប្រភេទ/ចេញ',
                        },
                    },
                    userInfo: {
                        index: {
                            personInCharge: 'ផ្នែក ត្រួត ព្រួញ',
                            recentFollower: 'បាន ធ្វើ តាម ថ្មីៗ ។',
                            startTime: 'ពេលវេលា ដំបូង ដែល ទៅ ការ',
                            followUpDays: 'ថ្ងៃ តាម បន្ទាត់',
                            day: 'ថ្ងៃStencils',
                            remarks: 'ពាក្យ បញ្ជា',
                        },
                    },
                },
            },
            studyAnalysis: {
                index: {
                    teamMembers: 'សមាស ក្រុមName',
                    membersLearnTheTotalNumberOfOtherPeoplesConversationsdeDuplicationLookingUpTheDetailsOfTheConversationAndClickingTheRecordingAndPlayingIsRegardedAsLearningOnce: 'ចំនួន សរុប នៃ សម័យ ដែល សមាជិក បាន រៀន ពី ផ្សេង ទៀត (de-plication) ។ ការ មើល សេចក្ដី លម្អិត សម័យ និង ចុច លើ ការ ថត ដើម្បី ចាក់ ត្រូវ បាន ទាក់ទង ជា ការ សិក្សា មួយ ។',
                    totalNumberOfStudies: 'ចំនួន សរុប',
                    theTotalNumberOfCommentsAndRepliesFromMembersToOtherPeoplesSessionsdeDuplication: 'ចំនួន សរុប នៃ សេចក្ដី អធិប្បាយ និង ឆ្លើយតប ដែល បាន ចាប់ផ្ដើម ដោយ សមាជិក ទៅ សម័យ របស់ មនុស្ស ផ្សេង (Deduplication)',
                    totalNumberOfInteractions: 'ចំនួន អភិវឌ្ឍន៍ សរុប',
                    learnTheSumOfConversationCallDuration: 'ថិរវេលា ហៅ សម័យ ដែល បាន រៀនName',
                    lengthOfStudy: 'កាលបរិច្ឆេទ បង្ហាញ',
                    totalNumberOfMembersWhoInitiatedTheConversationToOthers: 'ចំនួន សរុប សំណើ សម្រាប់ ជំនួយ ពី សមាជិក ទៅ សម័យ របស់ មនុស្ស ផ្សេង',
                    totalNumberOfRequests: 'ចំនួន សរុប សំណើ សម្រាប់ ជំនួយ',
                    totalNumberOfMembersCounselingOthersForHelpdeDuplication: 'ចំនួន សរុប នៃ សមាជិក ការ ទទួល ជំនួយ ពី ផ្សេង ទៀត (de- deplication)',
                    totalCounseling: 'ចំនួន បង្រៀន សរុប',
                    totalNumberOfMemberSessionsToOthersAddedToTheCaseBasedeDuplication: 'ចំនួន សរុប នៃ សម័យ របស់ សមាជិក ទៅ កាន់ ផ្សេង ទៀត ដែល បាន បន្ថែម ទៅ បណ្ណាល័យ ករណី (de- doplication)',
                    addCase: 'បន្ថែម អក្សរ',
                    totalNumberOfSubscriptionsMadeByMembersToOtherPeoplesSessionsdeDuplication: 'ចំនួន ការ ជាវ សរុប របស់ សមាជិក ទៅ សម័យ របស់ មនុស្ស ផ្សេង ទៀត (deduplication)',
                    subscribe: 'ជាប់ ជាវ',
                    totalNumberOfSessionsCommunicatedByMembers: 'ចំនួន សរុប របស់ សម័យ ដែល ទាក់ទង ដោយ សមាជ្ញ',
                    totalSessions: 'សម័យ សរុប',
                    theTotalNumberdeDuplicationOfAMembersOwnSessionItIsDeemedToBeAReplayIfTheMemberHasCheckedTheSessionDetailsAndClickedTheRecordingAndPlayback: 'ចំនួន សរុប នៃ សមាជិក ដែល ចាក់ សម័យ របស់ ពួក វា ឡើង វិញ (de-plication) ដោយ ស្វែងរក សេចក្ដី លម្អិត សម័យ និង ចុច លើ ការ ថត ដើម្បី ចាក់ ជា ការ ចាក់ ឡើង វិញ ។',
                    totalNumberOfDoubleDisk: 'ចំនួន ឡើង វិញ សរុប',
                    totalNumberOfDuplicateDiskTotalNumberOfSessions: 'ចំនួន សរុប របស់ សម័យ ឡើង វិញ/ ចំនួន សរុប របស់ សម័យ * 100%',
                    proportionOfDoubleDisk: 'ភាគរយ នៃ ការ ធ្វើ ឡើង វិញ',
                    summationOfConversationCallDurationOfDuplicateDisk: 'សរុប នៃ ថិរវេលា ទំនាក់ទំនង របស់ ថាស ពីរ ។',
                    resumptionDuration: 'ថិរវេលា ខ្ពស់',
                    totalNumberOfRequestsForHelpFromMembersForTheirOwnSessionsdeDuplication: 'ចំនួន សរុប របស់ សមាជ្ញ',
                    theTotalNumberOfCommentsincludingRepliesReceivedByOthersInAMembersSession: 'ចំនួន សរុប នៃ សេចក្ដី អធិប្បាយ (រួម បញ្ចូល ឆ្លើយតប) ដែល បាន ទទួល ដោយ ផ្សេង ទៀត សម្រាប់ សម័យ របស់ សមាជ្ញ',
                    theTotalNumberOfSessionsOfMembersAddedToTheCaseBaseByOthersdeDuplication: 'ចំនួន សរុប នៃ សម័យ របស់ សមាជិក ត្រូវ បាន បន្ថែម ទៅ បណ្ណាល័យ ករណី ដោយ ផ្សេង ទៀត (de- ដកស្រង់)',
                    theTotalNumberOfMemberSessionsSubscribedByOthersdeDuplication: 'ចំនួន សរុប នៃ សម័យ របស់ សមាជិក ដែល បាន ជាវ ជាវ ដោយ ផ្សេង ទៀត (deduplication)',
                    askForHelpInTheLastMonth: 'ខែ ចុងក្រោយ សម្រាប់ ជំនួយ ។',
                    lastTimeForHelp: 'ពេលវេលា ចុង ក្រោយ ដើម្បី សួរ ជំនួយ',
                    operation: 'ប្រតិបត្តិការ',
                    viewAllSessionsInTheLastMonth: 'មើល សម័យ ទាំងអស់ ក្នុង ខែ ចុងក្រោយ',
                    allDepartments: 'ភាគ ទាំងអស់',
                    reset: 'កំណត់ ឡើង វិញ',
                    query: 'សំណួរ',
                    altogether: 'សរុប',
                    secondSession: 'សម័យ ដើម',
                },
            },
            checkPointTest: {
                components: {
                    testSelectComponent: {
                        currentTestItems: 'គម្រោង សាកល្បង បច្ចុប្បន្ន ៖',
                        supervisionItem: 'ធាតុ មួយ',
                        keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                    },
                },
                index: {
                    pleaseCheckTheMonitoringItemsOrKeyEventsToBeTestedAndEnsureThatThereAreCallsInTheSimulatedDialogue: 'សូម ពិនិត្យ មើល ធាតុ ត្រួតពិនិត្យ ឬ ព្រឹត្តិការណ៍ សោ ដែល អ្នក ចង់ សាកល្បង ហើយ ប្រាកដ ថា មាន មាតិកា និយាយ នៅ ក្នុង ការ ក្លែង ធ្វើ ការ សម្រាក',
                },
            },
            executionAnalysis: {
                index: {
                    executiveForceAnalysis: 'ការ វិភាគ ប្រតិបត្តិ',
                },
            },
            konwledgeBase: {
                detail: {
                    components: {
                        richTextList: {
                            process: 'ដំណើរការ 1',
                            technologicalProcess: 'ដំណើរការ',
                            newProcess: 'ដំណើរការ ថ្មី',
                        },
                    },
                    index: {
                        upload: 'ផ្ទុក ឡើង លើ',
                        preservation: 'រក្សាទុក',
                        newlyBuild: 'ថ្មី',
                        cancel: 'បោះបង់',
                        name: 'ឈ្មោះ:',
                        describe: 'សេចក្ដី ពិពណ៌នា',
                        type: 'ប្រភេទ@ info: whatsthis',
                        classification: 'ថត',
                        content: 'មាតិកា',
                        enclosure: 'សំណួរ',
                        knowledgePointAssociation: 'ទំនាក់ទំនង',
                        open: 'បើក',
                        close: 'បិទ',
                        operator: 'កម្មវិធី',
                        logic: 'តក្ក',
                        see: 'ទិដ្ឋភាព',
                        edit: 'កែសម្រួល',
                    },
                },
                index: {
                    name: 'ឈ្មោះ:',
                    describe: 'សេចក្ដី ពិពណ៌នា',
                    createdBy: 'អ្នក បង្កើតComment',
                    type: 'ប្រភេទ@ info: whatsthis',
                    lastUpdated: 'ពេលវេលា ធ្វើ ឲ្យ ទាន់សម័យ ចុងក្រោយ',
                    numberOfReferences: 'ចំនួន យោងName',
                    operation: 'ប្រតិបត្តិការ',
                    see: 'ទិដ្ឋភាព',
                    edit: 'កែសម្រួល',
                    delete: 'លុប',
                    categoryDeletedSuccessfully: 'បាន លុប ប្រភេទ ដោយ ជោគជ័យ',
                    classificationOfKnowledgePoints: 'ចំណុច ចំណុច ចំណុច សាធារណៈ',
                    newlyBuild: 'ថ្មី',
                    knowledgeBase: 'មូលដ្ឋាន សិទ្ធិ',
                    knowledgePoints: 'ចំណុច ស្គាល់ ចំណុច',
                    technologicalProcess: 'ដំណើរការ',
                    keyword: 'ពាក្យ គន្លឹះ',
                    batchExport: 'នាំចេញ BatchName',
                    batchDelete: 'លុប Batch',
                    importProcess: 'នាំចូល ដំណើរការ',
                    importKnowledgePoints: 'នាំចូល ចំណុច សាធារណៈ',
                    ifTheKnowledgePointDoesNotExistInTheKnowledgeBaseAddTheKnowledgePointDirectlyIfItExistsSkipAndDoNotUpdate: 'ប្រសិនបើ ចំណុច ស្គាល់ មិន មាន នៅ ក្នុង មូលដ្ឋាន សាធារណៈ ទេ បន្ថែម ចំណុច ស្គាល់ ដោយ ផ្ទាល់ ប្រសិន បើ វា មាន ។ រំលង វា ហើយ កុំ ធ្វើ ឲ្យ វា ទាន់សម័យ ។',
                    editKnowledgePointClassification: 'កែសម្រួល ចំណុច ចំណុច ព័ត៌មាន',
                    newKnowledgePointClassification: 'ថ្នាក់ ចំណុច ស្គាល់ ថ្មី',
                    categoryEditingSucceeded: 'ការ កែសម្រួល ប្រភេទ ជោគជ័យ',
                    newClassificationSucceeded: 'ប្រភេទ ថ្មី ដោយ ជោគជ័យ',
                    classificationName: 'ឈ្មោះ ប្រភេទ',
                },
            },
            monitoringReport: {
                index: {
                    executiveSupervision: 'ការ ត្រួត ពិន្ទុ ប្រតិបត្តិការName',
                },
            },
            topicCallout: {
                index: {
                    whole: 'ទាំង អស់',
                    date: 'កាលបរិច្ឆេទ',
                    dimensionStatus: 'ស្ថានភាព ហៅ',
                    callRecordID: 'លេខ សម្គាល់ កំណត់ហេតុ ហៅ',
                    callRecordIDMustBeNumeric: 'លេខ សម្គាល់ កំណត់ ហៅ ត្រូវ តែ ជា លេខ មួយ',
                    strip: 'អត្ថបទ',
                    topicAnnotation: 'ការ ហៅ ប្រធាន បទ',
                    annotated: 'ស្លាក',
                    stripNotMarked: 'របារ មិន បាន ស្លាក',
                    barInDimension: 'របារ ក្នុង ការ ហៅ',
                    customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                    sale: 'ល្អ',
                    common: 'សរុប',
                    sessions: 'សម័យ',
                    currentTopic: 'ប្រធាន បទ បច្ចុប្បន្ន ៖',
                    staff: 'ការងារ',
                    topicOfConversation: 'ប្រធាន បទ',
                    theOperationIsSuccessfulAndTheDimensionHasBeenReset: 'ប្រតិបត្តិការ បាន ជោគជ័យ កំណត់ ការ ហៅ ឡើងវិញ',
                    afterResetAllTheAnnotationRecordsOfThisCommunicationSessionWillBeClearedPleaseConfirm: 'បន្ទាប់ ពី កំណត់ ឡើង វិញ ថត ស្លាក របស់ សម័យ នេះ នឹង ត្រូវ បាន ជម្រះ ។ សូម អះអាង',
                    resetAll: 'កំណត់ ទាំងអស់',
                    pleaseSelectTheTopicToBeMarked: 'សូម ជ្រើស ប្រធានបទ ដែល ត្រូវ ស្លាក',
                    pleaseTickTheSentenceToBeMarked: 'សូម ពិនិត្យ មើល ពាក្យ ដែល ត្រូវ សម្គាល់Name',
                    theOperationIsSuccessfulAndTheAnnotationHasTakenEffect: 'ប្រតិបត្តិការ បាន ជោគជ័យ ស្លាក បាន ទទួល ប្រយោជន៍',
                    theScopeOfThisAnnotationIncludesMessagesOfOtherTopicsClickOKToCoverThem: 'ចន្លោះ នៃ ចំណារ នេះ រួម បញ្ចូល សារ ពី ប្រធាន បទ ផ្សេង ទៀត ។ ចុច ត្រឹមត្រូវ ដើម្បី សរសេរ ជាន់ លើ ពួកវា ។',
                    confirmDimensions: 'អះអាង ការ ហៅ',
                    talkTime: 'ពេលវេលា និយាយComment',
                    callID: 'លេខ សម្គាល់ ហៅ',
                },
            },
            topicList: {
                index: {
                    callID: 'លេខ សម្គាល់ ហៅ',
                    latestMarkedTime: 'ពេលវេលា សម្គាល់ ចុងក្រោយ',
                    topicOfConversation: 'ប្រធាន បទ',
                    numberOfSentences: 'ចំនួន ពណ៌',
                    sentence: 'ប្រយោជន៍',
                    operation: 'ប្រតិបត្តិការ',
                    see: 'ទិដ្ឋភាព',
                    delete: 'លុប',
                    edit: 'កែសម្រួល',
                    newSubTopic: 'ប្រធាន រង ថ្មី',
                    move: 'ផ្លាស់ទី',
                    whole: 'ទាំង អស់',
                    topicDeletedSuccessfully: 'បាន លុប ប្រធានបទ ដោយ ជោគជ័យ',
                    newlyBuild: 'ថ្មី',
                    topicList: 'បញ្ជី ប្រតិទិន',
                    callIDMustBeNumeric: 'លេខ សម្គាល់ ហៅ ត្រូវ តែ ជា លេខ មួយ',
                    leadInTopic: 'នាំចូល ព័ត៌មាន',
                    whenTheCategoryNameIsRepeatedTheOriginalTopicCategoryWillNotBeOverwrittenThisItemWillBeSkippedDirectlyAndWillNotBeImported: 'ប្រសិន បើ ឈ្មោះ ប្រភេទ ត្រូវ បាន ស្ទួន ប្រភេទ ប្រធានបទ ដើម នឹង មិន ត្រូវ បាន សរសេរ ជាន់ លើ ទេ ។ ហើយ ធាតុ នឹង ត្រូវ បាន រំលង ហើយ នឹង មិន ត្រូវ បាន នាំចូល ។',
                    mobileClassification: 'ចល័ត ចល័ត',
                    editTopic: 'កែសម្រួល ប្រធាន បទ',
                    newTopic: 'ប្រធាន បទ ថ្មី',
                    topicName: 'ឈ្មោះ ប្រតិទិន',
                },
            },
            groupTest: {
                detail: {
                    template: {
                        modificationSucceeded: 'ការ កែប្រែ បាន ជោគជ័យ',
                        createdSuccessfully: 'បាន បង្កើត ដោយ ជោគជ័យ',
                        modificationFailed: 'ការ កែប្រែ បាន បរាជ័យ',
                        creationFailed: 'បាន បរាជ័យ',
                        monitoringName: 'ឈ្មោះ ត្រួត ពិនិត្យComment',
                        upToCharacters: 'អតិបរមា ៤០ តួ អក្សរ',
                        pleaseEnterAName: 'សូម បញ្ចូល ឈ្មោះ មួយ',
                        monitoringIndicators: 'លិបិក្រម ត្រួត ពិន្ទុ',
                        sessionActivity: 'សកម្មភាព សម័យ',
                        conversationAction: 'សកម្មភាព សម័យ',
                        keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                        supervisionItems: 'ធាតុ មួយ',
                        monitoringMembers: 'សមាជិក ត្រួត ពិន្ទុ',
                        groupReceivingGuidanceTrainingOrManagementIntervention: 'ក្រុម ដែល ទទួល ការ ណែនាំ បង្ហាត់ ឬ ការ ដោះស្រាយ គ្រប់គ្រងName',
                        groupA: 'ក្រុម A',
                        pleaseSelectGroupAData: 'សូម ជ្រើស ទិន្នន័យ ក្រុម A',
                        thereAreDuplicateUsersInGroupB: 'ស្ទួន អ្នក ប្រើ នៅ ក្នុង ក្រុម B',
                        groupARemarks: 'ព័ត៌មាន ក្រុម A',
                        controlGroupGroupComparedWithGroupA: 'ក្រុម ត្រួតពិនិត្យ ប្រៀបធៀប ជាមួយ ក្រុម A',
                        groupB: 'ក្រុម B',
                        pleaseSelectGroupBData: 'សូម ជ្រើស ទិន្នន័យ ក្រុម B',
                        thereAreDuplicateUsersInGroupA: 'មាន អ្នក ប្រើ ស្ទួន នៅ ក្នុង ក្រុម A',
                        groupBRemarks: 'ព័ត៌មាន ក្រុម B',
                        monitoringPeriod: 'រង្វង់ ត្រួត ពិន្ទុ',
                        startNode: 'ចាប់ផ្ដើម ថ្នាំង',
                        monitoringScope: 'ជួរ ត្រួត ពិន្ទុ',
                        pleaseSelectMonitoringConditions: 'សូម ជ្រើស លក្ខខណ្ឌ ត្រួត ពិន្ទុ',
                        pleaseEnterANumber: 'សូម បញ្ចូល លេខ មួយ',
                        pleaseSelectATimePeriod: 'សូម ជ្រើស កំឡុង ពេលវេលា',
                        preservation: 'រក្សាទុក',
                        cancel: 'បោះបង់',
                    },
                },
                list: {
                    template: {
                        deletionSucceeded: 'បាន លុប ដោយ ជោគជ័យ',
                        notStarted: 'មិន បាន ចាប់ផ្ដើម',
                        haveInHand: 'កំពុង វឌ្ឍន៍',
                        closed: 'បាន បញ្ចប់',
                        newGroupTest: 'សាកល្បង ក្រុម ថ្មី',
                    },
                },
            },
            businessConfiguration: {
                salesStage1: 'រូបរាង',
                communicationStrategy1: 'យុទ្ធសាស្ត្រ ទំនាក់ទំនង',
                riskAllocation: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                businessConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                communicationStrategy: {
                    detail: {
                        components: {
                            pushRichText: {
                                index: {
                                    objectionHandlingScript: 'ការ ដោះស្រាយ ទិន្នន័យ',
                                    productSellingPointScript: 'ចំណុច ចែក លទ្ធផលName',
                                    caseGrouping: 'ការ ដាក់ ក្រុម អក្សរ',
                                    pleaseSelectExcellentCases: 'សូម ជ្រើស ករណី ល្អ ។',
                                    pleaseSelectKnowledgePoints: 'សូម ជ្រើស ចំណុច សាធារណៈ',
                                    associativeLinks: 'តំណ ដែល ទាក់ទង',
                                    jumpTo: 'លោតComment',
                                    jumpType: 'ប្រភេទ លោតComment',
                                    knowledgePoints: 'ចំណុច ស្គាល់ ចំណុច',
                                    excellentCases: 'តួអក្សរ ល្អ បំផុត',
                                    excellentScript: 'និយាយ ល្អ ខ្ពស់',
                                    pleaseSelectASingleKnowledgePoint: 'សូម ជ្រើស ចំណុច ស្គាល់ មួយ មួយ',
                                },
                            },
                        },
                        index: {
                            name: 'ឈ្មោះ:',
                            pushText: 'ចុច អត្ថបទ',
                            enableStatus: 'បាន អនុញ្ញាត ស្ថានភាព',
                            triggerRules: 'ក្បៀស',
                            communicationStrategy: 'យុទ្ធសាស្ត្រ ទំនាក់ទំនង',
                        },
                    },
                    list: {
                        index: {
                            communicationStrategyGrouping: 'ក្រុម យុទ្ធសាស្ត្រ ទំនាក់ទំនង',
                            name: 'ឈ្មោះ:',
                            pushText: 'ចុច អត្ថបទ',
                            effectiveness: 'ភាព បែបផែន',
                            openSuccessfully: 'បើក ដោយ ជោគជ័យ',
                            closeSuccessfully: 'បាន បិទ ដោយ ជោគជ័យ',
                            operationFailed: 'ប្រតិបត្តិការ បាន បរាជ័យ',
                            operation: 'ប្រតិបត្តិការ',
                            edit: 'កែសម្រួល',
                            delete: 'លុប',
                            newlyBuild: 'ថ្មី',
                            communicationStrategy: 'យុទ្ធសាស្ត្រ ទំនាក់ទំនង',
                            editGroup: 'កែសម្រួល ការ ដាក់ ក្រុមComment',
                            groupName: 'ឈ្មោះ ក្រុម',
                        },
                    },
                },
                riskStatement: {
                    detail: {
                        components: {
                            riskSettingRule: {
                                index: {
                                    allSessions: 'សម័យ ទាំងអស់',
                                    recentDays: 'ថ្ងៃ ថ្មីៗ',
                                    recentSessions: 'សម័យ ថ្មីៗ',
                                    scopeOfApplication: 'វិធីសាស្ត្រ កម្មវិធី ៖',
                                    day: 'ថ្ងៃStencils',
                                    through: 'ប្តូរ@ info: whatsthis',
                                },
                            },
                        },
                        index: {
                            describe: 'សេចក្ដី ពិពណ៌នា',
                            applicableCustomers: 'អនុវត្ត ទៅកាន់ ភ្ញៀវ',
                            enableStatus: 'បាន អនុញ្ញាត ស្ថានភាព',
                            triggerRules: 'ក្បៀស',
                            riskRules: 'ក្ដារ ចល័ត',
                        },
                    },
                    list: {
                        index: {
                            riskAllocation: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                            keyWord: 'ពាក្យ សោ',
                            newRiskRule: 'ច្បាប់ ការ លទ្ធផល ថ្មី',
                            riskRuleName: 'ឈ្មោះ ក្បួន រចនាសម្ព័ន្ធ',
                            describe: 'សេចក្ដី ពិពណ៌នា',
                            state: 'ស្ថានភាព',
                            openSuccessfully: 'បើក ដោយ ជោគជ័យ',
                            closeSuccessfully: 'បាន បិទ ដោយ ជោគជ័យ',
                            operationFailed: 'ប្រតិបត្តិការ បាន បរាជ័យ',
                            operation: 'ប្រតិបត្តិការ',
                            edit: 'កែសម្រួល',
                            delete: 'លុប',
                            deletionSucceeded: 'បាន លុប ដោយ ជោគជ័យ',
                        },
                    },
                },
                salesStage: {
                    detail: {
                        components: {
                            alias: {
                                orderInput: 'កា រកំណត់ លំដាប់',
                            },
                            endReasonList: {
                                addEndReason: 'បន្ថែម មូលហេតុ បញ្ចប់',
                                enterEndReason: 'បញ្ចូល មូលហេតុ បញ្ចប់',
                            },
                            stageList: {
                                keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                                waysideData: 'ទិន្នន័យ តាម ផ្លូវComment',
                                includeAny: 'មាន ថ្មី',
                                includeAll: 'មាន ទាំងអស់',
                                pleaseEnterTheStageName: 'សូម បញ្ចូល ឈ្មោះ រូបភាព',
                                setStageRules: 'កំណត់ ច្បាប់ ស្ថានភាព',
                                stageName: 'ឈ្មោះ ថេរ',
                                operator: 'កម្មវិធី',
                                logic: 'តក្ក',
                            },
                        },
                        index: {
                            theInputFormatOfTheTimeTypeFieldIs: 'ទ្រង់ទ្រាយ វាល បញ្ចូល ប្រភេទ ពេលវេលា ៖ 2022-12- 31 00: 00: 000',
                            requestFailedPleaseTryAgainLater: 'បាន បរាជ័យ សំណើ សូម ព្យាយាម ម្ដង ទៀត ក្រោយ@ info: whatsthis',
                            salesStage: 'រូបរាង',
                            essentialInformation: 'ព័ត៌មាន មូលដ្ឋាន',
                            name: 'ឈ្មោះ:',
                            applicableDepartments: 'វឌ្ឍនភាព អាច អនុវត្ត បានName',
                            applicableToOthers: 'អនុវត្ត ទៅកាន់ ផ្សេង',
                            manualChangePhase: 'វិធី ផ្លាស់ប្ដូរ ដោយដៃ',
                            enableStatus: 'បាន អនុញ្ញាត ស្ថានភាព',
                            describe: 'សេចក្ដី ពិពណ៌នា',
                            opportunityStageSettings: 'ការ កំណត់ រូបរាង Opportunity',
                            stageSettings: 'ការ កំណត់ ថត',
                            aliasSettings: 'ការ កំណត់ ក្លែងក្លាយComment',
                            closeOpportunity: 'ភាព បញ្ចប់',
                            newSuccessfully: 'ជោគជ័យ ថ្មី',
                            newFailed: 'បាន បរាជ័យ ថ្មី',
                            savingSucceeded: 'រក្សាទុក ដោយ ជោគជ័យ',
                            saveFailed: 'បាន បរាជ័យ ក្នុង ការ រក្សាទុក',
                        },
                    },
                    list: {
                        index: {
                            salesStage: 'រូបរាង',
                            keyWord: 'ពាក្យ សោ',
                            newSalesStage: 'ថ្មី',
                            salesStageName: 'ឈ្មោះ ស្ថានភាព លេង',
                            describe: 'សេចក្ដី ពិពណ៌នា',
                            state: 'ស្ថានភាព',
                            openSuccessfully: 'បើក ដោយ ជោគជ័យ',
                            closeSuccessfully: 'បាន បិទ ដោយ ជោគជ័យ',
                            operationFailed: 'ប្រតិបត្តិការ បាន បរាជ័យ',
                            operation: 'ប្រតិបត្តិការ',
                            edit: 'កែសម្រួល',
                            delete: 'លុប',
                            deletionSucceeded: 'បាន លុប ដោយ ជោគជ័យ',
                        },
                    },
                },
                largeModelGeneration: {
                    index: {
                        largeModelGeneration: 'ការ បង្កើត ម៉ូដែល ធំ',
                        conversationInsights: 'សម័យ សម័យ',
                    },
                    sessionsInsight: {
                        components: {
                            autoGenerate: {
                                index: {
                                    automaticGeneration: 'បាន បង្កើត ដោយ ស្វ័យ ប្រវត្តិ',
                                },
                            },
                            hooks: {
                                conversationSummary: 'សង្ខេប សម័យ',
                                conversationProcess: 'ដំណើរការ សម័យ',
                                opportunityPoints: 'ចំណុច ជំនួយ',
                            },
                            prompt: {
                                index: {
                                    edit: 'កែសម្រួល',
                                    restoreDefault: 'ស្ដារ លំនាំដើម',
                                    cancel: 'បោះបង់',
                                    confirm: 'អះអាង',
                                },
                            },
                        },
                        index: {
                            saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                            hintLanguage: 'សួរ',
                            preserve: 'រក្សាទុក',
                            cancel: 'បោះបង់',
                        },
                    },
                },
            },
            salesBusinessConfigurationEntry: {
                largeModelGeneration: 'ការ បង្កើត ម៉ូដែល ធំ',
                salesStage: 'រូបរាង',
                communicationStrategy: 'យុទ្ធសាស្ត្រ ទំនាក់ទំនង',
                riskAllocation: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                businessConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
            },
            salesLearningCenter: {
                knowledgeBase: 'មូលដ្ឋាន សិទ្ធិ',
                speechCorpus: 'បណ្ណាល័យ និយាយComment',
                learningCenter: 'មជ្ឈមណ្ឌល បង្ហាញ',
            },
            customerFields: {
                components: {
                    baseFields: {
                        index: {
                            customerInformation: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
                        },
                    },
                },
                index: {
                    otherInformation: 'ព័ត៌មាន ផ្សេងទៀត',
                },
            },
        },
        intelligentAnalysis: {
            ruleTemplate: {
                components: {
                    importButton: {
                        index: {
                            import: 'នាំចូល',
                        },
                    },
                },
                hooks: {
                    index: {
                        questionnaire: 'កម្រិត សំណួរ',
                        eCommerceReview: 'E- Comment',
                        socialMediaComments: 'សេចក្តី អធិប្បាយ មេឌៀ',
                        mixing: 'លាយ',
                        videoCall: 'ហៅ វីដេអូ',
                        all: 'ទាំង អស់',
                        intelligentModel: 'ម៉ូឌុល ខ្លាំង',
                        smartRules: 'ច្បាប់ ឆ្លាត',
                        manualScoring: 'ពិន្ទុ ដៃ',
                        enable: 'អនុញ្ញាត',
                        notEnabled: 'មិន បាន អនុញ្ញាត',
                        voiceCall: 'ហៅ សំឡេង',
                        textDialogue: 'ប្រអប់ អត្ថបទ',
                        ecommerceTextSession: 'សម័យ អត្ថបទ E- commerce',
                        workOrder: 'លំដាប់ ការងារ',
                    },
                },
                index: {
                    language: 'ភាសាComment',
                    mixing: 'លាយ',
                    videoCall: 'ហៅ វីដេអូ',
                    ruleName: 'ឈ្មោះ បន្ទាត់',
                    ruleType: 'ប្រភេទ បន្ទាត់',
                    pleaseSelect: 'សូម ជ្រើស',
                    ruleStatus: 'ស្ថានភាព បន្ទាត់',
                    dataSourceType: 'ប្រភេទ ប្រភព ទិន្នន័យ',
                    voiceCall: 'ហៅ សំឡេង',
                    textDialogue: 'ប្រអប់ អត្ថបទ',
                    ecommerceTextSession: 'សម័យ អត្ថបទ E- commerce',
                    workOrder: 'លំដាប់ ការងារ',
                    status: 'ស្ថានភាព',
                    operation: 'ប្រតិបត្តិការ',
                    edit: 'កែសម្រួល',
                    ruleTemplate: 'ពុម្ព បន្ទាត់',
                },
            },
            analysisReportTitle: 'របាយការណ៍ វិភាគName',
            ruleTest: 'ការ សាកល្បង បន្ទាត់',
            intelligentTags: {
                publicOpinionLabel: 'ស្លាក ទិដ្ឋភាព សាធារណៈ',
                businessLabel: 'ស្លាក ព័ត៌មាន',
                userLabel: 'ស្លាក អ្នកប្រើ',
                productLabel: 'ស្លាក ធាតុ',
                labelDisplayQuantity: 'ចំនួន បង្ហាញ ស្លាក',
                unlimited: 'គ្មាន កំណត់',
                ignoringTagLibraries: 'មិន អើពើ បណ្ណាល័យ ស្លាក',
                automaticallyGenerateLabels: 'បង្កើត ស្លាក ដោយ ស្វ័យ ប្រវត្តិ',
                afterActivationLabelsAreAutomaticallyGeneratedForTheSessionBasedOnTheLargeModelAndTheGeneratedLabelsAreClassifiedAsunclassifiedByDefault: 'បន្ទាប់ ពី បាន អនុញ្ញាត សម័យ ស្លាក ត្រូវ បាន បង្កើត ដោយ ស្វ័យ ប្រវត្តិ ដោយ មូលដ្ឋាន លើ ម៉ូដែល ធំ ។ និង ស្លាក ដែល បាន បង្កើត ត្រូវ បាន ថ្នាក់ ក្រោម មិន ថ្នាក់ តាម លំនាំដើម ។',
                defaultValidity: 'ភាព បែបផែន លំនាំដើម',
                supervisionItem: 'ធាតុ មួយ',
                customerLabel: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
                newSupervisionItemRule: 'ច្បាប់ ធាតុ ត្រួត ពិនិត្យ ថ្មី',
                editSupervisionItemRule: 'កែសម្រួល ច្បាប់ ធាតុ ដែល បាន ត្រួត ពិន្ទុ',
                newCustomerLabel: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ ថ្មី',
                editCustomerLabel: 'កែសម្រួល ស្លាក របស់ ម៉ាស៊ីន ភ្ញៀវ',
                newSessionLabel: 'ស្លាក សម័យ ថ្មី',
                editSessionLabel: 'កែសម្រួល ស្លាក សម័យ',
                newKeyEvent: 'ព្រឹត្តិការណ៍ សោ ថ្មី',
                editKeyEvents: 'កែសម្រួល ព្រឹត្តិការណ៍ សោ',
                detail: {
                    template: {
                        type: 'ប្រភេទ@ info: whatsthis',
                        rules: 'បន្ទាត់',
                        language: 'ភាសាComment',
                        pleaseSelectLanguage: 'សូម ជ្រើស ភាសា មួយ',
                        nameIsARequiredField: 'ឈ្មោះ គឺ ជា វាល ដែល ទាមទារ',
                    },
                    formItemComponent: {
                        ifTheDialogDoesNotMeetTheFollowingOperatorConditionsTheLargeModelIsUsedToDetermineIfTheDialogDoesNotMeetTheFollowingOperatorConditions: 'ប្រសិន បើ ប្រអប់ មិន ធ្វើ ឲ្យ លក្ខខណ្ឌ សកម្មភាព ដូច ខាង ក្រោម ម៉ូដែល ធំ ត្រូវ បាន ប្រើ ដើម្បី កំណត់ ថា ប្រសិន បើ ប្រអប់ មិន ធ្វើ ឲ្យ លក្ខខណ្ឌ របស់ អ្នក ប្រើ ដូច ខាងក្រោម ។',
                        largeModelExtensionLabel: 'ស្លាក ផ្នែក បន្ថែម ម៉ូដែល ធំ',
                        sessionRecordID: 'លេខ សម្គាល់ សម័យ',
                        sessionTime: 'ពេលវេលា សម័យ',
                        smartTags: 'ស្លាក ឆ្លាត',
                        viewDetails: 'មើល សេចក្ដី លម្អិត',
                        afterDeletionTheDataRecordedInThisSessionWillBeClearedAreYouSureYouWantToDeleteIt: 'បន្ទាប់ ពី លុប ទិន្នន័យ របស់ សម័យ នេះ នឹង ត្រូវ បាន ជម្រះ ។ តើ អ្នក ពិត ជា លុប វា ឬ ?',
                        tagData: 'ទិន្នន័យ ស្លាក',
                        batchDeletion: 'លុប Batch',
                    },
                    component: {
                        pleaseSelectAtLeastOneModel: 'សូម ជ្រើស យ៉ាងហោច ណាស់ ម៉ូដែល មួយ',
                        userLabel: 'ស្លាក អ្នកប្រើ',
                        productLabel: 'ស្លាក ធាតុ',
                        publicOpinionLabel: 'ស្លាក ទិដ្ឋភាព សាធារណៈ',
                    },
                },
                template: {
                    labelExtraction: 'ស្រង់ ស្លាក',
                    presetLabelGroup: 'កំណត់ ក្រុម ស្លាក ជា មុន',
                    customLabelGroup: 'ក្រុម ស្លាក ផ្ទាល់ខ្លួន',
                    generateLabelsAutomatically: 'បង្កើត ស្លាក ដោយ ស្វ័យ ប្រវត្តិ',
                    recordingTime: 'ពេលវេលា ថត',
                    youCanSelectUpToOneMonthDaysOfRecordsInTheLastYear: 'អ្នក អាច ជ្រើស កា រថត ថត នៅ ឆ្នាំ ចុងក្រោយ ។',
                    advancedFiltering: 'តម្រង កម្រិត ខ្ពស់',
                    dataType: 'ប្រភេទ ទិន្នន័យ',
                    filterCriteria: 'លក្ខខណ្ឌ តម្រង',
                    edit: 'កែសម្រួល',
                    createANewSubcategory: 'ប្រភេទ រង ថ្មី',
                    delete: 'លុប',
                    nameLengthCannotExceed: 'ប្រវែង ឈ្មោះ មិន អាច លើក ៤០ ទេ',
                },
                component: {
                    firstCreationMethod: 'វិធីសាស្ត្រ បង្កើត មុន',
                    createManually: 'បង្កើត ដោយ ដៃ',
                    largeModelCreation: 'បង្កើត ម៉ូឌុល ធំ',
                    language: 'ភាសាComment',
                    modelExpansion: 'ពង្រីក ម៉ូឌុល',
                    enable: 'អនុញ្ញាត',
                    notEnabled: 'មិន បាន អនុញ្ញាត',
                    standardScreening: 'តម្រង ស្តង់ដារ',
                    advancedFiltering: 'តម្រង កម្រិត ខ្ពស់',
                },
                components: {
                    autoGenerateTagsModal: {
                        afterOpeningTagsAreAutomaticallyGeneratedForSessionsBasedOnLargeModelsTheGeneratedTagsAreClassifiedUnderLargeModelTagsByDefault: 'បន្ទាប់ ពី បើក ស្លាក ត្រូវ បាន បង្កើត ដោយ ស្វ័យ ប្រវត្តិ សម្រាប់ សម័យ ដែល មាន មូលដ្ឋាន លើ ម៉ូដែល ធំ ។ ស្លាក ដែល បាន បង្កើត ត្រូវ បាន ថ្នាក់ ក្រោម " ស្លាក ម៉ូឌុល ធំ" តាម លំនាំដើម ។',
                        labelingRequirements: 'ចម្លើយ ចំពោះ សំណួរ',
                        pleaseEnter: 'សូម បញ្ចូល',
                        tagIgnored: 'បាន មិន អើពើ ស្លាក',
                        pleaseEnterTheLabelToBeIgnoredAndEnterTheCarToBeAddedAutomatically: 'សូម បញ្ចូល ស្លាក ដែល ត្រូវ មិន អើពើ ហើយ បញ្ចូល កាត ដែល ត្រូវ បន្ថែម ដោយ ស្វ័យ ប្រវត្តិ ។',
                        batchFilterLabel: 'ស្លាក តម្រង Bath',
                    },
                    tagExtractModal: {
                        taskType: 'ប្រភេទ ភារកិច្ច',
                        immediateExecution: 'ការ ប្រតិបត្តិ ភ្លាមៗ',
                        timingExecution: 'ការ ប្រតិបត្តិ ពេលវេលា',
                        executionFrequency: 'ប្រេកង់ ប្រតិបត្តិ',
                        pleaseSelectAnExecutionFrequency: 'សូម ជ្រើស ប្រេកង់ ប្រតិបត្តិ',
                        timeFrameCannotExceedDays: 'ស៊ុម ពេលវេលា មិន អាច លើក ៣០ ថ្ងៃ ឡើយ',
                        scheduledTaskInEffect: 'ភារកិច្ច ដែល បាន កំណត់ ពេល មាន ប្រសិទ្ធភាព',
                        pleaseStartUsingAfterDataProcessingIsComplete: 'សូម ចាប់ផ្ដើម ប្រើ បន្ទាប់ ពី ដំណើរការ ទិន្នន័យ បាន បញ្ចប់',
                        endTask: 'បញ្ចប់ ភារកិច្ច',
                        viewTasks: 'មើល ភារកិច្ច',
                        voiceCall: 'ហៅ សំឡេង',
                        textDialogue: 'ប្រអប់ អត្ថបទ',
                        workOrder: 'លំដាប់ ការងារ',
                        formValidationFailed: 'បាន បរាជ័យ ក្នុង ការ ធ្វើ ឲ្យ សំណុំ បែបបទ ៖',
                        labelExtraction: 'ស្រង់ ស្លាក',
                        dataSource: 'ប្រភព ទិន្នន័យ',
                        pleaseSelectADataSource: 'សូម ជ្រើស ប្រភព ទិន្នន័យ',
                        dataTimeRange: 'ជួរ ពេលវេលា ទិន្នន័យ',
                        pleaseSelectATimeRange: 'សូម ជ្រើស ជួរ ពេលវេលា',
                        selectUpToDaysOfData: 'ជ្រើស ទិន្នន័យ ៣០ ថ្ងៃ@ info: whatsthis',
                        extractionQuantityUpperLimit: 'ដែន កំណត់ ខ្ពស់',
                        pleaseEnterTheMaximumExtractionQuantity: 'សូម បញ្ចូល ចំនួន ស្រង់ អតិបរមា',
                        addToClassification: 'បន្ថែម ទៅ កាន់ ថ្នាក់',
                        pleaseSelectALabelClassification: 'សូម ជ្រើស តម្លៃ ស្លាក',
                        extractionRequirements: 'ការ ទាមទារ ស្រង់ចេញ',
                        pleaseEnterExtractionRequirementsoptional: 'សូម បញ្ចូល ការ ទាមទារ ស្រង់ចេញ (ជម្រើស)',
                        submittedSuccessfullyStartCreatingTags: 'បាន ដាក់ ស្នើ ដោយ ជោគជ័យ ចាប់ផ្ដើម បង្កើត ស្លាក',
                        checkLater: 'ពិនិត្យ មួយ',
                    },
                    timeRange: {
                        index: {
                            today: 'ថ្ងៃ នេះ@ item: inlistbox',
                            yesterday: 'ម្រាមង',
                            theDayBeforeYesterday: 'ថ្ងៃ មុន ម្ល',
                            thisWeek: 'សប្ដាហ៍ នេះ',
                            lastWeek: 'សប្ដាហ៍ មុន',
                            thisMonth: 'ខែ នេះ',
                            lastMonth: 'ខែ មុន',
                        },
                    },
                },
            },
            businessAnalysis: {
                detail: {
                    businessAnalysisFiter: {
                        component: {
                            keyWord: 'ពាក្យ សោ',
                            sessionLabel: 'ស្លាក សម័យ',
                            keyEvents: 'ព្រឹត្តិការណ៍ សោ',
                            matchAny: 'ផ្គូផ្គង',
                            matchAll: 'ផ្គូផ្គង ទាំងអស់',
                            beEqualTo: 'ស្មើ',
                            includeAll: 'មាន ទាំងអស់',
                            includeAny: 'មាន ថ្មី',
                            advancedConditions: 'លក្ខខណ្ឌ កម្រិត ខ្ពស់',
                            smartTag: 'ស្លាក ឆ្លាត',
                            smartTagI: 'ស្លាក ឆ្លាត',
                            smartTagII: 'ស្លាក ឆ្លាត IIName',
                        },
                        template: {
                            pleaseSelectSmartTag: 'សូម ជ្រើស ស្លាក ជម្រះ',
                            pleaseSelectASessionLabel: 'សូម ជ្រើស ស្លាក សម័យ',
                            pleaseSelectAKeyEvent: 'សូម ជ្រើស ព្រឹត្តិការណ៍ សោ',
                            pleaseSelectAdvancedCondition: 'សូម ជ្រើស លក្ខខណ្ឌ កម្រិត ខ្ពស់',
                            newAdvancedFilter: 'តម្រង កម្រិត ខ្ពស់ ថ្មី',
                            moveUp: 'ផ្លាស់ទី ឡើង លើ',
                            moveDown: 'ផ្លាស់ទី ចុះក្រោម',
                            moveLeft: 'ផ្លាស់ទី ទៅ ឆ្វេង',
                            shiftRight: 'ផ្លាស់ទី ទៅ ស្ដាំ',
                        },
                    },
                    component: {
                        businessAnalysispng: 'ការ វិភាគ បណ្ដាញ.pn',
                        savedSuccessfully: 'រក្សាទុក ដោយ ជោគជ័យ',
                    },
                    template: {
                        ecommerceSessionQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព សម័យ E-commerce',
                        questionnaire: 'កម្រិត សំណួរ',
                    },
                },
            },
            supervision: {
                detail: {
                    index: {
                        permanentlyValid: 'មាន ប្រយោជន៍ ធម្មតា',
                        permanentlyInvalid: 'មិន ត្រឹមត្រូវ',
                        customValidity: 'រយៈពេល មាន សុពលភាព ផ្ទាល់ខ្លួន',
                        termOfValidity: 'រយៈពេល មាន សុពលភាព',
                        name: 'ឈ្មោះ:',
                        explain: 'សេចក្ដី ពិពណ៌នា',
                        state: 'ស្ថានភាព',
                        classification: 'ថត',
                        smartRecommendation: 'អនុសាសន៍ ជម្រះ',
                        preconditions: 'លក្ខខណ្ឌ មុន',
                        SetPreconditionsForThisSupervisionItem: '1. កំណត់ ភាព ត្រឹមត្រូវ សម្រាប់ ធាតុ ការ គ្រប់គ្រង នេះ ៖',
                        whenThePreconditionsAreMetItIsThesupervisionItemToBeImplementedAndThenTheSupervisionItemShallBeTested: 'នៅ ពេល ទំនាក់ទំនង មុន ត្រូវ បាន ធ្វើ ឲ្យ វា ត្រូវ បាន ត្រួត ពិនិត្យ ជា "ធាតុ ត្រួត ពិនិត្យ ត្រូវ បាន អនុវត្ត" ហើយ ធាតុ ត្រួត ពិនិត្យ នឹង ត្រូវ បាន សាកល្បង ។',
                        ifThePreconditionsAreNotMetTheSupervisionItemWillNotBeDetected: 'ប្រសិនបើ ទំនាក់ទំនង មុន មិន ត្រូវ បាន រៀបចំ ធាតុ មួយ នឹង មិន ត្រូវ បាន រក ឃើញ ទេ ។',
                        NoPreconditionsAreSetThatIsAllSessionsAreDetectedByDefault: '2. កុំ កំណត់ ចំណុច ដែល ជា សម័យ ទាំងអស់ ត្រូវ បាន រកឃើញ តាម លំនាំ ដើម ។',
                        have: 'បាន',
                        nothing: 'គ្មាន ទេ',
                        preconditionRule: 'ច្បាប់ ភាព ជាមុន',
                        preconditionLogic: 'តក្កវិជ្ជា មុន',
                    },
                    recommendation: {
                        caseGrouping: 'ការ ដាក់ ក្រុម អក្សរ',
                        whenEmployeesFailToPerformWellTheyCanIntelligentlyRecommendExcellentScriptsAndExcellentCases: '( ក) តើ អ្នក ចាស់ ទុំ អាច ធ្វើ អ្វី?',
                        smartRecommendation: 'អនុសាសន៍ ជម្រះ',
                        open: 'បើក',
                        close: 'បិទ',
                        whenThisSupervisionItem: 'នៅពេល ធាតុ ការ គ្រប់គ្រង នេះ',
                        implement: 'ប្រតិបត្តិ',
                        unexecuted: 'មិន បាន ប្រតិបត្តិ',
                        when: 'ពេល ៖',
                        recommendedKnowledgePoints: 'ផ្ដល់ អនុសាសន៍ ចំណុច សម្ងាត់',
                        caseRecommendation: 'អនុសាសន៍ តួអក្សរ',
                    },
                },
                index: {
                    determine: 'កំណត់@ info: whatsthis',
                    sort: 'តម្រង',
                    sortSucceeded: 'តម្រៀប ដោយ ជោគជ័យ',
                    supervisionItemClassification: 'ថ្នាក់ ធាតុ មួយ',
                    pressEnterToCreateANew: 'ចុច បញ្ចូល ថ្មី',
                    nameCannotBeEmpty: 'ឈ្មោះ មិន អាច ទទេ',
                    newlyBuild: 'ថ្មី',
                    name: 'ឈ្មោះ:',
                    explain: 'សេចក្ដី ពិពណ៌នា',
                    validStatus: 'ស្ថានភាព ត្រឹមត្រូវ',
                    permanentlyValid: 'មាន ប្រយោជន៍ ធម្មតា',
                    permanentlyInvalid: 'មិន ត្រឹមត្រូវ',
                    operation: 'ប្រតិបត្តិការ',
                    edit: 'កែសម្រួល',
                    batchDelete: 'លុប Batch',
                    newSupervisionItem: 'ធាតុ ត្រួត ពិនិត្យ ថ្មី',
                    keyWord: 'ពាក្យ សោ',
                    delete: 'លុប',
                    deleteSucceeded: 'បាន លុប ដោយ ជោគជ័យ',
                },
            },
            analysisReport: {
                components: {
                    list: {
                        index: {
                            theDataCannotBeRecoveredAfterDeletionAreYouSureYouWantToDeleteIt: 'ទិន្នន័យ មិន អាច ត្រូវ បាន ស្ដារ ឡើង វិញ បន្ទាប់ ពី ត្រូវ បាន លុប ។ តើ អ្នក ពិត ជា ចង់ លុប វា ឬ ?',
                        },
                    },
                    businessAnalysisFiter: {
                        component: {
                            smartTag: 'ស្លាក ឆ្លាត',
                            beEqualTo: 'ស្មើ',
                            includeAll: 'មាន ទាំងអស់',
                            includeAny: 'មាន ថ្មី',
                            matchAny: 'ផ្គូផ្គង',
                            matchAll: 'ផ្គូផ្គង ទាំងអស់',
                            smartTagI: 'ស្លាក ឆ្លាត',
                            smartTagII: 'ស្លាក ឆ្លាត IIName',
                        },
                        template: {
                            pleaseSelectASmartTag: 'សូម ជ្រើស ស្លាក ជម្រះ',
                            pleaseSelectAdvancedConditions: 'សូម ជ្រើស លក្ខខណ្ឌ កម្រិត ខ្ពស់',
                            newAdvancedFilter: 'តម្រង កម្រិត ខ្ពស់ ថ្មី',
                            rename: 'ប្ដូរ ឈ្មោះ',
                            moveUp: 'ផ្លាស់ទី ឡើង លើ',
                            moveDown: 'ផ្លាស់ទី ចុះក្រោម',
                            shiftLeft: 'ផ្លាស់ទី ទៅ ឆ្វេង',
                            shiftRight: 'ផ្លាស់ទី ទៅ ស្ដាំ',
                        },
                    },
                },
                template: {
                    businessTrendAnalysis: 'ការ វិភាគ រចនាប័យ',
                    percentableSituation: 'ស្ថានភាព ភាគរយ',
                    delete: 'លុប',
                    labelFiltering: 'ការ ត្រង ស្លាក ៖',
                    satisfyAny: 'ជួប ប្រទះ',
                    meetAll: 'សម័យ ទាំងអស់',
                    theNumberOfConversationsOfSecondaryCategoryLabelsPrimaryCategoryAndASessionMayContainMultipleLabels: 'ចំនួន ស្លាក ថ្នាក់ ទីពីរ ≥ កា រកំណត់ ចម្បង សម័យ អាច មាន ស្លាក ច្រើន',
                    calculationLogicOfMonthOnMonthChangeconversationVolumeOfTheSelectedTimePeriodConversationVolumeOfTheImmediatelyPrecedingTimePeriodconversationVolumeOfTheLastTimePeriod: 'តក្កវិធី សម្រាប់ ការ គណនា នៃ ការ ផ្លាស់ប្ដូរ រង្វង់ ៖ ( ប្រអប់ កម្រិត សំឡេង ក្នុង ប្រអប់ កម្រិត សំឡេង ពេលវេលា ដែល បាន ជ្រើស ក្នុង រយៈពេល មុន ភ្លាមៗ) ប្រអប់ កម្រិត សំឡេង ក្នុង រយៈពេល មុន',
                    proportionOfPrimaryClassification: 'ភាគរយ នៃ តម្លៃ កម្រិត ដំបូង',
                    saveAs: 'រក្សាទុក',
                    cover: 'គម្រប',
                    preservation: 'រក្សាទុក',
                    qualityInspectionTask: 'ភារកិច្ច វិភាគ ៖',
                    query: 'សំណួរ',
                    changeFromMonthToMonth: 'ផ្លាស់ប្ដូរ ភ្លើង',
                    tagRanking: 'ស្លាក តម្លៃ',
                    proportion: 'ស្ថានភាព ភាគរយ',
                },
                component: {
                    ecommerceTextSession: 'សម័យ អត្ថបទ E- commerce',
                    questionnaire: 'កម្រិត សំណួរ',
                    noSubordinateClassificationExists: 'គ្មាន ថ្នាក់ កណ្ដុរ ខាង ឡើយ',
                    categoryName: 'ឈ្មោះ ប្រភេទ',
                    numberOfConversations: 'ចំនួន សាកល្បង',
                    operation: 'ប្រតិបត្តិការ',
                    businessAnalysispng: 'ការ វិភាគ បណ្ដាញ.pn',
                    savingSucceeded: 'រក្សាទុក ដោយ ជោគជ័យ',
                    deletionSucceeded: 'បាន លុប ដោយ ជោគជ័យ',
                    sequence: 'លំដាប់',
                    firstLevelClassification: 'ការ កំណត់ កម្រិត ១',
                    ringRatioChange: 'ផ្លាស់ប្ដូរ ភ្លើង',
                    classClassification: 'កម្រិត {0}',
                },
            },
            intelligentExtractors: {
                components: {
                    pageLeftTable: {
                        areYouSureToDeleteTheDocumentAndItsExtractedContent: 'អះអាង ដើម្បី លុប ឯកសារ និង មាតិកា ដែល បាន ស្រង់ចេញ របស់ វា ?',
                        addKnowledgeBase: 'បន្ថែម មូលដ្ឋាន សាធារណៈ',
                        uploadDocument: 'ផ្ទុក ឯកសារ',
                        supportsWordPDFPowerPointExcelAndTxtFormatFiles: 'គាំទ្រ ពាក្យ, pdf, ppt, excel, txt',
                        taskName: 'ឈ្មោះ ភារកិច្ច',
                        extractConversationDate: 'ស្រង់ កាលបរិច្ឆេទ ទំនាក់ទំនង',
                        pleaseSelectAConversationDate: 'សូម ជ្រើស កាលបរិច្ឆេទ ស្វែងរក',
                        dataSource: 'ប្រភព ទិន្នន័យ',
                        dataType: 'ប្រភេទ ទិន្នន័យ',
                    },
                    pageRightTable: {
                        index: {
                            exportSuccessful: 'នាំចេញ បាន ជោគជ័យ',
                            problem: 'សំណួរ',
                            answer: 'ចម្លើយ',
                            addToKnowledgeBase: 'បន្ថែម ទៅ មូលដ្ឋាន សាធារណៈ',
                            pleaseConfirmWhetherToDeleteIt: 'សូម កំណត់ ថា តើ ត្រូវ លុប',
                        },
                        pageRightFrom: {
                            addToKnowledgeBase: 'បន្ថែម ទៅ មូលដ្ឋាន សាធារណៈ',
                            selectClassification: 'ជ្រើស ប្រភេទ',
                            pleaseSelectAKnowledgeBaseClassification: 'សូម ជ្រើស ទិដ្ឋភាព មូលដ្ឋាន សាធារណៈ',
                        },
                    },
                },
                index: {
                    intelligentExtraction: 'ស្រង់ ចេញ',
                    documentExtraction: 'ការ ស្រង់ ឯកសារ',
                    dialogueExtraction: 'ប្រអប់ ស្រង់ចេញ',
                },
            },
            ignoreLabel: {
                index: {
                    operationSuccessful: 'ប្រតិបត្តិការ បាន ជោគជ័យ',
                    labelIgnored: 'បាន មិន អើពើ ស្លាក',
                    add: 'បន្ថែម@ info: whatsthis',
                    areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                    batchFilterLabels: 'ស្លាក តម្រង Bath',
                },
            },
            dataPreprocess: {
                component: {
                    language: 'ភាសាComment',
                },
                detail: {
                    template: {
                        language: 'ភាសាComment',
                    },
                },
            },
            intelligentCollection: {
                index: {
                    language: 'ភាសាComment',
                },
                detail: {
                    index: {
                        language: 'ភាសាComment',
                        pleaseSelectLanguage: 'សូម ជ្រើស ភាសា មួយ',
                    },
                },
            },
            customerPortrait: {
                template: {
                    ticketCount: 'ចំនួន លំដាប់ ការងារ ៖',
                    numberOfVideoCalls: 'ចំនួន ហៅ វីដេអូ ៖',
                    questionnaire: 'កម្រិត សំណួរ',
                },
            },
            sentimentAnalysis: {
                index: {
                    publicOpinionAnalysis: 'ការ វិភាគ កម្រិត សាធារណៈ',
                },
            },
        },
        logoSite: {
            index: {
                intelligentQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
                savedSuccessfully: 'រក្សាទុក ដោយ ជោគជ័យ',
                logoSettings: 'ការ កំណត់ ឡូ',
                default: 'លំនាំដើម',
                custom: 'ផ្ទាល់ខ្លួន',
                title: 'ចំណង ជើង',
                theTitleOfTheSystemDisplayShouldBeWithinWords: 'ឈ្មោះ ចំណង ជើង ដែល បាន បង្ហាញ ដោយ ប្រព័ន្ធ ត្រូវ បាន ផ្ដល់ អនុសាសន៍ ក្នុង តួអក្សរ ៦ ។',
                logoImageUpload: 'ផ្ទុក ឡើង រូបភាព ឡូ',
                pleaseSelectAPictureWithASizeOfNoMoreThankb: 'សូម ជ្រើស រូបភាព ដែល មាន ទំហំ ដែល មិន មែន ជា 2048 kb',
                inOrderToEnsureTheBrowsingEffectOfLogoUploadPicturesSuggestions: 'ដើម្បី សារ',
                Size5050Pixels: '១ ទំហំ ៖ 50*50 ភីកសែល',
                FormatPicturesWithTransparentBackgroundPNGOrJPGLogoGraphicsInWhite: '2. ទ្រង់ទ្រាយ ៖ រូបភាព ដែល មាន ផ្ទៃ ខាង ថ្លា, png ឬ jpg ក្រាហ្វិក ដោយ ប្រើ ក្រាហ្វិក សត្វ',
                browserLabelIcon: 'រូបតំណាង ផ្ទាំង កម្មវិធី រុករក',
                toEnsureTheBrowsingEffectOfTagsUploadPicturesSuggestions: 'ដើម្បី សារ',
                Size3232Pixels: '១ ទំហំ ៖ ៣២* ភីកសែល',
                FormatPictureWithTransparentBackgroundPNGOrJpg: '2. ទ្រង់ទ្រាយ ៖ រូបភាព ដែល មាន ផ្ទៃ ខាង ថ្លា, png ឬ jpg',
            },
        },
        sdkTest: {
            index: {
                qualityInspectionInProgressPleaseCheckLater: 'ការ ត្រួត ពិនិត្យ គុណភាព កំពុង ដំណើរការ សូម រង់ចាំ ...',
            },
            componentIndex: {
                atThatTimeInChinasRealEstateReachedACriticalMomentForItsSurvivalALargeNumberOfHousesWereLeftUnattendedAndThePeopleWereUnwillingToBuyThemHangzhouOnceFellBelow8000AndSomeDevelopersFailedToShipAtThatTimeShenzhenWasStillAbout2w3wConsolidationAndTheHousesInTheFirstTierCitiesWereAlsoInDanger: 'នៅ ក្នុង ឆ្នាំ ២០០៥ ដោយ សម័យ ប្រទេស របស់ ខ្ញុំ បាន មក ដល់ ម៉ោង សំខាន់ មួយ នៃ ការ ជោគជ័យ ។ [ រូបភាព នៅ ទំព័រ ២៦] Hangzhou នៅពេល ដែល មាន នៅ ខាង ក្រោម 8000 ហើយ អ្នក អភិវឌ្ឍន៍ ខ្លួន បាន បំបែក ប្រទេស ។ Shenzhen នៅ តែ កំពុង តែ បន្ថយ រហូត ដល់ 2w-3 w នៅ ពេល នោះ ហើយ ទំព័រ នៅ ទីក្រុង ទីក្រុង ដំបូង ក៏ មាន គ្រោះថ្នាក់ ។',
                xiaoAn: 'អាន ។',
                storestoreStoreloadTheseMemoryBarriersAreCalledJSRMemoryBarriersTheyAreImplementedAtTheJVMLevelThereAreTwoWaysToImplementThemAtTheBottomOfTheOperatingSystemLockBus2MemoryBarrierMetaLanguageSuchAsSfancewriteBarrierMfencefullScreenBarrierAndIfencereadBarrierTheBottomLayerOfTheHotspotsVirtualMachineUsesAnAssemblyStatementLockADDLLockIsAnEmptyOperationThatIsLockBusThisIsBecauseSomeOperatingSystemsDoNotSupportMemoryBarrierMetaLanguage: 'Storestore storeload បណ្ដុះ សតិ ទាំងនេះ ត្រូវ បាន ហៅ បណ្ដុះ សតិ jsr ដែល មាន នៅ កម្រិត jvm ។ មាន ការ ប្រតិបត្តិ ពីរ នៅ ខាង ក្រោម ប្រព័ន្ធ ប្រតិបត្តិការ ៖ មួយ គឺ ត្រូវ ចាក់សោ ខ្សែ និង ផ្សេងទៀត គឺ ជា បណ្ដាញ សតិ សំឡេង ដូចជា sfance (ការ សរសេរ ជុំ) ស្រទាប់ ខាង ក្រោម របស់ ម៉ាស៊ីន និម្មិត មាត្រ និម្មិត ប្រើ ប្រកាស ទំនាក់ទំនង ៖ ចាក់សោ addl ចាក់សោ ប្រតិបត្តិការ ទទេ ។ ដែល ជា សោ ។ វា ត្រូវ បាន ធ្វើ ដោយ សារ ប្រព័ន្ធ ប្រតិបត្តិការ មួយ ចំនួន មិន គាំទ្រ សតិ សតិ ឡើយ ។',
                xiaobei: 'ស៊ីយ៉ូប៊ីworld. kgm',
                TryToMarinateTheMeatForSeveralTimesTheDishesFriedAfterAddingTheIngredientsAndWineAreLikeRottenMeatWithASourSmellSinceThenNoCookingWineHasBeenAddedToTheBacon: '១. ព្យាយាម ធ្វើ បាំង រវាង ច្រើន ម្ដង ហើយ ព្យាយាម បំបាត់ កម្លាំង បន្ទាប់ ពី បន្ថែម ប៊ីម ។ បង ស្រី ! ចាប់ ពី ឥឡូវ នេះ គ្មាន រង្វង់ ឡើង វិញ សម្រាប់ ប៊ីន',
                xiaodong: 'ស៊ីយ៉ូដងworld. kgm',
                xiaoxi: 'ស៊ីយ៉ូ ស៊ីchina. kgm',
                TryToMarinateTheMeatForSeveralTimesTheDishesFriedAfterAddingTheWineAreLikeRottenMeatWithASourSmellSinceThenNoCookingWineHasBeenAddedToTheBacon: '៣: សូម ព្យាយាម ធ្វើ បាំង ច្រើន ម្ដង ទៀត ហើយ កម្លាំង ដែល បាន បំបាត់ ឡើង បន្ទាប់ ពី បន្ថែម ប៊ូ វ គឺ ដូច មាស ដែល បាន បាត់ ។ មាន លុប ! ចាប់ ពី ឥឡូវ នេះ គ្មាន រង្វង់ ឡើង វិញ សម្រាប់ ប៊ីន',
            },
        },
        home: {
            index: {
                flyingBookConversation: 'សៀវភៅ កម្រិត សៀវភៅ',
                templateManagement: 'គ្រប់គ្រង ពុម្ព',
                evaluationOverview: 'ទិដ្ឋភាព មើល',
                evaluationRecord: 'ថត តម្លៃ',
                curriculumEvaluation: 'ការ វាយតម្លៃ',
                videoCallManagement: 'គ្រប់គ្រង ការ ហៅ វីដេអូ',
                planManagement: 'ការ គ្រប់គ្រង គ្រោងការណ៍',
                dataIntegration: 'ការ បញ្ចូល ទិន្នន័យ',
                questionnaireManagement: 'គ្រប់គ្រង សំណួរ',
                originalSoundManagement: 'គ្រប់គ្រង សំឡេង ដើម',
                productManagement: 'គ្រប់គ្រង លទ្ធផលName',
                productDetails: 'សេចក្ដី លម្អិត លម្អិត',
                qualityAccompanyList: 'គុណភាព រួមបញ្ចូល បញ្ជី បញ្ជា',
                ecommerceReviewManagement: 'ការ គ្រប់គ្រង ការ ត្រួតពិនិត្យ E-commerce',
                socialMediaReviewManagement: 'គ្រប់គ្រង មេឌៀ សំឡេង',
                customDataSource: 'ប្រភព ទិន្នន័យ ផ្ទាល់ខ្លួន',
                qualityInspectionResults: 'លទ្ធផល ត្រួត ពិនិត្យ គុណភាព',
                accountManagement: 'គ្រប់គ្រង គណនី',
                employeeProfile: 'បញ្ជា',
                intelligentAnalysis: 'ការ វិភាគ បដិសេធ',
                customKanban: 'ផ្ទាល់ខ្លួន',
                dataScreening: 'មើល ទូទៅ ទិន្នន័យ',
                learningRecord: 'ថត សិក្សា',
                dataAnalysis: 'ការ វិភាគ ទិន្នន័យ',
                scoringManagement: 'គ្រប់គ្រង ពិន្ទុ',
                businessConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                manualReview: 'មើល ដៃ',
                taskList: 'បញ្ជី ភារកិច្ច',
                videoAnalysis: 'វិភាគ វីដេអូ',
                overview: 'មើល មើល',
                personalSignage: 'កាបេន ផ្ទាល់ខ្លួន',
                learningCenter: 'មជ្ឈមណ្ឌល បង្ហាញ',
                wrongQuestionSet: 'កំណត់ បញ្ហា ខុស',
                abilityImprovement: 'សមត្ថភាព ធ្វើ ឲ្យ ប្រសើរ',
                close: 'បិទ',
                switchingSystemApplications: 'ការ ប្ដូរ កម្មវិធី ប្រព័ន្ធ',
                moveTheMouseHereToCallUpTheApplicationSwitchingMenuClickTheMenuItemToJumpToDifferentApplications: 'ផ្លាស់ទី កណ្ដុរ នៅ ទីនេះ ដើម្បី ហៅ ម៉ឺនុយ ប្ដូរ កម្មវិធី ហើយ ចុច ធាតុ ម៉ឺនុយ ដើម្បី លោត ទៅ កម្មវិធី ផ្សេង ។',
                teamAnalysis: 'ការ វិភាគ ក្រុមComment',
                semanticIntelligence: 'ជម្រះ សំឡេង',
                permissionManagement: 'គ្រប់គ្រង សិទ្ធិ',
                dataConnection: 'ការ ចត ទិន្នន័យ',
                courseManagement: 'គ្រប់គ្រង សំឡេង',
                labelManagement: 'គ្រប់គ្រង ស្លាក',
                curriculum: 'មជ្ឈមណ្ឌល វា',
                courseConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ',
                task: 'ភារកិច្ច របស់ ខ្ញុំ',
                historicalLearningData: 'ប្រវត្តិ',
                taskCenter: 'គ្រប់គ្រង ភារកិច្ច',
                knowledgeBase: 'មូលដ្ឋាន សិទ្ធិ',
                ecommerceSessionManagement: 'គ្រប់គ្រង សម័យ E-commerce',
            },
            components: {
                subAppEntries: {
                    applicationSwitching: 'ការ ប្ដូរ កម្មវិធី',
                    descriptionOfIntelligentQualityInspectionSystem: 'សេចក្ដី ពិពណ៌នា របស់ ប្រព័ន្ធ ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
                },
            },
        },
        eCommerceManage: {
            template: {
                ecommerceSessionFilter: 'តម្រង សម័យ E- Comment',
                allEcommerceSessions: 'សម័យ អ៊ីនធឺណិត ទាំងអស់',
                ecommerceSessionManagement: 'គ្រប់គ្រង សម័យ E-commerce',
            },
        },
        analysisEnable: {
            bestPractices: 'សកម្មភាព ល្អ បំផុតName',
            behaviorAnalysis: 'ការ វិភាគ ឥរិយាបថ',
            teamAnalysis: 'ការ វិភាគ ក្រុមComment',
            executiveSupervision: 'ការ ត្រួត ពិន្ទុ ប្រតិបត្តិការName',
            executiveForceAnalysis: 'ការ វិភាគ ប្រតិបត្តិ',
        },
        appealCheckingTask: {
            sdk: {
                index: {
                    interfaceRequestExceptionPleaseTryAgainLater: 'សំណើ អនុវត្ត ចំណុច ប្រទាក់ សូម ព្យាយាម ម្ដង ទៀត ក្រោយ',
                    currentDataCannotBeAppealed: 'ទិន្នន័យ បច្ចុប្បន្ន មិន អាច ត្រូវ បាន បិទ',
                    beforeCanAppeal: 'មុន នឹង អាច សិទ្ធិ',
                    time: 'ពេលវេលា',
                    uniqueRecordID: 'លេខ សម្គាល់ សំឡេង',
                    videoSessionID: 'លេខ សម្គាល់ សម័យ វីដេអូ',
                    intelligentInspectionTime: 'ពេលវេលាត្រួតពិនិត្យគុណភាពឆ្លាតវៃ',
                    manualInspectionTime: 'ពេលវេលាត្រួតពិនិត្យគុណភាពដោយដៃ',
                    grade: 'ការ វាយតម្លៃ ៖',
                    startTime: 'ពេលវេលា ចាប់ផ្ដើម',
                    workOrderNo: 'លេខ លំដាប់ ការងារ',
                    customerServiceHasReadNotRead: 'ភ្នាក់ងារ អាន/មិន អាន',
                    canYouAppeal: 'ថាតើ ត្រូវ អាក់',
                },
                components: {
                    viewTabs: {
                        index: {
                            caseLibrary: 'បណ្ណាល័យ អក្សរ',
                        },
                    },
                    caseLibView: {
                        index: {
                            caseLibrary: 'បណ្ណាល័យ អក្សរ',
                        },
                    },
                    qaResultView: {
                        index: {
                            reviewDetailsNotObtained: 'បាន បរាជ័យ ក្នុង ការ ទៅ យក សេចក្ដី លម្អិត ទិដ្ឋភាព ។',
                            customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                            review: 'ពិនិត្យឡើងវិញ',
                        },
                    },
                },
            },
        },
        clientCenter: {
            wechatClientManage: {
                template: {
                    enterpriseAndMicroNotes: 'សម្គាល់ មីក្រូ សិទ្ធិ',
                    addFriendTime: 'បន្ថែម ពេលវេលា មិត្តភក្ដិ',
                },
            },
            template: {
                ecommerceCustomers: 'ភ្ញៀវ E-commerce',
            },
        },
        qualityInspectionList: {
            detail: {
                component: {
                    finalSubmission: 'ការ ដាក់ ស្នើ ចុងក្រោយ',
                    operationSucceeded: 'ប្រតិបត្តិការ បាន ជោគជ័យ',
                    operationFailed: 'ប្រតិបត្តិការ បាន បរាជ័យ',
                    startPerformingReQualityInspection: 'ចាប់ផ្ដើម ឡើង វិញ',
                    callID: 'លេខ សម្គាល់ ហៅ',
                },
                template: {
                    newFeaturesClickThequickSpotCheckButtonAndAfterTheSubmissionIsSuccessfulItWillAutomaticallyJumpToTheNextPage: 'លក្ខណៈ ពិសេស ថ្មី ! ចុច ប៊ូតុង ការ ពិនិត្យ មើល គំរូ រហ័ស នឹង លោត ទៅ កាន់ ទំព័រ បន្ទាប់ បន្ទាប់ បន្ទាប់ ពី ការ ដាក់ស្នើ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ជោគជ័យ',
                },
                components: {
                    finalReview: {
                        index: {
                            confirmedFinal: 'បាន អះអាង ចុងក្រោយ ?',
                            afterTheFinalReviewOnlyTheFinalReviewAndFilingOperationsAreSupported: 'បន្ទាប់ ពី ការ ត្រួត ពិនិត្យ ចុង ក្រោយ តែ ការ មើល ចុងក្រោយ និង ប្រតិបត្តិការ ដាក់ ចុងក្រោយ ត្រូវ បាន គាំទ្រ ។',
                            finalAppeal: 'សិទ្ធិ ចុងក្រោយ',
                        },
                    },
                },
            },
            template: {
                sort: 'តម្រង',
                deleteRecord: 'លុប ថត',
                areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                confirm: 'កំណត់@ info: whatsthis',
                reIdentification: 'ការ កំណត់ អត្តសញ្ញាណ ឡើង វិញ',
                rerecognitionWillConsumeTranscriptionTimePleaseOperateWithCaution: 'ការ កំណត់ អត្តសញ្ញាណ ឡើង វិញ នឹង បណ្ដោះ អាសន្ន ពេលវេលា ផ្ទេរ សូម ប្រតិបត្តិការ ដោយ សុវត្ថិភាព ។',
                determine: 'កំណត់@ info: whatsthis',
                executionSuccessful: 'ការ ប្រតិបត្តិ ដោយ ជោគជ័យ',
            },
            component: {
                pleaseSelectData: 'សូម ជ្រើស ទិន្នន័យ',
                operationSuccessful: 'ប្រតិបត្តិការ បាន ជោគជ័យ',
                startPerformingReQualityInspection: 'ចាប់ផ្ដើម ឡើង វិញ',
            },
        },
        recordUpload: {
            template: {
                workOrderUpload: 'ផ្ទុក ឡើង វិញ',
                uploadFileName: 'ផ្ទុក ឈ្មោះ ឯកសារ',
                analysisTask: 'ភារកិច្ច វិភាគរក',
                analyzeProgress: 'វិភាគ វឌ្ឍនភាព',
                analysisSucceeded: 'វិភាគ នៃ ជោគជ័យ',
                analysisFailed: 'ការ វិភាគ បរាជ័យ',
                localDataUpload: 'ផ្ទុក ទិន្នន័យ មូលដ្ឋាន',
                recordingUpload: 'ការ ថត អូឌីយ៉ូ',
                textUpload: 'ផ្ទុក ឡើង អត្ថបទName',
                uploadTime: 'ពេលវេលា ផ្ទុក ឡើង',
                taskName: 'ឈ្មោះ ភារកិច្ច',
                operator: 'កម្មវិធី',
                qualityInspectionProgress: 'វឌ្ឍនភាព ត្រួតពិនិត្យ គុណភាព',
                whole: 'ទាំង អស់',
                haveInHand: 'កំពុង វឌ្ឍន៍',
                completed: 'បាន បញ្ចប់',
                exportAllCompletedDataRecordsUnderTheCurrentFilterCondition: 'នាំចេញ ថត ទិន្នន័យ ដែល បាន បញ្ចប់ ទាំងអស់ ក្រោម លក្ខខណ្ឌ តម្រង បច្ចុប្បន្ន ?',
                upload: 'ផ្ទុក ឡើង លើ',
            },
            detail: {
                info: {
                    template: {
                        uploadTicketFieldData: 'ផ្ទុក ទិន្នន័យ វាល ត្រួត ពិន្ទុ',
                        workOrderFieldTemplateDownload: 'ទាញយក ពុម្ព វាល លំដាប់ ការងារ',
                        uploadWorkOrderMailData: 'ផ្ទុក ទិន្នន័យ សំបុត្រ លំដាប់ ការងារ',
                        emailTemplateDownload: 'ទាញយក ពុម្ព អ៊ីមែល',
                        fillInTheName: 'បំពេញ ឈ្មោះ@ info: whatsthis',
                        fillInTheNameSuchAsTheTypesetpurposeOfTheImportedData: 'បញ្ចូល ឈ្មោះ ដូចជា ប្រភេទ/ખ ជ្រើស/គោលបំណង របស់ ទិន្នន័យ ដែល បាន នាំចូល ។',
                        default: 'លំនាំដើម',
                        jDCOM: 'ហ្គីងដូនgreat- britain_ counties. kgm',
                        dataType: 'ប្រភេទ ទិន្នន័យ',
                        selectAnalysisTask: 'ជ្រើស ភារកិច្ច វិភាគName',
                        uploadFiles: 'ផ្ទុក ឯកសារ',
                        DownloadExcelTemplateAndFillInAccordingToTheFormat: '១ ទាញ យក ពុម្ព ខ្ពស់ ខ្ពស់ ហើយ បំពេញ វា យោង តាម ទ្រង់ទ្រាយ ៖',
                        template: 'ពុម្ព',
                        SupportUpTo10000PiecesOfData: '២. គាំទ្រ អតិបរមា 10000 នៃ ទិន្នន័យ',
                        supportTheUploadOfDialogDataExportedByJDLogFileWithAMaximumFileSizeOfM: 'គាំទ្រ ប្រអប់ ទិន្នន័យ ដែល បាន នាំចេញ Jingdong, ឯកសារ.txt, ទំហំ ឯកសារ អតិបរមា 100M',
                        alongTheWayDataTemplate: 'ពុម្ព ទិន្នន័យ បន្ទាត់',
                    },
                },
                result: {
                    template: {
                        workOrderQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព លំដាប់ ការងារ',
                        workOrderQualityInspectionCompleted: 'បាន បញ្ចប់',
                        textUnderInspection: 'សូម រង់ចាំ ដោយ សប្បាយ កំឡុង ពេល ត្រួត ពិនិត្យ គុណភាព អត្ថបទ ។',
                        textQualityInspectionCompleted: 'បាន បញ្ចប់ ការ ត្រួតពិនិត្យ គុណភាព អត្ថបទName',
                    },
                },
                template: {
                    startAnalysis: 'ចាប់ផ្ដើម ការ វិភាគ រក',
                    pleaseUploadTheFile: 'សូម ផ្ទុក ឯកសារ',
                    localDataUpload: 'ផ្ទុក ទិន្នន័យ មូលដ្ឋាន',
                },
            },
        },
        reviewList: {
            detail: {
                template: {
                    newFeaturesClickThereviewAndSubmitButtonAndThePageWillAutomaticallyJumpToTheNextPageAfterTheSubmissionIsSuccessful: 'លក្ខណៈ ពិសេស ថ្មី ! ចុច \'កា រកមើល\' ប៊ូតុង ដាក់ ស្នើ បន្ទាប់ ពី ការ ដាក់ស្នើ ត្រូវ បាន ជោគជ័យ វា នឹង លោត ទៅ ទំព័រ បន្ទាប់ ដោយ ស្វ័យ ប្រវត្តិ',
                },
            },
            template: {
                sort: 'តម្រង',
            },
        },
        role: {
            detail: {
                taskPermissions: {
                    template: {
                        qualityInspectionTaskPermission: 'សិទ្ធិ ភារកិច្ច ត្រួត ពិនិត្យ គុណភាព',
                        edit: 'កែសម្រួល',
                        iParticipated: 'ខ្ញុំ រួមបញ្ចូល បញ្ជា',
                    },
                },
                dataPermissions: {
                    template: {
                        thisRoleCanSeeDataUnderTheSelectedDepartment: 'តួនាទី នេះ អាច មើល ទិន្នន័យ ក្រោម ភាគ ដែល បាន ជ្រើស',
                        dataPermissions: 'សិទ្ធិ ទិន្នន័យ',
                        selectDepartment: 'ជ្រើស ហត្ថលេខា',
                        edit: 'កែសម្រួល',
                    },
                },
            },
        },
        spotCheckList: {
            detail: {
                component: {
                    startPerformingReQualityInspection: 'ចាប់ផ្ដើម ឡើង វិញ',
                    callID: 'លេខ សម្គាល់ ហៅ',
                },
                template: {
                    newFeaturesClickThesampleInspectionSubmissionAndquickSampleInspectionButtonsAfterTheSubmissionIsSuccessfulItWillAutomaticallyJumpToTheNextPage: 'លក្ខណៈ ពិសេស ថ្មី ! ចុច \' គំរូ ដាក់ \' និង\' គំរូ រហ័ស ដាក់ ស្នើ \' ប៊ូតុង នឹង លោត ទៅ ទំព័រ បន្ទាប់ បន្ទាប់ ពី ការ ដាក់ស្នើ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~',
                },
            },
            template: {
                sort: 'តម្រង',
            },
        },
        templateTest: {
            semanticTags: {
                template: {
                    rule: 'បន្ទាត់',
                },
            },
        },
        ticketManage: {
            detail: {
                template: {
                    workOrderManagement: 'គ្រប់គ្រង លំដាប់ ការងារ',
                    workOrderDetails: 'សេចក្ដី លម្អិត លំដាប់ ការងារ',
                },
            },
            template: {
                workOrderFilter: 'តម្រង លំដាប់ ការងារ',
                allWorkOrders: 'លំដាប់ ការងារ ទាំងអស់',
                workOrderManagement: 'គ្រប់គ្រង លំដាប់ ការងារ',
            },
        },
        trainingCenter: {
            topicAnnotation: 'ការ ហៅ ប្រធាន បទ',
            topicList: 'បញ្ជី ប្រតិទិន',
            clusteringAnnotation: {
                components: {
                    filter: {
                        index: {
                            roleType: 'ប្រភេទ ដេល',
                            keyWord: 'ពាក្យ សោ',
                            pleaseEnterKeywordSearch: 'សូម បញ្ចូល ការ ស្វែងរក ពាក្យ គន្លឹះ',
                            query: 'សំណួរ',
                        },
                    },
                },
            },
            similarQuestionRecommend: {
                index: {
                    thisFunctionHasNotBeenOpenedYetPleaseContactTheSystemAdministratorIfNecessary: 'អនុគមន៍ នេះ មិន ត្រូវ បាន បើក ទេ ។ សូម ទាក់ទង អ្នក គ្រប់គ្រង ប្រព័ន្ធ ប្រសិន បើ ចាំបាច់ ។',
                    pleaseSelectAQuestion: 'សូម ជ្រើស សំណួរ !',
                    recommendedSimilarSentencesLargeModel: 'ផ្ដល់ អនុសាសន៍ ដែល ស្រដៀង គ្នា (ម៉ូដែល ធំ)',
                    selectAll: 'ជ្រើស ទាំងអស់',
                    add: 'បន្ថែម@ info: whatsthis',
                    changeBatch: 'ផ្លាស់ប្ដូរ ថត',
                },
            },
            fastTraining: {
                components: {
                    sentenceTypeTag: {
                        index: {
                            createManually: 'បង្កើត ដោយ ដៃ',
                            largeModelExpansion: 'ពង្រីក ម៉ូឌុល ធំ',
                            nLPAutomaticExpansion: 'ពង្រីក NLP ដោយ ស្វ័យ ប្រវត្តិ',
                        },
                    },
                },
            },
        },
        adminEntry: {
            qualityInspectionLanguageSettings: 'ការ កំណត់ ភាសា ត្រួត ពិនិត្យ គុណភាព',
            businessWorkingHours: 'ម៉ោង ការងារ រហ័ស',
            localDataUpload: 'ផ្ទុក ទិន្នន័យ មូលដ្ឋាន',
            assembleMenuListAccordingToCurrentUserPermissions: 'ផ្ញើ បញ្ជី ម៉ឺនុយ ដោយ យោង តាម សិទ្ធិ អ្នក ប្រើ បច្ចុប្បន្ន',
            sessionSettings: 'ការ កំណត់ សម័យ',
            logoSettings: 'ការ កំណត់ ឡូ',
        },
        login: {
            template: {
                welcomeBackPleaseEnterYourDetails: 'សូម ស្វាគមន៍ មក វិញ ! សូម បញ្ចូល សេចក្ដី លម្អិត របស់ អ្នក',
                mailbox: 'អ៊ីមែល',
                password: 'ពាក្យ សម្ងាត់',
                signIn: 'ចូលComment',
            },
            components: {
                layout: {
                    theCurrentIPDoesNotAllowLogin: 'IP បច្ចុប្បន្ន មិន អនុញ្ញាត ការ ចូល ឡើយ',
                    welcomeToLogin: 'សូម ស្វាគមន៍ មក ចូលName',
                    pursuingExcellenceAndLeadingChange: 'យក តម្រាប់ តាម ល្អ ដែល នាំ មុខ ការ ផ្លាស់ប្ដូរ ។',
                    intelligentPlatform: 'វេទិកា ជម្រះ',
                },
                virtualLogin: {
                    index: {
                        pleaseSelect: 'សូម ជ្រើស',
                    },
                },
            },
            oauth: {
                illegalCall: 'ហៅ មិន ត្រឹមត្រូវ',
                welcomeBackClickTheButtonBelowToJumpToTheIdentityAuthenticationPlatform: 'សូម ស្វាគមន៍ មក វិញ ! ចុច ប៊ូតុង ខាងក្រោម ដើម្បី លោត ទៅ កាន់ វេទិកា ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ',
                loggingIn: 'ចូល ... @ info: whatsthis',
                unifiedIdentityAuthenticationLogin: 'ការ ចូល ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ ដែល បាន ឯកសារ',
            },
            component: {
                unableToLogIn: 'មិន អាច ចូល !',
                unableToLand: 'មិន អាច កើត ឡើង !',
                theAccountDoesNotHaveTheCorrectPhoneInformationAndCannotObtainTheVerificationCodePleaseContactTheAdministratorToFillInTheCorrectPhoneInformationAndTryAgain: 'គណនី មិនមាន ព័ត៌មាន ទូរស័ព្ទ ត្រឹមត្រូវ ទេ ហើយ មិន អាច យក កូដ ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ ។ សូម ទាក់ទង អ្នក គ្រប់គ្រង ដើម្បី បំពេញ ព័ត៌មាន ទូរស័ព្ទ ត្រឹមត្រូវ ហើយ ព្យាយាម ម្ដង ទៀត ។',
            },
        },
        checkPointTest: {
            index: {
                simulatedWorkOrder: 'លំដាប់ ការងារ',
                ruleTestSomeRulesCannotBeTestedUsingRulesSuchAsVoiceSpeedVolumeAndOnTheRoadData: 'ការ សាកល្បង ច្បាប់ ៖ ច្បាប់ មួយ ចំនួន មិន អាច ត្រូវ បាន សាកល្បង ដោយ ប្រើ ក្បួន ដូចជា ល្បឿន និយាយ និង កម្រិត សំឡេង ទិន្នន័យ តាម ផ្លូវ ។ ។',
            },
        },
        appEntry: {
            components: {
                subSystemEntryCard: {
                    learnMore: 'សិក្សា ផ្សេងទៀត',
                    enteringTheSystem: 'បញ្ចូល ប្រព័ន្ធ',
                },
            },
            index: {
                cancel: 'បោះបង់',
                enteringTheSystem: 'បញ្ចូល ប្រព័ន្ធ',
                close: 'បិទ',
                enterSystemApplication: 'បញ្ចូល កម្មវិធី ប្រព័ន្ធ',
                clickEnterSystemToJumpToTheEnabledSystemApplication: 'ចុច "បញ្ចូល ប្រព័ន្ធ" ដើម្បី លោត ទៅ កម្មវិធី ប្រព័ន្ធ ដែល បាន អនុញ្ញាត',
            },
        },
        permissionManagement: {
            employeeManagement: 'គ្រប់គ្រង ភ្ញៀវ',
            roleManagement: 'គ្រប់គ្រង រលូន',
            permissionManagement: 'គ្រប់គ្រង សិទ្ធិ',
        },
        generalSetting: {
            docking: {
                components: {
                    ruleList: {
                        beEqualTo: 'ស្មើ',
                        contain: 'មាន ថ្មី',
                        doesNotContain: 'មិនមាន ទេ',
                        applicationSystem: 'ប្រព័ន្ធ កម្មវិធី',
                        intelligentQualityInspection: 'ការ ត្រួត ពិនិត្យ/ ការ វិភាគ សម័យ គុណភាព ត្រឹមត្រូវ',
                        salesEmpowerment: 'ការ សន្យារ',
                        dataSourceType: 'ប្រភេទ ប្រភព ទិន្នន័យ',
                        filterCriteria: 'លក្ខខណ្ឌ តម្រង',
                    },
                },
                index: {
                    dataConnection: 'ការ ចត ទិន្នន័យ',
                    savingSucceeded: 'រក្សាទុក ដោយ ជោគជ័យ',
                    dataIsolation: 'ការ បំពេញ ទិន្នន័យ',
                    afterOpeningYouCanSetTheDataRangeOfEachApplicationSystemAccessCallAndEnterpriseWeChatSessionIfTheSwitchIsNotTurnedOnAllSystemsAreConnectedToFullData: 'បន្ទាប់ ពី បើក អ្នក អាច កំណត់ ជួរ ទិន្នន័យ នៃ ការ ចូល ដំណើរការ ប្រព័ន្ធ កម្មវិធី នីមួយៗ សម័យ WeChat ។ ប្រសិន បើ មិន ត្រូវ បាន បើក ប្រព័ន្ធ ទាំងអស់ នឹង ត្រូវ បាន តភ្ជាប់ ទៅ ទិន្នន័យ ពេញលេញ ។',
                    accessRules: 'ច្បាប់ ចូល ដំណើរការ',
                    preservation: 'រក្សាទុក',
                },
            },
            permissionManagement: {
                role: {
                    index: {
                        applyName: 'ឈ្មោះ កម្មវិធី',
                        accessRights: 'ចូល ដំណើរការ',
                        inAppPermissionSettings: 'ការ កំណត់ សិទ្ធិ ក្នុង appName',
                        setUp: 'រៀបចំ',
                        applicationAccess: 'ចូល ដំណើរការ កម្មវិធី',
                        newRole: 'ភាព ថ្មី',
                    },
                },
            },
        },
        wechatNotificationAnalysis: {
            conversationalAnalysis: {
                index: {
                    sessionDetails: 'សេចក្ដី លម្អិត សម័យ',
                },
            },
            messageNotification: {
                index: {
                    sessionDetails: 'សេចក្ដី លម្អិត សម័យ',
                    caseDetails: 'សេចក្ដី លម្អិត',
                },
            },
        },
        coach: {
            courseManagement: {
                baseInfo: {
                    index: {
                        save: 'រក្សាទុក',
                        cancel: 'បោះបង់',
                        visibleEmployees: 'អ្នក ប្រើ ដែល មើល ឃើញName',
                        newCourse: 'ទីតាំង ថ្មី',
                        editCourse: 'កែសម្រួល សំឡេង',
                        courseName: 'ឈ្មោះ សំឡេង',
                        courseIntroduction: 'ការ ណែនាំ ដក',
                        courseType: 'ប្រភេទ សំឡេង',
                        courseClassification: 'ថ្នាក់ វត្ថុ',
                        courseCover: 'គម្រប',
                        learningContent: 'មាតិកា បង្ហាញ',
                        uploadLearningMaterials: 'ផ្ទុក វត្ថុ បង្រៀន ឡើង ឡើង',
                    },
                },
                flow: {
                    components: {
                        configDrawer: {
                            test: 'សាកល្បង',
                            preservation: 'រក្សាទុក',
                            cancel: 'បោះបង់',
                            editNodeName: 'កែសម្រួល ឈ្មោះ ថ្នាំង',
                            determine: 'កំណត់@ info: whatsthis',
                            individual: 'មួយ',
                            of: 'សរុប',
                            branch: 'ចំណុច',
                        },
                        configDrawerComponents: {
                            pPTParsing: 'ការ វិភាគ PPT នៅ ក្នុង ...',
                            uploadSuccessful: 'ផ្ទុក ឡើង ជោគជ័យ',
                            uploadAttachments: 'ផ្ទុក ឯកសារ ភ្ជាប់',
                            pPTParsingPleaseWait: 'ញែក PPT សូម រង់ចាំ បាន',
                        },
                        customerPortraitConfigDrawer: {
                            cancel: 'បោះបង់',
                            afterDeletionItCannotBeRestoredAreYouSureYouWantToDeleteThisPortrait: 'វា មិន អាច ត្រូវ បាន ស្ដារ ឡើង វិញ បន្ទាប់ ពី លុប ។ តើ អ្នក ពិត ជា ចង់ លុប រូបរាង នេះ ឬ ?',
                            delete: 'លុប',
                            determine: 'កំណត់@ info: whatsthis',
                            customerPortrait: 'ច្រក ក្បៀស',
                            bindSelectedCharacterPortrait: 'ចង តួអក្សរ ដែល បាន ជ្រើស',
                            customerProfileDetails: 'សេចក្ដី លម្អិត ទម្រង់ របស់ ម៉ាស៊ីន ភ្ញៀវ',
                            createANewCustomerProfile: 'ទម្រង់ ម៉ាស៊ីន ភ្ញៀវ ថ្មី',
                        },
                        flow: {
                            sidebar: {
                                node: 'ថ្នាំង',
                            },
                            useControlButtons: {
                                cancellingPleaseWait: 'មិន ធ្វើ វិញ សូម ក្រោយ ...',
                                redoInProgressPleaseWait: 'ឡើង វិញ សូម ក្រោយ ....',
                                automaticOrganization: 'បញ្ចប់ ដោយ ស្វ័យ ប្រវត្តិ',
                                canvasAdaptation: 'ផ្ទៃ ខ្លួន រចនាសម្ព័ន្ធ',
                                delete: 'លុប',
                            },
                            useFlow: {
                                nodeCannotBeConnectedToItself: 'ថ្នាំង មិន អាច តភ្ជាប់ ទៅកាន់ ខ្លួន វា បាន ទេ',
                            },
                        },
                        globalConfigDrawer: {
                            cancel: 'បោះបង់',
                            determine: 'កំណត់@ info: whatsthis',
                            globalConfiguration: 'ការ កំណត់ រចនាសម្ព័ន្ធ សកល',
                            sessionDetection: 'ការ រក ឃើញ សម័យ',
                            reciprocalRule: 'ក្ដារ អន្តរកម្ម',
                            robotVoice: 'សំឡេង  Robot',
                        },
                        interactionRuleForm: {
                            studentNodeTimeoutWithoutAnsweringSetting: 'ការ កំណត់ ថ្នាំង សិទ្ធិ អស់ ពេលវេលា ដែល មិន បាន ឆ្លើយតប',
                            maximumAllowedSilenceTimeForStudentsNotAnswerings: 'អនុញ្ញាត អតិបរមា ពេលវេលា ស្ងាត់ (s)',
                            promptScriptForFailureToAnswerOverTime: 'សួរ សម្រាប់ អស់ ពេលវេលា',
                            addScript: 'បន្ថែម ពាក្យ',
                        },
                        robotTimbreForm: {
                            aixianatural: 'អ៊ីស (និមិត្ត)',
                            zhishaChat: 'Zhisha (ជជែក)',
                            zhiqiangentle: 'ស៊ីគីយ៉ា (Gentle)',
                            zhimiEmotion: 'ស្គាល់ ឃ្លាំង',
                            aiShuoNatural: 'អ៊ីសូ (និមិត្ត)',
                            zhishuoChat: 'Zhishuo (ជជែក)',
                            aiHaoAffinity: 'អ៊ី ហូ (Affinity)',
                            zhixiangEmotion: 'ហ្គីxiang (បង្ហាញ)',
                            robotVoice: 'សំឡេង  Robot',
                            schoolboy: 'ក្មេង',
                            girlStudent: 'ក្មេង',
                            volume: 'កម្រិត សំឡេង',
                            tone: 'តូន',
                            speechSpeed: 'ល្បឿន និយាយComment',
                            test: 'សាកល្បង',
                            helloIAmAnIntelligentTrainingCoachAndLookForwardToCommunicatingWithYou: 'Hello, ខ្ញុំ ជា អ្នក បង្ហាត់ បង្ហាត់ បង្ហាត់ បង្ហាញ និង រង់ចាំ ទៅ កាន់ ទំនាក់ទំនង ជាមួយ អ្នក ។',
                        },
                        sessionDetectionForm: {
                            expressionDetection: 'រក ឃើញ កន្សា',
                            excessiveDetectionOfModalParticles: 'ការ រក ឃើញ ពាក្យ ម៉ូឌុល បន្ថែម',
                            theNumberOfRepetitionsIs: 'ចំនួន ការ ធ្វើ ឡើងវិញ',
                            minus: 'ពេលវេលា បន្ថែម',
                            appear: 'លេចឡើយ',
                            subtract: 'ពេលវេលា បន្ថែម',
                            branch: 'ចំណុច',
                            addRules: 'បន្ថែម បន្ទាត់',
                            includingNegativeAngryComplaining: '(រួម បញ្ចូល អន្តរ, ខ្លាំង, ស្លាប់)',
                            scorePointsDisplay: 'ការ បង្ហាញ ចំណុច ពិន្ទុ',
                            reminderOfSpeakingTooFasttooSlow: 'ល្បឿន',
                            scriptViolationReminder: 'កម្មវិធី រំលឹក',
                            emotionalReminder: 'ការ រំលឹក សម្រាក',
                            speechSpeedDetection: 'ការ រក ឃើញ ល្បឿន និយាយComment',
                            normalSpeechSpeedScore: 'ការ សម្រាក ត្បូង',
                            speakTooFast: 'និយាយ លឿន ពេញ',
                            everyMinuteGreaterThan: 'ក្នុង មួយ នាទី',
                            aWordAppears: 'ពាក្យ លេចឡើង ។',
                            speakTooSlowly: 'និយាយ យឺត ពេកComment',
                            lessThanPerMinute: 'តិច ជា មួយ ក្នុង នាទី',
                            ignoreLessThan: 'មិន អើពើ',
                            aSentenceOfWords: 'ពាក្យ ពាក្យ',
                            emotionalDetection: 'ការ រក ឃើញ សំខាន់',
                            emotionalNormalScore: 'ពិន្ទុ ខ្ពស់ ធម្មតា',
                            negativeEmotions: 'សកម្មភាព អុហ្វសិត',
                            illegalWordDetection: 'ការ រក ឃើញ ពាក្យ មិន ត្រឹមត្រូវ',
                            scriptViolationConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ បំបាត់ និយាយComment',
                            realTimePromptOnTheFrontEnd: 'ប្រយោជន៍ ពេលវេលា real- endName',
                        },
                        const: {
                            nodeConfigs: {
                                knowledgeNode: {
                                    knowledgeBaseQA: 'ស្គាល់ Q & A',
                                    qAMethod: 'វិធីសាស្ត្រ សំណួរ និង ចម្លើយ',
                                    numberOfQuestionsAndAnswers: 'ចំនួន សំណួរ និង ចម្លើយ',
                                    scoringRules: 'ក្ដារ ពិន្ទុ',
                                    ifAnyQuestionAndAnswerIsCorrect: 'សំណួរ និង ចម្លើយ ត្រឹមត្រូវ អ្នក ហេតុ',
                                    branch: 'ចំណុច',
                                    successfullySaved: 'រក្សាទុក ដោយ ជោគជ័យ',
                                },
                                pptNode: {
                                    verificationPassed: 'ការ ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ',
                                    upload: 'ផ្ទុក ឡើង លើ',
                                    supportPptPdfFormatFiles: 'គាំទ្រ ឯកសារ ទ្រង់ទ្រាយ ppt និង pdf',
                                    uploadSlide: 'ផ្ទុក ស្លាយ',
                                    assessmentMethod: 'វិធីសាស្ត្រ តម្លៃ',
                                    associateSlide: 'ស្លាយ ទាក់ទង',
                                    standardScript: 'និយាយ ស្តង់ដារ',
                                    successfullySaved: 'រក្សាទុក ដោយ ជោគជ័យ',
                                },
                                robotNode: {
                                    robotScript: 'និយាយ  Robot',
                                    randomScript: 'និយាយ ចៃដន្យ',
                                    chooseAScriptWithSimilarSemanticsAndTheRobotWillRandomlySayOneSentence: 'ជ្រើស និយាយ សញ្ញា ស្រដៀងគ្នា រ៉ូប៊ី នឹង និយាយ ចៃដន្យ',
                                    customerPortrait: 'ច្រក ក្បៀស',
                                    whenTheCustomersPortraitIsConsistentTheRobotSaysThisScript: 'នៅពេល ចំណុច ប្រទាក់ អ្នក ភ្ជាប់',
                                    setAsDefaultScript: 'កំណត់ ជា លំនាំដើម',
                                    yes: 'បាន',
                                    no: 'គ្មាន ទេ',
                                    useThisScriptWhenTheRobotMissesAnyUserTags: 'វា ត្រូវ បាន និយាយ ពេល រ៉ូប៊ី បាត់ ស្លាក អ្នក ប្រើ ណាមួយ ។',
                                    successfullySaved: 'រក្សាទុក ដោយ ជោគជ័យ',
                                    thisBranchNodeAlreadyHasADefaultScriptDoYouWantToReplaceTheDefaultScriptWithTheCurrentScript: 'ថ្នាំង នេះ មាន និយាយ លំនាំដើម រួច ហើយ ។ តើ អ្នក ចង់ ជំនួស និយាយ លំនាំដើម ដោយ និយាយ បច្ចុប្បន្ន ឬ ?',
                                },
                                startNode: {
                                    paragon: 'សំឡេង',
                                    successfullySaved: 'រក្សាទុក ដោយ ជោគជ័យ',
                                },
                                userNode: {
                                    verificationPassed: 'ការ ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ',
                                    standardScript: 'និយាយ ស្តង់ដារ',
                                    successfullySaved: 'រក្សាទុក ដោយ ជោគជ័យ',
                                },
                                aiGenDialogueNode: {
                                    pleaseImproveTheConfiguration: 'សូម កំណត់ រចនា សម្ព័ន្ធ',
                                },
                                aiGenPromptNode: {
                                    pleaseEnterAConversationExample: 'សូម បញ្ចូល គំរូ សម្រាំង',
                                    dialogueExample: 'ឧទាហរណ៍ ទំនាក់ទំនង',
                                    generateConversationExamples: 'បង្កើត ឧទាហរណ៍ ប្រអប់Name',
                                    mattersNeedingAttention: 'ការ ព្យាយាមComment',
                                    pleaseEnterThePromptLanguage: 'សូម បញ្ចូល សួរ',
                                },
                                aiGenSceneNode: {
                                    dialogueScenario: 'ប្រអប់ រូបភាព',
                                    simulateCharacter: 'តួ អក្សរ',
                                    accompanyingTrainees: 'វត្ថុ ដែល ចូលរួម@ info: whatsthis',
                                    selectFromTemplateLibrary: 'ជ្រើស ពី បណ្ណាល័យ ពុម្ព',
                                    templateLibrary: 'បណ្ណាល័យ ពុម្ព',
                                    role: 'រលូន',
                                    scene: 'ចម្រៀក',
                                },
                            },
                        },
                        pPTTestDrawer: {
                            slideTestWindow: 'បង្អួច សាកល្បង ស្លាយ',
                            clearContent: 'ជម្រះ មាតិកា',
                            close: 'បិទ',
                        },
                        aiGenFlowDrawer: {
                            index: {
                                aIGenerationProcessScript: 'ដំណើរការ បង្កើត AI',
                                scriptStyle: 'រចនាប័ទ្ម និយាយComment',
                                theMostConversationRounds: 'ពណ៌ ជុំ ច្រើន នៃ ប្រអប់Name',
                                copyConversation: 'ប្រអប់ ចម្លង',
                                application: 'កម្មវិធី',
                                regenerate: 'បង្កើត ឡើង វិញ',
                                startGenerating: 'ចាប់ផ្តើម',
                                pleaseGenerateAProcess: 'សូម បង្កើត ដំណើរការ',
                                copySuccessful: 'ចម្លង ជោគជ័យ',
                            },
                        },
                        aiGenPPTDrawer: {
                            components: {
                                tipInput: {
                                    index: {
                                        salesRepresentative: 'អ្នក លេង លេង',
                                        customerServicePersonnel: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                                        storeCounter: 'រក្សាទុក ច្រក',
                                    },
                                },
                            },
                            index: {
                                generateFullTextSpeechScript: 'បង្កើត សិទ្ធិ និយាយ ពេញ អត្ថបទ ពេញ',
                                speaker: 'អ្នក និយាយComment',
                                scriptStyle: 'រចនាប័ទ្ម និយាយComment',
                                copyConversation: 'ប្រអប់ ចម្លង',
                                application: 'កម្មវិធី',
                                regenerate: 'បង្កើត ឡើង វិញ',
                                startGenerating: 'ចាប់ផ្តើម',
                                pleaseGenerateAProcess: 'សូម បង្កើត ដំណើរការ',
                                operationSuccessful: 'ប្រតិបត្តិការ បាន ជោគជ័យ',
                                copySuccessful: 'ចម្លង ជោគជ័យ',
                            },
                        },
                        aiTextArea: {
                            index: {
                                scriptPolishing: 'សម្រាក',
                            },
                        },
                        aiWordsTextArea: {
                            theScriptCannotBeEmpty: 'ពាក្យ មិន អាច ទទេ !',
                            copySuccessful: 'ចម្លង ជោគជ័យ',
                            cancel: 'បោះបង់',
                            copy: 'ចម្លង',
                            replaceTheOriginalText: 'ជំនួស ដើម',
                            aiGeneration: 'បង្កើត AiName',
                            aiPolishing: 'អ៊ី',
                            currentStyle: 'រចនាប័ទ្ម បច្ចុប្បន្ន',
                            rigorous: 'កម្លាំង',
                            mild: 'លុប',
                            lively: 'ផ្ទៃតង',
                            simplicity: 'ធម្មតា',
                            pleaseEnterTheSpeakerRole: 'សូម បញ្ចូល តួនាទី របស់ អ្នក និយាយ ៖',
                            startGenerating: 'ចាប់ផ្តើម',
                        },
                        auditionTextArea: {
                            theScriptCannotBeEmpty: 'ពាក្យ មិន អាច ទទេ !',
                            copySuccessful: 'ចម្លង ជោគជ័យ',
                            aiRewrite: 'សរសេរ ឡើង វិញ',
                            cancel: 'បោះបង់',
                            copy: 'ចម្លង',
                            replaceTheOriginalText: 'ជំនួស ដើម',
                            currentStyle: 'រចនាប័ទ្ម បច្ចុប្បន្ន',
                            rigorous: 'កម្លាំង',
                            mild: 'លុប',
                            lively: 'ផ្ទៃតង',
                            simplicity: 'ធម្មតា',
                            pleaseEnterTheSpeakerRole: 'សូម បញ្ចូល តួនាទី របស់ អ្នក និយាយ ៖',
                            startGenerating: 'ចាប់ផ្តើម',
                        },
                    },
                    index: {
                        verificationPassed: 'ការ ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ',
                        ruleValidation: 'ការ ផ្ទៀងផ្ទាត់ បន្ទាត់',
                        aIGeneration: 'បង្កើត AI',
                        generateFullTextSpeechScript: 'បង្កើត សិទ្ធិ និយាយ ពេញ អត្ថបទ ពេញ',
                        editCourse: 'កែសម្រួល សំឡេង',
                        importConversation: 'នាំចូល សៀវភៅ',
                        uploadExcelToCompleteDialogueImport: 'ការ នាំចូល ប្រអប់ លេង',
                        editBasicInformation: 'កែសម្រួល ព័ត៌មាន មូលដ្ឋាន',
                        test: 'សាកល្បង',
                        release: 'បោះពុម្ព',
                    },
                },
            },
            customerTagsManagement: {
                components: {
                    addTag: {
                        index: {
                            newLabel: 'ស្លាក ថ្មី',
                        },
                    },
                    tag: {
                        index: {
                            afterDeletionItCannotBeRestoredAreYouSureYouWantToDeleteThisLabel: 'មិន អាច យក ឡើងវិញ បន្ទាប់ ពី លុប ។ តើ អ្នក ពិត ជា ចង់ លុប ស្លាក នេះ ឬ ?',
                            delete: 'លុប',
                            cancel: 'បោះបង់',
                        },
                    },
                },
                index: {
                    labelManagement: 'គ្រប់គ្រង ស្លាក',
                    newGroup: 'ក្រុម ថ្មី',
                    edit: 'កែសម្រួល',
                    afterDeletionItCannotBeRestoredAreYouSureYouWantToDeleteThisLabelGroup: 'មិន អាច យក ឡើងវិញ បន្ទាប់ ពី លុប ។ តើ អ្នក ពិត ជា ចង់ លុប ក្រុម ស្លាក នេះ ឬ ?',
                    delete: 'លុប',
                    cancel: 'បោះបង់',
                    editGroup: 'កែសម្រួល ការ ដាក់ ក្រុមComment',
                    labelGroupName: 'ឈ្មោះ ក្រុម ស្លាក',
                },
            },
            learningCenter: {
                components: {
                    camera: {
                        index: {
                            cameraDisabled: 'បិទ ម៉ាស៊ីន ថត',
                            noCameraDevicesFound: 'រក មិន ឃើញ ឧបករណ៍ ម៉ាស៊ីន ថត',
                        },
                    },
                    cue: {
                        index: {
                            regenerate: 'បង្កើត ឡើង វិញ',
                            generate: 'បង្កើត@ info: whatsthis',
                            referenceScript: 'និយាយ យោងName',
                            mattersNeedingAttention: 'ការ ព្យាយាមComment',
                            examFrequency: 'ចំនួន សិទ្ធិ',
                            section: 'ភាគComment',
                            timestotal: 'ពេលវេលា/ សរុប',
                            second: 'ពេលវេលាName',
                            requirementsForPassingTheExam: 'ការ ទាមទារ សម្រាប់ ការ អនុញ្ញាត',
                            examScore: 'ពិន្ទុ សាកល្បង ≥',
                            branch: 'ចំណុច',
                        },
                    },
                    customerInfo: {
                        index: {
                            thereIsCurrentlyNoPortraitAvailable: 'គ្មាន ច្រក',
                            customerBackground: 'ផ្ទៃ ខាង ក្រោយ របស់ ម៉ាស៊ីន ភ្ញៀវ',
                            customerLabel: 'ស្លាក ម៉ាស៊ីន ភ្ញៀវ',
                        },
                    },
                    flow: {
                        index: {
                            processReminder: 'ដំណើរការ (',
                            score: 'ពិន្ទុ',
                            TotalScore: '/ ពិន្ទុ',
                        },
                    },
                    index: {
                        taskSource: 'ប្រភព ភារកិច្ច',
                        taskName: 'ឈ្មោះ ភារកិច្ច',
                        taskStatus: 'ស្ថានភាព ភារកិច្ច',
                        whole: 'ទាំង អស់',
                        completionStatus: 'ស្ថានភាព បញ្ចប់',
                        courseClassification: 'ថ្នាក់ វត្ថុ',
                        practiceMode: 'របៀប អនុវត្តComment',
                        examMode: 'របៀប ព្រួញ',
                        practiceTime: 'ពេលវេលា បង្ហាញ',
                    },
                    ppt: {
                        index: {
                            nextPage: 'ទំព័រ បន្ទាប់',
                            tips: 'សួរ',
                            continueWithCurrentPage: 'បន្ត ទំព័រ បច្ចុប្បន្ន',
                            goToTheNextPage: 'ទៅ ទំព័រ បន្ទាប់',
                            afterEnteringTheNextPageYouWillNotBeAbleToReturnToThePreviousPagePleaseConfirmThatTheExplanationOnTheCurrentPageIsCompleteBeforeJumpingToTheNextPage: 'បន្ទាប់ ពី បញ្ចូល ទំព័រ បន្ទាប់ អ្នក នឹង មិន អាច ត្រឡប់ ទៅ ទំព័រ មុន ។ សូម អះអាង ថា ការ ពន្យល់ របស់ ទំព័រ បច្ចុប្បន្ន បាន បញ្ចប់ មុន ពេល លោត ។',
                            clickingOnTheNextPageWillNoLongerCauseThisPromptToPopUp: 'ចុច លើ ទំព័រ បន្ទាប់ នឹង មិន លេចឡើង វិញ',
                        },
                        list: {
                            index: {
                                slide: 'ស្លាយ',
                            },
                        },
                    },
                    record: {
                        index: {
                            unableToRecord: 'មិន អាច ថត ៖',
                            creatingARecorderService: 'បង្កើត សេវា កម្មវិធី ថត',
                            turnOffTheRecorderService: 'បិទ សេវា កម្មវិធី ថត',
                            theCurrentClientIsAlreadyConnectedToTheASRWebsocketServer: 'ម៉ាស៊ីន ភ្ញៀវ បច្ចុប្បន្ន ត្រូវ បាន តភ្ជាប់ ទៅកាន់ ម៉ាស៊ីន បម្រើ ASR Websocket រួច ហើយ',
                            afterProcessingTheLastFrameRestoreTheState: 'បន្ទាប់ ពី ដំណើរការ ស៊ុម ចុងក្រោយ ស្ដារ ស្ដារ',
                            aSRConnectionClosed: 'បាន បិទ ការ តភ្ជាប់ ASR ... Name',
                            recordingPausedAndHasBeenProcessedButThereIsStillDataInTheCache: 'ការ ថត ត្រូវ បាន ផ្អាក ហើយ ត្រូវ បាន ដំណើរការ ប៉ុន្តែ នៅ តែ មាន ទិន្នន័យ នៅ ក្នុង ឃ្លាំង សម្ងាត់',
                            foundASRChannelClosedRecreateWebsocketLink: 'រក ឃើញ ឆានែល ASR ដែល បាន បិទ ហើយ បង្កើត តំណ Websocket ឡើង វិញ',
                            foundThatTheASRChannelIsNotOpenRecreateTheWebsocketLink: 'រកឃើញ ថា ឆានែល ASR មិន អាច បើក បាន បង្កើត តំណ Websocket ឡើង វិញ',
                        },
                        ppt: {
                            hook: {
                                index: {
                                    serverError: 'កំហុស ម៉ាស៊ីន បម្រើ',
                                },
                            },
                        },
                        text: {
                            index: {
                                pleaseEnter: 'សូម បញ្ចូល',
                                sendOut: 'ផ្ញើ',
                                startPracticing: 'ចាប់ផ្ដើម ដំណើរការ',
                                startTheExam: 'ចាប់ផ្ដើម សិទ្ធិ',
                            },
                        },
                        util: {
                            recorded: 'បាន ថត',
                            BitPcmSendFrameSizeMustBeAnIntegerMultipleOf2: '១៦- ប៊ីត pcm SendFrameSize ត្រូវ តែ ជា ចំនួន គំរូ នៃ ២',
                            pCMSamplingRateShouldNotOccur: 'អត្រា គំរូ pcm គួរ លេចឡើង ឡើយ',
                            andTheRequiredSamplingRate: 'និង អត្រា គំរូ ដែល ទាមទារ',
                            atypism: 'មិន ត្រឹមត្រូវ',
                            errorsThatShouldNotOccur: 'កំហុស ដែល មិន គួរ កើត ឡើង ៖',
                            spanStylecolorRedDataWithDisorderedOrderCanBeDirectlyDiscardedIfTheRequirementsAreNotHighspan: '<Span រចនាប័ទ្ម = "color: red"> ទិន្នន័យ ដែល ក្រៅ លំដាប់ អាច ត្រូវ បាន បោះបង់ ប្រសិនបើ ការ ទាមទារ មិន មាន ខ្ពស់ ។ </ Span>',
                            flower: 'ភ្លើង',
                            TransferStopped: ': ការ ផ្ទេរ បាន បញ្ឈប់',
                        },
                        video: {
                            index: {
                                camera: 'ម៉ាស៊ីន ថត',
                            },
                        },
                        voice: {
                            hook: {
                                bat: {
                                    index: {
                                        theCurrentClientIsAlreadyConnectedToTheASRWebsocketServer: 'ម៉ាស៊ីន ភ្ញៀវ បច្ចុប្បន្ន ត្រូវ បាន តភ្ជាប់ ទៅកាន់ ម៉ាស៊ីន បម្រើ ASR Websocket រួច ហើយ',
                                        aSRConnectionClosed: 'បាន បិទ ការ តភ្ជាប់ ASR ... Name',
                                        foundASRChannelClosedRecreateWebsocketLink: 'រក ឃើញ ឆានែល ASR ដែល បាន បិទ ហើយ បង្កើត តំណ Websocket ឡើង វិញ',
                                        unableToRecord: 'មិន អាច ថត ៖',
                                        aSRChannelClosedReopened: 'បាន បិទ ឆានែល ASR បាន បើក ឡើង វិញ',
                                        theASRChannelWasNotCreatedStartingNow: 'មិន បាន បង្កើត ឆានែល ASR ទេ ចាប់ផ្ដើម បង្កើត ឥឡូន',
                                        useEffectCallbackToClearTheASRChannel: 'UseEffect callback ដើម្បី ជម្រះ ឆានែល ASRName',
                                        creatingARecorderService: 'បង្កើត សេវា កម្មវិធី ថត',
                                        turnOffTheRecorderService: 'បិទ សេវា កម្មវិធី ថត',
                                    },
                                    util: {
                                        recorded: 'បាន ថត',
                                        BitPcmSendFrameSizeMustBeAnIntegerMultipleOf2: '១៦- ប៊ីត pcm SendFrameSize ត្រូវ តែ ជា ចំនួន គំរូ នៃ ២',
                                        pCMSamplingRateShouldNotOccur: 'អត្រា គំរូ pcm គួរ លេចឡើង ឡើយ',
                                        andTheRequiredSamplingRate: 'និង អត្រា គំរូ ដែល ទាមទារ',
                                        atypism: 'មិន ត្រឹមត្រូវ',
                                        errorsThatShouldNotOccur: 'កំហុស ដែល មិន គួរ កើត ឡើង ៖',
                                        spanStylecolorRedDataWithDisorderedOrderCanBeDirectlyDiscardedIfTheRequirementsAreNotHighspan: '<Span រចនាប័ទ្ម = "color: red"> ទិន្នន័យ ដែល ក្រៅ លំដាប់ អាច ត្រូវ បាន បោះបង់ ប្រសិនបើ ការ ទាមទារ មិន មាន ខ្ពស់ ។ </ Span>',
                                        flower: 'ភ្លើង',
                                        TransferStopped: ': ការ ផ្ទេរ បាន បញ្ឈប់',
                                    },
                                },
                                index: {
                                    failInSend: 'បាន បរាជ័យ ក្នុង ការ ផ្ញើ',
                                },
                            },
                            index: {
                                startRecording: 'ចាប់ផ្ដើម ថត',
                                endRecording: 'ចុង ថត',
                                startPracticing: 'ចាប់ផ្ដើម ដំណើរការ',
                                startTheExam: 'ចាប់ផ្ដើម សិទ្ធិ',
                            },
                        },
                    },
                    taskMessageModal: {
                        index: {
                            theRemainingNumberOfTimesForTheCurrentExamIs: '(ចំនួន សិទ្ធិ បច្ចុប្បន្ន កំពុង នៅស់ទេ',
                            totalScriptScore: 'ពិន្ទុ សរុប ៖',
                            totalEmotionalScore: 'ពិន្ទុ សរុប ៖',
                            totalScoreOfExpression: 'ពិន្ទុ កន្សោម សរុប ៖',
                            theCurrentTaskRatingResultNeedsToBeManuallyReviewedAfterTheReviewIsCompletedYouWillBeNotifiedOfTheFinalScorePleaseBePatientAndWait: 'លទ្ធផល ការ ពិនិត្យ ភារកិច្ច បច្ចុប្បន្ន ត្រូវ តែ មើល ដោយ ដៃ ។ បន្ទាប់ ពី ការ ពិនិត្យ បាន បញ្ចប់ អ្នក នឹង ត្រូវ បាន ជូនដំណឹង អំពី លទ្ធផល ចុងក្រោយ ។ សូម រង់ចាំ ដោយ សប្បាយ ។',
                            areYouSureToSubmit: 'អះអាង ការ ដាក់ស្នើ ?',
                            theExerciseHasEndedAreYouSureToSubmit: 'ការ វិវរណៈ បាន បញ្ចប់, តើ អ្នក ពិត ជា ចង់ ដាក់ ស្នើ វា ឬ ?',
                            theExamHasEndedAreYouSureToSubmit: 'ការ សិទ្ធិ បាន បញ្ចប់ តើ អ្នក ពិត ជា ចង់ ដាក់ ស្នើ វា ឬ ?',
                            completed: 'បាន បញ្ចប់',
                            page: 'ទំព័រ',
                            pageCount: 'ទំព័រ សរុប',
                            topic: 'ប្រធាន បទ',
                            totalNumberOfQuestions: 'ចំនួន សរុប នៃ សំណួរ',
                            totalScore: 'ពិន្ទុ សរុប',
                            branch: 'ចំណុច',
                            accumulatedCompletionProgress: 'វឌ្ឍនភាព បញ្ចប់ សមរម្យ',
                            accumulatedPracticeDuration: 'កាលបរិច្ឆេទ វិភាគ រយ',
                            lastPauseExerciseResults: 'លទ្ធផល វិធីសាស្ត្រ ពេលវេលា ចុងក្រោយ',
                            exerciseInstructions: 'បង្ហាត់ បង្ហាញ',
                            examInstructions: 'សេចក្ដី ពិពណ៌នា សិទ្ធិ',
                            halfwayPausePracticeResults: 'លទ្ធផល ផ្អាក ពិសេស ផ្អាក',
                            tips: 'សួរ',
                            afterExitingThisExerciseWillNotBeCountedTowardsTheGradeAreYouSureToExit: 'បន្ទាប់ ពី បញ្ហា នេះ នឹង មិន ត្រូវ បាន រួម បញ្ចូល ក្នុង ពិន្ទុ ។ តើ អ្នក ពិត ជា ចង់ ចេញ ឬ ?',
                            exitIsNotAllowedMidwayThroughTheExamAreYouSureToSubmit: 'ការ បិទ មិន ត្រូវ បាន អនុញ្ញាត ក្នុង កម្រិត សិទ្ធិ ។ អះអាង ការ ដាក់ស្នើ ?',
                            pleaseOperateWithCaution: 'ពេលវេលា សូម អនុញ្ញាត ឲ្យ ប្រតិបត្តិ)',
                            restart: 'ចាប់ផ្ដើម ឡើង វិញ',
                            returnToLearning: 'ត្រឡប់ ទៅ សៀវភៅ',
                            continuePracticing: 'បន្ត សកម្មភាព',
                            continuingTheExam: 'បន្ត សិទ្ធិ',
                            return: 'ត្រឡប់ វិញ',
                            notSubmittedTemporarily: 'មិន បាន ដាក់ ស្នើ',
                            iGotIt: 'ខ្ញុំ ដឹង ។',
                            confirmExit: 'អះអាង ចេញ',
                            confirmSubmission: 'អះអាង ការ ដាក់ ស្នើ',
                            signOut: 'ចេញ',
                        },
                    },
                    taskSubmitButton: {
                        index: {
                            suspend: 'ផ្អាក',
                            submit: 'ដាក់ ស្នើ',
                            remainingTimeOfThisQuestion: 'ពេលវេលា ដែល នៅ សល់',
                            SecondsLeftUntilTheEndTime: '១០ វិនាទី',
                            remainingTime: 'ពេលវេលា ដែល នៅ សល់',
                        },
                    },
                    util: {
                        noUserVoiceContentDetectedPleaseTryAgain: 'មិន បាន រក ឃើញ មាតិកា សំឡេង អ្នក ប្រើ សូម ព្យាយាម ម្ដង ទៀត',
                    },
                    wave: {
                        index: {
                            continueRecording: 'បន្ត ការ ថត',
                            submit: 'ដាក់ ស្នើ',
                            endRecording: 'ចុង ថត',
                            suspendRecording: 'ផ្អាក ថត',
                            startPracticing: 'ចាប់ផ្ដើម ដំណើរការ',
                            startTheExam: 'ចាប់ផ្ដើម សិទ្ធិ',
                        },
                    },
                    deviceModal: {
                        index: {
                            dialogueMode: 'របៀប ប្រអប់Name',
                            excessiveNoisePleaseSwitchToAQuietEnvironment: 'សំឡេង ពេក សូម ប្ដូរ ទៅ បរិស្ថាន ស្អាត',
                            normalNoiseDetection: 'រក ឃើញ សំឡេង គឺ ធម្មតា',
                            theVolumeIsTooLowPleaseIncreaseTheVolume: 'កម្រិត សំឡេង ទាប ពេក សូម បង្កើន កម្រិត សំឡេង',
                            volumeDetectionIsNormal: 'រក ឃើញ កម្រិត សំឡេង ធម្មតា',
                            noiseDetection: 'រក ឃើញ សំឡេង',
                            pleaseRemainQuietAndRecordAsAmbientSound: 'សូម ទុក ស៊ីឡូបៃ និង ថត សំឡេង ៣s ambientName',
                            endRecording: 'ចុង ថត',
                            startRecording: 'ចាប់ផ្ដើម ថត',
                            volumeDetection: 'រក ឃើញ កម្រិត សំឡេង',
                            pleaseReadNowPerformVolumeTestAtNormalVolume: 'សូម អាន " សាកល្បង សំឡេង ឥឡូវ" ក្នុង កម្រិត សំឡេង ធម្មតា"',
                            playLastDetectedAudio: 'ចាក់ អូឌីយ៉ូ រកឃើញ ចុងក្រោយ',
                            pleaseReadTheRequirementsCarefullyBeforeStarting: 'សូម អាន ការ ទាមទារ មុន ពេល អ្នក ចាប់ផ្ដើម ។',
                            return: 'ត្រឡប់ វិញ',
                            iGotIt: 'ខ្ញុំ ដឹង ។',
                            timeLimitForSingleQuestionAnswering: 'សំណួរ ចម្លើយ ដែន កំណត់ ពេលវេលា មួយ',
                            totalTimeLimit: 'ដែន កំណត់ ពេលវេលា សរុប',
                            unlimitedTime: 'ដែន កំណត់ ពេលវេលា',
                            stillNeedToCompleteTheTaskInTotal: 'ភារកិច្ច សរុប នៅ តែ ត្រូវ តែ បញ្ចប់ ទេ',
                            practice: 'ដំណើរការ',
                            second: 'ពេលវេលាName',
                            taskScore: 'ពិន្ទុ ភារកិច្ច មួយ ≥',
                            branch: 'ចំណុច',
                            or: 'ឬ ថត',
                            examScore: 'ពិន្ទុ សាកល្បង ≥',
                            remainingExamTimes: 'ចំនួន សិទ្ធិ ដែល នៅស់',
                            totalScore: 'ពិន្ទុ សរុប',
                            Script: '( បណ្ដាញ',
                            scoreEmotion: 'សមាសភាព',
                            fractionExpression: 'កន្សោម រង',
                            points: 'ចំណុច)',
                            standardScore: 'ពិន្ទុ ស្តង់ដារ',
                            excellentScore: 'ពិន្ទុ ខ្ពស់',
                            exerciseInstructions: 'បង្ហាត់ បង្ហាញ',
                            forASmoothAnswerPleaseCompleteTheEquipmentInspectionFirst: 'ដើម្បី ឆ្លើយ សំណួរ ដោយ លឿន សូម បញ្ចប់ ការ សាកល្បង ដំបូង ៖',
                            camera: 'ម៉ាស៊ីន ថត',
                            beingAbleToSeeOneselfInTheVideoMeansThatTheCameraIsFunctioningProperly: 'ការ អាច មើល ខ្លួន អ្នក ក្នុង វីដេអូ មានន័យ ថា ម៉ាស៊ីនថត គឺ ធម្មតា ។',
                            microphone: 'មីក្រូហ្វូន',
                            pleaseSpeakIntoTheMicrophoneSeeingTheWaveformPatternIndicatesThatTheMicrophoneIsFunctioningProperly: 'សូម និយាយ ទៅ ក្នុង ម៉ាក្រូហ្វូន សូម មើល លំនាំ woveForm មាន ន័យ ថា ម៉ាក្រូហ្វូន គឺ ធម្មតា',
                        },
                    },
                },
                course: {
                    components: {
                        folderTree: {
                            modal: {
                                index: {
                                    empty: 'ទទេ',
                                    copyTo: 'ចម្លង',
                                    classification: 'ថត',
                                    rename: 'ប្ដូរ ឈ្មោះ',
                                    newlyBuild: 'ថ្មី',
                                    categoryParent: 'ថ្នាក់ ខ្ពស់',
                                    moveTo: 'ផ្លាស់ទី',
                                    name: 'ឈ្មោះ:',
                                },
                            },
                            util: {
                                rename: 'ប្ដូរ ឈ្មោះ',
                                moveTo: 'ផ្លាស់ទី',
                                copyTo: 'ចម្លង',
                                delete: 'លុប',
                                courseClassification: 'ថ្នាក់ វត្ថុ',
                                newlyBuild: 'ថ្មី',
                            },
                        },
                        evaluateDrawer: {
                            index: {
                                curriculumEvaluation: 'ការ វាយតម្លៃ',
                                cancel: 'បោះបង់',
                                submission: 'ដាក់ ស្នើ',
                                courseQuality: 'គុណភាព ដក',
                                higherValuesIndicateBetterCourseQuality: 'តម្លៃ ខ្ពស់ បង្ហាញ គុណភាព បង្ហាញ',
                                learningEffect: 'បែបផែន បង្រៀនName',
                                theHigherTheValueTheBetterTheLearningEffect: '[ កំណត់ សម្គាល',
                                interactiveExperience: 'អន្តរសកម្ម',
                                theHigherTheValueTheBetterTheInteractiveExperienceOfTheCourse: 'តម្លៃ ខ្ពស់ ជាង ច្រើន ភាព ត្រឹមត្រូវ របស់ អន្តរសកម្ម ល្អ បំផុត ។',
                                suggestedFeedback: 'ការ ឆ្លើយតប ដែល បាន ស្នើ',
                                pleaseEnterAnEvaluationProposalForThisCourse: 'សូម បញ្ចូល សំណុំ ការ វាយតម្លៃ សម្រាប់ វត្ថុ',
                            },
                        },
                    },
                    edit: {
                        index: {
                            curriculum: 'សំឡេង',
                        },
                    },
                    index: {
                        courseLabel: 'ស្លាក ដក',
                        comments: 'សេចក្តី អធិប្បាយ',
                        submissionOfEvaluation: 'ការ ដាក់ស្នើ នៃ តម្លៃ ៖',
                        evaluationOfSuccess: 'តម្លៃ នៃ ការ ជោគជ័យ',
                        learn: 'ការ សិក្សា',
                        practice: 'អនុញ្ញាត',
                        examination: 'សាកល្បង',
                        curriculum: 'សំឡេង',
                        courseIntroduction: 'ការ ណែនាំ ដក ៖',
                        createdOn: 'ពេលវេលា បង្កើត ៖',
                        published: 'បាន បោះពុម្ព',
                        tasks: 'ភារកិច្ច',
                        unpublishedTasks: 'ភារកិច្ច ដែល មិន បាន បោះពុម្ព',
                        task: 'ភារកិច្ច',
                        operation: 'ប្រតិបត្តិការ',
                        learningMaterials: 'ការ សិក្សា',
                        goPractice: 'ទៅ កាន់ សកម្មភាព',
                        publishTask: 'បោះពុម្ព ភារកិច្ច',
                        taskData: 'ទិន្នន័យ ភារកិច្ច',
                        edit: 'កែសម្រួល',
                        copy: 'ចម្លង',
                        successfullyCopied: 'ចម្លង ជោគជ័យ',
                        delete: 'លុប',
                        afterDeletionAllTaskDataUnderThisCourseWillBeClearedAreYouSureToDeleteTheCourse: 'បន្ទាប់ ពី លុប ទិន្នន័យ ភារកិច្ច ទាំងអស់ នៅ ក្រោម លំហាត់ នេះ នឹង ត្រូវ បាន ជម្រះ ។ តើ អ្នក ពិត ជា លុប វត្ថុ',
                        courseName: 'ឈ្មោះ សំឡេង',
                        creationTime: 'ពេលវេលា បង្កើតComment',
                        releaseStatus: 'ស្ថានភាព បោះពុម្ព',
                        whole: 'ទាំង អស់',
                    },
                },
                nodeConfigTest: {
                    components: {
                        input: {
                            noSoundDetected: 'មិន បាន រកឃើញ សំឡេង',
                            voice: 'សំឡេង',
                            text: 'អត្ថបទ',
                            referenceScript: 'និយាយ យោង ៖',
                            clickOnTheRightSideToStartRecording: 'ចុច លើ ខាង ស្ដាំ ដើម្បី ចាប់ផ្ដើម ថត',
                            sendOut: 'ផ្ញើ',
                        },
                        hooks: {
                            input: {
                                theCurrentClientIsAlreadyConnectedToTheASRWebsocketServer: 'ម៉ាស៊ីន ភ្ញៀវ បច្ចុប្បន្ន ត្រូវ បាន តភ្ជាប់ ទៅកាន់ ម៉ាស៊ីន បម្រើ ASR Websocket រួច ហើយ',
                                afterProcessingTheLastFrameRestoreTheState: 'បន្ទាប់ ពី ដំណើរការ ស៊ុម ចុងក្រោយ ស្ដារ ស្ដារ',
                                aSRConnectionClosed: 'បាន បិទ ការ តភ្ជាប់ ASR ... Name',
                                recordingPausedAndHasBeenProcessedButThereIsStillDataInTheCache: 'ការ ថត ត្រូវ បាន ផ្អាក ហើយ ត្រូវ បាន ដំណើរការ ប៉ុន្តែ នៅ តែ មាន ទិន្នន័យ នៅ ក្នុង ឃ្លាំង សម្ងាត់',
                                foundASRChannelClosedRecreateWebsocketLink: 'រក ឃើញ ឆានែល ASR ដែល បាន បិទ ហើយ បង្កើត តំណ Websocket ឡើង វិញ',
                                foundThatTheASRChannelIsNotOpenRecreateTheWebsocketLink: 'រកឃើញ ថា ឆានែល ASR មិន អាច បើក បាន បង្កើត តំណ Websocket ឡើង វិញ',
                                unableToRecord: 'មិន អាច ថត ៖',
                                creatingARecorderService: 'បង្កើត សេវា កម្មវិធី ថត',
                                turnOffTheRecorderService: 'បិទ សេវា កម្មវិធី ថត',
                            },
                            util: {
                                recorded: 'បាន ថត',
                                BitPcmSendFrameSizeMustBeAnIntegerMultipleOf2: '១៦- ប៊ីត pcm SendFrameSize ត្រូវ តែ ជា ចំនួន គំរូ នៃ ២',
                                pCMSamplingRateShouldNotOccur: 'អត្រា គំរូ pcm គួរ លេចឡើង ឡើយ',
                                andTheRequiredSamplingRate: 'និង អត្រា គំរូ ដែល ទាមទារ',
                                atypism: 'មិន ត្រឹមត្រូវ',
                                errorsThatShouldNotOccur: 'កំហុស ដែល មិន គួរ កើត ឡើង ៖',
                                spanStylecolorRedDataWithDisorderedOrderCanBeDirectlyDiscardedIfTheRequirementsAreNotHighspan: '<Span រចនាប័ទ្ម = "color: red"> ទិន្នន័យ ដែល ក្រៅ លំដាប់ អាច ត្រូវ បាន បោះបង់ ប្រសិនបើ ការ ទាមទារ មិន មាន ខ្ពស់ ។ </ Span>',
                                flower: 'ភ្លើង',
                                TransferStopped: ': ការ ផ្ទេរ បាន បញ្ឈប់',
                            },
                        },
                        finishTest: {
                            index: {
                                endTest: 'បញ្ចប់ សាកល្បង',
                                testResult: 'លទ្ធផល សាកល្បង',
                                returnToCanvas: 'ត្រឡប់ ទៅ គំនូស',
                                retest: 'សាកល្បង ឡើង វិញ',
                            },
                        },
                    },
                    index: {
                        testFromCurrentNode: 'សាកល្បង ពី ថ្នាំង បច្ចុប្បន្ន',
                        listening: 'វិទ្យុ នៅ ក្នុង ...',
                        canvasTesting: 'ពាក្យ សាកល្បង',
                        endOfProcess: 'ចុង ដំណើរការ',
                        restart: 'ចាប់ផ្ដើម ឡើង វិញ',
                        start: 'ចាប់ផ្ដើម',
                    },
                },
                record: {
                    detail: {
                        components: {
                            openButton: {
                                index: {
                                    collapseAnalysis: 'វិភាគ ចេញ',
                                    expandParsing: 'ពង្រីក',
                                },
                            },
                            overView: {
                                index: {
                                    tooManyModalParticles: 'ពាក្យ modal ច្រើន ពេញ',
                                    second: 'ពេលវេលាName',
                                    ratingOverview: 'ទិដ្ឋភាព ពិន្ទុ',
                                    totalScore: 'ពិន្ទុ សរុប',
                                    section: 'ភាគComment',
                                    name: 'ឈ្មោះ:',
                                    of: '( សំឡេង',
                                    people: 'មនុស្ស)',
                                    scriptScore: 'ពិន្ទុ និយាយComment',
                                    common: 'សរុប',
                                    keyPoints: 'ចំណុច គ្រាប់ ចុច ៖',
                                    notReached: 'មិន បាន មក ដល់ ។',
                                    have: 'បាន',
                                    violationOfRegulations: 'បំពាន',
                                    emotionalScore: 'ពិន្ទុ សញ្ញា',
                                    appear: 'លេចឡើយ',
                                    secondaryNegativeEmotions: 'សកម្មភាព អង់គ្លេស ទី ដើម',
                                    expressionScore: 'ពិន្ទុ កន្សា',
                                    speakTooFast: 'និយាយ លឿន ពេញ',
                                    times: 'ពេលវេលា ៖',
                                    speakTooSlowly: 'និយាយ យឺត ពេកComment',
                                    average: 'មធ្យម',
                                    wordminute: 'ពាក្យ/នាទី',
                                },
                            },
                            score: {
                                index: {
                                    studentNodeName: 'ឈ្មោះ ថ្នាំង សិទ្ធិ',
                                    keyPointName: 'ឈ្មោះ ចំណុច សោ',
                                    slideNodeName: 'ឈ្មោះ ថ្នាំង ស្លាយ',
                                    dialogue: 'ប្រអប់Comment',
                                    mainPoints: 'ចំណុច សោ',
                                    slide: 'ស្លាយ',
                                    detectionResult: 'លទ្ធផល សាកល្បង',
                                    satisfy: 'ជួប ប្រទះ',
                                    dissatisfaction: 'មិន បាន ជម្រះ',
                                    score: 'ពិន្ទុ',
                                    script: 'ពាក្យ',
                                    semantics: 'Semantic',
                                    scriptViolation: 'ការ បំបាត់ និយាយComment',
                                    emotion: 'សមាសភាព',
                                    expression: 'កន្សា',
                                },
                            },
                            taskTitle: {
                                index: {
                                    branch: 'ចំណុច',
                                },
                            },
                            comprehensiveEvaluation: {
                                const: {
                                    thisTime: 'ពេលវេលា នេះ',
                                    lastTime: 'ពេលវេលា ចុងក្រោយ',
                                    comprehensiveEvaluation: 'ការ វាយតម្លៃ',
                                },
                                index: {
                                    spanStylemarginLeftpxStandardScriptAccumulation: 'រចនាប័ទ្ម <span = "margin-left: 8',
                                    theTotalNumberOfWordsHitByTheStudentAfterReading: 'ពាក្យ មួយ ចំនួន ពាក្យ គត់ ដោយ សិទ្ធិ',
                                    aWordspan: 'ពាក្យ </ span>',
                                    timesspanbrspanStylemarginLeftpxSpeakTooSlowly: 'Times </ span',
                                    timesspan: '</ Span>',
                                    tooManyModalParticles: '<Span រចនាប័ទ្ម = "margin-left: 8px"> · ពាក្យ modal ច្រើន ពេញ',
                                    complete: 'មាតិកា',
                                    keyHit: 'ចំណុច គ្រាប់ ចុច',
                                    languageNorm: 'ការ បញ្ជាក់ ភាសាName',
                                    fluentExpression: 'កន្សោម រលោង',
                                    emotionallyPositive: 'សុវត្ថិភាព ត្រឹមត្រូវ',
                                    radarChart: 'គំនូត',
                                    spanStylemarginLeftpxNumberOfCompleteProcesses: '<Span រចនាប័ទ្ម = "margin-left: 8px"> · ចំនួន ទំហំ ពេញលេញ',
                                    spanStylemarginLeftpxNumberOfHitPoints: 'រចនាប័ទ្ម <span = "margin-left: 8px"> · ចំណុច គ្រាប់ ចុច Hit ចំណុច',
                                    spanStylemarginLeftpxYes: 'រចនាប័ទ្ម <span = "margin-left: 8px"> · Yes',
                                    dealingWithIllegalWordsspan: 'ក្នុង ការ បំបាត់ ពាក្យ </ span>',
                                    spanStylemarginLeftpxSpeakTooFast: 'រចនាប័ទ្ម <span = "margin-left: 8px"> · Spew លឿន ពេញ',
                                    spanbrspanStylemarginLeftpxTooManyModalParticles: '</ Span><br /><span style = "margin- left: 8px"> ពាក្យ modal ច្រើន ពេញ',
                                    spanStylemarginLeftpxNegativeEmotions: '<Span រចនាប័ទ្ម = "margin- left: 8px"> · អាសយដ្ឋាន អវិជ្ជមាន',
                                },
                            },
                            scoreRecord: {
                                index: {
                                    scoringRecords: 'ថត ពិន្ទុ',
                                    firstRating: 'អត្រា ពេលវេលា ដំបូង',
                                    totalScore: 'ពិន្ទុ សរុប',
                                    changeTo: 'ផ្លាស់ប្ដូរ',
                                },
                            },
                            aiGenScore: {
                                index: {
                                    communicationStage: 'រូបរាង ទំនាក់ទំនង',
                                    communicationObjectives: 'គោលដៅ ទំនាក់ទំនង',
                                    scoringCriteria: 'លក្ខខណ្ឌ ពិន្ទុ',
                                    suggestionsForImprovement: 'ការ បង្កើន ការ បង្កើន',
                                },
                            },
                            onceMore: {
                                index: {
                                    remainingTimes: 'នៅ សល់ ៖',
                                    second: 'ពេលវេលាName',
                                    doItAgain: '។',
                                },
                            },
                            audio: {
                                index: {
                                    theBrowserDoesNotSupportAudioPlayback: 'កម្មវិធី រុករក មិន គាំទ្រ ការ ចាក់ អូឌីយ៉ូ ទេ ។',
                                },
                            },
                            evaluationSuggestion: {
                                index: {
                                    scriptCommentsAndSuggestions: 'សេចក្តី អធិប្បាយ និង ការ ស្នើ',
                                    regenerate: 'បង្កើត ឡើង វិញ',
                                    generate: 'បង្កើត@ info: whatsthis',
                                    generationFailed: 'បរាជ័យ ក្នុងកា រ ស្ថាបត្រ',
                                },
                            },
                            resultModal: {
                                index: {
                                    return: 'ត្រឡប់ វិញ',
                                    viewDetails: 'មើល សេចក្ដី លម្អិត',
                                },
                            },
                        },
                        index: {
                            reRatingSuccessful: 'ការ ពិន្ទុ ឡើងវិញ',
                            reRatingFailed: 'បាន បរាជ័យ ក្នុងកា រកំណត់ ឡើង វិញ',
                            downloadRecording: 'ទាញយក ថត',
                            downloadText: 'ទាញយក អត្ថបទName',
                            download: 'ទាញយក',
                            reRating: 'ការ ពិន្ទុ ឡើង វិញ',
                            submitARatingAppeal: 'ដាក់ ស្នើ ការ បង្ហាញ',
                            reviewSubmission: 'ឡើង វិញ',
                            saveChanges: 'រក្សាទុក ការ ផ្លាស់ប្ដូរ',
                            previousSentence: 'ពាក្យ មុន',
                            nextSentence: 'ពាក្យ បន្ទាប់',
                            score: 'ការ វាយតម្លៃ',
                            scoringSituation: 'ពិន្ទុ',
                            dialogueAnalysis: 'វិភាគ ប្រអប់Name',
                        },
                    },
                    index: {
                        ratingAppealInProgress: 'ការ ពិន្ទុ',
                        operation: 'ប្រតិបត្តិការ',
                        wrongQuestionSet: 'កំណត់ បញ្ហា ខុស',
                        ratingUpdate: 'ការ វាយតម្លៃ ទាន់ សម័យ',
                        viewDetails: 'មើល សេចក្ដី លម្អិត',
                        curriculum: 'សំឡេង',
                        taskName: 'ឈ្មោះ ភារកិច្ច',
                        taskType: 'ប្រភេទ ភារកិច្ច',
                        score: 'ពិន្ទុ',
                        scoringResults: 'លទ្ធផល ពិន្ទុ',
                        time: 'ពេលវេលា',
                        courseClassification: 'ថ្នាក់ វត្ថុ',
                        whole: 'ទាំង អស់',
                        learningTime: 'ពេលវេលា សិក្សា',
                        historicalLearningData: 'ទិន្នន័យ សិក្សា ប្រវត្តិ',
                    },
                },
                task: {
                    exercise: {
                        index: {
                            intelligentQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
                            practicePause: 'ដំណើរការ ផ្អាក',
                            lastProgress: 'វឌ្ឍនភាព ចុងក្រោយ',
                            continuePracticing: 'បន្ត សកម្មភាព',
                            practice: 'ដំណើរការ',
                            startPracticing: 'ចាប់ផ្ដើម ដំណើរការ',
                            historicalData: 'ទិន្នន័យ ប្រវត្តិ',
                            courseIntroduction: 'ការ ណែនាំ ដក ៖',
                            exerciseDifficulty: 'ភាព ពិបាក របស់ សកម្មភាព ៖',
                            practiceCompletionRequirements: 'ការ ទាមទារ បញ្ចប់ ដំណើរការ ៖',
                            practiceFrequency: 'ចំនួន លំហាត់ ≥',
                            second: 'ពេលវេលាName',
                            anyScore: 'ពិន្ទុ ≥',
                            branch: 'ចំណុច',
                            or: 'ឬ ថត',
                            taskList: 'បញ្ជី ភារកិច្ច',
                            practiceTime: 'ពេលវេលា សកម្មភាព ៖',
                            to: 'ទៅ',
                            unlimitedTime: 'ពេលវេលា គ្មាន កំណត់',
                            completionStatus: 'ស្ថានភាព បញ្ចប់',
                            numberOfExercises: 'ចំនួន សកម្មភាព',
                            maximumScore: 'ពិន្ទុ ខ្ពស់',
                            operation: 'ប្រតិបត្តិការ',
                            enteringLearning: 'បញ្ចូល ការ សិក្សា',
                            historicalLearningData: 'ទិន្នន័យ សិក្សា ប្រវត្តិ',
                            wrongQuestionSet: 'កំណត់ បញ្ហា ខុស',
                        },
                    },
                    index: {
                        practiceTasks: 'ដំណើរការ ភារកិច្ច',
                        examTasks: 'ភារកិច្ច ការ ពិពណ៌នា',
                        task: 'ភារកិច្ច',
                    },
                    learn: {
                        index: {
                            courseName: 'ឈ្មោះ សំឡេង',
                            courseIntroduction: 'ការ ណែនាំ ដក',
                            learningContent: 'មាតិកា បង្ហាញ',
                            downloadLearningMaterials: 'ការ ទាញ យក ចំណុច បង្ហាញ',
                            startPracticing: 'ចាប់ផ្ដើម ដំណើរការ',
                        },
                    },
                    test: {
                        index: {
                            taskList: 'បញ្ជី ភារកិច្ច',
                            courseIntroduction: 'ការ ណែនាំ ដក ៖',
                            examDifficulty: 'ពិបាក សិទ្ធិ ៖',
                            requirementsForPassingTheExam: 'ការ ទាមទារ សម្រាប់ ការ សិទ្ធិ ៖',
                            examScore: 'ពិន្ទុ សាកល្បង ≥',
                            branch: 'ចំណុច',
                            examTime: 'ពេលវេលា ពិនិត្យ ៖',
                            to: 'ទៅ',
                            unlimitedTime: 'ពេលវេលា គ្មាន កំណត់',
                            completionStatus: 'ស្ថានភាព បញ្ចប់',
                            completionTimes: 'ចំនួន ការ បញ្ចប់',
                            maximumScore: 'ពិន្ទុ ខ្ពស់',
                            operation: 'ប្រតិបត្តិការ',
                            immediateExam: 'សាកល្បង ភ្លាមៗ',
                            history: 'ប្រវត្តិ',
                        },
                    },
                },
                wrongQuestionSet: {
                    exercise: {
                        components: {
                            cue: {
                                index: {
                                    referenceScript: 'និយាយ យោងName',
                                },
                            },
                            flow: {
                                index: {
                                    wrongQuestionItem: 'ធាតុ ខុស ។',
                                    score: 'ពិន្ទុ',
                                    TotalScore: '/ ពិន្ទុ',
                                },
                            },
                            record: {
                                ppt: {
                                    hook: {
                                        index: {
                                            serverError: 'កំហុស ម៉ាស៊ីន បម្រើ',
                                        },
                                    },
                                    index: {
                                        startRecording: 'ចាប់ផ្ដើម ថត',
                                        endRecording: 'ចុង ថត',
                                        startPracticing: 'ចាប់ផ្ដើម ដំណើរការ',
                                    },
                                },
                                text: {
                                    index: {
                                        pleaseEnter: 'សូម បញ្ចូល',
                                        sendOut: 'ផ្ញើ',
                                        startPracticing: 'ចាប់ផ្ដើម ដំណើរការ',
                                    },
                                },
                                voice: {
                                    index: {
                                        startRecording: 'ចាប់ផ្ដើម ថត',
                                        endRecording: 'ចុង ថត',
                                        startPracticing: 'ចាប់ផ្ដើម ដំណើរការ',
                                    },
                                    hook: {
                                        index: {
                                            failInSend: 'បាន បរាជ័យ ក្នុង ការ ផ្ញើ',
                                        },
                                    },
                                },
                            },
                            taskMessageModal: {
                                index: {
                                    scoreForThisPracticeOfIncorrectQuestions: 'ពិន្ទុ លំហាត់ នេះ',
                                    tips: 'សួរ',
                                    areYouSureToEnd: 'អះអាង បញ្ចប់ ឬ ?',
                                    practiceAgainWithoutMasteringTheWrongQuestions: '[ រូបភាព នៅ ទំព័រ ៧]',
                                    continue: 'បន្ត@ info: whatsthis',
                                    returnToTheSetOfIncorrectQuestions: 'ត្រឡប់ ទៅ សំណុំ សំណួរ ខុស',
                                    end: 'បញ្ចប់',
                                    wrongQuestionItem: 'ធាតុ ខុស',
                                    numberOfExercisesThisTime: 'ចំនួន លំហាត់ នេះ',
                                    masteringTheSituation: 'ទទួល ស្ថានភាព',
                                    mastered: 'ការ ចាប់ផ្តើម',
                                    notMastered: 'មិន បាន មេ ទេ',
                                },
                            },
                            taskSubmitButton: {
                                index: {
                                    practiceThisQuestionAgain: 'ដំណើរការ សំណួរ នេះ ម្ដង ទៀត',
                                    nextQuestion: 'សំណួរ បន្ទាប់',
                                },
                            },
                        },
                        ppt: {
                            index: {
                                mispracticeExercises: 'ដំណើរការ ខុស',
                                endExercise: 'បញ្ចប់ លំហាយ',
                            },
                        },
                        text: {
                            index: {
                                mispracticeExercises: 'ដំណើរការ ខុស',
                                endExercise: 'បញ្ចប់ លំហាយ',
                            },
                        },
                        voice: {
                            index: {
                                mispracticeExercises: 'ដំណើរការ ខុស',
                                endExercise: 'បញ្ចប់ លំហាយ',
                            },
                        },
                    },
                    list: {
                        components: {
                            checkScript: {
                                index: {
                                    checkScript: 'មើល និយាយComment',
                                    section: 'ភាគComment',
                                    secondaryDiscourseTechnique: 'និយាយ រង',
                                },
                            },
                            tableItem: {
                                count: {
                                    second: 'ពេលវេលាName',
                                },
                                scoreRuleList: {
                                    noRelevantInformationFound: 'រក មិនឃើញ ព័ត៌មាន ទាក់ទង',
                                    recallWords: 'ចងចាំ ពាក្យ',
                                    branch: 'ចំណុច',
                                    answerIncorrectly: 'ចម្លើយ ខុស',
                                    second: 'ពេលវេលាName',
                                    wrongAnswerRate: 'អត្រា ចម្លើយ ខុស',
                                },
                                standardScript: {
                                    standardScript: 'និយាយ ស្តង់ដារ',
                                    myScript: 'ពាក្យ របស់ ខ្ញុំ',
                                },
                                status: {
                                    mastered: 'ការ ចាប់ផ្តើម',
                                    notMastered: 'មិន បាន មេ ទេ',
                                },
                                index: {
                                    totalNumberOfQuestionsAnswered: 'ចំនួន ចម្លើយ សរុប',
                                    numberOfTimesIncorrectQuestionsHaveBeenPracticed: 'ចំនួន សំណួរ ខុស ត្រូវ បាន អនុញ្ញាត',
                                },
                            },
                        },
                        index: {
                            wrongQuestionList: 'បញ្ជី សំណួរ ខុស',
                            wrongQuestionSet: 'កំណត់ បញ្ហា ខុស',
                            mispracticeExercises: 'ដំណើរការ ខុស',
                            taskName: 'ឈ្មោះ ភារកិច្ច',
                            staff: 'ការងារ',
                            masteringTheSituation: 'ទទួល ស្ថានភាព',
                            whole: 'ទាំង អស់',
                        },
                    },
                },
            },
            taskCenter: {
                components: {
                    completeStandart: {
                        index: {
                            practiceFrequency: 'ចំនួន លំហាត់ ≥',
                            second: 'ពេលវេលាName',
                            or: 'ឬ ថត',
                            excellentScoreAtAnyOneTime: 'ពិន្ទុ ល្អ បំផុត ណាមួយ (≥',
                            points: 'ចំណុច)',
                            examScore: 'ពិន្ទុ សាកល្បង ≥',
                            branch: 'ចំណុច',
                        },
                    },
                    manualReviewConfig: {
                        index: {
                            randomAverageDistribution: 'ការ ចែកចាយ មធ្យម',
                            assignToDesignatedPersonnel: 'ការ ផ្ដល់ ឲ្យ មនុស្ស ដែល បាន ដឹក នាំ់',
                        },
                    },
                    examTimesInput: {
                        index: {
                            successfullyIncreasedTheNumberOfExams: 'ជោគជ័យ ក្នុង បង្កើន ចំនួន សិទ្ធិ',
                            failedToIncreaseTheNumberOfExams: 'បង្កើន ចំនួន ការ សាកល្បង បរាជ័យ',
                            increaseTheNumberOfExams: 'បង្កើន ចំនួន សិទ្ធិ',
                            selectObjects: 'ជ្រើស វត្ថុ',
                        },
                    },
                    executionFilter: {
                        index: {
                            participationRate: 'អត្រា ចូល រួម@ info: whatsthis',
                        },
                    },
                    intelligentReview: {
                        index: {
                            overallReview: 'ការ ត្រួត ពិនិត្យ ទាំងអស់',
                            pleaseEnterTheReviewCriterianotMandatory: 'សូម បញ្ចូល លក្ខខណ្ឌ សេចក្ដី អធិប្បាយ (មិន ទាមទារ)',
                            commentaryOnSingleSentenceRhetoric: 'សេចក្ដី អធិប្បាយ លើ សំណួរ មួយ',
                            realTimeReview: 'មើល ពេលវេលា ពិសេស',
                        },
                    },
                },
                detail: {
                    resultAnalysis: {
                        averageScoreOfTheExam: 'ពិន្ទុ សាកល្បង មធ្យម',
                        averageExamDurationmin: 'ថិរវេលា សិទ្ធិ មធ្យម (មីន)',
                        accumulatedPracticeDurationmin: 'កាលបរិច្ឆេទ ដំណើរការ ចូល រួម ( Min)',
                        accumulatedPracticeTimes: 'ចំនួន លំហាត់ រមូល',
                        totalScore: 'ពិន្ទុ សរុប',
                        average: 'មធ្យម',
                        total: 'សរុប',
                        keyHitCount: 'ចំណុច គ្រាប់ចុច',
                        practiceAverageScore: 'ពិន្ទុ មធ្យម',
                        averagePracticeDurationmin: 'ថិរវេលា លំហាត់ មធ្យម (មីន)',
                        topOfTheHighestScore: 'ពិន្ទុ ខ្ពស់ បំផុត ៣',
                        branch: 'ចំណុច',
                        errorProneItemTop: 'ធាតុ លើ កំហុស កំពូល ៥',
                        hitRate: 'អត្រា លាយ',
                        hitRateOfKeyPointsInScript: 'អត្រា គំរូ គ្រាប់ ចុច ចំណុច',
                        averageScriptScore: 'ពិន្ទុ និយាយ មធ្យម',
                        sortByProcess: 'តម្រៀប តាម ដំណើរការ',
                        sortByScore: 'តម្រៀប តាម ពិន្ទុ',
                        averageScoreOfThisPagetotalScoreOfThisPage: 'ពិន្ទុ មធ្យម នៃ ទំព័រ នេះ',
                        averageScoreOfThisItemtotalScoreOfThisItem: 'ពិន្ទុ មធ្យម នៃ ធាតុ នេះ / ពិន្ទុ សរុប របស់ ធាតុ នេះ',
                        details: 'សេចក្ដី លម្អិត',
                        viewRules: 'មើល បន្ទាត់',
                        standardScript: 'និយាយ ស្តង់ដារ',
                    },
                    scoreDetailList: {
                        section: 'ភាគComment',
                        second: 'ពេលវេលាName',
                        practice: 'ដំណើរការ',
                        examination: 'ការ ព្រួញ',
                        notMeetingStandards: 'មិន មែន ជា ស្តង់ដារ',
                        meetingStandards: 'ស្តង់ដារ',
                        excellent: 'ល្អ ប្រសើរ',
                        frequency: 'ចំនួន ពេលវេលា',
                        fraction: 'ប្រទេស',
                        result: 'លទ្ធផល',
                        operation: 'ប្រតិបត្តិការ',
                        viewDetails: 'មើល សេចក្ដី លម្អិត',
                    },
                    index: {
                        common: 'សរុប',
                        people: 'មនុស្ស ជាតិ',
                        staff: 'ការងារ',
                        notMeetingStandards: 'មិន មែន ជា ស្តង់ដារ',
                        meetingStandards: 'ស្តង់ដារ',
                        excellent: 'ល្អ ប្រសើរ',
                        notStarted: 'មិន បាន ចាប់ផ្ដើម',
                        haveInHand: 'កំពុង វឌ្ឍន៍',
                        completed: 'បាន បញ្ចប់',
                        passed: 'បាន ជម្រះ',
                        hangInTheAir: 'មិន បាន បញ្ចប់',
                        failed: 'មិន មែនទេ',
                        unlimitedTime: 'ពេលវេលា គ្មាន កំណត់',
                        to: 'ទៅ',
                        maximumScoringCriteria: 'លក្ខខណ្ឌ ពិន្ទុ ខ្ពស់',
                        completionStatus: 'ស្ថានភាព បញ្ចប់',
                        employeeName: 'ឈ្មោះ ម៉ាស៊ីន ភ្ញៀវ',
                        frequency: 'ចំនួន ពេលវេលា',
                        practice: 'ដំណើរការ',
                        examination: 'ការ ព្រួញ',
                        average: 'មធ្យម',
                        speechCraftAvgScore: 'ពិន្ទុ និយាយ មធ្យម',
                        emotionAvgScore: 'ពិន្ទុ សំខាន់ មធ្យម',
                        speedAvgScore: 'ពិន្ទុ មធ្យម',
                        flowAvgScore: 'ពិន្ទុ ដំណើរការ មធ្យម',
                        practiceCostTime: 'កាលបរិច្ឆេទ',
                        participateCommitRate: 'អត្រា បន្ទាប់',
                        participateExcellentRate: 'អត្រា ខ្ពស់',
                        duration: 'កាលបរិច្ឆេទ',
                        score: 'ពិន្ទុ',
                        scoringResults: 'លទ្ធផល ពិន្ទុ',
                        flowScore: 'ពិន្ទុ ដំណើរការ',
                        craftScore: 'ពិន្ទុ និយាយComment',
                        emotionScore: 'ពិន្ទុ សញ្ញា',
                        speedScore: 'ពិន្ទុ កន្សា',
                        contentIntegrity: 'មាតិកា',
                        pointHitRate: 'អត្រា គំរូ ចំណុច គ្រាប់ចុច',
                        emotionNegativeRate: 'សមាសភាគ វិសេស នៃ សកម្មភាព',
                        paraPhaSiaRate: 'គុណភាព នៃ ល្បឿន និយាយ មិន ធម្មតា',
                        toneOvermuchRate: 'សមាសភាគ ច្រើន នៃ ពាក្យ modl',
                        maximumScore: 'ពិន្ទុ ខ្ពស់',
                        highestScoreResult: 'លទ្ធផល ពិន្ទុ ខ្ពស់',
                        state: 'ស្ថានភាព',
                        averageDurationmin: 'ថិរវេលា មធ្យម (មីន)',
                        lately: 'ថ្មីៗ',
                        time: 'ពេលវេលា',
                        operation: 'ប្រតិបត្តិការ',
                        viewDetails: 'មើល សេចក្ដី លម្អិត',
                        wrongQuestionSet: 'កំណត់ បញ្ហា ខុស',
                        taskName: 'ឈ្មោះ ភារកិច្ច',
                        completeRequirements: 'ការ ទាមទារ ពេញ',
                        publishTo: 'ការ បោះពុម្ព ផ្សាយ វត្ថុComment',
                        taskTime: 'ពេលវេលា ភារកិច្ច',
                        fractionalComposition: 'សមាសភាគ ដក',
                        totalScore: 'ពិន្ទុ សរុប',
                        branch: 'ចំណុច',
                        Script: '( បណ្ដាញ',
                        scoreEmotion: 'សមាសភាព',
                        fractionExpression: 'កន្សោម រង',
                        points: 'ចំណុច)',
                        implementationRate: 'អត្រា ចូល រួម@ info: whatsthis',
                        numberOfExecutors: 'ចំនួន អ្នក ចូលរួម@ info: whatsthis',
                        numberOfPeopleNotExecuted: 'ចំនួន អ្នក មិន ចូលរួម ទេ',
                        completionRate: 'អត្រា បំពេញComment',
                        numberOfCompletedPersonnel: 'ចំនួន បាន បញ្ចប់',
                        numberOfUnfinishedPersonnel: 'ចំនួន មិន បាន បញ្ចប់',
                        complianceRate: 'អត្រា បន្ទាប់',
                        numberOfQualifiedPersonnel: 'ចំនួន ការ ផ្ទៀងផ្ទាត់',
                        numberOfNonCompliantIndividuals: 'ចំនួន មនុស្ស ដែល មិន ទាក់ទង នឹង ស្តង់ដារ',
                        excellentRate: 'អត្រា ខ្ពស់',
                        participateCompleteRate: 'អត្រា បញ្ចប់ ការ ចូល រួម@ info: whatsthis',
                        numberOfOutstandingIndividuals: 'លេខ ខ្ពស់',
                        numberOfNonOutstandingIndividuals: 'លេខ មិន ល្អ បំផុត@ info: whatsthis',
                        export: 'នាំចេញ',
                        taskData: 'ទិន្នន័យ ភារកិច្ច',
                        resultAnalysis: 'ការ វិភាគ លទ្ធផល',
                        scoreDetails: 'សេចក្ដី លម្អិត ពិន្ទុ -',
                        dataOverview: 'មើល ទូទៅ ទិន្នន័យ',
                        taskDetail: 'សេចក្ដី លម្អិត ភារកិច្ច',
                        scriptAnalysis: 'ការ វិភាគ និយាយComment',
                        flowAnalysis: 'ការ វិភាគ ដំណើរការ',
                        expressionAnalysis: 'ការ វិភាគ កន្សា',
                        emotionAnalysis: 'ការ វិភាគ សំណួរ',
                        byTime: 'ទិដ្ឋភាព វិមាត្រ ពេលវេលា',
                        byNumber: 'ទិដ្ឋភាព ដឺក្រេ',
                        personData: 'ស្ថិតិ តាម កម្មវិធី',
                        numberData: 'សេចក្ដី លម្អិត តាម ថត',
                        count: 'តាម ចំនួន ពេលវេលា',
                        person: 'តាម ចំនួន មនុស្សName',
                        reachTimes: 'ពេលវេលា ទៅ ទេ',
                        outOfReachTimes: 'ពេលវេលា ដែល មិន បាន ទេ',
                        seeOutOfReach: 'ចុច ដើម្បី មើល មិន បាន ទទួល ទេ',
                        accumulative: 'មធ្យម',
                        script: 'ពាក្យ',
                        times: 'ពេលវេលាName',
                        sentence: 'ប្រយោជន៍',
                        expressionAverage: 'ពិន្ទុ កន្សោម មធ្យម',
                        modalAnalysis: 'ការ វិភាគ ភាគ ម៉ូឌុល',
                        total: 'សរុប',
                        muchModalAnalysis: 'ពាក្យ modal ច្រើន ពេញ',
                        normal: 'ធម្មតា',
                        speedAnalysis: 'ការ វិភាគ ល្បឿន និយាយComment',
                        speedDistribution: 'ការ ចែកចាយ អត្រា និយាយComment',
                        speakingSpeed: 'ល្បឿន',
                        normalSpeak: 'ល្បឿន និយាយ ធម្មតា',
                        tooFastSpeak: 'ល្បឿន ល្បឿន',
                        tooSlowlySpeak: 'ល្បឿន យឺត',
                        violationWord: 'ការ បំបាត់ ពាក្យ',
                        violationWordAnalysis: 'ការ វិភាគ នៃ ការ បំបាត់ ពាក្យ',
                        noData: 'គ្មាន ទេ',
                        emotionalScore: 'ពិន្ទុ សញ្ញា',
                        emotionalDistribution: 'ការ ចែកចាយ នៃ សកម្មភាពName',
                        negativeEmotion: 'សកម្មភាព អុហ្វសិត',
                        normalEmotion: 'សកម្មភាព ធម្មតា',
                        getDetail: 'មើល សេចក្ដី លម្អិត',
                        barPattern: 'ទិដ្ឋភាព របារ',
                        timeDimension: 'ទិដ្ឋភាព អតិបរមា',
                        timesDimension: 'ទិដ្ឋភាព ដឺក្រេ',
                    },
                    components: {
                        dataOverview: {
                            hook: {
                                useSummary: {
                                    score: 'ពិន្ទុ',
                                    speechScore: 'ពិន្ទុ និយាយComment',
                                    emotionScore: 'ពិន្ទុ សញ្ញា',
                                    expressionScore: 'ពិន្ទុ កន្សា',
                                    processScore: 'ពិន្ទុ ដំណើរការ',
                                    averageScore: 'មធ្យម',
                                    averageScoreOfScript: 'ពិន្ទុ និយាយ មធ្យម',
                                    averageEmotionalScore: 'ពិន្ទុ សំខាន់ មធ្យម',
                                    expressionAverageScore: 'ពិន្ទុ មធ្យម',
                                    processAverageScore: 'ពិន្ទុ ដំណើរការ មធ្យម',
                                    accumulatedDuration: 'កាលបរិច្ឆេទ',
                                    accumulatedTimes: 'ពេលវេលា ចូល គ្នា',
                                    participationComplianceRate: 'អត្រា ចូល រួម@ info: whatsthis',
                                    participationRateForAchievingExcellence: 'អត្រា ចូល រួម@ info: whatsthis',
                                    branch: 'ចំណុច',
                                    numberOfPeople: 'ចំនួន មេ',
                                    averageScoreOfExpression: 'ពិន្ទុ កន្សោម មធ្យម',
                                    people: 'មនុស្ស ជាតិ',
                                },
                            },
                        },
                        emotionAnalysis: {
                            components: {
                                simplePieChart: {
                                    index: {
                                        negativeEmotions: 'សកម្មភាព អុហ្វសិត',
                                    },
                                },
                            },
                        },
                        scriptAnalysis: {
                            hook: {
                                useSummary: {
                                    averageScoreOfScript: 'ពិន្ទុ និយាយ មធ្យម',
                                    branch: 'ចំណុច',
                                },
                                useSummaryDetail: {
                                    keyHitRate: 'អត្រា គំរូ ចំណុច គ្រាប់ចុច',
                                },
                            },
                        },
                    },
                },
                edit: {
                    index: {
                        intelligentReview: 'ទិដ្ឋភាព ឆ្លាត',
                        pleaseImproveTheConfiguration: 'សូម កំណត់ រចនា សម្ព័ន្ធ',
                        examResults: 'លទ្ធផល សិទ្ធិ',
                        showTheResultsAfterEachExam: 'បង្ហាញ លទ្ធផល បន្ទាប់ ពី សិទ្ធិ នីមួយៗ ។',
                        showTheResultsAfterTheLastExam: 'បង្ហាញ លទ្ធផល បន្ទាប់ ពី សិទ្ធិ ចុង ក្រោយ ។',
                        doNotDisplayResults: 'កុំ បង្ហាញ លទ្ធផល',
                        resultDisplay: 'លទ្ធផល បង្ហាញName',
                        score: 'ពិន្ទុ',
                        scoringResults: 'លទ្ធផល ពិន្ទុ',
                        allowViewingScoreDetails: 'អនុញ្ញាត ឲ្យ មើល សេចក្ដី លម្អិត ពិន្ទុ',
                        viewCanvasConfiguration: 'មើល ការ កំណត់ រចនា សម្ព័ន្ធ',
                        synchronizationFailedProcessNodeHasChanged: 'ការ ធ្វើ សមកាលកម្ម បាន បរាជ័យ ថ្នាក់ ដំណើរការ បាន បង្កើត ការ ផ្លាស់ប្ដូរ',
                        successfullySynchronizedPleaseClickOnpublishToUpdateTheCourse: 'ការ ធ្វើ សមកាលកម្ម ដែល បាន ជោគជ័យ សូម ចុច បោះពុម្ព ដើម្បី ធ្វើ ឲ្យ លំហាត់ ទាន់ សម័យ',
                        retrievedTheLatestCanvasConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ ចុងក្រោយ',
                        synchronizeCanvasConfiguration: 'ធ្វើ សមកាលកម្ម ការ កំណត់ រចនា សម្ព័ន្ធ',
                        scoringMethod: 'វិធីសាស្ត្រ ពិន្ទុ',
                        pointsProcessPointsScript1PointsEmotion2PointsSpeakingSpeed3Points: 'ចំណុច ត្រូ វ {0} ចំណុច សិទ្ធិ និយាយ {1} ចំណុច សំខាន់ {2} ចំណុច ល្បឿន {3} ចំណុច)',
                        excellentStandardsNeedToBeHigherThanStandardStandards: 'ស្តង់ដារ ល្អ ល្អ ត្រូវ តែ ខ្ពស់ ជាង ស្តង់ដារ',
                        theScoringCriteriaNeedToBeGreaterThanAndLessThanOrEqualTo100: 'លក្ខខណ្ឌ ពិន្ទុ ត្រូវ តែ ធំ ជាង 0% និង តិច ជាង ឬ ស្មើ ១០',
                        theScoringCriteriaNeedToBeGreaterThanPointsAndLessThanOrEqualTo0Points: 'ពាក្យ ពិន្ទុ ត្រូវ តែ ធំ ជាង ០ ចំណុច និង តិច ឬ ស្មើ ចំណុច {0} ។',
                        doRatingsRequireManualReview: 'ថាតើ ការ ពិនិត្យ ត្រូវការ មើល ដៃ',
                        allocationStrategy: 'គោលការណ៍ បិទ',
                        pleaseSelectTheAssignedPersonnel: 'សូម ជ្រើស មនុស្ស ដែល បាន ផ្ដល់ ទេ',
                        pleaseSelectADesignatedPerson: 'សូម ជ្រើស មនុស្ស ដែល បាន ដោះស្រាយ',
                        timeLimitForSingleQuestionAnswering: 'សំណួរ ចម្លើយ ដែន កំណត់ ពេលវេលា មួយ',
                    },
                    autoAddOrganizationList: {
                        publishToNewlyAddedEmployeesByDefault: 'បោះពុម្ព ផ្សាយ ទៅ អ្នក ប្រើ ដែល បាន បន្ថែម ថ្មីៗ តាម លំនាំដើម',
                    },
                },
                list: {
                    index: {
                        reRatingMeansMatchingWillBeDoneAccordingToTheScoringRulesOfTheLatestCanvasThereIsManuallyReviewedScoringDataForTheCurrentTaskDoYouWantToOverwriteTheScores: 'ការ ពិន្ទុ ឡើង វិញ បង្ហាញ ថា ពិន្ទុ នឹង ត្រូវ បាន ផ្គូផ្គង តាមរយៈ ក្បួន ការ ពិន្ទុ ចុងក្រោយ បំផុត ។ ភារកិច្ច បច្ចុប្បន្ន បាន មើល ទិន្នន័យ ពិន្ទុ ដោយ ដៃ ។ តើ អ្នក ចង់ សរសេរ ជាន់ លើ ពិន្ទុ ឬ ?',
                        notCovered: 'មិន គ្រប',
                        cover: 'គម្រប',
                        participationSituation: 'ការ ចូលរួម ភាព',
                        numberOfParticipants: 'ចំនួន អ្នក ចូលរួម@ info: whatsthis',
                        sumOfTheNumberOfPracticeSubjectsSelectedForThisTask: 'ចំនួន វត្ថុ លំហាត់ ដែល បាន ជ្រើស សម្រាប់ ភារកិច្ច នេះ',
                        sumOfTheNumberOfParticipantsInTheTask: 'សង្ខេប ចំនួន មនុស្ស ដែល បាន ចូលរួម ក្នុង ភារកិច្ច',
                        numberOfCompletedPersonnel: 'ចំនួន បាន បញ្ចប់',
                        sumOfTheNumberOfPeopleWhoMeetTheTaskCompletionRequirements: 'សង្ខេប ចំនួន មនុស្ស ដែល ទាក់ទង នឹង ការ បញ្ចប់ ភារកិច្ច',
                        numberOfQualifiedPersonnel: 'ចំនួន ការ ផ្ទៀងផ្ទាត់',
                        sumUpTheNumberOfPeopleWhoMeetTheTaskScoreRequirements: 'សង្ខេប ចំនួន មនុស្ស ដែល បាន ជួប ពិន្ទុ ភារកិច្ច',
                        excellentPersonnel: 'លេខ ខ្ពស់',
                        sumUpTheNumberOfPeopleWithExcellentTaskScores: 'សង្ខេប ចំនួន មនុស្ស ដែល បាន ជួប ភារកិច្ច ដែល មាន ពិន្ទុ ល្អ បំផុត',
                        participationRate: 'អត្រា ចូល រួម@ info: whatsthis',
                        numberOfParticipantsNumberOfParticipants: 'ចំនួន អ្នក ចូលរួម/លេខ អ្នក ចូលរួម ទេ',
                        numberOfCompletedNumberOfParticipants: 'ចំនួន ដែល បាន បញ្ចប់/ ចំនួន នៃ ការ ចូលរួម គ្នា',
                        numberOfPeopleWhoMeetTheStandardsnumberOfPeopleWhoShouldParticipate: 'ចំនួន ការ ចូល រួម/ លេខ របស់ អ្នក ចូល រួមName',
                        excellentNumbernumberOfParticipants: 'លេខ/ ចំនួន អ្នក ចូលរួម ល្អ',
                        participationCompletionRate: 'អត្រា បញ្ចប់ ការ ចូល រួម@ info: whatsthis',
                        numberOfCompletedParticipated: 'ចំនួន បញ្ចប់/ អ្នក ចូលរួម',
                        participationComplianceRate: 'អត្រា ចូល រួម@ info: whatsthis',
                        numberOfQualifiedPersonnelnumberOfParticipants: 'ចំនួន ការ ចូល រួម/ ផ្នែក ភាព',
                        participationRateForAchievingExcellence: 'អត្រា ចូល រួម@ info: whatsthis',
                        accumulatedDuration: 'កាលបរិច្ឆេទ',
                        sumOfTheDurationOfStudentParticipationInTheTask: 'ចូលរួម ក្នុង ថិរវេលា និង សរុប ភារកិច្ច',
                        averageDuration: 'ថិរវេលា មធ្យម',
                        sumOfStudentParticipationTimeInTaskstotalNumberOfParticipationTimes: 'ថិរវេលា សរុប របស់ អ្នក ចូលរួម/ ចំនួន សរុប របស់ អ្នក ចូលរួម ទេ',
                        accumulatedTimes: 'ពេលវេលា មធ្យម',
                        sumOfTheNumberOfTimesStudentsParticipateInTasks: 'ចំនួន អ្នក ចូលរួម ក្នុង ភារកិច្ច',
                        averageScore: 'មធ្យម',
                        theAverageScoreOfThePersonnelParticipatingInThisTask: 'ពិន្ទុ មធ្យម នៃ ភ្ញៀវ ដែល រួម បញ្ចូល ក្នុង ភារកិច្ច',
                        maximumScore: 'ពិន្ទុ ខ្ពស់',
                        theHighestScoreForThePersonnelInvolvedInThisTask: 'ពិន្ទុ ខ្ពស់ បំផុត របស់ ភារកិច្ច ដែល រួម បញ្ចូល ក្នុង ភារកិច្ច',
                        averageScoreOfScript: 'ពិន្ទុ និយាយ មធ្យម',
                        sumOfTraineeScriptScorestotalParticipationTimes: 'ពិន្ទុ សញ្ញា សម្រាក/ ពេលវេលា ចូល រួម បញ្ចូល សំឡេង',
                        totalScoreOfScript: 'ពិន្ទុ សរុប',
                        theTotalScoreOfTheScriptSetUnderThisTask: 'ពិន្ទុ សរុប ដែល បាន កំណត់ ក្រោម ភារកិច្ច នេះ',
                        processAverageScore: 'ពិន្ទុ ដំណើរការ មធ្យម',
                        sumOfStudentProcessScoresTotalParticipationTimes: 'ដំណើរការ ពិន្ទុ សរុប/ ចំនួន ចូលរួម សរុប',
                        totalProcessScore: 'ពិន្ទុ ដំណើរការ សរុប',
                        theTotalScoreOfTheProcessesSetUnderThisTask: 'ពិន្ទុ សរុប នៃ ដំណើរការ ដែល បាន កំណត់ ក្រោម ភារកិច្ច នេះ',
                        averageEmotionalScore: 'ពិន្ទុ សំខាន់ មធ្យម',
                        sumOfStudentEmotionalScoresTotalParticipationTimes: 'ចំនួន ពិន្ទុ សំខាន់/ ចំនួន សរុប នៃ ការ ចូល រួម បញ្ជា',
                        totalEmotionalScore: 'ពិន្ទុ សរុប',
                        theTotalScoreOfEmotionsSetUnderThisTask: 'ពិន្ទុ សំខាន់ សរុប ដែល បាន កំណត់ ក្រោម ភារកិច្ច នេះ',
                        averageScoreOfExpression: 'ពិន្ទុ កន្សោម មធ្យម',
                        sumOfStudentExpressionScorestotalParticipationTimes: 'សរុប នៃ ពិន្ទុ កន្សោម អ្នក រៀន/ ចំនួន បញ្ចូល សរុប',
                        totalScoreOfExpression: 'ពិន្ទុ កន្សោម សរុប',
                        theTotalScoreOfExpressionsSetUnderThisTask: 'ពិន្ទុ កន្សោម សរុប ដែល បាន កំណត់ ក្រោម ភារកិច្ច នេះ',
                        startExecutingReScoringYouCanJumpToTheTaskCenterToViewProgress: 'ចាប់ផ្ដើម ដើម្បី អនុញ្ញាត ការ ពិន្ទុ ឡើងវិញ អ្នក អាច លោត ទៅ កាន់ កណ្ដាល ភារកិច្ច ដើម្បី មើល វឌ្ឍនភាព ។',
                        reRating: 'ការ ពិន្ទុ ឡើង វិញ',
                        reRatingMeansThatMatchingWillBeDoneAccordingToTheLatestScoringRulesOnTheCanvasWhichWillOverwriteTheCurrentScoringResults: 'ការ ពិន្ទុ ឡើង វិញ បង្ហាញ ថា ពិន្ទុ នឹង ត្រូវ បាន ផ្គូផ្គង តាម ដាន ក្ដារ ពិន្ទុ របស់ គំនូរ ចុងក្រោយ បំផុត និង ពិន្ទុ បច្ចុប្បន្ន នឹង ត្រូវ បាន សរសេរ ជាន់ លើ ។ .',
                        releaseTime: 'ពេលវេលា លុប',
                    },
                },
                audit: {
                    components: {
                        pageLeftTable: {
                            reviewed: 'បាន ឡើង វិញ',
                            pendingReview: 'ត្រូវ បាន ពិនិត្យ មួយ',
                            enterKeywordSearch: 'បញ្ចូល ពាក្យ គន្លឹះ ដើម្បី ស្វែងរក',
                        },
                        pageRightTable: {
                            index: {
                                employeeName: 'ឈ្មោះ ម៉ាស៊ីន ភ្ញៀវ',
                                systemRating: 'ពិន្ទុ ប្រព័ន្ធ',
                                scoringResults: 'លទ្ធផល ពិន្ទុ',
                                duration: 'កាលបរិច្ឆេទ',
                                time: 'ពេលវេលា',
                                state: 'ស្ថានភាព',
                                whetherToModifyTheRating: 'ពិន្ទុ ត្រឹមត្រូវ',
                                finalScore: 'ពិន្ទុ ចុងក្រោយ',
                                reviewedBy: 'កម្មវិធី បន្ត',
                                operation: 'ប្រតិបត្តិការ',
                                viewScoreDetails: 'មើល សេចក្ដី លម្អិត ពិន្ទុ',
                                viewStatus: 'មើល ស្ថានភាព',
                                whole: 'ទាំង អស់',
                                correctionStatus: 'ស្ថានភាព ត្រឹមត្រូវ',
                                completeReview: 'បាន បញ្ចប់ ឡើង វិញ',
                                tips: 'សួរ',
                                theFinalScoreOfTheStudentIsBasedOnTheCurrentFinalReviewResultPleaseConfirm: 'លទ្ធផល ចុងក្រោយ របស់ អ្នក បង្ហាញ នឹង ត្រូវ បាន គាំទ្រ លទ្ធផល ចុងក្រោយ បច្ចុប្បន្ន សូម អះអាង',
                            },
                        },
                    },
                    index: {
                        manualReview: 'មើល ដៃ',
                    },
                },
                review: {
                    index: {
                        employeeName: 'ឈ្មោះ ម៉ាស៊ីន ភ្ញៀវ',
                        score: 'ពិន្ទុ',
                        scoringResults: 'លទ្ធផល ពិន្ទុ',
                        duration: 'កាលបរិច្ឆេទ',
                        taskName: 'ឈ្មោះ ភារកិច្ច',
                        numberOfAppealScripts: 'ចំនួន ភ្ជាប់',
                        appealTime: 'ពេលវេលា សំណួរ',
                        processStatus: 'ស្ថានភាព ដំណើរការ',
                        scoreAfterReview: 'ពិន្ទុ បន្ទាប់ ពី ពិនិត្យ មួយ',
                        reviewedBy: 'កម្មវិធី បន្ត',
                        operation: 'ប្រតិបត្តិការ',
                        viewScoreStatus: 'មើល ពិន្ទុ',
                        whole: 'ទាំង អស់',
                        manualReview: 'មើល ដៃ',
                    },
                },
                qalist: {
                    index: {
                        participatingEmployees: 'អ្នក ចូល រួម កិច្ចការ ។',
                        traineeNickname: 'សម្ម ឈ្មោះ បង្ហាញ',
                        whetherToParticipate: 'ថា តើ ត្រូវ ចូលរួម ឬ ទេ',
                        participateInTask: 'ចូលរួម ក្នុង ភារកិច្ច',
                        notInvolved: 'មិន រួម បញ្ចូល គ្នា',
                        participation: 'ការ ចូលរួម ភាព',
                        finish: 'បញ្ចប់',
                        whetherTheRequirementsForTaskCompletionAreMet: 'ថា តើ ការ ទាមទារ ការ បញ្ចប់ ភារកិច្ច ត្រូវ បាន ធ្វើ ទេ',
                        unfinished: 'មិន បាន បញ្ចប់',
                        complete: 'បញ្ចប់',
                        whetherItIsUpToStandard: 'ថាតើ វា ជា ស្តង់ដារ',
                        whetherTheScoreRequirementsOfTheTaskAchievementCriteriaAreMet: 'ថា តើ ការ ទាមទារ ពិន្ទុ នៃ លក្ខខណ្ឌ ភារកិច្ច ទទួល បាន ត្រឹមត្រូវ',
                        notUpToStandard: 'មិន មែន ជា ស្តង់ដារ',
                        standard: 'ស្តង់ដារ',
                        whetherItIsExcellent: 'ថាតើ វា ខ្ពស់',
                        whetherTheTaskMeetsTheRequirementsForAchievingExcellentScores: 'ថាតើ ភារកិច្ច ជួសជុល ការ ទាមទារ សម្រាប់ ការ យក ពិន្ទុ ល្អ បំផុត',
                        notExcellent: 'មិន ល្អ បំផុត',
                        excellent: 'ល្អ ប្រសើរ',
                        qualityAccompanyList: 'គុណភាព រួមបញ្ចូល បញ្ជី បញ្ជា',
                    },
                },
            },
            dashboard: {
                components: {
                    adminDataCards: {
                        exerciseTaskData: 'ដំណើរការ ទិន្នន័យ ភារកិច្ច',
                        implementationRate: 'អត្រា ការ អនុញ្ញាត',
                        numberOfExecutors: 'ចំនួន ការ ប្រតិបត្តិ',
                        numberOfPeopleNotExecuted: 'ចំនួន ដែល មិន បាន ប្រតិបត្តិ@ info: whatsthis',
                        completionRate: 'អត្រា បំពេញComment',
                        numberOfCompletedPersonnel: 'ចំនួន បាន បញ្ចប់',
                        numberOfUnfinishedPersonnel: 'ចំនួន មិន បាន បញ្ចប់',
                        complianceRate: 'អត្រា បន្ទាប់',
                        numberOfQualifiedPersonnel: 'ចំនួន ការ ផ្ទៀងផ្ទាត់',
                        numberOfNonCompliantIndividuals: 'ចំនួន មនុស្ស ដែល មិន ទាក់ទង នឹង ស្តង់ដារ',
                        excellentRate: 'អត្រា ខ្ពស់',
                        numberOfOutstandingIndividuals: 'លេខ ខ្ពស់',
                        numberOfNonOutstandingIndividuals: 'លេខ មិន ល្អ បំផុត@ info: whatsthis',
                        examTaskData: 'ទិន្នន័យ ភារកិច្ច',
                        published: 'បាន បោះពុម្ព',
                        courses: 'វត្ថុ',
                        courseData: 'ទិន្នន័យ ដក',
                        practiceTasks: 'ដំណើរការ ភារកិច្ច',
                        examTasks: 'ភារកិច្ច ការ ពិពណ៌នា',
                    },
                    practiceSummary: {
                        practiceSummary: 'សង្ខេប សិទ្ធិ',
                        numberOfPracticeTasks: 'ចំនួន ភារកិច្ច សកម្មភាព',
                        numberOfExercises: 'ចំនួន សកម្មភាព',
                        accumulatedPracticeDuration: 'កាលបរិច្ឆេទ វិភាគ រយ',
                        complianceRate: 'អត្រា បន្ទាប់',
                        excellentRate: 'អត្រា ខ្ពស់',
                        ranking: 'រលាត់',
                    },
                    rankingList: {
                        numberOfExercises: 'ចំនួន សកម្មភាព',
                        exerciseDuration: 'កាលបរិច្ឆេទ បង្ហាញ',
                        complianceRate: 'អត្រា បន្ទាប់',
                        excellentRate: 'អត្រា ខ្ពស់',
                        diligenceChart: 'បញ្ជី សំណួរ',
                        excellentList: 'បញ្ជី ល្អ ប្រសើរ',
                        ranking: 'គំរូ',
                        fullName: 'ឈ្មោះ:',
                        i: 'ខ្ញុំ...',
                    },
                    taskCard: {
                        end: 'កាលបរិច្ឆេទ ៖',
                        noDeadline: 'គ្មាន ពេលវេលា កំណត់',
                        second: 'ពេលវេលាName',
                        branch: 'ចំណុច',
                    },
                    taskProgress: {
                        thereAreCurrentlyNoTasksAvailable: 'គ្មាន ភារកិច្ច',
                        completed: 'បាន បញ្ចប់',
                    },
                    filter: {
                        employeeDepartment: 'វឌ្ឍនភាព ភ្ញៀវ',
                    },
                    exportButton: {
                        index: {
                            exportSuccessfulPleaseGoToTheTaskCenterToView: 'នាំចេញ បាន ជោគជ័យ សូម ទៅ កាន់ មជ្ឈមណ្ឌល ភារកិច្ច ដើម្បី មើលName',
                            export: 'នាំចេញ',
                        },
                    },
                    filterConfig: {
                        dropdown: {
                            custom: 'ផ្ទាល់ខ្លួន',
                        },
                        modal: {
                            updateSuccessful: 'ធ្វើ ឲ្យ ទាន់សម័យ បាន ជោគជ័យ',
                            successfullySaved: 'រក្សាទុក ដោយ ជោគជ័យ',
                            setAsACommonReport: 'កំណត់ ទៅ របាយការណ៍ ធម្មតា',
                            updateCurrentReport: 'ធ្វើ ឲ្យ របាយការណ៍ បច្ចុប្បន្ន',
                        },
                    },
                    employeeDataCards: {
                        components: {
                            abilityGrowthTrend: {
                                utils: {
                                    averageScore: 'មធ្យម',
                                    averageScoreOfScript: 'ពិន្ទុ និយាយ មធ្យម',
                                    averageEmotionalScore: 'ពិន្ទុ សំខាន់ មធ្យម',
                                    expressionAverageScore: 'ពិន្ទុ មធ្យម',
                                    processAverageScore: 'ពិន្ទុ ដំណើរការ មធ្យម',
                                    branch: 'ចំណុច',
                                },
                            },
                            comprehensiveEvaluation: {
                                const: {
                                    data: 'ទិន្នន័យ',
                                },
                            },
                            doneStatus: {
                                index: {
                                    practice: 'ដំណើរការ',
                                    examination: 'ការ ព្រួញ',
                                    executed: 'ប្រតិបត្តិ',
                                    unexecuted: 'មិន បាន ប្រតិបត្តិ',
                                    accumulatedExamDuration: 'ថិរវេលា សាកល្បង',
                                    examFrequency: 'ចំនួន សិទ្ធិ',
                                },
                            },
                            filter: {
                                index: {
                                    practice: 'ដំណើរការ',
                                    examination: 'ការ ព្រួញ',
                                    pleaseCompleteTheRequiredFields: 'សូម បញ្ចប់ ធាតុ ដែល ទាមទារ',
                                    staff: 'ការងារ',
                                    taskType: 'ប្រភេទ ភារកិច្ច',
                                    pleaseSelect: 'សូម ជ្រើស',
                                    taskName: 'ឈ្មោះ ភារកិច្ច',
                                },
                            },
                        },
                        index: {
                            completionStatus: 'ស្ថានភាព បញ្ចប់',
                            comprehensiveEvaluation: 'ការ វាយតម្លៃ',
                            abilityGrowthTrend: 'កម្រិត បង្កើន សមត្ថិភាព',
                            errorProneAnalysis: 'ការ វិភាគ ចំណុច បញ្ចូល កំហុស',
                        },
                    },
                },
                hook: {
                    useSummary: {
                        activePopulation: 'លេខ សកម្ម',
                        accumulatedPracticeDuration: 'កាលបរិច្ឆេទ វិភាគ រយ',
                        averagePracticeDuration: 'ពេលវេលា ដំណើរការ មធ្យម',
                        people: 'មនុស្ស ជាតិ',
                        numberOfPracticeTasks: 'ចំនួន ភារកិច្ច សកម្មភាព',
                        numberOfExercises: 'ចំនួន សកម្មភាព',
                        exerciseDuration: 'កាលបរិច្ឆេទ បង្ហាញ',
                        second: 'ពេលវេលាName',
                        avgScore: 'មធ្យម',
                        speechCraftAvgScore: 'ពិន្ទុ និយាយ មធ្យម',
                        emotionAvgScore: 'ពិន្ទុ សំខាន់ មធ្យម',
                        speedAvgScore: 'ពិន្ទុ មធ្យម',
                        flowAvgScore: 'ពិន្ទុ ដំណើរការ មធ្យម',
                        practiceCostTime: 'កាលបរិច្ឆេទ',
                        totalPracticeTimes: 'ពេលវេលា ចូល គ្នា',
                        participateCommitRate: 'អត្រា ចូល រួម@ info: whatsthis',
                        participateExcellentRate: 'អត្រា ចូល រួម@ info: whatsthis',
                    },
                },
                index: {
                    employeeProfile: 'បញ្ជា',
                    overview: 'មើល មើល',
                    personalSignage: 'កាបេន ផ្ទាល់ខ្លួន',
                    ongoingExercises: 'ដំណើរការ កំពុង ដំណើរការ',
                    ongoingExams: 'ការ ពិនិត្យ កំពុង ដំណើរការ',
                    practiceTaskProgress: 'បង្កើន វឌ្ឍនភាព ភារកិច្ច',
                    examTaskProgress: 'សាកល្បង វឌ្ឍនភាព ភារកិច្ច',
                },
            },
            businessConfiguration: {
                scoreManagement: {
                    dimensionIndex: {
                        index: {
                            pleaseSelectAConceptWord: 'សូម ជ្រើស ពាក្យ បង្ហាញ',
                            sessionDetectionSettings: 'ការ កំណត់ រក ឃើញ សម័យ',
                            successfullySaved: 'រក្សាទុក ដោយ ជោគជ័យ',
                            abnormalSpeechSpeed: 'ល្បឿន និយាយ មិន ធម្មតា',
                            supportCustomSpeechSpeedDetectionStandardsAndTheResultsWillBeJudgedAsNormalTooFastOrTooSlowWhenThereIsAnAbnormalSpeechSpeedtooFasttooSlowPointsWillBeDeductedAccordingToTheScoringRules: 'ស្តង់ដារ រកឃើញ ល្បឿន និយាយ ដែល បាន កំណត់ របស់ អ្នក ប្រើ ត្រូវ បាន គាំទ្រ ។ លទ្ធផល នឹង ជា ល្បឿន និយាយ ធម្មតា ល្បឿន និយាយ រហ័ស និង ល្បឿន និយាយ យឺត ពេក ។ នៅ ពេល ល្បឿន និយាយ មិន ធម្មតា (លឿន លឿន ពេញលេញ) ពិន្ទុ នឹង ត្រូវ បាន បន្ថយ យោង តាម ក្ដារ ការ ពិន្ទុ ។',
                            speechSpeedTooFastGreaterThanEveryMinute: 'ល្បឿន',
                            oneWordSpeakingTooSlowlyLessThanPerMinute: 'ពាក្យ យឺត ពេក ៖ les than per minute',
                            charactersIgnoringLessThan: 'ពាក្យ មិន អើពើ តិច',
                            aSentenceOfWords: 'ពាក្យ ពាក្យ',
                            excessiveModalParticles: 'ពាក្យ modal ច្រើន ពេញ',
                            supportCustomModalParticlesAndSetRulesForExcessiveModalParticlesWhenThereAreTooManyModalParticlesPointsWillBeDeductedAccordingToTheScoringRules: 'គាំទ្រ ពាក្យ គំរូ ផ្ទាល់ ខ្លួន និង កំណត់ ច្បាប់ នៃ ពាក្យ ដុំ ច្រើន ។ នៅពេល មាន ពាក្យ ម៉ូឌែល ច្រើន ពិន្ទុ នឹង ត្រូវ បាន បន្ថយ តាមរយៈ ក្បួន ការ ពិនិត្យ ។',
                            theNumberOfRepetitionsIs: 'ចំនួន ការ ធ្វើ ឡើងវិញ',
                            inTheSecondTenseItIsDeterminedThatThereAreTooManyModalParticles: 'ដ្បិត ទីពីរ គឺ ត្រូវ បាន បញ្ជាក់ ថា មាន ពាក្យ ម៉ូឌុល ច្រើន ។',
                            definitionOfSensitiveViolations: 'ការ បំពាន ការ តួ អក្សរ',
                            supportCustomWordLibrariesToDetectThePresenceOfIllegalWordsInASentenceWhenIllegalWordsAppearPointsWillBeDeductedAccordingToTheScoringRules: 'អ្នក អាច ប្ដូរ កម្រិត ពាក្យ មិន ត្រឹមត្រូវ តាម បំណង ដើម្បី រកឃើញ ថា តើ ពាក្យ មិន ត្រឹមត្រូវ លេចឡើង នៅ ក្នុង ប្រយោជន៍ ។ នៅពេល មាន ពាក្យ មិន ត្រឹមត្រូវ ពិន្ទុ នឹង ត្រូវ បាន បន្ថយ តាមរយៈ ច្បាប់ វិធី ។',
                            violationWords: 'ពាក្យ មិន ត្រឹមត្រូវ ៖',
                            emotionalDetection: 'ការ រក ឃើញ សំខាន់',
                            accordingToTheSystemEmotionModelDialogueTechniqueEmotionDetectionWillBeConductedAndTheResultsWillBeJudgedAsNormalEmotionsAndNegativeEmotionsincludingNegativeAngryAndComplainingWhenNegativeEmotionsOccurPointsWillBeDeductedAccordingToTheScoringRules: 'យោង តាម ប្រអប់ ម៉ូដែល សំខាន់ ប្រព័ន្ធ ។ សាកល្បង ការ សាកល្បង នឹង ត្រូវ បាន ប្រយោជន៍ ជា និច្ច ធម្មតា និង សកម្មភាព អង់គ្លេស នៅពេល មាន សកម្មភាព អស់ អស់ពី ពិន្ទុ នឹង ត្រូវ បាន បន្ថយ ដោយ ក្បួន ការ វិភាគ ។',
                            preserve: 'រក្សាទុក',
                        },
                    },
                    scoreDimension: {
                        index: {
                            ratingDimension: 'ទំហំ អត្រា',
                            ratingPoints: 'ចំណុច ពិន្ទុ',
                            explain: 'សេចក្ដី ពិពណ៌នា',
                            type: 'ប្រភេទ@ info: whatsthis',
                        },
                    },
                    scoreModel: {
                        components: {
                            comprehensiveEvaluation: {
                                const: {
                                    randomData: 'ទិន្នន័យ ចៃដន្យ',
                                },
                                index: {
                                    spanStylemarginLeftpxStandardScriptAccumulation: 'រចនាប័ទ្ម <span = "margin-left: 8',
                                    theTotalNumberOfWordsHitByTheStudentAfterReading: 'ពាក្យ មួយ ចំនួន ពាក្យ គត់ ដោយ សិទ្ធិ',
                                    aWordspan: 'ពាក្យ </ span>',
                                    timesspanbrspanStylemarginLeftpxSpeakTooSlowly: 'Times </ span',
                                    timesspan: '</ Span>',
                                    tooManyModalParticles: '<Span រចនាប័ទ្ម = "margin-left: 8px"> · ពាក្យ modal ច្រើន ពេញ',
                                },
                            },
                        },
                        detail: {
                            components: {
                                model: {
                                    group: {
                                        theScoreIs: 'ពិន្ទុ',
                                    },
                                    item: {
                                        violationOnceReduced: 'ការ លុប ១',
                                        abnormalSpeechSpeedincludingTooFastOrTooSlowDecrease: 'ល្បឿន មិន ធម្មតា (រួម បញ្ចូល ល្បឿន លឿន ពេក និង ល្បឿន យឺត ពេក) បន្ថយ 1',
                                        excessiveNumberOfModalParticlesReducedOnce: 'ពាក្យ ម៉ូឌុល ច្រើន ពេញ ពេញ ១ មុន',
                                        oneNegativeDecreaseInEmotions: 'សកម្មភាព អុហ្វសិត',
                                        branch: 'ចំណុច',
                                    },
                                    wrap: {
                                        name: 'ឈ្មោះ:',
                                        preserve: 'រក្សាទុក',
                                    },
                                },
                            },
                            index: {
                                complete: 'មាតិកា',
                                keyHit: 'ចំណុច គ្រាប់ ចុច',
                                accurateFollowupReading: 'ការ អាន ត្រឹមត្រូវ',
                                languageNorm: 'ការ បញ្ជាក់ ភាសាName',
                                speechSpeed: 'ល្បឿន និយាយComment',
                                modalParticles: 'ពាក្យ modal',
                                emotionallyPositive: 'សុវត្ថិភាព ត្រឹមត្រូវ',
                                scoringModel: 'ម៉ូដែល ពិន្ទុ',
                                successfullyModified: 'ការ កែប្រែ បាន ជោគជ័យ',
                                newSuccessfullyCreated: 'ជោគជ័យ ថ្មី',
                            },
                        },
                        index: {
                            scoringModel: 'ម៉ូដែល ពិន្ទុ',
                            newModel: 'ម៉ូដែល ថ្មី',
                            model: 'ម៉ូល',
                            type: 'ប្រភេទ@ info: whatsthis',
                            operation: 'ប្រតិបត្តិការ',
                            preview: 'មើល ជាមុន',
                            edit: 'កែសម្រួល',
                        },
                    },
                    index: {
                        scoringModel: 'ម៉ូដែល ពិន្ទុ',
                        ratingDimension: 'ទំហំ អត្រា',
                        sessionDetectionSettings: 'ការ កំណត់ រក ឃើញ សម័យ',
                    },
                },
            },
            dataAnalysis: {
                learningRecord: {
                    components: {
                        keyPointHit: {
                            index: {
                                pleaseSelect: 'សូម ជ្រើស',
                                hit: 'បិទ',
                                misses: 'បាត់Comment',
                            },
                        },
                    },
                    index: {
                        duration: 'កាលបរិច្ឆេទ',
                        processScore: 'ពិន្ទុ ដំណើរការ',
                        branch: 'ចំណុច',
                        contentCompleteness: 'មាតិកា',
                        scriptScore: 'ពិន្ទុ និយាយComment',
                        keyHitRate: 'អត្រា គំរូ ចំណុច គ្រាប់ចុច',
                        emotionalScore: 'ពិន្ទុ សញ្ញា',
                        negativeProportionOfEmotions: 'សមាសភាគ វិសេស នៃ សកម្មភាព',
                        expressionScore: 'ពិន្ទុ កន្សា',
                        theProportionOfAbnormalSpeechSpeed: 'គុណភាព នៃ ល្បឿន និយាយ មិន ធម្មតា',
                        excessiveProportionOfModalParticles: 'សមាសភាគ ច្រើន នៃ ពាក្យ modl',
                        learningRecordData: 'សិក្សា ទិន្នន័យ ថត',
                        staff: 'ការងារ',
                        curriculum: 'សំឡេង',
                        mainPoints: 'ចំណុច សោ',
                    },
                },
                customKanban: {
                    components: {
                        chart: {
                            components: {
                                header: {
                                    components: {
                                        chartToggle: {
                                            hooks: {
                                                form: 'តារាង',
                                                lineChart: 'គំនូសតាង បន្ទាត់',
                                                barChart: 'អ៊ីស្តូក្រម',
                                                pieChart: 'គំនូស់',
                                            },
                                            index: {
                                                switchingTypes: 'ប្រភេទ ប្ដូរ',
                                            },
                                        },
                                    },
                                    index: {
                                        saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                                        editChart: 'កែសម្រួល គំនូសតាង',
                                        chartName: 'ឈ្មោះ គំនូសតាង',
                                        deleteSuccessful: 'បាន លុប ដោយ ជោគជ័យ',
                                        refresh: 'ធ្វើ ឲ្យ ស្រស់',
                                        export: 'នាំចេញ',
                                        areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                                        delete: 'លុប',
                                        viewFilteringCriteria: 'មើល យោង តម្រង',
                                    },
                                },
                            },
                            index: {
                                exportSuccessfulPleaseGoToTheTaskCenterToCheck: 'នាំចេញ បាន ជោគជ័យ សូម ទៅ កាន់ មជ្ឈមណ្ឌល ភារកិច្ច ដើម្បី មើលName',
                            },
                        },
                        header: {
                            index: {
                                saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                                deleteSuccessful: 'បាន លុប ដោយ ជោគជ័យ',
                                editReport: 'កែសម្រួល របាយការណ៍Comment',
                                reportName: 'ឈ្មោះ របាយការណ៍Name',
                                refresh: 'ធ្វើ ឲ្យ ស្រស់',
                                areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                                delete: 'លុប',
                                exportToExcel: 'នាំចេញ  ExcelComment',
                                exportSnapshot: 'នាំចេញ រូបថត',
                                export: 'នាំចេញ',
                                authority: 'សិទ្ធិ',
                                permissionSettings: 'ការ កំណត់ សិទ្ធិ',
                                reportVisiblePermissions: 'រាយការណ៍ សិទ្ធិ ដែល អាច មើល ឃើញ',
                                visibleToEveryone: 'មើលឃើញ ទៅ ទាំងអស់',
                                onlyVisibleToOneself: 'មាន តែ មើល ឃើញ សម្រាប់ ផ្ទាល់ ខ្លួន ប៉ុណ្ណោះ',
                                designatedPersonnelVisible: 'មនុស្ស ដែល បាន បញ្ជាក់ អាច មើល ឃើញ ទេ',
                                pleaseSelect: 'សូម ជ្រើស',
                                reportDataPermissions: 'រាយការណ៍ សិទ្ធិ ទិន្នន័យ',
                                restrictedByUserPermissions: 'បាន ដាក់ កម្រិត ដោយ សិទ្ធិ អ្នក ប្រើ',
                                visiblePeopleAreTheSame: 'មនុស្ស ដែល មើលឃើញ គឺ ដូចគ្នា ។',
                            },
                        },
                        titleFooter: {
                            index: {
                                addReport: 'របាយការណ៍ ថ្មី',
                                reportName: 'ឈ្មោះ របាយការណ៍Name',
                            },
                        },
                    },
                    index: {
                        exportSuccessfulPleaseGoToTheTaskCenterToCheck: 'នាំចេញ បាន ជោគជ័យ សូម ទៅ កាន់ មជ្ឈមណ្ឌល ភារកិច្ច ដើម្បី មើលName',
                        dataQueryInProgress: 'សំណួរ ទិន្នន័យ ក្នុង ...',
                        customKanban: 'ផ្ទាល់ខ្លួន',
                    },
                },
                intelligentAnalysis: {
                    components: {
                        header: {
                            hooks: {
                                form: 'តារាង',
                                lineChart: 'គំនូសតាង បន្ទាត់',
                                barChart: 'អ៊ីស្តូក្រម',
                                pieChart: 'គំនូស់',
                            },
                            index: {
                                successfullyAdded: 'បាន បន្ថែម ដោយ ជោគជ័យ',
                                viewSQL: 'មើល SQL',
                                export: 'នាំចេញ',
                                addToReport: 'បន្ថែម ទៅ របាយការណ៍@ info: whatsthis',
                            },
                        },
                        refer: {
                            hooks: {
                                data: 'ទិន្នន័យ',
                                interrogativeSentence: 'សំណួរ',
                                historicalQuery: 'សំណួរ ប្រវត្តិ',
                            },
                            index: {
                                copySuccessful: 'ចម្លង ជោគជ័យ',
                                copy: 'ចម្លង',
                            },
                        },
                        search: {
                            components: {
                                latitudeModal: {
                                    components: {
                                        selector: {
                                            const: {
                                                notMeetingStandards: 'មិន មែន ជា ស្តង់ដារ',
                                                meetingStandards: 'ស្តង់ដារ',
                                                excellent: 'ល្អ ប្រសើរ',
                                                notStartedYet: 'មិន បាន ចាប់ផ្ដើម',
                                                inProgress: 'កំពុង វឌ្ឍន៍',
                                                completed: 'បាន បញ្ចប់',
                                                incomplete: 'មិន បាន បញ្ចប់',
                                            },
                                        },
                                    },
                                    const: {
                                        taskName: 'ឈ្មោះ ភារកិច្ច',
                                        department: 'ហត្ថលេខា',
                                        studentName: 'ឈ្មោះ សិទ្ធិ',
                                        scoringResults: 'លទ្ធផល ពិន្ទុ',
                                        taskCompletionStatus: 'ស្ថានភាព បញ្ចប់ ភារកិច្ច',
                                    },
                                    index: {
                                        pleaseSelectADimension: 'សូម ជ្រើស ទំហំ',
                                    },
                                },
                            },
                            index: {
                                enterToOpenThePopupBoxForDimensionSelection: 'បញ្ចូល @ ដើម្បី បើក ប្រអប់ រលប់ សម្រាប់ ជ្រើស វិមាត្រ',
                                pleaseEnterAQueryStatementToDirectlyQuery: 'សូម បញ្ចូល សេចក្ដី សន្យា សំណួរ ដែល ត្រូវ សួរ ដោយ ផ្ទាល់',
                                query: 'សំណួរ',
                            },
                        },
                    },
                    index: {
                        exportSuccessfulPleaseGoToTheTaskCenterToCheck: 'នាំចេញ បាន ជោគជ័យ សូម ទៅ កាន់ មជ្ឈមណ្ឌល ភារកិច្ច ដើម្បី មើលName',
                        dataQueryInProgress: 'សំណួរ ទិន្នន័យ ក្នុង ...',
                    },
                },
            },
            templateManage: {
                dialogueManage: {
                    edit: {
                        enterTheAppropriateSceneDescriptionAccordingToYourSparringPurposeForExampleIfACustomerWantsToBuySeriousIllnessInsuranceForHisFamilyTheSalespersonIntroducesTheInsuranceProductsAndProtectionToHimByPhoneYouCanProvideSpecificEventsThatMayOccurInTheSceneInTheDescriptionTheMoreDetailedTheSceneDescriptionTheMoreAccurateTheDialogueProcessOrFrameworkWillBeAndTheBetterTheEffectWillBe: 'បញ្ចូល ការ ពិពណ៌នា វិសាលភាព ដែល ត្រឹមត្រូវ តាម គោល បំណង របស់ អ្នក ។ ឧទាហរណ៍ ប្រសិនបើ អ្នក ភ្ញៀវ ចង់ ចង់ ចង្អុល ការ ប្រោស អ៊ីស្រាអែល សម្រាប់ ក្រុម គ្រួសារ របស់ គាត់ ។ ថ. ។ អ្នក អាច ផ្ដល់ ព្រឹត្តិការណ៍ ជាក់លាក់ ដែល អាច កើត ឡើង នៅ ក្នុង ការ ពិពណ៌នា ។ ការ ពិពណ៌នា លម្អិត ច្រើន ច្រើន ជាង ដំណើរការ ប្រអប់ ឬ គ្រោងការណ៍ នឹង មាន ត្រឹមត្រូវ',
                        enterTheAppropriateSceneDescriptionAccordingToYourSparringPurposeForExampleACustomerWantsToBuySeriousIllnessInsuranceForHisFamilyAndTheSalespersonIntroducesTheInsuranceProductsAndInsuranceToHimByPhoneYouCanProvideSpecificEventsThatMayOccurInTheSceneInTheDescriptionTheMoreDetailedTheSceneDescriptionTheMoreAccurateTheDialogueProcessOrFrameworkWillBeAndTheBetterTheEffectWillBe: 'បញ្ចូល ការ ពិពណ៌នា វិសាលភាព ដែល ត្រឹមត្រូវ តាម គោល បំណង របស់ អ្នក ។\nឧទាហរណ៍ អ្នក ភ្ញៀវ ចង់ ចង់ ចង្អុល ការ ប្រោស អ៊ីស្រាអែល សម្រាប់ ក្រុម គ្រួសារ របស់ គាត់ ។ ហើយ អ្នក ញែក លោត បញ្ចូល លទ្ធផល និង ការ សរសេរ សំនួរ ចំពោះ គាត់ ដោយ ទូរស័ព្ទ ។\nអ្នក អាច ផ្ដល់ ព្រឹត្តិការណ៍ ជាក់លាក់ ដែល អាច កើត ឡើង នៅ ក្នុង ការ ពិពណ៌នា ។ ការ ពិពណ៌នា លម្អិត ច្រើន ច្រើន ជាង ដំណើរការ ប្រអប់ ឬ គ្រោងការណ៍ នឹង មាន ត្រឹមត្រូវ',
                        editSceneSuccessfully: 'កែសម្រួល ទិដ្ឋភាព ដោយ ជោគជ័យ',
                        sceneCreatedSuccessfully: 'បាន បង្កើត រូបរាង ដោយ ជោគជ័យ',
                        sceneName: 'ឈ្មោះ រូបភាព',
                        pleaseEnterASceneName: 'សូម បញ្ចូល ឈ្មោះ រូបភាព',
                        pleaseEnter: 'សូម បញ្ចូល',
                        scenarioDescription: 'សេចក្ដី ពិពណ៌នា វិសារ',
                        pleaseEnterASceneDescription: 'សូម បញ្ចូល សេចក្ដី ពិពណ៌នា រូបភាព',
                        pleaseEnterASceneDescriptionForTheSceneAndThePurposeOfTheSceneEntryForExampleCustomersWantToHandlePersonnelNeedsBusinessEnterPersonnelInformationPhoneNumberAndOrderProductsAndImprovementsTheMoreDetailedTheSceneDescriptionTheMoreCharacteristicTheDialogueProcessWillBeTheBetterTheEffectWillBe: 'សូម បញ្ចូល សេចក្ដី ពិពណ៌នា រូបរាង សម្រាប់ រូបរាង និង គោល បំណង របស់ ធាតុ ទីតាំង ។\nឧទាហរណ៍ ៖ ម៉ាស៊ីន ភ្ញៀវ ចង់ ដោះស្រាយ ភ្ញៀវ ត្រូវការ បណ្ដាញ បញ្ចូល លេខ ព័ត៌មាន ទូរស័ព្ទ និង ការ ប្រសើរ ។\nការ ពិពណ៌នា លម្អិត ច្រើន ច្រើន នូវ លក្ខណៈ សម្បត្តិ ដំណើរការ ប្រអប់ នឹង បង្កើត បែបផែន ល្អ បំផុត ។',
                        panelObjectStudent: 'វត្ថុ បន្ទះ (មេរៀន)',
                        pleaseEnterAPanelObject: 'សូម បញ្ចូល វត្ថុ បន្ទះ',
                        proposedRolesRobots: 'ផ្លូវ ដែល បាន ទាក់ទង (Robots)',
                        pleaseSelectASuggestedRole: 'សូម ជ្រើស តួអក្សរ ដែល បាន ស្នើ',
                        pleaseEnterARoleName: 'សូម បញ្ចូល ឈ្មោះ role',
                        remarks: 'ពាក្យ បញ្ជា',
                        cancel: 'បោះបង់',
                        save: 'រក្សាទុក',
                    },
                    list: {
                        name: 'ឈ្មោះ:',
                        accompanyingTrainingObjectCadet: 'វត្ថុ បង្ហាត់ បង្ហាញ (Cadet)',
                        proposedRolesRobots: 'ផ្លូវ ដែល បាន ទាក់ទង (Robots)',
                        creationTime: 'ពេលវេលា បង្កើតComment',
                        remarks: 'ពាក្យ បញ្ជា',
                        enabledStatus: 'បាន អនុញ្ញាត ស្ថានភាព',
                        operation: 'ប្រតិបត្តិការ',
                        edit: 'កែសម្រួល',
                        delete: 'លុប',
                        failedToGetList: 'បាន បរាជ័យ ក្នុង ការ យក បញ្ជី@ info: whatsthis',
                        statusUpdateSuccessful: 'ធ្វើ ឲ្យ ស្ថានភាព ទាន់ សម័យ មាន ជោគជ័យ',
                        statusUpdateFailed: 'បាន បរាជ័យ ក្នុង ការ ធ្វើ ឲ្យ ស្ថានភាព ទាន់ សម័យ',
                        areYouSureYouWantToDelete: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                        confirm: 'អះអាង',
                        cancel: 'បោះបង់',
                        deletedSuccessfully: 'បាន លុប ដោយ ជោគជ័យ',
                        deleteFailed: 'បរាជ័យ លុប',
                        sceneName: 'ឈ្មោះ រូបភាព',
                        pleaseEnter: 'សូម បញ្ចូល',
                        pleaseEnterThePartnerstudent: 'សូម បញ្ចូល គូស គ្នា (មេរៀន)',
                        pleaseEnterARoleName: 'សូម បញ្ចូល ឈ្មោះ role',
                        pleaseEnterComments: 'សូម បញ្ចូល សេចក្ដី អធិប្បាយ',
                        startDate: 'កាលបរិច្ឆេទ ចាប់ផ្ដើម',
                        endDate: 'កាលបរិច្ឆេទ បញ្ចប់',
                        reset: 'កំណត់ ឡើង វិញ',
                        filter: 'តម្រង',
                        new: 'ថ្មី',
                    },
                },
                roleManage: {
                    edit: {
                        aishaNature: 'អ៊ីស (និមិត្ត)',
                        zhishachat: 'Zhisha (ជជែក)',
                        zhiqianGentle: 'ស៊ីគីយ៉ា (Gentle)',
                        knowRiceemotion: 'ស្គាល់ ឃ្លាំង',
                        aishuoNature: 'អ៊ីសូ (និមិត្ត)',
                        zhishuochat: 'Zhishuo (ជជែក)',
                        aiHaoAffinity: 'អ៊ី ហូ (Affinity)',
                        zhixiangEmotion: 'ហ្គីxiang (បង្ហាញ)',
                        enterTheCorrespondingDescriptionAccordingToYourPartnersTargetRoleSuchAsTAsPersonalityCharacteristicsCommunicationStylePositionAndWorkUnitPainPointsWhatProductsAreCurrentlyUsedWhatEnvironmentAreCurrentlyInPlaceAndWhatPossibleObjectionsAreThereEtcTheClearerTheDescriptionProvidedTheMoreAccurateAndSpecificTheRoleWillBeBuilt: 'បញ្ចូល សេចក្ដី ពិពណ៌នា ដែល ទាក់ទង នឹង តួនាទី គោលដៅ របស់ អ្នក ដូចជា លក្ខណៈ សម្បត្តិ របស់ TA រចនាប័ទ្ម ទំនាក់ទំនង ទីតាំង និង ឯកតា ការងារ ប្រើ បរិស្ថាន ណាមួយ ដែល នៅ ក្នុង កន្លែង បច្ចុប្បន្ន និង ការ បដិសេធ ដែល អាច មាន នៅ ទីនេះ ល ។ ជម្រះ ការ ពិពណ៌នា ដែល បាន ផ្ដល់ នូវ តួនាទី ដែល ត្រឹមត្រូវ និង ជាក់លាក់ ច្រើន ជាង បាន ស្ថិត@ info: whatsthis',
                        editingRoleSuccessfully: 'ការ កែសម្រួល ផ្លូវ ដោយ ជោគជ័យ',
                        roleCreatedSuccessfully: 'តួនាទី បាន បង្កើត ដោយ ជោគជ័យ',
                        failedToGetSceneDetails: 'បាន បរាជ័យ ក្នុង ការ យក សេចក្ដី លម្អិត រូបភាព',
                        createType: 'បង្កើត ប្រភេទ@ info: whatsthis',
                        accurateCreation: 'ការ បង្កើត ត្រឹមត្រូវ',
                        roleName: 'ឈ្មោះ រាង',
                        pleaseEnter: 'សូម បញ្ចូល',
                        gender: 'បិទ',
                        male: 'ប្រហែល',
                        female: 'ស្ដើម',
                        timbre: 'ត្បូង',
                        freeDescription: 'សេចក្ដី ពិពណ៌នា ទំនេរComment',
                        dialogueSimilarToYourPositionAndRoleSceneIncludingYourCharacterCommunicationStyleCoordinationAndWorkUnitFeelingsWhatProductsAreCurrentlyUsedWhatEnvironmentAreYouInAndWhatExternalCharacteristicsAreYouHavingWhatYouWantToReflectInTheDiscussionWhatYouWantToAchieveInTheDiscussionWhatIsTheSceneInTheContentAndTheCharacteristics: 'ប្រអប់ ស្រដៀង នឹង ទីតាំង និង តួអក្សរ របស់ អ្នក រួម បញ្ចូល តួអក្សរ រចនាប័ទ្ម ទំនាក់ទំនង របស់ អ្នក រចនាប័ទ្ម និង ឯកតា ការងារ អ្វី ដែល លទ្ធផល ត្រូវ បាន ប្រើ បច្ចុប្បន្ន, បរិស្ថាន ណា មួយ ដែល អ្នក នៅ ក្នុង និង លក្ខណៈ សម្បត្តិ ខាងក្រៅ ដែល អ្នក មាន ។ អ្វី ដែល អ្នក ចង់ ឆ្លើយ តប ក្នុង ការ ពិបាក និង អ្វី ដែល អ្នក ចង់ ទទួល ប្រយោជន៍ ក្នុង ការ ដោះស្រាយ បញ្ហា',
                        roleTags: 'ស្លាក រលូល',
                        remarks: 'ពាក្យ បញ្ជា',
                        cancel: 'បោះបង់',
                        save: 'រក្សាទុក',
                        create: 'បង្កើត@ info: whatsthis',
                    },
                    list: {
                        aishaNature: 'អ៊ីស (និមិត្ត)',
                        zhishachat: 'Zhisha (ជជែក)',
                        zhiqianGentle: 'ស៊ីគីយ៉ា (Gentle)',
                        knowRiceemotion: 'ស្គាល់ ឃ្លាំង',
                        aishuoNature: 'អ៊ីសូ (និមិត្ត)',
                        zhishuochat: 'Zhishuo (ជជែក)',
                        aiHaoAffinity: 'អ៊ី ហូ (Affinity)',
                        zhixiangEmotion: 'ហ្គីxiang (បង្ហាញ)',
                        roleName: 'ឈ្មោះ រាង',
                        roleGender: 'តួនាទី សំណួរ',
                        male: 'ប្រហែល',
                        female: 'ស្ដើម',
                        creationTime: 'ពេលវេលា បង្កើតComment',
                        backgroundDescription: 'សេចក្ដី ពិពណ៌នា ផ្ទៃ ខាង ក្រោយ',
                        timbreConfiguration: 'ការ កំណត់ រចនាសម្ព័ន្ធ timbreComment',
                        remarks: 'ពាក្យ បញ្ជា',
                        status: 'ស្ថានភាព',
                        operation: 'ប្រតិបត្តិការ',
                        edit: 'កែសម្រួល',
                        delete: 'លុប',
                        failedToGetList: 'បាន បរាជ័យ ក្នុង ការ យក បញ្ជី@ info: whatsthis',
                        updateStatusSuccessfully: 'ធ្វើ ឲ្យ ស្ថានភាព ទាន់សម័យ ដោយ ជោគជ័យ',
                        areYouSureYouWantToDelete: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                        cancel: 'បោះបង់',
                        deletedSuccessfully: 'បាន លុប ដោយ ជោគជ័យ',
                        pleaseEnterARoleName: 'សូម បញ្ចូល ឈ្មោះ role',
                        gender: 'បិទ',
                        pleaseSelect: 'សូម ជ្រើស',
                        pleaseEnterComments: 'សូម បញ្ចូល សេចក្ដី អធិប្បាយ',
                        reset: 'កំណត់ ឡើង វិញ',
                        filter: 'តម្រង',
                        new: 'ថ្មី',
                    },
                },
                index: {
                    newRole: 'ភាព ថ្មី',
                    editRole: 'កែសម្រួល រលា',
                    newScene: 'បន្ទាត់ ថ្មី',
                    editScene: 'កែសម្រួល រូបភាព',
                    templateManagement: 'គ្រប់គ្រង ពុម្ព',
                    roleManagement: 'គ្រប់គ្រង រលូន',
                    sceneManagement: 'គ្រប់គ្រង រូបភាព',
                },
            },
            courseEvaluation: {
                components: {
                    scoreRangeSelect: {
                        index: {
                            pleaseSelect: 'សូម ជ្រើស',
                            comprehensiveScore: 'ពិន្ទុ ពិន្ទុ',
                            courseQuality: 'គុណភាព ដក',
                            learningEffect: 'បែបផែន បង្រៀនName',
                            interactiveExperience: 'អន្តរសកម្ម',
                            greater: 'ធំ',
                            equal: 'ស្មើ',
                            less: 'តិច',
                            pleaseEnter: 'សូម បញ្ចូល',
                        },
                    },
                },
                overview: {
                    components: {
                        scoreTable: {
                            rankings: 'គំរូ',
                            courseName: 'ឈ្មោះ សំឡេង',
                            evaluationQuantity: 'តម្លៃ តម្លៃ',
                            practicePasses: 'ការ ពិពណ៌នាComment',
                        },
                        statisticsCards: {
                            numberOfPublishingTasks: 'ចំនួន ភារកិច្ច បោះពុម្ព ផ្សាយComment',
                            harvestEvaluationNumber: 'លេខ វាយតម្លៃ',
                            practicePasses: 'ការ ពិពណ៌នាComment',
                            examinations: 'ការ ពិពណ៌នា',
                        },
                        trendChart: {
                            comprehensiveScore: 'ពិន្ទុ ពិន្ទុ',
                            totalQuantityOfEvaluation: 'ចំនួន តម្លៃ សរុប',
                            addedComprehensiveEvaluationScore: 'បាន បន្ថែម ពិន្ទុ តម្លៃ បន្ថែម',
                            quantityOfNewEvaluation: 'ចំនួន តម្លៃ ថ្មី',
                            score: 'ពិន្ទុ',
                        },
                    },
                    index: {
                        failedToLoadDataPleaseTryAgain: 'បាន បរាជ័យ ក្នុង ការ ផ្ទុក ទិន្នន័យ សូម ព្យាយាម ម្ដង ទៀត',
                        evaluationOverview: 'ទិដ្ឋភាព មើល',
                        courseStatistics: 'ស្ថិតិ សំឡេង',
                        averageCourseScore: 'ពិន្ទុ មធ្យម',
                        evaluationTrendChart: 'ការ វាយតម្លៃ គំនូសតាង',
                    },
                },
                records: {
                    index: {
                        deletedSuccessfully: 'បាន លុប ដោយ ជោគជ័យ',
                        courseName: 'ឈ្មោះ សំឡេង',
                        courseType: 'ប្រភេទ សំឡេង',
                        evaluationTime: 'ពេលវេលា តម្លៃ',
                        evaluators: 'អ្នក ប្រយោជន៍',
                        operation: 'ប្រតិបត្តិការ',
                        viewDetails: 'មើល សេចក្ដី លម្អិត',
                        editCourse: 'កែសម្រួល សំឡេង',
                        confirmDelete: 'អះអាង លុប',
                        areYouSureYouWantToDeleteThisEvaluationRecord: 'តើ អ្នក ពិត ជា ចង់ លុប ថត តម្លៃ នេះ ឬ ?',
                        delete: 'លុប',
                        evaluationRecord: 'ថត តម្លៃ',
                        course: 'សំឡេង',
                        pleaseSelect: 'សូម ជ្រើស',
                        score: 'ពិន្ទុ',
                        textFeedback: 'ការ ជូន ដំណឹង អត្ថបទ',
                        all: 'ទាំង អស់',
                        yes: 'បាន',
                        no: 'គ្មាន ទេ',
                        reset: 'កំណត់ ឡើង វិញ',
                        determine: 'កំណត់@ info: whatsthis',
                    },
                },
            },
        },
        conversationAnalysis: {
            videoAnalysis: {
                detail: {
                    components: {
                        dialogue: {
                            index: {
                                keywordSearch: 'ស្វែងរក ពាក្យ គន្លឹះ',
                                previous: 'មុន',
                                next: 'បន្ទាប់',
                                theObjectThatTriggersTheScrollingEventIs: 'វត្ថុ ដែល កេះ ព្រឹត្តិការណ៍ រមូល',
                                userScrolling: 'រមូរ អ្នក ប្រើ',
                            },
                        },
                        summary: {
                            index: {
                                reminder: 'កម្មវិធី រំលឹក ៖',
                                edit: 'កែសម្រួល',
                                name: 'ឈ្មោះ:',
                                hintLanguage: 'សួរ',
                            },
                        },
                        viewpoint: {
                            index: {
                                viewpointExtraction: 'ស្រង់ ចំណុច ទិដ្ឋភាព',
                            },
                        },
                        outline: {
                            index: {
                                numberOfKeywords: 'ចំនួន ពាក្យ គន្លឹះ',
                                speaker: 'អ្នក និយាយComment',
                                speechDuration: 'ថិរវេលា ការ និយាយComment',
                                proportionOfSpeaking: 'ការ និយាយ សមាមាត្រ',
                                maximumSpeechDuration: 'ប្រវែង អតិបរមា',
                                numberOfQuestions: 'ចំនួន សំណួរ',
                                averageSpeechSpeed: 'ល្បឿន មធ្យម',
                                conversationalActions: 'សកម្មភាព សម័យ',
                                contentSummary: 'សង្ខេប មាតិកា',
                                generateSummary: 'បង្កើត សង្ខេប',
                                keywordCloud: 'ពាក្យ គន្លឹះ ពពក',
                            },
                        },
                    },
                    index: {
                        outline: 'សង្ខេប',
                        viewpoint: 'ជម្រើស',
                        contentSummary: 'សង្ខេប មាតិកា',
                        viewpointExtraction: 'ស្រង់ ចំណុច ទិដ្ឋភាព',
                        summaryOfKeyPoints: 'សង្ខេប នៃ ចំណុច សោ',
                        videoAnalysis: 'វិភាគ វីដេអូ',
                    },
                },
                list: {
                    index: {
                        delete: 'លុប',
                        uploadSuccessful: 'ផ្ទុក ឡើង ជោគជ័យ',
                        videoList: 'បញ្ជី វីដេអូ',
                        uploadVideo: 'ផ្ទុក វីដេអូ ឡើង លើ',
                        videoName: 'ឈ្មោះ វីដេអូ',
                        uploadTime: 'ពេលវេលា ផ្ទុក ឡើង',
                        endTime: 'ពេលវេលា បញ្ចប់',
                        analyzeProgress: 'វិភាគ វឌ្ឍនភាព',
                        haveInHand: 'កំពុង វឌ្ឍន៍',
                        completed: 'បាន បញ្ចប់',
                        fail: 'បាន បរាជ័យ',
                        toBegin: 'ដើម្បី ចាប់ផ្ដើម',
                        operation: 'ប្រតិបត្តិការ',
                        see: 'ទិដ្ឋភាព',
                    },
                },
            },
            productManage: {
                components: {
                    acousticData: {
                        components: {
                            template: {
                                index: {
                                    operationSuccessful: 'ប្រតិបត្តិការ បាន ជោគជ័យ',
                                    operator: 'កម្មវិធី',
                                    rules: 'បន្ទាត់',
                                    preserve: 'រក្សាទុក',
                                    cancel: 'បោះបង់',
                                },
                            },
                        },
                        index: {
                            questionnaire: 'កម្រិត សំណួរ',
                            voiceCall: 'ហៅ សំឡេង',
                            textDialogue: 'ប្រអប់ អត្ថបទ',
                            workOrder: 'លំដាប់ ការងារ',
                            videoCall: 'ហៅ វីដេអូ',
                            enterpriseMicroData: 'ទិន្នន័យ មីក្រូ',
                            socialMediaComments: 'សេចក្តី អធិប្បាយ មេឌៀ',
                            applicationComments: 'សេចក្តី អធិប្បាយ កម្មវិធី',
                            associatesAcousticData: 'ភ្ជាប់ ទិន្នន័យ អូគី',
                        },
                    },
                    baseInfo: {
                        index: {
                            saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                            basicInformation: 'ព័ត៌មាន មូលដ្ឋាន',
                            productName: 'ឈ្មោះ លុប',
                            productDescription: 'សេចក្ដី ពិពណ៌នា ផលិត ៖',
                            productPicture: 'រូបភាព លុប',
                            preserve: 'រក្សាទុក',
                            nextStep: 'ជំហាន បន្ទាប់',
                        },
                    },
                    subProduct: {
                        components: {
                            unrelatedProducts: {
                                index: {
                                    pleaseSelectProductData: 'សូម ជ្រើស ទិន្នន័យ ធាតុ',
                                },
                            },
                        },
                        index: {
                            associateSubproducts: 'ភ្ជាប់ ផលិត រង',
                            associationSuccess: 'ជោគជ័យ ទំនាក់ទំនង',
                            operationSuccessful: 'ប្រតិបត្តិការ បាន ជោគជ័យ',
                            productPicture: 'រូបភាព លុប',
                            productID: 'លេខ សម្គាល់ លុប',
                            productTitle: 'ចំណង ជើង លុប',
                            ecommercePlatform: 'វេទិកា E- Comment',
                            price: 'តម្លៃ',
                            sales: 'ល្អ',
                            numberOfComments: 'ចំនួន សេចក្តី អធិប្បាយ',
                            areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                            remove: 'យក ចេញ',
                            productManagement: 'គ្រប់គ្រង លទ្ធផលName',
                            productData: 'ទិន្នន័យ ផលិត ៖',
                        },
                    },
                },
                detail: {
                    index: {
                        productManagement: 'គ្រប់គ្រង លទ្ធផលName',
                        basicInformation: 'ព័ត៌មាន មូលដ្ឋាន',
                        associateSubproducts: 'ភ្ជាប់ ផលិត រង',
                        associatesAcousticData: 'ភ្ជាប់ ទិន្នន័យ អូគី',
                        newProduct: 'ផលិត ថ្មី',
                    },
                },
                list: {
                    components: {
                        checkReportButton: {
                            index: {
                                productStatistics: 'ស្ថិតិ បង្ហាញ',
                                productInsights: 'សិទ្ធិ វិទ្យុ',
                                userInsights: 'Insights របស់ អ្នក ប្រើ',
                                viewReport: 'មើល របាយការណ៍Comment',
                            },
                        },
                    },
                    index: {
                        pleaseEnterAKeyword: 'សូម បញ្ចូល ពាក្យ គន្លឹះ',
                        productPicture: 'រូបភាព លុប',
                        productName: 'ឈ្មោះ លុប',
                        productDescription: 'សេចក្ដី ពិពណ៌នា ផលិត ៖',
                        creationTime: 'ពេលវេលា បង្កើតComment',
                        updateTime: 'ពេលវេលា ទាន់ សម័យ',
                        ecommercePlatform: 'វេទិកា E- Comment',
                        numberOfSubproducts: 'ចំនួន ធនធាន រង',
                        edit: 'កែសម្រួល',
                        areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                        delete: 'លុប',
                        productManagement: 'គ្រប់គ្រង លទ្ធផលName',
                        newProduct: 'ផលិត ថ្មី',
                    },
                },
            },
            productDetail: {
                list: {
                    index: {
                        ecommercePlatform: 'វេទិកា E- Comment',
                        productTitle: 'ចំណង ជើង លុប',
                        productPicture: 'រូបភាព លុប',
                        productID: 'លេខ សម្គាល់ លុប',
                        price: 'តម្លៃ',
                        sales: 'ល្អ',
                        numberOfComments: 'ចំនួន សេចក្តី អធិប្បាយ',
                        associationStatus: 'ស្ថានភាព ទំនាក់ទំនង',
                        associated: 'បាន ទាក់ទង',
                        notAssociated: 'មិន ទាក់ទង',
                        associatedMainProduct: 'ផលិត មេ ដែល ទាក់ទង',
                        viewDetails: 'មើល សេចក្ដី លម្អិត',
                        productDetails: 'សេចក្ដី លម្អិត លម្អិត',
                    },
                },
            },
            dashboard: {
                index: {
                    recentDataTrendStatistics: 'ស្ថិតិ ទិន្នន័យ ថ្មីៗ',
                    nearlyDays: 'មាន ថ្ងៃ',
                },
                components: {
                    balanceCard: {
                        index: {
                            millionHours: 'ម៉ោង ។',
                            hours: 'ម៉ោង',
                        },
                    },
                },
            },
            dataIntegration: {
                dataIntegration: 'ការ បញ្ចូល ទិន្នន័យ',
            },
            planManage: {
                automaticTriggerMessage: {
                    index: {
                        saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                        autoTriggerMessage: 'សារ កេះ ស្វ័យ ប្រវត្តិ',
                        automaticPush: 'ចុច ស្វ័យ ប្រវត្តិ',
                        newPush: 'ចុច ថ្មី',
                        push: 'ចុច កណ្ដុរ',
                        preserve: 'រក្សាទុក',
                    },
                },
                index: {
                    autoTriggerMessage: 'សារ កេះ ស្វ័យ ប្រវត្តិ',
                    planManagement: 'ការ គ្រប់គ្រង គ្រោងការណ៍',
                },
            },
        },
        businessWorkingHours: {
            components: {
                businessWorkingHoursSetting: {
                    index: {
                        addWorkingHours: 'បន្ថែម ពេលវេលា ការងារ',
                    },
                },
            },
            index: {
                businessWorkingHours: 'ម៉ោង ការងារ រហ័ស',
                newlyBuild: 'ថ្មី',
                name: 'ឈ្មោះ:',
                describe: 'សេចក្ដី ពិពណ៌នា',
                operation: 'ប្រតិបត្តិការ',
                edit: 'កែសម្រួល',
                delete: 'លុប',
                editBusinessWorkingHours: 'កែសម្រួល ម៉ោង ការងារ',
                newBusinessWorkingHours: 'ម៉ោង ការងារ កម្មវិធី',
                workingHours: 'ពេលវេលា ការងារ',
            },
        },
        algorithmSemanticIntelligence: {
            intelligentExtraction: 'ស្រង់ ចេញ',
        },
        taskCenter: {
            downloadList: {
                component: {
                    areYouSureYouWantToCancelAfterCancellationItCannotBeRestoredAgain: 'តើ អ្នក ពិត ជា ចង់ បោះបង់ ឬ ? បោះបង់',
                },
            },
            taskList: {
                template: {
                    plannedAnalysisQuantity: 'មាតិកា ដែល បាន វិភាគ រយ',
                    actualAnalysisQuantity: 'ចំនួន ការ វិភាគ ពិតComment',
                    numberOfTokensConsumed: 'ចំនួន គំរូ ដែល បាន រុករក',
                },
            },
        },
        accountManagement: {
            securitySetting: 'ការ កំណត់ សុវត្ថិភាព',
            accountManagement: 'គ្រប់គ្រង គណនី',
        },
        securitySettings: {
            components: {
                iPInput: {
                    index: {
                        to: 'ទៅ',
                        switchToIPAddressMode: 'ប្ដូរ ទៅ របៀប អាសយដ្ឋាន IP',
                        switchToIPSegmentMode: 'ប្ដូរ ទៅ របៀប ចម្រៀក IP',
                    },
                },
                verificationConfig: {
                    index: {
                        afterTheTwostepVerificationIsTurnedOnEmployeesWhosePhoneNumbersAreNotFilledInAndWhosePhoneNumbersAreIncorrectlyFilledInWillNotBeAbleToLogInToTheSystemInCaseOfFailureToLogInPleaseContactTheAdministratorToModifyTheNormalPhoneNumberForTheEmployeesAccount: 'បន្ទាប់ ពី ការ ផ្ទៀងផ្ទាត់ ជំហាន ពីរ ត្រូវ បាន បើក អ្នក ប្រើ ដែល មិន បាន បំពេញ លេខ ទូរស័ព្ទ និង លេខ ទូរស័ព្ទ ដែល មិន ត្រឹមត្រូវ នឹង មិន អាច ចូល ទៅ បាន ប្រព័ន្ធ ។ ក្នុង ករណី ដែល បរាជ័យ ក្នុង ការ ចូល សូម ទាក់ទង អ្នក គ្រប់គ្រង ដើម្បី កែប្រែ លេខ ទូរស័ព្ទ ធម្មតា សម្រាប់ គណនី របស់ អ្នក ភ្ញៀវ ។',
                        afterTheTwostepVerificationIsEnabledTheEmployeeAccountWhoseMobilePhoneNumberIsNotFilledInOrWhoseMobilePhoneNumberIsIncorrectlyFilledInWillNotBeAbleToLogInToTheSystemInCaseOfFailureToLogInPleaseContactTheAdministratorToModifyTheNormalPhoneNumberForTheEmployeeAccount: 'បន្ទាប់ ពី បាន អនុញ្ញាត ការ ផ្ទៀងផ្ទាត់ ជំហាន ពីរ គណនី របស់ អ្នក ដែល លេខ ទូរស័ព្ទ ចល័ត របស់ វា មិន ត្រូវ បាន បំពេញ ឬ លេខ ទូរស័ព្ទ ចល័ត របស់ វា ត្រូវ បាន បំពេញ មិន ត្រឹមត្រូវ នឹង មិន អាច ធ្វើ បាន ទេ ។ ចូល ទៅ ប្រព័ន្ធ ។ ក្នុង ករណី ដែល បរាជ័យ ក្នុង ការ ចូល សូម ទាក់ទង អ្នក គ្រប់គ្រង ដើម្បី កែប្រែ លេខ ទូរស័ព្ទ ធម្មតា សម្រាប់ គណនី របស់ អ្នក ។',
                        afterTheTwostepVerificationIsTurnedOnEmployeesWhoDoNotFillInTheMobilePhoneNumberOrFillInTheWrongMobilePhoneNumberWillNotBeAbleToLogInToTheSystemInCaseOfFailureToLogInPleaseContactTheAdministratorToCorrectTheNormalPhoneNumberForTheEmployeeAccount: 'បន្ទាប់ ពី ការ ផ្ទៀងផ្ទាត់ ជំហាន ពីរ ត្រូវ បាន បើក អ្នក ប្រើ ដែល មិន បំពេញ លេខ ទូរស័ព្ទ ចល័ត ឬ បំពេញ លេខ ទូរស័ព្ទ ខុស គ្នា នឹង មិន អាច ចូល ទៅ ប្រព័ន្ធ ។ ក្នុង ករណី ដែល បរាជ័យ ក្នុង ការ ចូល សូម ទាក់ទង អ្នក គ្រប់គ្រង ដើម្បី កែ លេខ ទូរស័ព្ទ សម្រាប់ គណនី របស់ អ្នក ។',
                        login: 'ចូលComment',
                        attention: 'ការ ឆ្លើយតប',
                        saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                        twostepVerification: 'ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ',
                        landing: 'ការ បណ្ដាល់',
                        preserve: 'រក្សាទុក',
                    },
                },
            },
            index: {
                employeeLoginIPAddressRestrictions: 'ការ ដាក់ កម្រិត អាសយដ្ឋាន IP ការ ចូល ចំណុច',
                limitTheIPRangeThatEmployeesCanLogInToLoginIsNotAllowedIfTheIPRangeIsExceededOnlyValidForWebsitesMobileAppsAreNotRestrictedAndAdministratorsAreNotRestricted: 'កំណត់ ជួរ IP ដែល អ្នក ប្រើ អាច ចូល ទៅ ។ ការ ចូល មិន ត្រូវ បាន អនុញ្ញាត ប្រសិន បើ អាសយដ្ឋាន IP លើស ជួរ ទេ ។ មាន តែ ត្រឹមត្រូវ សម្រាប់ តំបន់ បណ្ដាញ កម្មវិធី ចល័ត មិន ត្រូវ បាន កម្រិត ទេ ហើយ អ្នក គ្រប់គ្រង មិន ត្រូវ បាន ដែន ។',
                iPRangeAllowedForLogin: 'ជួរ IP ត្រូវ បាន អនុញ្ញាត ឲ្យ ចូលName',
                saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                pleaseImproveTheConfiguration: 'សូម កំណត់ រចនា សម្ព័ន្ធ',
                securitySetting: 'ការ កំណត់ សុវត្ថិភាព',
                employeeLoginIPRestrictions: 'ការ ដាក់ កម្រិត IP ការ ចូល ដំណើរការ',
                restrictTheIPRangeThatEmployeesCanLogInToAndProhibitLoggingInBeyondTheRangeOnlyEffectiveForWebsitesMobileAppsAreNotRestrictedAndAdministratorsAreNotRestricted: 'កំណត់ ជួរ IP ដែល អ្នក ប្រើ អាច ចូល ទៅ ។ ការ ចូល មិន ត្រូវ បាន អនុញ្ញាត ពី ក្រៅ ជួរ ទេ ។ មាន តែ ត្រឹមត្រូវ សម្រាប់ តំបន់ បណ្ដាញ កម្មវិធី ចល័ត មិន ត្រូវ បាន កម្រិត ទេ ហើយ អ្នក គ្រប់គ្រង មិន ត្រូវ បាន ដែន ។',
                whenAddingOrModifyingPleaseFillInTheExternalIPSegmentsameCSegmentOrAFixedExternalIPAddress: 'នៅពេល បន្ថែម ឬ កែប្រែ សូម បញ្ចូល ចម្រៀក IP បណ្ដាញ ខាងក្រៅ (ចម្រៀក C ដូចគ្នា) ឬ អាសយដ្ឋាន IP បណ្ដាញ ខាងក្រៅ ថេរ ។',
                allowLoginIPRange: 'ជួរ IP ត្រូវ បាន អនុញ្ញាត ឲ្យ ចូលName',
                preserve: 'រក្សាទុក',
            },
        },
        coachAdminEntry: {
            webPlugin: 'កម្មវិធី ជំនួយ បណ្ដាញ',
            speechRecognition: 'ការ ទទួល ស្គាល់ និយាយComment',
        },
        billingCenter: {
            template: {
                details: 'សេចក្ដី លម្អិត',
                languageType: 'ប្រភេទ ភាសា',
                aSREngine: 'ម៉ាស៊ីន ASR',
                voiceQualityQuota: 'កម្រិត សំឡេង',
                realtimeData: 'ទិន្នន័យ ពេលវេលា ពិតComment',
                calculatedByDay: 'បាន គណនា តាម ថ្ងៃ@ info: whatsthis',
            },
            component: {
                aSRName: 'ឈ្មោះ ASR',
                language: 'ភាសាComment',
                remainingQuota: 'កូតា ដែល នៅស់',
                hours: 'ម៉ោង',
                usedQuota: 'បានប្រើ',
            },
        },
        speechRecognition: {
            component: {
                saveSuccessfully: 'រក្សាទុក ដោយ ជោគជ័យ',
                saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                minimumNumberOfSpeakersCannotBeGreaterThanMaximumNumber: 'ចំនួន និយាយ អប្បបរមា មិន អាច ធំ ជាង លេខ អតិបរមា',
                theNumberOfAgentsCannotBeGreaterThanTheMaximumNumberOfSpeakers: 'ចំនួន ភ្នាក់ងារ មិន អាច ធំ ជាង ចំនួន អតិបរមា របស់ អ្នក និយាយ ឡើយ',
                pleaseImproveTheConfiguration: 'សូម កំណត់ រចនា សម្ព័ន្ធ',
                operationSavedSuccessfully: 'ប្រតិបត្តិការ បាន រក្សាទុក ដោយ ជោគជ័យ !',
                deletedSuccessfully: 'បាន លុប ដោយ ជោគជ័យ !',
                pleaseSelectLanguage: 'សូម ជ្រើស ភាសា មួយ',
                pleaseConfigureRules: 'សូម កំណត់ រចនា សម្ព័ន្ធ',
                updateSuccessful: 'ធ្វើ ឲ្យ ទាន់សម័យ បាន ជោគជ័យ !',
                operationSuccessful: 'ប្រតិបត្តិការ បាន ជោគជ័យ !',
            },
            template: {
                mixedIdentification: 'អត្តសញ្ញាណ លាយ',
                whenEnabledMultilingualMixedTranscriptionIsAvailable: 'នៅពេល ដែល បាន អនុញ្ញាត ការ បម្រុង ទុក គំរូ ច្រើន អាច ប្រើ បានName',
                nonmanualFiltering: 'តម្រង មិនមែន ជា មួយ',
                whenEnabledOnlyTranscribeManualCalls: 'នៅពេល ដែល បាន អនុញ្ញាត តែ បម្លែង ការ ហៅ ដៃ',
                speakerIdentification: 'អត្តសញ្ញាណ កម្មវិធី និយាយComment',
                aSRLanguage: 'ភាសា ASR',
                pleaseSelect: 'សូម ជ្រើស',
                model: 'ម៉ូល',
                pleaseSelectLanguage: 'សូម ជ្រើស ភាសា មួយ',
                delete: 'លុប',
                newASRModel: 'ម៉ូដែល ASR ថ្មី',
            },
            components: {
                aSRFilterMethod: {
                    components: {
                        sampleUpperLimit: {
                            index: {
                                daily: 'ថ្ងៃថែម',
                                weekly: 'សប្ដាហ៍',
                                pleaseSelectAPeriod: 'សូម ជ្រើស រយៈពេល មួយ',
                                byQuantity: 'តាម សំឡេង',
                                longOnTime: 'វែង',
                                noUpperLimit: 'គ្មាន ដែន កំណត់ ខ្ពស់',
                                pleaseSelectACalculationDimension: 'សូម ជ្រើស វិធីសាស្ត្រ គណនា',
                                pleaseEnter: 'សូម បញ្ចូល',
                                hours: 'ម៉ោង',
                            },
                        },
                    },
                    index: {
                        filteringMethod: 'វិធីសាស្ត្រ តម្រង ៖',
                        allEligibleCallsPerformASR: 'អនុញ្ញាត ASR',
                        performASRForEligiblePartialCalls: 'អនុញ្ញាត ASR សម្រាប់ ការ ហៅ ផ្នែក ដែល អាច ទាក់ទង',
                        samplingRatio: 'សមាមាត្រ គំរូ ៖',
                        upperSamplingLimit: 'ដែន កំណត់ គំរូ ខ្ពស់ ៖',
                    },
                },
                aSRFilterStatus: {
                    index: {
                        drawLimitNotReached: 'គូរ ដែន កំណត់ មិន បាន ដល់ ទេ',
                        drawLimitReached: 'គូរ ដែន កំណត់ ដែល បាន ដល់ ទេ',
                    },
                },
                speakerRecognition: {
                    index: {
                        toAccessAThirdpartyCallRecordingThroughAPIItIsNecessaryToIdentifyWhetherTheLeftChannelIsACustomerServiceOrACustomer: 'ដើម្បី ចូល ដំណើរការ ការ ថត ហៅ ភាគ ទីបី តាម API ។ វា ត្រូវ ការ កំណត់ ថាតើ ឆានែល ខាង ឆ្វេង ជា សេវា របស់ ភ្ញៀវ ឬ អ្នក ភ្ញៀវ ។',
                        singlechannelRecordingDefinesTheRoleOfTheAgentThroughTextRecognitionAndRoleConfiguration: 'ការ ថត ឆានែល តែ មួយ កំណត់ តួនាទី របស់ ភ្នាក់ងារ តាមរយៈ ការ ស្គាល់ អត្ថបទ និង ការ កំណត់ រចនា សម្ព័ន្ធ តួអក្សរ ។',
                        aPIIdentifiesTrackRole: 'អត្តសញ្ញាណ ផ្លូវ បទ API',
                        textRecognition: 'ការ ស្គាល់ អត្ថបទ',
                        minimumNumberOfSpeakers: 'ចំនួន អ្នក និយាយ អប្បបរមា',
                        maximumNumberOfSpeakers: 'ចំនួន អ្នក និយាយ អតិបរមា',
                        numberOfCustomerService: 'ចំនួន សេវា ម៉ាស៊ីន ភ្ញៀវ',
                        operator: 'ប្រតិបត្តិការ ៖',
                        rules: 'ច្បាប់ ៖',
                        preserve: 'រក្សាទុក',
                    },
                },
            },
        },
        dataAnalysis: {
            customerServiceResults: 'លទ្ធផល សេវា ម៉ាស៊ីន ភ្ញៀវ',
            qualityInspectionOverviewReport: 'របាយការណ៍ ទូទៅ មើល គុណភាព',
            competitiveProductAnalysis: {
                index: {
                    competitionAnalysis: 'ការ វិភាគ រចនាសម្ព័ន្ធ',
                },
            },
            generalInspectionReport: {
                component: {
                    ecommerceTextSession: 'សម័យ អត្ថបទ E- commerce',
                    workOrder: 'លំដាប់ ការងារ',
                    all: 'ទាំង អស់',
                    questionnaire: 'កម្រិត សំណួរ',
                },
                template: {
                    customerService: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    totalEcommerceSessions: 'សម័យ អ៊ីមែល សរុប',
                    totalWorkOrder: 'លំដាប់ ការងារ សរុប',
                    totalQuestionnaire: 'ថ្នាក់ សរុប',
                },
            },
            productInsight: {
                index: {
                    productInsights: 'សិទ្ធិ វិទ្យុ',
                },
            },
            productStatistics: {
                index: {
                    productStatistics: 'ស្ថិតិ បង្ហាញ',
                },
            },
            statisticalProfile: {
                index: {
                    statisticalOverview: 'មើល ទូទៅ ស្ថិតិ',
                },
            },
            userInsight: {
                index: {
                    userInsights: 'Insights របស់ អ្នក ប្រើ',
                },
            },
            socialMediaSentiment: {
                index: {
                    socialMediaPublicOpinion: 'មេឌៀ សាធារណៈ សាធារណៈ',
                },
            },
            qualityInspectionOverview: {
                index: {
                    qualityInspectionOverviewReport: 'របាយការណ៍ ទូទៅ មើល គុណភាព',
                },
            },
            customerServiceScore: {
                index: {
                    customerServiceResults: 'លទ្ធផល សេវា ម៉ាស៊ីន ភ្ញៀវ',
                },
            },
        },
        eCommentManage: {
            template: {
                ecommerceReviewFilter: 'តម្រង មើល E- Comment',
                allComments: 'សេចក្ដី អធិប្បាយ ទាំងអស់',
                ecommerceReviewManagement: 'ការ គ្រប់គ្រង ការ ត្រួតពិនិត្យ E-commerce',
            },
            detail: {
                template: {
                    ecommerceReviewManagement: 'ការ គ្រប់គ្រង ការ ត្រួតពិនិត្យ E-commerce',
                    detailsOfEcommerceComments: 'សេចក្ដី លម្អិត នៃ សេចក្ដី អធិប្បាយ e-commerce',
                },
            },
        },
        mCommentManage: {
            template: {
                socialMediaReviewFilter: 'តម្រង មើល មេឌៀ សាធារណៈ',
                allComments: 'សេចក្ដី អធិប្បាយ ទាំងអស់',
                socialMediaReviewManagement: 'គ្រប់គ្រង មេឌៀ សំឡេង',
            },
            detail: {
                template: {
                    socialMediaReviewManagement: 'គ្រប់គ្រង មេឌៀ សំឡេង',
                    detailsOfSocialMediaComments: 'សេចក្ដី លម្អិត នៃ សេចក្ដី អធិប្បាយ មេឌៀ សំឡេង',
                },
            },
        },
        conversationAnalysisDataAnalysis: {
            statisticalOverview: 'មើល ទូទៅ ស្ថិតិ',
            publicOpinionAnalysis: 'ការ វិភាគ កម្រិត សាធារណៈ',
            userInsights: 'Insights របស់ អ្នក ប្រើ',
            productInsights: 'សិទ្ធិ វិទ្យុ',
            productStatistics: 'ស្ថិតិ បង្ហាញ',
            socialMediaPublicOpinion: 'មេឌៀ សាធារណៈ សាធារណៈ',
            dataAnalysis: 'ការ វិភាគ ទិន្នន័យ',
            competitionAnalysis: 'ការ វិភាគ រចនាសម្ព័ន្ធ',
        },
        videoCallManage: {
            template: {
                videoCallFilters: 'តម្រង ហៅ វីដេអូName',
                videoCallManagement: 'គ្រប់គ្រង ការ ហៅ វីដេអូ',
                videoCallFilter: 'តម្រង ហៅ វីដេអូ',
            },
        },
        qaLanguageSetting: {
            template: {
                ecommerceTextDialogue: 'ប្រអប់ អត្ថបទ អ៊ីមែល',
                flyingBookGroupChat: 'ជជែក ក្រុម សៀវភៅ',
                translation: 'ការ បក ប្រែ',
                questionnaire: 'កម្រិត សំណួរ',
                voiceCall: 'ហៅ សំឡេង',
                textDialogue: 'ប្រអប់ អត្ថបទ',
                workOrder: 'លំដាប់ ការងារ',
                videoCall: 'ហៅ វីដេអូ',
                enterpriseWeChatConversation: 'សម័យ micro-section Enterprise',
                enterpriseMicroVoice: 'សំឡេង',
                ecommerceReviewData: 'ទិន្នន័យ មើល E-commerce',
                socialMediaReviewData: 'ទិន្នន័យ មើល មេឌៀ សាធារណៈ',
                qualityInspectionLanguageSettings: 'ការ កំណត់ ភាសា ត្រួត ពិនិត្យ គុណភាព',
                index: {
                    defaultASRModel: 'ម៉ូដែល ASR លំនាំដើម',
                    pleaseSelectASecondaryLanguage: 'សូម ជ្រើស ភាសា រង',
                    languageAdaptive: 'កែប្រែ ភាសា',
                    whenEnabledYouCanSetMultipleTranscriptionLanguagesForAVoiceTheModelAutomaticallyRecognizesAndSelectsALanguageForTranscriptionLanguageAdaptationOnlyTakesEffectWhenUsingGoogleMicrosoftAndAliParaformervOtherASREnginesDoNotTakeEffect: 'នៅពេល ដែល បាន បើក អ្នក អាច កំណត់ ភាសា ការ បដិសេធ ច្រើន សម្រាប់ សំឡេង ។ ម៉ូដែល ស្គាល់ និង ជ្រើស ភាសា សម្រាប់ ការ បម្លែង ដោយ ស្វ័យ ប្រវត្តិ ។ ការ ផ្លូវ ភាសា តែ មាន ប្រសិទ្ធភាព នៅ ពេល ប្រើ Google Microsoft និង Ali paraformer-v2 ម៉ាស៊ីន ASR ផ្សេងទៀត មិន មាន ប្រសិទ្ធភាព ។',
                    defaultPrimaryLanguage: 'ភាសា ចម្បង លំនាំដើម',
                    defaultSublanguage: 'ភាសា រង លំនាំដើម',
                    saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                    deleteSuccessful: 'បាន លុប ដោយ ជោគជ័យ',
                    modificationSucceeded: 'ការ កែប្រែ បាន ជោគជ័យ',
                    areYouSureToDeleteIt: 'តើ អ្នក ពិត ជា ចង់ លុប ឬ ?',
                    defaultLanguage: 'ភាសា លំនាំដើម',
                    multilanguageSettings: 'ការ កំណត់ ភាសា ច្រើន',
                    specifyDifferentLanguagesForDifferentData: 'បញ្ជាក់ ភាសា ផ្សេងៗ សម្រាប់ ទិន្នន័យ ផ្សេង',
                },
            },
            translate: {
                template: {
                    components: {
                        rules: {
                            components: {
                                item: {
                                    index: {
                                        sourceLanguage: 'ភាសា ប្រភព',
                                        targetLanguage: 'ភាសា គោលដៅ',
                                    },
                                },
                            },
                            index: {
                                setTheCorrespondenceBetweenTheSourceLanguageAndTheTargetLanguagePleaseSetTheTranslationRulesAfterTheQualityInspectionLanguageIsSet: 'កំណត់ សំណួរ រវាង ភាសា ប្រភព និង ភាសា គោលដៅ ។ សូម កំណត់ ច្បាប់ ការ បកប្រែ បន្ទាប់ ពី កំណត់ ភាសា ត្រួតពិនិត្យ គុណភាព ។',
                                newTranslationRule: 'ច្បាប់ បកប្រែ ថ្មី',
                            },
                        },
                    },
                    index: {
                        translationOfTerms: 'ការ បកប្រែ ពាក្យ',
                        availableInSemanticIntelligenceSetTheTranslationTermInTheSmartThesaurusWhenEnabledTheSpecifiedWordsInTheTranscriptionResultCanBeTranslatedIntoProfessionalTerms: 'មាន ក្នុង សញ្ញា សម្ងាត់ -\nកំណត់ ពាក្យ ការ បកប្រែ ក្នុង សញ្ញា សម្រាក ។ នៅ ពេល បាន បើក ពាក្យ ដែល បាន បញ្ជាក់ នៅ ក្នុង លទ្ធផល បដិសេធ អាច ត្រូវ បាន បកប្រែ ទៅ កាន់ ពាក្យ វិនិច្ឆ័យ ។',
                        saveSuccessful: 'រក្សាទុក ដោយ ជោគជ័យ',
                        onState: 'នៅ សត្វ',
                        translateTheSourceLanguageDataIntoTheTargetLanguageAndThenPerformQualityInspectionAndSmartLabel: 'បកប្រែ ទិន្នន័យ ភាសា ប្រភព ទៅកាន់ ភាសា គោលដៅ ហើយ បន្ទាប់ មក អនុវត្ត ការ ត្រួត ពិនិត្យ គុណភាព និង ស្លាក ត្រឹមត្រូវ ។',
                        dataSourceType: 'ប្រភេទ ប្រភព ទិន្នន័យ',
                        translationRules: 'ច្បាប់ បក ប្រែ',
                        preserve: 'រក្សាទុក',
                    },
                },
            },
        },
        systemIntegration: {
            zendesk: {
                components: {
                    chat: {
                        index: {
                            authorizationSucceeded: 'ការ ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ បាន ជោគជ័យ',
                            cancelAuthorizationSuccessfully: 'បោះបង់ ការ អនុញ្ញាត ដោយ ជោគជ័យ',
                            clientID: 'លេខ សម្គាល់ ម៉ាស៊ីន ភ្ញៀវ',
                            clientKey: 'គ្រាប់ ចុច ម៉ាស៊ីន ភ្ញៀវ',
                            redirectURL: 'ប្ដូរ ទិស URL',
                        },
                    },
                    ticket: {
                        index: {
                            authorizationSucceeded: 'ការ ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ បាន ជោគជ័យ',
                            cancelAuthorizationSuccessfully: 'បោះបង់ ការ អនុញ្ញាត ដោយ ជោគជ័យ',
                        },
                    },
                },
            },
            kcsDocking: {
                index: {
                    interfaceURL: 'URL ចំណុច ប្រទាក់',
                    publicKey: 'សោ សាធារណៈ',
                    privateKey: 'គ្រាប់ ចុច ឯកជន',
                },
            },
            feishu: {
                index: {
                    cancel: 'បោះបង់',
                    preserve: 'រក្សាទុក',
                },
            },
            template: {
                largeModel: 'ម៉ូដែល ធំ',
                jingdong: 'ហ្គីងដូនgreat- britain_ counties. kgm',
                flyingBook: 'សៀវភៅ បង្ហាញ',
                voiceRobot: 'រ៉ូប៊ី សំឡេង',
            },
            voiceRobot: {
                index: {
                    domainName: 'ឈ្មោះ ដែន',
                    administratorMailbox: 'ប្រអប់ សំបុត្រ របស់ អ្នក គ្រប់គ្រងComment',
                    tenantAppid: 'បាន អនុញ្ញាត',
                    tenantSecrect: 'ចំណុច សម្ងាត់',
                },
            },
            integrationLLM: {
                index: {
                    intelligentModel: 'ម៉ូឌុល ខ្លាំង',
                    smartLabel: 'ស្លាក ឆ្លាត',
                    businessSummary: 'សង្ខេប ពាក្យ',
                    problemExtraction: 'ស្រង់ បញ្ហា',
                    intelligentExtraction: 'ស្រង់ ចេញ',
                    semanticLabel: 'ស្លាក semantic',
                    translation: 'ការ បក ប្រែ',
                    pictureUnderstanding: 'ការ យល់ រូបភាព',
                    audioUnderstanding: 'ការ យល់ អូឌីយ៉ូ',
                    videoUnderstanding: 'ការ យល់ វីដេអូ',
                    saveSuccessfully: 'រក្សាទុក ដោយ ជោគជ័យ',
                    pleaseSelectAModel: 'សូម ជ្រើស ម៉ូឌុល',
                    save: 'រក្សាទុក',
                    modelLevelChangedTip: 'កម្រិតម៉ូដែលបានផ្លាស់ប្តូរ។ ថ្លៃសេវានឹងត្រូវគណនាតាមម៉ូដែលថ្មី។',
                },
            },
            jdShop: {
                components: {
                    configForm: {
                        index: {
                            newStore: 'ផ្ទុក ថ្មី',
                            editBasicInformation: 'កែសម្រួល ព័ត៌មាន មូលដ្ឋាន',
                            saveSuccessfully: 'រក្សាទុក ដោយ ជោគជ័យ',
                            save: 'រក្សាទុក',
                            shopName: 'ឈ្មោះ shop',
                            pleaseEnter: 'សូម បញ្ចូល',
                            merchantID: 'លេខ សម្គាល់ បញ្ជី',
                            accountNumber: 'លេខ គណនី',
                        },
                    },
                },
                hooks: {
                    index: {
                        authorizationSucceeded: 'ការ ផ្ទៀងផ្ទាត់ ភាព ត្រឹមត្រូវ បាន ជោគជ័យ',
                    },
                },
                index: {
                    accountNumber: 'លេខ គណនី',
                    shopName: 'ឈ្មោះ shop',
                    merchantID: 'លេខ សម្គាល់ បញ្ជី',
                    status: 'ស្ថានភាព',
                    authorized: 'បាន អនុញ្ញាត',
                    subscriptionExpiration: 'ការ ផុតកំណត់',
                    unauthorized: 'មិន បាន អនុញ្ញាត',
                    creationTime: 'ពេលវេលា បង្កើតComment',
                    editBasicInformation: 'កែសម្រួល ព័ត៌មាន មូលដ្ឋាន',
                    reauthorization: 'ការ អនុញ្ញាត ឡើង វិញ',
                    authorization: 'ការ អនុញ្ញាត',
                    confirmDeletion: 'អះអាង ការ លុប ?',
                    delete: 'លុប',
                },
            },
        },
        surveyManage: {
            detail: {
                template: {
                    questionnaireManagement: 'គ្រប់គ្រង សំណួរ',
                    questionnaireDetails: 'សេចក្ដី លម្អិត សំណួរ',
                },
            },
            template: {
                questionnaireFilter: 'តម្រង ថ្នាក់ សំណួរ',
                allQuestionnaires: 'កម្រិត សំណួរ ទាំងអស់',
                questionnaireManagement: 'គ្រប់គ្រង សំណួរ',
            },
        },
        soundtrackManage: {
            template: {
                originalSoundManagement: 'គ្រប់គ្រង សំឡេង ដើម',
                allSonic: 'សូនីក ទាំងអស់',
            },
        },
        feishuQa: {
            chatRecord: {
                components: {
                    filter: {
                        index: {
                            loadMore: 'ផ្ទុក បន្ថែម',
                        },
                    },
                },
            },
            feishuQaEntry: {
                realtimeMessage: 'សារ ពេលវេលា ពិតComment',
                groupChatSegmentation: 'ចម្រៀក ជជែក ជជែក ក្រុម',
                flyingBookConversation: 'សៀវភៅ កម្រិត សៀវភៅ',
            },
        },
        customerService: {
            customerInformation: {
                component: {
                    status: 'ស្ថានភាព',
                    department: 'ហត្ថលេខា',
                    newEmployee: 'ម៉ាស៊ីន ភ្ញៀវ ថ្មី',
                    oldStaff: 'អ្នក ចាស់ៗ',
                    customerServiceType: 'ប្រភេទ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    creationTime: 'ពេលវេលា បង្កើតComment',
                },
                components: {
                    agentTypeConfig: {
                        index: {
                            saveSuccessfully: 'រក្សាទុក ដោយ ជោគជ័យ',
                            agentTypeConfiguration: 'ការ កំណត់ រចនា សម្ព័ន្ធ ប្រភេទ ភ្នែកComment',
                            newEmployeeCycle: 'បង្វិល ថ្មី',
                            pleaseEnterNewEmployeeCycle: 'សូម បញ្ចូល រង្វង់ របស់ អ្នក ថ្មី',
                            day: 'ថ្ងៃStencils',
                        },
                    },
                },
                template: {
                    pleaseSelectAStatus: 'សូម ជ្រើស ស្ថានភាព ។',
                    enable: 'បើកប្រាស់',
                    disable: 'បិទការប្រើប្រាស់',
                    byCustomerServiceGroup: 'តាម ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    byDepartment: 'តាម ឃ្លាំង',
                    department: 'ហត្ថលេខា',
                },
            },
        },
        caseBase: {
            template: {
                sort: 'តម្រង',
            },
        },
        testSetList: {
            template: {
                sort: 'តម្រង',
            },
        },
    },
    columns: {
        admin: {
            user: {
                id: 'ID',
                headPortraitUrl: 'អាវតារ',
                realname: 'ឈ្មោះ:',
                nickname: 'ឈ្មោះ សំឡេង',
                name: 'ឈ្មោះ:',
                email: 'លេខ គណនី ( អ៊ីមែល)',
                mobile: 'ទូរស័ព្ទ',
                agentId: 'ការងារ លេខ ។',
                position: 'ប្រកាស',
                role: 'រលូន',
                actions: 'ប្រតិបត្តិការ',
                createUser: 'ម៉ាស៊ីន ភ្ញៀវ ថ្មី',
                editUser: 'កែសម្រួល ការងារ',
                account: 'លេខ គណនី',
                originPassword: 'ពាក្យ សម្ងាត់ ដើម',
                newPassword: 'ពាក្យ សម្ងាត់ ថ្មី',
                resumePassword: 'អះអាង ពាក្យ សម្ងាត់',
                userGroup: 'ក្រុម អ្នកប្រើ',
                authorizationGroup: 'ក្រុម សិទ្ធិ',
                resetPassword: 'កំណត់ ពាក្យ សម្ងាត់ ឡើង វិញ',
            },
            userGroups: {
                id: 'ID',
                name: 'ឈ្មោះ:',
                userCount: 'ចំនួន ភ្ជាប់',
                actions: 'ប្រតិបត្តិការ',
                createUserGroup: 'បន្ថែម ក្រុម អ្នកប្រើ',
                editUserGroup: 'កែសម្រួល ក្រុម អ្នក ភ្ជាប់',
                member: 'សមាជ្ញ',
            },
            role: {
                id: 'ID',
                name: 'ឈ្មោះ:',
                actions: 'ប្រតិបត្តិការ',
                all: 'ទាំង អស់',
                taskName: 'ភារកិច្ច',
                readTask: 'ទិដ្ឋភាព ភារកិច្ច',
                manageTemplate: 'គ្រប់គ្រង ពុម្ព',
                manualInspection: 'មើល ដៃ',
                readResultAll: 'ទិដ្ឋភាព លទ្ធផល',
                readResultPersonal: 'ទិដ្ឋភាព លទ្ធផល (លទ្ធផល)',
                readProcess: 'មើល ដំណើរ ការ ត្រួត ពិនិត្យ គុណភាព',
                readReport: 'ស្ថិតិ និង របាយការណ៍Name',
            },
        },
        download: {
            downloadCenter: {
                createTime: 'កាលបរិច្ឆេទ',
                taskName: 'ឈ្មោះ:',
                size: 'ទំហំ',
                status: 'ស្ថានភាព',
            },
        },
        tasks: {
            manage: {
                template: {
                    condition: {
                        idCode: 'ID',
                        name: 'ឈ្មោះ:',
                        remark: 'សេចក្ដី ពិពណ៌នា',
                        actions: 'ប្រតិបត្តិការ',
                    },
                    checkPoint: {
                        name: 'ឈ្មោះ:',
                        remark: 'សេចក្ដី ពិពណ៌នា',
                        type: 'ប្រភេទ@ info: whatsthis',
                        gradeType: 'វិធីសាស្ត្រ តម្លៃ',
                        conditionLogic: 'បន្ទាត់',
                        predeterminedScore: 'ពិន្ទុ',
                        weight: 'កម្ពស់',
                        status: 'ស្ថានភាព',
                        actions: 'ប្រតិបត្តិការ',
                        switchOn: 'អនុញ្ញាត',
                        switchOff: 'អសកម្ម',
                    },
                },
                workbench: {
                    qualityCheckList: {
                        time: 'ពេលវេលា',
                        customer: 'ម៉ាស៊ីន ភ្ញៀវ',
                        customerPhone: 'ទូរស័ព្ទ ម៉ាស៊ីន ភ្ញៀវ',
                        callType: 'ប្រភេទ ហៅ',
                        source: 'ប្រភព',
                        voiceRecording: 'ការ ថត ហៅ',
                        graded: 'ការ វាយតម្លៃ',
                        openingGreeting: 'ការ បើក សម្រាក',
                    },
                    checkPointList: {
                        name: 'ចំណុច ត្រួត ពិនិត្យ គុណភាព',
                        type: 'ប្រភេទ@ info: whatsthis',
                        deductScore: 'ប្រទេស',
                        isHit: 'តួ អក្សរ',
                        status: 'ឡើង វិញ',
                        finalDeductScore: 'អះអាង ការ ដោះស្រាយ ចំណុច',
                        hit: 'បិទ',
                        notHit: 'បាត់Comment',
                    },
                },
            },
        },
        custom: {
            keywords: 'ប្រអប់ ពាក្យ គ្រាប់ ចុចComment',
        },
    },
    menu: {
        admin: {
            system: {
                text: 'ការ កំណត់ ប្រព័ន្ធ',
            },
            systemIntegration: {
                text: 'ការ រួមបញ្ចូល ប្រព័ន្ធ',
                subTitle: {
                    udesk: 'ប្រព័ន្ធ សេវា ម៉ាស៊ីន ភ្ញៀវ Udesk',
                    udeskWhite: 'ប្រព័ន្ធ សេវា ម៉ាស៊ីន ភ្ញៀវ',
                    wechat: 'បណ្ដាញ ជម្រះ',
                    taobao: 'តាវ៉ូ គីណូ',
                    weifeng: 'វ៉េហ្វងworld. kgm',
                },
            },
            columnsManage: {
                text: 'គ្រប់គ្រង វាល ត្រួត ពិនិត្យ គុណភាព',
            },
            customerField: {
                text: 'វាល ម៉ាស៊ីន ភ្ញៀវ',
            },
            speechRecognition: {
                text: 'ការ ទទួល ស្គាល់ និយាយComment',
            },
            user: {
                text: 'គ្រប់គ្រង ភ្ញៀវ',
            },
            userGroups: {
                text: 'ការ គ្រប់គ្រង ក្រុម អ្នកប្រើ',
            },
            role: {
                text: 'គ្រប់គ្រង រលូន',
            },
            dataMigration: {
                text: 'ការ ប្ដូរ ទិន្នន័យ',
            },
            taskCenter: {
                text: 'មជ្ឈមណ្ឌល ភារកិច្ច',
            },
            recordUpload: {
                text: 'ផ្ទុក ថត មូលដ្ឋាន',
            },
            anomalousData: {
                text: 'ទិន្នន័យ',
            },
            systemLog: {
                text: 'កំណត់ហេតុ សារ',
            },
            msgCenter: {
                text: 'មជ្ឈមណ្ឌល សារ',
            },
            wechatDocking: {
                text: 'ការ ហោច មីក្រូ សិទ្ធិ',
            },
        },
        tasks: {
            homePage: {
                text: 'ទំព័រ ផ្ទះ',
            },
            workbench: {
                text: 'ពង្រីក',
            },
            semanticIntelligence: {
                text: 'ជម្រះ សំឡេង',
            },
            intelligentAnalysis: {
                text: 'ការ វិភាគ បដិសេធ',
            },
            intelligentLabel: {
                text: 'ស្លាក ឆ្លាត',
            },
            admin: {
                text: 'គ្រប់គ្រងComment',
            },
            callManage: {
                text: 'គ្រប់គ្រង ហៅ',
            },
            dialogueManage: {
                text: 'ប្រអប់ គ្រប់គ្រងComment',
            },
            ticketManage: {
                text: 'គ្រប់គ្រង លំដាប់ ការងារ',
            },
            dataAnalysis: {
                text: 'ការ វិភាគ ទិន្នន័យ',
            },
            customerService: {
                text: 'មជ្ឈមណ្ឌល សេវា ម៉ាស៊ីន ភ្ញៀវ',
            },
            clientCenter: {
                text: 'មជ្ឈមណ្ឌល ម៉ាស៊ីន ភ្ញៀវ',
            },
            insight: {
                text: 'Insight',
            },
            trainingCenter: {
                text: 'មជ្ឈមណ្ឌល បង្ហាញ',
            },
            templates: {
                text: 'គ្រប់គ្រង ពុម្ព',
            },
            wechatQaTasks: {
                text: 'ការងារ WeChat Workbench',
            },
            wechatQaSetting: {
                text: 'ការ កំណត់ រចនា សម្ព័ន្ធ ការ វិភាគ WeChat Enterprise',
            },
            wechatQaChartRecord: {
                text: 'សម័យ WeChat Enterprise',
            },
            wechatStaffCenter: {
                text: 'មជ្ឈមណ្ឌល ការងារ',
            },
            callAnalysis: {
                text: 'ការ វិភាគ សកម្ម',
            },
            caseBaseFolder: {
                text: 'បណ្ណាល័យ អក្សរ',
            },
            coachTask: {
                text: 'ភារកិច្ច បង្រៀនComment',
            },
            teamAnalysis: {
                text: 'ការ វិភាគ ក្រុមComment',
            },
            customer: {
                text: 'មជ្ឈមណ្ឌល ម៉ាស៊ីន ភ្ញៀវ',
            },
            analysisEnable: {
                text: 'ការ វិភាគ ថាស',
            },
            analysisHelp: {
                text: 'ការ វិភាគ ជំនួយ',
            },
            analysisStudy: {
                text: 'ការ វិភាគ សិក្សា',
            },
            analysisReview: {
                text: 'ការ វិភាគ ថាស បង្ហាញ',
            },
            analysisTags: {
                text: 'ការ វិភាគ ស្លាក ឆ្លាត',
            },
            analysisSentiment: {
                text: 'ការ វិភាគ កម្រិត សាធារណៈ',
            },
            analysisBusiness: {
                text: 'ការ វិភាគ បិទ',
            },
            groupTest: {
                text: 'សាកល្បង ក្រុម',
            },
        },
        navBar: {
            billingCenter: 'មជ្ឈមណ្ឌល ជំនួយ',
            uploadDownload: 'ផ្ទុក ឡើង និង ទាញយក មជ្ឈមណ្ឌល',
            setting: 'ការ កំណត់ ប្រព័ន្ធ',
        },
    },
    fix: {
        selectType: 'ជ្រើស ប្រភេទ ៖',
        all: 'ទាំង អស់',
        call: 'ហៅ',
        text: 'ប្រអប់Comment',
        wechat: 'សម័យ WeChat Enterprise',
        businessTrendAnalysis: 'ការ វិភាគ រយ ចលនា កម្រិត ១',
        noEchart: 'គ្មាន ទិន្នន័យ សម្រាប់ គំនូសតាង',
        checkPointisRequired: 'ការ កំណត់ រចនា សម្ព័ន្ធ បន្ទាត់',
        voiceDownLoad: 'ទាញយក ថត',
        exportTxt: 'នាំចេញ អត្ថបទ TXT',
        exportWord: 'នាំចេញ អត្ថបទ ពាក្យ',
        sureReRole: 'តើ ការ អះអាង បញ្ច្រាស តួនាទី របស់ អ្នក និយាយ ឬ ទេ?',
        sureRecover: 'អះអាង ការ កែប្រែ ឡើង វិញ ?',
        sureReAsr: 'អះអាង ការ កំណត់ ឡើង វិញ ?',
        reRole: 'អ្នក និពន្ធ បញ្ច្រាស',
        recover: 'កែ កំហុស ឡើង វិញ',
        reAsr: 'ការ កំណត់ អត្តសញ្ញាណ ឡើង វិញ',
        recordingOperation: 'ប្រតិបត្តិការ ថត',
        onlySave30Day: '(៣០ ថ្ងៃ តែ ប៉ុណ្ណោះ)',
        appealError: 'សូម អភិវឌ្ឍន៍ ចំណុច ត្រួត ពិនិត្យ គុណភាព មុន ពេល ដាក់ស្នើ វា ។',
        exportToTaskCenter: 'បាន នាំចេញ ដោយ ជោគជ័យ ទៅកាន់ មជ្ឈមណ្ឌល ទាញយក ឡើង និង ទាញយក',
        caseBaseLimit: 'បណ្ណាល័យ ករណី មិន អាច លើក ៥០',
        unnamed: 'គ្មាន ឈ្មោះ',
        wordSpeed: 'ពាក្យ/ មីន',
        hit: 'បិទ',
        checkPoint: 'ចំណុច ត្រួត ពិនិត្យ គុណភាព',
        realTimeAdditionTip1: 'បន្ថែម ពេលវេលា real ៖ quality inspection ចាប់ផ្ដើម ភ្លាមៗ ពេល ទិន្នន័យ បញ្ចូល ប្រព័ន្ធ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
        realTimeAdditionTip2: 'បន្ថែម ពេលវេលា ៖ ពេលវេលា បន្ថែម ទិន្នន័យ ដោយ ស្វ័យ ប្រវត្តិ សម្រាប់ ការ ត្រួត ពិនិត្យ គុណភាព',
        null: 'គ្មាន ទេ',
        collcetedProps: 'វាល សម្រាំង',
        editingNameNow: 'ឈ្មោះ ត្រូវ បាន កែសម្រួល',
        upToFourLevels: 'ថ្នាក់ ថ្នាក់ ៤ កម្រិត',
        default: 'លំនាំដើម',
        nameCantBeNull: 'ឈ្មោះ មិន អាច ទទេ',
        editingNow: 'សកម្មភាព កំពុង ត្រូវ បាន កែសម្រួល',
        nameError: 'ឈ្មោះ ខុស',
        nameMaxLength8: 'ប្រវែង ឈ្មោះ អតិបរមា គឺ ៨',
        callTime: 'ពេលវេលា និយាយComment',
        sentimentValue: 'តម្លៃ សំខាន់ របស់ ម៉ាស៊ីន ភ្ញៀវ',
        agentSentimentValue: 'តម្លៃ សេវា ម៉ាស៊ីន ភ្ញៀវ',
        sentimentAnalysis: 'ការ វិភាគ សំណួរ',
        associatedData: 'ទិន្នន័យ តាម ផ្លូវComment',
        notifyTheOwner: 'ជូនដំណឹង របស់ ម្ចាស់ ក្រុម',
        notifyTheEmployee: 'ជូនដំណឹង អ្នក ភ្ជាប់',
        notifyTheOwnerTip: 'នៅ ពេល ប្រភេទ ជជែក ក្រុម អ្នក ក្រុម នឹង ត្រូវ បាន ជូនដំណឹង ។',
        customNotifyEmployee: 'អ្នក ប្រើ ការ ជូនដំណឹង ផ្ទាល់ខ្លួន',
        customNotifyEmployeeTip: 'បើ អ្នក កំពុង កោត ខ្លាច ជា អ្នក ភ្ញាក់ ផ្អើល អ្នក ភ្ញៀវ ដែល សារ នឹង ត្រូវ បាន ជូន ដំណឹង ។',
        clickToLearnMore: 'ចុច ដើម្បី សិក្សា ផ្សេងទៀត',
        repeatMarkingTip: 'ថត នេះ ត្រូវ បាន សម្គាល់ ដោយ ចំណុច ត្រួត ពិនិត្យ គុណភាព នេះ ហើយ មិន ចាំបាច់ ការ សម្គាល់ ឡើងវិញ ។',
        successfulEvaluation: 'តម្លៃ នៃ ការ ជោគជ័យ',
        evaluationFailed: 'ការ ត្រួតពិនិត្យ បរាជ័យ',
        qualityInspectionScore: 'ពិន្ទុ ត្រួត ពិនិត្យ គុណភាព',
        semanticTags: 'ស្លាក semantic',
        smartTags: 'ស្លាក ឆ្លាត',
        collect: 'ប្រមូល ព័ត៌មាន',
        appealRecord: 'ថត នៃ ការ ភ្ញៀវ',
        satisfy: 'បាន ជោគជ័យ',
        notSatisfy: 'មិន បាន ជម្រះ',
        appealPlaceHolder: 'សូម បញ្ចូល មូលហេតុ សំណួរ',
        giveUp: 'បោះពុម្ព',
        rejectReasonPlaceHolder: 'សូម បញ្ចូល មូលហេតុ សម្រាប់ ការ បដិសេធ',
        reject: 'បាន បដិសេធ',
        changeRejectReason: 'កែប្រែ មូលហេតុ បដិសេធ',
        pass: 'តាម គ',
        revise: 'កែប្រែComment',
        machineEvaluation: 'ការ វាយតម្លៃ ម៉ាស៊ីន',
        poor: 'ខុស',
        excellent: 'ល្អ ។',
        moderate: 'ទូទៅ',
        mustMarked: 'ចំណុច ត្រួត ពិនិត្យ គុណភាព នេះ ត្រូវ តែ សម្គាល់@ info: whatsthis',
        pleaseChoose: 'សូម ជ្រើស',
        manualEvaluation: 'ការ វាយតម្លៃ ដោយដៃ',
        qualityInspectionTemplate: 'ពុម្ព ត្រួត ពិនិត្យ គុណភាព ខ្ពស់',
        collectionTemplate: 'ពុម្ព ការ ទទួល យក ដែល អាច អនុវត្ត បានName',
        keywordsWordCloud: 'ពាក្យ គន្លឹះ ពពក',
        editCategoryLabel: 'កែសម្រួល ស្លាក ប្រភេទ',
        justCall: 'គ្រាន់ តែ មើល ហៅ',
        justConversation: 'គ្រាន់ តែ មើល ប្រអប់ ។',
        batchOperation: 'ប្រតិបត្តិការ ថ្មី',
        customerServicesGroup: 'ក្រុម សេវា ម៉ាស៊ីន ភ្ញៀវ',
        joinGroup: 'ចូលរួម ក្រុម',
        removeGroup: 'ផ្លាស់ទី ចេញ ពី ក្រុម',
        enterInformationEntity: 'សូម បញ្ចូល មាតិកា ធាតុ ព័ត៌មាន',
        enterNotBeNull: 'បញ្ចូល មិន អាច ទទេ',
        operationGroup: 'ក្រុម ប្រតិបត្តិការ',
        customerServiceSelected: 'សេវា ម៉ាស៊ីន ភ្ញៀវ ដែល បាន ជ្រើស',
        callAndConversation: 'ការ ហៅ/ សាកល្បង',
        conversation: 'ប្រអប់Comment',
        system: 'ប្រព័ន្ធ',
        customize: 'ផ្ទាល់ខ្លួន',
        effective: 'មាន ប្រសិទ្ធភាព',
        invalid: 'មិន ត្រឹមត្រូវ',
        successfulAndToTaskCenter: 'ការ ប្រតិបត្តិ បាន ជោគជ័យ សូម ទៅ កាន់ មជ្ឈមណ្ឌល ភារកិច្ច ដើម្បី ពិនិត្យ មួយ',
        recalculationFailed: 'បរាជ័យ Recalc',
        selectRecalculatedIndicator: 'សូម ជ្រើស កម្មវិធី បង្ហាញ ដើម្បី ទាញ យក ឡើង វិញ',
        source: 'សូម ជ្រើស ប្រភព ទិន្នន័យ',
        placeholder: 'សូម បញ្ចូល ពាក្យ គន្លឹះ',
        cumulative: 'មធ្យម',
        average: 'ប្រភេទ មធ្យម',
        distribution: 'ច្បាប់ ចែកចាយ',
        originalDataCannotEmpty: 'ទិន្នន័យ ដើម មិន អាច ទទេ',
        inspection: 'ការ ត្រួត ពិនិត្យ គុណភាព',
        check: 'ការ ត្រួត ពិនិត្យ ចៃដន្យ',
        review: 'ឡើង វិញ',
        draftSavedSuccessfully: 'ព្រាង ត្រូវ បាន រក្សាទុក ដោយ ជោគជ័យ',
        optimization: 'ការ ធ្វើ ឲ្យ ប្រព័ន្ធ',
        agentName: 'ឈ្មោះ សេវា ម៉ាស៊ីន ភ្ញៀវ',
        allTasks: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព ទាំងអស់',
        datePickerSelect: 'ជ្រើស កាលបរិច្ឆេទ',
        callSelect: 'ជ្រើស ប្រអប់Name',
        taskSelect: 'ជ្រើស ភារកិច្ច',
        genReport: 'បង្កើត របាយការណ៍@ info: whatsthis',
        dataSource: 'ប្រភព ទិន្នន័យ',
        callsTotal: 'ហៅ សរុប',
        intelligentQualityInspection: 'ការ ត្រួត ពិនិត្យ គុណភាព ត្រឹមត្រូវ',
        percentage: 'លក្ខណៈ សម្បត្តិ',
        artificialSampling: 'ការ គំរូ ដោយ ដៃ',
        appealNumber: 'ចំនួន សញ្ញា',
        totalConversation: 'ចំនួន ប្រអប់ សរុប',
        samplingReviewRate: 'អត្រា មើល បាន',
        data: 'ទិន្នន័យ',
        inspectionResults: 'លទ្ធផល ត្រួត ពិនិត្យ គុណភាព',
        inspected: 'ការ ត្រួត ពិនិត្យ គុណភាព',
        totalScore: 'ពិន្ទុ សរុប',
        learnMore: 'មើល ទៀត',
        inspectionEffect: 'បែបផែន ការ ត្រួត ពិនិត្យ គុណភាព',
        allTotal: 'សរុប',
        manualInspection: 'មើល ដៃ',
        artificialReview: 'មើល ដៃ',
        approvalAmountAndRate: 'អត្រា អត្រា ការ អនុញ្ញាត ដែល បាន អនុញ្ញាត',
        customerScore: 'ពិន្ទុ សេវា ម៉ាស៊ីន ភ្ញៀវ',
        inspectionRecommendations: 'ការ ត្រួត ពិនិត្យ គុណភាព',
        saveDraft: 'រក្សាទុក ព្រាង',
        historicalAdvice: 'សំណួរ ប្រវត្តិ',
        advicePlaceHolder: 'សូម បញ្ចូល ការ ស្នើ',
        upload: 'ផ្ទុក ឯកសារ',
        customAdd: 'បន្ថែម តម្រង',
        advancedConditions: 'លក្ខខណ្ឌ កម្រិត ខ្ពស់',
        keyWord: 'ពាក្យ សោ',
        containsAll: 'មាន ទាំងអស់',
        containsAny: 'មាន ថ្មី',
        matchAny: 'ផ្គូផ្គង',
        matchAll: 'ផ្គូផ្គង ទាំងអស់',
        smartTagsOne: 'ស្លាក ឆ្លាត',
        smartTagsTwo: 'ស្លាក ឆ្លាត IIName',
        season: 'រយៈពេល',
        month: 'ខែ',
        week: 'សប្ដាហ៍',
        day: 'ថ្ងៃStencils',
        hour: 'នៅ ពេល បញ្ចូល',
        notMoreThan366: 'គ្មាន ច្រើន ជាង 366 ថ្ងៃ ។',
        propsCannotBeNull: 'វាល មួយ ចំនួន មិន ត្រូវ បាន បំពេញ ឡើយ',
        other: 'ផ្សេងទៀត',
        correlationCoefficient: 'កម្រិត កម្រិត ពណ៌',
        repetitionRate: 'អត្រា ការ ធ្វើ ឡើងវិញ',
        configurationItemsMoreThan20: 'បន្ថែម ធាតុ កំណត់ រចនា សម្ព័ន្ធ ២០',
        conversionAnalysis: 'ការ វិភាគ បច្ចុប្បន្ន',
        correlationAnalysis: 'ការ វិភាគ ទំនាក់ទំនង',
        successfulExportAndToTaskCenter: 'នាំចេញ បាន ជោគជ័យ សូម ទៅ កាន់ មជ្ឈមណ្ឌល ភារកិច្ច ដើម្បី មើលName',
        typeSelect: 'ជ្រើស ប្រភព',
        exportExcel: 'នាំចេញ  ExcelComment',
        exportPng: 'នាំចេញ png',
        noDataChart: 'គ្មាន ទិន្នន័យ សម្រាប់ គំនូសតាង',
        placeOperator: 'សូម ជ្រើស ស្លាក ជម្រះ',
        placeAdvancedConditions: 'សូម ជ្រើស លក្ខខណ្ឌ កម្រិត ខ្ពស់',
        createAdvancedConditions: 'តម្រង កម្រិត ខ្ពស់ ថ្មី',
        moveUp: 'ផ្លាស់ទី ឡើង លើ',
        moveDown: 'ផ្លាស់ទី ចុះក្រោម',
        moveLeft: 'ផ្លាស់ទី ទៅ ឆ្វេង',
        moveRight: 'ផ្លាស់ទី ទៅ ស្ដាំ',
        statusChangeSuccess: 'ស្ថានភាព បាន កែប្រែ ដោយ ជោគជ័យ',
        editSuccess: 'ការ កែប្រែ បាន ជោគជ័យ',
        saveSuccess: 'រក្សាទុក ដោយ ជោគជ័យ',
        firstPage: 'ទំព័រ ផ្ទះ',
        lastPage: 'ទំព័រ ស្មើ',
        customerInfo: 'ព័ត៌មាន ម៉ាស៊ីន ភ្ញៀវ',
        type: 'ប្រភេទ@ info: whatsthis',
        NumberTypeErrorMessage: 'មាតិកា ព័ត៌មាន វាល នៃ ប្រភេទ លេខ អាច មាន តែ លេខ ឬ "។"',
        taskStartPrompt: 'ការ បើក ភារកិច្ច',
        startConfirm: 'សូម ចុច ប៊ូតុង ការ អះអាង ដើម្បី បើក ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
        continueToSubmitWithoutEvaluation: 'បន្ត ការ ដាក់ ស្នើ ដោយ គ្មាន ការ វាយតម្លៃ',
        rejectTip: 'គ្មាន សកម្មភាព ផ្លាស់ប្ដូរ ដែល បាន រកឃើញ ទេ តើ អ្នក ពិត ជា បដិសេធ ការ តភ្ជាប់ ទាំងអស់ ដោយ ផ្ទាល់ ឬ ?',
        unmarkedSelfLearningTip: 'អ្នក មាន ចំណុច ត្រួត ពិនិត្យ គុណភាព សិក្សា ផ្ទាល់ ខ្លួន',
        markedSuccessfully: 'ការ ជោគជ័យ',
        markingFailed: 'បរាជ័យ ក្នុង ការ បរាជ័យ',
        exceedingLength: 'ប្រវែង បន្ថែម',
        uncategorized: 'គ្មាន ថ្នាក់',
        addSuccess: 'ជោគជ័យ ថ្មី',
        deleteSuccess: 'បាន លុប ដោយ ជោគជ័យ',
        featureName: 'ឈ្មោះ ធាតុ',
        informationEntity: 'ធាតុ ព័ត៌មាន',
        standardAnswer: 'ចម្លើយ ស្តង់ដារ',
        keyElementAnswer: 'ធាតុ សោ ដើម្បី ឆ្លើយតប',
        generalStatement: 'សេចក្ដី បម្លែង ទូទៅ (គ្មាន ត្រូវ សួរ)',
        generalQuestionsAndConfirmation: 'សំណួរ ទូទៅ និង អះអាង',
        specialQuestionsAndAnswers: 'សំណួរ ពិសេស និង ចម្លើយ',
        agent: 'សេវា ម៉ាស៊ីន ភ្ញៀវ',
        customer: 'ម៉ាស៊ីន ភ្ញៀវ',
        semanticTagsAndInformationEntitiesCannotBeEmpty: 'ធាតុ គ្រាប់ ចុច ស្លាក សំឡេង និង ធាតុ ព័ត៌មាន ដែល មិន អាច ទទេ នៅពេល តែ មួយ គេ',
        standardSentence: 'ពាក្យ ស្តង់ដារ',
        acquaintance: 'ការ បដិសេធ',
        smartUePlaceholder: 'សូម បញ្ចូល ឈ្មោះ អន្តរកម្ម',
        typeSelectPlaceholder: 'សូម ជ្រើស ប្រភេទ@ info: whatsthis',
        keyElement: 'ធាតុ សោ',
        reQuerySementicTags: 'ជ្រើស ស្លាក semantic',
        querySementicTags: 'ជ្រើស ស្លាក សំឡេង',
        QATestForm: 'សំណុំ បែបបទ ការ រក ឃើញ សំណួរ និង ចម្លើយ',
        selectNotBeNull: 'ការ ជ្រើស មិន អាច ទទេ',
        featureDetectionTarget: 'គោលដៅ រក ឃើញ ធាតុName',
        categorized: 'ថត',
        effectiveness: 'ភាព បែបផែន',
        hideAdvancedSettings: 'លាក់ ការ កំណត់ កម្រិត ខ្ពស់',
        showAdvancedSettings: 'បង្ហាញ ការ កំណត់ កម្រិត ខ្ពស់',
        generalStatementOnly: 'សិទ្ធិ',
        generalQuestions: 'សំឡេង',
        affirmativeExpression: 'កន្សោម អះអាង',
        negativeIntention: 'ជម្រះ អុហ្វសិត',
        searchSementicTags: 'ស្លាក សួរ សំណួរ',
        choiceQuestion: 'ពាក្យ សួរ សួរ អក្សរ ជ្រើស',
        selectiveAnswer: 'ចម្លើយ ប្រភេទ ជ្រើស',
        sementicTagsPlaceholder: 'សូម បញ្ចូល មាតិកា ស្លាក semantic',
        openSpecialQuestion: 'បើក សំណួរ ពិសេស',
        openAnswer: 'បើក ចម្លើយ ។',
        customQA: 'Q & A ផ្ទាល់ខ្លួន',
        questions: 'វិធីសាស្ត្រ សួរ',
        dataPlaceholder: 'សូម បញ្ចូល មាតិកា',
        reply: 'ចម្លើយ',
        notFindSuitableLabel: 'រក មិន ឃើញ ស្លាក ដែល សមរម្យ ។',
        addSemanticTag: 'បន្ថែម ស្លាក semantic ថ្មី',
        intelligentInteraction: 'អន្តរកម្ម',
        matching: 'ផ្គូផ្គង',
        bout: 'ពេលវេលាName',
        keywordMatch: 'ការ ផ្គូផ្គង ពាក្យ គន្លឹះ',
        addFilterConditions: 'បន្ថែម លក្ខខណ្ឌ តម្រង',
        buttonStartCollectionTask: 'សូម ចុច ប៊ូតុង ត្រឹមត្រូវ ដើម្បី ចាប់ផ្ដើម ភារកិច្ច សម្រាំង',
        buttonStartTask: 'សូម ចុច ប៊ូតុង ត្រឹមត្រូវ',
        ruleConfigurationIsRequired: 'ការ កំណត់ រចនា សម្ព័ន្ធ បន្ទាត់',
        asrRunning: 'ការ ប្រតិបត្តិ ASR',
        errorCorrectionExecution: 'ការ ប្រតិបត្តិ ការ កែ កំហុស',
        emotionalVolumeRecognition: 'ការ ទទួល យក សំឡេង សំឡេង',
        dataPreprocessing: 'ដំណើរការ ទិន្នន័យ',
        inspectionExecution: 'ការ ប្រតិបត្តិ ការ ត្រួត ពិនិត្យ គុណភាព',
        businessId: 'លេខ សម្គាល់ ពាក្យ',
        businessTime: 'ពេលវេលា បណ្ដាញ',
        createTime: 'ពេលវេលា បង្កើតComment',
        abnormalReason: 'មូលហេតុ មិន ធម្មតា',
        singleChat: 'ជជែក ទៀត',
        groupChat: 'ជជែក ក្រុម',
        taskContent: 'មាតិកា ភារកិច្ច',
        submissionTime: 'ពេលវេលា ដាក់ ស្នើ',
        startTime: 'ពេលវេលា ចាប់ផ្ដើម',
        endTime: 'ពេលវេលា បញ្ចប់',
        runningTime: 'ប្រតិបត្តិការ ចាប់ផ្ដើម ពេលវេលា',
        totalAmountOfData: 'កម្រិត ទិន្នន័យ សរុប',
        resultsOfThe: 'លទ្ធផល ប្រតិបត្តិ',
        operator: 'កម្មវិធី',
        taskDetails: 'សេចក្ដី លម្អិត ភារកិច្ច',
        executiveFunction: 'អនុគមន៍ ប្រតិបត្តិ',
        qualityCheckTasks: 'ភារកិច្ច ការ ត្រួត ពិនិត្យ គុណភាព',
        implementationDetails: 'សេចក្ដី លម្អិត ប្រតិបត្តិ',
        conditionalRules: 'ច្បាប់ លក្ខខណ្ឌ',
        smartCondition: 'លក្ខខណ្ឌ ឆ្លាត',
        goThis: 'ផ្លាស់ទី ទៅ នេះ',
        pleaseMarkClassification: 'សូម សម្គាល់ ថ្នាក់Name',
        advancedScreening: 'តម្រង កម្រិត ខ្ពស់',
        noDataToManipulate: 'គ្មាន ទិន្នន័យ ត្រូវ រៀបចំ',
        concept: 'ពាក្យ ទំនាក់ទំនង',
        checkPoint1: 'ការ កំណត់ រចនាសម្ព័ន្ធ បន្ទាត់',
        requiredFieldsCannotEmpty: 'ធាតុ ដែល ទាមទារ មិន អាច ទទេ',
        rule: 'បន្ទាត់',
        afterFixUnit: 'ពាក្យ',
        unmarkedSelfLearningPointsTip: 'អ្នក មាន ចំណុច ត្រួត ពិនិត្យ គុណភាព សិក្សា ផ្ទាល់ ខ្លួន',
        onlyReservedFor7Days: 'តែ 7 ថ្ងៃ)',
        downloadError: 'ការ ទាញយក បាន បរាជ័យ',
        pause: 'ផ្អាក',
        continue: 'បន្ត@ info: whatsthis',
        recalcScore: 'គណនា តែ ពិន្ទុ',
        recalculatePointsAndScores: 'គណនា ចំណុច និង ពិន្ទុ ត្រួត ពិន្ទុ',
        recalculatePointsAndScoresWithEmtry: 'គណនា ចំណុច ត្រួត ពិន្ទុ និង ពិន្ទុ ត្រួត ពិនិត្យ គុណភាព ទទេ)',
        inProgress: 'កំពុង វឌ្ឍន៍',
        toBeExecuted: 'ត្រូវ បាន អនុញ្ញាត',
        executeImmediately: 'ការ ប្រតិបត្តិ ភ្លាមៗ',
        specialElements: 'ធាតុ ពិសេស',
        logicRule: 'ច្បាប់ តក្ក',
        every: 'ផ្គូផ្គង ច្រើន',
        hitRecall: 'ចង ពាក្យ',
        notHitRecall: 'បាត់ ពាក្យ',
        hitRecallRegular: 'ហៅ ធម្មតា',
        notHitRecallRegular: 'បាត់ ធម្មតា',
        hitRule: 'គូរ បន្ទាត់',
        notHitRule: 'ច្បាប់ ដែល បាន បាត់Comment',
        hitSimilarSentence: 'ពាក្យ ស្រដៀង គ្នាName',
        notHitSimilarSentence: 'បាត់ ពាក្យ ស្រដៀង គ្នាName',
        hitExcludeSimilarSentences: 'គំរូ ដើម្បី បិទ ពាក្យ ស្រដៀង គ្នាName',
        notHitExcludeSimilarSentences: 'បាន បាត់ ឲ្យ បដិសេធ ពាក្យ ស្រដៀង គ្នាName',
        updateSuccess: 'ធ្វើ ឲ្យ ទាន់សម័យ បាន ជោគជ័យ',
        qualify: 'ធម្មតា',
        recallKeyWord: 'ចងចាំ ពាក្យ គន្លឹះ',
        grammar: 'ក្ដារ ក្រាប',
    },
    api: {
        putTypoDatasByIdStatusByStatus: 'បាន បរាជ័យ ក្នុង ការ ផ្លាស់ប្ដូរ ត្រឹមត្រូវ សូម ព្យាយាម ម្ដង ទៀត',
        postAutoMateTasksCaseByTaskId: 'បាន បរាជ័យ ក្នុង ការ កំណត់ រចនា សម្ព័ន្ធ ការ ធ្វើ សមកាលកម្ម បណ្ណាល័យ រូបភាព',
        getAutoMateTasksCaseByTaskId: 'បរាជ័យ ក្នុង ការ កំណត់ រចនា សម្ព័ន្ធ ការ ធ្វើ សមកាលកម្ម បណ្ណាល័យ តួអក្សរ',
        postInspectionRemarkModelConfigs: 'បាន បរាជ័យ ក្នុង ការ រក្សាទុក ពុម្ព អធិប្បាយName',
        putInspectionRemarkModelConfigsById: 'បាន បរាជ័យ ក្នុង ការ រក្សាទុក ពុម្ព អធិប្បាយName',
        getInspectionRemarkModelConfigsById: 'បាន បរាជ័យ ក្នុង ការ យក ទិន្នន័យ ពុម្ព អធិប្បាយName',
        postKnowledgeDatas: 'បាន បរាជ័យ ក្នុង ការ បង្កើត មូលដ្ឋាន ស្គាល់ សូម ព្យាយាម ម្ដង ទៀត',
        putKnowledgeDatasById: 'បាន បរាជ័យ ការ កែប្រែ ឃ្លាំង សូម ព្យាយាម ម្ដង ទៀត',
        getLibraryFiles: 'បាន បរាជ័យ ក្នុង ការ ទទួល យក បញ្ជី ថត តម្លៃ ។',
        getLibraryCalls: 'បាន បរាជ័យ ក្នុង ការ យក ឯកសារ',
        getLibraryFilesSearch: 'ការ ស្វែងរក បាន បរាជ័យ',
        putLibraryFilesMoveById: 'បាន បរាជ័យ ក្នុង ការ ផ្លាស់ទី ថត តម្លៃ ។',
        putLibraryCallsById: 'បាន បរាជ័យ ក្នុង ការ ប្ដូរ ឈ្មោះ ឯកសារ !',
        postLibraryFiles: 'បាន បរាជ័យ ក្នុង ការ បន្ថែម ថត',
        putLibraryFilesById: 'បាន បរាជ័យ ក្នុង ការ ប្ដូរ ថត',
        deleteLibraryFilesById: 'បរាជ័យ លុប',
        deleteLibraryCallsById: 'បរាជ័យ លុប',
        postLibraryCalls: 'បាន បរាជ័យ',
        getVoiceUploadResultById: 'នាំចេញ លទ្ធផល ផ្ទុក ឡើង បាន បរាជ័យ',
    },
};